(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("$rdf"), require("SolidLogic"));
	else if(typeof define === 'function' && define.amd)
		define(["$rdf", "SolidLogic"], factory);
	else if(typeof exports === 'object')
		exports["UI"] = factory(require("$rdf"), require("SolidLogic"));
	else
		root["UI"] = factory(root["$rdf"], root["SolidLogic"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__264__, __WEBPACK_EXTERNAL_MODULE__663__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 49
(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/*!
 * mime-types
 * Copyright(c) 2014 Jonathan Ong
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module dependencies.
 * @private
 */

var db = __webpack_require__(598)
var extname = (__webpack_require__(466).extname)
var mimeScore = __webpack_require__(983)

/**
 * Module variables.
 * @private
 */

var EXTRACT_TYPE_REGEXP = /^\s*([^;\s]*)(?:;|\s|$)/
var TEXT_TYPE_REGEXP = /^text\//i

/**
 * Module exports.
 * @public
 */

exports.charset = charset
exports.charsets = { lookup: charset }
exports.contentType = contentType
exports.extension = extension
exports.extensions = Object.create(null)
exports.lookup = lookup
exports.types = Object.create(null)
exports._extensionConflicts = []

// Populate the extensions/types maps
populateMaps(exports.extensions, exports.types)

/**
 * Get the default charset for a MIME type.
 *
 * @param {string} type
 * @return {false|string}
 */

function charset (type) {
  if (!type || typeof type !== 'string') {
    return false
  }

  // TODO: use media-typer
  var match = EXTRACT_TYPE_REGEXP.exec(type)
  var mime = match && db[match[1].toLowerCase()]

  if (mime && mime.charset) {
    return mime.charset
  }

  // default text/* to utf-8
  if (match && TEXT_TYPE_REGEXP.test(match[1])) {
    return 'UTF-8'
  }

  return false
}

/**
 * Create a full Content-Type header given a MIME type or extension.
 *
 * @param {string} str
 * @return {false|string}
 */

function contentType (str) {
  // TODO: should this even be in this module?
  if (!str || typeof str !== 'string') {
    return false
  }

  var mime = str.indexOf('/') === -1 ? exports.lookup(str) : str

  if (!mime) {
    return false
  }

  // TODO: use content-type or other module
  if (mime.indexOf('charset') === -1) {
    var charset = exports.charset(mime)
    if (charset) mime += '; charset=' + charset.toLowerCase()
  }

  return mime
}

/**
 * Get the default extension for a MIME type.
 *
 * @param {string} type
 * @return {false|string}
 */

function extension (type) {
  if (!type || typeof type !== 'string') {
    return false
  }

  // TODO: use media-typer
  var match = EXTRACT_TYPE_REGEXP.exec(type)

  // get extensions
  var exts = match && exports.extensions[match[1].toLowerCase()]

  if (!exts || !exts.length) {
    return false
  }

  return exts[0]
}

/**
 * Lookup the MIME type for a file path/extension.
 *
 * @param {string} path
 * @return {false|string}
 */

function lookup (path) {
  if (!path || typeof path !== 'string') {
    return false
  }

  // get the extension ("ext" or ".ext" or full path)
  var extension = extname('x.' + path)
    .toLowerCase()
    .slice(1)

  if (!extension) {
    return false
  }

  return exports.types[extension] || false
}

/**
 * Populate the extensions and types maps.
 * @private
 */

function populateMaps (extensions, types) {
  Object.keys(db).forEach(function forEachMimeType (type) {
    var mime = db[type]
    var exts = mime.extensions

    if (!exts || !exts.length) {
      return
    }

    // mime -> extensions
    extensions[type] = exts

    // extension -> mime
    for (var i = 0; i < exts.length; i++) {
      var extension = exts[i]
      types[extension] = _preferredType(extension, types[extension], type)

      // DELETE (eventually): Capture extension->type maps that change as a
      // result of switching to mime-score.  This is just to help make reviewing
      // PR #119 easier, and can be removed once that PR is approved.
      const legacyType = _preferredTypeLegacy(
        extension,
        types[extension],
        type
      )
      if (legacyType !== types[extension]) {
        exports._extensionConflicts.push([extension, legacyType, types[extension]])
      }
    }
  })
}

// Resolve type conflict using mime-score
function _preferredType (ext, type0, type1) {
  var score0 = type0 ? mimeScore(type0, db[type0].source) : 0
  var score1 = type1 ? mimeScore(type1, db[type1].source) : 0

  return score0 > score1 ? type0 : type1
}

// Resolve type conflict using pre-mime-score logic
function _preferredTypeLegacy (ext, type0, type1) {
  var SOURCE_RANK = ['nginx', 'apache', undefined, 'iana']

  var score0 = type0 ? SOURCE_RANK.indexOf(db[type0].source) : 0
  var score1 = type1 ? SOURCE_RANK.indexOf(db[type1].source) : 0

  if (
    exports.types[extension] !== 'application/octet-stream' &&
    (score0 > score1 ||
      (score0 === score1 &&
        exports.types[extension]?.slice(0, 12) === 'application/'))
  ) {
    return type0
  }

  return score0 > score1 ? type0 : type1
}


/***/ },

/***/ 172
(module) {

function _OverloadYield(e, d) {
  this.v = e, this.k = d;
}
module.exports = _OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },

/***/ 264
(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__264__;

/***/ },

/***/ 373
(module) {

function _regeneratorKeys(e) {
  var n = Object(e),
    r = [];
  for (var t in n) r.unshift(t);
  return function e() {
    for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
    return e.done = !0, e;
  };
}
module.exports = _regeneratorKeys, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },

/***/ 378
(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   LN: () => (/* binding */ iconBase),
/* harmony export */   Pt: () => (/* binding */ icons),
/* harmony export */   i1: () => (/* binding */ originalIconBase)
/* harmony export */ });
/* harmony import */ var _debug__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(423);
/* module decorator */ module = __webpack_require__.hmd(module);
// Works in FF extension - what about browserify??
// 2021-04-08 Convert to TS

/* The Firefox case is left for historical record, as we don't currenly
 * have a FF extension for mashlib, but we could.  This is sthepoint to
 * hack the place it can find its icons internally
 *
 * The $SolidTestEnvironment is important and is used for
 * example when testing on localhost to specify a place the icons be found
 * in your test set up.
 *
 * You can also use it if you want to just run a mashlib whhich takes its
 * icons seved by other than github.
 */


// Do not export. Always us this module to find the icons, as they vary
var iconsOnGithub = 'https://solidos.github.io/solid-ui/src'; // changed org 2022-05

var icons = module.scriptURI // Firefox extension
? {
  iconBase: module.scriptURI.slice(0, module.scriptURI.lastIndexOf('/')) + '/icons/',
  originalIconBase: module.scriptURI.slice(0, module.scriptURI.lastIndexOf('/')) + '/originalIcons/'
} : typeof $SolidTestEnvironment !== 'undefined' && $SolidTestEnvironment.iconBase // Test environemnt
? {
  iconBase: $SolidTestEnvironment.iconBase,
  originalIconBase: $SolidTestEnvironment.originalIconBase
} : {
  // Normal case:
  iconBase: iconsOnGithub + '/icons/',
  originalIconBase: iconsOnGithub + '/originalIcons/'
};
(0,_debug__WEBPACK_IMPORTED_MODULE_0__/* .log */ .Rm)('   icons.iconBase is set to : ' + icons.iconBase);

// allow tests etc  named-import this directly from this module
var iconBase = icons.iconBase;
var originalIconBase = icons.originalIconBase;

/***/ },

/***/ 386
(module) {

/**
 * Provides a way to access commonly used namespaces
 *
 * Usage:
 *
 *   ```
 *   const $rdf = require('rdflib'); //or any other RDF/JS-compatible library
 *   const ns = require('solid-namespace')($rdf);
 *   const store = $rdf.graph();
 *
 *   let me = ...;
 *   let name = store.any(me, ns.vcard(‘fn’)) || store.any(me, ns.foaf(‘name’));
 *   ```
 * @module vocab
 */
const aliases = {
  acl: 'http://www.w3.org/ns/auth/acl#',
  arg: 'http://www.w3.org/ns/pim/arg#',
  as: 'https://www.w3.org/ns/activitystreams#',
  bookmark: 'http://www.w3.org/2002/01/bookmark#',
  cal: 'http://www.w3.org/2002/12/cal/ical#',
  cco: 'http://www.ontologyrepository.com/CommonCoreOntologies/',
  cert: 'http://www.w3.org/ns/auth/cert#',
  contact: 'http://www.w3.org/2000/10/swap/pim/contact#',
  dc: 'http://purl.org/dc/elements/1.1/',
  dct: 'http://purl.org/dc/terms/',
  doap: 'http://usefulinc.com/ns/doap#',
  foaf: 'http://xmlns.com/foaf/0.1/',
  geo: 'http://www.w3.org/2003/01/geo/wgs84_pos#',
  gpx: 'http://www.w3.org/ns/pim/gpx#',
  gr: 'http://purl.org/goodrelations/v1#',
  http: 'http://www.w3.org/2007/ont/http#',
  httph: 'http://www.w3.org/2007/ont/httph#',
  icalTZ: 'http://www.w3.org/2002/12/cal/icaltzd#', // Beware: not cal:
  ldp: 'http://www.w3.org/ns/ldp#',
  link: 'http://www.w3.org/2007/ont/link#',
  log: 'http://www.w3.org/2000/10/swap/log#',
  meeting: 'http://www.w3.org/ns/pim/meeting#',
  mo: 'http://purl.org/ontology/mo/',
  org: 'http://www.w3.org/ns/org#',
  owl: 'http://www.w3.org/2002/07/owl#',
  pad: 'http://www.w3.org/ns/pim/pad#',
  patch: 'http://www.w3.org/ns/pim/patch#',
  prov: 'http://www.w3.org/ns/prov#',
  pto: 'http://www.productontology.org/id/',
  qu: 'http://www.w3.org/2000/10/swap/pim/qif#',
  trip: 'http://www.w3.org/ns/pim/trip#',
  rdf: 'http://www.w3.org/1999/02/22-rdf-syntax-ns#',
  rdfs: 'http://www.w3.org/2000/01/rdf-schema#',
  rss: 'http://purl.org/rss/1.0/',
  sched: 'http://www.w3.org/ns/pim/schedule#',
  schema: 'http://schema.org/', // @@ beware confusion with documents no 303
  sioc: 'http://rdfs.org/sioc/ns#',
  skos: 'http://www.w3.org/2004/02/skos/core#',
  solid: 'http://www.w3.org/ns/solid/terms#',
  space: 'http://www.w3.org/ns/pim/space#',
  stat: 'http://www.w3.org/ns/posix/stat#',
  tab: 'http://www.w3.org/2007/ont/link#',
  tabont: 'http://www.w3.org/2007/ont/link#',
  ui: 'http://www.w3.org/ns/ui#',
  vann: 'http://purl.org/vocab/vann/',
  vcard: 'http://www.w3.org/2006/vcard/ns#',
  wf: 'http://www.w3.org/2005/01/wf/flow#',
  xsd: 'http://www.w3.org/2001/XMLSchema#',
}

/**
 * @param [rdflib] {RDF} Optional RDF Library (such as rdflib.js or rdf-ext) to inject
 */
function vocab (rdf = { namedNode: u => u }) {
  const namespaces = {}
  for (const alias in aliases) {
    const expansion = aliases[alias]
    namespaces[alias] = function (localName = '') {
      return rdf.namedNode(expansion + localName)
    }
  };

  return namespaces
};

module.exports = vocab


/***/ },

/***/ 423
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   R8: () => (/* binding */ warn),
/* harmony export */   Rm: () => (/* binding */ log),
/* harmony export */   uP: () => (/* binding */ trace),
/* harmony export */   z3: () => (/* binding */ error)
/* harmony export */ });
function log() {
  var _console;
  (_console = console).log.apply(_console, arguments);
}
function warn() {
  var _console2;
  (_console2 = console).warn.apply(_console2, arguments);
}
function error() {
  var _console3;
  (_console3 = console).error.apply(_console3, arguments);
}
function trace() {
  var _console4;
  (_console4 = console).trace.apply(_console4, arguments);
}

/***/ },

/***/ 466
() {

/* (ignored) */

/***/ },

/***/ 546
(module) {

function _regeneratorDefine(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  module.exports = _regeneratorDefine = function regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _regeneratorDefine(e, r, n, t);
}
module.exports = _regeneratorDefine, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },

/***/ 579
(module, __unused_webpack_exports, __webpack_require__) {

var _typeof = (__webpack_require__(738)["default"]);
function _regeneratorValues(e) {
  if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
      r = 0;
    if (t) return t.call(e);
    if ("function" == typeof e.next) return e;
    if (!isNaN(e.length)) return {
      next: function next() {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
  }
  throw new TypeError(_typeof(e) + " is not iterable");
}
module.exports = _regeneratorValues, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },

/***/ 580
(module) {

"use strict";
/*!
 * escape-html
 * Copyright(c) 2012-2013 TJ Holowaychuk
 * Copyright(c) 2015 Andreas Lubbe
 * Copyright(c) 2015 Tiancheng "Timothy" Gu
 * MIT Licensed
 */



/**
 * Module variables.
 * @private
 */

var matchHtmlRegExp = /["'&<>]/;

/**
 * Module exports.
 * @public
 */

module.exports = escapeHtml;

/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */

function escapeHtml(string) {
  var str = '' + string;
  var match = matchHtmlRegExp.exec(str);

  if (!match) {
    return str;
  }

  var escape;
  var html = '';
  var index = 0;
  var lastIndex = 0;

  for (index = match.index; index < str.length; index++) {
    switch (str.charCodeAt(index)) {
      case 34: // "
        escape = '&quot;';
        break;
      case 38: // &
        escape = '&amp;';
        break;
      case 39: // '
        escape = '&#39;';
        break;
      case 60: // <
        escape = '&lt;';
        break;
      case 62: // >
        escape = '&gt;';
        break;
      default:
        continue;
    }

    if (lastIndex !== index) {
      html += str.substring(lastIndex, index);
    }

    lastIndex = index + 1;
    html += escape;
  }

  return lastIndex !== index
    ? html + str.substring(lastIndex, index)
    : html;
}


/***/ },

/***/ 598
(module, __unused_webpack_exports, __webpack_require__) {

/*!
 * mime-db
 * Copyright(c) 2014 Jonathan Ong
 * Copyright(c) 2015-2022 Douglas Christopher Wilson
 * MIT Licensed
 */

/**
 * Module exports.
 */

module.exports = __webpack_require__(813)


/***/ },

/***/ 633
(module, __unused_webpack_exports, __webpack_require__) {

var OverloadYield = __webpack_require__(172);
var regenerator = __webpack_require__(993);
var regeneratorAsync = __webpack_require__(869);
var regeneratorAsyncGen = __webpack_require__(887);
var regeneratorAsyncIterator = __webpack_require__(791);
var regeneratorKeys = __webpack_require__(373);
var regeneratorValues = __webpack_require__(579);
function _regeneratorRuntime() {
  "use strict";

  var r = regenerator(),
    e = r.m(_regeneratorRuntime),
    t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
  function n(r) {
    var e = "function" == typeof r && r.constructor;
    return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
  }
  var o = {
    "throw": 1,
    "return": 2,
    "break": 3,
    "continue": 3
  };
  function a(r) {
    var e, t;
    return function (n) {
      e || (e = {
        stop: function stop() {
          return t(n.a, 2);
        },
        "catch": function _catch() {
          return n.v;
        },
        abrupt: function abrupt(r, e) {
          return t(n.a, o[r], e);
        },
        delegateYield: function delegateYield(r, o, a) {
          return e.resultName = o, t(n.d, regeneratorValues(r), a);
        },
        finish: function finish(r) {
          return t(n.f, r);
        }
      }, t = function t(r, _t, o) {
        n.p = e.prev, n.n = e.next;
        try {
          return r(_t, o);
        } finally {
          e.next = n.n;
        }
      }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
      try {
        return r.call(this, e);
      } finally {
        n.p = e.prev, n.n = e.next;
      }
    };
  }
  return (module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
    return {
      wrap: function wrap(e, t, n, o) {
        return r.w(a(e), t, n, o && o.reverse());
      },
      isGeneratorFunction: n,
      mark: r.m,
      awrap: function awrap(r, e) {
        return new OverloadYield(r, e);
      },
      AsyncIterator: regeneratorAsyncIterator,
      async: function async(r, e, t, o, u) {
        return (n(e) ? regeneratorAsyncGen : regeneratorAsync)(a(r), e, t, o, u);
      },
      keys: regeneratorKeys,
      values: regeneratorValues
    };
  }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },

/***/ 663
(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__663__;

/***/ },

/***/ 738
(module) {

function _typeof(o) {
  "@babel/helpers - typeof";

  return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },

/***/ 756
(module, __unused_webpack_exports, __webpack_require__) {

// TODO(Babel 8): Remove this file.

var runtime = __webpack_require__(633)();
module.exports = runtime;

// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


/***/ },

/***/ 791
(module, __unused_webpack_exports, __webpack_require__) {

var OverloadYield = __webpack_require__(172);
var regeneratorDefine = __webpack_require__(546);
function AsyncIterator(t, e) {
  function n(r, o, i, f) {
    try {
      var c = t[r](o),
        u = c.value;
      return u instanceof OverloadYield ? e.resolve(u.v).then(function (t) {
        n("next", t, i, f);
      }, function (t) {
        n("throw", t, i, f);
      }) : e.resolve(u).then(function (t) {
        c.value = t, i(c);
      }, function (t) {
        return n("throw", t, i, f);
      });
    } catch (t) {
      f(t);
    }
  }
  var r;
  this.next || (regeneratorDefine(AsyncIterator.prototype), regeneratorDefine(AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function () {
    return this;
  })), regeneratorDefine(this, "_invoke", function (t, o, i) {
    function f() {
      return new e(function (e, r) {
        n(t, i, e, r);
      });
    }
    return r = r ? r.then(f, f) : f();
  }, !0);
}
module.exports = AsyncIterator, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },

/***/ 813
(module) {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('{"application/1d-interleaved-parityfec":{"source":"iana"},"application/3gpdash-qoe-report+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/3gpp-ims+xml":{"source":"iana","compressible":true},"application/3gpphal+json":{"source":"iana","compressible":true},"application/3gpphalforms+json":{"source":"iana","compressible":true},"application/a2l":{"source":"iana"},"application/ace+cbor":{"source":"iana"},"application/ace+json":{"source":"iana","compressible":true},"application/ace-groupcomm+cbor":{"source":"iana"},"application/ace-trl+cbor":{"source":"iana"},"application/activemessage":{"source":"iana"},"application/activity+json":{"source":"iana","compressible":true},"application/aif+cbor":{"source":"iana"},"application/aif+json":{"source":"iana","compressible":true},"application/alto-cdni+json":{"source":"iana","compressible":true},"application/alto-cdnifilter+json":{"source":"iana","compressible":true},"application/alto-costmap+json":{"source":"iana","compressible":true},"application/alto-costmapfilter+json":{"source":"iana","compressible":true},"application/alto-directory+json":{"source":"iana","compressible":true},"application/alto-endpointcost+json":{"source":"iana","compressible":true},"application/alto-endpointcostparams+json":{"source":"iana","compressible":true},"application/alto-endpointprop+json":{"source":"iana","compressible":true},"application/alto-endpointpropparams+json":{"source":"iana","compressible":true},"application/alto-error+json":{"source":"iana","compressible":true},"application/alto-networkmap+json":{"source":"iana","compressible":true},"application/alto-networkmapfilter+json":{"source":"iana","compressible":true},"application/alto-propmap+json":{"source":"iana","compressible":true},"application/alto-propmapparams+json":{"source":"iana","compressible":true},"application/alto-tips+json":{"source":"iana","compressible":true},"application/alto-tipsparams+json":{"source":"iana","compressible":true},"application/alto-updatestreamcontrol+json":{"source":"iana","compressible":true},"application/alto-updatestreamparams+json":{"source":"iana","compressible":true},"application/aml":{"source":"iana"},"application/andrew-inset":{"source":"iana","extensions":["ez"]},"application/appinstaller":{"compressible":false,"extensions":["appinstaller"]},"application/applefile":{"source":"iana"},"application/applixware":{"source":"apache","extensions":["aw"]},"application/appx":{"compressible":false,"extensions":["appx"]},"application/appxbundle":{"compressible":false,"extensions":["appxbundle"]},"application/at+jwt":{"source":"iana"},"application/atf":{"source":"iana"},"application/atfx":{"source":"iana"},"application/atom+xml":{"source":"iana","compressible":true,"extensions":["atom"]},"application/atomcat+xml":{"source":"iana","compressible":true,"extensions":["atomcat"]},"application/atomdeleted+xml":{"source":"iana","compressible":true,"extensions":["atomdeleted"]},"application/atomicmail":{"source":"iana"},"application/atomsvc+xml":{"source":"iana","compressible":true,"extensions":["atomsvc"]},"application/atsc-dwd+xml":{"source":"iana","compressible":true,"extensions":["dwd"]},"application/atsc-dynamic-event-message":{"source":"iana"},"application/atsc-held+xml":{"source":"iana","compressible":true,"extensions":["held"]},"application/atsc-rdt+json":{"source":"iana","compressible":true},"application/atsc-rsat+xml":{"source":"iana","compressible":true,"extensions":["rsat"]},"application/atxml":{"source":"iana"},"application/auth-policy+xml":{"source":"iana","compressible":true},"application/automationml-aml+xml":{"source":"iana","compressible":true,"extensions":["aml"]},"application/automationml-amlx+zip":{"source":"iana","compressible":false,"extensions":["amlx"]},"application/bacnet-xdd+zip":{"source":"iana","compressible":false},"application/batch-smtp":{"source":"iana"},"application/bdoc":{"compressible":false,"extensions":["bdoc"]},"application/beep+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/bufr":{"source":"iana"},"application/c2pa":{"source":"iana"},"application/calendar+json":{"source":"iana","compressible":true},"application/calendar+xml":{"source":"iana","compressible":true,"extensions":["xcs"]},"application/call-completion":{"source":"iana"},"application/cals-1840":{"source":"iana"},"application/captive+json":{"source":"iana","compressible":true},"application/cbor":{"source":"iana"},"application/cbor-seq":{"source":"iana"},"application/cccex":{"source":"iana"},"application/ccmp+xml":{"source":"iana","compressible":true},"application/ccxml+xml":{"source":"iana","compressible":true,"extensions":["ccxml"]},"application/cda+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/cdfx+xml":{"source":"iana","compressible":true,"extensions":["cdfx"]},"application/cdmi-capability":{"source":"iana","extensions":["cdmia"]},"application/cdmi-container":{"source":"iana","extensions":["cdmic"]},"application/cdmi-domain":{"source":"iana","extensions":["cdmid"]},"application/cdmi-object":{"source":"iana","extensions":["cdmio"]},"application/cdmi-queue":{"source":"iana","extensions":["cdmiq"]},"application/cdni":{"source":"iana"},"application/ce+cbor":{"source":"iana"},"application/cea":{"source":"iana"},"application/cea-2018+xml":{"source":"iana","compressible":true},"application/cellml+xml":{"source":"iana","compressible":true},"application/cfw":{"source":"iana"},"application/cid-edhoc+cbor-seq":{"source":"iana"},"application/city+json":{"source":"iana","compressible":true},"application/city+json-seq":{"source":"iana"},"application/clr":{"source":"iana"},"application/clue+xml":{"source":"iana","compressible":true},"application/clue_info+xml":{"source":"iana","compressible":true},"application/cms":{"source":"iana"},"application/cnrp+xml":{"source":"iana","compressible":true},"application/coap-eap":{"source":"iana"},"application/coap-group+json":{"source":"iana","compressible":true},"application/coap-payload":{"source":"iana"},"application/commonground":{"source":"iana"},"application/concise-problem-details+cbor":{"source":"iana"},"application/conference-info+xml":{"source":"iana","compressible":true},"application/cose":{"source":"iana"},"application/cose-key":{"source":"iana"},"application/cose-key-set":{"source":"iana"},"application/cose-x509":{"source":"iana"},"application/cpl+xml":{"source":"iana","compressible":true,"extensions":["cpl"]},"application/csrattrs":{"source":"iana"},"application/csta+xml":{"source":"iana","compressible":true},"application/cstadata+xml":{"source":"iana","compressible":true},"application/csvm+json":{"source":"iana","compressible":true},"application/cu-seeme":{"source":"apache","extensions":["cu"]},"application/cwl":{"source":"iana","extensions":["cwl"]},"application/cwl+json":{"source":"iana","compressible":true},"application/cwl+yaml":{"source":"iana"},"application/cwt":{"source":"iana"},"application/cybercash":{"source":"iana"},"application/dart":{"compressible":true},"application/dash+xml":{"source":"iana","compressible":true,"extensions":["mpd"]},"application/dash-patch+xml":{"source":"iana","compressible":true,"extensions":["mpp"]},"application/dashdelta":{"source":"iana"},"application/davmount+xml":{"source":"iana","compressible":true,"extensions":["davmount"]},"application/dca-rft":{"source":"iana"},"application/dcd":{"source":"iana"},"application/dec-dx":{"source":"iana"},"application/dialog-info+xml":{"source":"iana","compressible":true},"application/dicom":{"source":"iana","extensions":["dcm"]},"application/dicom+json":{"source":"iana","compressible":true},"application/dicom+xml":{"source":"iana","compressible":true},"application/dii":{"source":"iana"},"application/dit":{"source":"iana"},"application/dns":{"source":"iana"},"application/dns+json":{"source":"iana","compressible":true},"application/dns-message":{"source":"iana"},"application/docbook+xml":{"source":"apache","compressible":true,"extensions":["dbk"]},"application/dots+cbor":{"source":"iana"},"application/dpop+jwt":{"source":"iana"},"application/dskpp+xml":{"source":"iana","compressible":true},"application/dssc+der":{"source":"iana","extensions":["dssc"]},"application/dssc+xml":{"source":"iana","compressible":true,"extensions":["xdssc"]},"application/dvcs":{"source":"iana"},"application/eat+cwt":{"source":"iana"},"application/eat+jwt":{"source":"iana"},"application/eat-bun+cbor":{"source":"iana"},"application/eat-bun+json":{"source":"iana","compressible":true},"application/eat-ucs+cbor":{"source":"iana"},"application/eat-ucs+json":{"source":"iana","compressible":true},"application/ecmascript":{"source":"apache","compressible":true,"extensions":["ecma"]},"application/edhoc+cbor-seq":{"source":"iana"},"application/edi-consent":{"source":"iana"},"application/edi-x12":{"source":"iana","compressible":false},"application/edifact":{"source":"iana","compressible":false},"application/efi":{"source":"iana"},"application/elm+json":{"source":"iana","charset":"UTF-8","compressible":true},"application/elm+xml":{"source":"iana","compressible":true},"application/emergencycalldata.cap+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/emergencycalldata.comment+xml":{"source":"iana","compressible":true},"application/emergencycalldata.control+xml":{"source":"iana","compressible":true},"application/emergencycalldata.deviceinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.ecall.msd":{"source":"iana"},"application/emergencycalldata.legacyesn+json":{"source":"iana","compressible":true},"application/emergencycalldata.providerinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.serviceinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.subscriberinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.veds+xml":{"source":"iana","compressible":true},"application/emma+xml":{"source":"iana","compressible":true,"extensions":["emma"]},"application/emotionml+xml":{"source":"iana","compressible":true,"extensions":["emotionml"]},"application/encaprtp":{"source":"iana"},"application/entity-statement+jwt":{"source":"iana"},"application/epp+xml":{"source":"iana","compressible":true},"application/epub+zip":{"source":"iana","compressible":false,"extensions":["epub"]},"application/eshop":{"source":"iana"},"application/exi":{"source":"iana","extensions":["exi"]},"application/expect-ct-report+json":{"source":"iana","compressible":true},"application/express":{"source":"iana","extensions":["exp"]},"application/fastinfoset":{"source":"iana"},"application/fastsoap":{"source":"iana"},"application/fdf":{"source":"iana","extensions":["fdf"]},"application/fdt+xml":{"source":"iana","compressible":true,"extensions":["fdt"]},"application/fhir+json":{"source":"iana","charset":"UTF-8","compressible":true},"application/fhir+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/fido.trusted-apps+json":{"compressible":true},"application/fits":{"source":"iana"},"application/flexfec":{"source":"iana"},"application/font-sfnt":{"source":"iana"},"application/font-tdpfr":{"source":"iana","extensions":["pfr"]},"application/font-woff":{"source":"iana","compressible":false},"application/framework-attributes+xml":{"source":"iana","compressible":true},"application/geo+json":{"source":"iana","compressible":true,"extensions":["geojson"]},"application/geo+json-seq":{"source":"iana"},"application/geopackage+sqlite3":{"source":"iana"},"application/geopose+json":{"source":"iana","compressible":true},"application/geoxacml+json":{"source":"iana","compressible":true},"application/geoxacml+xml":{"source":"iana","compressible":true},"application/gltf-buffer":{"source":"iana"},"application/gml+xml":{"source":"iana","compressible":true,"extensions":["gml"]},"application/gnap-binding-jws":{"source":"iana"},"application/gnap-binding-jwsd":{"source":"iana"},"application/gnap-binding-rotation-jws":{"source":"iana"},"application/gnap-binding-rotation-jwsd":{"source":"iana"},"application/gpx+xml":{"source":"apache","compressible":true,"extensions":["gpx"]},"application/grib":{"source":"iana"},"application/gxf":{"source":"apache","extensions":["gxf"]},"application/gzip":{"source":"iana","compressible":false,"extensions":["gz"]},"application/h224":{"source":"iana"},"application/held+xml":{"source":"iana","compressible":true},"application/hjson":{"extensions":["hjson"]},"application/hl7v2+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/http":{"source":"iana"},"application/hyperstudio":{"source":"iana","extensions":["stk"]},"application/ibe-key-request+xml":{"source":"iana","compressible":true},"application/ibe-pkg-reply+xml":{"source":"iana","compressible":true},"application/ibe-pp-data":{"source":"iana"},"application/iges":{"source":"iana"},"application/im-iscomposing+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/index":{"source":"iana"},"application/index.cmd":{"source":"iana"},"application/index.obj":{"source":"iana"},"application/index.response":{"source":"iana"},"application/index.vnd":{"source":"iana"},"application/inkml+xml":{"source":"iana","compressible":true,"extensions":["ink","inkml"]},"application/iotp":{"source":"iana"},"application/ipfix":{"source":"iana","extensions":["ipfix"]},"application/ipp":{"source":"iana"},"application/isup":{"source":"iana"},"application/its+xml":{"source":"iana","compressible":true,"extensions":["its"]},"application/java-archive":{"source":"iana","compressible":false,"extensions":["jar","war","ear"]},"application/java-serialized-object":{"source":"apache","compressible":false,"extensions":["ser"]},"application/java-vm":{"source":"apache","compressible":false,"extensions":["class"]},"application/javascript":{"source":"apache","charset":"UTF-8","compressible":true,"extensions":["js"]},"application/jf2feed+json":{"source":"iana","compressible":true},"application/jose":{"source":"iana"},"application/jose+json":{"source":"iana","compressible":true},"application/jrd+json":{"source":"iana","compressible":true},"application/jscalendar+json":{"source":"iana","compressible":true},"application/jscontact+json":{"source":"iana","compressible":true},"application/json":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["json","map"]},"application/json-patch+json":{"source":"iana","compressible":true},"application/json-seq":{"source":"iana"},"application/json5":{"extensions":["json5"]},"application/jsonml+json":{"source":"apache","compressible":true,"extensions":["jsonml"]},"application/jsonpath":{"source":"iana"},"application/jwk+json":{"source":"iana","compressible":true},"application/jwk-set+json":{"source":"iana","compressible":true},"application/jwk-set+jwt":{"source":"iana"},"application/jwt":{"source":"iana"},"application/kpml-request+xml":{"source":"iana","compressible":true},"application/kpml-response+xml":{"source":"iana","compressible":true},"application/ld+json":{"source":"iana","compressible":true,"extensions":["jsonld"]},"application/lgr+xml":{"source":"iana","compressible":true,"extensions":["lgr"]},"application/link-format":{"source":"iana"},"application/linkset":{"source":"iana"},"application/linkset+json":{"source":"iana","compressible":true},"application/load-control+xml":{"source":"iana","compressible":true},"application/logout+jwt":{"source":"iana"},"application/lost+xml":{"source":"iana","compressible":true,"extensions":["lostxml"]},"application/lostsync+xml":{"source":"iana","compressible":true},"application/lpf+zip":{"source":"iana","compressible":false},"application/lxf":{"source":"iana"},"application/mac-binhex40":{"source":"iana","extensions":["hqx"]},"application/mac-compactpro":{"source":"apache","extensions":["cpt"]},"application/macwriteii":{"source":"iana"},"application/mads+xml":{"source":"iana","compressible":true,"extensions":["mads"]},"application/manifest+json":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["webmanifest"]},"application/marc":{"source":"iana","extensions":["mrc"]},"application/marcxml+xml":{"source":"iana","compressible":true,"extensions":["mrcx"]},"application/mathematica":{"source":"iana","extensions":["ma","nb","mb"]},"application/mathml+xml":{"source":"iana","compressible":true,"extensions":["mathml"]},"application/mathml-content+xml":{"source":"iana","compressible":true},"application/mathml-presentation+xml":{"source":"iana","compressible":true},"application/mbms-associated-procedure-description+xml":{"source":"iana","compressible":true},"application/mbms-deregister+xml":{"source":"iana","compressible":true},"application/mbms-envelope+xml":{"source":"iana","compressible":true},"application/mbms-msk+xml":{"source":"iana","compressible":true},"application/mbms-msk-response+xml":{"source":"iana","compressible":true},"application/mbms-protection-description+xml":{"source":"iana","compressible":true},"application/mbms-reception-report+xml":{"source":"iana","compressible":true},"application/mbms-register+xml":{"source":"iana","compressible":true},"application/mbms-register-response+xml":{"source":"iana","compressible":true},"application/mbms-schedule+xml":{"source":"iana","compressible":true},"application/mbms-user-service-description+xml":{"source":"iana","compressible":true},"application/mbox":{"source":"iana","extensions":["mbox"]},"application/media-policy-dataset+xml":{"source":"iana","compressible":true,"extensions":["mpf"]},"application/media_control+xml":{"source":"iana","compressible":true},"application/mediaservercontrol+xml":{"source":"iana","compressible":true,"extensions":["mscml"]},"application/merge-patch+json":{"source":"iana","compressible":true},"application/metalink+xml":{"source":"apache","compressible":true,"extensions":["metalink"]},"application/metalink4+xml":{"source":"iana","compressible":true,"extensions":["meta4"]},"application/mets+xml":{"source":"iana","compressible":true,"extensions":["mets"]},"application/mf4":{"source":"iana"},"application/mikey":{"source":"iana"},"application/mipc":{"source":"iana"},"application/missing-blocks+cbor-seq":{"source":"iana"},"application/mmt-aei+xml":{"source":"iana","compressible":true,"extensions":["maei"]},"application/mmt-usd+xml":{"source":"iana","compressible":true,"extensions":["musd"]},"application/mods+xml":{"source":"iana","compressible":true,"extensions":["mods"]},"application/moss-keys":{"source":"iana"},"application/moss-signature":{"source":"iana"},"application/mosskey-data":{"source":"iana"},"application/mosskey-request":{"source":"iana"},"application/mp21":{"source":"iana","extensions":["m21","mp21"]},"application/mp4":{"source":"iana","extensions":["mp4","mpg4","mp4s","m4p"]},"application/mpeg4-generic":{"source":"iana"},"application/mpeg4-iod":{"source":"iana"},"application/mpeg4-iod-xmt":{"source":"iana"},"application/mrb-consumer+xml":{"source":"iana","compressible":true},"application/mrb-publish+xml":{"source":"iana","compressible":true},"application/msc-ivr+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/msc-mixer+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/msix":{"compressible":false,"extensions":["msix"]},"application/msixbundle":{"compressible":false,"extensions":["msixbundle"]},"application/msword":{"source":"iana","compressible":false,"extensions":["doc","dot"]},"application/mud+json":{"source":"iana","compressible":true},"application/multipart-core":{"source":"iana"},"application/mxf":{"source":"iana","extensions":["mxf"]},"application/n-quads":{"source":"iana","extensions":["nq"]},"application/n-triples":{"source":"iana","extensions":["nt"]},"application/nasdata":{"source":"iana"},"application/news-checkgroups":{"source":"iana","charset":"US-ASCII"},"application/news-groupinfo":{"source":"iana","charset":"US-ASCII"},"application/news-transmission":{"source":"iana"},"application/nlsml+xml":{"source":"iana","compressible":true},"application/node":{"source":"iana","extensions":["cjs"]},"application/nss":{"source":"iana"},"application/oauth-authz-req+jwt":{"source":"iana"},"application/oblivious-dns-message":{"source":"iana"},"application/ocsp-request":{"source":"iana"},"application/ocsp-response":{"source":"iana"},"application/octet-stream":{"source":"iana","compressible":true,"extensions":["bin","dms","lrf","mar","so","dist","distz","pkg","bpk","dump","elc","deploy","exe","dll","deb","dmg","iso","img","msi","msp","msm","buffer"]},"application/oda":{"source":"iana","extensions":["oda"]},"application/odm+xml":{"source":"iana","compressible":true},"application/odx":{"source":"iana"},"application/oebps-package+xml":{"source":"iana","compressible":true,"extensions":["opf"]},"application/ogg":{"source":"iana","compressible":false,"extensions":["ogx"]},"application/ohttp-keys":{"source":"iana"},"application/omdoc+xml":{"source":"apache","compressible":true,"extensions":["omdoc"]},"application/onenote":{"source":"apache","extensions":["onetoc","onetoc2","onetmp","onepkg","one","onea"]},"application/opc-nodeset+xml":{"source":"iana","compressible":true},"application/oscore":{"source":"iana"},"application/oxps":{"source":"iana","extensions":["oxps"]},"application/p21":{"source":"iana"},"application/p21+zip":{"source":"iana","compressible":false},"application/p2p-overlay+xml":{"source":"iana","compressible":true,"extensions":["relo"]},"application/parityfec":{"source":"iana"},"application/passport":{"source":"iana"},"application/patch-ops-error+xml":{"source":"iana","compressible":true,"extensions":["xer"]},"application/pdf":{"source":"iana","compressible":false,"extensions":["pdf"]},"application/pdx":{"source":"iana"},"application/pem-certificate-chain":{"source":"iana"},"application/pgp-encrypted":{"source":"iana","compressible":false,"extensions":["pgp"]},"application/pgp-keys":{"source":"iana","extensions":["asc"]},"application/pgp-signature":{"source":"iana","extensions":["sig","asc"]},"application/pics-rules":{"source":"apache","extensions":["prf"]},"application/pidf+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/pidf-diff+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/pkcs10":{"source":"iana","extensions":["p10"]},"application/pkcs12":{"source":"iana"},"application/pkcs7-mime":{"source":"iana","extensions":["p7m","p7c"]},"application/pkcs7-signature":{"source":"iana","extensions":["p7s"]},"application/pkcs8":{"source":"iana","extensions":["p8"]},"application/pkcs8-encrypted":{"source":"iana"},"application/pkix-attr-cert":{"source":"iana","extensions":["ac"]},"application/pkix-cert":{"source":"iana","extensions":["cer"]},"application/pkix-crl":{"source":"iana","extensions":["crl"]},"application/pkix-pkipath":{"source":"iana","extensions":["pkipath"]},"application/pkixcmp":{"source":"iana","extensions":["pki"]},"application/pls+xml":{"source":"iana","compressible":true,"extensions":["pls"]},"application/poc-settings+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/postscript":{"source":"iana","compressible":true,"extensions":["ai","eps","ps"]},"application/ppsp-tracker+json":{"source":"iana","compressible":true},"application/private-token-issuer-directory":{"source":"iana"},"application/private-token-request":{"source":"iana"},"application/private-token-response":{"source":"iana"},"application/problem+json":{"source":"iana","compressible":true},"application/problem+xml":{"source":"iana","compressible":true},"application/provenance+xml":{"source":"iana","compressible":true,"extensions":["provx"]},"application/provided-claims+jwt":{"source":"iana"},"application/prs.alvestrand.titrax-sheet":{"source":"iana"},"application/prs.cww":{"source":"iana","extensions":["cww"]},"application/prs.cyn":{"source":"iana","charset":"7-BIT"},"application/prs.hpub+zip":{"source":"iana","compressible":false},"application/prs.implied-document+xml":{"source":"iana","compressible":true},"application/prs.implied-executable":{"source":"iana"},"application/prs.implied-object+json":{"source":"iana","compressible":true},"application/prs.implied-object+json-seq":{"source":"iana"},"application/prs.implied-object+yaml":{"source":"iana"},"application/prs.implied-structure":{"source":"iana"},"application/prs.mayfile":{"source":"iana"},"application/prs.nprend":{"source":"iana"},"application/prs.plucker":{"source":"iana"},"application/prs.rdf-xml-crypt":{"source":"iana"},"application/prs.vcfbzip2":{"source":"iana"},"application/prs.xsf+xml":{"source":"iana","compressible":true,"extensions":["xsf"]},"application/pskc+xml":{"source":"iana","compressible":true,"extensions":["pskcxml"]},"application/pvd+json":{"source":"iana","compressible":true},"application/qsig":{"source":"iana"},"application/raml+yaml":{"compressible":true,"extensions":["raml"]},"application/raptorfec":{"source":"iana"},"application/rdap+json":{"source":"iana","compressible":true},"application/rdf+xml":{"source":"iana","compressible":true,"extensions":["rdf","owl"]},"application/reginfo+xml":{"source":"iana","compressible":true,"extensions":["rif"]},"application/relax-ng-compact-syntax":{"source":"iana","extensions":["rnc"]},"application/remote-printing":{"source":"apache"},"application/reputon+json":{"source":"iana","compressible":true},"application/resolve-response+jwt":{"source":"iana"},"application/resource-lists+xml":{"source":"iana","compressible":true,"extensions":["rl"]},"application/resource-lists-diff+xml":{"source":"iana","compressible":true,"extensions":["rld"]},"application/rfc+xml":{"source":"iana","compressible":true},"application/riscos":{"source":"iana"},"application/rlmi+xml":{"source":"iana","compressible":true},"application/rls-services+xml":{"source":"iana","compressible":true,"extensions":["rs"]},"application/route-apd+xml":{"source":"iana","compressible":true,"extensions":["rapd"]},"application/route-s-tsid+xml":{"source":"iana","compressible":true,"extensions":["sls"]},"application/route-usd+xml":{"source":"iana","compressible":true,"extensions":["rusd"]},"application/rpki-checklist":{"source":"iana"},"application/rpki-ghostbusters":{"source":"iana","extensions":["gbr"]},"application/rpki-manifest":{"source":"iana","extensions":["mft"]},"application/rpki-publication":{"source":"iana"},"application/rpki-roa":{"source":"iana","extensions":["roa"]},"application/rpki-signed-tal":{"source":"iana"},"application/rpki-updown":{"source":"iana"},"application/rsd+xml":{"source":"apache","compressible":true,"extensions":["rsd"]},"application/rss+xml":{"source":"apache","compressible":true,"extensions":["rss"]},"application/rtf":{"source":"iana","compressible":true,"extensions":["rtf"]},"application/rtploopback":{"source":"iana"},"application/rtx":{"source":"iana"},"application/samlassertion+xml":{"source":"iana","compressible":true},"application/samlmetadata+xml":{"source":"iana","compressible":true},"application/sarif+json":{"source":"iana","compressible":true},"application/sarif-external-properties+json":{"source":"iana","compressible":true},"application/sbe":{"source":"iana"},"application/sbml+xml":{"source":"iana","compressible":true,"extensions":["sbml"]},"application/scaip+xml":{"source":"iana","compressible":true},"application/scim+json":{"source":"iana","compressible":true},"application/scvp-cv-request":{"source":"iana","extensions":["scq"]},"application/scvp-cv-response":{"source":"iana","extensions":["scs"]},"application/scvp-vp-request":{"source":"iana","extensions":["spq"]},"application/scvp-vp-response":{"source":"iana","extensions":["spp"]},"application/sdp":{"source":"iana","extensions":["sdp"]},"application/secevent+jwt":{"source":"iana"},"application/senml+cbor":{"source":"iana"},"application/senml+json":{"source":"iana","compressible":true},"application/senml+xml":{"source":"iana","compressible":true,"extensions":["senmlx"]},"application/senml-etch+cbor":{"source":"iana"},"application/senml-etch+json":{"source":"iana","compressible":true},"application/senml-exi":{"source":"iana"},"application/sensml+cbor":{"source":"iana"},"application/sensml+json":{"source":"iana","compressible":true},"application/sensml+xml":{"source":"iana","compressible":true,"extensions":["sensmlx"]},"application/sensml-exi":{"source":"iana"},"application/sep+xml":{"source":"iana","compressible":true},"application/sep-exi":{"source":"iana"},"application/session-info":{"source":"iana"},"application/set-payment":{"source":"iana"},"application/set-payment-initiation":{"source":"iana","extensions":["setpay"]},"application/set-registration":{"source":"iana"},"application/set-registration-initiation":{"source":"iana","extensions":["setreg"]},"application/sgml":{"source":"iana"},"application/sgml-open-catalog":{"source":"iana"},"application/shf+xml":{"source":"iana","compressible":true,"extensions":["shf"]},"application/sieve":{"source":"iana","extensions":["siv","sieve"]},"application/simple-filter+xml":{"source":"iana","compressible":true},"application/simple-message-summary":{"source":"iana"},"application/simplesymbolcontainer":{"source":"iana"},"application/sipc":{"source":"iana"},"application/slate":{"source":"iana"},"application/smil":{"source":"apache"},"application/smil+xml":{"source":"iana","compressible":true,"extensions":["smi","smil"]},"application/smpte336m":{"source":"iana"},"application/soap+fastinfoset":{"source":"iana"},"application/soap+xml":{"source":"iana","compressible":true},"application/sparql-query":{"source":"iana","extensions":["rq"]},"application/sparql-results+xml":{"source":"iana","compressible":true,"extensions":["srx"]},"application/spdx+json":{"source":"iana","compressible":true},"application/spirits-event+xml":{"source":"iana","compressible":true},"application/sql":{"source":"iana","extensions":["sql"]},"application/srgs":{"source":"iana","extensions":["gram"]},"application/srgs+xml":{"source":"iana","compressible":true,"extensions":["grxml"]},"application/sru+xml":{"source":"iana","compressible":true,"extensions":["sru"]},"application/ssdl+xml":{"source":"apache","compressible":true,"extensions":["ssdl"]},"application/sslkeylogfile":{"source":"iana"},"application/ssml+xml":{"source":"iana","compressible":true,"extensions":["ssml"]},"application/st2110-41":{"source":"iana"},"application/stix+json":{"source":"iana","compressible":true},"application/stratum":{"source":"iana"},"application/swid+cbor":{"source":"iana"},"application/swid+xml":{"source":"iana","compressible":true,"extensions":["swidtag"]},"application/tamp-apex-update":{"source":"iana"},"application/tamp-apex-update-confirm":{"source":"iana"},"application/tamp-community-update":{"source":"iana"},"application/tamp-community-update-confirm":{"source":"iana"},"application/tamp-error":{"source":"iana"},"application/tamp-sequence-adjust":{"source":"iana"},"application/tamp-sequence-adjust-confirm":{"source":"iana"},"application/tamp-status-query":{"source":"iana"},"application/tamp-status-response":{"source":"iana"},"application/tamp-update":{"source":"iana"},"application/tamp-update-confirm":{"source":"iana"},"application/tar":{"compressible":true},"application/taxii+json":{"source":"iana","compressible":true},"application/td+json":{"source":"iana","compressible":true},"application/tei+xml":{"source":"iana","compressible":true,"extensions":["tei","teicorpus"]},"application/tetra_isi":{"source":"iana"},"application/thraud+xml":{"source":"iana","compressible":true,"extensions":["tfi"]},"application/timestamp-query":{"source":"iana"},"application/timestamp-reply":{"source":"iana"},"application/timestamped-data":{"source":"iana","extensions":["tsd"]},"application/tlsrpt+gzip":{"source":"iana"},"application/tlsrpt+json":{"source":"iana","compressible":true},"application/tm+json":{"source":"iana","compressible":true},"application/tnauthlist":{"source":"iana"},"application/toc+cbor":{"source":"iana"},"application/token-introspection+jwt":{"source":"iana"},"application/toml":{"source":"iana","compressible":true,"extensions":["toml"]},"application/trickle-ice-sdpfrag":{"source":"iana"},"application/trig":{"source":"iana","extensions":["trig"]},"application/trust-chain+json":{"source":"iana","compressible":true},"application/trust-mark+jwt":{"source":"iana"},"application/trust-mark-delegation+jwt":{"source":"iana"},"application/ttml+xml":{"source":"iana","compressible":true,"extensions":["ttml"]},"application/tve-trigger":{"source":"iana"},"application/tzif":{"source":"iana"},"application/tzif-leap":{"source":"iana"},"application/ubjson":{"compressible":false,"extensions":["ubj"]},"application/uccs+cbor":{"source":"iana"},"application/ujcs+json":{"source":"iana","compressible":true},"application/ulpfec":{"source":"iana"},"application/urc-grpsheet+xml":{"source":"iana","compressible":true},"application/urc-ressheet+xml":{"source":"iana","compressible":true,"extensions":["rsheet"]},"application/urc-targetdesc+xml":{"source":"iana","compressible":true,"extensions":["td"]},"application/urc-uisocketdesc+xml":{"source":"iana","compressible":true},"application/vc":{"source":"iana"},"application/vc+cose":{"source":"iana"},"application/vc+jwt":{"source":"iana"},"application/vcard+json":{"source":"iana","compressible":true},"application/vcard+xml":{"source":"iana","compressible":true},"application/vemmi":{"source":"iana"},"application/vividence.scriptfile":{"source":"apache"},"application/vnd.1000minds.decision-model+xml":{"source":"iana","compressible":true,"extensions":["1km"]},"application/vnd.1ob":{"source":"iana"},"application/vnd.3gpp-prose+xml":{"source":"iana","compressible":true},"application/vnd.3gpp-prose-pc3a+xml":{"source":"iana","compressible":true},"application/vnd.3gpp-prose-pc3ach+xml":{"source":"iana","compressible":true},"application/vnd.3gpp-prose-pc3ch+xml":{"source":"iana","compressible":true},"application/vnd.3gpp-prose-pc8+xml":{"source":"iana","compressible":true},"application/vnd.3gpp-v2x-local-service-information":{"source":"iana"},"application/vnd.3gpp.5gnas":{"source":"iana"},"application/vnd.3gpp.5gsa2x":{"source":"iana"},"application/vnd.3gpp.5gsa2x-local-service-information":{"source":"iana"},"application/vnd.3gpp.5gsv2x":{"source":"iana"},"application/vnd.3gpp.5gsv2x-local-service-information":{"source":"iana"},"application/vnd.3gpp.access-transfer-events+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.bsf+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.crs+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.current-location-discovery+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.gmop+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.gtpc":{"source":"iana"},"application/vnd.3gpp.interworking-data":{"source":"iana"},"application/vnd.3gpp.lpp":{"source":"iana"},"application/vnd.3gpp.mc-signalling-ear":{"source":"iana"},"application/vnd.3gpp.mcdata-affiliation-command+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-msgstore-ctrl-request+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-payload":{"source":"iana"},"application/vnd.3gpp.mcdata-regroup+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-service-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-signalling":{"source":"iana"},"application/vnd.3gpp.mcdata-ue-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-user-profile+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-affiliation-command+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-floor-request+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-location-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-mbms-usage-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-regroup+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-service-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-signed+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-ue-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-ue-init-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-user-profile+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-affiliation-command+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-location-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-mbms-usage-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-regroup+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-service-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-transmission-request+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-ue-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-user-profile+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mid-call+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.ngap":{"source":"iana"},"application/vnd.3gpp.pfcp":{"source":"iana"},"application/vnd.3gpp.pic-bw-large":{"source":"iana","extensions":["plb"]},"application/vnd.3gpp.pic-bw-small":{"source":"iana","extensions":["psb"]},"application/vnd.3gpp.pic-bw-var":{"source":"iana","extensions":["pvb"]},"application/vnd.3gpp.pinapp-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.s1ap":{"source":"iana"},"application/vnd.3gpp.seal-group-doc+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.seal-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.seal-location-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.seal-mbms-usage-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.seal-network-qos-management-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.seal-ue-config-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.seal-unicast-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.seal-user-profile-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.sms":{"source":"iana"},"application/vnd.3gpp.sms+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.srvcc-ext+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.srvcc-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.state-and-event-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.ussd+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.v2x":{"source":"iana"},"application/vnd.3gpp.vae-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp2.bcmcsinfo+xml":{"source":"iana","compressible":true},"application/vnd.3gpp2.sms":{"source":"iana"},"application/vnd.3gpp2.tcap":{"source":"iana","extensions":["tcap"]},"application/vnd.3lightssoftware.imagescal":{"source":"iana"},"application/vnd.3m.post-it-notes":{"source":"iana","extensions":["pwn"]},"application/vnd.accpac.simply.aso":{"source":"iana","extensions":["aso"]},"application/vnd.accpac.simply.imp":{"source":"iana","extensions":["imp"]},"application/vnd.acm.addressxfer+json":{"source":"iana","compressible":true},"application/vnd.acm.chatbot+json":{"source":"iana","compressible":true},"application/vnd.acucobol":{"source":"iana","extensions":["acu"]},"application/vnd.acucorp":{"source":"iana","extensions":["atc","acutc"]},"application/vnd.adobe.air-application-installer-package+zip":{"source":"apache","compressible":false,"extensions":["air"]},"application/vnd.adobe.flash.movie":{"source":"iana"},"application/vnd.adobe.formscentral.fcdt":{"source":"iana","extensions":["fcdt"]},"application/vnd.adobe.fxp":{"source":"iana","extensions":["fxp","fxpl"]},"application/vnd.adobe.partial-upload":{"source":"iana"},"application/vnd.adobe.xdp+xml":{"source":"iana","compressible":true,"extensions":["xdp"]},"application/vnd.adobe.xfdf":{"source":"apache","extensions":["xfdf"]},"application/vnd.aether.imp":{"source":"iana"},"application/vnd.afpc.afplinedata":{"source":"iana"},"application/vnd.afpc.afplinedata-pagedef":{"source":"iana"},"application/vnd.afpc.cmoca-cmresource":{"source":"iana"},"application/vnd.afpc.foca-charset":{"source":"iana"},"application/vnd.afpc.foca-codedfont":{"source":"iana"},"application/vnd.afpc.foca-codepage":{"source":"iana"},"application/vnd.afpc.modca":{"source":"iana"},"application/vnd.afpc.modca-cmtable":{"source":"iana"},"application/vnd.afpc.modca-formdef":{"source":"iana"},"application/vnd.afpc.modca-mediummap":{"source":"iana"},"application/vnd.afpc.modca-objectcontainer":{"source":"iana"},"application/vnd.afpc.modca-overlay":{"source":"iana"},"application/vnd.afpc.modca-pagesegment":{"source":"iana"},"application/vnd.age":{"source":"iana","extensions":["age"]},"application/vnd.ah-barcode":{"source":"apache"},"application/vnd.ahead.space":{"source":"iana","extensions":["ahead"]},"application/vnd.airzip.filesecure.azf":{"source":"iana","extensions":["azf"]},"application/vnd.airzip.filesecure.azs":{"source":"iana","extensions":["azs"]},"application/vnd.amadeus+json":{"source":"iana","compressible":true},"application/vnd.amazon.ebook":{"source":"apache","extensions":["azw"]},"application/vnd.amazon.mobi8-ebook":{"source":"iana"},"application/vnd.americandynamics.acc":{"source":"iana","extensions":["acc"]},"application/vnd.amiga.ami":{"source":"iana","extensions":["ami"]},"application/vnd.amundsen.maze+xml":{"source":"iana","compressible":true},"application/vnd.android.ota":{"source":"iana"},"application/vnd.android.package-archive":{"source":"apache","compressible":false,"extensions":["apk"]},"application/vnd.anki":{"source":"iana"},"application/vnd.anser-web-certificate-issue-initiation":{"source":"iana","extensions":["cii"]},"application/vnd.anser-web-funds-transfer-initiation":{"source":"apache","extensions":["fti"]},"application/vnd.antix.game-component":{"source":"iana","extensions":["atx"]},"application/vnd.apache.arrow.file":{"source":"iana"},"application/vnd.apache.arrow.stream":{"source":"iana"},"application/vnd.apache.parquet":{"source":"iana"},"application/vnd.apache.thrift.binary":{"source":"iana"},"application/vnd.apache.thrift.compact":{"source":"iana"},"application/vnd.apache.thrift.json":{"source":"iana"},"application/vnd.apexlang":{"source":"iana"},"application/vnd.api+json":{"source":"iana","compressible":true},"application/vnd.aplextor.warrp+json":{"source":"iana","compressible":true},"application/vnd.apothekende.reservation+json":{"source":"iana","compressible":true},"application/vnd.apple.installer+xml":{"source":"iana","compressible":true,"extensions":["mpkg"]},"application/vnd.apple.keynote":{"source":"iana","extensions":["key"]},"application/vnd.apple.mpegurl":{"source":"iana","extensions":["m3u8"]},"application/vnd.apple.numbers":{"source":"iana","extensions":["numbers"]},"application/vnd.apple.pages":{"source":"iana","extensions":["pages"]},"application/vnd.apple.pkpass":{"compressible":false,"extensions":["pkpass"]},"application/vnd.arastra.swi":{"source":"apache"},"application/vnd.aristanetworks.swi":{"source":"iana","extensions":["swi"]},"application/vnd.artisan+json":{"source":"iana","compressible":true},"application/vnd.artsquare":{"source":"iana"},"application/vnd.astraea-software.iota":{"source":"iana","extensions":["iota"]},"application/vnd.audiograph":{"source":"iana","extensions":["aep"]},"application/vnd.autodesk.fbx":{"extensions":["fbx"]},"application/vnd.autopackage":{"source":"iana"},"application/vnd.avalon+json":{"source":"iana","compressible":true},"application/vnd.avistar+xml":{"source":"iana","compressible":true},"application/vnd.balsamiq.bmml+xml":{"source":"iana","compressible":true,"extensions":["bmml"]},"application/vnd.balsamiq.bmpr":{"source":"iana"},"application/vnd.banana-accounting":{"source":"iana"},"application/vnd.bbf.usp.error":{"source":"iana"},"application/vnd.bbf.usp.msg":{"source":"iana"},"application/vnd.bbf.usp.msg+json":{"source":"iana","compressible":true},"application/vnd.bekitzur-stech+json":{"source":"iana","compressible":true},"application/vnd.belightsoft.lhzd+zip":{"source":"iana","compressible":false},"application/vnd.belightsoft.lhzl+zip":{"source":"iana","compressible":false},"application/vnd.bint.med-content":{"source":"iana"},"application/vnd.biopax.rdf+xml":{"source":"iana","compressible":true},"application/vnd.blink-idb-value-wrapper":{"source":"iana"},"application/vnd.blueice.multipass":{"source":"iana","extensions":["mpm"]},"application/vnd.bluetooth.ep.oob":{"source":"iana"},"application/vnd.bluetooth.le.oob":{"source":"iana"},"application/vnd.bmi":{"source":"iana","extensions":["bmi"]},"application/vnd.bpf":{"source":"iana"},"application/vnd.bpf3":{"source":"iana"},"application/vnd.businessobjects":{"source":"iana","extensions":["rep"]},"application/vnd.byu.uapi+json":{"source":"iana","compressible":true},"application/vnd.bzip3":{"source":"iana"},"application/vnd.c3voc.schedule+xml":{"source":"iana","compressible":true},"application/vnd.cab-jscript":{"source":"iana"},"application/vnd.canon-cpdl":{"source":"iana"},"application/vnd.canon-lips":{"source":"iana"},"application/vnd.capasystems-pg+json":{"source":"iana","compressible":true},"application/vnd.cendio.thinlinc.clientconf":{"source":"iana"},"application/vnd.century-systems.tcp_stream":{"source":"iana"},"application/vnd.chemdraw+xml":{"source":"iana","compressible":true,"extensions":["cdxml"]},"application/vnd.chess-pgn":{"source":"iana"},"application/vnd.chipnuts.karaoke-mmd":{"source":"iana","extensions":["mmd"]},"application/vnd.ciedi":{"source":"iana"},"application/vnd.cinderella":{"source":"iana","extensions":["cdy"]},"application/vnd.cirpack.isdn-ext":{"source":"iana"},"application/vnd.citationstyles.style+xml":{"source":"iana","compressible":true,"extensions":["csl"]},"application/vnd.claymore":{"source":"iana","extensions":["cla"]},"application/vnd.cloanto.rp9":{"source":"iana","extensions":["rp9"]},"application/vnd.clonk.c4group":{"source":"iana","extensions":["c4g","c4d","c4f","c4p","c4u"]},"application/vnd.cluetrust.cartomobile-config":{"source":"iana","extensions":["c11amc"]},"application/vnd.cluetrust.cartomobile-config-pkg":{"source":"iana","extensions":["c11amz"]},"application/vnd.cncf.helm.chart.content.v1.tar+gzip":{"source":"iana"},"application/vnd.cncf.helm.chart.provenance.v1.prov":{"source":"iana"},"application/vnd.cncf.helm.config.v1+json":{"source":"iana","compressible":true},"application/vnd.coffeescript":{"source":"iana"},"application/vnd.collabio.xodocuments.document":{"source":"iana"},"application/vnd.collabio.xodocuments.document-template":{"source":"iana"},"application/vnd.collabio.xodocuments.presentation":{"source":"iana"},"application/vnd.collabio.xodocuments.presentation-template":{"source":"iana"},"application/vnd.collabio.xodocuments.spreadsheet":{"source":"iana"},"application/vnd.collabio.xodocuments.spreadsheet-template":{"source":"iana"},"application/vnd.collection+json":{"source":"iana","compressible":true},"application/vnd.collection.doc+json":{"source":"iana","compressible":true},"application/vnd.collection.next+json":{"source":"iana","compressible":true},"application/vnd.comicbook+zip":{"source":"iana","compressible":false},"application/vnd.comicbook-rar":{"source":"iana"},"application/vnd.commerce-battelle":{"source":"iana"},"application/vnd.commonspace":{"source":"iana","extensions":["csp"]},"application/vnd.contact.cmsg":{"source":"iana","extensions":["cdbcmsg"]},"application/vnd.coreos.ignition+json":{"source":"iana","compressible":true},"application/vnd.cosmocaller":{"source":"iana","extensions":["cmc"]},"application/vnd.crick.clicker":{"source":"iana","extensions":["clkx"]},"application/vnd.crick.clicker.keyboard":{"source":"iana","extensions":["clkk"]},"application/vnd.crick.clicker.palette":{"source":"iana","extensions":["clkp"]},"application/vnd.crick.clicker.template":{"source":"iana","extensions":["clkt"]},"application/vnd.crick.clicker.wordbank":{"source":"iana","extensions":["clkw"]},"application/vnd.criticaltools.wbs+xml":{"source":"iana","compressible":true,"extensions":["wbs"]},"application/vnd.cryptii.pipe+json":{"source":"iana","compressible":true},"application/vnd.crypto-shade-file":{"source":"iana"},"application/vnd.cryptomator.encrypted":{"source":"iana"},"application/vnd.cryptomator.vault":{"source":"iana"},"application/vnd.ctc-posml":{"source":"iana","extensions":["pml"]},"application/vnd.ctct.ws+xml":{"source":"iana","compressible":true},"application/vnd.cups-pdf":{"source":"iana"},"application/vnd.cups-postscript":{"source":"iana"},"application/vnd.cups-ppd":{"source":"iana","extensions":["ppd"]},"application/vnd.cups-raster":{"source":"iana"},"application/vnd.cups-raw":{"source":"iana"},"application/vnd.curl":{"source":"iana"},"application/vnd.curl.car":{"source":"apache","extensions":["car"]},"application/vnd.curl.pcurl":{"source":"apache","extensions":["pcurl"]},"application/vnd.cyan.dean.root+xml":{"source":"iana","compressible":true},"application/vnd.cybank":{"source":"iana"},"application/vnd.cyclonedx+json":{"source":"iana","compressible":true},"application/vnd.cyclonedx+xml":{"source":"iana","compressible":true},"application/vnd.d2l.coursepackage1p0+zip":{"source":"iana","compressible":false},"application/vnd.d3m-dataset":{"source":"iana"},"application/vnd.d3m-problem":{"source":"iana"},"application/vnd.dart":{"source":"iana","compressible":true,"extensions":["dart"]},"application/vnd.data-vision.rdz":{"source":"iana","extensions":["rdz"]},"application/vnd.datalog":{"source":"iana"},"application/vnd.datapackage+json":{"source":"iana","compressible":true},"application/vnd.dataresource+json":{"source":"iana","compressible":true},"application/vnd.dbf":{"source":"iana","extensions":["dbf"]},"application/vnd.dcmp+xml":{"source":"iana","compressible":true,"extensions":["dcmp"]},"application/vnd.debian.binary-package":{"source":"iana"},"application/vnd.dece.data":{"source":"iana","extensions":["uvf","uvvf","uvd","uvvd"]},"application/vnd.dece.ttml+xml":{"source":"iana","compressible":true,"extensions":["uvt","uvvt"]},"application/vnd.dece.unspecified":{"source":"iana","extensions":["uvx","uvvx"]},"application/vnd.dece.zip":{"source":"iana","extensions":["uvz","uvvz"]},"application/vnd.denovo.fcselayout-link":{"source":"iana","extensions":["fe_launch"]},"application/vnd.desmume.movie":{"source":"iana"},"application/vnd.dir-bi.plate-dl-nosuffix":{"source":"iana"},"application/vnd.dm.delegation+xml":{"source":"iana","compressible":true},"application/vnd.dna":{"source":"iana","extensions":["dna"]},"application/vnd.document+json":{"source":"iana","compressible":true},"application/vnd.dolby.mlp":{"source":"apache","extensions":["mlp"]},"application/vnd.dolby.mobile.1":{"source":"iana"},"application/vnd.dolby.mobile.2":{"source":"iana"},"application/vnd.doremir.scorecloud-binary-document":{"source":"iana"},"application/vnd.dpgraph":{"source":"iana","extensions":["dpg"]},"application/vnd.dreamfactory":{"source":"iana","extensions":["dfac"]},"application/vnd.drive+json":{"source":"iana","compressible":true},"application/vnd.ds-keypoint":{"source":"apache","extensions":["kpxx"]},"application/vnd.dtg.local":{"source":"iana"},"application/vnd.dtg.local.flash":{"source":"iana"},"application/vnd.dtg.local.html":{"source":"iana"},"application/vnd.dvb.ait":{"source":"iana","extensions":["ait"]},"application/vnd.dvb.dvbisl+xml":{"source":"iana","compressible":true},"application/vnd.dvb.dvbj":{"source":"iana"},"application/vnd.dvb.esgcontainer":{"source":"iana"},"application/vnd.dvb.ipdcdftnotifaccess":{"source":"iana"},"application/vnd.dvb.ipdcesgaccess":{"source":"iana"},"application/vnd.dvb.ipdcesgaccess2":{"source":"iana"},"application/vnd.dvb.ipdcesgpdd":{"source":"iana"},"application/vnd.dvb.ipdcroaming":{"source":"iana"},"application/vnd.dvb.iptv.alfec-base":{"source":"iana"},"application/vnd.dvb.iptv.alfec-enhancement":{"source":"iana"},"application/vnd.dvb.notif-aggregate-root+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-container+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-generic+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-ia-msglist+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-ia-registration-request+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-ia-registration-response+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-init+xml":{"source":"iana","compressible":true},"application/vnd.dvb.pfr":{"source":"iana"},"application/vnd.dvb.service":{"source":"iana","extensions":["svc"]},"application/vnd.dxr":{"source":"iana"},"application/vnd.dynageo":{"source":"iana","extensions":["geo"]},"application/vnd.dzr":{"source":"iana"},"application/vnd.easykaraoke.cdgdownload":{"source":"iana"},"application/vnd.ecdis-update":{"source":"iana"},"application/vnd.ecip.rlp":{"source":"iana"},"application/vnd.eclipse.ditto+json":{"source":"iana","compressible":true},"application/vnd.ecowin.chart":{"source":"iana","extensions":["mag"]},"application/vnd.ecowin.filerequest":{"source":"iana"},"application/vnd.ecowin.fileupdate":{"source":"iana"},"application/vnd.ecowin.series":{"source":"iana"},"application/vnd.ecowin.seriesrequest":{"source":"iana"},"application/vnd.ecowin.seriesupdate":{"source":"iana"},"application/vnd.efi.img":{"source":"iana"},"application/vnd.efi.iso":{"source":"iana"},"application/vnd.eln+zip":{"source":"iana","compressible":false},"application/vnd.emclient.accessrequest+xml":{"source":"iana","compressible":true},"application/vnd.enliven":{"source":"iana","extensions":["nml"]},"application/vnd.enphase.envoy":{"source":"iana"},"application/vnd.eprints.data+xml":{"source":"iana","compressible":true},"application/vnd.epson.esf":{"source":"iana","extensions":["esf"]},"application/vnd.epson.msf":{"source":"iana","extensions":["msf"]},"application/vnd.epson.quickanime":{"source":"iana","extensions":["qam"]},"application/vnd.epson.salt":{"source":"iana","extensions":["slt"]},"application/vnd.epson.ssf":{"source":"iana","extensions":["ssf"]},"application/vnd.ericsson.quickcall":{"source":"iana"},"application/vnd.erofs":{"source":"iana"},"application/vnd.espass-espass+zip":{"source":"iana","compressible":false},"application/vnd.eszigno3+xml":{"source":"iana","compressible":true,"extensions":["es3","et3"]},"application/vnd.etsi.aoc+xml":{"source":"iana","compressible":true},"application/vnd.etsi.asic-e+zip":{"source":"iana","compressible":false},"application/vnd.etsi.asic-s+zip":{"source":"iana","compressible":false},"application/vnd.etsi.cug+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvcommand+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvdiscovery+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvprofile+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsad-bc+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsad-cod+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsad-npvr+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvservice+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsync+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvueprofile+xml":{"source":"iana","compressible":true},"application/vnd.etsi.mcid+xml":{"source":"iana","compressible":true},"application/vnd.etsi.mheg5":{"source":"iana"},"application/vnd.etsi.overload-control-policy-dataset+xml":{"source":"iana","compressible":true},"application/vnd.etsi.pstn+xml":{"source":"iana","compressible":true},"application/vnd.etsi.sci+xml":{"source":"iana","compressible":true},"application/vnd.etsi.simservs+xml":{"source":"iana","compressible":true},"application/vnd.etsi.timestamp-token":{"source":"iana"},"application/vnd.etsi.tsl+xml":{"source":"iana","compressible":true},"application/vnd.etsi.tsl.der":{"source":"iana"},"application/vnd.eu.kasparian.car+json":{"source":"iana","compressible":true},"application/vnd.eudora.data":{"source":"iana"},"application/vnd.evolv.ecig.profile":{"source":"iana"},"application/vnd.evolv.ecig.settings":{"source":"iana"},"application/vnd.evolv.ecig.theme":{"source":"iana"},"application/vnd.exstream-empower+zip":{"source":"iana","compressible":false},"application/vnd.exstream-package":{"source":"iana"},"application/vnd.ezpix-album":{"source":"iana","extensions":["ez2"]},"application/vnd.ezpix-package":{"source":"iana","extensions":["ez3"]},"application/vnd.f-secure.mobile":{"source":"iana"},"application/vnd.familysearch.gedcom+zip":{"source":"iana","compressible":false},"application/vnd.fastcopy-disk-image":{"source":"iana"},"application/vnd.fdf":{"source":"apache","extensions":["fdf"]},"application/vnd.fdsn.mseed":{"source":"iana","extensions":["mseed"]},"application/vnd.fdsn.seed":{"source":"iana","extensions":["seed","dataless"]},"application/vnd.fdsn.stationxml+xml":{"source":"iana","charset":"XML-BASED","compressible":true},"application/vnd.ffsns":{"source":"iana"},"application/vnd.ficlab.flb+zip":{"source":"iana","compressible":false},"application/vnd.filmit.zfc":{"source":"iana"},"application/vnd.fints":{"source":"iana"},"application/vnd.firemonkeys.cloudcell":{"source":"iana"},"application/vnd.flographit":{"source":"iana","extensions":["gph"]},"application/vnd.fluxtime.clip":{"source":"iana","extensions":["ftc"]},"application/vnd.font-fontforge-sfd":{"source":"iana"},"application/vnd.framemaker":{"source":"iana","extensions":["fm","frame","maker","book"]},"application/vnd.freelog.comic":{"source":"iana"},"application/vnd.frogans.fnc":{"source":"apache","extensions":["fnc"]},"application/vnd.frogans.ltf":{"source":"apache","extensions":["ltf"]},"application/vnd.fsc.weblaunch":{"source":"iana","extensions":["fsc"]},"application/vnd.fujifilm.fb.docuworks":{"source":"iana"},"application/vnd.fujifilm.fb.docuworks.binder":{"source":"iana"},"application/vnd.fujifilm.fb.docuworks.container":{"source":"iana"},"application/vnd.fujifilm.fb.jfi+xml":{"source":"iana","compressible":true},"application/vnd.fujitsu.oasys":{"source":"iana","extensions":["oas"]},"application/vnd.fujitsu.oasys2":{"source":"iana","extensions":["oa2"]},"application/vnd.fujitsu.oasys3":{"source":"iana","extensions":["oa3"]},"application/vnd.fujitsu.oasysgp":{"source":"iana","extensions":["fg5"]},"application/vnd.fujitsu.oasysprs":{"source":"iana","extensions":["bh2"]},"application/vnd.fujixerox.art-ex":{"source":"iana"},"application/vnd.fujixerox.art4":{"source":"iana"},"application/vnd.fujixerox.ddd":{"source":"iana","extensions":["ddd"]},"application/vnd.fujixerox.docuworks":{"source":"iana","extensions":["xdw"]},"application/vnd.fujixerox.docuworks.binder":{"source":"iana","extensions":["xbd"]},"application/vnd.fujixerox.docuworks.container":{"source":"iana"},"application/vnd.fujixerox.hbpl":{"source":"iana"},"application/vnd.fut-misnet":{"source":"iana"},"application/vnd.futoin+cbor":{"source":"iana"},"application/vnd.futoin+json":{"source":"iana","compressible":true},"application/vnd.fuzzysheet":{"source":"iana","extensions":["fzs"]},"application/vnd.ga4gh.passport+jwt":{"source":"iana"},"application/vnd.genomatix.tuxedo":{"source":"iana","extensions":["txd"]},"application/vnd.genozip":{"source":"iana"},"application/vnd.gentics.grd+json":{"source":"iana","compressible":true},"application/vnd.gentoo.catmetadata+xml":{"source":"iana","compressible":true},"application/vnd.gentoo.ebuild":{"source":"iana"},"application/vnd.gentoo.eclass":{"source":"iana"},"application/vnd.gentoo.gpkg":{"source":"iana"},"application/vnd.gentoo.manifest":{"source":"iana"},"application/vnd.gentoo.pkgmetadata+xml":{"source":"iana","compressible":true},"application/vnd.gentoo.xpak":{"source":"iana"},"application/vnd.geo+json":{"source":"apache","compressible":true},"application/vnd.geocube+xml":{"source":"apache","compressible":true},"application/vnd.geogebra.file":{"source":"iana","extensions":["ggb"]},"application/vnd.geogebra.pinboard":{"source":"iana"},"application/vnd.geogebra.slides":{"source":"iana","extensions":["ggs"]},"application/vnd.geogebra.tool":{"source":"iana","extensions":["ggt"]},"application/vnd.geometry-explorer":{"source":"iana","extensions":["gex","gre"]},"application/vnd.geonext":{"source":"iana","extensions":["gxt"]},"application/vnd.geoplan":{"source":"iana","extensions":["g2w"]},"application/vnd.geospace":{"source":"iana","extensions":["g3w"]},"application/vnd.gerber":{"source":"iana"},"application/vnd.globalplatform.card-content-mgt":{"source":"iana"},"application/vnd.globalplatform.card-content-mgt-response":{"source":"iana"},"application/vnd.gmx":{"source":"iana","extensions":["gmx"]},"application/vnd.gnu.taler.exchange+json":{"source":"iana","compressible":true},"application/vnd.gnu.taler.merchant+json":{"source":"iana","compressible":true},"application/vnd.google-apps.audio":{},"application/vnd.google-apps.document":{"compressible":false,"extensions":["gdoc"]},"application/vnd.google-apps.drawing":{"compressible":false,"extensions":["gdraw"]},"application/vnd.google-apps.drive-sdk":{"compressible":false},"application/vnd.google-apps.file":{},"application/vnd.google-apps.folder":{"compressible":false},"application/vnd.google-apps.form":{"compressible":false,"extensions":["gform"]},"application/vnd.google-apps.fusiontable":{},"application/vnd.google-apps.jam":{"compressible":false,"extensions":["gjam"]},"application/vnd.google-apps.mail-layout":{},"application/vnd.google-apps.map":{"compressible":false,"extensions":["gmap"]},"application/vnd.google-apps.photo":{},"application/vnd.google-apps.presentation":{"compressible":false,"extensions":["gslides"]},"application/vnd.google-apps.script":{"compressible":false,"extensions":["gscript"]},"application/vnd.google-apps.shortcut":{},"application/vnd.google-apps.site":{"compressible":false,"extensions":["gsite"]},"application/vnd.google-apps.spreadsheet":{"compressible":false,"extensions":["gsheet"]},"application/vnd.google-apps.unknown":{},"application/vnd.google-apps.video":{},"application/vnd.google-earth.kml+xml":{"source":"iana","compressible":true,"extensions":["kml"]},"application/vnd.google-earth.kmz":{"source":"iana","compressible":false,"extensions":["kmz"]},"application/vnd.gov.sk.e-form+xml":{"source":"apache","compressible":true},"application/vnd.gov.sk.e-form+zip":{"source":"iana","compressible":false},"application/vnd.gov.sk.xmldatacontainer+xml":{"source":"iana","compressible":true,"extensions":["xdcf"]},"application/vnd.gpxsee.map+xml":{"source":"iana","compressible":true},"application/vnd.grafeq":{"source":"iana","extensions":["gqf","gqs"]},"application/vnd.gridmp":{"source":"iana"},"application/vnd.groove-account":{"source":"iana","extensions":["gac"]},"application/vnd.groove-help":{"source":"iana","extensions":["ghf"]},"application/vnd.groove-identity-message":{"source":"iana","extensions":["gim"]},"application/vnd.groove-injector":{"source":"iana","extensions":["grv"]},"application/vnd.groove-tool-message":{"source":"iana","extensions":["gtm"]},"application/vnd.groove-tool-template":{"source":"iana","extensions":["tpl"]},"application/vnd.groove-vcard":{"source":"iana","extensions":["vcg"]},"application/vnd.hal+json":{"source":"iana","compressible":true},"application/vnd.hal+xml":{"source":"iana","compressible":true,"extensions":["hal"]},"application/vnd.handheld-entertainment+xml":{"source":"iana","compressible":true,"extensions":["zmm"]},"application/vnd.hbci":{"source":"iana","extensions":["hbci"]},"application/vnd.hc+json":{"source":"iana","compressible":true},"application/vnd.hcl-bireports":{"source":"iana"},"application/vnd.hdt":{"source":"iana"},"application/vnd.heroku+json":{"source":"iana","compressible":true},"application/vnd.hhe.lesson-player":{"source":"iana","extensions":["les"]},"application/vnd.hp-hpgl":{"source":"iana","extensions":["hpgl"]},"application/vnd.hp-hpid":{"source":"iana","extensions":["hpid"]},"application/vnd.hp-hps":{"source":"iana","extensions":["hps"]},"application/vnd.hp-jlyt":{"source":"iana","extensions":["jlt"]},"application/vnd.hp-pcl":{"source":"iana","extensions":["pcl"]},"application/vnd.hp-pclxl":{"source":"iana","extensions":["pclxl"]},"application/vnd.hsl":{"source":"iana"},"application/vnd.httphone":{"source":"iana"},"application/vnd.hydrostatix.sof-data":{"source":"iana","extensions":["sfd-hdstx"]},"application/vnd.hyper+json":{"source":"iana","compressible":true},"application/vnd.hyper-item+json":{"source":"iana","compressible":true},"application/vnd.hyperdrive+json":{"source":"iana","compressible":true},"application/vnd.hzn-3d-crossword":{"source":"iana"},"application/vnd.ibm.afplinedata":{"source":"apache"},"application/vnd.ibm.electronic-media":{"source":"iana"},"application/vnd.ibm.minipay":{"source":"iana","extensions":["mpy"]},"application/vnd.ibm.modcap":{"source":"apache","extensions":["afp","listafp","list3820"]},"application/vnd.ibm.rights-management":{"source":"iana","extensions":["irm"]},"application/vnd.ibm.secure-container":{"source":"iana","extensions":["sc"]},"application/vnd.iccprofile":{"source":"iana","extensions":["icc","icm"]},"application/vnd.ieee.1905":{"source":"iana"},"application/vnd.igloader":{"source":"iana","extensions":["igl"]},"application/vnd.imagemeter.folder+zip":{"source":"iana","compressible":false},"application/vnd.imagemeter.image+zip":{"source":"iana","compressible":false},"application/vnd.immervision-ivp":{"source":"iana","extensions":["ivp"]},"application/vnd.immervision-ivu":{"source":"iana","extensions":["ivu"]},"application/vnd.ims.imsccv1p1":{"source":"iana"},"application/vnd.ims.imsccv1p2":{"source":"iana"},"application/vnd.ims.imsccv1p3":{"source":"iana"},"application/vnd.ims.lis.v2.result+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolconsumerprofile+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolproxy+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolproxy.id+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolsettings+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolsettings.simple+json":{"source":"iana","compressible":true},"application/vnd.informedcontrol.rms+xml":{"source":"iana","compressible":true},"application/vnd.informix-visionary":{"source":"apache"},"application/vnd.infotech.project":{"source":"iana"},"application/vnd.infotech.project+xml":{"source":"iana","compressible":true},"application/vnd.innopath.wamp.notification":{"source":"iana"},"application/vnd.insors.igm":{"source":"iana","extensions":["igm"]},"application/vnd.intercon.formnet":{"source":"iana","extensions":["xpw","xpx"]},"application/vnd.intergeo":{"source":"iana","extensions":["i2g"]},"application/vnd.intertrust.digibox":{"source":"iana"},"application/vnd.intertrust.nncp":{"source":"iana"},"application/vnd.intu.qbo":{"source":"iana","extensions":["qbo"]},"application/vnd.intu.qfx":{"source":"iana","extensions":["qfx"]},"application/vnd.ipfs.ipns-record":{"source":"iana"},"application/vnd.ipld.car":{"source":"iana"},"application/vnd.ipld.dag-cbor":{"source":"iana"},"application/vnd.ipld.dag-json":{"source":"iana"},"application/vnd.ipld.raw":{"source":"iana"},"application/vnd.iptc.g2.catalogitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.conceptitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.knowledgeitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.newsitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.newsmessage+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.packageitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.planningitem+xml":{"source":"iana","compressible":true},"application/vnd.ipunplugged.rcprofile":{"source":"iana","extensions":["rcprofile"]},"application/vnd.irepository.package+xml":{"source":"iana","compressible":true,"extensions":["irp"]},"application/vnd.is-xpr":{"source":"iana","extensions":["xpr"]},"application/vnd.isac.fcs":{"source":"iana","extensions":["fcs"]},"application/vnd.iso11783-10+zip":{"source":"iana","compressible":false},"application/vnd.jam":{"source":"iana","extensions":["jam"]},"application/vnd.japannet-directory-service":{"source":"iana"},"application/vnd.japannet-jpnstore-wakeup":{"source":"iana"},"application/vnd.japannet-payment-wakeup":{"source":"iana"},"application/vnd.japannet-registration":{"source":"iana"},"application/vnd.japannet-registration-wakeup":{"source":"iana"},"application/vnd.japannet-setstore-wakeup":{"source":"iana"},"application/vnd.japannet-verification":{"source":"iana"},"application/vnd.japannet-verification-wakeup":{"source":"iana"},"application/vnd.jcp.javame.midlet-rms":{"source":"iana","extensions":["rms"]},"application/vnd.jisp":{"source":"iana","extensions":["jisp"]},"application/vnd.joost.joda-archive":{"source":"iana","extensions":["joda"]},"application/vnd.jsk.isdn-ngn":{"source":"iana"},"application/vnd.kahootz":{"source":"iana","extensions":["ktz","ktr"]},"application/vnd.kde.karbon":{"source":"iana","extensions":["karbon"]},"application/vnd.kde.kchart":{"source":"iana","extensions":["chrt"]},"application/vnd.kde.kformula":{"source":"iana","extensions":["kfo"]},"application/vnd.kde.kivio":{"source":"iana","extensions":["flw"]},"application/vnd.kde.kontour":{"source":"iana","extensions":["kon"]},"application/vnd.kde.kpresenter":{"source":"iana","extensions":["kpr","kpt"]},"application/vnd.kde.kspread":{"source":"iana","extensions":["ksp"]},"application/vnd.kde.kword":{"source":"iana","extensions":["kwd","kwt"]},"application/vnd.kdl":{"source":"iana"},"application/vnd.kenameaapp":{"source":"iana","extensions":["htke"]},"application/vnd.keyman.kmp+zip":{"source":"iana","compressible":false},"application/vnd.keyman.kmx":{"source":"iana"},"application/vnd.kidspiration":{"source":"iana","extensions":["kia"]},"application/vnd.kinar":{"source":"iana","extensions":["kne","knp"]},"application/vnd.koan":{"source":"iana","extensions":["skp","skd","skt","skm"]},"application/vnd.kodak-descriptor":{"source":"iana","extensions":["sse"]},"application/vnd.las":{"source":"iana"},"application/vnd.las.las+json":{"source":"iana","compressible":true},"application/vnd.las.las+xml":{"source":"iana","compressible":true,"extensions":["lasxml"]},"application/vnd.laszip":{"source":"iana"},"application/vnd.ldev.productlicensing":{"source":"iana"},"application/vnd.leap+json":{"source":"iana","compressible":true},"application/vnd.liberty-request+xml":{"source":"iana","compressible":true},"application/vnd.llamagraphics.life-balance.desktop":{"source":"iana","extensions":["lbd"]},"application/vnd.llamagraphics.life-balance.exchange+xml":{"source":"iana","compressible":true,"extensions":["lbe"]},"application/vnd.logipipe.circuit+zip":{"source":"iana","compressible":false},"application/vnd.loom":{"source":"iana"},"application/vnd.lotus-1-2-3":{"source":"iana","extensions":["123"]},"application/vnd.lotus-approach":{"source":"iana","extensions":["apr"]},"application/vnd.lotus-freelance":{"source":"iana","extensions":["pre"]},"application/vnd.lotus-notes":{"source":"iana","extensions":["nsf"]},"application/vnd.lotus-organizer":{"source":"iana","extensions":["org"]},"application/vnd.lotus-screencam":{"source":"iana","extensions":["scm"]},"application/vnd.lotus-wordpro":{"source":"iana","extensions":["lwp"]},"application/vnd.macports.portpkg":{"source":"iana","extensions":["portpkg"]},"application/vnd.mapbox-vector-tile":{"source":"iana","extensions":["mvt"]},"application/vnd.marlin.drm.actiontoken+xml":{"source":"iana","compressible":true},"application/vnd.marlin.drm.conftoken+xml":{"source":"iana","compressible":true},"application/vnd.marlin.drm.license+xml":{"source":"iana","compressible":true},"application/vnd.marlin.drm.mdcf":{"source":"iana"},"application/vnd.mason+json":{"source":"iana","compressible":true},"application/vnd.maxar.archive.3tz+zip":{"source":"iana","compressible":false},"application/vnd.maxmind.maxmind-db":{"source":"iana"},"application/vnd.mcd":{"source":"iana","extensions":["mcd"]},"application/vnd.mdl":{"source":"iana"},"application/vnd.mdl-mbsdf":{"source":"iana"},"application/vnd.medcalcdata":{"source":"iana","extensions":["mc1"]},"application/vnd.mediastation.cdkey":{"source":"iana","extensions":["cdkey"]},"application/vnd.medicalholodeck.recordxr":{"source":"iana"},"application/vnd.meridian-slingshot":{"source":"iana"},"application/vnd.mermaid":{"source":"iana"},"application/vnd.mfer":{"source":"iana","extensions":["mwf"]},"application/vnd.mfmp":{"source":"iana","extensions":["mfm"]},"application/vnd.micro+json":{"source":"iana","compressible":true},"application/vnd.micrografx.flo":{"source":"iana","extensions":["flo"]},"application/vnd.micrografx.igx":{"source":"iana","extensions":["igx"]},"application/vnd.microsoft.portable-executable":{"source":"iana"},"application/vnd.microsoft.windows.thumbnail-cache":{"source":"iana"},"application/vnd.miele+json":{"source":"iana","compressible":true},"application/vnd.mif":{"source":"iana","extensions":["mif"]},"application/vnd.minisoft-hp3000-save":{"source":"iana"},"application/vnd.mitsubishi.misty-guard.trustweb":{"source":"iana"},"application/vnd.mobius.daf":{"source":"iana","extensions":["daf"]},"application/vnd.mobius.dis":{"source":"iana","extensions":["dis"]},"application/vnd.mobius.mbk":{"source":"iana","extensions":["mbk"]},"application/vnd.mobius.mqy":{"source":"iana","extensions":["mqy"]},"application/vnd.mobius.msl":{"source":"iana","extensions":["msl"]},"application/vnd.mobius.plc":{"source":"iana","extensions":["plc"]},"application/vnd.mobius.txf":{"source":"iana","extensions":["txf"]},"application/vnd.modl":{"source":"iana"},"application/vnd.mophun.application":{"source":"iana","extensions":["mpn"]},"application/vnd.mophun.certificate":{"source":"iana","extensions":["mpc"]},"application/vnd.motorola.flexsuite":{"source":"iana"},"application/vnd.motorola.flexsuite.adsi":{"source":"iana"},"application/vnd.motorola.flexsuite.fis":{"source":"iana"},"application/vnd.motorola.flexsuite.gotap":{"source":"iana"},"application/vnd.motorola.flexsuite.kmr":{"source":"iana"},"application/vnd.motorola.flexsuite.ttc":{"source":"iana"},"application/vnd.motorola.flexsuite.wem":{"source":"iana"},"application/vnd.motorola.iprm":{"source":"iana"},"application/vnd.mozilla.xul+xml":{"source":"iana","compressible":true,"extensions":["xul"]},"application/vnd.ms-3mfdocument":{"source":"iana"},"application/vnd.ms-artgalry":{"source":"iana","extensions":["cil"]},"application/vnd.ms-asf":{"source":"iana"},"application/vnd.ms-cab-compressed":{"source":"iana","extensions":["cab"]},"application/vnd.ms-color.iccprofile":{"source":"apache"},"application/vnd.ms-excel":{"source":"iana","compressible":false,"extensions":["xls","xlm","xla","xlc","xlt","xlw"]},"application/vnd.ms-excel.addin.macroenabled.12":{"source":"iana","extensions":["xlam"]},"application/vnd.ms-excel.sheet.binary.macroenabled.12":{"source":"iana","extensions":["xlsb"]},"application/vnd.ms-excel.sheet.macroenabled.12":{"source":"iana","extensions":["xlsm"]},"application/vnd.ms-excel.template.macroenabled.12":{"source":"iana","extensions":["xltm"]},"application/vnd.ms-fontobject":{"source":"iana","compressible":true,"extensions":["eot"]},"application/vnd.ms-htmlhelp":{"source":"iana","extensions":["chm"]},"application/vnd.ms-ims":{"source":"iana","extensions":["ims"]},"application/vnd.ms-lrm":{"source":"iana","extensions":["lrm"]},"application/vnd.ms-office.activex+xml":{"source":"iana","compressible":true},"application/vnd.ms-officetheme":{"source":"iana","extensions":["thmx"]},"application/vnd.ms-opentype":{"source":"apache","compressible":true},"application/vnd.ms-outlook":{"compressible":false,"extensions":["msg"]},"application/vnd.ms-package.obfuscated-opentype":{"source":"apache"},"application/vnd.ms-pki.seccat":{"source":"apache","extensions":["cat"]},"application/vnd.ms-pki.stl":{"source":"apache","extensions":["stl"]},"application/vnd.ms-playready.initiator+xml":{"source":"iana","compressible":true},"application/vnd.ms-powerpoint":{"source":"iana","compressible":false,"extensions":["ppt","pps","pot"]},"application/vnd.ms-powerpoint.addin.macroenabled.12":{"source":"iana","extensions":["ppam"]},"application/vnd.ms-powerpoint.presentation.macroenabled.12":{"source":"iana","extensions":["pptm"]},"application/vnd.ms-powerpoint.slide.macroenabled.12":{"source":"iana","extensions":["sldm"]},"application/vnd.ms-powerpoint.slideshow.macroenabled.12":{"source":"iana","extensions":["ppsm"]},"application/vnd.ms-powerpoint.template.macroenabled.12":{"source":"iana","extensions":["potm"]},"application/vnd.ms-printdevicecapabilities+xml":{"source":"iana","compressible":true},"application/vnd.ms-printing.printticket+xml":{"source":"apache","compressible":true},"application/vnd.ms-printschematicket+xml":{"source":"iana","compressible":true},"application/vnd.ms-project":{"source":"iana","extensions":["mpp","mpt"]},"application/vnd.ms-tnef":{"source":"iana"},"application/vnd.ms-visio.viewer":{"extensions":["vdx"]},"application/vnd.ms-windows.devicepairing":{"source":"iana"},"application/vnd.ms-windows.nwprinting.oob":{"source":"iana"},"application/vnd.ms-windows.printerpairing":{"source":"iana"},"application/vnd.ms-windows.wsd.oob":{"source":"iana"},"application/vnd.ms-wmdrm.lic-chlg-req":{"source":"iana"},"application/vnd.ms-wmdrm.lic-resp":{"source":"iana"},"application/vnd.ms-wmdrm.meter-chlg-req":{"source":"iana"},"application/vnd.ms-wmdrm.meter-resp":{"source":"iana"},"application/vnd.ms-word.document.macroenabled.12":{"source":"iana","extensions":["docm"]},"application/vnd.ms-word.template.macroenabled.12":{"source":"iana","extensions":["dotm"]},"application/vnd.ms-works":{"source":"iana","extensions":["wps","wks","wcm","wdb"]},"application/vnd.ms-wpl":{"source":"iana","extensions":["wpl"]},"application/vnd.ms-xpsdocument":{"source":"iana","compressible":false,"extensions":["xps"]},"application/vnd.msa-disk-image":{"source":"iana"},"application/vnd.mseq":{"source":"iana","extensions":["mseq"]},"application/vnd.msgpack":{"source":"iana"},"application/vnd.msign":{"source":"iana"},"application/vnd.multiad.creator":{"source":"iana"},"application/vnd.multiad.creator.cif":{"source":"iana"},"application/vnd.music-niff":{"source":"iana"},"application/vnd.musician":{"source":"iana","extensions":["mus"]},"application/vnd.muvee.style":{"source":"iana","extensions":["msty"]},"application/vnd.mynfc":{"source":"iana","extensions":["taglet"]},"application/vnd.nacamar.ybrid+json":{"source":"iana","compressible":true},"application/vnd.nato.bindingdataobject+cbor":{"source":"iana"},"application/vnd.nato.bindingdataobject+json":{"source":"iana","compressible":true},"application/vnd.nato.bindingdataobject+xml":{"source":"iana","compressible":true,"extensions":["bdo"]},"application/vnd.nato.openxmlformats-package.iepd+zip":{"source":"iana","compressible":false},"application/vnd.ncd.control":{"source":"iana"},"application/vnd.ncd.reference":{"source":"iana"},"application/vnd.nearst.inv+json":{"source":"iana","compressible":true},"application/vnd.nebumind.line":{"source":"iana"},"application/vnd.nervana":{"source":"iana"},"application/vnd.netfpx":{"source":"iana"},"application/vnd.neurolanguage.nlu":{"source":"iana","extensions":["nlu"]},"application/vnd.nimn":{"source":"iana"},"application/vnd.nintendo.nitro.rom":{"source":"iana"},"application/vnd.nintendo.snes.rom":{"source":"iana"},"application/vnd.nitf":{"source":"iana","extensions":["ntf","nitf"]},"application/vnd.noblenet-directory":{"source":"iana","extensions":["nnd"]},"application/vnd.noblenet-sealer":{"source":"iana","extensions":["nns"]},"application/vnd.noblenet-web":{"source":"iana","extensions":["nnw"]},"application/vnd.nokia.catalogs":{"source":"iana"},"application/vnd.nokia.conml+wbxml":{"source":"iana"},"application/vnd.nokia.conml+xml":{"source":"iana","compressible":true},"application/vnd.nokia.iptv.config+xml":{"source":"iana","compressible":true},"application/vnd.nokia.isds-radio-presets":{"source":"iana"},"application/vnd.nokia.landmark+wbxml":{"source":"iana"},"application/vnd.nokia.landmark+xml":{"source":"iana","compressible":true},"application/vnd.nokia.landmarkcollection+xml":{"source":"iana","compressible":true},"application/vnd.nokia.n-gage.ac+xml":{"source":"iana","compressible":true,"extensions":["ac"]},"application/vnd.nokia.n-gage.data":{"source":"iana","extensions":["ngdat"]},"application/vnd.nokia.n-gage.symbian.install":{"source":"apache","extensions":["n-gage"]},"application/vnd.nokia.ncd":{"source":"iana"},"application/vnd.nokia.pcd+wbxml":{"source":"iana"},"application/vnd.nokia.pcd+xml":{"source":"iana","compressible":true},"application/vnd.nokia.radio-preset":{"source":"iana","extensions":["rpst"]},"application/vnd.nokia.radio-presets":{"source":"iana","extensions":["rpss"]},"application/vnd.novadigm.edm":{"source":"iana","extensions":["edm"]},"application/vnd.novadigm.edx":{"source":"iana","extensions":["edx"]},"application/vnd.novadigm.ext":{"source":"iana","extensions":["ext"]},"application/vnd.ntt-local.content-share":{"source":"iana"},"application/vnd.ntt-local.file-transfer":{"source":"iana"},"application/vnd.ntt-local.ogw_remote-access":{"source":"iana"},"application/vnd.ntt-local.sip-ta_remote":{"source":"iana"},"application/vnd.ntt-local.sip-ta_tcp_stream":{"source":"iana"},"application/vnd.oai.workflows":{"source":"iana"},"application/vnd.oai.workflows+json":{"source":"iana","compressible":true},"application/vnd.oai.workflows+yaml":{"source":"iana"},"application/vnd.oasis.opendocument.base":{"source":"iana"},"application/vnd.oasis.opendocument.chart":{"source":"iana","extensions":["odc"]},"application/vnd.oasis.opendocument.chart-template":{"source":"iana","extensions":["otc"]},"application/vnd.oasis.opendocument.database":{"source":"apache","extensions":["odb"]},"application/vnd.oasis.opendocument.formula":{"source":"iana","extensions":["odf"]},"application/vnd.oasis.opendocument.formula-template":{"source":"iana","extensions":["odft"]},"application/vnd.oasis.opendocument.graphics":{"source":"iana","compressible":false,"extensions":["odg"]},"application/vnd.oasis.opendocument.graphics-template":{"source":"iana","extensions":["otg"]},"application/vnd.oasis.opendocument.image":{"source":"iana","extensions":["odi"]},"application/vnd.oasis.opendocument.image-template":{"source":"iana","extensions":["oti"]},"application/vnd.oasis.opendocument.presentation":{"source":"iana","compressible":false,"extensions":["odp"]},"application/vnd.oasis.opendocument.presentation-template":{"source":"iana","extensions":["otp"]},"application/vnd.oasis.opendocument.spreadsheet":{"source":"iana","compressible":false,"extensions":["ods"]},"application/vnd.oasis.opendocument.spreadsheet-template":{"source":"iana","extensions":["ots"]},"application/vnd.oasis.opendocument.text":{"source":"iana","compressible":false,"extensions":["odt"]},"application/vnd.oasis.opendocument.text-master":{"source":"iana","extensions":["odm"]},"application/vnd.oasis.opendocument.text-master-template":{"source":"iana"},"application/vnd.oasis.opendocument.text-template":{"source":"iana","extensions":["ott"]},"application/vnd.oasis.opendocument.text-web":{"source":"iana","extensions":["oth"]},"application/vnd.obn":{"source":"iana"},"application/vnd.ocf+cbor":{"source":"iana"},"application/vnd.oci.image.manifest.v1+json":{"source":"iana","compressible":true},"application/vnd.oftn.l10n+json":{"source":"iana","compressible":true},"application/vnd.oipf.contentaccessdownload+xml":{"source":"iana","compressible":true},"application/vnd.oipf.contentaccessstreaming+xml":{"source":"iana","compressible":true},"application/vnd.oipf.cspg-hexbinary":{"source":"iana"},"application/vnd.oipf.dae.svg+xml":{"source":"iana","compressible":true},"application/vnd.oipf.dae.xhtml+xml":{"source":"iana","compressible":true},"application/vnd.oipf.mippvcontrolmessage+xml":{"source":"iana","compressible":true},"application/vnd.oipf.pae.gem":{"source":"iana"},"application/vnd.oipf.spdiscovery+xml":{"source":"iana","compressible":true},"application/vnd.oipf.spdlist+xml":{"source":"iana","compressible":true},"application/vnd.oipf.ueprofile+xml":{"source":"iana","compressible":true},"application/vnd.oipf.userprofile+xml":{"source":"iana","compressible":true},"application/vnd.olpc-sugar":{"source":"iana","extensions":["xo"]},"application/vnd.oma-scws-config":{"source":"iana"},"application/vnd.oma-scws-http-request":{"source":"iana"},"application/vnd.oma-scws-http-response":{"source":"iana"},"application/vnd.oma.bcast.associated-procedure-parameter+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.drm-trigger+xml":{"source":"apache","compressible":true},"application/vnd.oma.bcast.imd+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.ltkm":{"source":"iana"},"application/vnd.oma.bcast.notification+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.provisioningtrigger":{"source":"iana"},"application/vnd.oma.bcast.sgboot":{"source":"iana"},"application/vnd.oma.bcast.sgdd+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.sgdu":{"source":"iana"},"application/vnd.oma.bcast.simple-symbol-container":{"source":"iana"},"application/vnd.oma.bcast.smartcard-trigger+xml":{"source":"apache","compressible":true},"application/vnd.oma.bcast.sprov+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.stkm":{"source":"iana"},"application/vnd.oma.cab-address-book+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-feature-handler+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-pcc+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-subs-invite+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-user-prefs+xml":{"source":"iana","compressible":true},"application/vnd.oma.dcd":{"source":"iana"},"application/vnd.oma.dcdc":{"source":"iana"},"application/vnd.oma.dd2+xml":{"source":"iana","compressible":true,"extensions":["dd2"]},"application/vnd.oma.drm.risd+xml":{"source":"iana","compressible":true},"application/vnd.oma.group-usage-list+xml":{"source":"iana","compressible":true},"application/vnd.oma.lwm2m+cbor":{"source":"iana"},"application/vnd.oma.lwm2m+json":{"source":"iana","compressible":true},"application/vnd.oma.lwm2m+tlv":{"source":"iana"},"application/vnd.oma.pal+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.detailed-progress-report+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.final-report+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.groups+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.invocation-descriptor+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.optimized-progress-report+xml":{"source":"iana","compressible":true},"application/vnd.oma.push":{"source":"iana"},"application/vnd.oma.scidm.messages+xml":{"source":"iana","compressible":true},"application/vnd.oma.xcap-directory+xml":{"source":"iana","compressible":true},"application/vnd.omads-email+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.omads-file+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.omads-folder+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.omaloc-supl-init":{"source":"iana"},"application/vnd.onepager":{"source":"iana"},"application/vnd.onepagertamp":{"source":"iana"},"application/vnd.onepagertamx":{"source":"iana"},"application/vnd.onepagertat":{"source":"iana"},"application/vnd.onepagertatp":{"source":"iana"},"application/vnd.onepagertatx":{"source":"iana"},"application/vnd.onvif.metadata":{"source":"iana"},"application/vnd.openblox.game+xml":{"source":"iana","compressible":true,"extensions":["obgx"]},"application/vnd.openblox.game-binary":{"source":"iana"},"application/vnd.openeye.oeb":{"source":"iana"},"application/vnd.openofficeorg.extension":{"source":"apache","extensions":["oxt"]},"application/vnd.openstreetmap.data+xml":{"source":"iana","compressible":true,"extensions":["osm"]},"application/vnd.opentimestamps.ots":{"source":"iana"},"application/vnd.openvpi.dspx+json":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.custom-properties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.customxmlproperties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawing+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.chart+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramcolors+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramdata+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramlayout+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramstyle+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.extended-properties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.commentauthors+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.comments+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.handoutmaster+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.notesmaster+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.notesslide+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.presentation":{"source":"iana","compressible":false,"extensions":["pptx"]},"application/vnd.openxmlformats-officedocument.presentationml.presentation.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.presprops+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slide":{"source":"iana","extensions":["sldx"]},"application/vnd.openxmlformats-officedocument.presentationml.slide+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slidelayout+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slidemaster+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slideshow":{"source":"iana","extensions":["ppsx"]},"application/vnd.openxmlformats-officedocument.presentationml.slideshow.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slideupdateinfo+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.tablestyles+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.tags+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.template":{"source":"iana","extensions":["potx"]},"application/vnd.openxmlformats-officedocument.presentationml.template.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.viewprops+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.calcchain+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.externallink+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcachedefinition+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcacherecords+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.pivottable+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.querytable+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionheaders+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionlog+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.sharedstrings+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":{"source":"iana","compressible":false,"extensions":["xlsx"]},"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.sheetmetadata+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.tablesinglecells+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.template":{"source":"iana","extensions":["xltx"]},"application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.usernames+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.volatiledependencies+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.theme+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.themeoverride+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.vmldrawing":{"source":"iana"},"application/vnd.openxmlformats-officedocument.wordprocessingml.comments+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.document":{"source":"iana","compressible":false,"extensions":["docx"]},"application/vnd.openxmlformats-officedocument.wordprocessingml.document.glossary+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.document.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.endnotes+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.fonttable+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.footer+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.footnotes+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.numbering+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.settings+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.styles+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.template":{"source":"iana","extensions":["dotx"]},"application/vnd.openxmlformats-officedocument.wordprocessingml.template.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.websettings+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-package.core-properties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-package.digital-signature-xmlsignature+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-package.relationships+xml":{"source":"iana","compressible":true},"application/vnd.oracle.resource+json":{"source":"iana","compressible":true},"application/vnd.orange.indata":{"source":"iana"},"application/vnd.osa.netdeploy":{"source":"iana"},"application/vnd.osgeo.mapguide.package":{"source":"iana","extensions":["mgp"]},"application/vnd.osgi.bundle":{"source":"iana"},"application/vnd.osgi.dp":{"source":"iana","extensions":["dp"]},"application/vnd.osgi.subsystem":{"source":"iana","extensions":["esa"]},"application/vnd.otps.ct-kip+xml":{"source":"iana","compressible":true},"application/vnd.oxli.countgraph":{"source":"iana"},"application/vnd.pagerduty+json":{"source":"iana","compressible":true},"application/vnd.palm":{"source":"iana","extensions":["pdb","pqa","oprc"]},"application/vnd.panoply":{"source":"iana"},"application/vnd.paos.xml":{"source":"iana"},"application/vnd.patentdive":{"source":"iana"},"application/vnd.patientecommsdoc":{"source":"iana"},"application/vnd.pawaafile":{"source":"iana","extensions":["paw"]},"application/vnd.pcos":{"source":"iana"},"application/vnd.pg.format":{"source":"iana","extensions":["str"]},"application/vnd.pg.osasli":{"source":"iana","extensions":["ei6"]},"application/vnd.piaccess.application-licence":{"source":"iana"},"application/vnd.picsel":{"source":"iana","extensions":["efif"]},"application/vnd.pmi.widget":{"source":"iana","extensions":["wg"]},"application/vnd.poc.group-advertisement+xml":{"source":"iana","compressible":true},"application/vnd.pocketlearn":{"source":"iana","extensions":["plf"]},"application/vnd.powerbuilder6":{"source":"iana","extensions":["pbd"]},"application/vnd.powerbuilder6-s":{"source":"iana"},"application/vnd.powerbuilder7":{"source":"iana"},"application/vnd.powerbuilder7-s":{"source":"iana"},"application/vnd.powerbuilder75":{"source":"iana"},"application/vnd.powerbuilder75-s":{"source":"iana"},"application/vnd.preminet":{"source":"iana"},"application/vnd.previewsystems.box":{"source":"iana","extensions":["box"]},"application/vnd.procrate.brushset":{"extensions":["brushset"]},"application/vnd.procreate.brush":{"extensions":["brush"]},"application/vnd.procreate.dream":{"extensions":["drm"]},"application/vnd.proteus.magazine":{"source":"iana","extensions":["mgz"]},"application/vnd.psfs":{"source":"iana"},"application/vnd.pt.mundusmundi":{"source":"iana"},"application/vnd.publishare-delta-tree":{"source":"iana","extensions":["qps"]},"application/vnd.pvi.ptid1":{"source":"iana","extensions":["ptid"]},"application/vnd.pwg-multiplexed":{"source":"iana"},"application/vnd.pwg-xhtml-print+xml":{"source":"iana","compressible":true,"extensions":["xhtm"]},"application/vnd.qualcomm.brew-app-res":{"source":"iana"},"application/vnd.quarantainenet":{"source":"iana"},"application/vnd.quark.quarkxpress":{"source":"iana","extensions":["qxd","qxt","qwd","qwt","qxl","qxb"]},"application/vnd.quobject-quoxdocument":{"source":"iana"},"application/vnd.radisys.moml+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-conf+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-conn+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-dialog+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-stream+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-conf+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-base+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-fax-detect+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-fax-sendrecv+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-group+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-speech+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-transform+xml":{"source":"iana","compressible":true},"application/vnd.rainstor.data":{"source":"iana"},"application/vnd.rapid":{"source":"iana"},"application/vnd.rar":{"source":"iana","extensions":["rar"]},"application/vnd.realvnc.bed":{"source":"iana","extensions":["bed"]},"application/vnd.recordare.musicxml":{"source":"iana","extensions":["mxl"]},"application/vnd.recordare.musicxml+xml":{"source":"iana","compressible":true,"extensions":["musicxml"]},"application/vnd.relpipe":{"source":"iana"},"application/vnd.renlearn.rlprint":{"source":"iana"},"application/vnd.resilient.logic":{"source":"iana"},"application/vnd.restful+json":{"source":"iana","compressible":true},"application/vnd.rig.cryptonote":{"source":"iana","extensions":["cryptonote"]},"application/vnd.rim.cod":{"source":"apache","extensions":["cod"]},"application/vnd.rn-realmedia":{"source":"apache","extensions":["rm"]},"application/vnd.rn-realmedia-vbr":{"source":"apache","extensions":["rmvb"]},"application/vnd.route66.link66+xml":{"source":"iana","compressible":true,"extensions":["link66"]},"application/vnd.rs-274x":{"source":"iana"},"application/vnd.ruckus.download":{"source":"iana"},"application/vnd.s3sms":{"source":"iana"},"application/vnd.sailingtracker.track":{"source":"iana","extensions":["st"]},"application/vnd.sar":{"source":"iana"},"application/vnd.sbm.cid":{"source":"iana"},"application/vnd.sbm.mid2":{"source":"iana"},"application/vnd.scribus":{"source":"iana"},"application/vnd.sealed.3df":{"source":"iana"},"application/vnd.sealed.csf":{"source":"iana"},"application/vnd.sealed.doc":{"source":"iana"},"application/vnd.sealed.eml":{"source":"iana"},"application/vnd.sealed.mht":{"source":"iana"},"application/vnd.sealed.net":{"source":"iana"},"application/vnd.sealed.ppt":{"source":"iana"},"application/vnd.sealed.tiff":{"source":"iana"},"application/vnd.sealed.xls":{"source":"iana"},"application/vnd.sealedmedia.softseal.html":{"source":"iana"},"application/vnd.sealedmedia.softseal.pdf":{"source":"iana"},"application/vnd.seemail":{"source":"iana","extensions":["see"]},"application/vnd.seis+json":{"source":"iana","compressible":true},"application/vnd.sema":{"source":"iana","extensions":["sema"]},"application/vnd.semd":{"source":"iana","extensions":["semd"]},"application/vnd.semf":{"source":"iana","extensions":["semf"]},"application/vnd.shade-save-file":{"source":"iana"},"application/vnd.shana.informed.formdata":{"source":"iana","extensions":["ifm"]},"application/vnd.shana.informed.formtemplate":{"source":"iana","extensions":["itp"]},"application/vnd.shana.informed.interchange":{"source":"iana","extensions":["iif"]},"application/vnd.shana.informed.package":{"source":"iana","extensions":["ipk"]},"application/vnd.shootproof+json":{"source":"iana","compressible":true},"application/vnd.shopkick+json":{"source":"iana","compressible":true},"application/vnd.shp":{"source":"iana"},"application/vnd.shx":{"source":"iana"},"application/vnd.sigrok.session":{"source":"iana"},"application/vnd.simtech-mindmapper":{"source":"iana","extensions":["twd","twds"]},"application/vnd.siren+json":{"source":"iana","compressible":true},"application/vnd.sketchometry":{"source":"iana"},"application/vnd.smaf":{"source":"iana","extensions":["mmf"]},"application/vnd.smart.notebook":{"source":"iana"},"application/vnd.smart.teacher":{"source":"iana","extensions":["teacher"]},"application/vnd.smintio.portals.archive":{"source":"iana"},"application/vnd.snesdev-page-table":{"source":"iana"},"application/vnd.software602.filler.form+xml":{"source":"iana","compressible":true,"extensions":["fo"]},"application/vnd.software602.filler.form-xml-zip":{"source":"iana"},"application/vnd.solent.sdkm+xml":{"source":"iana","compressible":true,"extensions":["sdkm","sdkd"]},"application/vnd.spotfire.dxp":{"source":"iana","extensions":["dxp"]},"application/vnd.spotfire.sfs":{"source":"iana","extensions":["sfs"]},"application/vnd.sqlite3":{"source":"iana"},"application/vnd.sss-cod":{"source":"iana"},"application/vnd.sss-dtf":{"source":"iana"},"application/vnd.sss-ntf":{"source":"iana"},"application/vnd.stardivision.calc":{"source":"apache","extensions":["sdc"]},"application/vnd.stardivision.draw":{"source":"apache","extensions":["sda"]},"application/vnd.stardivision.impress":{"source":"apache","extensions":["sdd"]},"application/vnd.stardivision.math":{"source":"apache","extensions":["smf"]},"application/vnd.stardivision.writer":{"source":"apache","extensions":["sdw","vor"]},"application/vnd.stardivision.writer-global":{"source":"apache","extensions":["sgl"]},"application/vnd.stepmania.package":{"source":"iana","extensions":["smzip"]},"application/vnd.stepmania.stepchart":{"source":"iana","extensions":["sm"]},"application/vnd.street-stream":{"source":"iana"},"application/vnd.sun.wadl+xml":{"source":"iana","compressible":true,"extensions":["wadl"]},"application/vnd.sun.xml.calc":{"source":"apache","extensions":["sxc"]},"application/vnd.sun.xml.calc.template":{"source":"apache","extensions":["stc"]},"application/vnd.sun.xml.draw":{"source":"apache","extensions":["sxd"]},"application/vnd.sun.xml.draw.template":{"source":"apache","extensions":["std"]},"application/vnd.sun.xml.impress":{"source":"apache","extensions":["sxi"]},"application/vnd.sun.xml.impress.template":{"source":"apache","extensions":["sti"]},"application/vnd.sun.xml.math":{"source":"apache","extensions":["sxm"]},"application/vnd.sun.xml.writer":{"source":"apache","extensions":["sxw"]},"application/vnd.sun.xml.writer.global":{"source":"apache","extensions":["sxg"]},"application/vnd.sun.xml.writer.template":{"source":"apache","extensions":["stw"]},"application/vnd.sus-calendar":{"source":"iana","extensions":["sus","susp"]},"application/vnd.svd":{"source":"iana","extensions":["svd"]},"application/vnd.swiftview-ics":{"source":"iana"},"application/vnd.sybyl.mol2":{"source":"iana"},"application/vnd.sycle+xml":{"source":"iana","compressible":true},"application/vnd.syft+json":{"source":"iana","compressible":true},"application/vnd.symbian.install":{"source":"apache","extensions":["sis","sisx"]},"application/vnd.syncml+xml":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["xsm"]},"application/vnd.syncml.dm+wbxml":{"source":"iana","charset":"UTF-8","extensions":["bdm"]},"application/vnd.syncml.dm+xml":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["xdm"]},"application/vnd.syncml.dm.notification":{"source":"iana"},"application/vnd.syncml.dmddf+wbxml":{"source":"iana"},"application/vnd.syncml.dmddf+xml":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["ddf"]},"application/vnd.syncml.dmtnds+wbxml":{"source":"iana"},"application/vnd.syncml.dmtnds+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.syncml.ds.notification":{"source":"iana"},"application/vnd.tableschema+json":{"source":"iana","compressible":true},"application/vnd.tao.intent-module-archive":{"source":"iana","extensions":["tao"]},"application/vnd.tcpdump.pcap":{"source":"iana","extensions":["pcap","cap","dmp"]},"application/vnd.think-cell.ppttc+json":{"source":"iana","compressible":true},"application/vnd.tmd.mediaflex.api+xml":{"source":"iana","compressible":true},"application/vnd.tml":{"source":"iana"},"application/vnd.tmobile-livetv":{"source":"iana","extensions":["tmo"]},"application/vnd.tri.onesource":{"source":"iana"},"application/vnd.trid.tpt":{"source":"iana","extensions":["tpt"]},"application/vnd.triscape.mxs":{"source":"iana","extensions":["mxs"]},"application/vnd.trueapp":{"source":"iana","extensions":["tra"]},"application/vnd.truedoc":{"source":"iana"},"application/vnd.ubisoft.webplayer":{"source":"iana"},"application/vnd.ufdl":{"source":"iana","extensions":["ufd","ufdl"]},"application/vnd.uic.osdm+json":{"source":"iana","compressible":true},"application/vnd.uiq.theme":{"source":"iana","extensions":["utz"]},"application/vnd.umajin":{"source":"iana","extensions":["umj"]},"application/vnd.unity":{"source":"iana","extensions":["unityweb"]},"application/vnd.uoml+xml":{"source":"iana","compressible":true,"extensions":["uoml","uo"]},"application/vnd.uplanet.alert":{"source":"iana"},"application/vnd.uplanet.alert-wbxml":{"source":"iana"},"application/vnd.uplanet.bearer-choice":{"source":"iana"},"application/vnd.uplanet.bearer-choice-wbxml":{"source":"iana"},"application/vnd.uplanet.cacheop":{"source":"iana"},"application/vnd.uplanet.cacheop-wbxml":{"source":"iana"},"application/vnd.uplanet.channel":{"source":"iana"},"application/vnd.uplanet.channel-wbxml":{"source":"iana"},"application/vnd.uplanet.list":{"source":"iana"},"application/vnd.uplanet.list-wbxml":{"source":"iana"},"application/vnd.uplanet.listcmd":{"source":"iana"},"application/vnd.uplanet.listcmd-wbxml":{"source":"iana"},"application/vnd.uplanet.signal":{"source":"iana"},"application/vnd.uri-map":{"source":"iana"},"application/vnd.valve.source.material":{"source":"iana"},"application/vnd.vcx":{"source":"iana","extensions":["vcx"]},"application/vnd.vd-study":{"source":"iana"},"application/vnd.vectorworks":{"source":"iana"},"application/vnd.vel+json":{"source":"iana","compressible":true},"application/vnd.veraison.tsm-report+cbor":{"source":"iana"},"application/vnd.veraison.tsm-report+json":{"source":"iana","compressible":true},"application/vnd.verimatrix.vcas":{"source":"iana"},"application/vnd.veritone.aion+json":{"source":"iana","compressible":true},"application/vnd.veryant.thin":{"source":"iana"},"application/vnd.ves.encrypted":{"source":"iana"},"application/vnd.vidsoft.vidconference":{"source":"iana"},"application/vnd.visio":{"source":"iana","extensions":["vsd","vst","vss","vsw","vsdx","vtx"]},"application/vnd.visionary":{"source":"iana","extensions":["vis"]},"application/vnd.vividence.scriptfile":{"source":"iana"},"application/vnd.vocalshaper.vsp4":{"source":"iana"},"application/vnd.vsf":{"source":"iana","extensions":["vsf"]},"application/vnd.wap.sic":{"source":"iana"},"application/vnd.wap.slc":{"source":"iana"},"application/vnd.wap.wbxml":{"source":"iana","charset":"UTF-8","extensions":["wbxml"]},"application/vnd.wap.wmlc":{"source":"iana","extensions":["wmlc"]},"application/vnd.wap.wmlscriptc":{"source":"iana","extensions":["wmlsc"]},"application/vnd.wasmflow.wafl":{"source":"iana"},"application/vnd.webturbo":{"source":"iana","extensions":["wtb"]},"application/vnd.wfa.dpp":{"source":"iana"},"application/vnd.wfa.p2p":{"source":"iana"},"application/vnd.wfa.wsc":{"source":"iana"},"application/vnd.windows.devicepairing":{"source":"iana"},"application/vnd.wmc":{"source":"iana"},"application/vnd.wmf.bootstrap":{"source":"iana"},"application/vnd.wolfram.mathematica":{"source":"iana"},"application/vnd.wolfram.mathematica.package":{"source":"iana"},"application/vnd.wolfram.player":{"source":"iana","extensions":["nbp"]},"application/vnd.wordlift":{"source":"iana"},"application/vnd.wordperfect":{"source":"iana","extensions":["wpd"]},"application/vnd.wqd":{"source":"iana","extensions":["wqd"]},"application/vnd.wrq-hp3000-labelled":{"source":"iana"},"application/vnd.wt.stf":{"source":"iana","extensions":["stf"]},"application/vnd.wv.csp+wbxml":{"source":"iana"},"application/vnd.wv.csp+xml":{"source":"iana","compressible":true},"application/vnd.wv.ssp+xml":{"source":"iana","compressible":true},"application/vnd.xacml+json":{"source":"iana","compressible":true},"application/vnd.xara":{"source":"iana","extensions":["xar"]},"application/vnd.xarin.cpj":{"source":"iana"},"application/vnd.xecrets-encrypted":{"source":"iana"},"application/vnd.xfdl":{"source":"iana","extensions":["xfdl"]},"application/vnd.xfdl.webform":{"source":"iana"},"application/vnd.xmi+xml":{"source":"iana","compressible":true},"application/vnd.xmpie.cpkg":{"source":"iana"},"application/vnd.xmpie.dpkg":{"source":"iana"},"application/vnd.xmpie.plan":{"source":"iana"},"application/vnd.xmpie.ppkg":{"source":"iana"},"application/vnd.xmpie.xlim":{"source":"iana"},"application/vnd.yamaha.hv-dic":{"source":"iana","extensions":["hvd"]},"application/vnd.yamaha.hv-script":{"source":"iana","extensions":["hvs"]},"application/vnd.yamaha.hv-voice":{"source":"iana","extensions":["hvp"]},"application/vnd.yamaha.openscoreformat":{"source":"iana","extensions":["osf"]},"application/vnd.yamaha.openscoreformat.osfpvg+xml":{"source":"iana","compressible":true,"extensions":["osfpvg"]},"application/vnd.yamaha.remote-setup":{"source":"iana"},"application/vnd.yamaha.smaf-audio":{"source":"iana","extensions":["saf"]},"application/vnd.yamaha.smaf-phrase":{"source":"iana","extensions":["spf"]},"application/vnd.yamaha.through-ngn":{"source":"iana"},"application/vnd.yamaha.tunnel-udpencap":{"source":"iana"},"application/vnd.yaoweme":{"source":"iana"},"application/vnd.yellowriver-custom-menu":{"source":"iana","extensions":["cmp"]},"application/vnd.zul":{"source":"iana","extensions":["zir","zirz"]},"application/vnd.zzazz.deck+xml":{"source":"iana","compressible":true,"extensions":["zaz"]},"application/voicexml+xml":{"source":"iana","compressible":true,"extensions":["vxml"]},"application/voucher-cms+json":{"source":"iana","compressible":true},"application/voucher-jws+json":{"source":"iana","compressible":true},"application/vp":{"source":"iana"},"application/vp+cose":{"source":"iana"},"application/vp+jwt":{"source":"iana"},"application/vq-rtcpxr":{"source":"iana"},"application/wasm":{"source":"iana","compressible":true,"extensions":["wasm"]},"application/watcherinfo+xml":{"source":"iana","compressible":true,"extensions":["wif"]},"application/webpush-options+json":{"source":"iana","compressible":true},"application/whoispp-query":{"source":"iana"},"application/whoispp-response":{"source":"iana"},"application/widget":{"source":"iana","extensions":["wgt"]},"application/winhlp":{"source":"apache","extensions":["hlp"]},"application/wita":{"source":"iana"},"application/wordperfect5.1":{"source":"iana"},"application/wsdl+xml":{"source":"iana","compressible":true,"extensions":["wsdl"]},"application/wspolicy+xml":{"source":"iana","compressible":true,"extensions":["wspolicy"]},"application/x-7z-compressed":{"source":"apache","compressible":false,"extensions":["7z"]},"application/x-abiword":{"source":"apache","extensions":["abw"]},"application/x-ace-compressed":{"source":"apache","extensions":["ace"]},"application/x-amf":{"source":"apache"},"application/x-apple-diskimage":{"source":"apache","extensions":["dmg"]},"application/x-arj":{"compressible":false,"extensions":["arj"]},"application/x-authorware-bin":{"source":"apache","extensions":["aab","x32","u32","vox"]},"application/x-authorware-map":{"source":"apache","extensions":["aam"]},"application/x-authorware-seg":{"source":"apache","extensions":["aas"]},"application/x-bcpio":{"source":"apache","extensions":["bcpio"]},"application/x-bdoc":{"compressible":false,"extensions":["bdoc"]},"application/x-bittorrent":{"source":"apache","extensions":["torrent"]},"application/x-blender":{"extensions":["blend"]},"application/x-blorb":{"source":"apache","extensions":["blb","blorb"]},"application/x-bzip":{"source":"apache","compressible":false,"extensions":["bz"]},"application/x-bzip2":{"source":"apache","compressible":false,"extensions":["bz2","boz"]},"application/x-cbr":{"source":"apache","extensions":["cbr","cba","cbt","cbz","cb7"]},"application/x-cdlink":{"source":"apache","extensions":["vcd"]},"application/x-cfs-compressed":{"source":"apache","extensions":["cfs"]},"application/x-chat":{"source":"apache","extensions":["chat"]},"application/x-chess-pgn":{"source":"apache","extensions":["pgn"]},"application/x-chrome-extension":{"extensions":["crx"]},"application/x-cocoa":{"source":"nginx","extensions":["cco"]},"application/x-compress":{"source":"apache"},"application/x-compressed":{"extensions":["rar"]},"application/x-conference":{"source":"apache","extensions":["nsc"]},"application/x-cpio":{"source":"apache","extensions":["cpio"]},"application/x-csh":{"source":"apache","extensions":["csh"]},"application/x-deb":{"compressible":false},"application/x-debian-package":{"source":"apache","extensions":["deb","udeb"]},"application/x-dgc-compressed":{"source":"apache","extensions":["dgc"]},"application/x-director":{"source":"apache","extensions":["dir","dcr","dxr","cst","cct","cxt","w3d","fgd","swa"]},"application/x-doom":{"source":"apache","extensions":["wad"]},"application/x-dtbncx+xml":{"source":"apache","compressible":true,"extensions":["ncx"]},"application/x-dtbook+xml":{"source":"apache","compressible":true,"extensions":["dtb"]},"application/x-dtbresource+xml":{"source":"apache","compressible":true,"extensions":["res"]},"application/x-dvi":{"source":"apache","compressible":false,"extensions":["dvi"]},"application/x-envoy":{"source":"apache","extensions":["evy"]},"application/x-eva":{"source":"apache","extensions":["eva"]},"application/x-font-bdf":{"source":"apache","extensions":["bdf"]},"application/x-font-dos":{"source":"apache"},"application/x-font-framemaker":{"source":"apache"},"application/x-font-ghostscript":{"source":"apache","extensions":["gsf"]},"application/x-font-libgrx":{"source":"apache"},"application/x-font-linux-psf":{"source":"apache","extensions":["psf"]},"application/x-font-pcf":{"source":"apache","extensions":["pcf"]},"application/x-font-snf":{"source":"apache","extensions":["snf"]},"application/x-font-speedo":{"source":"apache"},"application/x-font-sunos-news":{"source":"apache"},"application/x-font-type1":{"source":"apache","extensions":["pfa","pfb","pfm","afm"]},"application/x-font-vfont":{"source":"apache"},"application/x-freearc":{"source":"apache","extensions":["arc"]},"application/x-futuresplash":{"source":"apache","extensions":["spl"]},"application/x-gca-compressed":{"source":"apache","extensions":["gca"]},"application/x-glulx":{"source":"apache","extensions":["ulx"]},"application/x-gnumeric":{"source":"apache","extensions":["gnumeric"]},"application/x-gramps-xml":{"source":"apache","extensions":["gramps"]},"application/x-gtar":{"source":"apache","extensions":["gtar"]},"application/x-gzip":{"source":"apache"},"application/x-hdf":{"source":"apache","extensions":["hdf"]},"application/x-httpd-php":{"compressible":true,"extensions":["php"]},"application/x-install-instructions":{"source":"apache","extensions":["install"]},"application/x-ipynb+json":{"compressible":true,"extensions":["ipynb"]},"application/x-iso9660-image":{"source":"apache","extensions":["iso"]},"application/x-iwork-keynote-sffkey":{"extensions":["key"]},"application/x-iwork-numbers-sffnumbers":{"extensions":["numbers"]},"application/x-iwork-pages-sffpages":{"extensions":["pages"]},"application/x-java-archive-diff":{"source":"nginx","extensions":["jardiff"]},"application/x-java-jnlp-file":{"source":"apache","compressible":false,"extensions":["jnlp"]},"application/x-javascript":{"compressible":true},"application/x-keepass2":{"extensions":["kdbx"]},"application/x-latex":{"source":"apache","compressible":false,"extensions":["latex"]},"application/x-lua-bytecode":{"extensions":["luac"]},"application/x-lzh-compressed":{"source":"apache","extensions":["lzh","lha"]},"application/x-makeself":{"source":"nginx","extensions":["run"]},"application/x-mie":{"source":"apache","extensions":["mie"]},"application/x-mobipocket-ebook":{"source":"apache","extensions":["prc","mobi"]},"application/x-mpegurl":{"compressible":false},"application/x-ms-application":{"source":"apache","extensions":["application"]},"application/x-ms-shortcut":{"source":"apache","extensions":["lnk"]},"application/x-ms-wmd":{"source":"apache","extensions":["wmd"]},"application/x-ms-wmz":{"source":"apache","extensions":["wmz"]},"application/x-ms-xbap":{"source":"apache","extensions":["xbap"]},"application/x-msaccess":{"source":"apache","extensions":["mdb"]},"application/x-msbinder":{"source":"apache","extensions":["obd"]},"application/x-mscardfile":{"source":"apache","extensions":["crd"]},"application/x-msclip":{"source":"apache","extensions":["clp"]},"application/x-msdos-program":{"extensions":["exe"]},"application/x-msdownload":{"source":"apache","extensions":["exe","dll","com","bat","msi"]},"application/x-msmediaview":{"source":"apache","extensions":["mvb","m13","m14"]},"application/x-msmetafile":{"source":"apache","extensions":["wmf","wmz","emf","emz"]},"application/x-msmoney":{"source":"apache","extensions":["mny"]},"application/x-mspublisher":{"source":"apache","extensions":["pub"]},"application/x-msschedule":{"source":"apache","extensions":["scd"]},"application/x-msterminal":{"source":"apache","extensions":["trm"]},"application/x-mswrite":{"source":"apache","extensions":["wri"]},"application/x-netcdf":{"source":"apache","extensions":["nc","cdf"]},"application/x-ns-proxy-autoconfig":{"compressible":true,"extensions":["pac"]},"application/x-nzb":{"source":"apache","extensions":["nzb"]},"application/x-perl":{"source":"nginx","extensions":["pl","pm"]},"application/x-pilot":{"source":"nginx","extensions":["prc","pdb"]},"application/x-pkcs12":{"source":"apache","compressible":false,"extensions":["p12","pfx"]},"application/x-pkcs7-certificates":{"source":"apache","extensions":["p7b","spc"]},"application/x-pkcs7-certreqresp":{"source":"apache","extensions":["p7r"]},"application/x-pki-message":{"source":"iana"},"application/x-rar-compressed":{"source":"apache","compressible":false,"extensions":["rar"]},"application/x-redhat-package-manager":{"source":"nginx","extensions":["rpm"]},"application/x-research-info-systems":{"source":"apache","extensions":["ris"]},"application/x-sea":{"source":"nginx","extensions":["sea"]},"application/x-sh":{"source":"apache","compressible":true,"extensions":["sh"]},"application/x-shar":{"source":"apache","extensions":["shar"]},"application/x-shockwave-flash":{"source":"apache","compressible":false,"extensions":["swf"]},"application/x-silverlight-app":{"source":"apache","extensions":["xap"]},"application/x-sql":{"source":"apache","extensions":["sql"]},"application/x-stuffit":{"source":"apache","compressible":false,"extensions":["sit"]},"application/x-stuffitx":{"source":"apache","extensions":["sitx"]},"application/x-subrip":{"source":"apache","extensions":["srt"]},"application/x-sv4cpio":{"source":"apache","extensions":["sv4cpio"]},"application/x-sv4crc":{"source":"apache","extensions":["sv4crc"]},"application/x-t3vm-image":{"source":"apache","extensions":["t3"]},"application/x-tads":{"source":"apache","extensions":["gam"]},"application/x-tar":{"source":"apache","compressible":true,"extensions":["tar"]},"application/x-tcl":{"source":"apache","extensions":["tcl","tk"]},"application/x-tex":{"source":"apache","extensions":["tex"]},"application/x-tex-tfm":{"source":"apache","extensions":["tfm"]},"application/x-texinfo":{"source":"apache","extensions":["texinfo","texi"]},"application/x-tgif":{"source":"apache","extensions":["obj"]},"application/x-ustar":{"source":"apache","extensions":["ustar"]},"application/x-virtualbox-hdd":{"compressible":true,"extensions":["hdd"]},"application/x-virtualbox-ova":{"compressible":true,"extensions":["ova"]},"application/x-virtualbox-ovf":{"compressible":true,"extensions":["ovf"]},"application/x-virtualbox-vbox":{"compressible":true,"extensions":["vbox"]},"application/x-virtualbox-vbox-extpack":{"compressible":false,"extensions":["vbox-extpack"]},"application/x-virtualbox-vdi":{"compressible":true,"extensions":["vdi"]},"application/x-virtualbox-vhd":{"compressible":true,"extensions":["vhd"]},"application/x-virtualbox-vmdk":{"compressible":true,"extensions":["vmdk"]},"application/x-wais-source":{"source":"apache","extensions":["src"]},"application/x-web-app-manifest+json":{"compressible":true,"extensions":["webapp"]},"application/x-www-form-urlencoded":{"source":"iana","compressible":true},"application/x-x509-ca-cert":{"source":"iana","extensions":["der","crt","pem"]},"application/x-x509-ca-ra-cert":{"source":"iana"},"application/x-x509-next-ca-cert":{"source":"iana"},"application/x-xfig":{"source":"apache","extensions":["fig"]},"application/x-xliff+xml":{"source":"apache","compressible":true,"extensions":["xlf"]},"application/x-xpinstall":{"source":"apache","compressible":false,"extensions":["xpi"]},"application/x-xz":{"source":"apache","extensions":["xz"]},"application/x-zip-compressed":{"extensions":["zip"]},"application/x-zmachine":{"source":"apache","extensions":["z1","z2","z3","z4","z5","z6","z7","z8"]},"application/x400-bp":{"source":"iana"},"application/xacml+xml":{"source":"iana","compressible":true},"application/xaml+xml":{"source":"apache","compressible":true,"extensions":["xaml"]},"application/xcap-att+xml":{"source":"iana","compressible":true,"extensions":["xav"]},"application/xcap-caps+xml":{"source":"iana","compressible":true,"extensions":["xca"]},"application/xcap-diff+xml":{"source":"iana","compressible":true,"extensions":["xdf"]},"application/xcap-el+xml":{"source":"iana","compressible":true,"extensions":["xel"]},"application/xcap-error+xml":{"source":"iana","compressible":true},"application/xcap-ns+xml":{"source":"iana","compressible":true,"extensions":["xns"]},"application/xcon-conference-info+xml":{"source":"iana","compressible":true},"application/xcon-conference-info-diff+xml":{"source":"iana","compressible":true},"application/xenc+xml":{"source":"iana","compressible":true,"extensions":["xenc"]},"application/xfdf":{"source":"iana","extensions":["xfdf"]},"application/xhtml+xml":{"source":"iana","compressible":true,"extensions":["xhtml","xht"]},"application/xhtml-voice+xml":{"source":"apache","compressible":true},"application/xliff+xml":{"source":"iana","compressible":true,"extensions":["xlf"]},"application/xml":{"source":"iana","compressible":true,"extensions":["xml","xsl","xsd","rng"]},"application/xml-dtd":{"source":"iana","compressible":true,"extensions":["dtd"]},"application/xml-external-parsed-entity":{"source":"iana"},"application/xml-patch+xml":{"source":"iana","compressible":true},"application/xmpp+xml":{"source":"iana","compressible":true},"application/xop+xml":{"source":"iana","compressible":true,"extensions":["xop"]},"application/xproc+xml":{"source":"apache","compressible":true,"extensions":["xpl"]},"application/xslt+xml":{"source":"iana","compressible":true,"extensions":["xsl","xslt"]},"application/xspf+xml":{"source":"apache","compressible":true,"extensions":["xspf"]},"application/xv+xml":{"source":"iana","compressible":true,"extensions":["mxml","xhvml","xvml","xvm"]},"application/yaml":{"source":"iana"},"application/yang":{"source":"iana","extensions":["yang"]},"application/yang-data+cbor":{"source":"iana"},"application/yang-data+json":{"source":"iana","compressible":true},"application/yang-data+xml":{"source":"iana","compressible":true},"application/yang-patch+json":{"source":"iana","compressible":true},"application/yang-patch+xml":{"source":"iana","compressible":true},"application/yang-sid+json":{"source":"iana","compressible":true},"application/yin+xml":{"source":"iana","compressible":true,"extensions":["yin"]},"application/zip":{"source":"iana","compressible":false,"extensions":["zip"]},"application/zip+dotlottie":{"extensions":["lottie"]},"application/zlib":{"source":"iana"},"application/zstd":{"source":"iana"},"audio/1d-interleaved-parityfec":{"source":"iana"},"audio/32kadpcm":{"source":"iana"},"audio/3gpp":{"source":"iana","compressible":false,"extensions":["3gpp"]},"audio/3gpp2":{"source":"iana"},"audio/aac":{"source":"iana","extensions":["adts","aac"]},"audio/ac3":{"source":"iana"},"audio/adpcm":{"source":"apache","extensions":["adp"]},"audio/amr":{"source":"iana","extensions":["amr"]},"audio/amr-wb":{"source":"iana"},"audio/amr-wb+":{"source":"iana"},"audio/aptx":{"source":"iana"},"audio/asc":{"source":"iana"},"audio/atrac-advanced-lossless":{"source":"iana"},"audio/atrac-x":{"source":"iana"},"audio/atrac3":{"source":"iana"},"audio/basic":{"source":"iana","compressible":false,"extensions":["au","snd"]},"audio/bv16":{"source":"iana"},"audio/bv32":{"source":"iana"},"audio/clearmode":{"source":"iana"},"audio/cn":{"source":"iana"},"audio/dat12":{"source":"iana"},"audio/dls":{"source":"iana"},"audio/dsr-es201108":{"source":"iana"},"audio/dsr-es202050":{"source":"iana"},"audio/dsr-es202211":{"source":"iana"},"audio/dsr-es202212":{"source":"iana"},"audio/dv":{"source":"iana"},"audio/dvi4":{"source":"iana"},"audio/eac3":{"source":"iana"},"audio/encaprtp":{"source":"iana"},"audio/evrc":{"source":"iana"},"audio/evrc-qcp":{"source":"iana"},"audio/evrc0":{"source":"iana"},"audio/evrc1":{"source":"iana"},"audio/evrcb":{"source":"iana"},"audio/evrcb0":{"source":"iana"},"audio/evrcb1":{"source":"iana"},"audio/evrcnw":{"source":"iana"},"audio/evrcnw0":{"source":"iana"},"audio/evrcnw1":{"source":"iana"},"audio/evrcwb":{"source":"iana"},"audio/evrcwb0":{"source":"iana"},"audio/evrcwb1":{"source":"iana"},"audio/evs":{"source":"iana"},"audio/flac":{"source":"iana"},"audio/flexfec":{"source":"iana"},"audio/fwdred":{"source":"iana"},"audio/g711-0":{"source":"iana"},"audio/g719":{"source":"iana"},"audio/g722":{"source":"iana"},"audio/g7221":{"source":"iana"},"audio/g723":{"source":"iana"},"audio/g726-16":{"source":"iana"},"audio/g726-24":{"source":"iana"},"audio/g726-32":{"source":"iana"},"audio/g726-40":{"source":"iana"},"audio/g728":{"source":"iana"},"audio/g729":{"source":"iana"},"audio/g7291":{"source":"iana"},"audio/g729d":{"source":"iana"},"audio/g729e":{"source":"iana"},"audio/gsm":{"source":"iana"},"audio/gsm-efr":{"source":"iana"},"audio/gsm-hr-08":{"source":"iana"},"audio/ilbc":{"source":"iana"},"audio/ip-mr_v2.5":{"source":"iana"},"audio/isac":{"source":"apache"},"audio/l16":{"source":"iana"},"audio/l20":{"source":"iana"},"audio/l24":{"source":"iana","compressible":false},"audio/l8":{"source":"iana"},"audio/lpc":{"source":"iana"},"audio/matroska":{"source":"iana"},"audio/melp":{"source":"iana"},"audio/melp1200":{"source":"iana"},"audio/melp2400":{"source":"iana"},"audio/melp600":{"source":"iana"},"audio/mhas":{"source":"iana"},"audio/midi":{"source":"apache","extensions":["mid","midi","kar","rmi"]},"audio/midi-clip":{"source":"iana"},"audio/mobile-xmf":{"source":"iana","extensions":["mxmf"]},"audio/mp3":{"compressible":false,"extensions":["mp3"]},"audio/mp4":{"source":"iana","compressible":false,"extensions":["m4a","mp4a","m4b"]},"audio/mp4a-latm":{"source":"iana"},"audio/mpa":{"source":"iana"},"audio/mpa-robust":{"source":"iana"},"audio/mpeg":{"source":"iana","compressible":false,"extensions":["mpga","mp2","mp2a","mp3","m2a","m3a"]},"audio/mpeg4-generic":{"source":"iana"},"audio/musepack":{"source":"apache"},"audio/ogg":{"source":"iana","compressible":false,"extensions":["oga","ogg","spx","opus"]},"audio/opus":{"source":"iana"},"audio/parityfec":{"source":"iana"},"audio/pcma":{"source":"iana"},"audio/pcma-wb":{"source":"iana"},"audio/pcmu":{"source":"iana"},"audio/pcmu-wb":{"source":"iana"},"audio/prs.sid":{"source":"iana"},"audio/qcelp":{"source":"iana"},"audio/raptorfec":{"source":"iana"},"audio/red":{"source":"iana"},"audio/rtp-enc-aescm128":{"source":"iana"},"audio/rtp-midi":{"source":"iana"},"audio/rtploopback":{"source":"iana"},"audio/rtx":{"source":"iana"},"audio/s3m":{"source":"apache","extensions":["s3m"]},"audio/scip":{"source":"iana"},"audio/silk":{"source":"apache","extensions":["sil"]},"audio/smv":{"source":"iana"},"audio/smv-qcp":{"source":"iana"},"audio/smv0":{"source":"iana"},"audio/sofa":{"source":"iana"},"audio/sp-midi":{"source":"iana"},"audio/speex":{"source":"iana"},"audio/t140c":{"source":"iana"},"audio/t38":{"source":"iana"},"audio/telephone-event":{"source":"iana"},"audio/tetra_acelp":{"source":"iana"},"audio/tetra_acelp_bb":{"source":"iana"},"audio/tone":{"source":"iana"},"audio/tsvcis":{"source":"iana"},"audio/uemclip":{"source":"iana"},"audio/ulpfec":{"source":"iana"},"audio/usac":{"source":"iana"},"audio/vdvi":{"source":"iana"},"audio/vmr-wb":{"source":"iana"},"audio/vnd.3gpp.iufp":{"source":"iana"},"audio/vnd.4sb":{"source":"iana"},"audio/vnd.audiokoz":{"source":"iana"},"audio/vnd.celp":{"source":"iana"},"audio/vnd.cisco.nse":{"source":"iana"},"audio/vnd.cmles.radio-events":{"source":"iana"},"audio/vnd.cns.anp1":{"source":"iana"},"audio/vnd.cns.inf1":{"source":"iana"},"audio/vnd.dece.audio":{"source":"iana","extensions":["uva","uvva"]},"audio/vnd.digital-winds":{"source":"iana","extensions":["eol"]},"audio/vnd.dlna.adts":{"source":"iana"},"audio/vnd.dolby.heaac.1":{"source":"iana"},"audio/vnd.dolby.heaac.2":{"source":"iana"},"audio/vnd.dolby.mlp":{"source":"iana"},"audio/vnd.dolby.mps":{"source":"iana"},"audio/vnd.dolby.pl2":{"source":"iana"},"audio/vnd.dolby.pl2x":{"source":"iana"},"audio/vnd.dolby.pl2z":{"source":"iana"},"audio/vnd.dolby.pulse.1":{"source":"iana"},"audio/vnd.dra":{"source":"iana","extensions":["dra"]},"audio/vnd.dts":{"source":"iana","extensions":["dts"]},"audio/vnd.dts.hd":{"source":"iana","extensions":["dtshd"]},"audio/vnd.dts.uhd":{"source":"iana"},"audio/vnd.dvb.file":{"source":"iana"},"audio/vnd.everad.plj":{"source":"iana"},"audio/vnd.hns.audio":{"source":"iana"},"audio/vnd.lucent.voice":{"source":"iana","extensions":["lvp"]},"audio/vnd.ms-playready.media.pya":{"source":"iana","extensions":["pya"]},"audio/vnd.nokia.mobile-xmf":{"source":"iana"},"audio/vnd.nortel.vbk":{"source":"iana"},"audio/vnd.nuera.ecelp4800":{"source":"iana","extensions":["ecelp4800"]},"audio/vnd.nuera.ecelp7470":{"source":"iana","extensions":["ecelp7470"]},"audio/vnd.nuera.ecelp9600":{"source":"iana","extensions":["ecelp9600"]},"audio/vnd.octel.sbc":{"source":"iana"},"audio/vnd.presonus.multitrack":{"source":"iana"},"audio/vnd.qcelp":{"source":"apache"},"audio/vnd.rhetorex.32kadpcm":{"source":"iana"},"audio/vnd.rip":{"source":"iana","extensions":["rip"]},"audio/vnd.rn-realaudio":{"compressible":false},"audio/vnd.sealedmedia.softseal.mpeg":{"source":"iana"},"audio/vnd.vmx.cvsd":{"source":"iana"},"audio/vnd.wave":{"compressible":false},"audio/vorbis":{"source":"iana","compressible":false},"audio/vorbis-config":{"source":"iana"},"audio/wav":{"compressible":false,"extensions":["wav"]},"audio/wave":{"compressible":false,"extensions":["wav"]},"audio/webm":{"source":"apache","compressible":false,"extensions":["weba"]},"audio/x-aac":{"source":"apache","compressible":false,"extensions":["aac"]},"audio/x-aiff":{"source":"apache","extensions":["aif","aiff","aifc"]},"audio/x-caf":{"source":"apache","compressible":false,"extensions":["caf"]},"audio/x-flac":{"source":"apache","extensions":["flac"]},"audio/x-m4a":{"source":"nginx","extensions":["m4a"]},"audio/x-matroska":{"source":"apache","extensions":["mka"]},"audio/x-mpegurl":{"source":"apache","extensions":["m3u"]},"audio/x-ms-wax":{"source":"apache","extensions":["wax"]},"audio/x-ms-wma":{"source":"apache","extensions":["wma"]},"audio/x-pn-realaudio":{"source":"apache","extensions":["ram","ra"]},"audio/x-pn-realaudio-plugin":{"source":"apache","extensions":["rmp"]},"audio/x-realaudio":{"source":"nginx","extensions":["ra"]},"audio/x-tta":{"source":"apache"},"audio/x-wav":{"source":"apache","extensions":["wav"]},"audio/xm":{"source":"apache","extensions":["xm"]},"chemical/x-cdx":{"source":"apache","extensions":["cdx"]},"chemical/x-cif":{"source":"apache","extensions":["cif"]},"chemical/x-cmdf":{"source":"apache","extensions":["cmdf"]},"chemical/x-cml":{"source":"apache","extensions":["cml"]},"chemical/x-csml":{"source":"apache","extensions":["csml"]},"chemical/x-pdb":{"source":"apache"},"chemical/x-xyz":{"source":"apache","extensions":["xyz"]},"font/collection":{"source":"iana","extensions":["ttc"]},"font/otf":{"source":"iana","compressible":true,"extensions":["otf"]},"font/sfnt":{"source":"iana"},"font/ttf":{"source":"iana","compressible":true,"extensions":["ttf"]},"font/woff":{"source":"iana","extensions":["woff"]},"font/woff2":{"source":"iana","extensions":["woff2"]},"image/aces":{"source":"iana","extensions":["exr"]},"image/apng":{"source":"iana","compressible":false,"extensions":["apng"]},"image/avci":{"source":"iana","extensions":["avci"]},"image/avcs":{"source":"iana","extensions":["avcs"]},"image/avif":{"source":"iana","compressible":false,"extensions":["avif"]},"image/bmp":{"source":"iana","compressible":true,"extensions":["bmp","dib"]},"image/cgm":{"source":"iana","extensions":["cgm"]},"image/dicom-rle":{"source":"iana","extensions":["drle"]},"image/dpx":{"source":"iana","extensions":["dpx"]},"image/emf":{"source":"iana","extensions":["emf"]},"image/fits":{"source":"iana","extensions":["fits"]},"image/g3fax":{"source":"iana","extensions":["g3"]},"image/gif":{"source":"iana","compressible":false,"extensions":["gif"]},"image/heic":{"source":"iana","extensions":["heic"]},"image/heic-sequence":{"source":"iana","extensions":["heics"]},"image/heif":{"source":"iana","extensions":["heif"]},"image/heif-sequence":{"source":"iana","extensions":["heifs"]},"image/hej2k":{"source":"iana","extensions":["hej2"]},"image/ief":{"source":"iana","extensions":["ief"]},"image/j2c":{"source":"iana"},"image/jaii":{"source":"iana","extensions":["jaii"]},"image/jais":{"source":"iana","extensions":["jais"]},"image/jls":{"source":"iana","extensions":["jls"]},"image/jp2":{"source":"iana","compressible":false,"extensions":["jp2","jpg2"]},"image/jpeg":{"source":"iana","compressible":false,"extensions":["jpg","jpeg","jpe"]},"image/jph":{"source":"iana","extensions":["jph"]},"image/jphc":{"source":"iana","extensions":["jhc"]},"image/jpm":{"source":"iana","compressible":false,"extensions":["jpm","jpgm"]},"image/jpx":{"source":"iana","compressible":false,"extensions":["jpx","jpf"]},"image/jxl":{"source":"iana","extensions":["jxl"]},"image/jxr":{"source":"iana","extensions":["jxr"]},"image/jxra":{"source":"iana","extensions":["jxra"]},"image/jxrs":{"source":"iana","extensions":["jxrs"]},"image/jxs":{"source":"iana","extensions":["jxs"]},"image/jxsc":{"source":"iana","extensions":["jxsc"]},"image/jxsi":{"source":"iana","extensions":["jxsi"]},"image/jxss":{"source":"iana","extensions":["jxss"]},"image/ktx":{"source":"iana","extensions":["ktx"]},"image/ktx2":{"source":"iana","extensions":["ktx2"]},"image/naplps":{"source":"iana"},"image/pjpeg":{"compressible":false,"extensions":["jfif"]},"image/png":{"source":"iana","compressible":false,"extensions":["png"]},"image/prs.btif":{"source":"iana","extensions":["btif","btf"]},"image/prs.pti":{"source":"iana","extensions":["pti"]},"image/pwg-raster":{"source":"iana"},"image/sgi":{"source":"apache","extensions":["sgi"]},"image/svg+xml":{"source":"iana","compressible":true,"extensions":["svg","svgz"]},"image/t38":{"source":"iana","extensions":["t38"]},"image/tiff":{"source":"iana","compressible":false,"extensions":["tif","tiff"]},"image/tiff-fx":{"source":"iana","extensions":["tfx"]},"image/vnd.adobe.photoshop":{"source":"iana","compressible":true,"extensions":["psd"]},"image/vnd.airzip.accelerator.azv":{"source":"iana","extensions":["azv"]},"image/vnd.clip":{"source":"iana"},"image/vnd.cns.inf2":{"source":"iana"},"image/vnd.dece.graphic":{"source":"iana","extensions":["uvi","uvvi","uvg","uvvg"]},"image/vnd.djvu":{"source":"iana","extensions":["djvu","djv"]},"image/vnd.dvb.subtitle":{"source":"iana","extensions":["sub"]},"image/vnd.dwg":{"source":"iana","extensions":["dwg"]},"image/vnd.dxf":{"source":"iana","extensions":["dxf"]},"image/vnd.fastbidsheet":{"source":"iana","extensions":["fbs"]},"image/vnd.fpx":{"source":"iana","extensions":["fpx"]},"image/vnd.fst":{"source":"iana","extensions":["fst"]},"image/vnd.fujixerox.edmics-mmr":{"source":"iana","extensions":["mmr"]},"image/vnd.fujixerox.edmics-rlc":{"source":"iana","extensions":["rlc"]},"image/vnd.globalgraphics.pgb":{"source":"iana"},"image/vnd.microsoft.icon":{"source":"iana","compressible":true,"extensions":["ico"]},"image/vnd.mix":{"source":"iana"},"image/vnd.mozilla.apng":{"source":"iana"},"image/vnd.ms-dds":{"compressible":true,"extensions":["dds"]},"image/vnd.ms-modi":{"source":"iana","extensions":["mdi"]},"image/vnd.ms-photo":{"source":"apache","extensions":["wdp"]},"image/vnd.net-fpx":{"source":"iana","extensions":["npx"]},"image/vnd.pco.b16":{"source":"iana","extensions":["b16"]},"image/vnd.radiance":{"source":"iana"},"image/vnd.sealed.png":{"source":"iana"},"image/vnd.sealedmedia.softseal.gif":{"source":"iana"},"image/vnd.sealedmedia.softseal.jpg":{"source":"iana"},"image/vnd.svf":{"source":"iana"},"image/vnd.tencent.tap":{"source":"iana","extensions":["tap"]},"image/vnd.valve.source.texture":{"source":"iana","extensions":["vtf"]},"image/vnd.wap.wbmp":{"source":"iana","extensions":["wbmp"]},"image/vnd.xiff":{"source":"iana","extensions":["xif"]},"image/vnd.zbrush.pcx":{"source":"iana","extensions":["pcx"]},"image/webp":{"source":"iana","extensions":["webp"]},"image/wmf":{"source":"iana","extensions":["wmf"]},"image/x-3ds":{"source":"apache","extensions":["3ds"]},"image/x-adobe-dng":{"extensions":["dng"]},"image/x-cmu-raster":{"source":"apache","extensions":["ras"]},"image/x-cmx":{"source":"apache","extensions":["cmx"]},"image/x-emf":{"source":"iana"},"image/x-freehand":{"source":"apache","extensions":["fh","fhc","fh4","fh5","fh7"]},"image/x-icon":{"source":"apache","compressible":true,"extensions":["ico"]},"image/x-jng":{"source":"nginx","extensions":["jng"]},"image/x-mrsid-image":{"source":"apache","extensions":["sid"]},"image/x-ms-bmp":{"source":"nginx","compressible":true,"extensions":["bmp"]},"image/x-pcx":{"source":"apache","extensions":["pcx"]},"image/x-pict":{"source":"apache","extensions":["pic","pct"]},"image/x-portable-anymap":{"source":"apache","extensions":["pnm"]},"image/x-portable-bitmap":{"source":"apache","extensions":["pbm"]},"image/x-portable-graymap":{"source":"apache","extensions":["pgm"]},"image/x-portable-pixmap":{"source":"apache","extensions":["ppm"]},"image/x-rgb":{"source":"apache","extensions":["rgb"]},"image/x-tga":{"source":"apache","extensions":["tga"]},"image/x-wmf":{"source":"iana"},"image/x-xbitmap":{"source":"apache","extensions":["xbm"]},"image/x-xcf":{"compressible":false},"image/x-xpixmap":{"source":"apache","extensions":["xpm"]},"image/x-xwindowdump":{"source":"apache","extensions":["xwd"]},"message/bhttp":{"source":"iana"},"message/cpim":{"source":"iana"},"message/delivery-status":{"source":"iana"},"message/disposition-notification":{"source":"iana","extensions":["disposition-notification"]},"message/external-body":{"source":"iana"},"message/feedback-report":{"source":"iana"},"message/global":{"source":"iana","extensions":["u8msg"]},"message/global-delivery-status":{"source":"iana","extensions":["u8dsn"]},"message/global-disposition-notification":{"source":"iana","extensions":["u8mdn"]},"message/global-headers":{"source":"iana","extensions":["u8hdr"]},"message/http":{"source":"iana","compressible":false},"message/imdn+xml":{"source":"iana","compressible":true},"message/mls":{"source":"iana"},"message/news":{"source":"apache"},"message/ohttp-req":{"source":"iana"},"message/ohttp-res":{"source":"iana"},"message/partial":{"source":"iana","compressible":false},"message/rfc822":{"source":"iana","compressible":true,"extensions":["eml","mime","mht","mhtml"]},"message/s-http":{"source":"apache"},"message/sip":{"source":"iana"},"message/sipfrag":{"source":"iana"},"message/tracking-status":{"source":"iana"},"message/vnd.si.simp":{"source":"apache"},"message/vnd.wfa.wsc":{"source":"iana","extensions":["wsc"]},"model/3mf":{"source":"iana","extensions":["3mf"]},"model/e57":{"source":"iana"},"model/gltf+json":{"source":"iana","compressible":true,"extensions":["gltf"]},"model/gltf-binary":{"source":"iana","compressible":true,"extensions":["glb"]},"model/iges":{"source":"iana","compressible":false,"extensions":["igs","iges"]},"model/jt":{"source":"iana","extensions":["jt"]},"model/mesh":{"source":"iana","compressible":false,"extensions":["msh","mesh","silo"]},"model/mtl":{"source":"iana","extensions":["mtl"]},"model/obj":{"source":"iana","extensions":["obj"]},"model/prc":{"source":"iana","extensions":["prc"]},"model/step":{"source":"iana","extensions":["step","stp","stpnc","p21","210"]},"model/step+xml":{"source":"iana","compressible":true,"extensions":["stpx"]},"model/step+zip":{"source":"iana","compressible":false,"extensions":["stpz"]},"model/step-xml+zip":{"source":"iana","compressible":false,"extensions":["stpxz"]},"model/stl":{"source":"iana","extensions":["stl"]},"model/u3d":{"source":"iana","extensions":["u3d"]},"model/vnd.bary":{"source":"iana","extensions":["bary"]},"model/vnd.cld":{"source":"iana","extensions":["cld"]},"model/vnd.collada+xml":{"source":"iana","compressible":true,"extensions":["dae"]},"model/vnd.dwf":{"source":"iana","extensions":["dwf"]},"model/vnd.flatland.3dml":{"source":"iana"},"model/vnd.gdl":{"source":"iana","extensions":["gdl"]},"model/vnd.gs-gdl":{"source":"apache"},"model/vnd.gs.gdl":{"source":"iana"},"model/vnd.gtw":{"source":"iana","extensions":["gtw"]},"model/vnd.moml+xml":{"source":"iana","compressible":true},"model/vnd.mts":{"source":"iana","extensions":["mts"]},"model/vnd.opengex":{"source":"iana","extensions":["ogex"]},"model/vnd.parasolid.transmit.binary":{"source":"iana","extensions":["x_b"]},"model/vnd.parasolid.transmit.text":{"source":"iana","extensions":["x_t"]},"model/vnd.pytha.pyox":{"source":"iana","extensions":["pyo","pyox"]},"model/vnd.rosette.annotated-data-model":{"source":"iana"},"model/vnd.sap.vds":{"source":"iana","extensions":["vds"]},"model/vnd.usda":{"source":"iana","extensions":["usda"]},"model/vnd.usdz+zip":{"source":"iana","compressible":false,"extensions":["usdz"]},"model/vnd.valve.source.compiled-map":{"source":"iana","extensions":["bsp"]},"model/vnd.vtu":{"source":"iana","extensions":["vtu"]},"model/vrml":{"source":"iana","compressible":false,"extensions":["wrl","vrml"]},"model/x3d+binary":{"source":"apache","compressible":false,"extensions":["x3db","x3dbz"]},"model/x3d+fastinfoset":{"source":"iana","extensions":["x3db"]},"model/x3d+vrml":{"source":"apache","compressible":false,"extensions":["x3dv","x3dvz"]},"model/x3d+xml":{"source":"iana","compressible":true,"extensions":["x3d","x3dz"]},"model/x3d-vrml":{"source":"iana","extensions":["x3dv"]},"multipart/alternative":{"source":"iana","compressible":false},"multipart/appledouble":{"source":"iana"},"multipart/byteranges":{"source":"iana"},"multipart/digest":{"source":"iana"},"multipart/encrypted":{"source":"iana","compressible":false},"multipart/form-data":{"source":"iana","compressible":false},"multipart/header-set":{"source":"iana"},"multipart/mixed":{"source":"iana"},"multipart/multilingual":{"source":"iana"},"multipart/parallel":{"source":"iana"},"multipart/related":{"source":"iana","compressible":false},"multipart/report":{"source":"iana"},"multipart/signed":{"source":"iana","compressible":false},"multipart/vnd.bint.med-plus":{"source":"iana"},"multipart/voice-message":{"source":"iana"},"multipart/x-mixed-replace":{"source":"iana"},"text/1d-interleaved-parityfec":{"source":"iana"},"text/cache-manifest":{"source":"iana","compressible":true,"extensions":["appcache","manifest"]},"text/calendar":{"source":"iana","extensions":["ics","ifb"]},"text/calender":{"compressible":true},"text/cmd":{"compressible":true},"text/coffeescript":{"extensions":["coffee","litcoffee"]},"text/cql":{"source":"iana"},"text/cql-expression":{"source":"iana"},"text/cql-identifier":{"source":"iana"},"text/css":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["css"]},"text/csv":{"source":"iana","compressible":true,"extensions":["csv"]},"text/csv-schema":{"source":"iana"},"text/directory":{"source":"iana"},"text/dns":{"source":"iana"},"text/ecmascript":{"source":"apache"},"text/encaprtp":{"source":"iana"},"text/enriched":{"source":"iana"},"text/fhirpath":{"source":"iana"},"text/flexfec":{"source":"iana"},"text/fwdred":{"source":"iana"},"text/gff3":{"source":"iana"},"text/grammar-ref-list":{"source":"iana"},"text/hl7v2":{"source":"iana"},"text/html":{"source":"iana","compressible":true,"extensions":["html","htm","shtml"]},"text/jade":{"extensions":["jade"]},"text/javascript":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["js","mjs"]},"text/jcr-cnd":{"source":"iana"},"text/jsx":{"compressible":true,"extensions":["jsx"]},"text/less":{"compressible":true,"extensions":["less"]},"text/markdown":{"source":"iana","compressible":true,"extensions":["md","markdown"]},"text/mathml":{"source":"nginx","extensions":["mml"]},"text/mdx":{"compressible":true,"extensions":["mdx"]},"text/mizar":{"source":"iana"},"text/n3":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["n3"]},"text/parameters":{"source":"iana","charset":"UTF-8"},"text/parityfec":{"source":"iana"},"text/plain":{"source":"iana","compressible":true,"extensions":["txt","text","conf","def","list","log","in","ini"]},"text/provenance-notation":{"source":"iana","charset":"UTF-8"},"text/prs.fallenstein.rst":{"source":"iana"},"text/prs.lines.tag":{"source":"iana","extensions":["dsc"]},"text/prs.prop.logic":{"source":"iana"},"text/prs.texi":{"source":"iana"},"text/raptorfec":{"source":"iana"},"text/red":{"source":"iana"},"text/rfc822-headers":{"source":"iana"},"text/richtext":{"source":"iana","compressible":true,"extensions":["rtx"]},"text/rtf":{"source":"iana","compressible":true,"extensions":["rtf"]},"text/rtp-enc-aescm128":{"source":"iana"},"text/rtploopback":{"source":"iana"},"text/rtx":{"source":"iana"},"text/sgml":{"source":"iana","extensions":["sgml","sgm"]},"text/shaclc":{"source":"iana"},"text/shex":{"source":"iana","extensions":["shex"]},"text/slim":{"extensions":["slim","slm"]},"text/spdx":{"source":"iana","extensions":["spdx"]},"text/strings":{"source":"iana"},"text/stylus":{"extensions":["stylus","styl"]},"text/t140":{"source":"iana"},"text/tab-separated-values":{"source":"iana","compressible":true,"extensions":["tsv"]},"text/troff":{"source":"iana","extensions":["t","tr","roff","man","me","ms"]},"text/turtle":{"source":"iana","charset":"UTF-8","extensions":["ttl"]},"text/ulpfec":{"source":"iana"},"text/uri-list":{"source":"iana","compressible":true,"extensions":["uri","uris","urls"]},"text/vcard":{"source":"iana","compressible":true,"extensions":["vcard"]},"text/vnd.a":{"source":"iana"},"text/vnd.abc":{"source":"iana"},"text/vnd.ascii-art":{"source":"iana"},"text/vnd.curl":{"source":"iana","extensions":["curl"]},"text/vnd.curl.dcurl":{"source":"apache","extensions":["dcurl"]},"text/vnd.curl.mcurl":{"source":"apache","extensions":["mcurl"]},"text/vnd.curl.scurl":{"source":"apache","extensions":["scurl"]},"text/vnd.debian.copyright":{"source":"iana","charset":"UTF-8"},"text/vnd.dmclientscript":{"source":"iana"},"text/vnd.dvb.subtitle":{"source":"iana","extensions":["sub"]},"text/vnd.esmertec.theme-descriptor":{"source":"iana","charset":"UTF-8"},"text/vnd.exchangeable":{"source":"iana"},"text/vnd.familysearch.gedcom":{"source":"iana","extensions":["ged"]},"text/vnd.ficlab.flt":{"source":"iana"},"text/vnd.fly":{"source":"iana","extensions":["fly"]},"text/vnd.fmi.flexstor":{"source":"iana","extensions":["flx"]},"text/vnd.gml":{"source":"iana"},"text/vnd.graphviz":{"source":"iana","extensions":["gv"]},"text/vnd.hans":{"source":"iana"},"text/vnd.hgl":{"source":"iana"},"text/vnd.in3d.3dml":{"source":"iana","extensions":["3dml"]},"text/vnd.in3d.spot":{"source":"iana","extensions":["spot"]},"text/vnd.iptc.newsml":{"source":"iana"},"text/vnd.iptc.nitf":{"source":"iana"},"text/vnd.latex-z":{"source":"iana"},"text/vnd.motorola.reflex":{"source":"iana"},"text/vnd.ms-mediapackage":{"source":"iana"},"text/vnd.net2phone.commcenter.command":{"source":"iana"},"text/vnd.radisys.msml-basic-layout":{"source":"iana"},"text/vnd.senx.warpscript":{"source":"iana"},"text/vnd.si.uricatalogue":{"source":"apache"},"text/vnd.sosi":{"source":"iana"},"text/vnd.sun.j2me.app-descriptor":{"source":"iana","charset":"UTF-8","extensions":["jad"]},"text/vnd.trolltech.linguist":{"source":"iana","charset":"UTF-8"},"text/vnd.vcf":{"source":"iana"},"text/vnd.wap.si":{"source":"iana"},"text/vnd.wap.sl":{"source":"iana"},"text/vnd.wap.wml":{"source":"iana","extensions":["wml"]},"text/vnd.wap.wmlscript":{"source":"iana","extensions":["wmls"]},"text/vnd.zoo.kcl":{"source":"iana"},"text/vtt":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["vtt"]},"text/wgsl":{"source":"iana","extensions":["wgsl"]},"text/x-asm":{"source":"apache","extensions":["s","asm"]},"text/x-c":{"source":"apache","extensions":["c","cc","cxx","cpp","h","hh","dic"]},"text/x-component":{"source":"nginx","extensions":["htc"]},"text/x-fortran":{"source":"apache","extensions":["f","for","f77","f90"]},"text/x-gwt-rpc":{"compressible":true},"text/x-handlebars-template":{"extensions":["hbs"]},"text/x-java-source":{"source":"apache","extensions":["java"]},"text/x-jquery-tmpl":{"compressible":true},"text/x-lua":{"extensions":["lua"]},"text/x-markdown":{"compressible":true,"extensions":["mkd"]},"text/x-nfo":{"source":"apache","extensions":["nfo"]},"text/x-opml":{"source":"apache","extensions":["opml"]},"text/x-org":{"compressible":true,"extensions":["org"]},"text/x-pascal":{"source":"apache","extensions":["p","pas"]},"text/x-processing":{"compressible":true,"extensions":["pde"]},"text/x-sass":{"extensions":["sass"]},"text/x-scss":{"extensions":["scss"]},"text/x-setext":{"source":"apache","extensions":["etx"]},"text/x-sfv":{"source":"apache","extensions":["sfv"]},"text/x-suse-ymp":{"compressible":true,"extensions":["ymp"]},"text/x-uuencode":{"source":"apache","extensions":["uu"]},"text/x-vcalendar":{"source":"apache","extensions":["vcs"]},"text/x-vcard":{"source":"apache","extensions":["vcf"]},"text/xml":{"source":"iana","compressible":true,"extensions":["xml"]},"text/xml-external-parsed-entity":{"source":"iana"},"text/yaml":{"compressible":true,"extensions":["yaml","yml"]},"video/1d-interleaved-parityfec":{"source":"iana"},"video/3gpp":{"source":"iana","extensions":["3gp","3gpp"]},"video/3gpp-tt":{"source":"iana"},"video/3gpp2":{"source":"iana","extensions":["3g2"]},"video/av1":{"source":"iana"},"video/bmpeg":{"source":"iana"},"video/bt656":{"source":"iana"},"video/celb":{"source":"iana"},"video/dv":{"source":"iana"},"video/encaprtp":{"source":"iana"},"video/evc":{"source":"iana"},"video/ffv1":{"source":"iana"},"video/flexfec":{"source":"iana"},"video/h261":{"source":"iana","extensions":["h261"]},"video/h263":{"source":"iana","extensions":["h263"]},"video/h263-1998":{"source":"iana"},"video/h263-2000":{"source":"iana"},"video/h264":{"source":"iana","extensions":["h264"]},"video/h264-rcdo":{"source":"iana"},"video/h264-svc":{"source":"iana"},"video/h265":{"source":"iana"},"video/h266":{"source":"iana"},"video/iso.segment":{"source":"iana","extensions":["m4s"]},"video/jpeg":{"source":"iana","extensions":["jpgv"]},"video/jpeg2000":{"source":"iana"},"video/jpm":{"source":"apache","extensions":["jpm","jpgm"]},"video/jxsv":{"source":"iana"},"video/lottie+json":{"source":"iana","compressible":true},"video/matroska":{"source":"iana"},"video/matroska-3d":{"source":"iana"},"video/mj2":{"source":"iana","extensions":["mj2","mjp2"]},"video/mp1s":{"source":"iana"},"video/mp2p":{"source":"iana"},"video/mp2t":{"source":"iana","extensions":["ts","m2t","m2ts","mts"]},"video/mp4":{"source":"iana","compressible":false,"extensions":["mp4","mp4v","mpg4"]},"video/mp4v-es":{"source":"iana"},"video/mpeg":{"source":"iana","compressible":false,"extensions":["mpeg","mpg","mpe","m1v","m2v"]},"video/mpeg4-generic":{"source":"iana"},"video/mpv":{"source":"iana"},"video/nv":{"source":"iana"},"video/ogg":{"source":"iana","compressible":false,"extensions":["ogv"]},"video/parityfec":{"source":"iana"},"video/pointer":{"source":"iana"},"video/quicktime":{"source":"iana","compressible":false,"extensions":["qt","mov"]},"video/raptorfec":{"source":"iana"},"video/raw":{"source":"iana"},"video/rtp-enc-aescm128":{"source":"iana"},"video/rtploopback":{"source":"iana"},"video/rtx":{"source":"iana"},"video/scip":{"source":"iana"},"video/smpte291":{"source":"iana"},"video/smpte292m":{"source":"iana"},"video/ulpfec":{"source":"iana"},"video/vc1":{"source":"iana"},"video/vc2":{"source":"iana"},"video/vnd.cctv":{"source":"iana"},"video/vnd.dece.hd":{"source":"iana","extensions":["uvh","uvvh"]},"video/vnd.dece.mobile":{"source":"iana","extensions":["uvm","uvvm"]},"video/vnd.dece.mp4":{"source":"iana"},"video/vnd.dece.pd":{"source":"iana","extensions":["uvp","uvvp"]},"video/vnd.dece.sd":{"source":"iana","extensions":["uvs","uvvs"]},"video/vnd.dece.video":{"source":"iana","extensions":["uvv","uvvv"]},"video/vnd.directv.mpeg":{"source":"iana"},"video/vnd.directv.mpeg-tts":{"source":"iana"},"video/vnd.dlna.mpeg-tts":{"source":"iana"},"video/vnd.dvb.file":{"source":"iana","extensions":["dvb"]},"video/vnd.fvt":{"source":"iana","extensions":["fvt"]},"video/vnd.hns.video":{"source":"iana"},"video/vnd.iptvforum.1dparityfec-1010":{"source":"iana"},"video/vnd.iptvforum.1dparityfec-2005":{"source":"iana"},"video/vnd.iptvforum.2dparityfec-1010":{"source":"iana"},"video/vnd.iptvforum.2dparityfec-2005":{"source":"iana"},"video/vnd.iptvforum.ttsavc":{"source":"iana"},"video/vnd.iptvforum.ttsmpeg2":{"source":"iana"},"video/vnd.motorola.video":{"source":"iana"},"video/vnd.motorola.videop":{"source":"iana"},"video/vnd.mpegurl":{"source":"iana","extensions":["mxu","m4u"]},"video/vnd.ms-playready.media.pyv":{"source":"iana","extensions":["pyv"]},"video/vnd.nokia.interleaved-multimedia":{"source":"iana"},"video/vnd.nokia.mp4vr":{"source":"iana"},"video/vnd.nokia.videovoip":{"source":"iana"},"video/vnd.objectvideo":{"source":"iana"},"video/vnd.planar":{"source":"iana"},"video/vnd.radgamettools.bink":{"source":"iana"},"video/vnd.radgamettools.smacker":{"source":"apache"},"video/vnd.sealed.mpeg1":{"source":"iana"},"video/vnd.sealed.mpeg4":{"source":"iana"},"video/vnd.sealed.swf":{"source":"iana"},"video/vnd.sealedmedia.softseal.mov":{"source":"iana"},"video/vnd.uvvu.mp4":{"source":"iana","extensions":["uvu","uvvu"]},"video/vnd.vivo":{"source":"iana","extensions":["viv"]},"video/vnd.youtube.yt":{"source":"iana"},"video/vp8":{"source":"iana"},"video/vp9":{"source":"iana"},"video/webm":{"source":"apache","compressible":false,"extensions":["webm"]},"video/x-f4v":{"source":"apache","extensions":["f4v"]},"video/x-fli":{"source":"apache","extensions":["fli"]},"video/x-flv":{"source":"apache","compressible":false,"extensions":["flv"]},"video/x-m4v":{"source":"apache","extensions":["m4v"]},"video/x-matroska":{"source":"apache","compressible":false,"extensions":["mkv","mk3d","mks"]},"video/x-mng":{"source":"apache","extensions":["mng"]},"video/x-ms-asf":{"source":"apache","extensions":["asf","asx"]},"video/x-ms-vob":{"source":"apache","extensions":["vob"]},"video/x-ms-wm":{"source":"apache","extensions":["wm"]},"video/x-ms-wmv":{"source":"apache","compressible":false,"extensions":["wmv"]},"video/x-ms-wmx":{"source":"apache","extensions":["wmx"]},"video/x-ms-wvx":{"source":"apache","extensions":["wvx"]},"video/x-msvideo":{"source":"apache","extensions":["avi"]},"video/x-sgi-movie":{"source":"apache","extensions":["movie"]},"video/x-smv":{"source":"apache","extensions":["smv"]},"x-conference/x-cooltalk":{"source":"apache","extensions":["ice"]},"x-shader/x-fragment":{"compressible":true},"x-shader/x-vertex":{"compressible":true}}');

/***/ },

/***/ 869
(module, __unused_webpack_exports, __webpack_require__) {

var regeneratorAsyncGen = __webpack_require__(887);
function _regeneratorAsync(n, e, r, t, o) {
  var a = regeneratorAsyncGen(n, e, r, t, o);
  return a.next().then(function (n) {
    return n.done ? n.value : a.next();
  });
}
module.exports = _regeneratorAsync, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },

/***/ 887
(module, __unused_webpack_exports, __webpack_require__) {

var regenerator = __webpack_require__(993);
var regeneratorAsyncIterator = __webpack_require__(791);
function _regeneratorAsyncGen(r, e, t, o, n) {
  return new regeneratorAsyncIterator(regenerator().w(r, e, t, o), n || Promise);
}
module.exports = _regeneratorAsyncGen, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },

/***/ 983
(module) {

// 'mime-score' back-ported to CommonJS

// Score RFC facets (see https://tools.ietf.org/html/rfc6838#section-3)
var FACET_SCORES = {
  'prs.': 100,
  'x-': 200,
  'x.': 300,
  'vnd.': 400,
  default: 900
}

// Score mime source (Logic originally from `jshttp/mime-types` module)
var SOURCE_SCORES = {
  nginx: 10,
  apache: 20,
  iana: 40,
  default: 30 // definitions added by `jshttp/mime-db` project?
}

var TYPE_SCORES = {
  // prefer application/xml over text/xml
  // prefer application/rtf over text/rtf
  application: 1,

  // prefer font/woff over application/font-woff
  font: 2,

  // prefer video/mp4 over audio/mp4 over application/mp4
  // See https://www.rfc-editor.org/rfc/rfc4337.html#section-2
  audio: 2,
  video: 3,

  default: 0
}

/**
 * Get each component of the score for a mime type.  The sum of these is the
 * total score.  The higher the score, the more "official" the type.
 */
module.exports = function mimeScore (mimeType, source = 'default') {
  if (mimeType === 'application/octet-stream') {
    return 0
  }

  const [type, subtype] = mimeType.split('/')

  const facet = subtype.replace(/(\.|x-).*/, '$1')

  const facetScore = FACET_SCORES[facet] || FACET_SCORES.default
  const sourceScore = SOURCE_SCORES[source] || SOURCE_SCORES.default
  const typeScore = TYPE_SCORES[type] || TYPE_SCORES.default

  // All else being equal prefer shorter types
  const lengthScore = 1 - mimeType.length / 100

  return facetScore + sourceScore + typeScore + lengthScore
}


/***/ },

/***/ 993
(module, __unused_webpack_exports, __webpack_require__) {

var regeneratorDefine = __webpack_require__(546);
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return regeneratorDefine(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (regeneratorDefine(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, regeneratorDefine(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, regeneratorDefine(u, "constructor", GeneratorFunctionPrototype), regeneratorDefine(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", regeneratorDefine(GeneratorFunctionPrototype, o, "GeneratorFunction"), regeneratorDefine(u), regeneratorDefine(u, o, "Generator"), regeneratorDefine(u, n, function () {
    return this;
  }), regeneratorDefine(u, "toString", function () {
    return "[object Generator]";
  }), (module.exports = _regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = _regenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/harmony module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.hmd = (module) => {
/******/ 			module = Object.create(module);
/******/ 			if (!module.children) module.children = [];
/******/ 			Object.defineProperty(module, 'exports', {
/******/ 				enumerable: true,
/******/ 				set: () => {
/******/ 					throw new Error('ES Modules may not assign module.exports or exports.*, Use ESM export syntax, instead: ' + module.id);
/******/ 				}
/******/ 			});
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  acl: () => (/* reexport */ acl),
  aclControl: () => (/* reexport */ aclControl),
  create: () => (/* reexport */ create),
  createTypes: () => (/* reexport */ types_namespaceObject),
  dom: () => (/* binding */ src_dom),
  icons: () => (/* reexport */ iconBase/* icons */.Pt),
  infiniteMessageArea: () => (/* reexport */ infiniteMessageArea),
  initFooter: () => (/* reexport */ initFooter),
  initHeader: () => (/* reexport */ initHeader),
  language: () => (/* reexport */ language_namespaceObject),
  log: () => (/* reexport */ log_namespaceObject),
  login: () => (/* reexport */ login_namespaceObject),
  matrix: () => (/* reexport */ matrix),
  media: () => (/* reexport */ media),
  messageArea: () => (/* reexport */ messageArea),
  ns: () => (/* reexport */ src_ns),
  pad: () => (/* reexport */ pad_namespaceObject),
  participation: () => (/* reexport */ participation_namespaceObject),
  preferences: () => (/* reexport */ preferences_namespaceObject),
  style: () => (/* reexport */ style),
  table: () => (/* reexport */ renderTableViewPane),
  tabs: () => (/* reexport */ tabs_namespaceObject),
  utils: () => (/* reexport */ utils_namespaceObject),
  widgets: () => (/* reexport */ widgets_namespaceObject)
});

// NAMESPACE OBJECT: ./src/log.ts
var log_namespaceObject = {};
__webpack_require__.r(log_namespaceObject);
__webpack_require__.d(log_namespaceObject, {
  LogLevel: () => (LogLevel),
  alert: () => (log_alert),
  clear: () => (clear),
  debug: () => (debug),
  dumpHTML: () => (dumpHTML),
  error: () => (error),
  escapeForXML: () => (escapeForXML),
  info: () => (info),
  logAscending: () => (logAscending),
  logDescending: () => (logDescending),
  msg: () => (msg),
  setInternals: () => (setInternals),
  setLevel: () => (setLevel),
  success: () => (success),
  warn: () => (warn)
});

// NAMESPACE OBJECT: ./src/utils/index.js
var utils_namespaceObject = {};
__webpack_require__.r(utils_namespaceObject);
__webpack_require__.d(utils_namespaceObject, {
  AJARImage: () => (AJARImage),
  RDFComparePredicateObject: () => (RDFComparePredicateObject),
  RDFComparePredicateSubject: () => (RDFComparePredicateSubject),
  addLoadEvent: () => (addLoadEvent),
  ancestor: () => (ancestor),
  beep: () => (beep),
  clearVariableNames: () => (clearVariableNames),
  emptyNode: () => (emptyNode),
  escapeForXML: () => (utils_escapeForXML),
  findPos: () => (findPos),
  genUuid: () => (genUuid),
  getAbout: () => (getAbout),
  getEyeFocus: () => (getEyeFocus),
  getTarget: () => (getTarget),
  getTerm: () => (getTerm),
  hashColor: () => (hashColor),
  include: () => (include),
  label: () => (label_label),
  labelForXML: () => (labelForXML),
  labelWithOntology: () => (labelWithOntology),
  newVariableName: () => (newVariableName),
  ontologyLabel: () => (ontologyLabel),
  predParentOf: () => (predParentOf),
  predicateLabel: () => (predicateLabel),
  predicateLabelForXML: () => (predicateLabelForXML),
  shortName: () => (shortName),
  stackString: () => (stackString),
  syncTableToArray: () => (syncTableToArray),
  syncTableToArrayReOrdered: () => (syncTableToArrayReOrdered)
});

// NAMESPACE OBJECT: ./src/widgets/forms/autocomplete/language.ts
var language_namespaceObject = {};
__webpack_require__.r(language_namespaceObject);
__webpack_require__.d(language_namespaceObject, {
  addDefaults: () => (addDefaults),
  defaultPreferredLanguages: () => (defaultPreferredLanguages),
  filterByLanguage: () => (filterByLanguage),
  getPreferredLanguages: () => (getPreferredLanguages),
  getPreferredLanguagesFor: () => (getPreferredLanguagesFor),
  languageCodeURIBase: () => (languageCodeURIBase)
});

// NAMESPACE OBJECT: ./src/widgets/forms/autocomplete/publicData.ts
var publicData_namespaceObject = {};
__webpack_require__.r(publicData_namespaceObject);
__webpack_require__.d(publicData_namespaceObject, {
  AUTOCOMPLETE_LIMIT: () => (AUTOCOMPLETE_LIMIT),
  ESCOResultToBindings: () => (ESCOResultToBindings),
  bindingToTerm: () => (bindingToTerm),
  dbPediaTypeMap: () => (dbPediaTypeMap),
  dbpediaParameters: () => (dbpediaParameters),
  escoParameters: () => (escoParameters),
  fetcherOptionsJsonPublicData: () => (fetcherOptionsJsonPublicData),
  getDbpediaDetails: () => (getDbpediaDetails),
  getWikidataDetails: () => (getWikidataDetails),
  getWikidataDetailsOld: () => (getWikidataDetailsOld),
  getWikidataLocation: () => (getWikidataLocation),
  instituteDetailsWikidataQuery: () => (instituteDetailsWikidataQuery),
  loadFromBindings: () => (loadFromBindings),
  loadPublicDataThing: () => (loadPublicDataThing),
  queryESCODataByName: () => (queryESCODataByName),
  queryPublicDataByName: () => (queryPublicDataByName),
  queryPublicDataConstruct: () => (queryPublicDataConstruct),
  queryPublicDataSelect: () => (queryPublicDataSelect),
  variableNameToPredicateMap: () => (variableNameToPredicateMap),
  wikidataClasses: () => (wikidataClasses),
  wikidataIncomingClassMap: () => (wikidataIncomingClassMap),
  wikidataOutgoingClassMap: () => (wikidataOutgoingClassMap),
  wikidataParameters: () => (wikidataParameters)
});

// NAMESPACE OBJECT: ./src/login/login.ts
var login_namespaceObject = {};
__webpack_require__.r(login_namespaceObject);
__webpack_require__.d(login_namespaceObject, {
  ensureLoadedPreferences: () => (ensureLoadedPreferences),
  ensureLoadedProfile: () => (ensureLoadedProfile),
  ensureLoggedIn: () => (ensureLoggedIn),
  filterAvailablePanes: () => (filterAvailablePanes),
  findAppInstances: () => (findAppInstances),
  getUserRoles: () => (getUserRoles),
  loginStatusBox: () => (loginStatusBox),
  newAppInstance: () => (newAppInstance),
  registrationControl: () => (registrationControl),
  registrationList: () => (registrationList),
  renderScopeHeadingRow: () => (renderScopeHeadingRow),
  renderSignInPopup: () => (renderSignInPopup),
  scopeLabel: () => (scopeLabel),
  selectWorkspace: () => (selectWorkspace)
});

// NAMESPACE OBJECT: ./src/widgets/index.js
var widgets_namespaceObject = {};
__webpack_require__.r(widgets_namespaceObject);
__webpack_require__.d(widgets_namespaceObject, {
  Group: () => (Group),
  GroupBuilder: () => (GroupBuilder),
  GroupPicker: () => (GroupPicker),
  PeoplePicker: () => (PeoplePicker),
  Person: () => (Person),
  addStyleSheet: () => (addStyleSheet),
  allClassURIs: () => (allClassURIs),
  appendForm: () => (appendForm),
  askName: () => (askName),
  attachmentList: () => (attachmentList),
  basicField: () => (basicField),
  buildCheckboxForm: () => (buildCheckboxForm),
  button: () => (buttons_button),
  cancelButton: () => (buttons_cancelButton),
  clearElement: () => (clearElement),
  complain: () => (complain),
  continueButton: () => (continueButton),
  createLinkDiv: () => (createLinkDiv),
  createLinkForURI: () => (createLinkForURI),
  createNameDiv: () => (createNameDiv),
  defaultAnnotationStore: () => (defaultAnnotationStore),
  deleteButtonWithCheck: () => (deleteButtonWithCheck),
  editFormButton: () => (editFormButton),
  errorMessageBlock: () => (errorMessageBlock),
  extractLogURI: () => (extractLogURI),
  faviconOrDefault: () => (faviconOrDefault),
  field: () => (field),
  fieldFunction: () => (fieldFunction),
  fieldLabel: () => (fieldLabel),
  fieldParams: () => (fieldParams),
  fieldStore: () => (fieldStore),
  fileUploadButtonDiv: () => (fileUploadButtonDiv),
  findClosest: () => (findClosest),
  findImage: () => (findImage),
  findImageFromURI: () => (findImageFromURI),
  formatDateTime: () => (formatDateTime),
  formsFor: () => (formsFor),
  iconForClass: () => (iconForClass),
  imagesOf: () => (imagesOf),
  index: () => (index),
  isAudio: () => (isAudio),
  isImage: () => (isImage),
  isVideo: () => (isVideo),
  linkButton: () => (linkButton),
  linkIcon: () => (linkIcon),
  makeDescription: () => (makeDescription),
  makeDraggable: () => (makeDraggable),
  makeDropTarget: () => (makeDropTarget),
  makeSelectForCategory: () => (makeSelectForCategory),
  makeSelectForChoice: () => (makeSelectForChoice),
  makeSelectForClassifierOptions: () => (makeSelectForClassifierOptions),
  makeSelectForNestedCategory: () => (makeSelectForNestedCategory),
  makeSelectForOptions: () => (makeSelectForOptions),
  mostSpecificClassURI: () => (mostSpecificClassURI),
  newButton: () => (newButton),
  newThing: () => (newThing),
  openHrefInOutlineMode: () => (openHrefInOutlineMode),
  personTR: () => (personTR),
  promptForNew: () => (promptForNew),
  propertiesForClass: () => (propertiesForClass),
  propertyTriage: () => (propertyTriage),
  publicData: () => (publicData_namespaceObject),
  refreshTree: () => (refreshTree),
  removeButton: () => (removeButton),
  renderAsDiv: () => (renderAsDiv),
  renderAsRow: () => (renderAsRow),
  renderAutoComplete: () => (renderAutoComplete),
  renderAutocompleteControl: () => (renderAutocompleteControl),
  renderNameValuePair: () => (renderNameValuePair),
  selectorPanel: () => (selectorPanel),
  selectorPanelRefresh: () => (selectorPanelRefresh),
  setImage: () => (setImage),
  setName: () => (setName),
  setVisible: () => (setVisible),
  shortDate: () => (shortDate),
  shortTime: () => (shortTime),
  sortByLabel: () => (sortByLabel),
  sortBySequence: () => (sortBySequence),
  timestamp: () => (timestamp),
  uploadFiles: () => (uploadFiles)
});

// NAMESPACE OBJECT: ./src/participation.ts
var participation_namespaceObject = {};
__webpack_require__.r(participation_namespaceObject);
__webpack_require__.d(participation_namespaceObject, {
  manageParticipation: () => (manageParticipation),
  participationObject: () => (participationObject),
  recordParticipation: () => (recordParticipation),
  renderParticipants: () => (renderParticipants)
});

// NAMESPACE OBJECT: ./src/pad.ts
var pad_namespaceObject = {};
__webpack_require__.r(pad_namespaceObject);
__webpack_require__.d(pad_namespaceObject, {
  getChunks: () => (getChunks),
  lightColorHash: () => (lightColorHash),
  manageParticipation: () => (manageParticipation),
  notepad: () => (notepad),
  notepadToHTML: () => (notepadToHTML),
  participationObject: () => (participationObject),
  recordParticipation: () => (recordParticipation),
  renderParticipants: () => (renderParticipants),
  xmlEncode: () => (xmlEncode)
});

// NAMESPACE OBJECT: ./src/preferences.js
var preferences_namespaceObject = {};
__webpack_require__.r(preferences_namespaceObject);
__webpack_require__.d(preferences_namespaceObject, {
  get: () => (get),
  getPreferencesForClass: () => (getPreferencesForClass),
  recordPersonalDefaults: () => (recordPersonalDefaults),
  recordSharedPreferences: () => (recordSharedPreferences),
  renderPreferencesForm: () => (renderPreferencesForm),
  set: () => (set),
  value: () => (value)
});

// NAMESPACE OBJECT: ./src/tabs.ts
var tabs_namespaceObject = {};
__webpack_require__.r(tabs_namespaceObject);
__webpack_require__.d(tabs_namespaceObject, {
  TabWidgetElement: () => (TabWidgetElement),
  tabWidget: () => (tabWidget)
});

// NAMESPACE OBJECT: ./src/create/types.ts
var types_namespaceObject = {};
__webpack_require__.r(types_namespaceObject);

// EXTERNAL MODULE: ./node_modules/solid-namespace/index.js
var solid_namespace = __webpack_require__(386);
var solid_namespace_default = /*#__PURE__*/__webpack_require__.n(solid_namespace);
// EXTERNAL MODULE: external "$rdf"
var external_$rdf_ = __webpack_require__(264);
;// ./src/ns.js
// Namespaces we commonly use and have common prefixes for around Solid

 // Delegate to this which takes RDFlib as param.

/* harmony default export */ const src_ns = (solid_namespace_default()(external_$rdf_));
;// ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function asyncToGenerator_asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}

// EXTERNAL MODULE: ./node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(756);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: external "SolidLogic"
var external_SolidLogic_ = __webpack_require__(663);
;// ./src/log.ts
// ///////////////////////  Logging
//
// bitmask levels
// const TNONE = 0
/** @internal */
var TERROR = 1;
/** @internal */
var TWARN = 2;
/** @internal */
var TMESG = 4;
/** @internal */
var TSUCCESS = 8;
/** @internal */
var TINFO = 16;
/** @internal */
var TDEBUG = 32;
/** @internal */
var TALL = 63;

/** @internal */
var LogLevel = /*#__PURE__*/function (LogLevel) {
  LogLevel[LogLevel["Error"] = 1] = "Error";
  LogLevel[LogLevel["Warning"] = 2] = "Warning";
  LogLevel[LogLevel["Message"] = 4] = "Message";
  LogLevel[LogLevel["Success"] = 8] = "Success";
  LogLevel[LogLevel["Info"] = 16] = "Info";
  LogLevel[LogLevel["Debug"] = 32] = "Debug";
  LogLevel[LogLevel["All"] = 63] = "All";
  return LogLevel;
}({});

/** @internal */
var _level = TERROR + TWARN + TMESG;
/** @internal */
var _ascending = false;
/** @internal */
var _dom = document; // must be able to override for tests
/** @internal */
var _window = window; // must be able to override for tests

/** @internal */
function log(str) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : TMESG;
  var typestr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'mesg';
  if (!(_level & type)) return; // bitmask

  if (typeof _dom !== 'undefined') {
    var logArea = _dom.getElementById('status');
    if (!logArea) return;
    var addendum = _dom.createElement('span');
    addendum.setAttribute('class', typestr);
    var now = new Date();
    addendum.innerHTML = "".concat(now.getHours(), ":").concat(now.getMinutes(), ":").concat(now.getSeconds(), " [").concat(typestr, "] ").concat(escapeForXML(str), "<br/>");
    if (_ascending) {
      logArea.insertBefore(addendum, logArea.firstChild);
    } else {
      logArea.appendChild(addendum);
    }
  } else if (typeof console !== 'undefined') {
    console.log(str);
  }
}

/**
 * Adds a message to the element with id "status". The messages are prepended with
 * time and type of message, in this case [mesg].
 */
function msg(message) {
  log(message);
}

/**
 * Adds a warning message to the element with id "status". The messages are
 * prepended with time and type of message, in this case [warn].
 */
function warn(message) {
  log(message, TWARN, 'warn');
}

/**
 * Adds a debugging message to the element with id "status". The messages are
 * prepended with time and type of message, in this case [dbug].
 */
function debug(message) {
  log(message, TDEBUG, 'dbug');
}

/**
 * Adds a info message to the element with id "status". The messages are
 * prepended with time and type of message, in this case [info].
 */
function info(message) {
  log(message, TINFO, 'info');
}

/**
 * Adds a error to the element with id "status". The messages are
 * prepended with time and type of message, in this case [eror].
 */
function error(message) {
  log(message, TERROR, 'eror');
}

/**
 * Adds a success message to the element with id "status". The messages are
 * prepended with time and type of message, in this case [good].
 */
function success(message) {
  log(message, TSUCCESS, 'good');
}

/**
 * Uses the global alert to send an alert. If global alert is not available, it
 * will output the message using the method [[warning]]s.
 */
function log_alert(message) {
  if (_window && typeof _window.alert !== 'undefined') {
    _window.alert(message);
  } else {
    warn(message);
  }
}

/**
 * Will clear the content of the element with id "status".
 */
function clear() {
  var _dom2;
  var logArea = (_dom2 = _dom) === null || _dom2 === void 0 ? void 0 : _dom2.getElementById('status');
  if (!logArea) return;
  logArea.innerHTML = '';
}

/**
 * Lets you configure which types of messages will be shown. The module uses
 * [bitmask](https://en.wikipedia.org/wiki/Mask_(computing)) to filter which
 * types of messages should be shown. E.g. if you only want warning messages
 * to be shown, pass 2 to the function, if you want warning and success to be
 * shown, pass 10 (2+8). By passing the sum of all, 63, you'll show all
 * types of messages.
 *
 * - Error: 1
 * - Warning: 2
 * - Message: 4
 * - Success: 8
 * - Info: 16
 * - Debug: 32
 */
function setLevel(level) {
  _level = TALL;
  debug('Log level is now ' + level);
  _level = level;
}

/**
 * Will dump the current HTML using the [[debug]] method.
 */
function dumpHTML() {
  var _dom3;
  if (!_dom) return;
  var level = _level;
  _level = TALL;
  debug(((_dom3 = _dom) === null || _dom3 === void 0 || (_dom3 = _dom3.body) === null || _dom3 === void 0 ? void 0 : _dom3.innerHTML) || '');
  _level = level;
}

/**
 * Will start prepending messages the list of log messages.
 */
function logAscending() {
  _ascending = true;
}

/**
 * Will start appending messages the list of log messages. (This is default
 * behavior.)
 */
function logDescending() {
  _ascending = false;
}

/** @internal */
function escapeForXML(str) {
  // can be replaced with function utils module when migrating
  return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

/** @internal */
function setInternals(window, document) {
  _window = window;
  _dom = document;
}
;// ./src/utils/label.ts



 // pull in first avoid cross-refs

var UI = {
  log: log_namespaceObject,
  ns: src_ns,
  rdf: external_$rdf_
};

// This ubiquitous function returns the best label for a thing
//
// The hacks in this code make a major difference to the usability
function label_label(thing) {
  var initialCap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  function doCap(label) {
    if (initialCap) {
      return label.slice(0, 1).toUpperCase() + label.slice(1);
    }
    return label;
  }
  function cleanUp(label) {
    var result = '';
    if (label.slice(-1) === '/') label = label.slice(0, -1); // chop trailing slash
    for (var i = 0; i < label.length; i++) {
      if (label[i] === '_' || label[i] === '-') {
        result += ' ';
        continue;
      }
      result += label[i];
      if (i + 1 < label.length && label[i].toUpperCase() !== label[i] && label[i + 1].toLowerCase() !== label[i + 1]) {
        result += ' ';
      }
    }
    if (result.slice(0, 4) === 'has ') result = result.slice(4);
    return doCap(result);
  }
  var label = getWellKnownLabel(thing);
  if (label) {
    return doCap(label.value);
  }

  // Default to label just generated from the URI

  if (thing.termType === 'BlankNode') {
    return '...';
  }
  if (thing.termType === 'Collection') {
    return '(' + thing.elements.length + ')';
  }
  var s = thing.uri;
  if (typeof s === 'undefined') return thing.toString(); // can't be a symbol
  // s = decodeURI(s) // This can crash is random valid @ signs are presentation
  // The idea was to clean up eg URIs encoded in query strings
  // Also encoded character in what was filenames like @ [] {}
  try {
    s = s.split('/').map(decodeURIComponent).join('/'); // If it is properly encoded
  } catch (_e) {
    // try individual decoding of ASCII code points
    for (var i = s.length - 3; i > 0; i--) {
      var hex = '0123456789abcefABCDEF'; // The while upacks multiple layers of encoding
      while (s[i] === '%' && hex.indexOf(s[i + 1]) >= 0 && hex.indexOf(s[i + 2]) >= 0) {
        s = s.slice(0, i) + String.fromCharCode(parseInt(s.slice(i + 1, i + 3), 16)) + s.slice(i + 3);
      }
    }
  }
  s = slice(s, '/profile/card#me');
  s = slice(s, '#this');
  s = slice(s, '#me');
  var hash = s.indexOf('#');
  if (hash >= 0) return cleanUp(s.slice(hash + 1));

  // Eh? Why not do this? e.g. dc:title needs it only trim URIs, not rdfs:labels
  var slash = s.lastIndexOf('/', s.length - 2); // (len-2) excludes trailing slash
  if (slash >= 0 && slash < thing.uri.length) return cleanUp(s.slice(slash + 1));
  return doCap(decodeURIComponent(thing.uri));
}
function slice(s, suffix) {
  var length = suffix.length * -1;
  if (s.slice(length) === suffix) {
    return s.slice(0, length);
  }
  return s;
}

// Hard coded known label predicates
//  @@ TBD: Add subproperties of rdfs:label
function getWellKnownLabel(thing) {
  return external_SolidLogic_.store.any(thing, UI.ns.ui('label')) ||
  // Prioritize ui:label
  external_SolidLogic_.store.any(thing, UI.ns.link('message')) || external_SolidLogic_.store.any(thing, UI.ns.vcard('fn')) || external_SolidLogic_.store.any(thing, UI.ns.foaf('name')) || external_SolidLogic_.store.any(thing, UI.ns.dct('title')) || external_SolidLogic_.store.any(thing, UI.ns.dc('title')) || external_SolidLogic_.store.any(thing, UI.ns.rss('title')) || external_SolidLogic_.store.any(thing, UI.ns.contact('fullName')) || external_SolidLogic_.store.any(thing, external_SolidLogic_.store.sym('http://www.w3.org/2001/04/roadmap/org#name')) || external_SolidLogic_.store.any(thing, UI.ns.cal('summary')) || external_SolidLogic_.store.any(thing, UI.ns.foaf('nick')) || external_SolidLogic_.store.any(thing, UI.ns.as('name')) || external_SolidLogic_.store.any(thing, UI.ns.schema('name')) || external_SolidLogic_.store.any(thing, UI.ns.rdfs('label')) || external_SolidLogic_.store.any(thing, external_SolidLogic_.store.sym('http://www.w3.org/2004/02/skos/core#prefLabel'));
}
// EXTERNAL MODULE: ./src/debug.ts
var src_debug = __webpack_require__(423);
;// ./src/acl/acl.ts


/**
 * Non-UI functions for access control.
 * See https://github.com/solidos/web-access-control-spec
 * for the spec that defines how ACL documents work.
 * @packageDocumentation
 */






var kb = external_SolidLogic_.solidLogicSingleton.store;

/**
 * Take the "default" ACL and convert it into the equivalent ACL
 * which the resource would have had. Return it as a new separate store.
 * The "defaultForNew" predicate is also accepted, as a deprecated
 * synonym for "default".
 */
function adoptACLDefault(doc, aclDoc, defaultResource, defaultACLDoc) {
  var ACL = src_ns.acl;
  var isContainer = doc.uri.slice(-1) === '/'; // Give default for all directories

  var defaults = kb.each(undefined, ACL('default'), defaultResource, defaultACLDoc).concat(kb.each(undefined, ACL('defaultForNew'), defaultResource, defaultACLDoc));
  var proposed = defaults.reduce(function (accumulatedStatements, da) {
    return accumulatedStatements.concat(kb.statementsMatching(da, src_ns.rdf('type'), ACL('Authorization'), defaultACLDoc)).concat(kb.statementsMatching(da, ACL('agent'), undefined, defaultACLDoc)).concat(kb.statementsMatching(da, ACL('agentClass'), undefined, defaultACLDoc)).concat(kb.statementsMatching(da, ACL('agentGroup'), undefined, defaultACLDoc)).concat(kb.statementsMatching(da, ACL('origin'), undefined, defaultACLDoc)).concat(kb.statementsMatching(da, ACL('originClass'), undefined, defaultACLDoc)).concat(kb.statementsMatching(da, ACL('mode'), undefined, defaultACLDoc)).concat((0,external_$rdf_.st)(da, ACL('accessTo'), doc, defaultACLDoc)).concat(isContainer ? (0,external_$rdf_.st)(da, ACL('default'), doc, defaultACLDoc) : []);
  }, []);
  var kb2 = (0,external_$rdf_.graph)(); // Potential - derived is kept apart
  proposed.forEach(function (st) {
    return kb2.add(move(st.subject), move(st.predicate), move(st.object), (0,external_$rdf_.sym)(aclDoc.uri));
  });
  return kb2;
  function move(symbol) {
    var y = defaultACLDoc.uri.length; // The default ACL file
    return (0,external_$rdf_.sym)(symbol.uri.slice(0, y) === defaultACLDoc.uri ? aclDoc.uri + symbol.uri.slice(y) : symbol.uri);
  }
}

/**
 * Read and canonicalize the ACL for x in aclDoc
 *
 * Accumulate the access rights which each agent or class has
 */
function readACL(doc, aclDoc) {
  var kb2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : kb;
  var getDefaults = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var auths = getDefaults ? getDefaultsFallback(kb2, src_ns) : kb2.each(undefined, src_ns.acl('accessTo'), doc);
  var ACL = src_ns.acl;
  var ac = {
    agent: {},
    agentClass: {},
    agentGroup: {},
    origin: {},
    originClass: {}
  };
  Object.keys(ac).forEach(function (pred) {
    auths.forEach(function (a) {
      kb2.each(a, ACL('mode')).forEach(function (mode) {
        kb2.each(a, ACL(pred)).forEach(function (agent) {
          ac[pred][agent.uri] = ac[pred][agent.uri] || {};
          ac[pred][agent.uri][mode.uri] = a; // could be "true" but leave pointer just in case
        });
      });
    });
  });
  return ac;
  function getDefaultsFallback(kb, ns) {
    return kb.each(undefined, ns.acl('default'), doc).concat(kb.each(undefined, ns.acl('defaultForNew'), doc));
  }
}

/**
 * Compare two ACLs
 */
function sameACL(a, b) {
  var contains = function contains(a, b) {
    for (var pred in {
      agent: true,
      agentClass: true,
      agentGroup: true,
      origin: true,
      originClass: true
    }) {
      if (a[pred]) {
        for (var agent in a[pred]) {
          for (var mode in a[pred][agent]) {
            if (!b[pred][agent] || !b[pred][agent][mode]) {
              return false;
            }
          }
        }
      }
    }
    return true;
  };
  return contains(a, b) && contains(b, a);
}

/**
 * Union N ACLs
 */
function ACLunion(list) {
  var b = list[0];
  var a, ag;
  var _loop = function _loop(k) {
    ;
    ['agent', 'agentClass', 'agentGroup', 'origin', 'originClass'].forEach(function (pred) {
      a = list[k];
      if (a[pred]) {
        for (ag in a[pred]) {
          for (var mode in a[pred][ag]) {
            if (!b[pred][ag]) b[pred][ag] = [];
            b[pred][ag][mode] = true;
          }
        }
      }
    });
  };
  for (var k = 1; k < list.length; k++) {
    _loop(k);
  }
  return b;
}
/**
 * Merge ACLs lists from things to form union
 */
function loadUnionACL(subjectList, callbackFunction) {
  var aclList = [];
  var _doList = function doList(list) {
    if (list.length) {
      var doc = list.shift().doc();
      getACLorDefault(doc, function (ok, p2, targetDoc, targetACLDoc, defaultHolder, defaultACLDoc) {
        var defa = !p2;
        if (!ok || !defaultHolder || !defaultACLDoc) return callbackFunction(ok, targetACLDoc);
        var acl = defa ? readACL(defaultHolder, defaultACLDoc) : readACL(targetDoc, targetACLDoc);
        aclList.push(acl);
        _doList(list.slice(1));
      });
    } else {
      // all gone
      callbackFunction(true, ACLunion(aclList));
    }
  };
  _doList(subjectList);
}

/**
 * Represents these as an RDF graph by combination of modes
 *
 * Each agent can only be in one place in this model, one combination of modes.
 * Combos are like full control, read append, read only etc.
 */
function ACLbyCombination(ac) {
  var byCombo = {};
  ['agent', 'agentClass', 'agentGroup', 'origin', 'originClass'].forEach(function (pred) {
    for (var agent in ac[pred]) {
      var combo = [];
      for (var mode in ac[pred][agent]) {
        combo.push(mode);
      }
      combo.sort();
      var combo2 = combo.join('\n');
      if (!byCombo[combo2]) byCombo[combo2] = [];
      byCombo[combo2].push([pred, agent]);
    }
  });
  return byCombo;
}

/**
 * Write ACL graph to store from AC
 */
function makeACLGraph(kb, x, ac, aclDoc) {
  var byCombo = ACLbyCombination(ac);
  return makeACLGraphbyCombo(kb, x, byCombo, aclDoc);
}

/**
 * Write ACL graph to store from combo
 */
function makeACLGraphbyCombo(kb, x, byCombo, aclDoc, main, defa) {
  var ACL = src_ns.acl;
  for (var combo in byCombo) {
    var pairs = byCombo[combo];
    if (!pairs.length) continue; // do not add to store when no agent
    var modeURIs = combo.split('\n');
    var _short = modeURIs.map(function (u) {
      return u.split('#')[1];
    }).join('');
    if (defa && !main) _short += 'Default'; // don't muddle authorizations
    var a = kb.sym(aclDoc.uri + '#' + _short);
    kb.add(a, src_ns.rdf('type'), ACL('Authorization'), aclDoc);
    if (main) {
      kb.add(a, ACL('accessTo'), x, aclDoc);
    }
    if (defa) {
      kb.add(a, ACL('default'), x, aclDoc);
    }
    for (var i = 0; i < modeURIs.length; i++) {
      kb.add(a, ACL('mode'), kb.sym(modeURIs[i]), aclDoc);
    }
    for (var _i = 0; _i < pairs.length; _i++) {
      var pred = pairs[_i][0];
      var ag = pairs[_i][1];
      kb.add(a, ACL(pred), kb.sym(ag), aclDoc);
    }
  }
}

/**
 * Debugging short strings for dumping ACL
 * and possibly in the UI
 */
function ACLToString(ac) {
  return comboToString(ACLbyCombination(ac));
}

/**
 * Convert a [[ComboList]] to a string
 */
function comboToString(byCombo) {
  var str = '';
  for (var combo in byCombo) {
    var modeURIs = combo.split('\n');
    var initials = modeURIs.map(function (u) {
      return u.split('#')[1][0];
    }).join('');
    str += initials + ':';
    var pairs = byCombo[combo];
    for (var i = 0; i < pairs.length; i++) {
      var pred = pairs[i][0];
      var ag = (0,external_$rdf_.sym)(pairs[i][1]);
      str += pred === 'agent' ? '@' : '';
      str += ag.sameTerm(src_ns.foaf('Agent')) ? '*' : label_label(ag);
      if (i < pairs.length - 1) str += ',';
    }
    str += ';';
  }
  return '{' + str.slice(0, -1) + '}'; // drop extra semicolon
}

/**
 * Write ACL graph as Turtle
 */
function makeACLString(x, ac, aclDoc) {
  var kb2 = (0,external_$rdf_.graph)();
  makeACLGraph(kb2, x, ac, aclDoc);
  return (0,external_$rdf_.serialize)(aclDoc, kb2, aclDoc.uri, 'text/turtle') || '';
}

/**
 * Write ACL graph to web
 */
function putACLObject(kb, x, ac, aclDoc, callbackFunction) {
  var byCombo = ACLbyCombination(ac);
  return putACLbyCombo(kb, x, byCombo, aclDoc, callbackFunction);
}

/**
 * Write ACL graph to web from a [[ComboList]]
 */
function putACLbyCombo(kb, x, byCombo, aclDoc, callbackFunction) {
  var _kb$updater;
  var kb2 = (0,external_$rdf_.graph)();
  makeACLGraphbyCombo(kb2, x, byCombo, aclDoc, true);

  // const str = makeACLString = function(x, ac, aclDoc)
  (_kb$updater = kb.updater) === null || _kb$updater === void 0 || _kb$updater.put(aclDoc, kb2.statementsMatching(undefined, undefined, undefined, aclDoc), 'text/turtle', function (uri, ok, message) {
    if (!ok) {
      callbackFunction(ok, message);
    } else {
      var _kb$fetcher;
      (_kb$fetcher = kb.fetcher) === null || _kb$fetcher === void 0 || _kb$fetcher.unload(aclDoc);
      makeACLGraphbyCombo(kb, x, byCombo, aclDoc, true);
      kb.fetcher.requested[aclDoc.uri] = 'done'; // missing: save headers
      callbackFunction(ok);
    }
  });
}
/**
 * Fix the ACl for an individual card as a function of the groups it is in
 *
 * All group files must be loaded first
 */
function fixIndividualCardACL(person, log, callbackFunction) {
  var groups = kb.each(undefined, src_ns.vcard('hasMember'), person);
  // const doc = person.doc()
  if (groups) {
    fixIndividualACL(person, groups, log, callbackFunction);
  } else {
    log('This card is in no groups');
    callbackFunction(true); // fine, no requirements to access. default should be ok
  }
  // @@ if no groups, then use default for People container or the book top container.?
}

/**
 * This function is used by [[fixIndividualCardACL]]
 */
function fixIndividualACL(item, subjects, log, callbackFunction) {
  log = log || src_debug/* log */.Rm;
  var doc = item.doc();
  getACLorDefault(doc, function (ok, exists, targetDoc, targetACLDoc, defaultHolder, defaultACLDoc) {
    if (!ok || !defaultHolder || !defaultACLDoc) return callbackFunction(false, targetACLDoc); // ie message
    var ac = exists ? readACL(targetDoc, targetACLDoc) : readACL(defaultHolder, defaultACLDoc);
    loadUnionACL(subjects, function (ok, union) {
      if (!ok) return callbackFunction(false, union);
      if (sameACL(union, ac)) {
        log('Nice - same ACL. no change ' + label_label(item) + ' ' + doc);
      } else {
        log('Group ACLs differ for ' + label_label(item) + ' ' + doc);

        // log("Group ACLs: " + makeACLString(targetDoc, union, targetACLDoc))
        // log((exists ? "Previous set" : "Default") + " ACLs: " +
        // makeACLString(targetDoc, ac, targetACLDoc))

        putACLObject(kb, targetDoc, union, targetACLDoc, callbackFunction);
      }
    });
  });
}

/**
 * Set an ACL
 */
function setACL(docURI, aclText, callbackFunction) {
  var aclDoc = kb.any(docURI, external_SolidLogic_.ACL_LINK); // @@ check that this get set by web.js
  if (!kb.fetcher) {
    throw new Error('Store has no fetcher');
  }
  if (aclDoc) {
    // Great we already know where it is
    kb.fetcher.webOperation('PUT', aclDoc.value, {
      data: aclText,
      contentType: 'text/turtle'
    }).then(function (res) {
      callbackFunction(res.ok, res.error || '');
    }); // @@@ check params
  } else {
    kb.fetcher.nowOrWhenFetched(docURI, undefined, function (ok, body) {
      if (!ok) return callbackFunction(ok, 'Gettting headers for ACL: ' + body);
      var aclDoc = kb.any(docURI, external_SolidLogic_.ACL_LINK); // @@ check that this get set by web.js
      if (!aclDoc) {
        // complainIfBad(false, "No Link rel=ACL header for " + docURI)
        callbackFunction(false, 'No Link rel=ACL header for ' + docURI);
      } else {
        if (!kb.fetcher) {
          throw new Error('Store has no fetcher');
        }
        kb.fetcher.webOperation('PUT', aclDoc.value, {
          data: aclText,
          contentType: 'text/turtle'
        }).then(function (res) {
          callbackFunction(res.ok, res.error || '');
        });
      }
    });
  }
}

/**
 * Get ACL file or default if necessary
 *
 * @param callbackFunction  Will be called in the following ways, in the following cases:
 * * `callbackFunction(true, true, doc, aclDoc)` if the ACL did exist
 * * `callbackFunction(true, false, doc, aclDoc, defaultHolder, defaultACLDoc)` if the ACL file did not exist but a default did
 * * `callbackFunction(false, false, status, message)` when there was an error getting the original
 * * `callbackFunction(false, true, status, message)` when there was an error getting the default
 */
function getACLorDefault(doc, callbackFunction) {
  getACL(doc, function (ok, status, aclDoc, message) {
    var ACL = src_ns.acl;
    if (!ok) return callbackFunction(false, false, status, message);

    // Recursively search for the ACL file which gives default access
    var _tryParent = function tryParent(uri) {
      if (uri.slice(-1) === '/') {
        uri = uri.slice(0, -1);
      }
      var right = uri.lastIndexOf('/');
      var left = uri.indexOf('/', uri.indexOf('//') + 2);
      if (left > right) {
        return callbackFunction(false, true, 404, 'Found no ACL resource');
      }
      uri = uri.slice(0, right + 1);
      var doc2 = (0,external_$rdf_.sym)(uri);
      getACL(doc2, function (ok, status, defaultACLDoc) {
        if (!ok) {
          return callbackFunction(false, true, status, "( No ACL pointer ".concat(uri, " ").concat(status, ")").concat(defaultACLDoc));
        } else if (status === 403) {
          return callbackFunction(false, true, status, "( default ACL file FORBIDDEN. Stop.".concat(uri, ")"));
        } else if (status === 404) {
          return _tryParent(uri);
        } else if (status !== 200) {
          return callbackFunction(false, true, status, "Error status '".concat(status, "' searching for default for ").concat(doc2));
        }
        // 200
        // statusBlock.textContent += (" ACCESS set at " + uri + ". End search.")
        var defaults = kb.each(undefined, ACL('default'), kb.sym(uri), defaultACLDoc).concat(kb.each(undefined, ACL('defaultForNew'), kb.sym(uri), defaultACLDoc));
        if (!defaults.length) {
          return _tryParent(uri); // Keep searching
        }
        var defaultHolder = kb.sym(uri);
        return callbackFunction(true, false, doc, aclDoc, defaultHolder, defaultACLDoc);
      });
    }; // tryParent

    if (!ok) {
      return callbackFunction(false, false, status, "Error accessing Access Control information for ".concat(doc, ") ").concat(message));
    } else if (status === 404) {
      _tryParent(doc.uri); //  @@ construct default one - the server should do that
    } else if (status === 403) {
      return callbackFunction(false, false, status, "(Sharing not available to you)".concat(message));
    } else if (status !== 200) {
      return callbackFunction(false, false, status, "Error ".concat(status, " accessing Access Control information for ").concat(doc, ": ").concat(message));
    } else {
      // 200
      return callbackFunction(true, true, doc, aclDoc);
    }
  }); // Call to getACL
}

/**
 * Calls back `(ok, status, acldoc, message)` as follows
 *
 * * `(false, 900, errormessage)` if no link header
 * * `(true, 403, documentSymbol, fileaccesserror)` if not authorized
 * * `(true, 404, documentSymbol, fileaccesserror)` if does not exist
 * * `(true, 200, documentSymbol)` if file exists and read OK
 */
function getACL(doc, callbackFunction) {
  if (!kb.fetcher) {
    throw new Error('kb has no fetcher');
  }
  kb.fetcher.nowOrWhenFetched(doc, undefined, function (ok, body) {
    if (!ok) {
      return callbackFunction(ok, "Can't get headers to find ACL for ".concat(doc, ": ").concat(body));
    }
    var aclDoc = kb.any(doc, external_SolidLogic_.ACL_LINK); // @@ check that this get set by web.js
    if (!aclDoc) {
      callbackFunction(false, 900, "No Link rel=ACL header for ".concat(doc));
    } else {
      if (!kb.fetcher) {
        throw new Error('kb has no fetcher');
      }
      if (kb.fetcher.nonexistent[aclDoc.value]) {
        return callbackFunction(true, 404, aclDoc, "ACL file ".concat(aclDoc, " does not exist."));
      }
      kb.fetcher.nowOrWhenFetched(aclDoc, undefined, function (ok, message, response) {
        if (!ok) {
          callbackFunction(true, response.status, aclDoc, "Can't read Access Control File ".concat(aclDoc, ": ").concat(message));
        } else {
          callbackFunction(true, 200, aclDoc);
        }
      });
    }
  });
}

/**
 * Calls [[getACLorDefault]] and then (?)
 */
function getProspectiveHolder(_x) {
  return _getProspectiveHolder.apply(this, arguments);
}
function _getProspectiveHolder() {
  _getProspectiveHolder = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee(targetDirectory) {
    return regenerator_default().wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", new Promise(function (resolve, reject) {
            return getACLorDefault((0,external_$rdf_.sym)(targetDirectory), function (ok, isDirectACL, targetDoc, targetACLDoc, defaultHolder) {
              if (ok) {
                return resolve(isDirectACL ? targetDoc : defaultHolder);
              }
              return reject(new Error("Error loading ".concat(targetDirectory)));
            });
          }));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getProspectiveHolder.apply(this, arguments);
}
;// ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
function classCallCheck_classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

;// ./node_modules/@babel/runtime/helpers/esm/typeof.js
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

;// ./node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

;// ./node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}

;// ./node_modules/@babel/runtime/helpers/esm/createClass.js

function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, toPropertyKey(o.key), o);
  }
}
function createClass_createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}

;// ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}

;// ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}

;// ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}

;// ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js

function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

;// ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

;// ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}

// EXTERNAL MODULE: ./node_modules/mime-types/index.js
var mime_types = __webpack_require__(49);
;// ./src/styleConstants.js
/* harmony default export */ const styleConstants = ({
  highlightColor: '#7C4DFF',
  // Solid lavender https://design.inrupt.com/atomic-core/?cat=Core

  formBorderColor: '#888888',
  // Mid-grey
  formHeadingColor: '#888888',
  // originally was brown; now grey
  lowProfileLinkColor: '#3B5998',
  // Grey-blue, e.g., for field labels linking to ontology
  formFieldNameBoxWidth: '8em',
  // The fixed amount to get form fields to line up
  // We put in the latter when switching away from using tables.  However, getting
  // alignment between fields in different groups is a hard problem.

  mediaModuleCanvasWidth: '640',
  mediaModuleCanvasHeight: '480',
  textInputSize: 20,
  // Rough default text input size, in characters
  tabBorderRadius: '0.2em',
  textInputBackgroundColor: '#eef',
  textInputBackgroundColorUneditable: '#fff',
  textInputColor: '#000',
  textInputColorPending: '#888',
  defaultErrorBackgroundColor: '#fee',
  participationDefaultBackground: 'white',
  basicMaxLength: '4096'
});
;// ./src/style.js
// Common readable consistent stylesheet
// to avoid using style sheets which are document-global
// and make programmable style toggling with selection, drag over, etc easier
// These must all end with semicolon so they can be appended to.


var style = {
  // styleModule

  checkboxStyle: 'color: black; font-size: 100%; padding-left: 0.5 em; padding-right: 0.5 em;',
  checkboxInputStyle: 'font-size: 150%; height: 1.2em; width: 1.2em; background-color: #eef; border-radius:0.2em; margin: 0.1em;',
  fieldLabelStyle: 'color: #3B5998; text-decoration: none;',
  formSelectStyle: 'background-color: #eef; padding: 0.5em;  border: .05em solid #88c; border-radius:0.2em; font-size: 100%; margin:0.4em;',
  textInputStyle: 'background-color: #eef; padding: 0.5em;  border: .05em solid #88c; border-radius:0.2em; font-size: 100%; margin:0.4em;',
  textInputStyleUneditable:
  // Color difference only
  'background-color: white; padding: 0.5em;  border: .05em solid white; border-radius:0.2em; font-size: 100%; margin:0.4em;',
  buttonStyle: 'background-color: #fff; padding: 0.7em;  border: .01em solid white; border-radius:0.2em; font-size: 100%; margin: 0.3em;',
  // 'background-color: #eef;
  commentStyle: 'padding: 0.7em;  border: none; font-size: 100%; white-space: pre-wrap;',
  iconStyle: 'width: 3em; height: 3em; margin: 0.1em; border-radius: 1em;',
  smallButtonStyle: 'margin: 0.2em; width: 1em; height:1em;',
  classIconStyle: 'width: 3em; height: 3em; margin: 0.1em; border-radius: 0.2em; border: 0.1em solid green; padding: 0.2em; background-color: #efe;',
  // combine with buttonStyle
  confirmPopupStyle: 'padding: 0.7em; border-radius: 0.2em; border: 0.1em solid orange; background-color: white; box-shadow: 0.5em 0.9em #888;',
  messageBodyStyle: 'white-space: pre-wrap; width: 99%; font-size:100%; border: 0.07em solid #eee; border-radius:0.2em; padding: .3em 0.5em; margin: 0.1em;',
  pendingeditModifier: 'color: #bbb;',
  // Contacts
  personaBarStyle: 'width: 100%; height: 4em; background-color: #eee; vertical-align: middle;',
  searchInputStyle: 'border: 0.1em solid #444; border-radius: 0.2em; width: 100%; font-size: 100%; padding: 0.1em 0.6em; margin 0.2em;',
  autocompleteRowStyle: 'border: 0.2em solid straw;',
  // Login buttons
  signInAndUpButtonStyle: 'padding: 1em; border-radius:0.2em; font-size: 100%;',
  // was 0.5em radius
  headerBannerLoginInput: 'margin: 0.75em 0 0.75em 0.5em !important; padding: 0.5em !important;',
  signUpBackground: 'background-color: #eef;',
  signInBackground: 'background-color: #efe;',
  // Forms
  heading1Style: 'font-size: 180%; font-weight: bold; color: #888888; padding: 0.5em; margin: 0.7em 0.0m;',
  // originally was brown; now grey
  heading2Style: 'font-size: 130%; font-weight: bold; color: #888888; padding: 0.4em; margin: 0.7em 0.0em;',
  // originally was brown; now grey
  heading3Style: 'font-size: 120%; font-weight: bold; color: #888888; padding: 0.3em; margin: 0.7em 0.0em;',
  // For example, in large forms or before a small form
  heading4Style: 'font-size: 110%; font-weight: bold; color: #888888; padding: 0.2em; margin: 0.7em 0.0em;',
  // Lowest level used by default in small things

  formHeadingStyle: 'font-size: 110%; font-weight: bold; color: #888888; padding: 0.2em;  margin: 0.7em 0.0em;',
  // originally was brown; now grey
  formTextInput: 'font-size: 100%; margin: 0.1em; padding: 0.1em;',
  // originally used this
  formGroupStyle: ["padding-left: 0em; border: 0.0em solid ".concat(styleConstants.formBorderColor, "; border-radius: 0.2em;"), // weight 0
  "padding-left: 2em; border: 0.05em solid ".concat(styleConstants.formBorderColor, "; border-radius: 0.2em;"), "padding-left: 2em; border: 0.1em solid ".concat(styleConstants.formBorderColor, "; border-radius: 0.2em;"), "padding-left: 2em; border: 0.2em solid ".concat(styleConstants.formBorderColor, "; border-radius: 0.2em;") // @@ pink
  ],
  formFieldLabelStyle: "color: ".concat(styleConstants.lowProfileLinkColor, "; text-decoration: none;"),
  formFieldNameBoxStyle: "padding: 0.3em; vertical-align: middle; width:".concat(styleConstants.formFieldNameBoxWidth, ";"),
  multilineTextInputStyle: 'font-size:100%; white-space: pre-wrap; background-color: #eef;' + ' border: 0.07em solid gray; padding: 1em 0.5em; margin: 1em 1em;',
  // Buttons
  renderAsDivStyle: 'display: flex; align-items: center; justify-content: space-between; height: 2.5em; padding: 1em;',
  imageDivStyle: 'width:2.5em; padding:0.5em; height: 2.5em;',
  linkDivStyle: 'width:2em; padding:0.5em; height: 4em;',
  // ACL
  aclControlBoxContainer: 'margin: 1em;',
  aclControlBoxHeader: 'font-size: 120%; margin: 0 0 1rem;',
  aclControlBoxStatus: 'display: none; margin: 1rem 0;',
  aclControlBoxStatusRevealed: 'display: block;',
  aclGroupContent: 'maxWidth: 650;',
  accessGroupList: 'display: grid; grid-template-columns: 1fr; margin: 1em; width: 100%;',
  accessGroupListItem: 'display: grid; grid-template-columns: 100px auto 30%;',
  defaultsController: 'display: flex;',
  defaultsControllerNotice: 'color: #888; flexGrow: 1; fontSize: 80%;',
  bigButton: 'background-color: white; border: 0.1em solid #888; border-radius: 0.3em; max-width: 50%; padding-bottom: 1em; padding-top: 1em;',
  group: 'color: #888;',
  group1: 'color: green;',
  group2: 'color: #cc0;',
  group3: 'color: orange;',
  group5: 'color: red;',
  group9: 'color: blue;',
  group13: 'color: purple;',
  trustedAppAddApplicationsTable: 'background-color: #eee;',
  trustedAppCancelButton: 'float: right;',
  trustedAppControllerI: 'border-color: orange; border-radius: 1em; border-width: 0.1em;',
  temporaryStatusInit: 'background: green;',
  temporaryStatusEnd: 'background: transparent; transition: background 5s linear;',
  // header
  headerUserMenuLink: 'background: none; border: 0; color: black; cursor: pointer; display: block; font-family: Arial; font-size: 1em; text-align: left; padding: 1em;  width: 100%; text-decoration: none;',
  headerUserMenuLinkHover: 'background: none; border: 0; color: black; cursor: pointer; display: block; font-family: Arial; font-size: 1em; text-align: left; padding: 1em;  width: 100%; text-decoration: none; background-image: linear-gradient(to right, #7C4DFF 0%, #18A9E6 50%, #01C9EA 100%);',
  headerUserMenuTrigger: 'background: none; border: 0; cursor: pointer; width: 60px; height: 60px;',
  headerUserMenuTriggerImg: 'border-radius: 50%; height: 56px; width: 28px !important;',
  headerUserMenuButton: 'background: none; border: 0; color: black; cursor: pointer; display: block; font-family: Arial; font-size: 1em; text-align: left; padding: 1em; width: 100%;',
  headerUserMenuButtonHover: 'background: none; border: 0; color: black; cursor: pointer; display: block; font-family: Arial; font-size: 1em; text-align: left; padding: 1em; width: 100%; background-image: linear-gradient(to right, #7C4DFF 0%, #18A9E6 50%, #01C9EA 100%);',
  headerUserMenuList: 'list-style: none; margin: 0; padding: 0;',
  headerUserMenuListDisplay: 'list-style: none; margin: 0; padding: 0; display:true;',
  headerUserMenuNavigationMenu: 'background: white; border: solid 1px #000000; border-right: 0; position: absolute; right: 0; top: 60px; width: 200px; z-index: 1; display: true;',
  headerUserMenuNavigationMenuNotDisplayed: 'background: white; border: solid 1px #000000; border-right: 0; position: absolute; right: 0; top: 60px; width: 200px; z-index: 1; display: none;',
  headerUserMenuListItem: 'border-bottom: solid 1px #000000;',
  headerUserMenuPhoto: 'border-radius: 50%; background-position: center; background-repeat: no-repeat; background-size: cover; height: 50px; width: 50px;',
  headerBanner: 'box-shadow: 0px 1px 4px #000000; display: flex; justify-content: space-between; padding: 0 1.5em; margin-bottom: 4px;',
  headerBannerLink: 'display: block;',
  headerBannerRightMenu: 'display: flex;',
  headerBannerLogin: 'margin-left: auto;',
  allChildrenVisible: 'display:true;',
  headerBannerUserMenu: 'border-left: solid 1px #000000; margin-left: auto;',
  headerBannerHelpMenu: 'border-left: solid 1px #000000; margin-left: auto;',
  headerBannerIcon: 'background-size: 65px 60px !important; height: 60px !important; width: 65px !important;',
  // may just be 65px round($icon-size * 352 / 322);

  // footer
  footer: 'border-top: solid 1px $divider-color; font-size: 0.9em; padding: 0.5em 1.5em;',
  // buttons
  primaryButton: 'background-color: #7c4dff; color: #ffffff; font-family: Raleway, Roboto, sans-serif; border-radius: 0.25em; border-color: #7c4dff; border: 1px solid; cursor: pointer; font-size: .8em; text-decoration: none; padding: 0.5em 4em; transition: 0.25s all ease-in-out; outline: none;',
  primaryButtonHover: 'background-color: #9f7dff; color: #ffffff; font-family: Raleway, Roboto, sans-serif;border-radius: 0.25em; border-color: #7c4dff; border: 1px solid; cursor: pointer; font-size: .8em; text-decoration: none; padding: 0.5em 4em; transition: 0.25s all ease-in-out; outline: none; transition: 0.25s all ease-in-out;',
  primaryButtonNoBorder: 'background-color: #ffffff; color: #7c4dff; font-family: Raleway, Roboto, sans-serif;border-radius: 0.25em; border-color: #7c4dff; border: 1px solid; cursor: pointer; font-size: .8em; text-decoration: none; padding: 0.5em 4em; transition: 0.25s all ease-in-out; outline: none;',
  primaryButtonNoBorderHover: 'background-color: #7c4dff; color: #ffffff; font-family: Raleway, Roboto, sans-serif; border-radius: 0.25em; border-color: #7c4dff; border: 1px solid; cursor: pointer; font-size: .8em; text-decoration: none; padding: 0.5em 4em; transition: 0.25s all ease-in-out; outline: none; transition: 0.25s all ease-in-out;',
  secondaryButton: 'background-color: #01c9ea; color: #ffffff; font-family: Raleway, Roboto, sans-serif;border-radius: 0.25em; border-color: #01c9ea; border: 1px solid; cursor: pointer; font-size: .8em; text-decoration: none; padding: 0.5em 4em; transition: 0.25s all ease-in-out; outline: none;',
  secondaryButtonHover: 'background-color: #37cde6; color: #ffffff; font-family: Raleway, Roboto, sans-serif;border-radius: 0.25em; border-color: #7c4dff; border: 1px solid; cursor: pointer; font-size: .8em; text-decoration: none; padding: 0.5em 4em; transition: 0.25s all ease-in-out; outline: none; transition: 0.25s all ease-in-out;',
  secondaryButtonNoBorder: 'background-color: #ffffff; color: #01c9ea; font-family: Raleway, Roboto, sans-serif; border-radius: 0.25em; border-color: #01c9ea; border: 1px solid; cursor: pointer; font-size: .8em; text-decoration: none; padding: 0.5em 4em; transition: 0.25s all ease-in-out; outline: none;',
  secondaryButtonNoBorderHover: 'background-color: #01c9ea; color: #ffffff; font-family: Raleway, Roboto, sans-serif; border-radius: 0.25em; border-color: #01c9ea; border: 1px solid; cursor: pointer; font-size: .8em; text-decoration: none; padding: 0.5em 4em; transition: 0.25s all ease-in-out; outline: none; transition: 0.25s all ease-in-out;',
  // media
  controlStyle: "border-radius: 0.5em; margin: 0.8em; width:".concat(styleConstants.mediaModuleCanvasWidth, "; height:").concat(styleConstants.mediaModuleCanvasHeight, ";"),
  // dragAndDrop
  dragEvent: 'background-color: #ccc; border: 0.25em dashed black; border-radius: 0.3em;',
  dropEvent: 'background-color: white; border: 0em solid black;',
  restoreStyle: 'background-color: white;',
  // errors
  errorCancelButton: 'width: 2em; height: 2em; align: right;',
  errorMessageBlockStyle: 'margin: 0.1em; padding: 0.5em; border: 0.05em solid gray; color:black;',
  // pad
  notepadStyle: 'padding: 1em; overflow: auto; resize: horizontal; min-width: 40em;',
  upstreamStatus: 'width: 50%;',
  downstreamStatus: 'width: 50%;',
  baseStyle: 'font-size: 100%; font-family: monospace; width: 100%; border: none; white-space: pre-wrap;',
  headingCore: 'font-family: sans-serif; font-weight: bold;  border: none;',
  headingStyle: ['font-size: 110%; padding-top: 0.5em; padding-bottom: 0.5em; width: 100%;', 'font-size: 120%; padding-top: 1em; padding-bottom: 1em; width: 100%;', 'font-size: 150%; padding-top: 1em; padding-bottom: 1em; width: 100%;'],
  // participation
  participantsStyle: 'margin: 0.8em;',
  participantsBlock: 'height: 1.5em; width: 1.5em; margin: 0.3em; border 0.01em solid #888;',
  personTableTD: 'vertical-align: middle;',
  // tabs
  tabsNavElement: 'margin: 0;',
  tabsRootElement: 'display: flex; height: 100%; width: 100%;',
  tabsMainElement: 'margin: 0; width:100%; height: 100%;',
  tabContainer: 'list-style-type: none; display: flex; height: 100%; width: 100%; margin: 0; padding: 0;',
  makeNewSlot: 'background: none; border: none; font: inherit; cursor: pointer;',
  ellipsis: 'position: absolute; right: 0; bottom: 0; width: 20%; background: none; color: inherit; border: none; padding: 0; font: inherit; cursor: pointer; outline: inherit;'
};
style.setStyle = function setStyle(ele, styleName) {
  ele.style = style[styleName];
};
;// ./src/widgets/dragAndDrop.js
/* Drag and drop common functionality
 *
 * It is easy to make something draggable, or to make it a drag target!
 * Just call the functions below. In a Solid world, any part of the UI which
 * represents one thing which has a URI, should be made draggable using makeDraggable.
 * Any list of things should typically allow you to drag new members of the list
 * onto it.
 * The file upload function, uploadFiles, is provided as often as someone drags a file from the computer
 * desktop. You may want to upload it into the pod.
 */




/* global FileReader alert */

function makeDropTarget(ele, droppedURIHandler, droppedFileHandler) {
  var dragoverListener = function dragoverListener(e) {
    e.preventDefault(); // Need this; otherwise, drop does not work.
    e.dataTransfer.dropEffect = 'copy';
  };
  var dragenterListener = function dragenterListener(e) {
    src_debug/* log */.Rm('dragenter event dropEffect: ' + e.dataTransfer.dropEffect);
    if (this.localStyle) {
      //  necessary not sure when
      if (!this.savedStyle) {
        this.savedStyle = style.dragEvent;
      }
    }
    e.dataTransfer.dropEffect = 'link';
    src_debug/* log */.Rm('dragenter event dropEffect 2: ' + e.dataTransfer.dropEffect);
  };
  var dragleaveListener = function dragleaveListener(e) {
    src_debug/* log */.Rm('dragleave event dropEffect: ' + e.dataTransfer.dropEffect);
    if (this.savedStyle) {
      this.localStyle = this.savedStyle;
    } else {
      this.localStyle = style.dropEvent;
    }
  };
  var dropListener = function dropListener(e) {
    if (e.preventDefault) e.preventDefault(); // stops the browser from redirecting off to the text.
    src_debug/* log */.Rm('Drop event. dropEffect: ' + e.dataTransfer.dropEffect);
    src_debug/* log */.Rm('Drop event. types: ' + (e.dataTransfer.types ? e.dataTransfer.types.join(', ') : 'NOPE'));
    var uris = null;
    var text;
    if (e.dataTransfer.types) {
      for (var t = 0; t < e.dataTransfer.types.length; t++) {
        var type = e.dataTransfer.types[t];
        if (type === 'text/uri-list') {
          uris = e.dataTransfer.getData(type).split('\n'); // @ ignore those starting with #
          src_debug/* log */.Rm('Dropped text/uri-list: ' + uris);
        } else if (type === 'text/plain') {
          text = e.dataTransfer.getData(type);
        } else if (type === 'Files' && droppedFileHandler) {
          var files = e.dataTransfer.files; // FileList object.
          for (var i = 0; files[i]; i++) {
            var f = files[i];
            src_debug/* log */.Rm('Filename: ' + f.name + ', type: ' + (f.type || 'n/a') + ' size: ' + f.size + ' bytes, last modified: ' + (f.lastModifiedDate ? f.lastModifiedDate.toLocaleDateString() : 'n/a'));
          }
          droppedFileHandler(files);
        }
      }
      if (uris === null && text && text.slice(0, 4) === 'http') {
        uris = text;
        src_debug/* log */.Rm('Waring: Poor man\'s drop: using text for URI'); // chrome disables text/uri-list??
      }
    } else {
      // ... however, if we're IE, we don't have the .types property, so we'll just get the Text value
      uris = [e.dataTransfer.getData('Text')];
      src_debug/* log */.Rm('WARNING non-standard drop event: ' + uris[0]);
    }
    src_debug/* log */.Rm('Dropped URI list (2): ' + uris);
    if (uris) {
      droppedURIHandler(uris);
    }
    this.localStyle = style.restoreStyle; // restore style
    return false;
  }; // dropListener

  var addTargetListeners = function addTargetListeners(ele) {
    if (!ele) {
      src_debug/* log */.Rm('@@@ addTargetListeners: ele ' + ele);
    }
    ele.addEventListener('dragover', dragoverListener);
    ele.addEventListener('dragenter', dragenterListener);
    ele.addEventListener('dragleave', dragleaveListener);
    ele.addEventListener('drop', dropListener);
  };
  addTargetListeners(ele, droppedURIHandler);
} // listen for dropped URIs

// Make an HTML element draggable as a URI-identified thing
//
// Possibly later set the drag image too?
//
function makeDraggable(tr, obj) {
  tr.setAttribute('draggable', 'true'); // Stop the image being dragged instead - just the TR

  tr.addEventListener('dragstart', function (e) {
    tr.style.fontWeight = 'bold';
    e.dataTransfer.setData('text/uri-list', obj.uri);
    e.dataTransfer.setData('text/plain', obj.uri);
    e.dataTransfer.setData('text/html', tr.outerHTML);
    src_debug/* log */.Rm('Dragstart: ' + tr + ' -> ' + obj + 'de: ' + e.dataTransfer.dropEffect);
  }, false);
  tr.addEventListener('drag', function (e) {
    e.preventDefault();
    e.stopPropagation();
    // debug.log('Drag: dropEffect: ' + e.dataTransfer.dropEffect)
  }, false);
  tr.addEventListener('dragend', function (e) {
    tr.style.fontWeight = 'normal';
    src_debug/* log */.Rm('Dragend dropeffect: ' + e.dataTransfer.dropEffect);
    src_debug/* log */.Rm('Dragend: ' + tr + ' -> ' + obj);
  }, false);
}

/** uploadFiles
**
**  Generic uploader of local files to the web
**   typically called from dropped file handler
**
**  @param {Fetcher} fetcher    instance of class Fetcher as in kb.fetcher
**  @param {Array<File>} files      Array of file objects
**  @param {String} fileBase    URI of folder in which to put files (except images) (no trailing slash)
**  @param {String } imageBase  URI of folder in which to put images
**  @param successHandler function(file, uploadedURI)    Called after EACH success upload
**                              With file object an final URI as params
*/

function uploadFiles(fetcher, files, fileBase, imageBase, successHandler) {
  for (var i = 0; files[i]; i++) {
    var f = files[i];
    src_debug/* log */.Rm(' dropped: Filename: ' + f.name + ', type: ' + (f.type || 'n/a') + ' size: ' + f.size + ' bytes, last modified: ' + (f.lastModifiedDate ? f.lastModifiedDate.toLocaleDateString() : 'n/a')); // See e.g. https://www.html5rocks.com/en/tutorials/file/dndfiles/

    // @@ Add: progress bar(s)
    var reader = new FileReader();
    reader.onload = function (theFile) {
      return function (e) {
        var data = e.target.result;
        var suffix = '';
        src_debug/* log */.Rm(' File read byteLength : ' + data.byteLength);
        var contentType = theFile.type;
        if (!theFile.type || theFile.type === '') {
          // Not known by browser
          contentType = mime_types.lookup(theFile.name);
          if (!contentType) {
            var msg = 'Filename needs to have an extension which gives a type we know: ' + theFile.name;
            src_debug/* log */.Rm(msg);
            alert(msg);
            throw new Error(msg);
          }
        } else {
          var extension = mime_types.extension(theFile.type);
          // Note not simple: eg .mp3 => audio/mpeg; .mpga => audio/mpeg; audio/mp3 => .mp3
          if (extension && extension !== 'false' && !theFile.name.endsWith('.' + extension) &&
          // Not already has preferred extension? and ...
          theFile.type !== mime_types.lookup(theFile.name)) {
            // the mime type of this ext is not the right one?
            suffix = '_.' + extension;
            // console.log('MIME TYPE MISMATCH: ' + mime.lookup(theFile.name) + ': adding extension: ' + suffix)
          }
        }
        var folderName = theFile.type.startsWith('image/') ? imageBase || fileBase : fileBase;
        var destURI = folderName + (folderName.endsWith('/') ? '' : '/') + encodeURIComponent(theFile.name) + suffix;
        fetcher.webOperation('PUT', destURI, {
          data: data,
          contentType: contentType
        }).then(function (_response) {
          src_debug/* log */.Rm(' Upload: put OK: ' + destURI);
          successHandler(theFile, destURI);
        }, function (error) {
          var msg = ' Upload: FAIL ' + destURI + ', Error: ' + error;
          src_debug/* log */.Rm(msg);
          alert(msg);
          throw new Error(msg);
        });
      };
    }(f);
    reader.readAsArrayBuffer(f);
  }
}
// EXTERNAL MODULE: ./src/iconBase.ts
var iconBase = __webpack_require__(378);
;// ./src/utils/index.js
//                  Solid-UI general Utilities
//                  ==========================
//
// This must load AFTER the rdflib.js and log-ext.js (or log.js).
//



 // pull in first avoid cross-refs

var utils_UI = {
  log: log_namespaceObject,
  ns: src_ns,
  rdf: external_$rdf_
};

var nextVariable = 0;
function newVariableName() {
  return 'v' + nextVariable++;
}
function clearVariableNames() {
  nextVariable = 0;
}

// http://stackoverflow.com/questions/879152/how-do-i-make-javascript-beep
// http://www.tsheffler.com/blog/2013/05/14/audiocontext-noteonnoteoff-and-time-units/

var audioContext;
if (typeof AudioContext !== 'undefined') {
  audioContext = AudioContext;
} else if (typeof window !== 'undefined') {
  audioContext = window.AudioContext || window.webkitAudioContext;
}
function beep() {
  if (!audioContext) {
    return;
  } // Safari 2015

  var ContextClass = audioContext;
  var ctx = new ContextClass();
  return function (duration, frequency, type, finishedCallback) {
    duration = +(duration || 0.3);

    // Only 0-4 are valid types.
    type = type || 'sine'; // sine, square, sawtooth, triangle

    if (typeof finishedCallback !== 'function') {
      finishedCallback = function finishedCallback() {};
    }
    var osc = ctx.createOscillator();
    osc.type = type;
    osc.frequency.value = frequency || 256;
    osc.connect(ctx.destination);
    osc.start(0);
    osc.stop(duration);
  };
}

// Make pseudorandom color from a uri
// NOT USED ANYWHERE
function hashColor(who) {
  who = who.uri || who;
  var hash = function hash(x) {
    return x.split('').reduce(function (a, b) {
      a = (a << 5) - a + b.charCodeAt(0);
      return a & a;
    }, 0);
  };
  return '#' + (hash(who) & 0xffffff | 0xc0c0c0).toString(16); // c0c0c0 or 808080 forces pale
}
function genUuid() {
  // http://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
}

/** Sync a DOM table with an array of things
 *
 * @param {DomElement} table - will have a tr for each thing
 * @param {Array<NamedNode>} things - ORDERED array of NamedNode objects
 * @param {function({NamedNode})} createNewRow(thing) returns a TR table row for a new thing
 *
 * Tolerates out of order elements but puts new ones in order.
 * Can be used for any element type; does not have to be a table and tr.
 */
function syncTableToArray(table, things, createNewRow) {
  var foundOne;
  var row;
  var i;
  for (i = 0; i < table.children.length; i++) {
    row = table.children[i];
    row.trashMe = true;
  }
  for (var g = 0; g < things.length; g++) {
    var thing = things[g];
    foundOne = false;
    for (i = 0; i < table.children.length; i++) {
      row = table.children[i];
      if (row.subject && row.subject.sameTerm(thing)) {
        row.trashMe = false;
        foundOne = true;
        break;
      }
    }
    if (!foundOne) {
      var newRow = createNewRow(thing);
      // Insert new row in position g in the table to match array
      if (g >= table.children.length) {
        table.appendChild(newRow);
      } else {
        var ele = table.children[g];
        table.insertBefore(newRow, ele);
      }
      newRow.subject = thing;
    } // if not foundOne
  } // loop g

  for (i = 0; i < table.children.length; i++) {
    row = table.children[i];
    if (row.trashMe) {
      table.removeChild(row);
    }
  }
} // syncTableToArray

/** Sync a DOM table with an array of things
 *
 * @param {DomElement} table - will have a tr for each thing
 * @param {Array<NamedNode>} things - ORDERED array of UNIQUE NamedNode objects. No duplicates
 * @param {function({NamedNode})} createNewRow(thing) returns a rendering of a new thing
 *
 * Ensures order matches exacly.  We will re-rder existing elements if necessary
 * Can be used for any element type; does not have to be a table and tr.
 * Any RDF node value can only appear ONCE in the array
 */
function syncTableToArrayReOrdered(table, things, createNewRow) {
  var elementMap = {};
  for (var i = 0; i < table.children.length; i++) {
    var row = table.children[i];
    elementMap[row.subject.toNT()] = row; // More sophisticaed would be to have a bag of duplicates
  }
  for (var g = 0; g < things.length; g++) {
    var thing = things[g];
    if (g >= table.children.length) {
      // table needs extending
      var newRow = createNewRow(thing);
      newRow.subject = thing;
      table.appendChild(newRow);
    } else {
      var _row = table.children[g];
      if (_row.subject.sameTerm(thing)) {
        // ...
      } else {
        var existingRow = elementMap[thing.toNT()];
        if (existingRow) {
          table.removeChild(existingRow);
          table.insertBefore(existingRow, _row); // Insert existing row in place of this one
        } else {
          var _newRow = createNewRow(thing);
          _row.before(_newRow); // Insert existing row in place of this one
          _newRow.subject = thing;
        }
      }
    }
  } // loop g
  // Lop off any we don't need any more:
  while (table.children.length > things.length) {
    table.removeChild(table.children[table.children.length - 1]);
  }
} // syncTableToArrayReOrdered

/* Error stack to string for better diagnotsics
 **
 ** See  http://snippets.dzone.com/posts/show/6632
 */
function stackString(e) {
  var str = '' + e + '\n';
  var i;
  if (!e.stack) {
    return str + 'No stack available.\n';
  }
  var lines = e.stack.toString().split('\n');
  var toPrint = [];
  for (i = 0; i < lines.length; i++) {
    var line = lines[i];
    if (line.indexOf('ecmaunit.js') > -1) {
      // remove useless bit of traceback
      break;
    }
    if (line.charAt(0) === '(') {
      line = 'function' + line;
    }
    var chunks = line.split('@');
    toPrint.push(chunks);
  }
  // toPrint.reverse();  No - I prefer the latest at the top by the error message -tbl

  for (i = 0; i < toPrint.length; i++) {
    str += '  ' + toPrint[i][1] + '\n    ' + toPrint[i][0];
  }
  return str;
}
function emptyNode(node) {
  var nodes = node.childNodes;
  var len = nodes.length;
  for (var i = len - 1; i >= 0; i--) node.removeChild(nodes[i]);
  return node;
}
function getTarget(e) {
  var target;
  e = e || window.event;
  if (e.target) target = e.target;else if (e.srcElement) target = e.srcElement;
  if (target.nodeType === 3) {
    // defeat Safari bug [sic]
    target = target.parentNode;
  }
  // UI.log.debug("Click on: " + target.tagName)
  return target;
}
function ancestor(target, tagName) {
  var level;
  for (level = target; level; level = level.parentNode) {
    // UI.log.debug("looking for "+tagName+" Level: "+level+" "+level.tagName)
    try {
      if (level.tagName === tagName) return level;
    } catch (e) {
      // can hit "TypeError: can't access dead object" in ffox
      return undefined;
    }
  }
  return undefined;
}
function getAbout(kb, target) {
  var level, aa;
  for (level = target; level && level.nodeType === 1; level = level.parentNode) {
    // UI.log.debug("Level "+level + ' '+level.nodeType + ': '+level.tagName)
    aa = level.getAttribute('about');
    if (aa) {
      // UI.log.debug("kb.fromNT(aa) = " + kb.fromNT(aa))
      return kb.fromNT(aa);
      //        } else {
      //            if (level.tagName=='TR') return undefined//this is to prevent literals passing through
    }
  }
  utils_UI.log.debug('getAbout: No about found');
  return undefined;
}
function getTerm(target) {
  var statementTr = target.parentNode;
  var st = statementTr ? statementTr.AJAR_statement : undefined;
  var className = st ? target.className : ''; // if no st then it's necessary to use getAbout
  switch (className) {
    case 'pred':
    case 'pred selected':
      return st.predicate;
    case 'obj':
    case 'obj selected':
      if (!statementTr.AJAR_inverse) {
        return st.object;
      } else {
        return st.subject;
      }
    case '':
    case 'selected':
      // header TD
      return getAbout(external_SolidLogic_.store, target);
    // kb to be changed
    case 'undetermined selected':
      return target.nextSibling ? st.predicate : !statementTr.AJAR_inverse ? st.object : st.subject;
  }
}
function include(document, linkstr) {
  var lnk = document.createElement('script');
  lnk.setAttribute('type', 'text/javascript');
  lnk.setAttribute('src', linkstr);
  // TODO:This needs to be fixed or no longer used.
  // document.getElementsByTagName('head')[0].appendChild(lnk)
  return lnk;
}
function addLoadEvent(func) {
  var oldonload = window.onload;
  if (typeof window.onload !== 'function') {
    window.onload = func;
  } else {
    window.onload = function () {
      oldonload();
      func();
    };
  }
} // addLoadEvent

// Find the position of an object relative to the window
function findPos(obj) {
  // C&P from http://www.quirksmode.org/js/findpos.html
  var myDocument = obj.ownerDocument;
  var DocBox = myDocument.documentElement.getBoundingClientRect();
  var box = obj.getBoundingClientRect();
  return [box.left - DocBox.left, box.top - DocBox.top];
}
function getEyeFocus(element, instantly, isBottom, myWindow) {
  if (!myWindow) myWindow = window;
  var elementPosY = findPos(element)[1];
  var appContext = window.SolidAppContext || {};
  var scrollDiff = appContext && appContext.scroll || 52; // 52 = magic number for web-based version
  var totalScroll = elementPosY - scrollDiff - myWindow.scrollY;
  if (instantly) {
    if (isBottom) {
      myWindow.scrollBy(0, elementPosY + element.clientHeight - (myWindow.scrollY + myWindow.innerHeight));
      return;
    }
    myWindow.scrollBy(0, totalScroll);
    return;
  }
  var id = myWindow.setInterval(scrollAmount, 50);
  var times = 0;
  function scrollAmount() {
    myWindow.scrollBy(0, totalScroll / 10);
    times++;
    if (times === 10) {
      myWindow.clearInterval(id);
    }
  }
}
function AJARImage(src, alt, tt, doc) {
  if (!doc) {
    doc = document;
  }
  var image = doc.createElement('img');
  image.setAttribute('src', src);
  image.addEventListener('copy', function (e) {
    e.clipboardData.setData('text/plain', '');
    e.clipboardData.setData('text/html', '');
    e.preventDefault(); // We want no title data to be written to the clipboard
  });
  //    if (typeof alt != 'undefined')      // Messes up cut-and-paste of text
  //        image.setAttribute('alt', alt)
  if (typeof tt !== 'undefined') {
    image.setAttribute('title', tt);
  }
  return image;
}

//  Make short name for ontology

function shortName(uri) {
  var p = uri;
  if ('#/'.indexOf(p[p.length - 1]) >= 0) p = p.slice(0, -1);
  var namespaces = [];
  for (var _ns in this.prefixes) {
    namespaces[this.prefixes[_ns]] = _ns; // reverse index
  }
  var pok;
  var canUse = function canUse(pp) {
    // if (!__Serializer.prototype.validPrefix.test(pp)) return false; // bad format
    if (pp === 'ns') return false; // boring
    // if (pp in this.namespaces) return false; // already used
    // this.prefixes[uri] = pp;
    // this.namespaces[pp] = uri;
    pok = pp;
    return true;
  };
  var i;
  var hash = p.lastIndexOf('#');
  if (hash >= 0) p = p.slice(hash - 1); // lop off localid
  // eslint-disable-next-line no-unreachable-loop
  for (;;) {
    var slash = p.lastIndexOf('/');
    if (slash >= 0) p = p.slice(slash + 1);
    i = 0;
    while (i < p.length) {
      if (this.prefixchars.indexOf(p[i])) i++;else break;
    }
    p = p.slice(0, i);
    if (p.length < 6 && canUse(p)) return pok; // exact i sbest
    if (canUse(p.slice(0, 3))) return pok;
    if (canUse(p.slice(0, 2))) return pok;
    if (canUse(p.slice(0, 4))) return pok;
    if (canUse(p.slice(0, 1))) return pok;
    if (canUse(p.slice(0, 5))) return pok;
    for (i = 0;; i++) if (canUse(p.slice(0, 3) + i)) return pok;
  }
}

// Short name for an ontology
function ontologyLabel(term) {
  if (term.uri === undefined) return '??';
  var s = term.uri;
  var namespaces = [];
  var i = s.lastIndexOf('#');
  var part;
  if (i >= 0) {
    s = s.slice(0, i + 1);
  } else {
    i = s.lastIndexOf('/');
    if (i >= 0) {
      s = s.slice(0, i + 1);
    } else {
      return term.uri + '?!'; // strange should have # or /
    }
  }
  for (var _ns2 in utils_UI.ns) {
    namespaces[utils_UI.ns[_ns2]] = _ns2; // reverse index
  }
  try {
    return namespaces[s];
  } catch (e) {}
  s = s.slice(0, -1); // Chop off delimiter ... now have just

  while (s) {
    i = s.lastIndexOf('/');
    if (i >= 0) {
      part = s.slice(i + 1);
      s = s.slice(0, i);
      if (part !== 'ns' && '0123456789'.indexOf(part[0]) < 0) {
        return part;
      }
    } else {
      return term.uri + '!?'; // strange should have a nice part
    }
  }
}
function labelWithOntology(x, initialCap) {
  var t = external_SolidLogic_.store.findTypeURIs(x);
  if (t[utils_UI.ns.rdf('Predicate').uri] || t[utils_UI.ns.rdfs('Class').uri]) {
    return label_label(x, initialCap) + ' (' + ontologyLabel(x) + ')';
  }
  return label_label(x, initialCap);
}
function utils_escapeForXML(str) {
  return str.replace(/&/g, '&amp;').replace(/</g, '&lt;');
}

//  As above but escaped for XML and chopped of contains a slash
function labelForXML(x) {
  return utils_escapeForXML(label_label(x));
}
function predicateLabelForXML(p, inverse) {
  return utils_escapeForXML(predicateLabel(p, inverse));
}
// As above but for predicate, possibly inverse
function predicateLabel(p, inverse) {
  var lab = label_label(p);
  if (inverse) {
    // If we know an inverse predicate, use its label
    var ip = external_SolidLogic_.store.any(p, utils_UI.ns.owl('inverseOf')) || external_SolidLogic_.store.any(undefined, utils_UI.ns.owl('inverseOf'), p);
    if (ip) return label_label(ip);
    if (lab === 'type') return '...'; // Not "is type of"
    return 'is ' + lab + ' of';
  }
  return lab;
}

// Not a method. For use in sorts
function RDFComparePredicateObject(self, other) {
  var x = self.predicate.compareTerm(other.predicate);
  if (x !== 0) return x;
  return self.object.compareTerm(other.object);
}
function RDFComparePredicateSubject(self, other) {
  var x = self.predicate.compareTerm(other.predicate);
  if (x !== 0) return x;
  return self.subject.compareTerm(other.subject);
}
// ends

function predParentOf(node) {
  var n = node;
  while (true) {
    if (n.getAttribute('predTR')) {
      return n;
    } else if (n.previousSibling && n.previousSibling.nodeName === 'TR') {
      n = n.previousSibling;
    } else {
      utils_UI.log.error('Could not find predParent');
      return node;
    }
  }
}

// makeQueryRow moved to outline mode
;// ./src/widgets/error.ts
/**
 * Create an error message block
 * @param dom The DOM on which dom.createElement will be called
 * @param err The error message string to display (or an error object)
 * @param backgroundColor Background color. Default: '#fee'
 * @param err2 Is the second param is a string, you can put the original Error in here
 * @returns A div element with the err string
 *
 * This will return a DOM element you can put in the UI as a notice for the user
 *  Meanwhile the stack is dumped to the console for the developer, so you actually know
 *  where it happened!
 */




function errorMessageBlock(dom, err, backgroundColor, err2) {
  var div = dom.createElement('div');

  /* tslint:disable-next-line */ // Too complex for TS?
  // @ts-ignore
  var errorObject = err2 || err instanceof Error ? err : null;
  if (errorObject) {
    console.error("errorMessageBlock: ".concat(errorObject, " at: ").concat(errorObject.stack || '??'), errorObject); // @@ pick one
    div.textContent = errorObject.message;
  } else {
    div.textContent = err;
  }
  div.appendChild(buttons_cancelButton(dom, function () {
    if (div.parentNode) div.parentNode.removeChild(div);
  })).style = style.errorCancelButton;
  div.setAttribute('style', style.errorMessageBlockStyle);
  div.style.backgroundColor = backgroundColor || styleConstants.defaultErrorBackgroundColor;
  return div;
}
;// ./src/widgets/widgetHelpers.ts


/**
 * Wraps a Div in a TR/RD
 *
 * Takes a div and wraps it in a TR/TD to be backwards compatible to the
 * table structure of mashlib
 *
 * @param dom The HTML Document object aka Document Object Model
 * @param div the created widget will be appended to this
 * @param obj not sure what this is used for exactly
 *
 * @returns The HTML widget created
 *
 * @internal exporting this only for unit tests
 */

var wrapDivInATR = function wrapDivInATR(dom, div, obj) {
  var tr = dom.createElement('tr');
  var td = tr.appendChild(dom.createElement('td'));
  td.appendChild(div);
  tr.subject = obj;
  return tr;
};

/**
 * Adds a click listener to a div
 *
 * Adds a given function as a click listener on the given div
 *
 * @param dom The HTML Document object aka Document Object Model
 * @param onClickFunction the click function to add to the click listener
 *
 * @returns The HTML widget created
 *
 * @internal exporting this only for unit tests
 */

var addClickListenerToElement = function addClickListenerToElement(div, onClickFunction) {
  div.addEventListener('click', onClickFunction);
};

/**
 * Wraps a Div in a TR/RD
 *
 * Takes a div and wraps it in a TR/TD to be backwards compatible to the
 * table structure of mashlib
 *
 * @param dom The HTML Document object aka Document Object Model
 * @param div the created widget will be appended to this
 * @param obj not sure what this is used for exactly
 *
 * @returns The HTML widget created
 *
 * @internal exporting this only for unit tests
 */

var createImageDiv = function createImageDiv(dom, div, image) {
  var imageDiv = div.appendChild(dom.createElement('div'));
  imageDiv.setAttribute('style', style.imageDivStyle);
  imageDiv.appendChild(image);
  image.setAttribute('draggable', 'false'); // Stop the image being dragged instead - just the TR
};
;// ./src/widgets/buttons/iconLinks.ts


/**
 * Creates an anchor tag for a NamedNode
 *
 * Takes a NamedNode and creates an anchor tag for it
 *
 * @param dom The HTML Document object aka Document Object Model
 * @param subject NamedNode the anchor tag is created for
 * @param iconURI? Optional if you have your own icon link
 *
 * @returns The anchor tag for the subject
 *
 */

function linkIcon(dom, subject, iconURI) {
  var anchor = dom.createElement('a');
  anchor.setAttribute('href', subject.uri);
  if (subject.uri.startsWith('http')) {
    // If diff web page
    anchor.setAttribute('target', '_blank'); // open in a new tab or window
  } // as mailboxes and mail messages do not need new browser window
  var img = anchor.appendChild(dom.createElement('img'));
  img.setAttribute('src', iconURI || iconBase/* originalIconBase */.i1 + 'go-to-this.png');
  img.setAttribute('style', 'margin: 0.3em;');
  return anchor;
}
/**
 * Creates a Link for a URI
 *
 * Takes a div element for a link and attaches the provided linkIcon
 *
 * @param dom The HTML Document object aka Document Object Model
 * @param linkDiv the created link will be appended to this
 * @param obj NamedNode the link needs to be created for
 *
 * @returns The HTML widget created
 *
 */

var createLinkForURI = function createLinkForURI(dom, linkDiv, obj) {
  var iconLink = linkIcon(dom, obj);
  var anchor = linkDiv.appendChild(iconLink);
  anchor.classList.add('HoverControlHide');
  linkDiv.appendChild(dom.createElement('br'));
};
;// ./src/widgets/buttons.ts
/*  Buttons
*/













/**
 * UI Widgets such as buttons
 * @packageDocumentation
 */

/* global alert */

var buttons_iconBase = iconBase/* icons */.Pt.iconBase;
var cancelIconURI = buttons_iconBase + 'noun_1180156.svg'; // black X
var checkIconURI = buttons_iconBase + 'noun_1180158.svg'; // green checkmark; Continue

function getStatusArea(context) {
  var box = context && context.statusArea || context && context.div || null;
  if (box) return box;
  var dom = context && context.dom;
  if (!dom && typeof document !== 'undefined') {
    dom = document;
  }
  if (dom) {
    var body = dom.getElementsByTagName('body')[0];
    box = dom.createElement('div');
    body.insertBefore(box, body.firstElementChild);
    if (context) {
      context.statusArea = box;
    }
    return box;
  }
  return null;
}

/**
 * Display an error message block
 */
function complain(context, err) {
  if (!err) return; // only if error
  var ele = getStatusArea(context);
  src_debug/* log */.Rm('Complaint: ' + err);
  if (ele) ele.appendChild(errorMessageBlock(context && context.dom || document, err));else alert(err);
}

/**
 * Remove all the children of an HTML element
 */
function clearElement(ele) {
  while (ele.firstChild) {
    ele.removeChild(ele.firstChild);
  }
  return ele;
}

/**
 * To figure out the log URI from the full URI used to invoke the reasoner
 */
function extractLogURI(fullURI) {
  var logPos = fullURI.search(/logFile=/);
  var rulPos = fullURI.search(/&rulesFile=/);
  return fullURI.substring(logPos + 8, rulPos);
}

/**
 * By default, converts e.g. '2020-02-19T19:35:28.557Z' to '19:35'
 * if today is 19 Feb 2020, and to 'Feb 19' if not.
 * @@@ TODO This needs to be changed to local time
 * @param noTime Return a string like 'Feb 19' even if it's today.
 */
function shortDate(str, noTime) {
  if (!str) return '???';
  var month = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  try {
    var nowZ = new Date().toISOString();
    // var nowZ = $rdf.term(now).value
    // var n = now.getTimezoneOffset() // Minutes
    if (str.slice(0, 10) === nowZ.slice(0, 10) && !noTime) {
      return str.slice(11, 16);
    }
    if (str.slice(0, 4) === nowZ.slice(0, 4)) {
      return month[parseInt(str.slice(5, 7), 10) - 1] + ' ' + parseInt(str.slice(8, 10), 10);
    }
    return str.slice(0, 10);
  } catch (e) {
    return 'shortdate:' + e;
  }
}

/**
 * Format a date and time
 * @param date for instance `new Date()`
 * @param format  for instance '{FullYear}-{Month}-{Date}T{Hours}:{Minutes}:{Seconds}.{Milliseconds}'
 * @returns for instance '2000-01-15T23:14:23.002'
 */
function formatDateTime(date, format) {
  return format.split('{').map(function (s) {
    var k = s.split('}')[0];
    var width = {
      Milliseconds: 3,
      FullYear: 4
    };
    var d = {
      Month: 1
    };
    return s ? ('000' + (date['get' + k]() + (d[k] || 0))).slice(-(width[k] || 2)) + s.split('}')[1] : '';
  }).join('');
}

/**
 * Get a string representation of the current time
 * @returns for instance '2000-01-15T23:14:23.002'
 */
function timestamp() {
  return formatDateTime(new Date(), '{FullYear}-{Month}-{Date}T{Hours}:{Minutes}:{Seconds}.{Milliseconds}');
}

/**
 * Get a short string representation of the current time
 * @returns for instance '23:14:23.002'
 */
function shortTime() {
  return formatDateTime(new Date(), '{Hours}:{Minutes}:{Seconds}.{Milliseconds}');
}

// ///////////////////// Handy UX widgets

/**
 * Sets the best name we have and looks up a better one
 */
function setName(element, x) {
  var kb = external_SolidLogic_.store;
  var findName = function findName(x) {
    var name = kb.any(x, src_ns.vcard('fn')) || kb.any(x, src_ns.foaf('name')) || kb.any(x, src_ns.vcard('organization-name'));
    return name ? name.value : null;
  };
  var name = x.sameTerm(src_ns.foaf('Agent')) ? 'Everyone' : findName(x);
  element.textContent = name || label_label(x);
  if (!name && x.uri) {
    if (!kb.fetcher) {
      throw new Error('kb has no fetcher');
    }
    // Note this is only a fetch, not a lookUP of all sameAs etc
    kb.fetcher.nowOrWhenFetched(x.doc(), undefined, function (_ok) {
      element.textContent = findName(x) || label_label(x); // had: (ok ? '' : '? ') +
    });
  }
}

/**
 * Set of suitable images
 * See also [[findImage]]
 * @param x The thing for which we want to find an image
 * @param kb The RDF store to look in
 * @returns It goes looking for triples in `kb`,
 *          `(subject: x), (predicate: see list below) (object: image-url)`
 *          to find any image linked from the thing with one of the following
 *          predicates (in order):
 *          * ns.sioc('avatar')
 *          * ns.foaf('img')
 *          * ns.vcard('logo')
 *          * ns.vcard('hasPhoto')
 *          * ns.vcard('photo')
 *          * ns.foaf('depiction')

 */
function imagesOf(x, kb) {
  return kb.each(x, src_ns.sioc('avatar')).concat(kb.each(x, src_ns.foaf('img'))).concat(kb.each(x, src_ns.vcard('logo'))).concat(kb.each(x, src_ns.vcard('hasPhoto'))).concat(kb.each(x, src_ns.vcard('photo'))).concat(kb.each(x, src_ns.foaf('depiction')));
}

/**
 * Best logo or avatar or photo etc to represent someone or some group etc
 */
var iconForClass = {
  // Potentially extendable by other apps, panes, etc
  // Relative URIs to the iconBase
  'solid:AppProviderClass': 'noun_144.svg',
  //  @@ classs name should not contain 'Class'
  'solid:AppProvider': 'noun_15177.svg',
  // @@
  'solid:Pod': 'noun_Cabinet_1434380.svg',
  'vcard:Group': 'noun_339237.svg',
  'vcard:Organization': 'noun_143899.svg',
  'vcard:Individual': 'noun_15059.svg',
  'schema:Person': 'noun_15059.svg',
  'foaf:Person': 'noun_15059.svg',
  'foaf:Agent': 'noun_98053.svg',
  'acl:AuthenticatedAgent': 'noun_99101.svg',
  'prov:SoftwareAgent': 'noun_Robot_849764.svg',
  // Bot
  'vcard:AddressBook': 'noun_15695.svg',
  'trip:Trip': 'noun_581629.svg',
  'meeting:LongChat': 'noun_1689339.svg',
  'meeting:Meeting': 'noun_66617.svg',
  'meeting:Project': 'noun_1036577.svg',
  'ui:Form': 'noun_122196.svg',
  'rdfs:Class': 'class-rectangle.svg',
  // For RDF developers
  'rdf:Property': 'property-diamond.svg',
  'owl:Ontology': 'noun_classification_1479198.svg',
  'wf:Tracker': 'noun_122196.svg',
  'wf:Task': 'noun_17020_gray-tick.svg',
  'wf:Open': 'noun_17020_sans-tick.svg',
  'wf:Closed': 'noun_17020.svg'
};

/**
 * Returns the origin of the URI of a NamedNode
 */
function tempSite(x) {
  // use only while one in rdflib fails with origins 2019
  var str = x.uri.split('#')[0];
  var p = str.indexOf('//');
  if (p < 0) throw new Error('This URI does not have a web site part (origin)');
  var q = str.indexOf('/', p + 2);
  if (q < 0) {
    // no third slash?
    return str.slice(0) + '/'; // Add slash to a bare origin
  } else {
    return str.slice(0, q + 1);
  }
}

/**
 * Find an image for this thing as a class
 */
function findImageFromURI(x) {
  var iconDir = buttons_iconBase;

  // Special cases from URI scheme:
  if (typeof x !== 'string' && x.uri) {
    if (x.uri.split('/').length === 4 && !x.uri.split('/')[1] && !x.uri.split('/')[3]) {
      return iconDir + 'noun_15177.svg'; // App -- this is an origin
    }
    // Non-HTTP URI types imply types
    if (x.uri.startsWith('message:') || x.uri.startsWith('mid:')) {
      // message: is apple bug-- should be mid:
      return iconDir + 'noun_480183.svg'; // envelope  noun_567486
    }
    if (x.uri.startsWith('mailto:')) {
      return iconDir + 'noun_567486.svg'; // mailbox - an email desitination
    }
    // For HTTP(s) documents, we could look at the MIME type if we know it.
    if (x.uri.startsWith('https:') && x.uri.indexOf('#') < 0) {
      return tempSite(x) + 'favicon.ico'; // was x.site().uri + ...
      // Todo: make the document icon a fallback for if the favicon does not exist
      // todo: pick up a possible favicon for the web page itself from a link
      // was: return iconDir + 'noun_681601.svg' // document - under solid assumptions
    }
    return null;
  }
  return iconDir + 'noun_10636_grey.svg'; // Grey Circle -  some thing
}

/**
 * Find something we have as explicit image data for the thing
 * See also [[imagesOf]]
 * @param thing The thing for which we want to find an image
 * @returns The URL of a globe icon if thing equals `ns.foaf('Agent')`
 *          or `ns.rdf('Resource')`. Otherwise, it goes looking for
 *          triples in `store`,
 *          `(subject: thing), (predicate: see list below) (object: image-url)`
 *          to find any image linked from the thing with one of the following
 *          predicates (in order):
 *          * ns.sioc('avatar')
 *          * ns.foaf('img')
 *          * ns.vcard('logo')
 *          * ns.vcard('hasPhoto')
 *          * ns.vcard('photo')
 *          * ns.foaf('depiction')
 */
function findImage(thing) {
  var kb = external_SolidLogic_.store;
  var iconDir = buttons_iconBase;
  if (thing.sameTerm(src_ns.foaf('Agent')) || thing.sameTerm(src_ns.rdf('Resource'))) {
    return iconDir + 'noun_98053.svg'; // Globe
  }
  var image = kb.any(thing, src_ns.sioc('avatar')) || kb.any(thing, src_ns.foaf('img')) || kb.any(thing, src_ns.vcard('logo')) || kb.any(thing, src_ns.vcard('hasPhoto')) || kb.any(thing, src_ns.vcard('photo')) || kb.any(thing, src_ns.foaf('depiction'));
  return image ? image.uri : null;
}

/**
 * Do the best you can with the data available
 *
 * @return {Boolean} Are we happy with this icon?
 * Sets src AND STYLE of the image.
 */
function trySetImage(element, thing, iconForClassMap) {
  var kb = external_SolidLogic_.store;
  var explitImage = findImage(thing);
  if (explitImage) {
    element.setAttribute('src', explitImage);
    return true;
  }
  // This is one of the classes we know about - the class itself?
  var typeIcon = iconForClassMap[thing.uri];
  if (typeIcon) {
    element.setAttribute('src', typeIcon);
    element.style = style.classIconStyle;
    // element.style.border = '0.1em solid green;'
    // element.style.backgroundColor = '#eeffee' // pale green
    return true;
  }
  var schemeIcon = findImageFromURI(thing);
  if (schemeIcon) {
    element.setAttribute('src', schemeIcon);
    return true; // happy with this -- don't look it up
  }

  // Do we have a generic icon for something in any class its in?
  var types = kb.findTypeURIs(thing);
  for (var typeURI in types) {
    if (iconForClassMap[typeURI]) {
      element.setAttribute('src', iconForClassMap[typeURI]);
      return false; // maybe we can do better
    }
  }
  element.setAttribute('src', buttons_iconBase + 'noun_10636_grey.svg'); // Grey Circle -  some thing
  return false; // we can do better
}

/**
 * ToDo: Also add icons for *properties* like  home, work, email, range, domain, comment,
 */
function setImage(element, thing) {
  // 20191230a
  var kb = external_SolidLogic_.store;
  var iconForClassMap = {};
  for (var k in iconForClass) {
    var pref = k.split(':')[0];
    var id = k.split(':')[1];
    var theClass = src_ns[pref](id);
    iconForClassMap[theClass.uri] = external_$rdf_.uri.join(iconForClass[k], buttons_iconBase);
  }
  var happy = trySetImage(element, thing, iconForClassMap);
  if (!happy && thing.uri) {
    if (!kb.fetcher) {
      throw new Error('kb has no fetcher');
    }
    kb.fetcher.nowOrWhenFetched(thing.doc(), undefined, function (ok) {
      if (ok) {
        trySetImage(element, thing, iconForClassMap);
      }
    });
  }
}

// If a web page, then a favicon, with a fallback to ???
// See, e.g., http://stackoverflow.com/questions/980855/inputting-a-default-image
function faviconOrDefault(dom, x) {
  var image = dom.createElement('img');
  image.style = style.iconStyle;
  var isOrigin = function isOrigin(x) {
    if (!x.uri) return false;
    var parts = x.uri.split('/');
    return parts.length === 3 || parts.length === 4 && parts[3] === '';
  };
  image.setAttribute('src', buttons_iconBase + (isOrigin(x) ? 'noun_15177.svg' : 'noun_681601.svg') // App symbol vs document
  );
  if (x.uri && x.uri.startsWith('https:') && x.uri.indexOf('#') < 0) {
    var res = dom.createElement('object'); // favico with a fallback of a default image if no favicon
    res.setAttribute('data', tempSite(x) + 'favicon.ico');
    res.setAttribute('type', 'image/x-icon');
    res.appendChild(image); // fallback
    return res;
  } else {
    setImage(image, x);
    return image;
  }
}

/* Two-option dialog pop-up
*/

function renderDeleteConfirmPopup(dom, refererenceElement, prompt, deleteFunction) {
  function removePopup() {
    refererenceElement.parentElement.removeChild(refererenceElement);
  }
  function removePopupAndDoDeletion() {
    removePopup();
    deleteFunction();
  }
  var popup = dom.createElement('div');
  popup.style = style.confirmPopupStyle;
  popup.style.position = 'absolute';
  popup.style.top = '-1em'; // try leaving original button clear

  popup.style.display = 'grid';
  popup.style.gridTemplateColumns = 'auto auto';
  var affirm = dom.createElement('div');
  affirm.style.gridColumn = '1/2';
  affirm.style.gridRow = '1'; // @@ sigh; TS. could pass number in fact
  var cancel = dom.createElement('div');
  cancel.style.gridColumn = '1/2';
  cancel.style.gridRow = '2';
  var xButton = buttons_cancelButton(dom, removePopup);
  popup.appendChild(xButton);
  xButton.style.gridColumn = '1';
  xButton.style.gridRow = '2';
  var cancelPrompt = popup.appendChild(dom.createElement('button'));
  cancelPrompt.style = style.buttonStyle;
  cancelPrompt.style.gridRow = '2';
  cancelPrompt.style.gridColumn = '2';
  cancelPrompt.textContent = 'Cancel'; // @@ I18n

  var affirmIcon = buttons_button(dom, iconBase/* icons */.Pt.iconBase + 'noun_925021.svg', 'Delete it'); // trashcan
  popup.appendChild(affirmIcon);
  affirmIcon.style.gridRow = '1';
  affirmIcon.style.gridColumn = '1';
  var sureButtonElt = popup.appendChild(dom.createElement('button'));
  sureButtonElt.style = style.buttonStyle;
  sureButtonElt.style.gridRow = '1';
  sureButtonElt.style.gridColumn = '2';
  sureButtonElt.textContent = prompt;
  popup.appendChild(sureButtonElt);
  affirmIcon.addEventListener('click', removePopupAndDoDeletion);
  sureButtonElt.addEventListener('click', removePopupAndDoDeletion);

  // xButton.addEventListener('click', removePopup)
  cancelPrompt.addEventListener('click', removePopup);
  return popup;
}
/**
 * Delete button with a check you really mean it
 * @@ Supress check if command key held down?
 */
function deleteButtonWithCheck(dom, container, noun, deleteFunction) {
  function createPopup() {
    var refererenceElement = dom.createElement('div');
    container.insertBefore(refererenceElement, deleteButton);
    refererenceElement.style.position = 'relative'; // Needed as reference for popup
    refererenceElement.appendChild(renderDeleteConfirmPopup(dom, refererenceElement, prompt, deleteFunction));
  }
  var minusIconURI = buttons_iconBase + 'noun_2188_red.svg'; // white minus in red #cc0000 circle
  var deleteButton = dom.createElement('img');
  deleteButton.setAttribute('src', minusIconURI);
  deleteButton.setAttribute('style', style.smallButtonStyle); // @@tsc - would set deleteButton.style
  deleteButton.style["float"] = 'right'; // Historically this has alwaus floated right

  var prompt = 'Remove this ' + noun;
  deleteButton.title = prompt;
  // @@ In an ideal world, make use of hover an accessibility option
  deleteButton.classList.add('hoverControlHide');
  deleteButton.addEventListener('click', createPopup);
  container.classList.add('hoverControl');
  container.appendChild(deleteButton);
  deleteButton.setAttribute('data-testid', 'deleteButtonWithCheck');
  return deleteButton; // or button div?  caller may change size of image
}

/*  Make a button
 *
 * @param dom - the DOM document object
 * @Param iconURI - the URI of the icon to use (if any)
 * @param text - the tooltip text or possibly button contents text
 * @param handler <function> - A handler to called when button is clicked
 *
 * @returns <dDomElement> - the button
 */
function buttons_button(dom, iconURI, text, handler) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
    buttonColor: 'Primary',
    needsBorder: false
  };
  var button = dom.createElement('button');
  button.setAttribute('type', 'button');
  // button.innerHTML = text  // later, user preferences may make text preferred for some
  if (iconURI) {
    var img = button.appendChild(dom.createElement('img'));
    img.setAttribute('src', iconURI);
    img.setAttribute('style', 'width: 2em; height: 2em;'); // trial and error. 2em disappears
    img.title = text;
    button.setAttribute('style', style.buttonStyle);
  } else {
    button.textContent = text.toLocaleUpperCase();
    button.onmouseover = function () {
      if (options.buttonColor === 'Secondary') {
        if (options.needsBorder) {
          button.setAttribute('style', style.secondaryButtonNoBorderHover);
        } else {
          button.setAttribute('style', style.secondaryButtonHover);
        }
      } else {
        if (options.needsBorder) {
          button.setAttribute('style', style.primaryButtonNoBorderHover);
        } else {
          button.setAttribute('style', style.primaryButtonHover);
        }
      }
    };
    button.onmouseout = function () {
      if (options.buttonColor === 'Secondary') {
        if (options.needsBorder) {
          button.setAttribute('style', style.secondaryButtonNoBorder);
        } else {
          button.setAttribute('style', style.secondaryButton);
        }
      } else {
        if (options.needsBorder) {
          button.setAttribute('style', style.primaryButtonNoBorder);
        } else {
          button.setAttribute('style', style.primaryButton);
        }
      }
    };
    if (options.buttonColor === 'Secondary') {
      if (options.needsBorder) {
        button.setAttribute('style', style.secondaryButtonNoBorder);
      } else {
        button.setAttribute('style', style.secondaryButton);
      }
    } else {
      if (options.needsBorder) {
        button.setAttribute('style', style.primaryButtonNoBorder);
      } else {
        button.setAttribute('style', style.primaryButton);
      }
    }
  }
  if (handler) {
    button.addEventListener('click', handler, false);
  }
  return button;
}

/*  Make a cancel button
 *
 * @param dom - the DOM document object
 * @param handler <function> - A handler to called when button is clicked
 *
 * @returns <dDomElement> - the button
 */
function buttons_cancelButton(dom, handler) {
  var b = buttons_button(dom, cancelIconURI, 'Cancel', handler);
  if (b.firstChild) {
    // sigh for tsc
    b.firstChild.style.opacity = '0.3'; // Black X is too harsh: current language is grey X
  }
  return b;
}

/*  Make a continue button
 *
 * @param dom - the DOM document object
 * @param handler <function> - A handler to called when button is clicked
 *
 * @returns <dDomElement> - the button
 */
function continueButton(dom, handler) {
  return buttons_button(dom, checkIconURI, 'Continue', handler);
}

/* Grab a name for a new thing
 *
 * Form to get the name of a new thing before we create it
 * @params theClass  Misspelt to avoid clashing with the JavaScript keyword
 * @returns: a promise of (a name or null if cancelled)
 */
function askName(dom, kb, container, predicate, theClass, noun) {
  return new Promise(function (resolve, _reject) {
    var form = dom.createElement('div'); // form is broken as HTML behaviour can resurface on js error
    // classLabel = utils.label(ns.vcard('Individual'))
    predicate = predicate || src_ns.foaf('name'); // eg 'name' in user's language
    noun = noun || (theClass ? label_label(theClass) : '  '); // eg 'folder' in users's language
    var prompt = noun + ' ' + label_label(predicate) + ': ';
    form.appendChild(dom.createElement('p')).textContent = prompt;
    var namefield = dom.createElement('input');
    namefield.setAttribute('type', 'text');
    namefield.setAttribute('size', '100');
    namefield.setAttribute('maxLength', '2048'); // No arbitrary limits
    namefield.setAttribute('style', style.textInputStyle);
    namefield.select(); // focus next user input
    form.appendChild(namefield);
    container.appendChild(form);

    // namefield.focus()

    function gotName() {
      form.parentNode.removeChild(form);
      resolve(namefield.value.trim());
    }
    namefield.addEventListener('keyup', function (e) {
      if (e.keyCode === 13) {
        gotName();
      }
    }, false);
    form.appendChild(dom.createElement('br'));
    form.appendChild(buttons_cancelButton(dom, function (_event) {
      form.parentNode.removeChild(form);
      resolve(null);
    }));
    form.appendChild(continueButton(dom, function (_event) {
      gotName();
    }));
    namefield.focus();
  }); // Promise
}

/**
 * A TR to represent a draggable person, etc in a list
 *
 * pred is unused param at the moment
 */
var personTR = renderAsRow; // The legacy name is used in a lot of places

function renderAsRow(dom, pred, obj, options) {
  var tr = dom.createElement('tr');
  options = options || {};
  // tr.predObj = [pred.uri, obj.uri]   moved to acl-control
  var td1 = tr.appendChild(dom.createElement('td'));
  var td2 = tr.appendChild(dom.createElement('td'));
  var td3 = tr.appendChild(dom.createElement('td'));

  // const image = td1.appendChild(dom.createElement('img'))
  var image = options.image || faviconOrDefault(dom, obj);
  td1.setAttribute('style', 'vertical-align: middle; width:2.5em; padding:0.5em; height: 2.5em;');
  td2.setAttribute('style', 'vertical-align: middle; text-align:left;');
  td3.setAttribute('style', 'vertical-align: middle; width:2em; padding:0.5em; height: 4em;');
  td1.appendChild(image);
  if (options.title) {
    td2.textContent = options.title;
  } else {
    setName(td2, obj); // This is async
  }
  if (options.deleteFunction) {
    deleteButtonWithCheck(dom, td3, options.noun || 'one', options.deleteFunction);
  }
  if (obj.uri) {
    // blank nodes need not apply
    if (options.link !== false) {
      var anchor = td3.appendChild(linkIcon(dom, obj));
      anchor.classList.add('HoverControlHide');
      td3.appendChild(dom.createElement('br'));
    }
    if (options.draggable !== false) {
      // default is on
      image.setAttribute('draggable', 'false'); // Stop the image being dragged instead - just the TR
      makeDraggable(tr, obj);
    }
  }
  ;
  tr.subject = obj;
  return tr;
}

/* A helper function for renderAsDiv
*  creates the NameDiv for the person
*  Note: could not move it to the helper file because they call exported functions
*  from buttons
*  @internal exporting this only for unit tests
*/
function createNameDiv(dom, div, title, obj) {
  var nameDiv = div.appendChild(dom.createElement('div'));
  if (title) {
    nameDiv.textContent = title;
  } else {
    setName(nameDiv, obj); // This is async
  }
}
/* A helper function for renderAsDiv
*  creates the linkDiv for the person
*  Note: could not move it to the helper file because they call exported functions
*  from buttons
* @internal exporting this only for unit tests
*/
function createLinkDiv(dom, div, obj, options) {
  var linkDiv = div.appendChild(dom.createElement('div'));
  linkDiv.setAttribute('style', style.linkDivStyle);
  if (options.deleteFunction) {
    deleteButtonWithCheck(dom, linkDiv, options.noun || 'one', options.deleteFunction);
  }
  if (obj.uri) {
    // blank nodes need not apply
    if (options.link !== false) {
      createLinkForURI(dom, linkDiv, obj);
    }
    makeDraggable(div, obj);
  }
}
/**
 * A Div to represent a draggable person, etc in a list
 * configurable to add an onClick listener
 */
function renderAsDiv(dom, obj, options) {
  var div = dom.createElement('div');
  div.setAttribute('style', style.renderAsDivStyle);
  options = options || {};
  var image = options.image || faviconOrDefault(dom, obj);
  createImageDiv(dom, div, image);
  createNameDiv(dom, div, options.title, obj);
  createLinkDiv(dom, div, obj, options);
  if (options.clickable && options.onClickFunction) {
    addClickListenerToElement(div, options.onClickFunction);
  }

  // to be compatible with the SolidOS table layout
  if (options.wrapInATR) {
    var tr = wrapDivInATR(dom, div, obj);
    return tr;
  }
  return div;
}

/**
 * Refresh a DOM tree recursively
 */
function refreshTree(root) {
  if (root.refresh) {
    root.refresh();
    return;
  }
  for (var i = 0; i < root.children.length; i++) {
    refreshTree(root.children[i]);
  }
}

/**
 * Options argument for [[attachmentList]] function
 */

/**
 * Component that displays a list of resources, for instance
 * the attachments of a message, or the various documents related
 * to a meeting.
 * Accepts dropping URLs onto it to add attachments to it.
 */
function attachmentList(dom, subject, div) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  // options = options || {}

  var deleteAttachment = function deleteAttachment(target) {
    if (!kb.updater) {
      throw new Error('kb has no updater');
    }
    kb.updater.update((0,external_$rdf_.st)(subject, predicate, target, doc), [], function (uri, ok, errorBody, _xhr) {
      if (ok) {
        refresh();
      } else {
        complain(undefined, 'Error deleting one: ' + errorBody);
      }
    });
  };
  function createNewRow(target) {
    var theTarget = target;
    var opt = {
      noun: noun
    };
    if (modify) {
      opt.deleteFunction = function () {
        deleteAttachment(theTarget);
      };
    }
    return personTR(dom, predicate, target, opt);
  }
  var refresh = function refresh() {
    var things = kb.each(subject, predicate);
    things.sort();
    syncTableToArray(attachmentTable, things, createNewRow);
  };
  function droppedURIHandler(uris) {
    var ins = [];
    uris.forEach(function (u) {
      var target = (0,external_$rdf_.sym)(u); // Attachment needs text label to disinguish I think not icon.
      src_debug/* log */.Rm('Dropped on attachemnt ' + u); // icon was: iconBase + 'noun_25830.svg'
      ins.push((0,external_$rdf_.st)(subject, predicate, target, doc));
    });
    if (!kb.updater) {
      throw new Error('kb has no updater');
    }
    kb.updater.update([], ins, function (uri, ok, errorBody, _xhr) {
      if (ok) {
        refresh();
      } else {
        complain(undefined, 'Error adding one: ' + errorBody);
      }
    });
  }
  function droppedFileHandler(files) {
    var _options$uploadFolder, _options$uploadFolder2;
    uploadFiles(kb.fetcher, files, (_options$uploadFolder = options.uploadFolder) === null || _options$uploadFolder === void 0 ? void 0 : _options$uploadFolder.uri, // Files
    (_options$uploadFolder2 = options.uploadFolder) === null || _options$uploadFolder2 === void 0 ? void 0 : _options$uploadFolder2.uri,
    // Pictures
    function (theFile, destURI) {
      var ins = [(0,external_$rdf_.st)(subject, predicate, kb.sym(destURI), doc)];
      if (!kb.updater) {
        throw new Error('kb has no updater');
      }
      kb.updater.update([], ins, function (uri, ok, errorBody, _xhr) {
        if (ok) {
          refresh();
        } else {
          complain(undefined, 'Error adding link to uploaded file: ' + errorBody);
        }
      });
    });
  }
  var doc = options.doc || subject.doc();
  if (options.modify === undefined) options.modify = true;
  var modify = options.modify;
  var promptIcon = options.promptIcon || buttons_iconBase + 'noun_748003.svg'; //    target
  // const promptIcon = options.promptIcon || (iconBase + 'noun_25830.svg') //  paperclip
  var predicate = options.predicate || src_ns.wf('attachment');
  var noun = options.noun || 'attachment';
  var kb = external_SolidLogic_.store;
  var attachmentOuter = div.appendChild(dom.createElement('table'));
  attachmentOuter.setAttribute('style', 'margin-top: 1em; margin-bottom: 1em;');
  var attachmentOne = attachmentOuter.appendChild(dom.createElement('tr'));
  var attachmentLeft = attachmentOne.appendChild(dom.createElement('td'));
  var attachmentRight = attachmentOne.appendChild(dom.createElement('td'));
  var attachmentTable = attachmentRight.appendChild(dom.createElement('table'));
  attachmentTable.appendChild(dom.createElement('tr')) // attachmentTableTop
  ;
  attachmentOuter.refresh = refresh; // Participate in downstream changes
  // ;(attachmentTable as any).refresh = refresh   <- outer should be best?

  refresh();
  if (modify) {
    // const buttonStyle = 'width; 2em; height: 2em; margin: 0.5em; padding: 0.1em;'
    var paperclip = buttons_button(dom, promptIcon, 'Drop attachments here');
    // paperclip.style = buttonStyle // @@ needed?  default has white background
    attachmentLeft.appendChild(paperclip);
    var fhandler = options.uploadFolder ? droppedFileHandler : null;
    makeDropTarget(paperclip, droppedURIHandler, fhandler); // beware missing the wire of the paparclip!
    makeDropTarget(attachmentLeft, droppedURIHandler, fhandler); // just the outer won't do it

    if (options.uploadFolder) {
      // Addd an explicit file upload button as well
      var buttonDiv = fileUploadButtonDiv(dom, droppedFileHandler);
      attachmentLeft.appendChild(buttonDiv);
      // buttonDiv.children[1].style =  buttonStyle
    }
  }
  return attachmentOuter;
}

// /////////////////////////////////////////////////////////////////////////////

/**
 * Event Handler for links within solid apps.
 *
 * Note that native links have constraints in Firefox, they
 * don't work with local files for instance (2011)
 */
function openHrefInOutlineMode(e) {
  e.preventDefault();
  e.stopPropagation();
  var target = getTarget(e);
  var uri = target.getAttribute('href');
  if (!uri) return src_debug/* log */.Rm('openHrefInOutlineMode: No href found!\n');
  var dom = window.document;
  if (dom.outlineManager) {
    // @@ TODO Remove the use of document as a global object
    // TODO fix dependency cycle to solid-panes by calling outlineManager
    ;
    dom.outlineManager.GotoSubject(external_SolidLogic_.store.sym(uri), true, undefined, true, undefined);
  } else if (window && window.panes && window.panes.getOutliner) {
    // @@ TODO Remove the use of window as a global object
    ;
    window.panes.getOutliner().GotoSubject(external_SolidLogic_.store.sym(uri), true, undefined, true, undefined);
  } else {
    src_debug/* log */.Rm('ERROR: Can\'t access outline manager in this config');
  }
  // dom.outlineManager.GotoSubject(store.sym(uri), true, undefined, true, undefined)
}

/**
 * Make a URI in the Tabulator.org annotation store out of the URI of the thing to be annotated.
 *
 * @@ Todo: make it a personal preference.
 */
function defaultAnnotationStore(subject) {
  if (subject.uri === undefined) return undefined;
  var s = subject.uri;
  if (s.slice(0, 7) !== 'http://') return undefined;
  s = s.slice(7); // Remove
  var hash = s.indexOf('#');
  if (hash >= 0) s = s.slice(0, hash);
  // Strip trailing
  else {
    var slash = s.lastIndexOf('/');
    if (slash < 0) return undefined;
    s = s.slice(0, slash);
  }
  return external_SolidLogic_.store.sym('http://tabulator.org/wiki/annnotation/' + s);
}

/**
 * Retrieve all RDF class URIs from solid-ui's RDF store
 * @returns an object `ret` such that `Object.keys(ret)` is
 * the list of all class URIs.
 */
function allClassURIs() {
  var set = {};
  external_SolidLogic_.store.statementsMatching(undefined, src_ns.rdf('type'), undefined).forEach(function (st) {
    if (st.object.value) set[st.object.value] = true;
  });
  external_SolidLogic_.store.statementsMatching(undefined, src_ns.rdfs('subClassOf'), undefined).forEach(function (st) {
    if (st.object.value) set[st.object.value] = true;
    if (st.subject.value) set[st.subject.value] = true;
  });
  external_SolidLogic_.store.each(undefined, src_ns.rdf('type'), src_ns.rdfs('Class')).forEach(function (c) {
    if (c.value) set[c.value] = true;
  });
  return set;
}

/**
 * Figuring which properties we know about
 *
 * When the user inputs an RDF property, like for a form field
 * or when specifying the relationship between two arbitrary things,
 * then er can prompt them with properties the session knows about
 *
 * TODO: Look again by catching this somewhere. (On the kb?)
 * TODO: move to diff module? Not really a button.
 * @param {Store} kb The quadstore to be searched.
 */

function propertyTriage(kb) {
  var possibleProperties = {};
  // if (possibleProperties === undefined) possibleProperties = {}
  // const kb = store
  var dp = {};
  var op = {};
  var no = 0;
  var nd = 0;
  var nu = 0;
  var pi = kb.predicateIndex; // One entry for each pred
  for (var p in pi) {
    var object = pi[p][0].object;
    if (object.termType === 'Literal') {
      dp[p] = true;
      nd++;
    } else {
      op[p] = true;
      no++;
    }
  } // If nothing discovered, then could be either:
  var ps = kb.each(undefined, src_ns.rdf('type'), src_ns.rdf('Property'));
  for (var i = 0; i < ps.length; i++) {
    var _p = ps[i].toNT();
    if (!op[_p] && !dp[_p]) {
      dp[_p] = true;
      op[_p] = true;
      nu++;
    }
  }
  possibleProperties.op = op;
  possibleProperties.dp = dp;
  info("propertyTriage: ".concat(no, " non-lit, ").concat(nd, " literal. ").concat(nu, " unknown."));
  return possibleProperties;
}

/**
 * General purpose widgets
 */

/**
 * A button for jumping
 */
function linkButton(dom, object) {
  var b = dom.createElement('button');
  b.setAttribute('type', 'button');
  b.textContent = 'Goto ' + label_label(object);
  b.addEventListener('click', function (_event) {
    // b.parentNode.removeChild(b)
    // TODO fix dependency cycle to solid-panes by calling outlineManager
    ;
    dom.outlineManager.GotoSubject(object, true, undefined, true, undefined);
  }, true);
  return b;
}

/**
 * A button to remove some other element from the page
 */
function removeButton(dom, element) {
  var b = dom.createElement('button');
  b.setAttribute('type', 'button');
  b.textContent = '✕'; // MULTIPLICATION X
  b.addEventListener('click', function (_event) {
    ;
    element.parentNode.removeChild(element);
  }, true);
  return b;
}

//      Description text area
//
// Make a box to demand a description or display existing one
//
// @param dom - the document DOM for the user interface
// @param kb - the graph which is the knowledge base we are working with
// @param subject - a term, the subject of the statement(s) being edited.
// @param predicate - a term, the predicate of the statement(s) being edited
// @param store - The web document being edited
// @param callbackFunction - takes (boolean ok, string errorBody)

// /////////////////////////////////////// Random I/O widgets /////////////

// ////              Column Header Buttons
//
//  These are for selecting different modes, sources,styles, etc.
//
/*
buttons.headerButtons = function (dom, kb, name, words) {
    const box = dom.createElement('table')
    var i, word, s = '<tr>'
    box.setAttribute('style', 'width: 90%; height: 1.5em')
    for (i=0; i<words.length; i++) {
        s += '<td><input type="radio" name="' + name + '" id="' + words[i] + '" value='
    }
    box.innerHTML = s + '</tr>'

}
*/
// ////////////////////////////////////////////////////////////
//
//     selectorPanel
//
//  A vertical panel for selecting connections to left or right.
//
//   @param inverse means this is the object rather than the subject
//
function selectorPanel(dom, kb, type, predicate, inverse, possible, options, callbackFunction, linkCallback) {
  return selectorPanelRefresh(dom.createElement('div'), dom, kb, type, predicate, inverse, possible, options, callbackFunction, linkCallback);
}
function selectorPanelRefresh(list, dom, kb, type, predicate, inverse, possible, options, callbackFunction, linkCallback) {
  var style0 = 'border: 0.1em solid #ddd; border-bottom: none; width: 95%; height: 2em; padding: 0.5em;';
  var selected = null;
  list.innerHTML = '';
  var refreshItem = function refreshItem(box, x) {
    // Scope to hold item and x
    var item;
    // eslint-disable-next-line prefer-const
    var image;
    var setStyle = function setStyle() {
      var already = inverse ? kb.each(undefined, predicate, x) : kb.each(x, predicate);
      iconDiv.setAttribute('class', already.length === 0 ? 'hideTillHover' : ''); // See tabbedtab.css
      image.setAttribute('src', options.connectIcon || buttons_iconBase + 'noun_25830.svg');
      image.setAttribute('title', already.length ? already.length : 'attach');
    };
    var f = index.twoLine.widgetForClass(type);
    // eslint-disable-next-line prefer-const
    item = f(dom, x);
    item.setAttribute('style', style0);
    var nav = dom.createElement('div');
    nav.setAttribute('class', 'hideTillHover'); // See tabbedtab.css
    nav.setAttribute('style', 'float:right; width:10%');
    var a = dom.createElement('a');
    a.setAttribute('href', x.uri);
    a.setAttribute('style', 'float:right');
    nav.appendChild(a).textContent = '>';
    box.appendChild(nav);
    var iconDiv = dom.createElement('div');
    iconDiv.setAttribute('style', (inverse ? 'float:left;' : 'float:right;') + ' width:30px;');
    image = dom.createElement('img');
    setStyle();
    iconDiv.appendChild(image);
    box.appendChild(iconDiv);
    item.addEventListener('click', function (event) {
      if (selected === item) {
        // deselect
        item.setAttribute('style', style0);
        selected = null;
      } else {
        if (selected) selected.setAttribute('style', style0);
        item.setAttribute('style', style0 + 'background-color: #ccc; color:black;');
        selected = item;
      }
      callbackFunction(x, event, selected === item);
      setStyle();
    }, false);
    image.addEventListener('click', function (event) {
      linkCallback(x, event, inverse, setStyle);
    }, false);
    box.appendChild(item);
    return box;
  };
  for (var i = 0; i < possible.length; i++) {
    var box = dom.createElement('div');
    list.appendChild(box);
    refreshItem(box, possible[i]);
  }
  return list;
}

// ###########################################################################
//
//      Small compact views of things
//
var index = {};
// ///////////////////////////////////////////////////////////////////////////
// We need these for anything which is a subject of an attachment.
//
// These should be moved to type-dependeent UI code. Related panes maybe

function twoLineDefault(dom, x) {
  // Default
  var box = dom.createElement('div');
  box.textContent = label_label(x);
  return box;
}

/**
 * Find a function that can create a widget for a given class
 * @param c The RDF class for which we want a widget generator function
 */
function twoLineWidgetForClass(c) {
  var widget = index.twoLine[c.uri];
  var kb = external_SolidLogic_.store;
  if (widget) return widget;
  var sup = kb.findSuperClassesNT(c);
  for (var cl in sup) {
    widget = index.twoLine[kb.fromNT(cl).uri];
    if (widget) return widget;
  }
  return index.twoLine[''];
}

/**
 * Display a transaction
 * @param x Should have attributes through triples in store:
 *          * ns.qu('payee') -> a named node
 *          * ns.qu('date) -> a literal
 *          * ns.qu('amount') -> a literal
 */
function twoLineTransaction(dom, x) {
  var failed = '';
  var enc = function enc(p) {
    var y = external_SolidLogic_.store.any(x, src_ns.qu(p));
    if (!y) failed += '@@ No value for ' + p + '! ';
    return y ? utils_escapeForXML(y.value) : '?'; // @@@@
  };
  var box = dom.createElement('table');
  box.innerHTML = "\n      <tr>\n      <td colspan=\"2\"> ".concat(enc('payee'), "</td>\n      < /tr>\n      < tr >\n      <td>").concat(enc('date').slice(0, 10), "</td>\n      <td style = \"text-align: right;\">").concat(enc('amount'), "</td>\n      </tr>");
  if (failed) {
    box.innerHTML = "\n      <tr>\n        <td><a href=\"".concat(utils_escapeForXML(x.uri), "\">").concat(utils_escapeForXML(failed), "</a></td>\n      </tr>");
  }
  return box;
}

/**
 * Display a trip
 * @param x Should have attributes through triples in store:
 *          * ns.dc('title') -> a literal
 *          * ns.cal('dtstart') -> a literal
 *          * ns.cal('dtend') -> a literal
 */
function twoLineTrip(dom, x) {
  var enc = function enc(p) {
    var y = external_SolidLogic_.store.any(x, p);
    return y ? utils_escapeForXML(y.value) : '?';
  };
  var box = dom.createElement('table');
  box.innerHTML = "\n    <tr>\n      <td colspan=\"2\">".concat(enc(src_ns.dc('title')), "</td>\n    </tr>\n    <tr style=\"color: #777\">\n      <td>").concat(enc(src_ns.cal('dtstart')), "</td>\n      <td>").concat(enc(src_ns.cal('dtend')), "</td>\n    </tr>");
  return box;
}

/**
 * Stick a stylesheet link the document if not already there
 */
function addStyleSheet(dom, href) {
  var links = dom.querySelectorAll('link');
  for (var i = 0; i < links.length; i++) {
    if ((links[i].getAttribute('rel') || '') === 'stylesheet' && (links[i].getAttribute('href') || '') === href) {
      return;
    }
  }
  var link = dom.createElement('link');
  link.setAttribute('rel', 'stylesheet');
  link.setAttribute('type', 'text/css');
  link.setAttribute('href', href);
  dom.getElementsByTagName('head')[0].appendChild(link);
}

// Figure (or guess) whether this is an image, etc
//
function isAudio(file) {
  return isImage(file, 'audio');
}
function isVideo(file) {
  return isImage(file, 'video');
}
/**
 *
 */
function isImage(file, kind) {
  var dcCLasses = {
    audio: 'http://purl.org/dc/dcmitype/Sound',
    image: 'http://purl.org/dc/dcmitype/Image',
    video: 'http://purl.org/dc/dcmitype/MovingImage'
  };
  var what = kind || 'image';
  // See https://github.com/linkeddata/rdflib.js/blob/e367d5088c/src/formula.ts#L554
  //
  var typeURIs = external_SolidLogic_.store.findTypeURIs(file);
  // See https://github.com/linkeddata/rdflib.js/blob/d5000f/src/utils-js.js#L14
  // e.g.'http://www.w3.org/ns/iana/media-types/audio'
  var prefix = external_$rdf_.Util.mediaTypeClass(what + '/*').uri.split('*')[0];
  for (var t in typeURIs) {
    if (t.startsWith(prefix)) return true;
  }
  if (dcCLasses[what] in typeURIs) return true;
  return false;
}

/**
 * File upload button
 * @param dom The DOM aka document
 * @param  droppedFileHandler Same handler function as drop, takes array of file objects
 * @returns {Element} - a div with a button and a inout in it
 * The input is hidden, as it is uglky - the user clicks on the nice icons and fires the input.
 */
// See https://developer.mozilla.org/en-US/docs/Web/API/File/Using_files_from_web_applications
function fileUploadButtonDiv(dom, droppedFileHandler) {
  var div = dom.createElement('div');
  var input = div.appendChild(dom.createElement('input'));
  input.setAttribute('type', 'file');
  input.setAttribute('multiple', 'true');
  input.addEventListener('change', function (event) {
    src_debug/* log */.Rm('File drop event: ', event);
    if (event.files) {
      droppedFileHandler(event.files);
    } else if (event.target && event.target.files) {
      droppedFileHandler(event.target.files);
    } else {
      alert('Sorry no files .. internal error?');
    }
  }, false);
  input.style = 'display:none';
  var buttonElt = div.appendChild(buttons_button(dom, buttons_iconBase + 'noun_Upload_76574_000000.svg', 'Upload files', function (_event) {
    input.click();
  }));
  makeDropTarget(buttonElt, null, droppedFileHandler); // Can also just drop on button
  return div;
}
index = {
  line: {// Approx 80em
  },
  twoLine: {
    // Approx 40em * 2.4em
    '': twoLineDefault,
    'http://www.w3.org/2000/10/swap/pim/qif#Transaction': twoLineTransaction,
    'http://www.w3.org/ns/pim/trip#Trip': twoLineTrip,
    widgetForClass: twoLineWidgetForClass
  }
};
;// ./node_modules/@babel/runtime/helpers/esm/defineProperty.js

function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}

;// ./src/signup/config-default.js
/**
 * Provides a simple configuration object for Solid web client and other
 * modules.
 * @module config-default
 */
/* harmony default export */ const config_default = ({
  // @@ should not use export default
  /**
   * Primary authentication endpoint
   */
  authEndpoint: '',
  /**
   * Fallback authentication endpoint
   */
  fallbackAuthEndpoint: 'https://databox.me/',
  /**
   * Default signup endpoints (list of identity providers)
   */
  signupEndpoint: 'https://solidproject.org/get_a_pod',
  /**
   * Default height of the Signup popup window, in pixels
   */
  signupWindowHeight: 600,
  /**
   * Default width of the Signup popup window, in pixels
   */
  signupWindowWidth: 1024,
  /**
   * Path to the client private key (only needed when running within node)
   */
  key: '',
  /**
   * Path to the client certificate (only needed when running within node)
   */
  cert: ''
});
;// ./src/signup/signup.js


/**
 * Provides functionality for signing up with a Solid provider
 * @module signup
 */

/**
 * Creates a Signup UI manager
 * @class
 */
function Signup(config) {
  this.config = config || config_default;
}

/**
 * Sets up an event listener to monitor login messages from child window/iframe
 * @method listen
 * @return {Promise<String>} Event listener promise, resolves to user's WebID
 */
Signup.prototype.listen = function listen() {
  var promise = new Promise(function (resolve, reject) {
    var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
    var eventListener = window[eventMethod];
    var messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';
    eventListener(messageEvent, function (e) {
      var u = e.data;
      if (u.slice(0, 5) === 'User:') {
        var user = u.slice(5, u.length);
        if (user && user.length > 0 && user.slice(0, 4) === 'http') {
          return resolve(user);
        } else {
          return reject(user);
        }
      }
    }, true);
  });
  return promise;
};

/**
 * Opens a signup popup window, sets up `listen()`.
 * @method signup
 * @static
 * @param signupUrl {String} Location of a Solid server for user signup.
 * @return {Promise<String>} Returns a listener promise, resolves with signed
 *   up user's WebID.
 */
Signup.prototype.signup = function signup(signupUrl) {
  signupUrl = signupUrl || this.config.signupEndpoint;
  var width = this.config.signupWindowWidth;
  var height = this.config.signupWindowHeight;
  // set borders
  var leftPosition = window.screen.width / 2 - (width / 2 + 10);
  // set title and status bars
  var topPosition = window.screen.height / 2 - (height / 2 + 50);
  var windowTitle = 'Solid signup';
  var windowUrl = signupUrl + '?origin=' + encodeURIComponent(window.location.origin);
  var windowSpecs = 'resizable,scrollbars,status,width=' + width + ',height=' + height + ',left=' + leftPosition + ',top=' + topPosition;
  window.open(windowUrl, windowTitle, windowSpecs);
  var self = this;
  return new Promise(function (resolve) {
    self.listen().then(function (webid) {
      return resolve(webid);
    });
  });
};
;// ./src/widgets/forms/fieldParams.ts

var _fieldParams;


/**
 * The fieldParams object defines various constants
 * for use in various form fields. Depending on the
 * field in questions, different values may be read
 * from here.
 */
var fieldParams = (_fieldParams = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_fieldParams, src_ns.ui('ColorField').uri, {
  size: 9,
  type: 'color',
  style: 'height: 3em;',
  // around 1.5em is padding
  dt: 'color',
  pattern: /^\s*#[0-9a-f][0-9a-f][0-9a-f][0-9a-f][0-9a-f][0-9a-f]([0-9a-f][0-9a-f])?\s*$/
}), src_ns.ui('DateField').uri, {
  size: 20,
  type: 'date',
  dt: 'date',
  pattern: /^\s*[0-9][0-9][0-9][0-9](-[0-1]?[0-9]-[0-3]?[0-9])?Z?\s*$/
}), src_ns.ui('DateTimeField').uri, {
  size: 20,
  type: 'datetime-local',
  // See https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/datetime
  dt: 'dateTime',
  pattern: /^\s*[0-9][0-9][0-9][0-9](-[0-1]?[0-9]-[0-3]?[0-9])?(T[0-2][0-9]:[0-5][0-9](:[0-5][0-9])?)?Z?\s*$/
}), src_ns.ui('TimeField').uri, {
  size: 10,
  type: 'time',
  dt: 'time',
  pattern: /^\s*([0-2]?[0-9]:[0-5][0-9](:[0-5][0-9])?)\s*$/
}), src_ns.ui('IntegerField').uri, {
  size: 12,
  style: 'text-align: right;',
  dt: 'integer',
  pattern: /^\s*-?[0-9]+\s*$/
}), src_ns.ui('DecimalField').uri, {
  size: 12,
  style: 'text-align: right;',
  dt: 'decimal',
  pattern: /^\s*-?[0-9]*(\.[0-9]*)?\s*$/
}), src_ns.ui('FloatField').uri, {
  size: 12,
  style: 'text-align: right;',
  dt: 'float',
  pattern: /^\s*-?[0-9]*(\.[0-9]*)?((e|E)-?[0-9]*)?\s*$/
}), src_ns.ui('SingleLineTextField').uri, {}), src_ns.ui('NamedNodeURIField').uri, {
  namedNode: true
}), src_ns.ui('TextField').uri, {}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_fieldParams, src_ns.ui('PhoneField').uri, {
  size: 20,
  uriPrefix: 'tel:',
  pattern: /^\+?[\d-]+[\d]*$/
}), src_ns.ui('EmailField').uri, {
  size: 30,
  uriPrefix: 'mailto:',
  pattern: /^\s*.*@.*\..*\s*$/ // @@ Get the right regexp here
}), src_ns.ui('Group').uri, {
  style: style.formGroupStyle
}), src_ns.ui('Comment').uri, {
  element: 'p',
  style: style.commentStyle
}), src_ns.ui('Heading').uri, {
  element: 'h3',
  style: style.formHeadingStyle
}));
;// ./src/widgets/forms/fieldFunction.ts



var fieldFunction_store = external_SolidLogic_.solidLogicSingleton.store;
var field = {}; // Form field functions by URI of field type.

/**
 * Which class of field is this? Relies on http://www.w3.org/2000/01/rdf-schema#subClassOf and
 * https://linkeddata.github.io/rdflib.js/doc/classes/formula.html#bottomtypeuris
 * to find the most specific RDF type if there are multiple.
 *
 * @param x a form field, e.g. `namedNode('https://timbl.com/timbl/Public/Test/Forms/individualForm.ttl#fullNameField')`
 * @returns the URI of the most specific known class, e.g. `http://www.w3.org/ns/ui#SingleLineTextField`
 */
function mostSpecificClassURI(x) {
  var kb = fieldFunction_store;
  var ft = kb.findTypeURIs(x);
  var bot = kb.bottomTypeURIs(ft); // most specific
  var bots = [];
  for (var b in bot) bots.push(b);
  // if (bots.length > 1) throw "Didn't expect "+x+" to have multiple bottom types: "+bots
  return bots[0];
}

/**
 * Returns a function that creates a form widget
 * @param dom unused
 * @param fieldInQuestion the field for which to create a form, e.g. namedNode('https://timbl.com/timbl/Public/Test/Forms/individualForm.ttl#fullNameField')
 */
function fieldFunction(dom, fieldInQuestion) {
  var uri = mostSpecificClassURI(fieldInQuestion); // What type
  // const uri = field.uri
  var fun = field[uri];
  debug('paneUtils: Going to implement field ' + fieldInQuestion + ' of type ' + uri);
  if (!fun) {
    return function (dom2, container) {
      var box = errorMessageBlock(dom2, 'No handler for field ' + fieldInQuestion + ' of type ' + uri);
      if (container) container.appendChild(box);
      return box;
    };
  }
  return fun;
}
;// ./src/widgets/forms/formStyle.ts




var STYLE_URI_PREFIX = 'https://www.w3.org/ns/css#';
function setFieldStyle(ele, field) {
  var classUri = mostSpecificClassURI(field);
  var params = fieldParams[classUri] || {};
  var style = external_SolidLogic_.store.any(field, src_ns.ui('style'));
  if (!style) {
    if (params.style) {
      ele.setAttribute('style', params.style);
    }
    return;
  }
  if (style.termType === 'Literal') {
    if (style) ele.setAttribute('style', style.value);
  } else {
    var sts = external_SolidLogic_.store.statementsMatching(style, null, null, field.doc());
    sts.forEach(function (st) {
      if (st.predicate.uri && st.predicate.uri.startsWith(STYLE_URI_PREFIX)) {
        var cssAttribute = st.predicate.uri.slice(STYLE_URI_PREFIX.length);
        try {
          ele.style[cssAttribute] = st.object.value;
        } catch (_err) {
          console.warn("setFieldStyle: Error setting element style ".concat(cssAttribute, " to \"").concat(st.object.value, "\""));
          console.warn("setFieldStyle:   ... Element tagName was \"".concat(ele.tagName || '???', "\""));
        }
      }
    });
  }
}
;// ./src/widgets/forms/basic.ts









var basic_store = external_SolidLogic_.solidLogicSingleton.store;

/*  Style and create a name, value pair
*/
function renderNameValuePair(dom, kb, box, form, label) {
  // const property = kb.any(form, ns.ui('property'))
  box.style.display = 'flex';
  box.style.flexDirection = 'row';
  var lhs = box.appendChild(dom.createElement('div'));
  lhs.style.width = styleConstants.formFieldNameBoxWidth;
  var rhs = box.appendChild(dom.createElement('div'));
  lhs.setAttribute('class', 'formFieldName');
  lhs.setAttribute('style', style.formFieldNameBoxStyle);
  rhs.setAttribute('class', 'formFieldValue');
  if (label) {
    lhs.appendChild(dom.createTextNode(label));
  } else if (kb.any(form, src_ns.ui('property'))) {
    // Assume more space for error on right
    lhs.appendChild(fieldLabel(dom, kb.any(form, src_ns.ui('property')), form));
  } else {
    rhs.appendChild(errorMessageBlock(dom, 'No property or label given for form field: ' + form));
    lhs.appendChild(dom.createTextNode('???'));
  }
  return rhs;
}

/**
 * Create an anchor element with a label as the anchor text.
 *
 * @param dom The DOM
 * @param property href for the anchor element
 * @param fieldInQuestion field to produce a label for
 *
 * @internal exporting this only for unit tests
 */
function fieldLabel(dom, property, fieldInQuestion) {
  var lab = basic_store.any(fieldInQuestion, src_ns.ui('label'));
  if (!lab) lab = label_label(property, true); // Init capital
  if (property === undefined) {
    return dom.createTextNode('@@Internal error: undefined property');
  }
  var anchor = dom.createElement('a');
  /* istanbul ignore next */
  if (property.uri) anchor.setAttribute('href', property.uri);
  anchor.setAttribute('style', 'color: #3B5998; text-decoration: none;'); // Not too blue and no underline
  anchor.textContent = lab;
  return anchor;
}

/**
 * Returns the document for the first quad that matches
 * the subject and predicate provided, or default if that
 * store is not editable.
 *
 * @param subject Subject about which we want to find an editable RDF document
 * @param predicate Predicate about which we want to find an editable RDF document
 * @param def default RDF document to return if none found
 *
 * @internal exporting this only for unit tests
 */
function fieldStore(subject, predicate, def) {
  var sts = basic_store.statementsMatching(subject, predicate);
  if (sts.length === 0) return def; // can used default as no data yet
  if (!basic_store.updater) {
    throw new Error('Store has no updater');
  }
  if (sts.length > 0 && sts[0].why.value && basic_store.updater.editable(sts[0].why.value, basic_store)) {
    return basic_store.sym(sts[0].why.value);
  }
  return def;
}

/**
 * Render a basic form field
 *
 * The same function is used for many similar one-value fields, with different
 * regexps used to validate.
 *
 * @param dom The HTML Document object aka Document Object Model
 * @param container  If present, the created widget will be appended to this
 * @param already A hash table of (form, subject) kept to prevent recursive forms looping
 * @param subject The thing about which the form displays/edits data
 * @param form The form or field to be rendered
 * @param doc The web document in which the data is
 * @param callbackFunction Called when data is changed?
 *
 * @returns The HTML widget created
 */

function basicField(dom, container, already, subject, form, doc, callbackFunction) {
  var kb = basic_store;
  var formDoc = form.doc ? form.doc() : null; // @@ if blank no way to know

  var box = dom.createElement('div');
  var property = kb.any(form, src_ns.ui('property'));
  if (container) container.appendChild(box);
  if (!property) {
    return box.appendChild(errorMessageBlock(dom, 'Error: No property given for text field: ' + form));
  }
  var rhs = renderNameValuePair(dom, kb, box, form);

  // It can be cleaner to just remove empty fields if you can't edit them anyway
  var suppressEmptyUneditable = kb.anyJS(form, src_ns.ui('suppressEmptyUneditable'), null, formDoc);
  var uri = mostSpecificClassURI(form);
  var params = fieldParams[uri];
  if (params === undefined) params = {
    style: ''
  }; // non-bottom field types can do this
  var paramStyle = params.style || '';
  var inputStyle = style.textInputStyle + paramStyle;
  var field = dom.createElement('input');
  field.style = inputStyle;
  rhs.appendChild(field);
  field.setAttribute('type', params.type ? params.type : 'text');
  var size = kb.anyJS(form, src_ns.ui('size')) || styleConstants.textInputSize || 20;
  field.setAttribute('size', size);
  var maxLength = kb.any(form, src_ns.ui('maxLength'));
  field.setAttribute('maxLength', maxLength ? '' + maxLength : styleConstants.basicMaxLength);
  doc = doc || fieldStore(subject, property, doc);
  var obj = kb.any(subject, property, undefined, doc);
  if (!obj) {
    obj = kb.any(form, src_ns.ui('default'));
  }
  if (obj && obj.value && params.uriPrefix) {
    // eg tel: or mailto:
    field.value = decodeURIComponent(obj.value.replace(params.uriPrefix, '')) // should have no spaces but in case
    .replace(/ /g, '');
  } else if (obj) {
    /* istanbul ignore next */
    field.value = obj.value || obj.value || '';
  }
  field.setAttribute('style', inputStyle);
  if (!kb.updater) {
    throw new Error('kb has no updater');
  }
  if (!kb.updater.editable(doc.uri)) {
    field.readOnly = true // was: disabled. readOnly is better
    ;
    field.style = style.textInputStyleUneditable + paramStyle;
    if (suppressEmptyUneditable && field.value === '') {
      box.style.display = 'none'; // clutter
    }
    return box;
  }

  // read-write:
  field.addEventListener('keyup', function (_e) {
    if (params.pattern) {
      field.setAttribute('style', inputStyle + (field.value.match(params.pattern) ? 'color: green;' : 'color: red;'));
    }
  }, true);
  field.addEventListener('change', function (_e) {
    // i.e. lose focus with changed data
    if (params.pattern && !field.value.match(params.pattern)) return;
    field.disabled = true; // See if this stops getting two dates from fumbling e.g the chrome datepicker.
    field.setAttribute('style', inputStyle + 'color: gray;'); // pending
    var ds = kb.statementsMatching(subject, property); // remove any multiple values
    var result;
    if (params.namedNode) {
      result = kb.sym(field.value);
    } else if (params.uriPrefix) {
      result = encodeURIComponent(field.value.replace(/ /g, ''));
      result = kb.sym(params.uriPrefix + field.value);
    } else {
      if (params.dt) {
        result = new external_$rdf_.Literal(field.value.trim(), undefined, src_ns.xsd(params.dt));
      } else {
        result = new external_$rdf_.Literal(field.value);
      }
    }
    var is = ds.map(function (statement) {
      return (0,external_$rdf_.st)(statement.subject, statement.predicate, result, statement.why);
    }); // can include >1 doc
    if (is.length === 0) {
      // or none
      is = [(0,external_$rdf_.st)(subject, property, result, doc)];
    }
    function updateMany(ds, is, callback) {
      var docs = [];
      is.forEach(function (st) {
        if (!docs.includes(st.why.uri)) docs.push(st.why.uri);
      });
      ds.forEach(function (st) {
        /* istanbul ignore next */
        if (!docs.includes(st.why.uri)) docs.push(st.why.uri);
      });
      /* istanbul ignore next */
      if (docs.length === 0) {
        throw new Error('updateMany has no docs to patch');
      }
      if (!kb.updater) {
        throw new Error('kb has no updater');
      }
      if (docs.length === 1) {
        return kb.updater.update(ds, is, callback);
      }
      // return kb.updater.update(ds, is, callback)

      var doc = docs.pop();
      var is1 = is.filter(function (st) {
        return st.why.uri === doc;
      });
      var is2 = is.filter(function (st) {
        return st.why.uri !== doc;
      });
      var ds1 = ds.filter(function (st) {
        return st.why.uri === doc;
      });
      var ds2 = ds.filter(function (st) {
        return st.why.uri !== doc;
      });
      kb.updater.update(ds1, is1, function (uri, ok, body) {
        if (ok) {
          updateMany(ds2, is2, callback);
        } else {
          callback(uri, ok, body);
        }
      });
    }
    updateMany(ds, is, function (uri, ok, body) {
      // kb.updater.update(ds, is, function (uri, ok, body) {
      if (ok) {
        field.disabled = false;
        field.setAttribute('style', inputStyle);
      } else {
        box.appendChild(errorMessageBlock(dom, body));
      }
      callbackFunction(ok, body);
    });
  }, true);
  return box;
}
;// ./src/widgets/forms/autocomplete/language.ts


/* Logic to access public data stores
*
* including filtering resut by natural language etc
* See https://solidos.solidcommunity.net/public/2021/01%20Building%20Solid%20Apps%20which%20use%20Public%20Data.html
*/


// import * as logic from '../index'
// import { authn } from '../../../authn/index'



// import { Binding } from '../widgets/forms/autocomplete/publicData'
// import { nativeNameForLanguageCode, englishNameForLanguageCode } from './nativeNameForLanguageCode'

// const { currentUser } = logic.authn

var languageCodeURIBase = 'https://www.w3.org/ns/iana/language-code/'; /// @@ unsupported on the web (2021)

var defaultPreferredLanguages = ['en', 'fr', 'de', 'it', 'ar'];
function addDefaults(array) {
  if (!array) array = [];
  return array.concat(defaultPreferredLanguages.filter(function (code) {
    return !array.includes(code);
  }));
}
function getPreferredLanguagesFor(_x) {
  return _getPreferredLanguagesFor.apply(this, arguments);
}
/* Get the preferred langauges for the user
 *
 *  Either from solid preferences or browser preferences or default
 */
function _getPreferredLanguagesFor() {
  _getPreferredLanguagesFor = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee(person) {
    var _store$fetcher;
    var doc, list, languageCodeArray;
    return regenerator_default().wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          doc = person.doc();
          _context.next = 1;
          return (_store$fetcher = external_SolidLogic_.store.fetcher) === null || _store$fetcher === void 0 ? void 0 : _store$fetcher.load(doc);
        case 1:
          list = external_SolidLogic_.store.any(person, src_ns.schema('knowsLanguage'), null, doc);
          if (list) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return", defaultPreferredLanguages);
        case 2:
          languageCodeArray = [];
          list.elements.forEach(function (item) {
            // console.log('@@ item ' + item)
            var lang = external_SolidLogic_.store.any(item, src_ns.solid('publicId'), null, doc);
            if (!lang) {
              console.warn('getPreferredLanguages: No publiID of language.');
              return;
            }
            if (!lang.value.startsWith(languageCodeURIBase)) {
              console.error("What should be a language code ".concat(lang.value, " does not start with ").concat(languageCodeURIBase));
              return;
            }
            var code = lang.value.slice(languageCodeURIBase.length);
            languageCodeArray.push(code);
          });
          if (!(languageCodeArray.length > 0)) {
            _context.next = 3;
            break;
          }
          console.log("     User knows languages with codes: \"".concat(languageCodeArray.join(','), "\""));
          return _context.abrupt("return", addDefaults(languageCodeArray));
        case 3:
          return _context.abrupt("return", null);
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getPreferredLanguagesFor.apply(this, arguments);
}
function getPreferredLanguages() {
  return _getPreferredLanguages.apply(this, arguments);
}

/* From an array of bindings with a names for each row,
 * remove dupliacte names for the same thing, leaving the user's
 * preferred language version
*/
function _getPreferredLanguages() {
  _getPreferredLanguages = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee2() {
    var me, solidLanguagePrefs;
    return regenerator_default().wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 1;
          return external_SolidLogic_.authn.currentUser();
        case 1:
          me = _context2.sent;
          if (!me) {
            _context2.next = 3;
            break;
          }
          _context2.next = 2;
          return getPreferredLanguagesFor(me);
        case 2:
          solidLanguagePrefs = _context2.sent;
          if (!solidLanguagePrefs) {
            _context2.next = 3;
            break;
          }
          return _context2.abrupt("return", solidLanguagePrefs);
        case 3:
          if (!(typeof navigator !== 'undefined')) {
            _context2.next = 5;
            break;
          }
          if (!navigator.languages) {
            _context2.next = 4;
            break;
          }
          return _context2.abrupt("return", addDefaults(navigator.languages.map(function (longForm) {
            return longForm.split('-')[0];
          })));
        case 4:
          if (!navigator.language) {
            _context2.next = 5;
            break;
          }
          return _context2.abrupt("return", addDefaults([navigator.language.split('-')[0]]));
        case 5:
          return _context2.abrupt("return", defaultPreferredLanguages);
        case 6:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _getPreferredLanguages.apply(this, arguments);
}
function filterByLanguage(bindings, languagePrefs) {
  var uris = {};
  bindings.forEach(function (binding) {
    // Organize names by their subject
    var uri = binding.subject.value;
    uris[uri] = uris[uri] || [];
    uris[uri].push(binding);
  });
  var languagePrefs2 = languagePrefs || defaultPreferredLanguages;
  languagePrefs2.reverse(); // Preferred last

  var slimmed = [];
  // console.log(` @@ {languagePrefs2 ${languagePrefs2}`)
  for (var u in uris) {
    // needs hasOwnProperty ?
    var _bindings = uris[u];
    var sortMe = _bindings.map(function (binding) {
      var lang = binding.name['xml:lang'];
      var index = languagePrefs2.indexOf(lang);
      var pair = [index, binding];
      // console.log(`   @@ lang: ${lang}, index: ${index}`)
      return pair;
    });
    sortMe.sort(); // best at th ebottom
    sortMe.reverse(); // best at the top
    // console.debug('@@ sortMe:', sortMe)
    slimmed.push(sortMe[0][1]);
  } // map u
  src_debug/* log */.Rm(" Filter by language: ".concat(bindings.length, " -> ").concat(slimmed.length));
  return slimmed;
}
;// ./src/widgets/forms/autocomplete/publicData.ts


/* Logic to access public data stores
*
* including filtering resut by natural language etc
* See https://solidos.solidcommunity.net/public/2021/01%20Building%20Solid%20Apps%20which%20use%20Public%20Data.html
*/






var AUTOCOMPLETE_LIMIT = 200; // How many to get from server
// With 3000 we could exceed the wikidata timeout

var subjectRegexp = /\$\(subject\)/g;
// Schema.org seems to suggest NGOs are non-profit and Corporaions are for-profit
// but doesn't have explicit classes
var wikidataClasses = {
  Corporation: 'http://www.wikidata.org/entity/Q6881511',
  // Enterprise is for-profit
  EducationalOrganization: 'http://www.wikidata.org/entity/Q178706',
  // insitution
  GovernmentOrganization: 'http://www.wikidata.org/entity/Q327333',
  // government agency
  MedicalOrganization: 'http://www.wikidata.org/entity/Q4287745',
  MusicGroup: 'http://www.wikidata.org/entity/Q32178211',
  // music organization
  NGO: 'http://www.wikidata.org/entity/Q163740',
  // nonprofit organization @@
  Occupation: 'http://www.wikidata.org/entity/Q28640',
  // Profession
  // Organization: 'http://www.wikidata.org/entity/Q43229',
  Project: 'http://www.wikidata.org/entity/Q170584',
  ResearchOrganization: 'http://www.wikidata.org/entity/Q31855',
  SportsOrganization: 'http://www.wikidata.org/entity/Q4438121'
};
var instituteDetailsWikidataQuery = "prefix vcard: <http://www.w3.org/2006/vcard/ns#>\nCONSTRUCT\n{  wd:Q49108 vcard:fn ?itemLabel.\nwd:Q49108 rdf:type ?klass. ?klass rdfs:label ?klassLabel; rdfs:comment ?klassDescription .\nwd:Q49108 schema:logo ?logo;\n   schema:image ?image;\n   schema:logo  ?sealImage;\n   schema:subOrganization  ?subsidiary .\n      ?subsidiary rdfs:label ?subsidiaryLabel .\n ?supersidiary schema:subOrganization wd:Q49108 .\n      ?supersidiary rdfs:label ?supersidiaryLabel .\n  wd:Q49108 schema:location ?location .\n     ?location  schema:elevation  ?elevation .\n     ?location  wdt:P131  ?region .  ?region rdfs:label ?regionLabel .\n     ?location wdt:P625 ?coordinates .\n     ?location  schema:country  ?country . ?country rdfs:label ?countryLabel .\n}\nWHERE\n{  optional {wd:Q49108 rdfs:label ?itemLabel} .\n  optional {wd:Q49108 wdt:P154 ?logo .}\n  optional {wd:Q49108 wdt:P31 ?klass .}\n  optional {wd:Q49108 wdt:P158  ?sealImage .}\n  optional {wd:Q49108 wdt:P18 ?image .}\n\n  optional { wd:Q49108       wdt:P355 ?subsidiary . }\n  optional { ?supersidiary   wdt:P355 wd:Q49108. }\n\n  optional { wd:Q49108 wdt:P276 ?location .\n\n    optional { ?location  schema:eleveation  ?elevation }\n    optional { ?location  wdt:P131  ?region }\n    optional { ?location wdt:P625 ?coordinates }\n    optional {  ?location  wdt:P17  ?country }\n  }\n  SERVICE wikibase:label { bd:serviceParam wikibase:language \"fr,en,de,it\". }\n}";
var fetcherOptionsJsonPublicData = {
  credentials: 'omit',
  // try to avoid CORS problems. Data is public so no auth
  headers: new Headers({
    Accept: 'application/json'
  })
};
var escoParameters = {
  label: 'ESCO',
  logo: external_SolidLogic_.store.sym('https://ec.europa.eu/esco/portal/static_resource2/images/logo/logo_en.gif'),
  searchByNameURI: 'https://ec.europa.eu/esco/api/search?language=$(language)&type=occupation&text=$(name)'
  // endpoint: undefined
  // returnFormat: 'ESCO',
  // targetClass: {}
};
var dbpediaParameters = {
  label: 'DBPedia',
  logo: external_SolidLogic_.store.sym('https://upload.wikimedia.org/wikipedia/commons/thumb/7/73/DBpediaLogo.svg/263px-DBpediaLogo.svg.png'),
  searchByNameQuery: "select distinct ?subject, ?name where {\n    ?subject a $(targetClass); rdfs:label ?name\n    FILTER regex(?name, \"$(name)\", \"i\")\n  } LIMIT $(limit)",
  endpoint: 'https://dbpedia.org/sparql/'
};
var dbPediaTypeMap = {
  AcademicInsitution: 'http://umbel.org/umbel/rc/EducationalOrganization'
};
var wikidataOutgoingClassMap = {
  AcademicInsitution: 'http://www.wikidata.org/entity/Q4671277',
  Enterprise: 'http://www.wikidata.org/entity/Q6881511',
  Business: 'http://www.wikidata.org/entity/Q4830453',
  NGO: 'http://www.wikidata.org/entity/Q79913',
  CharitableOrganization: 'http://www.wikidata.org/entity/Q708676',
  Insitute: 'http://www.wikidata.org/entity/Q1664720'
};
var wikidataParameters = {
  label: 'WikiData',
  limit: 3000,
  // Need a high one as very many items, and many languages
  logo: external_SolidLogic_.store.sym('https://www.wikimedia.org/static/images/project-logos/wikidatawiki.png'),
  endpoint: 'https://query.wikidata.org/sparql',
  searchByNameQuery: "SELECT ?subject ?name\n  WHERE {\n    ?klass wdt:P279* $(targetClass) .\n    ?subject wdt:P31 ?klass .\n    ?subject rdfs:label ?name.\n    FILTER regex(?name, \"$(name)\", \"i\")\n  } LIMIT $(limit) ",
  // was SERVICE wikibase:label { bd:serviceParam wikibase:language "[AUTO_LANGUAGE],en" }

  insitituteDetailsQuery: "CONSTRUCT\n{  wd:Q49108 schema:name ?itemLabel;\n             schema:logo ?logo;\n              schema:logo  ?sealImage;\n             schema:subOrganization  ?subsidiary .\n                 ?subsidiary schema:name ?subsidiaryLabel .\n}\nWHERE\n{\n   wd:Q49108 # rdfs:label ?itemLabel ;\n             wdt:P154 ?logo;\n              wdt:P158  ?sealImage ;\n             wdt:P355  ?subsidiary .\n          #  ?subsidiary rdfs:label ?subsidiaryLabel .\n\n  SERVICE wikibase:label { bd:serviceParam wikibase:language \"[AUTO_LANGUAGE], fr\". }\n}"
};
var wikidataIncomingClassMap = {
  'http://www.wikidata.org/entity/Q15936437': src_ns.schema('CollegeOrUniversity'),
  // research university
  'http://www.wikidata.org/entity/Q1664720': src_ns.schema('EducationalOrganization'),
  // insitute @@
  'http://www.wikidata.org/entity/Q43229': src_ns.schema('Organization'),
  // research university
  'http://www.wikidata.org/entity/Q3918': src_ns.schema('CollegeOrUniversity'),
  // university
  'http://www.wikidata.org/entity/Q170584': src_ns.schema('Project'),
  // university
  'http://www.wikidata.org/entity/Q327333': src_ns.schema('GovernmentOrganization'),
  // govt agency
  'http://www.wikidata.org/entity/Q2221906': src_ns.schema('Place'),
  // geographic location
  'http://www.wikidata.org/entity/Q167037': src_ns.schema('Corporation') // Corporation
};
var variableNameToPredicateMap = {
  // allow other mappings to be added in theory hence var
  // wikidata:
  targetClass: src_ns.rdf('type'),
  // logo: ns.schema('logo'),
  sealImage: src_ns.schema('logo'),
  // image: ns.schema('image'),   defaults to shema
  shortName: src_ns.foaf('nick'),
  subsidiary: src_ns.schema('subOrganization'),
  // dbpedia - :
  city: src_ns.vcard('locality'),
  state: src_ns.vcard('region'),
  country: src_ns.vcard('country-name'),
  homepage: src_ns.foaf('homepage'),
  lat: src_ns.schema('latitude'),
  "long": src_ns.schema('longitude')
};
function bindingToTerm(item) {
  var typ = item.type.toLowerCase();
  if (typ === 'uri' || typ === 'iri') {
    return external_SolidLogic_.store.sym(item.value);
  } else if (typ === 'literal') {
    if (item['xml:lang']) {
      return new external_$rdf_.Literal(item.value, item['xml:lang']);
    } else {
      return new external_$rdf_.Literal(item.value);
    }
  } else {
    throw new Error("bindingToTerm: Unexpected type \"".concat(item.type, "\" in sparql binding}"));
  }
}
function loadFromBindings(kb, solidSubject, bindings, doc) {
  var predMap = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : variableNameToPredicateMap;
  var results = {};
  src_debug/* log */.Rm("loadFromBindings:  subject: ".concat(solidSubject));
  src_debug/* log */.Rm("                       doc: ".concat(doc));
  bindings.forEach(function (binding) {
    for (var key in binding) {
      var result = binding[key];
      var combined = JSON.stringify(result); // ( result.type, result.value )
      results[key] = results[key] || new Set();
      results[key].add(combined); // remove duplicates
    }
  });
  var _loop = function _loop(key) {
    var values = results[key];
    src_debug/* log */.Rm("    results ".concat(key, " -> ").concat(values));
    values.forEach(function (combined) {
      var result = JSON.parse(combined);
      var type = result.type,
        value = result.value;
      var obj;
      if (type === 'uri') {
        obj = kb.sym(value);
      } else if (type === 'literal') {
        obj = new external_$rdf_.Literal(value, result.language, result.datatype);
      } else {
        throw new Error("loadFromBindings:  unexpected type: ".concat(type));
      }
      if (key === 'type') {
        if (wikidataIncomingClassMap[value]) {
          obj = wikidataIncomingClassMap[value];
        } else {
          src_debug/* warn */.R8('Unmapped Wikidata Class: ' + value);
        }
      } else if (key === 'coordinates') {
        // const latlong = value // Like 'Point(-71.106111111 42.375)'
        src_debug/* log */.Rm('         @@@ hey a point: ' + value);
        // const regexp = /.*\(([-0-9\.-]*) ([-0-9\.-]*)\)/
        var regexp = /.*\(([-0-9.-]*) ([-0-9.-]*)\)/;
        var match = regexp.exec(value);
        if (match) {
          var _float = src_ns.xsd('float');
          var latitude = new external_$rdf_.Literal(match[1], null, _float);
          var longitude = new external_$rdf_.Literal(match[2], null, _float);
          kb.add(solidSubject, src_ns.schema('longitude'), longitude, doc);
          kb.add(solidSubject, src_ns.schema('latitude'), latitude, doc);
        } else {
          src_debug/* log */.Rm('Bad coordinates syntax: ' + value);
        }
      } else {
        var pred = predMap[key] || src_ns.schema(key); // fallback to just using schema.org
        kb.add(solidSubject, pred, obj, doc); // @@ deal with non-string and objects
        src_debug/* log */.Rm("  public data ".concat(pred, " ").concat(obj, "."));
      }
    });
  };
  for (var key in results) {
    _loop(key);
  }
}

/* ESCO sopecific
*/
function ESCOResultToBindings(json) {
  var results = json._embedded.results; // Array
  var bindings = results.map(function (result) {
    var name = result.title;
    var uri = result.uri; // like http://data.europa.eu/esco/occupation/57af9090-55b4-4911-b2d0-86db01c00b02
    return {
      name: {
        value: name,
        type: 'literal'
      },
      subject: {
        type: 'IRI',
        value: uri
      }
    }; // simulate SPARQL bindings
  });
  return bindings;
}

/*  Query all entities of given class and partially matching name
*/
function queryESCODataByName(_x, _x2, _x3) {
  return _queryESCODataByName.apply(this, arguments);
}

/* Cope ithe syntax probelm in wikidata timeout responses
*
* Wikidata bug: https://phabricator.wikimedia.org/T283962
* This will not be needed whn that  WDQS bug fixed.
* This is aptured in https://github.com/solidos/solid-ui/issues/403
*/
function _queryESCODataByName() {
  _queryESCODataByName = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee(filter, theClass, queryTarget) {
    var _store$fetcher;
    var limit, queryURI, response, text, json;
    return regenerator_default().wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (queryTarget.searchByNameURI) {
            _context.next = 1;
            break;
          }
          throw new Error('Missing queryTarget.searchByNameURI on queryESCODataByName');
        case 1:
          limit = queryTarget.limit || AUTOCOMPLETE_LIMIT;
          queryURI = queryTarget.searchByNameURI.replace('$(name)', filter).replace('$(limit)', '' + limit).replace('$(targetClass)', theClass.toNT());
          src_debug/* log */.Rm('Querying ESCO data - uri: ' + queryURI);
          _context.next = 2;
          return (_store$fetcher = external_SolidLogic_.store.fetcher) === null || _store$fetcher === void 0 ? void 0 : _store$fetcher.webOperation('GET', queryURI, fetcherOptionsJsonPublicData);
        case 2:
          response = _context.sent;
          text = (response === null || response === void 0 ? void 0 : response.responseText) || '';
          src_debug/* log */.Rm('    Query result  text' + text.slice(0, 500) + '...');
          if (!(text.length === 0)) {
            _context.next = 3;
            break;
          }
          throw new Error('Wot no text back from ESCO query ' + queryURI);
        case 3:
          json = JSON.parse(text); // console.log('Whole JSON return object', json)
          src_debug/* log */.Rm('    ESCO Query result JSON' + JSON.stringify(json, null, 4).slice(0, 500) + '...');
          return _context.abrupt("return", ESCOResultToBindings(json));
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _queryESCODataByName.apply(this, arguments);
}
function fixWikidataJSON(str) {
  var syntaxProblem = str.indexOf('SPARQL-QUERY');
  if (syntaxProblem < 0) return str;
  // console.log('@@ fixWikidataJSON FIXING')
  src_debug/* warn */.R8('  ### Fixing JSON with wikidata error code injection ' + str.slice(syntaxProblem, syntaxProblem + 200));
  var goodness = str.lastIndexOf('}, {');
  return str.slice(0, goodness) + ' } ] } } '; // Close binding, array, bindings, results, root object
}
/*  Query all entities of given class and partially matching name
*/
function queryPublicDataByName(_x4, _x5, _x6, _x7) {
  return _queryPublicDataByName.apply(this, arguments);
}

/* Query a database using SPARQL SELECT
*/
function _queryPublicDataByName() {
  _queryPublicDataByName = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee2(filter, theClass, languages, queryTarget) {
    var substituteStrings, languagePrefs, language, sparql, queryURI, response, _store$fetcher2, text, text2, json, bindings, _t, _t2;
    return regenerator_default().wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          substituteStrings = function _substituteStrings(template) {
            var limit = queryTarget.limit || AUTOCOMPLETE_LIMIT;
            var u1 = template.replace('$(name)', filter).replace('$(limit)', '' + limit).replace('$(language)', language);
            return u1.replace('$(targetClass)', theClass.toNT());
          };
          if (theClass) {
            _context2.next = 1;
            break;
          }
          throw new Error('queryPublicDataByName: No class provided');
        case 1:
          _context2.next = 2;
          return getPreferredLanguages();
        case 2:
          _t = _context2.sent;
          if (_t) {
            _context2.next = 3;
            break;
          }
          _t = defaultPreferredLanguages;
        case 3:
          languagePrefs = _t;
          language = languagePrefs[0] || 'en';
          if (!queryTarget.searchByNameQuery) {
            _context2.next = 4;
            break;
          }
          sparql = substituteStrings(queryTarget.searchByNameQuery);
          src_debug/* log */.Rm('Querying public data - sparql: ' + sparql);
          return _context2.abrupt("return", queryPublicDataSelect(sparql, queryTarget));
        case 4:
          if (!queryTarget.searchByNameURI) {
            _context2.next = 13;
            break;
          }
          // not sparql - random API
          queryURI = substituteStrings(queryTarget.searchByNameURI);
          _context2.prev = 5;
          _context2.next = 6;
          return (_store$fetcher2 = external_SolidLogic_.store.fetcher) === null || _store$fetcher2 === void 0 ? void 0 : _store$fetcher2.webOperation('GET', queryURI, fetcherOptionsJsonPublicData);
        case 6:
          response = _context2.sent;
          _context2.next = 8;
          break;
        case 7:
          _context2.prev = 7;
          _t2 = _context2["catch"](5);
          throw new Error("Exception when trying to fetch ".concat(queryURI, " \n ").concat(_t2));
        case 8:
          text = response.responseText || ''; // ts
          if (!(response.status !== 200)) {
            _context2.next = 9;
            break;
          }
          throw new Error("HTTP error status ".concat(response.status, " trying to fetch ").concat(queryURI, " "));
        case 9:
          src_debug/* log */.Rm('    Query result  text' + text.slice(0, 500) + '...');
          if (!(text.length === 0)) {
            _context2.next = 10;
            break;
          }
          throw new Error('queryPublicDataByName: No text back from public data query ' + queryURI);
        case 10:
          text2 = fixWikidataJSON(text); // Kludge: strip of interrupting error message
          json = JSON.parse(text2);
          src_debug/* log */.Rm('    API Query result JSON' + JSON.stringify(json, null, 4).slice(0, 500) + '...');
          if (!json._embedded) {
            _context2.next = 11;
            break;
          }
          src_debug/* log */.Rm('      Looks like ESCO');
          bindings = ESCOResultToBindings(json);
          return _context2.abrupt("return", bindings);
        case 11:
          alert('Code me: unrecognized API return format');
          throw new Error("*** Need to add code to parse unrecognized API JSON return\n".concat(JSON.stringify(json, null, 4)));
        case 12:
          _context2.next = 14;
          break;
        case 13:
          throw new Error('Query source must have either rest API or SPARQL endpoint.');
        case 14:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[5, 7]]);
  }));
  return _queryPublicDataByName.apply(this, arguments);
}
function queryPublicDataSelect(_x8, _x9) {
  return _queryPublicDataSelect.apply(this, arguments);
}

/* Load from a database using SPARQL CONSTRUCT
*/
function _queryPublicDataSelect() {
  _queryPublicDataSelect = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee3(sparql, queryTarget) {
    var _store$fetcher3;
    var myUrlWithParams, queryURI, headers, options, response, text, text2, json, bindings;
    return regenerator_default().wrap(function (_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          if (queryTarget.endpoint) {
            _context3.next = 1;
            break;
          }
          throw new Error('Missing queryTarget.endpoint required for queryPublicDataSelect');
        case 1:
          myUrlWithParams = new URL(queryTarget.endpoint);
          myUrlWithParams.searchParams.append('query', sparql);
          queryURI = myUrlWithParams.href;
          src_debug/* log */.Rm(' queryPublicDataSelect uri: ' + queryURI);
          headers = new Headers();
          headers.append('Accept', 'application/json');
          options = {
            credentials: 'omit',
            // CORS - as we know it is public
            headers: headers
          };
          _context3.next = 2;
          return (_store$fetcher3 = external_SolidLogic_.store.fetcher) === null || _store$fetcher3 === void 0 ? void 0 : _store$fetcher3.webOperation('GET', queryURI, options);
        case 2:
          response = _context3.sent;
          text = (response === null || response === void 0 ? void 0 : response.responseText) || '';
          if (!(text.length === 0)) {
            _context3.next = 3;
            break;
          }
          throw new Error('No text back from query ' + queryURI);
        case 3:
          text2 = fixWikidataJSON(text);
          json = JSON.parse(text2);
          src_debug/* log */.Rm('    Query result JSON' + JSON.stringify(json, null, 4).slice(0, 100) + '...');
          bindings = json.results.bindings;
          return _context3.abrupt("return", bindings);
        case 4:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _queryPublicDataSelect.apply(this, arguments);
}
function queryPublicDataConstruct(_x0, _x1, _x10) {
  return _queryPublicDataConstruct.apply(this, arguments);
}
function _queryPublicDataConstruct() {
  _queryPublicDataConstruct = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee4(sparql, pubicId, queryTarget) {
    var _store$fetcher4;
    var myUrlWithParams, queryURI, headers, options, response, text, report;
    return regenerator_default().wrap(function (_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          src_debug/* log */.Rm('queryPublicDataConstruct: sparql:', sparql);
          if (queryTarget.endpoint) {
            _context4.next = 1;
            break;
          }
          throw new Error('Missing queryTarget.endpoint required for queryPublicDataConstruct');
        case 1:
          myUrlWithParams = new URL(queryTarget.endpoint);
          myUrlWithParams.searchParams.append('query', sparql);
          queryURI = myUrlWithParams.href;
          src_debug/* log */.Rm(' queryPublicDataConstruct uri: ' + queryURI);
          headers = new Headers();
          headers.append('Accept', 'text/turtle');
          options = {
            credentials: 'omit',
            // CORS // @tsc pain
            headers: headers // ({ Accept: 'text/turtle' } as Headers)
          };
          _context4.next = 2;
          return (_store$fetcher4 = external_SolidLogic_.store.fetcher) === null || _store$fetcher4 === void 0 ? void 0 : _store$fetcher4.webOperation('GET', queryURI, options);
        case 2:
          response = _context4.sent;
          text = (response === null || response === void 0 ? void 0 : response.responseText) || 'No response text?';
          report = text.length > 500 ? text.slice(0, 200) + ' ... ' + text.slice(-200) : text;
          src_debug/* log */.Rm('    queryPublicDataConstruct result text:' + report);
          if (!(text.length === 0)) {
            _context4.next = 3;
            break;
          }
          throw new Error('queryPublicDataConstruct: No text back from construct query:' + queryURI);
        case 3:
          (0,external_$rdf_.parse)(text, external_SolidLogic_.store, pubicId.uri, 'text/turtle');
        case 4:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _queryPublicDataConstruct.apply(this, arguments);
}
function loadPublicDataThing(_x11, _x12, _x13) {
  return _loadPublicDataThing.apply(this, arguments);
}
function _loadPublicDataThing() {
  _loadPublicDataThing = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee5(kb, subject, publicDataID) {
    var iDToFetch, headers;
    return regenerator_default().wrap(function (_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          if (!publicDataID.uri.startsWith('https://dbpedia.org/resource/')) {
            _context5.next = 1;
            break;
          }
          return _context5.abrupt("return", getDbpediaDetails(kb, subject, publicDataID));
        case 1:
          if (!publicDataID.uri.match(/^https?:\/\/www\.wikidata\.org\/entity\/.*/)) {
            _context5.next = 3;
            break;
          }
          _context5.next = 2;
          return getWikidataDetails(kb, subject, publicDataID);
        case 2:
          _context5.next = 4;
          break;
        case 3:
          iDToFetch = publicDataID.uri.startsWith('http:') ? kb.sym('https:' + publicDataID.uri.slice(5)) : publicDataID;
          headers = new Headers();
          headers.append('Accept', 'text/turtle');
          return _context5.abrupt("return", kb.fetcher.load(iDToFetch, {
            credentials: 'omit',
            headers: headers
          }));
        case 4:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _loadPublicDataThing.apply(this, arguments);
}
function getWikidataDetails(_x14, _x15, _x16) {
  return _getWikidataDetails.apply(this, arguments);
}
function _getWikidataDetails() {
  _getWikidataDetails = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee6(kb, solidSubject, publicDataID) {
    var subjRegexp, sparql;
    return regenerator_default().wrap(function (_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          subjRegexp = /wd:Q49108/g;
          sparql = instituteDetailsWikidataQuery.replace(subjRegexp, publicDataID.toNT());
          _context6.next = 1;
          return queryPublicDataConstruct(sparql, publicDataID, wikidataParameters);
        case 1:
          src_debug/* log */.Rm('getWikidataDetails: loaded.', publicDataID);
        case 2:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return _getWikidataDetails.apply(this, arguments);
}
function getWikidataDetailsOld(_x17, _x18, _x19) {
  return _getWikidataDetailsOld.apply(this, arguments);
}
function _getWikidataDetailsOld() {
  _getWikidataDetailsOld = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee7(kb, solidSubject, publicDataID) {
    var sparql, bindings;
    return regenerator_default().wrap(function (_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          sparql = "select distinct *  where {\n  optional { $(subject)  wdt:P31  ?targetClass } # instance of\n  optional { $(subject)  wdt:P154  ?logo }\n  optional { $(subject)  wdt:P158  ?sealImage }\n# optional { $(subject)  wdt:P159  ?headquartersLocation }\n\noptional { $(subject)  wdt:P17  ?country }\noptional { $(subject)  wdt:P18  ?image }\noptional { $(subject)  wdt:P1813  ?shortName }\n\noptional { $(subject)  wdt:P355  ?subsidiary }\n# SERVICE wikibase:label { bd:serviceParam wikibase:language \"fr,en,de,it\" }\n}".replace(subjectRegexp, publicDataID.toNT());
          _context7.next = 1;
          return queryPublicDataSelect(sparql, wikidataParameters);
        case 1:
          bindings = _context7.sent;
          loadFromBindings(kb, publicDataID, bindings, publicDataID.doc()); // arg2 was solidSubject
        case 2:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return _getWikidataDetailsOld.apply(this, arguments);
}
function getWikidataLocation(_x20, _x21, _x22) {
  return _getWikidataLocation.apply(this, arguments);
}
function _getWikidataLocation() {
  _getWikidataLocation = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee8(kb, solidSubject, publicDataID) {
    var sparql, bindings;
    return regenerator_default().wrap(function (_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          sparql = "select distinct *  where {\n\n  $(subject) wdt:P276 ?location .\n\n  optional { ?location  wdt:P2044  ?elevation }\n  optional { ?location  wdt:P131  ?region }\n  optional { ?location wdt:P625 ?coordinates }\noptional {  ?location  wdt:P17  ?country }\n\n# SERVICE wikibase:label { bd:serviceParam wikibase:language \"fr,en,de,it\" }\n}".replace(subjectRegexp, publicDataID.toNT());
          src_debug/* log */.Rm(' location query sparql:' + sparql);
          _context8.next = 1;
          return queryPublicDataSelect(sparql, wikidataParameters);
        case 1:
          bindings = _context8.sent;
          src_debug/* log */.Rm(' location query bindings:', bindings);
          loadFromBindings(kb, publicDataID, bindings, publicDataID.doc()); // was solidSubject
        case 2:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return _getWikidataLocation.apply(this, arguments);
}
function getDbpediaDetails(_x23, _x24, _x25) {
  return _getDbpediaDetails.apply(this, arguments);
}
function _getDbpediaDetails() {
  _getDbpediaDetails = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee9(kb, solidSubject, publicDataID) {
    var sparql, bindings;
    return regenerator_default().wrap(function (_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          // Note below the string form of the named node with <> works in SPARQL
          sparql = "select distinct ?city, ?state, ?country, ?homepage, ?logo, ?lat, ?long,  WHERE {\n    OPTIONAL { <".concat(publicDataID, "> <http://dbpedia.org/ontology/city> ?city }\n    OPTIONAL { ").concat(publicDataID, " <http://dbpedia.org/ontology/state> ?state }\n    OPTIONAL { ").concat(publicDataID, " <http://dbpedia.org/ontology/country> ?country }\n    OPTIONAL { ").concat(publicDataID, " foaf:homepage ?homepage }\n    OPTIONAL { ").concat(publicDataID, " foaf:lat ?lat; foaf:long ?long }\n    OPTIONAL { ").concat(publicDataID, " <http://dbpedia.org/ontology/country> ?country }\n   }");
          _context9.next = 1;
          return queryPublicDataSelect(sparql, dbpediaParameters);
        case 1:
          bindings = _context9.sent;
          loadFromBindings(kb, publicDataID, bindings, publicDataID.doc());
          src_debug/* log */.Rm('Finished getDbpediaDetails.');
        case 2:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return _getDbpediaDetails.apply(this, arguments);
}
;// ./src/widgets/forms/autocomplete/autocompletePicker.ts

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = autocompletePicker_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function autocompletePicker_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return autocompletePicker_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? autocompletePicker_arrayLikeToArray(r, a) : void 0; } }
function autocompletePicker_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }

/* Autocomplete Picker: Create and edit data using public data
**
** As the data source is passed as a parameter, all kinds of APIa and query services can be used
**
*/







var AUTOCOMPLETE_THRESHOLD = 4; // don't check until this many characters typed
var AUTOCOMPLETE_ROWS = 20; // 20?
var AUTOCOMPLETE_ROWS_STRETCH = 40;

/*
Autocomplete happens in 6 phases:
  1. The search string is too small to bother
  2. The search string is big enough, and we have not loaded the array
  3. The search string is big enough, and we have loaded array up to the limit
       Display them and wait for more user input
  4. The search string is big enough, and we have loaded array NOT to the limit
     but including all matches.   No more fetches.
     If user gets more precise, wait for them to select one - or reduce to a single
  5. Single one selected. Optionally waiting for accept button to be pressed, OR can change string and go to 5 or 2
  6. Locked with a value. Press 'edit' button to return to 5
*/

function setVisible(element, visible) {
  element.style.display = visible ? '' : 'none'; // Do not use visibility, it holds the real estate
}

// The core of the autocomplete UI
function renderAutoComplete(_x, _x2, _x3, _x4) {
  return _renderAutoComplete.apply(this, arguments);
} // renderAutoComplete

// ENDS
function _renderAutoComplete() {
  _renderAutoComplete = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee8(dom, acOptions, decoration, callback) {
    var complain, finish, gotIt, _gotIt, acceptButtonHandler, _acceptButtonHandler, cancelButtonHandler, _cancelButtonHandler, nameMatch, clearList, inputEventHHandler, _inputEventHHandler, loadBindingsAndFilterByLanguage, _loadBindingsAndFilterByLanguage, filterByName, refreshList, _refreshList, initialize, targetClass, lastBindings, loadedEnough, inputEventHandlerLock, allDisplayed, lastFilter, numberOfRows, div, foundName, foundObject, table, head, cell, searchInput, size, searchInputStyle;
    return regenerator_default().wrap(function (_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          initialize = function _initialize() {
            if (acOptions.currentObject) {
              // If have existing value then jump into the endgame of the autocomplete
              searchInput.value = acOptions.currentName ? acOptions.currentName.value : '??? wot no name for ' + acOptions.currentObject;
              foundName = acOptions.currentName;
              lastFilter = acOptions.currentName ? acOptions.currentName.value : undefined;
              foundObject = acOptions.currentObject;
            } else {
              searchInput.value = '';
              lastFilter = undefined;
              foundObject = undefined;
            }
            if (decoration.deleteButton) {
              setVisible(decoration.deleteButton, !!acOptions.currentObject);
            }
            if (decoration.acceptButton) {
              setVisible(decoration.acceptButton, false); // hide until input complete
            }
            if (decoration.editButton) {
              setVisible(decoration.editButton, true);
            }
            if (decoration.cancelButton) {
              setVisible(decoration.cancelButton, false); // only allow cancel when there is something to cancel
            }
            inputEventHandlerLock = false;
            clearList();
          };
          _refreshList = function _refreshList3() {
            _refreshList = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee7() {
              var rowForBinding, compareBindingsByName, languagePrefs, filter, slimmed, displayable, _iterator, _step, binding;
              return regenerator_default().wrap(function (_context7) {
                while (1) switch (_context7.prev = _context7.next) {
                  case 0:
                    compareBindingsByName = function _compareBindingsByNam(self, other) {
                      return other.name.value > self.name.value ? 1 : other.name.name < self.name.value ? -1 : 0;
                    };
                    rowForBinding = function _rowForBinding(binding) {
                      var row = dom.createElement('tr');
                      style.setStyle(row, 'autocompleteRowStyle');
                      row.setAttribute('style', 'padding: 0.3em;');
                      row.style.color = allDisplayed ? '#080' : '#088'; // green means 'you should find it here'
                      row.textContent = binding.name.value;
                      var object = bindingToTerm(binding.subject);
                      var nameTerm = bindingToTerm(binding.name);
                      row.addEventListener('click', /*#__PURE__*/function () {
                        var _ref = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee6(_event) {
                          return regenerator_default().wrap(function (_context6) {
                            while (1) switch (_context6.prev = _context6.next) {
                              case 0:
                                src_debug/* log */.Rm('       click row textContent: ' + row.textContent);
                                src_debug/* log */.Rm('       click name: ' + nameTerm.value);
                                if (object && nameTerm) {
                                  gotIt(object, nameTerm);
                                }
                              case 1:
                              case "end":
                                return _context6.stop();
                            }
                          }, _callee6);
                        }));
                        return function (_x10) {
                          return _ref.apply(this, arguments);
                        };
                      }());
                      return row;
                    }; // console.log('@@ refreshList called')
                    // rowForBinding
                    if (!inputEventHandlerLock) {
                      _context7.next = 1;
                      break;
                    }
                    src_debug/* log */.Rm("Ignoring \"".concat(searchInput.value, "\" because of lock "));
                    return _context7.abrupt("return");
                  case 1:
                    src_debug/* log */.Rm("Setting lock at \"".concat(searchInput.value, "\""));
                    inputEventHandlerLock = true;
                    _context7.next = 2;
                    return getPreferredLanguages();
                  case 2:
                    languagePrefs = _context7.sent;
                    filter = searchInput.value.trim().toLowerCase();
                    if (!(filter.length < AUTOCOMPLETE_THRESHOLD)) {
                      _context7.next = 3;
                      break;
                    }
                    // too small
                    clearList();
                    // candidatesLoaded = false
                    numberOfRows = AUTOCOMPLETE_ROWS;
                    _context7.next = 6;
                    break;
                  case 3:
                    if (!(!allDisplayed || !lastFilter || !filter.startsWith(lastFilter))) {
                      _context7.next = 5;
                      break;
                    }
                    src_debug/* log */.Rm("   Querying database at \"".concat(filter, "\" cf last \"").concat(lastFilter, "\"."));
                    _context7.next = 4;
                    return loadBindingsAndFilterByLanguage(filter, languagePrefs);
                  case 4:
                    lastBindings = _context7.sent;
                  case 5:
                    // Trim table as search gets tighter:
                    slimmed = filterByName(filter, lastBindings);
                    if (loadedEnough && slimmed.length <= AUTOCOMPLETE_ROWS_STRETCH) {
                      numberOfRows = slimmed.length; // stretch if it means we get all items
                    }
                    allDisplayed = loadedEnough && slimmed.length <= numberOfRows;
                    src_debug/* log */.Rm(" Filter:\"".concat(filter, "\" lastBindings: ").concat(lastBindings.length, ", slimmed to ").concat(slimmed.length, "; rows: ").concat(numberOfRows, ", Enough? ").concat(loadedEnough, ", All displayed? ").concat(allDisplayed));
                    displayable = slimmed.slice(0, numberOfRows);
                    displayable.sort(compareBindingsByName);
                    clearList();
                    _iterator = _createForOfIteratorHelper(displayable);
                    try {
                      for (_iterator.s(); !(_step = _iterator.n()).done;) {
                        binding = _step.value;
                        table.appendChild(rowForBinding(binding));
                      }
                    } catch (err) {
                      _iterator.e(err);
                    } finally {
                      _iterator.f();
                    }
                    if (slimmed.length === 1) {
                      gotIt(bindingToTerm(slimmed[0].subject), bindingToTerm(slimmed[0].name));
                    }
                  case 6:
                    // else
                    inputEventHandlerLock = false;
                  case 7:
                  case "end":
                    return _context7.stop();
                }
              }, _callee7);
            }));
            return _refreshList.apply(this, arguments);
          };
          refreshList = function _refreshList2() {
            return _refreshList.apply(this, arguments);
          };
          filterByName = function _filterByName(filter, bindings) {
            return bindings.filter(function (binding) {
              return nameMatch(filter, binding.name.value);
            });
          };
          _loadBindingsAndFilterByLanguage = function _loadBindingsAndFilte2() {
            _loadBindingsAndFilterByLanguage = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee5(filter, languagePrefs) {
              var bindings, slimmed, _t;
              return regenerator_default().wrap(function (_context5) {
                while (1) switch (_context5.prev = _context5.next) {
                  case 0:
                    _context5.prev = 0;
                    _context5.next = 1;
                    return queryPublicDataByName(filter, targetClass, languagePrefs || defaultPreferredLanguages, acOptions.queryParams);
                  case 1:
                    bindings = _context5.sent;
                    _context5.next = 3;
                    break;
                  case 2:
                    _context5.prev = 2;
                    _t = _context5["catch"](0);
                    complain('Error querying db of organizations: ' + _t);
                    inputEventHandlerLock = false;
                    return _context5.abrupt("return");
                  case 3:
                    loadedEnough = bindings.length < AUTOCOMPLETE_LIMIT;
                    if (loadedEnough) {
                      lastFilter = filter;
                    } else {
                      lastFilter = undefined;
                    }
                    clearList();
                    slimmed = filterByLanguage(bindings, languagePrefs);
                    return _context5.abrupt("return", slimmed);
                  case 4:
                  case "end":
                    return _context5.stop();
                }
              }, _callee5, null, [[0, 2]]);
            }));
            return _loadBindingsAndFilterByLanguage.apply(this, arguments);
          };
          loadBindingsAndFilterByLanguage = function _loadBindingsAndFilte(_x0, _x1) {
            return _loadBindingsAndFilterByLanguage.apply(this, arguments);
          };
          _inputEventHHandler = function _inputEventHHandler3() {
            _inputEventHHandler = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee4(_event) {
              return regenerator_default().wrap(function (_context4) {
                while (1) switch (_context4.prev = _context4.next) {
                  case 0:
                    // console.log('@@ AC inputEventHHandler called')
                    setVisible(decoration.cancelButton, true); // only allow cancel when there is something to cancel
                    refreshList(); /// @@  debounqce does not work with jest
                    /*
                    if (runningTimeout) {
                      clearTimeout(runningTimeout)
                    }
                    runningTimeout = setTimeout(refreshList, AUTOCOMPLETE_DEBOUNCE_MS)
                    */
                  case 1:
                  case "end":
                    return _context4.stop();
                }
              }, _callee4);
            }));
            return _inputEventHHandler.apply(this, arguments);
          };
          inputEventHHandler = function _inputEventHHandler2(_x9) {
            return _inputEventHHandler.apply(this, arguments);
          };
          clearList = function _clearList() {
            while (table.children.length > 1) {
              table.removeChild(table.lastChild);
            }
          };
          nameMatch = function _nameMatch(filter, candidate) {
            var parts = filter.split(' '); // Each name part must be somewhere
            for (var j = 0; j < parts.length; j++) {
              var word = parts[j];
              if (candidate.toLowerCase().indexOf(word) < 0) return false;
            }
            return true;
          };
          _cancelButtonHandler = function _cancelButtonHandler3() {
            _cancelButtonHandler = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee3(_event) {
              return regenerator_default().wrap(function (_context3) {
                while (1) switch (_context3.prev = _context3.next) {
                  case 0:
                    src_debug/* log */.Rm('Auto complete: Canceled by user! ');
                    if (acOptions.permanent) {
                      initialize();
                    } else {
                      if (div.parentNode) {
                        div.parentNode.removeChild(div);
                      }
                    }
                  case 1:
                  case "end":
                    return _context3.stop();
                }
              }, _callee3);
            }));
            return _cancelButtonHandler.apply(this, arguments);
          };
          cancelButtonHandler = function _cancelButtonHandler2(_x8) {
            return _cancelButtonHandler.apply(this, arguments);
          };
          _acceptButtonHandler = function _acceptButtonHandler3() {
            _acceptButtonHandler = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee2(_event) {
              return regenerator_default().wrap(function (_context2) {
                while (1) switch (_context2.prev = _context2.next) {
                  case 0:
                    if (foundName && searchInput.value === foundName.value) {
                      // still
                      finish(foundObject, foundName);
                    }
                  case 1:
                  case "end":
                    return _context2.stop();
                }
              }, _callee2);
            }));
            return _acceptButtonHandler.apply(this, arguments);
          };
          acceptButtonHandler = function _acceptButtonHandler2(_x7) {
            return _acceptButtonHandler.apply(this, arguments);
          };
          _gotIt = function _gotIt3() {
            _gotIt = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee(object, name) {
              return regenerator_default().wrap(function (_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    if (!decoration.acceptButton) {
                      _context.next = 1;
                      break;
                    }
                    decoration.acceptButton.disbaled = false;
                    setVisible(decoration.acceptButton, true); // now wait for confirmation
                    searchInput.value = name.value; // complete it
                    foundName = name;
                    foundObject = object;
                    src_debug/* log */.Rm('Auto complete: name: ' + name);
                    src_debug/* log */.Rm('Auto complete: waiting for accept ' + object);
                    clearList(); // This may be an option - nice and clean but does not allow change of mind
                    return _context.abrupt("return");
                  case 1:
                    setVisible(decoration.cancelButton, true);
                    finish(object, name);
                  case 2:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));
            return _gotIt.apply(this, arguments);
          };
          gotIt = function _gotIt2(_x5, _x6) {
            return _gotIt.apply(this, arguments);
          };
          finish = function _finish(object, name) {
            src_debug/* log */.Rm('Auto complete: finish! ' + object);
            if (object.termType === 'Literal' && acOptions.queryParams.objectURIBase) {
              object = external_SolidLogic_.store.sym(acOptions.queryParams.objectURIBase.value + object.value);
            }
            // remove(decoration.cancelButton)
            // remove(decoration.acceptButton)
            // remove(div)
            clearList();
            callback(object, name);
          };
          complain = function _complain(message) {
            var errorRow = table.appendChild(dom.createElement('tr'));
            src_debug/* log */.Rm(message);
            var err = new Error(message);
            errorRow.appendChild(errorMessageBlock(dom, err, 'pink'));
            // errorMessageBlock will log the stack to the console
            style.setStyle(errorRow, 'autocompleteRowStyle');
            errorRow.style.padding = '1em';
          }; // refreshList
          // initialiize
          // const queryParams: QueryParameters = acOptions.queryParams
          targetClass = acOptions.targetClass;
          if (targetClass) {
            _context8.next = 1;
            break;
          }
          throw new Error('renderAutoComplete: missing targetClass');
        case 1:
          // console.log(`renderAutoComplete: targetClass=${targetClass}` )
          if (decoration.acceptButton) {
            decoration.acceptButton.addEventListener('click', acceptButtonHandler, false);
          }
          if (decoration.cancelButton) {
            decoration.cancelButton.addEventListener('click', cancelButtonHandler, false);
          }

          // var candidatesLoaded = false
          loadedEnough = false;
          inputEventHandlerLock = false;
          allDisplayed = false;
          lastFilter = undefined;
          numberOfRows = AUTOCOMPLETE_ROWS; // this gets slimmed down
          div = dom.createElement('div');
          foundName = undefined; // once found accepted string must match this
          foundObject = undefined;
          table = div.appendChild(dom.createElement('table'));
          table.setAttribute('data-testid', 'autocomplete-table');
          table.setAttribute('style', 'max-width: 30em; margin: 0.5em;');
          head = table.appendChild(dom.createElement('tr'));
          style.setStyle(head, 'autocompleteRowStyle'); // textInputStyle or
          cell = head.appendChild(dom.createElement('td'));
          searchInput = cell.appendChild(dom.createElement('input'));
          searchInput.setAttribute('type', 'text');
          initialize();
          size = acOptions.size || styleConstants.textInputSize || 20;
          searchInput.setAttribute('size', size);
          searchInput.setAttribute('data-testid', 'autocomplete-input');
          searchInputStyle = style.textInputStyle ||
          // searchInputStyle ?
          'border: 0.1em solid #444; border-radius: 0.5em; width: 100%; font-size: 100%; padding: 0.1em 0.6em'; // @
          searchInput.setAttribute('style', searchInputStyle);
          searchInput.addEventListener('keyup', function (event) {
            if (event.keyCode === 13) {
              acceptButtonHandler(event);
            }
          }, false);
          searchInput.addEventListener('input', inputEventHHandler);
          // console.log('@@ renderAutoComplete returns ' + div.innerHTML)
          return _context8.abrupt("return", div);
        case 2:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return _renderAutoComplete.apply(this, arguments);
}
;// ./src/widgets/forms/autocomplete/autocompleteBar.ts

function autocompleteBar_createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = autocompleteBar_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function autocompleteBar_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return autocompleteBar_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? autocompleteBar_arrayLikeToArray(r, a) : void 0; } }
function autocompleteBar_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }

/* The Autocomplete Control with decorations

This control has the buttons which control the state between editing, viewing, searching, accepting
and so on.  See the state diagram in the documentation.  The AUtocomplete Picker does the main work.

*/





 // dbpediaParameters

var WEBID_NOUN = 'Solid ID';
var GREEN_PLUS = iconBase/* icons */.Pt.iconBase + 'noun_34653_green.svg';
var SEARCH_ICON = iconBase/* icons */.Pt.iconBase + 'noun_Search_875351.svg';
var EDIT_ICON = iconBase/* icons */.Pt.iconBase + 'noun_253504.svg';
// const DELETE_ICON = icons.iconBase + 'noun_2188_red.svg'

function renderAutocompleteControl(_x, _x2, _x3, _x4, _x5, _x6) {
  return _renderAutocompleteControl.apply(this, arguments);
} // renderAutocompleteControl

// ends
function _renderAutocompleteControl() {
  _renderAutocompleteControl = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee6(dom, person, barOptions, acOptions, addOneIdAndRefresh, deleteOne) {
    var autoCompleteDone, _autoCompleteDone, greenButtonHandler, _greenButtonHandler, removeDecorated, displayAutocomplete, _displayAutocomplete, searchButtonHandler, _searchButtonHandler, droppedURIHandler, _droppedURIHandler, acceptButton, cancelButton, deleteButtonContainer, noun, deleteButton, editButton, editing, syncEditingStatus, decoration, decoratedAutocomplete, creationArea, plus;
    return regenerator_default().wrap(function (_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          syncEditingStatus = function _syncEditingStatus() {
            if (editing) {
              setVisible(editButton, false);
              setVisible(acceptButton, false); // not till got it
              setVisible(cancelButton, false);
            } else {
              setVisible(editButton, true);
              setVisible(acceptButton, false);
              setVisible(cancelButton, false);
            }
          };
          _droppedURIHandler = function _droppedURIHandler3() {
            _droppedURIHandler = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee5(uris) {
              var _iterator, _step, webid, _t2;
              return regenerator_default().wrap(function (_context5) {
                while (1) switch (_context5.prev = _context5.next) {
                  case 0:
                    _iterator = autocompleteBar_createForOfIteratorHelper(uris);
                    _context5.prev = 1;
                    _iterator.s();
                  case 2:
                    if ((_step = _iterator.n()).done) {
                      _context5.next = 4;
                      break;
                    }
                    webid = _step.value;
                    _context5.next = 3;
                    return addOneIdAndRefresh(person, webid);
                  case 3:
                    _context5.next = 2;
                    break;
                  case 4:
                    _context5.next = 6;
                    break;
                  case 5:
                    _context5.prev = 5;
                    _t2 = _context5["catch"](1);
                    _iterator.e(_t2);
                  case 6:
                    _context5.prev = 6;
                    _iterator.f();
                    return _context5.finish(6);
                  case 7:
                  case "end":
                    return _context5.stop();
                }
              }, _callee5, null, [[1, 5, 6, 7]]);
            }));
            return _droppedURIHandler.apply(this, arguments);
          };
          droppedURIHandler = function _droppedURIHandler2(_x1) {
            return _droppedURIHandler.apply(this, arguments);
          };
          _searchButtonHandler = function _searchButtonHandler3() {
            _searchButtonHandler = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee4(_event) {
              return regenerator_default().wrap(function (_context4) {
                while (1) switch (_context4.prev = _context4.next) {
                  case 0:
                    if (!decoratedAutocomplete) {
                      _context4.next = 1;
                      break;
                    }
                    creationArea.removeChild(decoratedAutocomplete);
                    decoratedAutocomplete = undefined;
                    _context4.next = 2;
                    break;
                  case 1:
                    _context4.next = 2;
                    return displayAutocomplete();
                  case 2:
                  case "end":
                    return _context4.stop();
                }
              }, _callee4);
            }));
            return _searchButtonHandler.apply(this, arguments);
          };
          searchButtonHandler = function _searchButtonHandler2(_x0) {
            return _searchButtonHandler.apply(this, arguments);
          };
          _displayAutocomplete = function _displayAutocomplete3() {
            _displayAutocomplete = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee3() {
              var _t;
              return regenerator_default().wrap(function (_context3) {
                while (1) switch (_context3.prev = _context3.next) {
                  case 0:
                    decoratedAutocomplete = dom.createElement('div');
                    decoratedAutocomplete.setAttribute('style', 'display: flex; flex-flow: wrap;');
                    _t = decoratedAutocomplete;
                    _context3.next = 1;
                    return renderAutoComplete(dom, acOptions, decoration, autoCompleteDone);
                  case 1:
                    _t.appendChild.call(_t, _context3.sent);
                    // console.log('@@ acceptButton', acceptButton)
                    decoratedAutocomplete.appendChild(acceptButton);
                    // console.log('@@ cancelButton', cancelButton)

                    decoratedAutocomplete.appendChild(cancelButton);
                    // console.log('@@ editButton', editButton)

                    decoratedAutocomplete.appendChild(editButton);
                    // console.log('@@ deleteButtonContainer', deleteButtonContainer)

                    decoratedAutocomplete.appendChild(deleteButtonContainer);
                    creationArea.appendChild(decoratedAutocomplete);
                  case 2:
                  case "end":
                    return _context3.stop();
                }
              }, _callee3);
            }));
            return _displayAutocomplete.apply(this, arguments);
          };
          displayAutocomplete = function _displayAutocomplete2() {
            return _displayAutocomplete.apply(this, arguments);
          };
          removeDecorated = function _removeDecorated() {
            if (decoratedAutocomplete) {
              creationArea.removeChild(decoratedAutocomplete);
              decoratedAutocomplete = undefined;
            }
          };
          _greenButtonHandler = function _greenButtonHandler3() {
            _greenButtonHandler = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee2(_event) {
              var webid;
              return regenerator_default().wrap(function (_context2) {
                while (1) switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.next = 1;
                    return askName(dom, external_SolidLogic_.store, creationArea, src_ns.vcard('url'), undefined, WEBID_NOUN);
                  case 1:
                    webid = _context2.sent;
                    if (webid) {
                      _context2.next = 2;
                      break;
                    }
                    return _context2.abrupt("return");
                  case 2:
                    return _context2.abrupt("return", addOneIdAndRefresh(person, webid));
                  case 3:
                  case "end":
                    return _context2.stop();
                }
              }, _callee2);
            }));
            return _greenButtonHandler.apply(this, arguments);
          };
          greenButtonHandler = function _greenButtonHandler2(_x9) {
            return _greenButtonHandler.apply(this, arguments);
          };
          _autoCompleteDone = function _autoCompleteDone3() {
            _autoCompleteDone = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee(object, name) {
              return regenerator_default().wrap(function (_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    if (acOptions.permanent) {
                      // remember to set this in publicid panel
                      setVisible(editButton, true);
                      setVisible(acceptButton, false);
                      setVisible(cancelButton, false);
                    } else {
                      // console.log('temporary - removed decoratiion')
                      removeDecorated();
                    }
                    return _context.abrupt("return", addOneIdAndRefresh(object, name));
                  case 1:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));
            return _autoCompleteDone.apply(this, arguments);
          };
          autoCompleteDone = function _autoCompleteDone2(_x7, _x8) {
            return _autoCompleteDone.apply(this, arguments);
          };
          acceptButton = continueButton(dom);
          acceptButton.setAttribute('data-testid', 'accept-button');
          cancelButton = buttons_cancelButton(dom);
          cancelButton.setAttribute('data-testid', 'cancel-button');
          deleteButtonContainer = dom.createElement('div');
          noun = acOptions.targetClass ? label_label(acOptions.targetClass) : 'item';
          deleteButton = deleteButtonWithCheck(dom, deleteButtonContainer, noun, deleteOne); // need to knock out this UI or caller does that
          deleteButton.setAttribute('data-testid', 'delete-button');
          editButton = buttons_button(dom, EDIT_ICON, 'Edit', function (_event) {
            editing = !editing;
            syncEditingStatus();
          });
          editButton.setAttribute('data-testid', 'edit-button');
          editing = true;
          decoration = {
            acceptButton: acceptButton,
            cancelButton: cancelButton,
            editButton: editButton,
            deleteButton: deleteButton
          };
          decoratedAutocomplete = undefined;
          creationArea = dom.createElement('div');
          creationArea.style.display = 'flex';
          creationArea.style.flexDirection = 'row';
          if (!(acOptions.permanent || acOptions.currentObject)) {
            _context6.next = 1;
            break;
          }
          _context6.next = 1;
          return displayAutocomplete();
        case 1:
          if (barOptions.editable) {
            // creationArea.appendChild(await renderAutoComplete(dom, barOptions, autoCompleteDone)) wait for searchButton
            creationArea.style.width = '100%';
            if (barOptions.manualURIEntry) {
              plus = creationArea.appendChild(buttons_button(dom, GREEN_PLUS, barOptions.idNoun, greenButtonHandler));
              makeDropTarget(plus, droppedURIHandler, undefined);
            }
            if (barOptions.dbLookup && !acOptions.currentObject && !acOptions.permanent) {
              creationArea.appendChild(buttons_button(dom, SEARCH_ICON, barOptions.idNoun, searchButtonHandler));
            }
          }
          syncEditingStatus();
          return _context6.abrupt("return", creationArea);
        case 2:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return _renderAutocompleteControl.apply(this, arguments);
}
;// ./src/widgets/forms/autocomplete/autocompleteField.ts


/* Form field for doing autocompleete
 */






/**
  * Render a autocomplete form field
  *
  * The autocomplete form searches for an object in a definitive public database,
  * and allows the user to search for it by name, displaying a list of objects whose names match
  * the input to date, and letting  the user either click on one of the list,
  * or just go on untill there is only one.  The process then returns two values,
  * the URiI of the object and its name.
  *
  * @param dom The HTML Document object aka Document Object Model
  * @param container  If present, the created widget will be appended to this
  * @param already A hash table of (form, subject) kept to prevent recursive forms looping
  * @param subject The thing about which the form displays/edits data
  * @param form The form or field to be rendered
  * @param doc The web document in which the data is
  * @param callbackFunction Called when data is changed so other parts can be refreshed.
  *
  * Form properties:
  * @param ui:property  The property to store the object itself
  * @param ui:labelProperty The property used to store the name of the object
  * @param ui:category The class of objects to be searched, if fixed (else dep on class of subject)
  *
  * @returns The HTML widget created
 */

function autocompleteField(dom, container, already, subject, form, doc, callbackFunction) {
  var _kb$updater;
  function addOneIdAndRefresh(_x, _x2) {
    return _addOneIdAndRefresh.apply(this, arguments);
  }
  function _addOneIdAndRefresh() {
    _addOneIdAndRefresh = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee(result, name) {
      var oldValue, oldName, deletables, insertables, _kb$updater2, _t;
      return regenerator_default().wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (name) {
              _context.next = 1;
              break;
            }
            throw new Error('autocompleteField:  No name set.');
          case 1:
            oldValue = kb.the(subject, property, null, doc);
            if (!oldValue) {
              _context.next = 2;
              break;
            }
            oldName = kb.any(oldValue, labelProperty, null, doc);
            if (!(oldValue.equals(result) && oldName && oldName.sameTerm(name))) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            deletables = oldValue ? kb.statementsMatching(subject, property, oldValue, doc).concat(kb.statementsMatching(oldValue, labelProperty, null, doc)) : []; // console.log('autocompleteField Deletables ' + deletables.map(st => st.toNT()))
            insertables = [(0,external_$rdf_.st)(subject, property, result, doc), (0,external_$rdf_.st)(result, labelProperty, name, doc)]; // @@ track the language of the  name too!
            // console.log(`AC form: ${deletables.length} to delete and ${insertables.length} to insert`)
            _context.prev = 3;
            _context.next = 4;
            return (_kb$updater2 = kb.updater) === null || _kb$updater2 === void 0 ? void 0 : _kb$updater2.updateMany(deletables, insertables);
          case 4:
            _context.next = 6;
            break;
          case 5:
            _context.prev = 5;
            _t = _context["catch"](3);
            callbackFunction(false, _t);
            box.appendChild(errorMessageBlock(dom, 'Autocomplete form data update error:' + _t, null, _t));
            return _context.abrupt("return");
          case 6:
            callbackFunction(true, '');
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 5]]);
    }));
    return _addOneIdAndRefresh.apply(this, arguments);
  }
  function deleteOne(_x3, _x4) {
    return _deleteOne.apply(this, arguments);
  }
  function _deleteOne() {
    _deleteOne = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee2(_result, _name) {
      var oldValue, deletables, insertables, _kb$updater3, e2, _t2;
      return regenerator_default().wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            oldValue = kb.the(subject, property, null, doc);
            if (oldValue) {
              _context2.next = 1;
              break;
            }
            callbackFunction(false, 'NO data to elete');
            box.appendChild(errorMessageBlock(dom, 'Autocomplete delete: no old data!'));
            return _context2.abrupt("return");
          case 1:
            // const oldName = kb.any(oldValue as any, labelProperty as any, null, doc)
            deletables = kb.statementsMatching(subject, property, oldValue, doc).concat(kb.statementsMatching(oldValue, labelProperty, null, doc)); // console.log('autocompleteField Deletables ' + deletables.map(st => st.toNT()))
            insertables = []; // console.log(`AC form delete: ${deletables.length} to delete and ${insertables.length} to insert`)
            _context2.prev = 2;
            _context2.next = 3;
            return (_kb$updater3 = kb.updater) === null || _kb$updater3 === void 0 ? void 0 : _kb$updater3.updateMany(deletables, insertables);
          case 3:
            _context2.next = 5;
            break;
          case 4:
            _context2.prev = 4;
            _t2 = _context2["catch"](2);
            e2 = new Error('Autocomplete form data delete error:' + _t2);
            callbackFunction(false, _t2);
            box.appendChild(errorMessageBlock(dom, e2, null, _t2));
            return _context2.abrupt("return");
          case 5:
            callbackFunction(true, ''); // changed
          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[2, 4]]);
    }));
    return _deleteOne.apply(this, arguments);
  }
  if (subject.termType !== 'NamedNode') {
    throw new Error('Sorry this field only works on NamedNode subjects (for editable)');
  }
  var kb = external_SolidLogic_.store;
  var formDoc = form.doc ? form.doc() : null; // @@ if blank no way to know

  var box = dom.createElement('div');
  if (container) container.appendChild(box);
  var lhs = dom.createElement('div');
  lhs.setAttribute('class', 'formFieldName');
  lhs.setAttribute('style', style.formFieldNameBoxStyle);
  box.appendChild(lhs);
  var rhs = dom.createElement('div');
  rhs.setAttribute('class', 'formFieldValue');
  box.appendChild(rhs);
  var property = kb.any(form, src_ns.ui('property'));
  if (!property) {
    return box.appendChild(errorMessageBlock(dom, 'Error: No property given for autocomplete field: ' + form));
  }
  var labelProperty = kb.any(form, src_ns.ui('labelProperty')) || src_ns.schema('name');

  // Parse the data source into query options

  var dataSource = kb.any(form, src_ns.ui('dataSource'));
  if (!dataSource) {
    // console.log('@@ connectedStatements ACF ', kb.connectedStatements(form).map(x => x.toNT()).join('\n'))
    return box.appendChild(errorMessageBlock(dom, 'Error: No data source given for autocomplete field: ' + form));
  }
  var queryParams = {
    // targetClass: kb.any(dataSource, ns.ui('targetClass'), null, dataSource.doc()) as NamedNode | undefined,
    label: kb.anyJS(dataSource, src_ns.schema('name'), null, dataSource.doc()),
    logo: kb.any(dataSource, src_ns.schema('logo'), null, dataSource.doc())
  };

  // @@ Should we pass the target class in from the data source definition or use a current type of the subject
  var targetClass = kb.any(form, src_ns.ui('targetClass'), null, form.doc()) ||
  // class in form takes pecedence
  kb.any(dataSource, src_ns.ui('targetClass'), null, dataSource.doc());
  if (targetClass) {
    queryParams.targetClass = targetClass;
  }
  queryParams.objectURIBase = kb.any(dataSource, src_ns.ui('objectURIBase'), null, dataSource.doc()) || undefined;

  /*
  if (!queryParams.targetClass) {
    const klass = kb.any(subject, ns.rdf('type')) as NamedNode | undefined
    // @@ be more selective of which class if many
    // @@ todo: Take ALL classes,  and compare them with those the data source knows about
    // with translation where necessary.  Find most specific of the classes for the search.
    if (!klass) throw new Error('Autocomplete: No class specified or is current type of' + subject)
    queryParams.targetClass = klass
  }
  */
  var endpoint = kb.anyJS(dataSource, src_ns.ui('endpoint'), null, dataSource.doc());
  if (endpoint) {
    // SPARQL
    queryParams.endpoint = endpoint;
    queryParams.searchByNameQuery = kb.anyJS(dataSource, src_ns.ui('searchByNameQuery'), null, dataSource.doc());
    if (!queryParams.searchByNameQuery) {
      return box.appendChild(errorMessageBlock(dom, 'Error: No searchByNameQuery given for endpoint data Source: ' + form));
    }
    queryParams.insitituteDetailsQuery = kb.anyJS(dataSource, src_ns.ui('insitituteDetailsQuery'), null, dataSource.doc());
  } else {
    // return box.appendChild(
    //  widgets.errorMessageBlock(dom, 'Error: No SPARQL endpoint given for autocomplete field: ' + form))
    var searchByNameURI = kb.anyJS(dataSource, src_ns.ui('searchByNameURI'));
    if (!searchByNameURI) {
      return box.appendChild(errorMessageBlock(dom, 'Error: No searchByNameURI OR sparql endpoint given for dataSource: ' + dataSource));
    }
    queryParams.searchByNameURI = searchByNameURI;
  }
  // It can be cleaner to just remove empty fields if you can't edit them anyway
  var suppressEmptyUneditable = kb.anyJS(form, src_ns.ui('suppressEmptyUneditable'), null, formDoc);
  var editable = (_kb$updater = kb.updater) === null || _kb$updater === void 0 ? void 0 : _kb$updater.editable(doc.uri);
  var autocompleteOptions = {
    // cancelButton?: HTMLElement,
    permanent: true,
    targetClass: queryParams.targetClass,
    // @@ simplify?
    queryParams: queryParams
  };
  autocompleteOptions.size = kb.anyJS(form, src_ns.ui('size'), null, formDoc) || undefined;
  var obj = kb.any(subject, property, undefined, doc);
  if (!obj) {
    obj = kb.any(form, src_ns.ui('default'));
    if (obj) {
      autocompleteOptions.currentObject = obj;
      autocompleteOptions.currentName = kb.any(autocompleteOptions.currentObject, labelProperty, null, doc);
    } else {
      // No data or default. Should we suprress the whole field?
      if (suppressEmptyUneditable && !editable) {
        box.style.display = 'none'; // clutter removal
        return box;
      }
    }
  } else {
    // get object and name from target data:
    autocompleteOptions.currentObject = obj;
    autocompleteOptions.currentName = kb.any(autocompleteOptions.currentObject, labelProperty, null, doc);
  }
  lhs.appendChild(fieldLabel(dom, property, form));
  var barOptions = {
    editable: editable,
    dbLookup: true
  };
  renderAutocompleteControl(dom, subject, barOptions, autocompleteOptions, addOneIdAndRefresh, deleteOne).then(function (control) {
    rhs.appendChild(control);
  }, function (err) {
    rhs.appendChild(errorMessageBlock(dom, "Error rendering autocomplete ".concat(form, ": ").concat(err), '#fee', err)); //
  });
  return box;
}

// ends
;// ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}

;// ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

;// ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

;// ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}

;// ./src/style_multiSelect.js
/*
 * BASED ON:
 * IconicMultiSelect v0.7.0
 * Licence:  MIT
 * (c) 2021 Sidney Wimart.
 * repo & configuration: https://github.com/sidneywm/iconic-multiselect
 */

/**
 * @version IconicMultiSelect v0.7.0
 * @licence  MIT
 */
var style_multiSelect_style = {
  multiselect__container: "\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n        background-color: #fff;\n        border-radius: 2px;\n        -webkit-box-shadow: 0 1px 3px 0 #d1d1d2, 0 0 0 1px #d1d1d2;\n                box-shadow: 0 1px 3px 0 #d1d1d2, 0 0 0 1px #d1d1d2;\n        -webkit-box-sizing: border-box;\n                box-sizing: border-box;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        min-height: 36px;\n        padding: 4px 8px 0 8px;\n        position: relative;\n        width: 354px;\n        margin-bottom: 5px;\n        font-size: 100%\n    ",
  /*
    multiselect__container:after: `
        content: '';
        min-height:inherit;
        font-size:0;
    `,
     multiselect__container > *: `
    color: #656565;
    font-size: 14px;
    `,
  */
  multiselect__wrapper: "\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-wrap: wrap;\n            flex-wrap: wrap;\n        height: 100%;\n        width: 100%;\n    ",
  multiselect__clear_btn: "\n        cursor: pointer;\n        align-items: center;\n        margin-bottom: 4px;\n        margin-left: 4px;\n    ",
  multiselect__options: "\n        background-color: #f6f6f6;\n        border-radius: 2px;\n        left: 0;\n        max-height: 0;\n        overflow: hidden;\n        position: absolute;\n        top: calc(100% + 3px);\n        z-index: 9999;\n        width: 100%;\n        opacity: 0;\n        transition: max-height 0.1s ease;\n    ",
  multiselect__options_visible: "\n        background-color: #f6f6f6;\n        border-radius: 2px;\n        left: 0;\n        max-height: 0;\n        overflow: hidden;\n        position: absolute;\n        top: calc(100% + 3px);\n        z-index: 9999;\n        width: 100%;\n        opacity: 0;\n        transition: max-height 0.1s ease;\n        max-height: 200px;\n        -webkit-box-shadow: 0 1px 3px 0 #d1d1d2, 0 0 0 1px #d1d1d2;\n        box-shadow: 0 1px 3px 0 #d1d1d2, 0 0 0 1px #d1d1d2;\n        opacity: 1;\n        transition: max-height 0.2s ease;\n    ",
  multiselect__options_ul: "\n        list-style: none;\n        margin: 0;\n        padding: 2px 0;\n        max-height: 200px;\n        overflow: auto;\n    ",
  multiselect__options_ul_li: "\n        cursor: pointer;\n        padding: 4px 8px;\n    ",
  // multiselect__options ul li:hover: `
  multiselect__options_ul_li_hover: "\n        background-color: #dedede;\n    ",
  /*
    multiselect__options ul li *: `
    pointer-events: none;
    `,
  */

  multiselect__options_ul_p_multiselect__options_no_results: "\n        margin: 0;\n        padding: 8px;\n        text-align: center;\n    ",
  multiselect__options_ul_p_multiselect__options_no_data: "\n        margin: 0;\n        padding: 8px;\n        text-align: center;\n    ",
  // multiselect__options ul li.multiselect__options--selected: `
  multiselect__options_ul_li_multiselect__options_selected: "\n        background-color: #656565;\n        color: #fff;\n    ",
  // multiselect__options ul li.multiselect__options--selected:hover: `
  multiselect__options_ul_li_multiselect__options_selected_hover: "\n    background-color: #656565;\n    ",
  // multiselect__options ul li.arrow-selected: `
  multiselect__options_ul_li_arrow_selected: "\n        border: 2px solid rgba(101, 101, 101, 0.5);\n    ",
  multiselect__selected: "\n        background-color: #656565;\n        border-radius: 2px;\n        color: #fff;\n        margin-bottom: 4px;\n        margin-right: 4px;\n        padding: 4px 8px;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n    ",
  multiselect__selected_multiselect__remove_btn: "\n        cursor: pointer;\n        display: flex;\n        margin-left: 6px;\n    ",
  multiselect__input: "\n        border: none;\n        -ms-flex-preferred-size: 40%;\n            flex-basis: 40%;\n        -webkit-box-flex: 1;\n            -ms-flex-positive: 1;\n                flex-grow: 1;\n        height: 5px;        \n        margin-bottom: 4px;\n        min-width: 40%;\n        outline: none;      \n    "
};
style_multiSelect_style.setStyle = function setStyle(ele, styleName) {
  ele.style = style_multiSelect_style[styleName];
};
;// ./src/widgets/multiSelect.js




/*
 * IconicMultiSelect v0.7.0
 * Licence:  MIT
 * (c) 2021 Sidney Wimart.
 * repo & configuration: https://github.com/sidneywm/iconic-multiselect
 */

/**
 * @version IconicMultiSelect v0.7.0
 * @licence  MIT
 */

var IconicMultiSelect = /*#__PURE__*/function () {
  /**
   * Iconic Multiselect constructor.
   * @param { Object[] } data - Array of objects.
   * @param { string } noData - Defines the message when there is no data input.
   * @param { string } noResults - Defines the message when there is no result if options are filtered.
   * @param { string } placeholder -  Defines the placeholder's text.
   * @param { string } select - DOM element to be selected. It must be a HTML Select tag - https://developer.mozilla.org/en-US/docs/Web/HTML/Element/select
   * @param { string } textField - Field to select in the object for the text.
   * @param { string } valueField - Field to select in the object for the value.
   */
  function IconicMultiSelect(_ref) {
    var data = _ref.data,
      itemTemplate = _ref.itemTemplate,
      noData = _ref.noData,
      noResults = _ref.noResults,
      placeholder = _ref.placeholder,
      select = _ref.select,
      container = _ref.container,
      tagTemplate = _ref.tagTemplate,
      textField = _ref.textField,
      valueField = _ref.valueField;
    classCallCheck_classCallCheck(this, IconicMultiSelect);
    _defineProperty(this, "_data", void 0);
    _defineProperty(this, "_domElements", void 0);
    _defineProperty(this, "_event", function () {});
    _defineProperty(this, "_itemTemplate", void 0);
    _defineProperty(this, "_multiselect", void 0);
    _defineProperty(this, "_noData", void 0);
    _defineProperty(this, "_noResults", void 0);
    _defineProperty(this, "_options", []);
    _defineProperty(this, "_placeholder", void 0);
    _defineProperty(this, "_select", void 0);
    _defineProperty(this, "_selectContainer", void 0);
    _defineProperty(this, "_selectedOptions", []);
    _defineProperty(this, "_tagTemplate", void 0);
    _defineProperty(this, "_textField", void 0);
    _defineProperty(this, "_valueField", void 0);
    _defineProperty(this, "_cross", "\n    <svg\n      width=\"24\"\n      height=\"24\"\n      viewBox=\"0 0 24 24\"\n      fill=\"none\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n    >\n      <path\n        d=\"M6.2253 4.81108C5.83477 4.42056 5.20161 4.42056 4.81108 4.81108C4.42056 5.20161 4.42056 5.83477 4.81108 6.2253L10.5858 12L4.81114 17.7747C4.42062 18.1652 4.42062 18.7984 4.81114 19.1889C5.20167 19.5794 5.83483 19.5794 6.22535 19.1889L12 13.4142L17.7747 19.1889C18.1652 19.5794 18.7984 19.5794 19.1889 19.1889C19.5794 18.7984 19.5794 18.1652 19.1889 17.7747L13.4142 12L19.189 6.2253C19.5795 5.83477 19.5795 5.20161 19.189 4.81108C18.7985 4.42056 18.1653 4.42056 17.7748 4.81108L12 10.5858L6.2253 4.81108Z\"\n        fill=\"currentColor\"\n      />\n    </svg>\n    ");
    this._data = data !== null && data !== void 0 ? data : [];
    this._itemTemplate = itemTemplate !== null && itemTemplate !== void 0 ? itemTemplate : null;
    this._noData = noData !== null && noData !== void 0 ? noData : 'No data found.';
    this._noResults = noResults !== null && noResults !== void 0 ? noResults : 'No results found.';
    this._placeholder = placeholder !== null && placeholder !== void 0 ? placeholder : 'Select...';
    this._select = select;
    // Timea added a container here
    this._selectContainer = container;
    this._tagTemplate = tagTemplate !== null && tagTemplate !== void 0 ? tagTemplate : null;
    this._textField = textField !== null && textField !== void 0 ? textField : null;
    this._valueField = valueField !== null && valueField !== void 0 ? valueField : null;
  }

  /**
   * Initialize the Iconic Multiselect component.
   * @public
   */
  return createClass_createClass(IconicMultiSelect, [{
    key: "init",
    value: function init() {
      // Timea change to use this._select instead of this._selectContainer
      if (this._select && this._select.nodeName === 'SELECT') {
        if (this._itemTemplate && this._data.length === 0) {
          throw new Error('itemTemplate must be initialized with data from the component settings');
        }
        if (this._tagTemplate && this._data.length === 0) {
          throw new Error('tagTemplate must be initialized with data from the component settings');
        }
        this._options = this._data.length > 0 ? this._getDataFromSettings() : this._getDataFromSelectTag();
        this._renderMultiselect();
        this._renderOptionsList();
        this._domElements = {
          clear: this._multiselect.querySelector('.multiselect__clear-btn'),
          input: this._multiselect.querySelector('.multiselect__input'),
          optionsContainer: this._multiselect.querySelector('.multiselect__options'),
          optionsContainerList: this._multiselect.querySelector('.multiselect__options > ul'),
          options: {
            list: this._multiselect.querySelectorAll('.multiselect__options > ul > li'),
            find: function find(callbackFn) {
              for (var i = 0; i < this.list.length; i++) {
                var node = this.list[i];
                if (callbackFn(node)) return node;
              }
              return undefined;
            },
            some: function some(callbackFn) {
              for (var i = 0; i < this.list.length; i++) {
                var node = this.list[i];
                if (callbackFn(node, i)) return true;
              }
              return false;
            }
          }
        };
        this._enableEventListenners();
        this._initSelectedList();
      } else {
        throw new Error("The selector '".concat(this._select, "' did not select any valid select tag."));
      }
    }

    /**
     * Subscribes to the emitted events.
     * @param { Function } callback - Callback function which emits a custom event object.
     * @public
     */
  }, {
    key: "subscribe",
    value: function subscribe(callback) {
      if (typeof callback === 'function') {
        this._event = callback;
      } else {
        throw new Error('parameter in the subscribe method is not a function');
      }
    }

    /**
     * Add an option to the selection list.
     * @param { Object: { text: string; value: string; }} option
     * @private
     */
  }, {
    key: "_addOptionToList",
    value: function _addOptionToList(option, index) {
      var _this = this;
      var html = "<span class=\"multiselect__selected\" style=\"".concat(style_multiSelect_style.multiselect__selected, "\" data-value=\"").concat(option.value, "\">").concat(this._tagTemplate ? this._processTemplate(this._tagTemplate, index) : option.text, "<span class=\"multiselect__remove-btn\" style=\"").concat(style_multiSelect_style.multiselect__remove_btn, "\">").concat(this._cross, "</span></span>");
      this._domElements.input.insertAdjacentHTML('beforebegin', html);
      var _this$_multiselect$qu = this._multiselect.querySelector("span[data-value=\"".concat(option.value, "\"]")),
        removeBtn = _this$_multiselect$qu.lastElementChild;
      removeBtn.addEventListener('click', function () {
        var target = _this._domElements.options.find(function (el) {
          return el.dataset.value === option.value;
        });
        _this._handleOption(target);
      });
    }

    /**
     * Clears all selected options.
     * @private
     */
  }, {
    key: "_clearSelection",
    value: function _clearSelection() {
      var _this2 = this;
      var _loop = function _loop() {
        var option = _this2._selectedOptions[i];
        var target = _this2._domElements.options.find(function (el) {
          return el.dataset.value === option.value;
        });
        target.classList.remove('multiselect__options--selected');
        target.setAttribute('style', style_multiSelect_style.multiselect__options);
        _this2._removeOptionFromList(target.dataset.value);
      };
      for (var i = 0; i < this._selectedOptions.length; i++) {
        _loop();
      }
      this._selectedOptions = [];
      this._handleClearSelectionBtn();
      this._handlePlaceholder();
      this._dispatchEvent({
        action: 'CLEAR_ALL_OPTIONS',
        selection: this._selectedOptions
      });
    }

    /**
     * Close the options container.
     * @private
     */
  }, {
    key: "_closeList",
    value: function _closeList() {
      this._domElements.input.value = '';
      this._domElements.optionsContainer.classList.remove('visible');
      this._domElements.optionsContainer.setAttribute('style', style_multiSelect_style.multiselect__options);
      this._filterOptions('');
      this._removeAllArrowSelected();
    }

    /**
     * Dispatches new events.
     * @param { object : { action: string; selection: { option: string; text: string; }[]; value?: string; } } event
     * @private
     */
  }, {
    key: "_dispatchEvent",
    value: function _dispatchEvent(event) {
      this._event(event);
    }

    /**
     * Enables all main event listenners.
     * @private
     */
  }, {
    key: "_enableEventListenners",
    value: function _enableEventListenners() {
      var _this3 = this;
      document.addEventListener('mouseup', function (_ref2) {
        var target = _ref2.target;
        if (!_this3._multiselect.contains(target)) {
          _this3._filterOptions('');
          _this3._closeList();
          _this3._handlePlaceholder();
        }
      });
      this._domElements.clear.addEventListener('click', function () {
        _this3._clearSelection();
      });
      for (var i = 0; i < this._domElements.options.list.length; i++) {
        var option = this._domElements.options.list[i];
        option.addEventListener('click', function (_ref3) {
          var target = _ref3.target;
          _this3._handleOption(target);
          _this3._closeList();
        });
      }
      this._domElements.input.addEventListener('focus', function () {
        _this3._domElements.optionsContainer.classList.add('visible');
        _this3._domElements.optionsContainer.setAttribute('style', style_multiSelect_style.multiselect__options_visible);
      });
      this._domElements.input.addEventListener('input', function (_ref4) {
        var value = _ref4.target.value;
        if (_this3._domElements.options.list.length > 0) {
          _this3._filterOptions(value);
        }
      });
      this._domElements.input.addEventListener('keydown', function (e) {
        _this3._handleArrows(e);
        _this3._handleBackspace(e);
        _this3._handleEnter(e);
      });
    }

    /**
     * Filters user input.
     * @param { string } value
     * @private
     */
  }, {
    key: "_filterOptions",
    value: function _filterOptions(value) {
      var _this4 = this;
      var isOpen = this._domElements.optionsContainer.classList.contains('visible');
      var valueLowerCase = value.toLowerCase();
      if (!isOpen && value.length > 0) {
        this._domElements.optionsContainer.classList.add('visible');
        this._domElements.optionsContainer.setAttribute('style', style_multiSelect_style.multiselect__options_visible);
      }
      if (this._domElements.options.list.length > 0) {
        for (var i = 0; i < this._domElements.options.list.length; i++) {
          var el = this._domElements.options.list[i];
          var text = this._itemTemplate ? this._data[i][this._textField] : el.textContent;
          if (text.toLowerCase().substring(0, valueLowerCase.length) === valueLowerCase) {
            this._domElements.optionsContainerList.appendChild(el);
          } else {
            el.parentNode && el.parentNode.removeChild(el);
          }
        }
        var hasResults = this._domElements.options.some(function (el, index) {
          return (_this4._itemTemplate ? _this4._data[index][_this4._textField] : el.textContent).toLowerCase().substring(0, valueLowerCase.length) === valueLowerCase;
        });
        this._showNoResults(!hasResults);
      }
    }
  }, {
    key: "_generateId",
    value: function _generateId(length) {
      var result = '';
      var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
    }

    /**
     * Gets data from select tag.
     * @private
     */
  }, {
    key: "_getDataFromSelectTag",
    value: function _getDataFromSelectTag() {
      var arr = [];
      var options = this._select.options;
      for (var i = 0; i < options.length; i++) {
        var item = options[i];
        arr.push({
          text: item.text,
          value: item.value,
          selected: item.hasAttribute('selected')
        });
      }
      return arr;
    }

    /**
     * Gets data from settings.
     * @private
     */
  }, {
    key: "_getDataFromSettings",
    value: function _getDataFromSettings() {
      if (this._data.length > 0 && this._valueField && this._textField) {
        var isValueFieldValid = typeof this._valueField === 'string';
        var isTextFieldValid = typeof this._textField === 'string';
        var arr = [];
        if (!isValueFieldValid || !isTextFieldValid) {
          throw new Error('textField and valueField must be of type string');
        }
        for (var i = 0; i < this._data.length; i++) {
          var item = this._data[i];
          arr.push({
            value: item[this._valueField],
            text: item[this._textField],
            selected: typeof item.selected === 'boolean' ? item.selected : false
          });
        }
        return arr;
      } else {
        return null;
      }
    }

    /**
     * Handles Arrow up & Down. Selection of an option is also possible with these keys.
     * @param { Event } event
     * @private
     */
  }, {
    key: "_handleArrows",
    value: function _handleArrows(event) {
      if (event.keyCode === 40 || event.keyCode === 38) {
        event.preventDefault();
        var isOpen = this._domElements.optionsContainer.classList.contains('visible');
        // An updated view of the container is needed because of the filtering option
        var optionsContainerList = this._multiselect.querySelector('.multiselect__options > ul');
        if (!isOpen) {
          this._domElements.optionsContainer.classList.add('visible');
          this._domElements.optionsContainer.setAttribute('style', style_multiSelect_style.multiselect__options_visible);
          optionsContainerList.firstElementChild.classList.add('arrow-selected');
          optionsContainerList.firstElementChild.setAttribute('style', style_multiSelect_style.multiselect__options_ul_li_arrow_selected);
          optionsContainerList.firstElementChild.scrollIntoView(false);
        } else {
          var selected = this._multiselect.querySelector('.multiselect__options ul li.arrow-selected');
          var action = {
            ArrowUp: 'previous',
            Up: 'previous',
            ArrowDown: 'next',
            Down: 'next'
          };
          if (!selected) {
            optionsContainerList.firstElementChild.classList.add('arrow-selected');
            optionsContainerList.firstElementChild.setAttribute('style', style_multiSelect_style.multiselect__options_ul_li_arrow_selected);
            optionsContainerList.firstElementChild.scrollIntoView(false);
            return;
          }
          selected.classList.remove('arrow-selected');
          selected.setAttribute('style', style_multiSelect_style.multiselect__options_ul_li);
          selected = selected[action[event.key] + 'ElementSibling'];

          // Go to start or end of the popup list
          if (!selected) {
            selected = optionsContainerList.children[action[event.key] === 'next' ? 0 : optionsContainerList.children.length - 1];
            selected.classList.add('arrow-selected');
            selected.setAttribute('style', style_multiSelect_style.multiselect__options_ul_li_arrow_selected);
            this._scrollIntoView(optionsContainerList, selected);
            return;
          }
          selected.classList.add('arrow-selected');
          selected.setAttribute('style', style_multiSelect_style.multiselect__options_ul_li_arrow_selected);
          this._scrollIntoView(optionsContainerList, selected);
        }
      }
    }

    /**
     * Handles the backspace key event - Deletes the preceding option in the selection list.
     * @param { Event } e
     * @private
     */
  }, {
    key: "_handleBackspace",
    value: function _handleBackspace(e) {
      if (e.keyCode === 8 && e.target.value === '') {
        var lastSelectedOption = this._selectedOptions.length > 0 ? this._selectedOptions[this._selectedOptions.length - 1] : null;
        if (lastSelectedOption) {
          var targetLastSelectedOption = this._multiselect.querySelector("li[data-value=\"".concat(lastSelectedOption.value, "\"]"));
          this._handleOption(targetLastSelectedOption);
          if (this._selectedOptions.length === 0) {
            this._domElements.optionsContainer.classList.remove('visible');
            this._domElements.optionsContainer.setAttribute('style', style_multiSelect_style.multiselect__options);
          }
        }
      }
    }

    /**
     * Shows clear selection button if some options are selected.
     * @private
     */
  }, {
    key: "_handleClearSelectionBtn",
    value: function _handleClearSelectionBtn() {
      if (this._selectedOptions.length > 0) {
        this._domElements.clear.style.display = 'flex';
      } else {
        this._domElements.clear.style.display = 'none';
      }
    }

    /**
     * Handles the enter key event.
     * @param { Event } event
     * @private
     */
  }, {
    key: "_handleEnter",
    value: function _handleEnter(event) {
      if (event.keyCode === 13) {
        var selected = this._multiselect.querySelector('.multiselect__options ul li.arrow-selected');
        if (selected) {
          this._handleOption(selected);
          this._closeList();
        }
      }
    }
  }, {
    key: "_handleOption",
    value: function _handleOption(target) {
      var dispatchEvent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      // Remove
      for (var i = 0; i < this._selectedOptions.length; i++) {
        var el = this._selectedOptions[i];
        if (el.value === target.dataset.value) {
          target.classList.remove('multiselect__options--selected');
          target.setAttribute('style', style_multiSelect_style.multiselect__options);
          this._selectedOptions.splice(i, 1);
          this._removeOptionFromList(target.dataset.value);
          this._handleClearSelectionBtn();
          this._handlePlaceholder();
          return dispatchEvent && this._dispatchEvent({
            action: 'REMOVE_OPTION',
            value: target.dataset.value,
            selection: this._selectedOptions
          });
        }
      }

      // Add
      for (var _i = 0; _i < this._options.length; _i++) {
        var option = this._options[_i];
        if (option.value === target.dataset.value) {
          target.classList.add('multiselect__options--selected');
          target.setAttribute('style', style_multiSelect_style.multiselect__options_selected);
          this._selectedOptions = [].concat(_toConsumableArray(this._selectedOptions), [option]);
          this._addOptionToList(option, _i);
          this._handleClearSelectionBtn();
          this._handlePlaceholder();
          return dispatchEvent && this._dispatchEvent({
            action: 'ADD_OPTION',
            value: target.dataset.value,
            selection: this._selectedOptions
          });
        }
      }
    }

    /**
     * Shows the placeholder if no options are selected.
     * @private
     */
  }, {
    key: "_handlePlaceholder",
    value: function _handlePlaceholder() {
      this._domElements.input.placeholder = this._placeholder;
    }
  }, {
    key: "_initSelectedList",
    value: function _initSelectedList() {
      var _this5 = this;
      var hasItemsSelected = false;
      var _loop2 = function _loop2() {
        var option = _this5._options[i];
        if (option.selected) {
          hasItemsSelected = true;
          var target = _this5._domElements.options.find(function (el) {
            return el.dataset.value === option.value;
          });
          target.classList.add('multiselect__options--selected');
          target.setAttribute('style', style_multiSelect_style.multiselect__options_selected);
          _this5._selectedOptions = [].concat(_toConsumableArray(_this5._selectedOptions), [option]);
          _this5._addOptionToList(option, i);
        }
      };
      for (var i = 0; i < this._options.length; i++) {
        _loop2();
      }
      if (hasItemsSelected) {
        this._handleClearSelectionBtn();
      }
      this._handlePlaceholder();
    }

    /**
     * Process the custom template.
     * @param { string } template
     * @private
     */
  }, {
    key: "_processTemplate",
    value: function _processTemplate(template, index) {
      var processedTemplate = template;
      var objAttr = template.match(/\$\{(\w+)\}/g).map(function (e) {
        return e.replace(/\$\{|\}/g, '');
      });
      for (var i = 0; i < objAttr.length; i++) {
        var _this$_data$index$att;
        var attr = objAttr[i];
        // eslint-disable-next-line no-useless-escape
        processedTemplate = processedTemplate.replace("${".concat(attr, "}"), (_this$_data$index$att = this._data[index][attr]) !== null && _this$_data$index$att !== void 0 ? _this$_data$index$att : '');
      }
      return processedTemplate;
    }
  }, {
    key: "_removeAllArrowSelected",
    value: function _removeAllArrowSelected() {
      var className = 'arrow-selected';
      var target = this._domElements.options.find(function (el) {
        return el.classList.contains(className);
      });
      target && target.classList.remove(className) && target.setAttribute('style', style_multiSelect_style.multiselect__options_ul_li);
    }

    /**
     * Removes an option from the list.
     * @param { string } value
     * @private
     */
  }, {
    key: "_removeOptionFromList",
    value: function _removeOptionFromList(value) {
      var optionDom = this._multiselect.querySelector("span[data-value=\"".concat(value, "\"]"));
      optionDom && optionDom.parentNode && optionDom.parentNode.removeChild(optionDom);
    }

    /**
     * Renders the multiselect options list view.
     * @private
     */
  }, {
    key: "_renderOptionsList",
    value: function _renderOptionsList() {
      var _this6 = this;
      var html = "\n        <div class=\"multiselect__options\" style=\"".concat(style_multiSelect_style.multiselect__options, "\">\n          <ul style=\"").concat(style_multiSelect_style.multiselect__options_ul, "\">\n          ").concat(this._options.length > 0 && !this._itemTemplate ? this._options.map(function (option) {
        return "\n              <li data-value=\"".concat(option.value, "\" style=\"").concat(style_multiSelect_style.multiselect__options_ul_li, "\">").concat(option.text, "</li>\n            ");
      }).join('') : '', "\n\n          ").concat(this._options.length > 0 && this._itemTemplate ? this._options.map(function (option, index) {
        return "\n              <li data-value=\"".concat(option.value, "\" style=\"").concat(style_multiSelect_style.multiselect__options_ul_li, "\">").concat(_this6._processTemplate(_this6._itemTemplate, index), "</li>\n            ");
      }).join('') : '', "\n          ").concat(this._showNoData(this._options.length === 0), "\n          </ul>\n        </div>\n      ");
      this._multiselect.insertAdjacentHTML('beforeend', html);
    }

    /**
     * Renders the multiselect view.
     * @private
     */
  }, {
    key: "_renderMultiselect",
    value: function _renderMultiselect() {
      this._select.style.display = 'none';
      var id = 'iconic-' + this._generateId(20);
      // Timea created dedicated div element because previous code was not rendering
      this._multiselect = document.createElement('div');
      this._multiselect.setAttribute('id', id);
      this._multiselect.setAttribute('class', 'multiselect__container');
      this._multiselect.setAttribute('style', style_multiSelect_style.multiselect__container);
      var html = "\n        <div class=\"multiselect__wrapper\" style=\"".concat(style_multiSelect_style.multiselect__wrapper, "\">\n          <input class=\"multiselect__input\" style=\"").concat(style_multiSelect_style.multiselect__input, "\" placeholder=\"").concat(this._placeholder, "\" />\n        </div>\n        <span style=\"display: none;\" class=\"multiselect__clear-btn\" style=\"").concat(style_multiSelect_style.multiselect__clear_btn, "\">").concat(this._cross, "</span>\n    ");
      this._multiselect.innerHTML = html;
      this._selectContainer.appendChild(this._multiselect);
    }

    /**
     * ScrollIntoView - This small utility reproduces the behavior of .scrollIntoView({ block: "nearest", inline: "nearest" })
     * This is for IE compatibility without a need of a polyfill
     * @private
     */
  }, {
    key: "_scrollIntoView",
    value: function _scrollIntoView(parent, child) {
      var rectParent = parent.getBoundingClientRect();
      var rectChild = child.getBoundingClientRect();

      // Detect if not visible at top and then scroll to the top
      if (!(rectParent.top < rectChild.bottom - child.offsetHeight)) {
        parent.scrollTop = child.clientHeight + (child.offsetTop - child.offsetHeight);
      }

      // Detect if not visible at bottom and then scroll to the bottom
      if (!(rectParent.bottom > rectChild.top + child.offsetHeight)) {
        parent.scrollTop = child.clientHeight + (child.offsetTop - child.offsetHeight) - (parent.offsetHeight - (child.offsetHeight + (child.offsetHeight - child.clientHeight)));
      }
    }

    /**
     * Shows a no data message.
     * @param { boolean } condition
     * @private
     */
  }, {
    key: "_showNoData",
    value: function _showNoData(condition) {
      return condition ? "<p class=\"multiselect__options--no-data\" style=\"".concat(style_multiSelect_style.multiselect__options_ul_p_multiselect__options_no_data, "\">").concat(this._noData, "</p>") : '';
    }

    /**
     * Shows a no results message.
     * @param { boolean } condition
     * @private
     */
  }, {
    key: "_showNoResults",
    value: function _showNoResults(condition) {
      var dom = this._multiselect.querySelector('.multiselect__options--no-results');
      if (condition) {
        var html = "<p class=\"multiselect__options--no-results\" style=\"".concat(style_multiSelect_style.multiselect__options_ul_p_multiselect__options_no_results, "\">").concat(this._noResults, "</p>");
        !dom && this._domElements.optionsContainerList.insertAdjacentHTML('beforeend', html);
      } else {
        dom && dom.parentNode && dom.parentNode.removeChild(dom);
      }
    }
  }]);
}();
;// ./src/widgets/forms.js


function forms_createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = forms_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function forms_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return forms_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? forms_arrayLikeToArray(r, a) : void 0; } }
function forms_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/*       F O R M S
 *
 *      A Vanilla Dom implementation of the form language
 */

/* global alert */



















 // Note default export



var checkMarkCharacter = "\u2713";
var cancelCharacter = "\u2715";
var dashCharacter = '-';
var forms_kb = external_SolidLogic_.store;
field[src_ns.ui('AutocompleteField').uri] = autocompleteField;

// ///////////////////////////////////////////////////////////////////////

/*                                  Form Field implementations
 **
 */
/**          Group of different fields
 **
 **  One type of form field is an ordered Group of other fields.
 **  A Form is actually just the same as a group.
 **
 ** @param {Document} dom The HTML Document object aka Document Object Model
 ** @param {Element?} container  If present, the created widget will be appended to this
 ** @param {Map} already A hash table of (form, subject) kept to prevent recursive forms looping
 ** @param {Node} subject The thing about which the form displays/edits data
 ** @param {Node} form The form or field to be rendered
 ** @param {Node} dataDoc The web document in which the data is
 ** @param {function(ok, errorMessage)} callbackFunction Called when data is changed?
 **
 ** @returns {Element} The HTML widget created
 */
function refreshOpionsSubfieldinGroup(dom, already, subject, dataDoc, callbackFunction, groupDiv, subfields) {
  var eles = groupDiv.children;
  for (var j = 0; j < subfields.length; j++) {
    // This is really messy.
    var _field = subfields[j];
    var t = mostSpecificClassURI(_field); // Field type
    if (t === src_ns.ui('Options').uri) {
      var optionsRender = fieldFunction(dom, _field);
      var newOne = optionsRender(dom, null, already, subject, _field, dataDoc, callbackFunction);
      src_debug/* log */.Rm('Refreshing Options field by replacing it.'); // better to support actual refresh
      groupDiv.insertBefore(newOne, eles[j]);
      groupDiv.removeChild(eles[j + 1]); // Remove the old one
    }
  }
}
field[src_ns.ui('Form').uri] = field[src_ns.ui('Group').uri] = function (dom, container, already, subject, form, dataDoc, callbackFunction) {
  var box = dom.createElement('div');
  var ui = src_ns.ui;
  if (container) container.appendChild(box);

  // Prevent loops
  if (!form) return;
  var key = subject.toNT() + '|' + form.toNT();
  if (already[key]) {
    // been there done that
    box.appendChild(dom.createTextNode('Group: see above ' + key));
    // TODO fix dependency cycle to solid-panes by calling outlineManager
    // const plist = [$rdf.st(subject, ns.owl('sameAs'), subject)] // @@ need prev subject
    // dom.outlineManager.appendPropertyTRs(box, plist)
    // dom.appendChild(plist)
    return box;
  }
  var already2 = {};
  for (var x in already) already2[x] = 1;
  already2[key] = 1;
  var formDoc = form.doc ? form.doc() : null; // @@ if blank no way to know
  var weight0 = forms_kb.any(form, ui('weight'), null, formDoc); // Say 0-3
  var weight = weight0 ? Number(weight0.value) : 1;
  if (weight > 3 || weight < 0) return box.appendChild(errorMessageBlock(dom, "Form Group weight ".concat(weight, " should be 0-3")));
  box.setAttribute('style', style.formGroupStyle[weight]); // Indent a group
  box.style.display = 'flex';
  box.style.flexDirection = 'column';
  box["class"] = 'form-weight-' + weight;
  var parts = forms_kb.any(form, ui('parts'), null, formDoc);
  var subfields;
  if (parts) {
    subfields = parts.elements;
  } else {
    parts = forms_kb.each(form, ui('part'), null, formDoc); //  Warning: unordered
    subfields = sortBySequence(parts);
  }
  if (!parts) {
    return box.appendChild(errorMessageBlock(dom, 'No parts to form! '));
  }
  for (var i = 0; i < subfields.length; i++) {
    var _field2 = subfields[i];
    var subFieldFunction = fieldFunction(dom, _field2); //

    var itemChanged = function itemChanged(ok, body) {
      if (ok && body && body.widget && body.widget === 'select') {
        refreshOpionsSubfieldinGroup(dom, already, subject, dataDoc, callbackFunction, box, subfields);
      }
      callbackFunction(ok, {
        widget: 'group',
        change: body
      });
    };
    box.appendChild(subFieldFunction(dom, null, already2, subject, _field2, dataDoc, itemChanged));
  }
  return box;
};

/**          Options field: Select one or more cases
 **
 ** @param {Document} dom The HTML Document object aka Document Object Model
 ** @param {Element?} container  If present, the created widget will be appended to this
 ** @param {Map} already A hash table of (form, subject) kept to prevent recursive forms looping
 ** @param {Node} subject The thing about which the form displays/edits data
 ** @param {Node} form The form or field to be rendered
 ** @param {Node} dataDoc The web document in which the data is
 ** @param {function(ok, errorMessage)} callbackFunction Called when data is changed?
 **
 ** @returns {Element} The HTML widget created
 */

field[src_ns.ui('Options').uri] = function (dom, container, already, subject, form, dataDoc, callbackFunction) {
  var kb = external_SolidLogic_.store;
  var box = dom.createElement('div');
  var formDoc = form.doc ? form.doc() : null; // @@ if blank no way to know

  var ui = src_ns.ui;
  if (container) container.appendChild(box);
  var dependingOn = kb.any(form, ui('dependingOn'));
  if (!dependingOn) {
    dependingOn = src_ns.rdf('type');
  } // @@ default to type (do we want defaults?)
  var cases = kb.each(form, ui('case'), null, formDoc);
  if (!cases) {
    box.appendChild(errorMessageBlock(dom, 'No cases to Options form. '));
  }
  var values;
  if (dependingOn.sameTerm(src_ns.rdf('type'))) {
    values = Object.keys(kb.findTypeURIs(subject)).map(function (uri) {
      return external_$rdf_.sym(uri);
    }); // Use RDF-S inference
  } else {
    values = kb.each(subject, dependingOn);
  }
  for (var i = 0; i < cases.length; i++) {
    var c = cases[i];
    var tests = kb.each(c, ui('for'), null, formDoc); // There can be multiple 'for'
    var match = false;
    for (var j = 0; j < tests.length; j++) {
      var _iterator = forms_createForOfIteratorHelper(values),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var value = _step.value;
          var test = tests[j];
          if (value.sameTerm(tests) || value.termType === test.termType && value.value === test.value) {
            match = true;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    if (match) {
      var _field3 = kb.the(c, ui('use'));
      if (!_field3) {
        box.appendChild(errorMessageBlock(dom, 'No "use" part for case in form ' + form));
        return box;
      } else {
        appendForm(dom, box, already, subject, _field3, dataDoc, callbackFunction);
      }
      break;
    }
  }
  // @@ Add box.refresh() to sync fields with values
  return box;
};

/**          Multiple field: zero or more similar subFields
 **
 ** @param {Document} dom The HTML Document object aka Document Object Model
 ** @param {Element?} container  If present, the created widget will be appended to this
 ** @param {Map} already A hash table of (form, subject) kept to prevent recursive forms looping
 ** @param {Node} subject The thing about which the form displays/edits data
 ** @param {Node} form The form or field to be rendered
 ** @param {Node} dataDoc The web document in which the data is
 ** @param {function(ok, errorMessage)} callbackFunction Called when data is changed?
 **
 ** @returns {Element} The HTML widget created
 **
 ** Form properties:
 **      @param {Boolean} reverse Make e reverse arc in the data OPS not SPO
 **      @param {NamedNode} property The property to be written in the data
 **      @param {Boolean} ordered Is the list an ordered one where the user defined the order
 */
field[src_ns.ui('Multiple').uri] = function (dom, container, already, subject, form, dataDoc, callbackFunction) {
  /** Diagnostic function
  */
  function debugString(values) {
    return values.map(function (x) {
      return x.toString().slice(-7);
    }).join(', ');
  }

  /** Add an item to the local quadstore not the UI or the web
  *
   * @param {Node} object The RDF object to be represented by this item.
   */
  function addItem() {
    return _addItem.apply(this, arguments);
  }
  /** Make a dom representation for an item
   * @param {Event} anyEvent if used as an event handler
   * @param {Node} object The RDF object to be represented by this item.
   */
  function _addItem() {
    _addItem = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee6() {
      var object, toBeInserted, msg, _t;
      return regenerator_default().wrap(function (_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            object = newThing(dataDoc); // by default just add new nodes
            if (!ordered) {
              _context6.next = 2;
              break;
            }
            createListIfNecessary(); // Sets list and unsavedList
            list.elements.push(object);
            _context6.next = 1;
            return saveListThenRefresh();
          case 1:
            _context6.next = 7;
            break;
          case 2:
            toBeInserted = reverse ? [external_$rdf_.st(object, property, subject, dataDoc)] : [external_$rdf_.st(subject, property, object, dataDoc)];
            _context6.prev = 3;
            _context6.next = 4;
            return kb.updater.update([], toBeInserted);
          case 4:
            _context6.next = 6;
            break;
          case 5:
            _context6.prev = 5;
            _t = _context6["catch"](3);
            msg = 'Error adding to unordered multiple: ' + _t;
            box.appendChild(errorMessageBlock(dom, msg));
            src_debug/* error */.z3(msg);
          case 6:
            refresh();
          case 7:
          case "end":
            return _context6.stop();
        }
      }, _callee6, null, [[3, 5]]);
    }));
    return _addItem.apply(this, arguments);
  }
  function renderItem(object) {
    function deleteThisItem() {
      return _deleteThisItem.apply(this, arguments);
    }
    /** Move the object up or down in the ordered list
     * @param {Event} anyEvent if used as an event handler
     * @param {Boolean} upwards Move this up (true) or down (false).
     */
    function _deleteThisItem() {
      _deleteThisItem = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee3() {
        var i, del;
        return regenerator_default().wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!ordered) {
                _context3.next = 5;
                break;
              }
              src_debug/* log */.Rm('pre delete: ' + debugString(list.elements));
              i = 0;
            case 1:
              if (!(i < list.elements.length)) {
                _context3.next = 4;
                break;
              }
              if (!list.elements[i].sameTerm(object)) {
                _context3.next = 3;
                break;
              }
              list.elements.splice(i, 1);
              _context3.next = 2;
              return saveListThenRefresh();
            case 2:
              return _context3.abrupt("return");
            case 3:
              i++;
              _context3.next = 1;
              break;
            case 4:
              _context3.next = 6;
              break;
            case 5:
              // unordered
              if (kb.holds(subject, property, object, dataDoc)) {
                del = [external_$rdf_.st(subject, property, object, dataDoc)];
                kb.updater.update(del, [], function (uri, ok, message) {
                  if (ok) {
                    body.removeChild(subField);
                  } else {
                    body.appendChild(errorMessageBlock(dom, 'Multiple: delete failed: ' + message));
                  }
                });
              }
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return _deleteThisItem.apply(this, arguments);
    }
    function moveThisItem(_x, _x2) {
      return _moveThisItem.apply(this, arguments);
    }
    /* A subField has been filled in
    *
    * One possibility is to not actually make the link to the thing until
    * this callback happens to avoid widow links
     */
    function _moveThisItem() {
      _moveThisItem = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee4(event, upwards) {
        var i;
        return regenerator_default().wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              // @@ possibly, allow shift+click to do move to top or bottom?
              src_debug/* log */.Rm('pre move: ' + debugString(list.elements));
              i = 0;
            case 1:
              if (!(i < list.elements.length)) {
                _context4.next = 3;
                break;
              }
              if (!list.elements[i].sameTerm(object)) {
                _context4.next = 2;
                break;
              }
              return _context4.abrupt("continue", 3);
            case 2:
              i++;
              _context4.next = 1;
              break;
            case 3:
              if (i === list.elements.length) {
                alert('list move: not found element for ' + object);
              }
              if (!upwards) {
                _context4.next = 5;
                break;
              }
              if (!(i === 0)) {
                _context4.next = 4;
                break;
              }
              alert('@@ boop - already at top   -temp message'); // @@ make boop sound
              return _context4.abrupt("return");
            case 4:
              list.elements.splice(i - 1, 2, list.elements[i], list.elements[i - 1]);
              _context4.next = 7;
              break;
            case 5:
              if (!(i === list.elements.length - 1)) {
                _context4.next = 6;
                break;
              }
              alert('@@ boop - already at bottom   -temp message'); // @@ make boop sound
              return _context4.abrupt("return");
            case 6:
              list.elements.splice(i, 2, list.elements[i + 1], list.elements[i]);
            case 7:
              _context4.next = 8;
              return saveListThenRefresh();
            case 8:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return _moveThisItem.apply(this, arguments);
    }
    function itemDone(ok, message) {
      src_debug/* log */.Rm("Item done callback for item ".concat(object.toString()));
      if (!ok) {
        // when does this happen? errors typically deal with upstream
        src_debug/* error */.z3('  Item done callback: Error: ' + message);
      }
      callbackFunction(ok, message);
    }
    debug('Multiple: render object: ' + object);
    var fn = fieldFunction(dom, element);
    var subField = fn(dom, null, already, object, element, dataDoc, itemDone); // subfields was: body.  moving to not passing that
    subField.subject = object; // Keep a back pointer between the DOM array and the RDF objects

    // delete button and move buttons
    if (kb.updater.editable(dataDoc.uri)) {
      deleteButtonWithCheck(dom, subField, multipleUIlabel, deleteThisItem);
      if (ordered) {
        // Add controsl in a frame
        var frame = dom.createElement('div');
        frame.style.display = 'grid';
        frame.style.gridTemplateColumns = 'auto 3em';
        frame.style.gridTemplateRows = '50% 50%';
        var moveUpButton = buttons_button(dom, iconBase/* icons */.Pt.iconBase + 'noun_1369237.svg', 'Move Up', /*#__PURE__*/function () {
          var _ref = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee(event) {
            return regenerator_default().wrap(function (_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  return _context.abrupt("return", moveThisItem(event, true));
                case 1:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }));
          return function (_x3) {
            return _ref.apply(this, arguments);
          };
        }());
        var moveDownButton = buttons_button(dom, iconBase/* icons */.Pt.iconBase + 'noun_1369241.svg', 'Move Down', /*#__PURE__*/function () {
          var _ref2 = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee2(event) {
            return regenerator_default().wrap(function (_context2) {
              while (1) switch (_context2.prev = _context2.next) {
                case 0:
                  return _context2.abrupt("return", moveThisItem(event, false));
                case 1:
                case "end":
                  return _context2.stop();
              }
            }, _callee2);
          }));
          return function (_x4) {
            return _ref2.apply(this, arguments);
          };
        }());
        var _shim = dom.createElement('div');
        _shim.appendChild(subField); // Subfield has its own layout
        frame.appendChild(_shim);
        frame.appendChild(moveUpButton);
        frame.appendChild(moveDownButton);
        moveUpButton.style.gridColumn = 2;
        moveDownButton.style.gridColumn = 2;
        moveUpButton.style.gridRow = 1;
        moveDownButton.style.padding = '0em'; // don't take too much space
        moveUpButton.style.padding = '0em';
        moveDownButton.style.gridRow = 2;
        _shim.style.gridColumn = 1;
        _shim.style.gridRowStart = 'span 2'; // Cover both rows
        // shim.style.gridRowEnd = 2 // Cover both rows
        return frame;
      }
    }
    return subField; // unused
  } // renderItem

  /// ///////// Body of Multiple form field implementation

  var plusIconURI = iconBase/* icons */.Pt.iconBase + 'noun_19460_green.svg'; // white plus in green circle

  var kb = external_SolidLogic_.store;
  var formDoc = form.doc ? form.doc() : null; // @@ if blank no way to know

  var box = dom.createElement('div');
  var shim = box; // no  shim
  // We don't indent multiple as it is a sort of a prefix of the next field and has contents of one.
  // box.setAttribute('style', 'padding-left: 2em; border: 0.05em solid green;')  // Indent a multiple
  var ui = src_ns.ui;
  if (container) container.appendChild(box);
  var orderedNode = kb.any(form, ui('ordered'));
  var ordered = orderedNode ? external_$rdf_.Node.toJS(orderedNode) : false;
  var property = kb.any(form, ui('property'));
  var reverse = kb.anyJS(form, ui('reverse'), null, formDoc);
  if (!property) {
    box.appendChild(errorMessageBlock(dom, 'No property to multiple: ' + form)); // used for arcs in the data
    return shim;
  }
  var multipleUIlabel = kb.any(form, ui('label'));
  if (!multipleUIlabel) multipleUIlabel = label_label(property);
  var min = kb.any(form, ui('min')); // This is the minimum number -- default 0
  min = min ? 0 + min.value : 0;
  var element = kb.any(form, ui('part')); // This is the form to use for each one
  if (!element) {
    box.appendChild(errorMessageBlock(dom, 'No part to multiple: ' + form));
    return shim;
  }
  var body = box.appendChild(dom.createElement('div'));
  body.style.display = 'flex';
  body.style.flexDirection = 'column';
  var list; // The RDF collection which keeps the ordered version or null
  var values; // Initial values - always an array.  Even when no list yet.
  values = reverse ? kb.any(null, property, subject, dataDoc) : kb.any(subject, property, null, dataDoc);
  if (ordered) {
    list = reverse ? kb.any(null, property, subject, dataDoc) : kb.any(subject, property, null, dataDoc);
    if (list) {
      values = list.elements;
    } else {
      values = [];
    }
  } else {
    values = reverse ? kb.each(null, property, subject, dataDoc) : kb.each(subject, property, null, dataDoc);
    list = null;
  }
  // Add control on the bottom for adding more items
  if (kb.updater.editable(dataDoc.uri)) {
    var tail = box.appendChild(dom.createElement('div'));
    tail.style.padding = '0.5em';
    var img = tail.appendChild(dom.createElement('img'));
    img.setAttribute('src', plusIconURI); //  plus sign
    img.setAttribute('style', 'margin: 0.2em; width: 1.5em; height:1.5em');
    img.title = 'Click to add another ' + multipleUIlabel;
    var prompt = dom.createElement('span');
    prompt.textContent = (values.length === 0 ? 'Add another ' : 'Add ') + multipleUIlabel;
    tail.addEventListener('click', /*#__PURE__*/function () {
      var _ref3 = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee5(_eventNotUsed) {
        return regenerator_default().wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 1;
              return addItem();
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      return function (_x5) {
        return _ref3.apply(this, arguments);
      };
    }(), true);
    tail.appendChild(prompt);
  }
  function createListIfNecessary() {
    if (!list) {
      list = new external_$rdf_.Collection();
      if (reverse) {
        kb.add(list, property, subject, dataDoc);
      } else {
        kb.add(subject, property, list, dataDoc);
      }
    }
  }
  function saveListThenRefresh() {
    return _saveListThenRefresh.apply(this, arguments);
  }
  function _saveListThenRefresh() {
    _saveListThenRefresh = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee7() {
      var _t2;
      return regenerator_default().wrap(function (_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            src_debug/* log */.Rm('save list: ' + debugString(list.elements)); // 20191214

            createListIfNecessary();
            _context7.prev = 1;
            _context7.next = 2;
            return kb.fetcher.putBack(dataDoc);
          case 2:
            _context7.next = 4;
            break;
          case 3:
            _context7.prev = 3;
            _t2 = _context7["catch"](1);
            box.appendChild(errorMessageBlock(dom, 'Error trying to put back a list: ' + _t2));
            return _context7.abrupt("return");
          case 4:
            refresh();
          case 5:
          case "end":
            return _context7.stop();
        }
      }, _callee7, null, [[1, 3]]);
    }));
    return _saveListThenRefresh.apply(this, arguments);
  }
  function refresh() {
    var vals;
    if (ordered) {
      var li = reverse ? kb.the(null, property, subject, dataDoc) : kb.the(subject, property, null, dataDoc);
      vals = li ? li.elements : [];
    } else {
      vals = reverse ? kb.each(null, property, subject, dataDoc) : kb.each(subject, property, null, dataDoc);
      vals.sort(); // achieve consistency on each refresh
    }
    syncTableToArrayReOrdered(body, vals, renderItem);
  }
  body.refresh = refresh; // Allow live update
  refresh();
  function asyncStuff() {
    return _asyncStuff.apply(this, arguments);
  }
  function _asyncStuff() {
    _asyncStuff = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee8() {
      var extra, j;
      return regenerator_default().wrap(function (_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            extra = min - values.length;
            if (!(extra > 0)) {
              _context8.next = 4;
              break;
            }
            j = 0;
          case 1:
            if (!(j < extra)) {
              _context8.next = 3;
              break;
            }
            src_debug/* log */.Rm('Adding extra: min ' + min);
            _context8.next = 2;
            return addItem();
          case 2:
            j++;
            _context8.next = 1;
            break;
          case 3:
            _context8.next = 4;
            return saveListThenRefresh();
          case 4:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
    return _asyncStuff.apply(this, arguments);
  }
  asyncStuff().then(function () {
    src_debug/* log */.Rm(' Multiple render: async stuff ok');
  }, function (err) {
    src_debug/* error */.z3(' Multiple render: async stuff fails. #### ', err);
  }); // async

  return shim;
}; // Multiple

/*          Text field
 **
 */
// For possible date popups see e.g. http://www.dynamicdrive.com/dynamicindex7/jasoncalendar.htm
// or use HTML5: http://www.w3.org/TR/2011/WD-html-markup-20110113/input.date.html
//

field[src_ns.ui('PhoneField').uri] = basicField;
field[src_ns.ui('EmailField').uri] = basicField;
field[src_ns.ui('ColorField').uri] = basicField;
field[src_ns.ui('DateField').uri] = basicField;
field[src_ns.ui('DateTimeField').uri] = basicField;
field[src_ns.ui('TimeField').uri] = basicField;
field[src_ns.ui('NumericField').uri] = basicField;
field[src_ns.ui('IntegerField').uri] = basicField;
field[src_ns.ui('DecimalField').uri] = basicField;
field[src_ns.ui('FloatField').uri] = basicField;
field[src_ns.ui('TextField').uri] = basicField;
field[src_ns.ui('SingleLineTextField').uri] = basicField;
field[src_ns.ui('NamedNodeURIField').uri] = basicField;

/*          Multiline Text field
 **
 */

field[src_ns.ui('MultiLineTextField').uri] = function (dom, container, already, subject, form, dataDoc, callbackFunction) {
  var ui = src_ns.ui;
  var kb = external_SolidLogic_.store;
  var formDoc = form.doc ? form.doc() : null; // @@ if blank no way to know

  var property = kb.any(form, ui('property'));
  if (!property) {
    return errorMessageBlock(dom, 'No property to text field: ' + form);
  }
  var box = dom.createElement('div');
  box.style.display = 'flex';
  box.style.flexDirection = 'row';
  var left = box.appendChild(dom.createElement('div'));
  left.style.width = styleConstants.formFieldNameBoxWidth;
  var right = box.appendChild(dom.createElement('div'));
  left.appendChild(fieldLabel(dom, property, form));
  dataDoc = fieldStore(subject, property, dataDoc);
  var text = kb.anyJS(subject, property, null, dataDoc) || '';
  var editable = kb.updater.editable(dataDoc.uri);
  var suppressEmptyUneditable = form && kb.anyJS(form, src_ns.ui('suppressEmptyUneditable'), null, formDoc);
  if (!editable && suppressEmptyUneditable && text === '') {
    box.style.display = 'none';
  }
  var field = makeDescription(dom, kb, subject, property, dataDoc, callbackFunction);
  right.appendChild(field);
  if (container) container.appendChild(box);
  return box;
};

/*          Boolean field  and Tri-state version (true/false/null)
 **
 ** @@ todo: remove tristate param
 */
function booleanField(dom, container, already, subject, form, dataDoc, callbackFunction, tristate) {
  var ui = src_ns.ui;
  var kb = external_SolidLogic_.store;
  var property = kb.any(form, ui('property'));
  if (!property) {
    var errorBlock = errorMessageBlock(dom, 'No property to boolean field: ' + form);
    if (container) container.appendChild(errorBlock);
    return errorBlock;
  }
  var lab = kb.any(form, ui('label'));
  if (!lab) lab = label_label(property, true); // Init capital
  dataDoc = fieldStore(subject, property, dataDoc);
  var state = kb.any(subject, property);
  if (state === undefined) {
    state = false;
  } // @@ sure we want that -- or three-state?
  var ins = external_$rdf_.st(subject, property, true, dataDoc);
  var del = external_$rdf_.st(subject, property, false, dataDoc);
  var box = buildCheckboxForm(dom, kb, lab, del, ins, form, dataDoc, tristate);
  if (container) container.appendChild(box);
  return box;
}
field[src_ns.ui('BooleanField').uri] = function (dom, container, already, subject, form, dataDoc, callbackFunction) {
  return booleanField(dom, container, already, subject, form, dataDoc, callbackFunction, false);
};
field[src_ns.ui('TristateField').uri] = function (dom, container, already, subject, form, dataDoc, callbackFunction) {
  return booleanField(dom, container, already, subject, form, dataDoc, callbackFunction, true);
};

/*          Classifier field
 **
 **  Nested categories
 **
 ** @@ To do: If a classification changes, then change any dependent Options fields.
 */

field[src_ns.ui('Classifier').uri] = function (dom, container, already, subject, form, dataDoc, callbackFunction) {
  var kb = external_SolidLogic_.store;
  var ui = src_ns.ui;
  var category = kb.any(form, ui('category'));
  if (!category) {
    return errorMessageBlock(dom, 'No category for classifier: ' + form);
  }
  debug('Classifier: dataDoc=' + dataDoc);
  var checkOptions = function checkOptions(ok, body) {
    if (!ok) return callbackFunction(ok, body);
    return callbackFunction(ok, body);
  };
  var box = makeSelectForNestedCategory(dom, kb, subject, category, dataDoc, checkOptions);
  if (container) container.appendChild(box);
  return box;
};

/**         Choice field
 **
 **  Not nested.  Generates a link to something from a given class.
 **  Optional subform for the thing selected.
 **  Generates a subForm based on a ui:use form
 **  Will look like:
 ** <div id=dropDownDiv>
 **   <div id=labelOfDropDown>
 **   <div id=selectDiv>
 **     <select id=dropDownSelect>
 **       <option> ....
 **     <subForm>
 **  Alternative implementatons could be:
 ** -- pop-up menu (as here)
 ** -- radio buttons
 ** -- auto-complete typing
 **
 ** TODO: according to ontology ui:choice can also have ns.ui('default') - this is not implemented yet
 */

field[src_ns.ui('Choice').uri] = function (dom, container, already, subject, form, dataDoc, callbackFunction) {
  var ui = src_ns.ui;
  var kb = external_SolidLogic_.store;
  var formDoc = form.doc ? form.doc() : null; // @@ if blank no way to know

  var p;
  var box = dom.createElement('div');
  box.setAttribute('class', 'choiceBox');
  // Set flexDirection column?
  if (container) container.appendChild(box);
  var lhs = dom.createElement('div');
  lhs.setAttribute('class', 'formFieldName choiceBox-label');
  box.appendChild(lhs);
  var rhs = dom.createElement('div');
  rhs.setAttribute('class', 'formFieldValue choiceBox-selectBox');
  box.appendChild(rhs);
  var property = kb.any(form, ui('property'));
  if (!property) {
    return box.appendChild(errorMessageBlock(dom, 'No property for Choice: ' + form));
  }
  lhs.appendChild(fieldLabel(dom, property, form));
  var uiFrom = kb.any(form, ui('from'));
  if (!uiFrom) {
    return errorMessageBlock(dom, 'No \'from\' for Choice: ' + form);
  }
  var subForm = kb.any(form, ui('use')); // Optional
  // const follow = kb.anyJS(form, ui('follow'), null, formDoc) // data doc moves to new subject?

  var opts = {
    form: form,
    subForm: subForm,
    disambiguate: false
  };
  function getSelectorOptions(dataSource) {
    var possible = [];
    var possibleProperties;
    possible = kb.each(undefined, src_ns.rdf('type'), uiFrom, formDoc);
    for (var x in findMembersNT(kb, uiFrom, dataSource)) {
      possible.push(kb.fromNT(x));
    } // Use rdfs

    if (uiFrom.sameTerm(src_ns.rdfs('Class'))) {
      for (p in allClassURIs()) possible.push(kb.sym(p));
      // log.debug("%%% Choice field: possible.length 2 = "+possible.length)
    } else if (uiFrom.sameTerm(src_ns.rdf('Property'))) {
      possibleProperties = propertyTriage(kb);
      for (p in possibleProperties.op) possible.push(kb.fromNT(p));
      for (p in possibleProperties.dp) possible.push(kb.fromNT(p));
      opts.disambiguate = true; // This is a big class, and the labels won't be enough.
    } else if (uiFrom.sameTerm(src_ns.owl('ObjectProperty'))) {
      possibleProperties = propertyTriage(kb);
      for (p in possibleProperties.op) possible.push(kb.fromNT(p));
      opts.disambiguate = true;
    } else if (uiFrom.sameTerm(src_ns.owl('DatatypeProperty'))) {
      possibleProperties = propertyTriage(kb);
      for (p in possibleProperties.dp) possible.push(kb.fromNT(p));
      opts.disambiguate = true;
    }
    return possible;
    // return sortByLabel(possible)
  }

  // TODO: this checks for any occurrence, regardless of true or false setting
  if (kb.any(form, ui('canMintNew'))) {
    opts.mint = '* Create new *'; // @@ could be better
  }
  var multiSelect = kb.any(form, ui('multiselect')); // Optional
  if (multiSelect) opts.multiSelect = true;

  // by default searches the dataDoc graph or optionally the full store
  var dataSource = kb.each(form, ui('search-full-store')).length ? null : dataDoc; // optional

  var selector;
  rhs.refresh = function () {
    // from ui:property
    var selectedOptions = kb.each(subject, property, null, dataDoc).map(function (object) {
      return object.value;
    });
    // from ui:from + ui:property
    var possibleOptions = getSelectorOptions(dataSource);
    possibleOptions.push(selectedOptions);
    possibleOptions = sortByLabel(possibleOptions);
    selector = makeSelectForChoice(dom, rhs, kb, subject, property, possibleOptions, selectedOptions, uiFrom, opts, dataDoc, callbackFunction);
    rhs.innerHTML = '';
    rhs.appendChild(selector);
    if (multiSelect) {
      var multiSelectDiv = new IconicMultiSelect({
        placeholder: selector.selected,
        select: selector,
        container: rhs,
        textField: 'textField',
        valueField: 'valueField'
      });
      multiSelectDiv.init();
      multiSelectDiv.subscribe(function (event) {
        if (event.action === 'REMOVE_OPTION') {
          selectedOptions = selectedOptions.filter(function (value) {
            return value !== event.value;
          });
        }
        if (event.action === 'CLEAR_ALL_OPTIONS') {
          selectedOptions = [];
        }
        if (event.action === 'ADD_OPTION') {
          var stringValue = event.value + '';
          if (stringValue.includes('Create new')) {
            var newObject = newThing(dataDoc);
            var is = [];
            is.push(external_$rdf_.st(subject, property, kb.sym(newObject), dataDoc));
            if (uiFrom) is.push(external_$rdf_.st(newObject, src_ns.rdf('type'), kb.sym(uiFrom), dataDoc));
            if (subForm) {
              addSubFormChoice(dom, rhs, {}, external_$rdf_.sym(newObject), subForm, dataDoc, function (ok, body) {
                if (ok) {
                  kb.updater.update([], is, function (uri, success, errorBody) {
                    if (!success) rhs.appendChild(errorMessageBlock(dom, 'Error updating select: ' + errorBody));
                  });
                  selectedOptions.push(newObject);
                  if (callbackFunction) callbackFunction(ok, {
                    widget: 'select',
                    event: 'new'
                  });
                } else {
                  rhs.appendChild(errorMessageBlock(dom, 'Error updating data in field of select: ' + body));
                }
              });
            }
          } else selectedOptions.push(event.value);
        }
        selector.update(selectedOptions);
      });
    }
  };
  rhs.refresh();
  if (selector && selector.refresh) selector.refresh();
  return box;
};
function addSubFormChoice(dom, selectDiv, already, subject, subForm, dataDoc, callbackFunction) {
  fieldFunction(dom, subForm)(dom, selectDiv, already, subject, subForm, dataDoc, callbackFunction);
}

//          Documentation - non-interactive fields
//

field[src_ns.ui('Comment').uri] = field[src_ns.ui('Heading').uri] = function (dom, container, already, subject, form, dataDoc, _callbackFunction) {
  var ui = src_ns.ui;
  var kb = external_SolidLogic_.store;
  var contents = kb.any(form, ui('contents'));
  if (!contents) contents = 'Error: No contents in comment field.';
  var formDoc = form.doc ? form.doc() : null; // @@ if blank no way to know

  var uri = mostSpecificClassURI(form);
  var params = fieldParams[uri] || {};
  var box = dom.createElement('div');
  if (container) container.appendChild(box);
  var p = box.appendChild(dom.createElement(params.element));
  p.textContent = contents;
  setFieldStyle(p, form);

  // Some headings and prompts are only useful to guide user input
  var suppressIfUneditable = kb.anyJS(form, src_ns.ui('suppressIfUneditable'), null, formDoc);
  var editable = kb.updater.editable(dataDoc.uri);
  if (suppressIfUneditable && !editable) {
    box.style.display = 'none';
  }
  return box;
};

// A button for editing a form (in place, at the moment)
//
//  When editing forms, make it yellow, when editing thr form form, pink
// Help people understand how many levels down they are.
//
function editFormButton(dom, container, form, dataDoc, callbackFunction) {
  var b = dom.createElement('button');
  b.setAttribute('type', 'button');
  b.innerHTML = 'Edit ' + label_label(src_ns.ui('Form'));
  b.addEventListener('click', function (_e) {
    var ff = appendForm(dom, container, {}, form, src_ns.ui('FormForm'), dataDoc, callbackFunction);
    ff.setAttribute('style', src_ns.ui('FormForm').sameTerm(form) ? 'background-color: #fee;' : 'background-color: #ffffe7;');
    b.parentNode.removeChild(b);
  }, true);
  return b;
}
function appendForm(dom, container, already, subject, form, dataDoc, itemDone) {
  return fieldFunction(dom, form)(dom, container, already, subject, form, dataDoc, itemDone);
}

/**          Find list of properties for class
//
// Three possible sources: Those mentioned in schemas, which exludes many
// those which occur in the data we already have, and those predicates we
// have come across anywhere and which are not explicitly excluded from
// being used with this class.
*/

function propertiesForClass(kb, c) {
  var explicit = kb.each(undefined, src_ns.rdf('range'), c);
  [src_ns.rdfs('comment'), src_ns.dc('title'),
  // Generic things
  src_ns.foaf('name'), src_ns.foaf('homepage')].forEach(function (x) {
    explicit.push(x);
  });
  var members = kb.each(undefined, src_ns.rdf('type'), c);
  if (members.length > 60) members = members.slice(0, 60); // Array supports slice?
  var used = {};
  for (var i = 0; i < (members.length > 60 ? 60 : members.length); i++) {
    kb.statementsMatching(members[i], undefined, undefined).forEach(function (st) {
      used[st.predicate.uri] = true;
    });
  }
  explicit.forEach(function (p) {
    used[p.uri] = true;
  });
  var result = [];
  for (var uri in used) {
    result.push(kb.sym(uri));
  }
  return result;
}

/** Find the closest class
* @param kb The quad store
* @param cla - the URI of the class
* @param prop
*/
function findClosest(kb, cla, prop) {
  var agenda = [kb.sym(cla)]; // ordered - this is breadth first search
  while (agenda.length > 0) {
    var c = agenda.shift(); // first
    var lists = kb.each(c, prop);
    debug('Lists for ' + c + ', ' + prop + ': ' + lists.length);
    if (lists.length !== 0) return lists;
    var supers = kb.each(c, src_ns.rdfs('subClassOf'));
    for (var i = 0; i < supers.length; i++) {
      agenda.push(supers[i]);
      debug('findClosest: add super: ' + supers[i]);
    }
  }
  return [];
}

// Which forms apply to a given existing subject?

function formsFor(subject) {
  var kb = external_SolidLogic_.store;
  debug('formsFor: subject=' + subject);
  var t = kb.findTypeURIs(subject);
  var t1;
  for (t1 in t) {
    debug('   type: ' + t1);
  }
  var bottom = kb.bottomTypeURIs(t); // most specific
  var candidates = [];
  for (var b in bottom) {
    // Find the most specific
    debug('candidatesFor: trying bottom type =' + b);
    candidates = candidates.concat(findClosest(kb, b, src_ns.ui('creationForm')));
    candidates = candidates.concat(findClosest(kb, b, src_ns.ui('annotationForm')));
  }
  return candidates;
}
function sortBySequence(list) {
  var subfields = list.map(function (p) {
    var k = forms_kb.any(p, src_ns.ui('sequence'));
    return [k || 9999, p];
  });
  subfields.sort(function (a, b) {
    return a[0] - b[0];
  });
  return subfields.map(function (pair) {
    return pair[1];
  });
}
function sortByLabel(list) {
  var subfields = list.map(function (p) {
    return [label_label(p).toLowerCase(), p];
  });
  subfields.sort();
  return subfields.map(function (pair) {
    return pair[1];
  });
}

/** Button to add a new whatever using a form
//
// @param form - optional form , else will look for one
// @param dataDoc - optional dataDoc else will prompt for one (unimplemented)
*/
function newButton(dom, kb, subject, predicate, theClass, form, dataDoc, callbackFunction) {
  var b = dom.createElement('button');
  b.setAttribute('type', 'button');
  b.innerHTML = 'New ' + label_label(theClass);
  b.addEventListener('click', function (_e) {
    b.parentNode.appendChild(promptForNew(dom, kb, subject, predicate, theClass, form, dataDoc, callbackFunction));
  }, false);
  return b;
}

/**      Prompt for new object of a given class
//
// @param dom - the document DOM for the user interface
// @param kb - the graph which is the knowledge base we are working with
// @param subject - a term, Thing this should be linked to when made. Optional.
// @param predicate - a term, the relationship for the subject link. Optional.
// @param theClass - an RDFS class containng the object about which the new information is.
// @param form  - the form to be used when a new one. null means please find one.
// @param dataDoc - The web document being edited
// @param callbackFunction - takes (boolean ok, string errorBody)
// @returns a dom object with the form DOM
*/
function promptForNew(dom, kb, subject, predicate, theClass, form, dataDoc, callbackFunction) {
  var box = dom.createElement('form');
  if (!form) {
    var lists = findClosest(kb, theClass.uri, src_ns.ui('creationForm'));
    if (lists.length === 0) {
      var p = box.appendChild(dom.createElement('p'));
      p.textContent = 'I am sorry, you need to provide information about a ' + label_label(theClass) + ' but I don\'t know enough information about those to ask you.';
      var b = box.appendChild(dom.createElement('button'));
      b.setAttribute('type', 'button');
      b.setAttribute('style', 'float: right;');
      b.innerHTML = 'Goto ' + label_label(theClass);
      b.addEventListener('click',
      // TODO fix dependency cycle to solid-panes by calling outlineManager
      function (_e) {
        dom.outlineManager.GotoSubject(theClass, true, undefined, true, undefined);
      }, false);
      return box;
    }
    debug('lists[0] is ' + lists[0]);
    form = lists[0]; // Pick any one
  }
  debug('form is ' + form);
  box.setAttribute('style', "border: 0.05em solid ".concat(styleConstants.formBorderColor, "; color: ").concat(styleConstants.formBorderColor)); // @@color?
  box.innerHTML = '<h3>New ' + label_label(theClass) + '</h3>';
  var formFunction = fieldFunction(dom, form);
  var object = newThing(dataDoc);
  var gotButton = false;
  var itemDone = function itemDone(ok, body) {
    if (!ok) return callbackFunction(ok, body);
    var insertMe = [];
    if (subject && !kb.holds(subject, predicate, object, dataDoc)) {
      insertMe.push(external_$rdf_.st(subject, predicate, object, dataDoc));
    }
    if (subject && !kb.holds(object, src_ns.rdf('type'), theClass, dataDoc)) {
      insertMe.push(external_$rdf_.st(object, src_ns.rdf('type'), theClass, dataDoc));
    }
    if (insertMe.length) {
      kb.updater.update([], insertMe, linkDone);
    } else {
      callbackFunction(true, body);
    }
    if (!gotButton) {
      gotButton = box.appendChild(linkButton(dom, object));
    }
  };
  function linkDone(uri, ok, body) {
    return callbackFunction(ok, body);
  }
  info('paneUtils Object is ' + object);
  var f = formFunction(dom, box, {}, object, form, dataDoc, itemDone);
  var rb = removeButton(dom, f);
  rb.setAttribute('style', 'float: right;');
  box.AJAR_subject = object;
  return box;
}
function makeDescription(dom, kb, subject, predicate, dataDoc, callbackFunction) {
  var group = dom.createElement('div');
  var desc = kb.anyJS(subject, predicate, null, dataDoc) || '';
  var field = dom.createElement('textarea');
  group.appendChild(field);
  field.rows = desc ? desc.split('\n').length + 2 : 2;
  field.cols = 80;
  field.setAttribute('style', style.multilineTextInputStyle);
  if (desc !== null) {
    field.value = desc;
  } else {
    // Unless you can make the predicate label disappear with the first click then this is over-cute
    // field.value = utils.label(predicate); // Was"enter a description here" @@ possibly: add prompt which disappears
    field.select(); // Select it ready for user input -- doesn't work
  }
  group.refresh = function () {
    var v = kb.any(subject, predicate, null, dataDoc);
    if (v && v.value !== field.value) {
      field.value = v.value; // don't touch widget if no change
      // @@ this is the place to color the field from the user who chanaged it
    }
  };
  function saveChange(_e) {
    submit.disabled = true;
    submit.setAttribute('style', 'visibility: hidden; float: right;'); // Keep UI clean
    field.disabled = true;
    field.style.color = styleConstants.textInputColorPending;
    var ds = kb.statementsMatching(subject, predicate, null, dataDoc);
    var is = external_$rdf_.st(subject, predicate, field.value, dataDoc);
    kb.updater.update(ds, is, function (uri, ok, body) {
      if (ok) {
        field.style.color = styleConstants.textInputColor;
        field.disabled = false;
      } else {
        group.appendChild(errorMessageBlock(dom, 'Error (while saving change to ' + dataDoc.uri + '): ' + body));
      }
      if (callbackFunction) {
        callbackFunction(ok, body);
      }
    });
  }
  var editable = kb.updater.editable(dataDoc.uri);
  var submit;
  if (editable) {
    submit = continueButton(dom, saveChange);
    submit.disabled = true; // until the filled has been modified
    submit.style.visibility = 'hidden';
    submit.style["float"] = 'right';
    group.appendChild(submit);
    field.addEventListener('keyup', function (_e) {
      // Green means has been changed, not saved yet
      field.style.color = 'green'; // setAttribute('style', style + 'color: green;')
      if (submit) {
        submit.disabled = false;
        submit.style.visibility = ''; // Remove visibility: hidden
      }
    }, true);
    field.addEventListener('change', saveChange, true);
  } else {
    field.disabled = true; // @@ change color too
    field.style.backgroundColor = styleConstants.textInputBackgroundColorUneditable;
  }
  return group;
}

/** Make SELECT element to select options
//
// @param subject - a term, the subject of the statement(s) being edited.
// @param predicate - a term, the predicate of the statement(s) being edited
// @param possible - a list of terms, the possible value the object can take
// @param options.multiple - Boolean - Whether more than one at a time is allowed
// @param options.nullLabel - a string to be displayed as the
//                        option for none selected (for non multiple)
// @param options.mint - User may create thing if this sent to the prompt string eg "New foo"
// @param options.subForm - If mint, then the form to be used for minting the new thing
// @param dataDoc - The web document being edited
// @param callbackFunction - takes (boolean ok, string errorBody)
*/
function makeSelectForClassifierOptions(dom, kb, subject, predicate, possible, options, dataDoc, callbackFunction) {
  debug('Select list length now ' + possible.length);
  var n = 0;
  var uris = {}; // Count them
  var editable = kb.updater.editable(dataDoc.uri);
  for (var i = 0; i < possible.length; i++) {
    var sub = possible[i]; // @@ Maybe; make this so it works with blank nodes too
    if (!sub.uri) src_debug/* warn */.R8("makeSelectForClassifierOptions: option does not have an uri: ".concat(sub, ", with predicate: ").concat(predicate));
    if (!sub.uri || sub.uri in uris) continue;
    uris[sub.uri] = true;
    n++;
  } // uris is now the set of possible options
  if (n === 0 && !options.mint) {
    return errorMessageBlock(dom, 'Can\'t do selector with no options, subject= ' + subject + ' property = ' + predicate + '.');
  }
  debug('makeSelectForClassifierOptions: dataDoc=' + dataDoc);
  var actual;
  var getActual = function getActual() {
    actual = {};
    if (predicate.sameTerm(src_ns.rdf('type'))) {
      actual = kb.findTypeURIs(subject);
    } else {
      kb.each(subject, predicate, null, dataDoc).forEach(function (x) {
        actual[x.uri] = true;
      });
    }
    return actual;
  };
  actual = getActual();
  var onChange = function onChange(_e) {
    select.disabled = true; // until data written back - gives user feedback too
    var ds = [];
    var is = [];
    var removeValue = function removeValue(t) {
      if (kb.holds(subject, predicate, t, dataDoc)) {
        ds.push(external_$rdf_.st(subject, predicate, t, dataDoc));
      }
    };
    var newObject;
    for (var _i = 0; _i < select.options.length; _i++) {
      var opt = select.options[_i];
      if (opt.selected && opt.AJAR_mint) {
        if (options.mintClass) {
          var thisForm = promptForNew(dom, kb, subject, predicate, options.mintClass, null, dataDoc, function (ok, body) {
            if (!ok) {
              callbackFunction(ok, body, {
                change: 'new'
              }); // @@ if ok, need some form of refresh of the select for the new thing
            }
          });
          select.parentNode.appendChild(thisForm);
          newObject = thisForm.AJAR_subject;
        } else {
          newObject = newThing(dataDoc);
        }
        is.push(external_$rdf_.st(subject, predicate, newObject, dataDoc));
        if (options.mintStatementsFun) {
          is = is.concat(options.mintStatementsFun(newObject));
        }
      }
      if (!opt.AJAR_uri) continue; // a prompt or mint
      if (opt.selected && !(opt.AJAR_uri in actual)) {
        // new class
        is.push(external_$rdf_.st(subject, predicate, kb.sym(opt.AJAR_uri), dataDoc));
      }
      if (!opt.selected && opt.AJAR_uri in actual) {
        // old class
        removeValue(kb.sym(opt.AJAR_uri));
      }
      if (opt.selected) select.currentURI = opt.AJAR_uri;
    }
    var sel = select.subSelect; // All subclasses must also go
    while (sel && sel.currentURI) {
      removeValue(kb.sym(sel.currentURI));
      sel = sel.subSelect;
    }
    sel = select.superSelect; // All superclasses are redundant
    while (sel && sel.currentURI) {
      removeValue(kb.sym(sel.currentURI));
      sel = sel.superSelect;
    }
    function doneNew(ok, _body) {
      callbackFunction(ok, {
        widget: 'select',
        event: 'new'
      });
    }
    info('makeSelectForClassifierOptions: data doc = ' + dataDoc);
    kb.updater.update(ds, is, function (uri, ok, body) {
      actual = getActual(); // refresh
      if (ok) {
        select.disabled = false; // data written back
        if (newObject) {
          var fn = fieldFunction(dom, options.subForm);
          fn(dom, select.parentNode, {}, newObject, options.subForm, dataDoc, doneNew);
        }
      } else {
        return select.parentNode.appendChild(errorMessageBlock(dom, 'Error updating data in select: ' + body));
      }
      if (callbackFunction) callbackFunction(ok, {
        widget: 'select',
        event: 'change'
      });
    });
  };
  var select = dom.createElement('select');
  select.setAttribute('style', style.formSelectStyle);
  if (options.multiple) select.setAttribute('multiple', 'true');
  select.currentURI = null;
  select.refresh = function () {
    actual = getActual(); // refresh
    for (var _i2 = 0; _i2 < select.children.length; _i2++) {
      var option = select.children[_i2];
      if (option.AJAR_uri) {
        option.selected = option.AJAR_uri in actual;
      }
    }
    select.disabled = false; // unlocked any conflict we had got into
  };
  for (var uri in uris) {
    var c = kb.sym(uri);
    var option = dom.createElement('option');
    if (options.disambiguate) {
      option.appendChild(dom.createTextNode(labelWithOntology(c, true))); // Init. cap
    } else {
      option.appendChild(dom.createTextNode(label_label(c, true))); // Init.
    }
    var backgroundColor = kb.any(c, kb.sym('http://www.w3.org/ns/ui#backgroundColor'));
    if (backgroundColor) {
      option.setAttribute('style', 'background-color: ' + backgroundColor.value + '; ');
    }
    option.AJAR_uri = uri;
    if (uri in actual) {
      option.setAttribute('selected', 'true');
      select.currentURI = uri;
      // dump("Already in class: "+ uri+"\n")
    }
    select.appendChild(option);
  }
  if (editable && options.mint) {
    var mint = dom.createElement('option');
    mint.appendChild(dom.createTextNode(options.mint));
    mint.AJAR_mint = true; // Flag it
    select.insertBefore(mint, select.firstChild);
  }
  if (select.currentURI == null && !options.multiple) {
    var prompt = dom.createElement('option');
    prompt.appendChild(dom.createTextNode(options.nullLabel));
    select.insertBefore(prompt, select.firstChild);
    prompt.selected = true;
  }
  if (editable) {
    select.addEventListener('change', onChange, false);
  }
  return select;
} // makeSelectForClassifierOptions

/** Make SELECT element to select options
//
// @param subject - a term, the subject of the statement(s) being edited.
// @param predicate - a term, the predicate of the statement(s) being edited
// @param possible - a list of terms, the possible value the object can take
// @param options.nullLabel - a string to be displayed as the
//                        option for none selected (for non multiple)
// @param options.subForm - If mint, then the form to be used for minting the new thing
// @param dataDoc - The web document being edited
// @param callbackFunction - takes (boolean ok, string errorBody)
*/
function makeSelectForOptions(dom, kb, subject, predicate, possible, options, dataDoc, callbackFunction) {
  debug('Select list length now ' + possible.length);
  var n = 0;
  var uris = {}; // Count them
  var editable = kb.updater.editable(dataDoc.uri);
  for (var i = 0; i < possible.length; i++) {
    var sub = possible[i]; // @@ Maybe; make this so it works with blank nodes too
    if (!sub.uri) src_debug/* warn */.R8("makeSelectForOptions: option does not have an uri: ".concat(sub, ", with predicate: ").concat(predicate));
    if (!sub.uri || sub.uri in uris) continue;
    uris[sub.uri] = true;
    n++;
  } // uris is now the set of possible options
  if (n === 0) {
    return errorMessageBlock(dom, 'Can\'t do selector with no options, subject= ' + subject + ' property = ' + predicate + '.');
  }
  debug('makeSelectForOptions: dataDoc=' + dataDoc);
  var actual;
  var getActual = function getActual() {
    actual = {};
    if (predicate.sameTerm(src_ns.rdf('type'))) {
      actual = kb.findTypeURIs(subject);
    } else {
      kb.each(subject, predicate, null, dataDoc).forEach(function (x) {
        if (x.uri) {
          actual[x.uri] = true;
        }
      });
    }
    return actual;
  };
  actual = getActual();
  var onChange = function onChange(_e) {
    select.disabled = true; // until data written back - gives user feedback too
    var ds = [];
    var is = [];
    var removeValue = function removeValue(t) {
      if (kb.holds(subject, predicate, t, dataDoc)) {
        ds.push(external_$rdf_.st(subject, predicate, t, dataDoc));
      }
    };
    for (var _i3 = 0; _i3 < select.options.length; _i3++) {
      var opt = select.options[_i3];
      if (!opt.AJAR_uri) continue; // a prompt or mint
      if (opt.selected && !(opt.AJAR_uri in actual)) {
        // new class
        is.push(external_$rdf_.st(subject, predicate, kb.sym(opt.AJAR_uri), dataDoc));
      }
      if (!opt.selected && opt.AJAR_uri in actual) {
        // old class
        removeValue(kb.sym(opt.AJAR_uri));
      }
      if (opt.selected) select.currentURI = opt.AJAR_uri;
    }
    var sel = select.subSelect; // All subclasses must also go
    while (sel && sel.currentURI) {
      removeValue(kb.sym(sel.currentURI));
      sel = sel.subSelect;
    }
    sel = select.superSelect; // All superclasses are redundant
    while (sel && sel.currentURI) {
      removeValue(kb.sym(sel.currentURI));
      sel = sel.superSelect;
    }
    info('selectForOptions: data doc = ' + dataDoc);
    kb.updater.update(ds, is, function (uri, ok, body) {
      actual = getActual(); // refresh
      if (ok) {
        select.disabled = false; // data written back
      } else {
        return select.parentNode.appendChild(errorMessageBlock(dom, 'Error updating data in select: ' + body));
      }
      if (callbackFunction) callbackFunction(ok, {
        widget: 'select',
        event: 'change'
      });
    });
  };
  var select = dom.createElement('select');
  select.setAttribute('style', style.formSelectStyle);
  select.currentURI = null;
  select.refresh = function () {
    actual = getActual(); // refresh
    for (var _i4 = 0; _i4 < select.children.length; _i4++) {
      var option = select.children[_i4];
      if (option.AJAR_uri) {
        option.selected = option.AJAR_uri in actual;
      }
    }
    select.disabled = false; // unlocked any conflict we had got into
  };
  for (var uri in uris) {
    var c = kb.sym(uri);
    var option = dom.createElement('option');
    if (options.disambiguate) {
      option.appendChild(dom.createTextNode(labelWithOntology(c, true))); // Init. cap
    } else {
      option.appendChild(dom.createTextNode(label_label(c, true))); // Init.
    }
    var backgroundColor = kb.any(c, kb.sym('http://www.w3.org/ns/ui#backgroundColor'));
    if (backgroundColor) {
      option.setAttribute('style', 'background-color: ' + backgroundColor.value + '; ');
    }
    option.AJAR_uri = uri;
    if (uri in actual) {
      option.setAttribute('selected', 'true');
      select.currentURI = uri;
      // dump("Already in class: "+ uri+"\n")
    }
    select.appendChild(option);
  }
  if (!select.currentURI) {
    var prompt = dom.createElement('option');
    prompt.appendChild(dom.createTextNode(options.nullLabel));
    select.insertBefore(prompt, select.firstChild);
    prompt.selected = true;
  }
  if (editable) {
    select.addEventListener('change', onChange, false);
  }
  return select;
} // makeSelectForOptions

// Make SELECT element to select subclasses
//
// If there is any disjoint union it will so a mutually exclusive dropdown
// Failing that it will do a multiple selection of subclasses.
// Callback takes (boolean ok, string errorBody)

function makeSelectForCategory(dom, kb, subject, category, dataDoc, callbackFunction) {
  var du = kb.any(category, src_ns.owl('disjointUnionOf'));
  var subs;
  var multiple = false;
  if (!du) {
    subs = kb.each(undefined, src_ns.rdfs('subClassOf'), category);
    multiple = true;
  } else {
    subs = du.elements;
  }
  debug('Select list length ' + subs.length);
  if (subs.length === 0) {
    return errorMessageBlock(dom, 'Can\'t do ' + (multiple ? 'multiple ' : '') + 'selector with no subclasses of category: ' + category);
  }
  if (subs.length === 1) {
    return errorMessageBlock(dom, 'Can\'t do ' + (multiple ? 'multiple ' : '') + 'selector with only 1 subclass of category: ' + category + ':' + subs[1]);
  }
  return makeSelectForClassifierOptions(dom, kb, subject, src_ns.rdf('type'), subs, {
    multiple: multiple,
    nullLabel: '* Select type *'
  }, dataDoc, callbackFunction);
}

/** Make SELECT element to select subclasses recurively
//
// It will so a mutually exclusive dropdown, with another if there are nested
// disjoint unions.
//
// @param  callbackFunction takes (boolean ok, string errorBody)
*/
function makeSelectForNestedCategory(dom, kb, subject, category, dataDoc, callbackFunction) {
  function update() {
    if (child) {
      container.removeChild(child);
      child = null;
    }
    if (select.currentURI && kb.any(kb.sym(select.currentURI), src_ns.owl('disjointUnionOf'))) {
      child = makeSelectForNestedCategory(dom, kb, subject, kb.sym(select.currentURI), dataDoc, callbackFunction);
      select.subSelect = child.firstChild;
      select.subSelect.superSelect = select;
      container.appendChild(child);
    }
  }
  var container = dom.createElement('span'); // Container
  var child = null;
  function onChange(ok, body) {
    if (ok) update();
    callbackFunction(ok, body);
  }
  var select = makeSelectForCategory(dom, kb, subject, category, dataDoc, onChange);
  container.appendChild(select);
  update();
  return container;
}

/*  Build a checkbox from a given statement(s)
 **
 **  If the source document is editable, make the checkbox editable
 **
 **  ins and sel are either statements *or arrays of statements* which should be
 **  made if the checkbox is checed and unchecked respectively.
 **  tristate: Allow ins, or del, or neither
 */
function buildCheckboxForm(dom, kb, lab, del, ins, form, dataDoc, tristate) {
  var box = dom.createElement('div');
  var rhs = renderNameValuePair(dom, kb, box, form, lab);
  var editable = kb.updater.editable(dataDoc.uri);
  var input = dom.createElement('button');
  var colorCarrier = input;
  input.style = style.checkboxInputStyle;
  rhs.appendChild(input);
  function fix(x) {
    if (!x) return []; // no statements
    if (x.object) {
      if (!x.why) {
        x.why = dataDoc; // be back-compaitible  with old code
      }
      return [x]; // one statements
    }
    if (x instanceof Array) return x;
    throw new Error('buildCheckboxForm: bad param ' + x);
  }
  ins = fix(ins);
  del = fix(del);
  function holdsAll(a) {
    var missing = a.filter(function (st) {
      return !kb.holds(st.subject, st.predicate, st.object, st.why);
    });
    return missing.length === 0;
  }
  function refresh() {
    var state = holdsAll(ins);
    var displayState = state;
    if (del.length) {
      var negation = holdsAll(del);
      if (state && negation) {
        box.appendChild(errorMessageBlock(dom, 'Inconsistent data in dataDoc!\n' + ins + ' and\n' + del));
        return box;
      }
      if (!state && !negation) {
        state = null;
        var defa = kb.any(form, src_ns.ui('default'));
        displayState = defa ? defa.value === '1' : tristate ? null : false;
      }
    }
    input.state = state;
    input.textContent = {
      "true": checkMarkCharacter,
      "false": tristate ? cancelCharacter : ' ',
      // Just use blank when not tristate
      "null": dashCharacter
    }[displayState];
  }
  refresh();
  if (!editable) return box;
  var boxHandler = function boxHandler(_e) {
    colorCarrier.style.color = '#bbb'; // grey -- not saved yet
    var toDelete = input.state === true ? ins : input.state === false ? del : [];
    input.newState = input.state === null ? true : input.state === true ? false : tristate ? null : true;
    var toInsert = input.newState === true ? ins : input.newState === false ? del : [];
    src_debug/* log */.Rm("  Deleting  ".concat(toDelete));
    src_debug/* log */.Rm("  Inserting ".concat(toInsert));
    kb.updater.update(toDelete, toInsert, function (uri, success, errorBody) {
      if (!success) {
        if (toDelete.why) {
          var hmmm = kb.holds(toDelete.subject, toDelete.predicate, toDelete.object, toDelete.why);
          if (hmmm) {
            src_debug/* log */.Rm(' @@@@@ weird if 409 - does hold statement');
          }
        }
        colorCarrier.style.color = '#000';
        colorCarrier.style.backgroundColor = '#fee';
        box.appendChild(errorMessageBlock(dom, "Checkbox: Error updating dataDoc from ".concat(input.state, " to ").concat(input.newState, ":\n\n").concat(errorBody)));
      } else {
        colorCarrier.style.color = '#000';
        input.state = input.newState;
        input.textContent = {
          "true": checkMarkCharacter,
          "false": cancelCharacter,
          "null": dashCharacter
        }[input.state]; // @@
      }
    });
  };
  input.addEventListener('click', boxHandler, false);
  return box;
}
/*
export function fieldLabel (dom, property, form) {
  let lab = kb.any(form, ns.ui('label'))
  if (!lab) lab = utils.label(property, true) // Init capital
  if (property === undefined) {
    return dom.createTextNode('@@Internal error: undefined property')
  }
  const anchor = dom.createElement('a')
  if (property.uri) anchor.setAttribute('href', property.uri)
  anchor.setAttribute('style', style.fieldLabelStyle) // Not too blue and no underline
  anchor.textContent = lab
  return anchor
}

export function fieldStore (subject, predicate, def) {
  const sts = kb.statementsMatching(subject, predicate)
  if (sts.length === 0) return def // can used default as no data yet
  if (
    sts.length > 0 &&
    sts[0].why.uri &&
    kb.updater.editable(sts[0].why.uri)
  ) {
    return kb.sym(sts[0].why.uri)
  }
  return def
}
*/
/** Mint local ID using timestamp
 * @param {NamedNode} doc - the document in which the ID is to be generated
 */
function newThing(doc) {
  var now = new Date();
  return external_$rdf_.sym(doc.uri + '#' + 'id' + ('' + now.getTime()));
}

/** Make SELECT element to select options
//
// @param subject - a term, the subject of the statement(s) being edited.
// @param predicate - a term, the predicate of the statement(s) being edited
// @param possible - a list of terms, the possible value the object can take
// @param options.mint - User may create thing if this sent to the prompt string eg "New foo"
// @param options.subForm - If mint, then the form to be used for minting the new thing
// @param dataDoc - The web document being edited
// @param callbackFunction - takes (boolean ok, string errorBody)
*/
function makeSelectForChoice(dom, container, kb, subject, predicate, inputPossibleOptions, selectedOptions, uiFrom, options, dataDoc, callbackFunction) {
  var optionsFromClassUIfrom = {}; // Count them
  var editable = kb.updater.editable(dataDoc.uri);
  for (var i = 0; i < inputPossibleOptions.length; i++) {
    var sub = inputPossibleOptions[i]; // @@ Maybe; make this so it works with blank nodes too
    // if (!sub.uri) debug.warn(`makeSelectForChoice: option does not have an uri: ${sub}, with predicate: ${predicate}`)
    if (!sub.uri || sub.uri in optionsFromClassUIfrom) continue;
    optionsFromClassUIfrom[sub.uri] = true;
  }
  var isEmpty = Object.keys(optionsFromClassUIfrom).length === 0;
  if (isEmpty && !options.mint) {
    return errorMessageBlock(dom, 'Can\'t do selector with no options, subject= ' + subject + ' property = ' + predicate + '.');
  }
  debug('makeSelectForChoice: dataDoc=' + dataDoc);
  function createDefaultSelectOptionText() {
    var firstSelectOptionText = '--- choice ---';
    if (predicate && !(predicate.termType === 'BlankNode')) {
      firstSelectOptionText = '* Select for property: ' + label_label(predicate) + ' *';
    }
    if (subject && !(subject.termType === 'BlankNode')) {
      firstSelectOptionText = '* Select for ' + label_label(subject, true) + ' *';
    }
    return firstSelectOptionText;
  }
  function createDefaultSelectOption() {
    var option = dom.createElement('option');
    option.appendChild(dom.createTextNode(createDefaultSelectOptionText()));
    option.disabled = true;
    option.value = true;
    option.hidden = true;
    option.selected = true;
    return option;
  }
  var onChange = function onChange(_e) {
    container.removeChild(container.lastChild);
    select.refresh();
  };
  var select = dom.createElement('select');
  select.setAttribute('style', style.formSelectStyle);
  select.setAttribute('id', 'formSelect');
  select.currentURI = null;
  for (var uri in optionsFromClassUIfrom) {
    select.appendChild(createOption(uri));
  }
  if (editable && options.mint) {
    var mint = dom.createElement('option');
    mint.appendChild(dom.createTextNode(options.mint));
    mint.AJAR_mint = true; // Flag it
    select.insertBefore(mint, select.firstChild);
  }
  if (select.children.length === 0) select.insertBefore(createDefaultSelectOption(), select.firstChild);
  select.update = function (newSelectedOptions) {
    selectedOptions = newSelectedOptions;
    var ds = [];
    var is = [];
    var removeValue = function removeValue(t) {
      if (kb.holds(subject, predicate, t, dataDoc)) {
        ds.push(external_$rdf_.st(subject, predicate, t, dataDoc));
      }
    };
    var addValue = function addValue(t) {
      if (!kb.holds(subject, predicate, t, dataDoc)) {
        is.push(external_$rdf_.st(subject, predicate, t, dataDoc));
        // console.log("----value added " + t)
      }
      if (uiFrom && !kb.holds(t, src_ns.rdf('type'), kb.sym(uiFrom), dataDoc)) {
        is.push(external_$rdf_.st(t, src_ns.rdf('type'), kb.sym(uiFrom), dataDoc));
        // console.log("----added type to value " + uiFrom)
      }
    };
    var existingValues = kb.each(subject, predicate, null, dataDoc).map(function (object) {
      return object.value;
    });
    var _iterator2 = forms_createForOfIteratorHelper(existingValues),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var value = _step2.value;
        if (!containsObject(value, selectedOptions)) removeValue(external_$rdf_.sym(value));
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    var _iterator3 = forms_createForOfIteratorHelper(selectedOptions),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var _value = _step3.value;
        if (!(_value in existingValues)) addValue(external_$rdf_.sym(_value));
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
    kb.updater.update(ds, is, function (uri, ok, body) {
      if (!ok) return select.parentNode.appendChild(errorMessageBlock(dom, 'Error updating data in select: ' + body));
      select.refresh();
      if (callbackFunction) callbackFunction(ok, {
        widget: 'select',
        event: 'change'
      });
    });
  };
  select.refresh = function () {
    select.disabled = true; // unlocked any conflict we had got into
    var is = [];
    var newObject;
    for (var _i5 = 0; _i5 < select.options.length; _i5++) {
      var opt = select.options[_i5];
      if (opt.selected && opt.AJAR_mint) {
        // not sure if this 'if' is used because I cannot find mintClass
        if (options.mintClass) {
          var thisForm = promptForNew(dom, kb, subject, predicate, uiFrom, options.subForm, dataDoc, function (ok, body) {
            if (!ok) {
              callbackFunction(ok, body, {
                change: 'new'
              }); // @@ if ok, need some form of refresh of the select for the new thing
            }
          });
          select.parentNode.appendChild(thisForm);
          newObject = thisForm.AJAR_subject;
        } else {
          newObject = newThing(dataDoc);
        }
        is.push(external_$rdf_.st(subject, predicate, kb.sym(newObject), dataDoc));
        if (uiFrom) is.push(external_$rdf_.st(newObject, src_ns.rdf('type'), kb.sym(uiFrom), dataDoc));

        // not sure if this 'if' is used because I cannot find mintStatementsFun
        if (options.mintStatementsFun) {
          is = is.concat(options.mintStatementsFun(newObject));
        }
        select.currentURI = newObject;
      }
      if (!opt.AJAR_uri) continue; // a prompt or mint
      if (opt.selected && containsObject(opt.AJAR_uri, selectedOptions)) {
        select.currentURI = opt.AJAR_uri;
      }
      if (!containsObject(opt.AJAR_uri, selectedOptions)) opt.removeAttribute('selected');
      if (containsObject(opt.AJAR_uri, selectedOptions)) opt.setAttribute('selected', 'true');
    }
    info('selectForOptions: data doc = ' + dataDoc);
    if (select.currentURI && options.subForm && !options.multiSelect) {
      addSubFormChoice(dom, container, {}, external_$rdf_.sym(select.currentURI), options.subForm, dataDoc, function (ok, body) {
        if (ok) {
          kb.updater.update([], is, function (uri, success, errorBody) {
            if (!success) container.appendChild(errorMessageBlock(dom, 'Error updating select: ' + errorBody));
          });
          if (callbackFunction) callbackFunction(ok, {
            widget: 'select',
            event: 'new'
          });
        } else {
          container.appendChild(errorMessageBlock(dom, 'Error updating data in field of select: ' + body));
        }
      });
    }
    select.disabled = false;
  };
  function createOption(uri) {
    var option = dom.createElement('option');
    var c = kb.sym(uri);
    var label;
    if (options.disambiguate) {
      label = labelWithOntology(c, true); // Init. cap
    } else {
      label = label_label(c, true);
    }
    option.appendChild(dom.createTextNode(label)); // Init.
    option.setAttribute('value', uri);
    var backgroundColor = kb.any(c, kb.sym('http://www.w3.org/ns/ui#backgroundColor'));
    if (backgroundColor) {
      option.setAttribute('style', 'background-color: ' + backgroundColor.value + '; ');
    }
    option.AJAR_uri = uri;
    if (containsObject(c.value, selectedOptions)) {
      option.setAttribute('selected', 'true');
    }
    return option;
  }
  if (editable) {
    select.addEventListener('change', onChange, false);
  }
  return select;
} // makeSelectForChoice

function containsObject(obj, list) {
  var i;
  for (i = 0; i < list.length; i++) {
    if (list[i] === obj) {
      return true;
    }
  }
  return false;
}

// This functions replaces the findMembersNT (thisClass) from rdflib until we fix: https://github.com/linkeddata/rdflib.js/issues/565
/**
 * For anything which has thisClass (or any subclass) as its type,
 * or is the object of something which has thisClass (or any subclass) as its range,
 * or subject of something which has thisClass (or any subclass) as its domain
 * We don't bother doing subproperty (yet?) as it doesn't seem to be used
 * much.
 * Get all the Classes of which we can RDFS-infer the subject is a member
 * @return a hash of URIs
 */
function findMembersNT(store, thisClass, quad) {
  var len2;
  var len4;
  var m;
  var pred;
  var ref1;
  var ref2;
  var ref3;
  var ref4;
  var ref5;
  var st;
  var u;
  var seeds = {};
  seeds[thisClass.toNT()] = true;
  var members = {};
  var ref = store.transitiveClosure(seeds, store.rdfFactory.namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf'), true);
  for (var t in ref) {
    ref1 = store.statementsMatching(null, store.rdfFactory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'), store.fromNT(t), quad);
    for (var i = 0, len = ref1.length; i < len; i++) {
      st = ref1[i];
      members[st.subject.toNT()] = st;
    }
    ref2 = store.each(null, store.rdfFactory.namedNode('http://www.w3.org/2000/01/rdf-schema#domain'), store.fromNT(t), quad);
    for (var l = 0, len1 = ref2.length; l < len1; l++) {
      pred = ref2[l];
      ref3 = store.statementsMatching(null, pred, null, quad);
      for (m = 0, len2 = ref3.length; m < len2; m++) {
        st = ref3[m];
        members[st.subject.toNT()] = st;
      }
    }
    ref4 = store.each(null, store.rdfFactory.namedNode('http://www.w3.org/2000/01/rdf-schema#range'), store.fromNT(t), quad);
    for (var q = 0, len3 = ref4.length; q < len3; q++) {
      pred = ref4[q];
      ref5 = store.statementsMatching(null, pred, null, quad);
      for (u = 0, len4 = ref5.length; u < len4; u++) {
        st = ref5[u];
        members[st.object.toNT()] = st;
      }
    }
  }
  return members;
}
;// ./src/login/login.ts

function login_createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = login_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function login_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return login_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? login_arrayLikeToArray(r, a) : void 0; } }
function login_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }

/* eslint-disable camelcase */
/**
 * Signing in, signing up, profile and preferences reloading
 * Type index management
 *
 * Many functions in this module take a context object which
 * holds various RDF symbols, add to it, and return a promise of it.
 *
 * * `me`                RDF symbol for the user's WebID
 * * `publicProfile`     The user's public profile, iff loaded
 * * `preferencesFile`   The user's personal preference file, iff loaded
 * * `index.public`      The user's public type index file
 * * `index.private`     The user's private type index file
 *
 * Not RDF symbols:
 * * `noun`            A string in english for the type of thing -- like "address book"
 * * `instance`        An array of nodes which are existing instances
 * * `containers`      An array of nodes of containers of instances
 * * `div`             A DOM element where UI can be displayed
 * * `statusArea`      A DOM element (opt) progress stuff can be displayed, or error messages
 * *
 * * Vocabulary:  "load" loads a file if it exists;
 * *  'Ensure" CREATES the file if it does not exist (if it can) and then loads it.
 * @packageDocumentation
 */










var login_store = external_SolidLogic_.solidLogicSingleton.store;
var _solidLogicSingleton$ = external_SolidLogic_.solidLogicSingleton.profile,
  loadPreferences = _solidLogicSingleton$.loadPreferences,
  loadProfile = _solidLogicSingleton$.loadProfile;
var _solidLogicSingleton$2 = external_SolidLogic_.solidLogicSingleton.typeIndex,
  getScopedAppInstances = _solidLogicSingleton$2.getScopedAppInstances,
  getRegistrations = _solidLogicSingleton$2.getRegistrations,
  loadAllTypeIndexes = _solidLogicSingleton$2.loadAllTypeIndexes,
  getScopedAppsFromIndex = _solidLogicSingleton$2.getScopedAppsFromIndex,
  deleteTypeIndexRegistration = _solidLogicSingleton$2.deleteTypeIndexRegistration;

/**
 * Resolves with the logged in user's WebID
 *
 * @param context
 */
// used to be logIn
function ensureLoggedIn(context) {
  var me = external_SolidLogic_.authn.currentUser();
  if (me) {
    external_SolidLogic_.authn.saveUser(me, context);
    return Promise.resolve(context);
  }
  return new Promise(function (resolve) {
    external_SolidLogic_.authn.checkUser().then(function (webId) {
      // Already logged in?
      if (webId) {
        src_debug/* log */.Rm("logIn: Already logged in as ".concat(webId));
        return resolve(context);
      }
      if (!context.div || !context.dom) {
        return resolve(context);
      }
      var box = loginStatusBox(context.dom, function (webIdUri) {
        external_SolidLogic_.authn.saveUser(webIdUri, context);
        resolve(context); // always pass growing context
      });
      context.div.appendChild(box);
    });
  });
}

/**
 * Loads preference file
 * Do this after having done log in and load profile
 *
 * @private
 *
 * @param context
 */
// used to be logInLoadPreferences
function ensureLoadedPreferences(_x) {
  return _ensureLoadedPreferences.apply(this, arguments);
}

/**
 * Logs the user in and loads their WebID profile document into the store
 *
 * @param context
 *
 * @returns Resolves with the context after login / fetch
 */
// used to be logInLoadProfile
function _ensureLoadedPreferences() {
  _ensureLoadedPreferences = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee4(context) {
    var progressDisplay, preferencesFile, m2, _t4;
    return regenerator_default().wrap(function (_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          if (!context.preferencesFile) {
            _context4.next = 1;
            break;
          }
          return _context4.abrupt("return", Promise.resolve(context));
        case 1:
          _context4.prev = 1;
          _context4.next = 2;
          return ensureLoadedProfile(context);
        case 2:
          context = _context4.sent;
          _context4.next = 3;
          return loadPreferences(context.me);
        case 3:
          preferencesFile = _context4.sent;
          if (progressDisplay) {
            progressDisplay.parentNode.removeChild(progressDisplay);
          }
          context.preferencesFile = preferencesFile;
          _context4.next = 11;
          break;
        case 4:
          _context4.prev = 4;
          _t4 = _context4["catch"](1);
          if (!(_t4 instanceof external_SolidLogic_.UnauthorizedError)) {
            _context4.next = 5;
            break;
          }
          m2 = 'Oops — you are not authenticated (properly logged in), so SolidOS cannot read your preferences file. Try logging out and then logging back in.';
          log_alert(m2);
          _context4.next = 11;
          break;
        case 5:
          if (!(_t4 instanceof external_SolidLogic_.CrossOriginForbiddenError)) {
            _context4.next = 6;
            break;
          }
          m2 = "Unauthorized: Assuming preference file blocked for origin ".concat(window.location.origin);
          context.preferencesFileError = m2;
          return _context4.abrupt("return", context);
        case 6:
          if (!(_t4 instanceof external_SolidLogic_.SameOriginForbiddenError)) {
            _context4.next = 7;
            break;
          }
          m2 = 'You are not authorized to read your preference file. This may be because you are using an untrusted web app.';
          src_debug/* warn */.R8(m2);
          return _context4.abrupt("return", context);
        case 7:
          if (!(_t4 instanceof external_SolidLogic_.NotEditableError)) {
            _context4.next = 8;
            break;
          }
          m2 = 'You are not authorized to edit your preference file. This may be because you are using an untrusted web app.';
          src_debug/* warn */.R8(m2);
          return _context4.abrupt("return", context);
        case 8:
          if (!(_t4 instanceof external_SolidLogic_.WebOperationError)) {
            _context4.next = 9;
            break;
          }
          m2 = 'You are not authorized to edit your preference file. This may be because you are using an untrusted web app.';
          src_debug/* warn */.R8(m2);
          _context4.next = 11;
          break;
        case 9:
          if (!(_t4 instanceof external_SolidLogic_.FetchError)) {
            _context4.next = 10;
            break;
          }
          m2 = "Strange: Error ".concat(_t4.status, " trying to read your preference file.").concat(_t4.message);
          log_alert(m2);
          _context4.next = 11;
          break;
        case 10:
          throw new Error("(via loadPrefs) ".concat(_t4));
        case 11:
          return _context4.abrupt("return", context);
        case 12:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[1, 4]]);
  }));
  return _ensureLoadedPreferences.apply(this, arguments);
}
function ensureLoadedProfile(_x2) {
  return _ensureLoadedProfile.apply(this, arguments);
}

/**
  * Returns promise of context with arrays of symbols
  *
  * leaving the `isPublic` param undefined will bring in community index things, too
  */
function _ensureLoadedProfile() {
  _ensureLoadedProfile = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee5(context) {
    var logInContext, _t5;
    return regenerator_default().wrap(function (_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          if (!context.publicProfile) {
            _context5.next = 1;
            break;
          }
          return _context5.abrupt("return", context);
        case 1:
          _context5.prev = 1;
          _context5.next = 2;
          return ensureLoggedIn(context);
        case 2:
          logInContext = _context5.sent;
          if (logInContext.me) {
            _context5.next = 3;
            break;
          }
          throw new Error('Could not log in');
        case 3:
          _context5.next = 4;
          return loadProfile(logInContext.me);
        case 4:
          context.publicProfile = _context5.sent;
          _context5.next = 6;
          break;
        case 5:
          _context5.prev = 5;
          _t5 = _context5["catch"](1);
          if (context.div && context.dom) {
            context.div.appendChild(errorMessageBlock(context.dom, _t5.message));
          }
          throw new Error("Can't log in: ".concat(_t5));
        case 6:
          return _context5.abrupt("return", context);
        case 7:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[1, 5]]);
  }));
  return _ensureLoadedProfile.apply(this, arguments);
}
function findAppInstances(_x3, _x4, _x5) {
  return _findAppInstances.apply(this, arguments);
}
function _findAppInstances() {
  _findAppInstances = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee6(context, theClass, isPublic) {
    var items, _t6;
    return regenerator_default().wrap(function (_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          if (!context.me) {
            _context6.next = 2;
            break;
          }
          _context6.next = 1;
          return getScopedAppInstances(theClass, context.me);
        case 1:
          _t6 = _context6.sent;
          _context6.next = 3;
          break;
        case 2:
          _t6 = [];
        case 3:
          items = _t6;
          if (isPublic === true) {
            // old API - not recommended!
            items = items.filter(function (item) {
              return item.scope.label === 'public';
            });
          } else if (isPublic === false) {
            items = items.filter(function (item) {
              return item.scope.label === 'private';
            });
          }
          context.instances = items.map(function (item) {
            return item.instance;
          });
          return _context6.abrupt("return", context);
        case 4:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return _findAppInstances.apply(this, arguments);
}
function scopeLabel(context, scope) {
  var mine = context.me && context.me.sameTerm(scope.agent);
  var name = mine ? '' : label_label(scope.agent) + ' ';
  return "".concat(name).concat(scope.label);
}
/**
 * UI to control registration of instance
 */
function registrationControl(_x6, _x7, _x8) {
  return _registrationControl.apply(this, arguments);
}
function _registrationControl() {
  _registrationControl = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee7(context, instance, theClass) {
    var registrationStatements, renderScopeCheckbox, dom, box, me, scopes, msg, tbody, form, _iterator, _step, scope, row, _t7;
    return regenerator_default().wrap(function (_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          renderScopeCheckbox = function _renderScopeCheckbox(scope) {
            var statements = registrationStatements(scope.index);
            var name = scopeLabel(context, scope);
            var label = "".concat(name, " link to this ").concat(context.noun);
            return buildCheckboxForm(context.dom, external_SolidLogic_.solidLogicSingleton.store, label, null, statements, form, scope.index);
          };
          registrationStatements = function _registrationStatemen(index) {
            var registrations = getRegistrations(instance, theClass);
            var reg = registrations.length ? registrations[0] : newThing(index);
            return [(0,external_$rdf_.st)(reg, src_ns.solid('instance'), instance, index), (0,external_$rdf_.st)(reg, src_ns.solid('forClass'), theClass, index)];
          };
          /// / body of registrationControl
          dom = context.dom;
          if (!(!dom || !context.div)) {
            _context7.next = 1;
            break;
          }
          throw new Error('registrationControl: need dom and div');
        case 1:
          box = dom.createElement('div');
          context.div.appendChild(box);
          context.me = external_SolidLogic_.authn.currentUser(); // @@
          me = context.me;
          if (me) {
            _context7.next = 2;
            break;
          }
          box.innerHTML = '<p style="margin:2em;">(Log in to save a link to this)</p>';
          return _context7.abrupt("return", context);
        case 2:
          _context7.prev = 2;
          _context7.next = 3;
          return loadAllTypeIndexes(me);
        case 3:
          scopes = _context7.sent;
          _context7.next = 5;
          break;
        case 4:
          _context7.prev = 4;
          _t7 = _context7["catch"](2);
          if (context.div && context.preferencesFileError) {
            msg = '(Lists of stuff not available)';
            context.div.appendChild(dom.createElement('p')).textContent = msg;
          } else if (context.div) {
            msg = "registrationControl: Type indexes not available: ".concat(_t7);
            context.div.appendChild(errorMessageBlock(context.dom, _t7));
          }
          src_debug/* log */.Rm(msg);
          return _context7.abrupt("return", context);
        case 5:
          box.innerHTML = '<table><tbody></tbody></table>'; // tbody will be inserted anyway
          box.setAttribute('style', 'font-size: 120%; text-align: right; padding: 1em; border: solid gray 0.05em;');
          tbody = box.children[0].children[0];
          form = new external_$rdf_.BlankNode(); // @@ say for now
          _iterator = login_createForOfIteratorHelper(scopes);
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              scope = _step.value;
              row = tbody.appendChild(dom.createElement('tr'));
              row.appendChild(renderScopeCheckbox(scope)); // @@ index
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          return _context7.abrupt("return", context);
        case 6:
        case "end":
          return _context7.stop();
      }
    }, _callee7, null, [[2, 4]]);
  }));
  return _registrationControl.apply(this, arguments);
}
function renderScopeHeadingRow(context, store, scope) {
  var backgroundColor = {
    "private": '#fee',
    "public": '#efe'
  };
  var dom = context.dom;
  var name = scopeLabel(context, scope);
  var row = dom.createElement('tr');
  var cell = row.appendChild(dom.createElement('td'));
  cell.setAttribute('colspan', '3');
  cell.style.backgoundColor = backgroundColor[scope.label] || 'white';
  var header = cell.appendChild(dom.createElement('h3'));
  header.textContent = name + ' links';
  header.style.textAlign = 'left';
  return row;
}
/**
  * UI to List at all registered things
  */
function registrationList(_x9, _x0) {
  return _registrationList.apply(this, arguments);
} // registrationList

/**
 * Bootstrapping identity
 * (Called by `loginStatusBox()`)
 *
 * @param dom
 * @param setUserCallback
 *
 * @returns
 */
function _registrationList() {
  _registrationList = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee9(context, options) {
    var dom, div, box, scopes, table, tbody, _iterator2, _step2, scope, headingRow, items, _iterator3, _step3, _loop, _t8, _t9;
    return regenerator_default().wrap(function (_context0) {
      while (1) switch (_context0.prev = _context0.next) {
        case 0:
          dom = context.dom;
          div = context.div;
          box = dom.createElement('div');
          div.appendChild(box);
          context.me = external_SolidLogic_.authn.currentUser(); // @@
          if (context.me) {
            _context0.next = 1;
            break;
          }
          box.innerHTML = '<p style="margin:2em;">(Log in list your stuff)</p>';
          return _context0.abrupt("return", context);
        case 1:
          _context0.next = 2;
          return loadAllTypeIndexes(context.me);
        case 2:
          scopes = _context0.sent;
          // includes community indexes

          // console.log('@@ registrationList ', scopes)
          box.innerHTML = '<table><tbody></tbody></table>'; // tbody will be inserted anyway
          box.setAttribute('style', 'font-size: 120%; text-align: right; padding: 1em; border: solid #eee 0.5em;');
          table = box.firstChild;
          tbody = table.firstChild;
          _iterator2 = login_createForOfIteratorHelper(scopes);
          _context0.prev = 3;
          _iterator2.s();
        case 4:
          if ((_step2 = _iterator2.n()).done) {
            _context0.next = 13;
            break;
          }
          scope = _step2.value;
          // need some predicate for listing/adding agents
          headingRow = renderScopeHeadingRow(context, login_store, scope);
          tbody.appendChild(headingRow);
          _context0.next = 5;
          return getScopedAppsFromIndex(scope, options.type || null);
        case 5:
          items = _context0.sent;
          // any class
          if (items.length === 0) headingRow.style.display = 'none';
          // console.log(`registrationList: @@ instance items for class ${options.type || 'undefined' }:`, items)
          _iterator3 = login_createForOfIteratorHelper(items);
          _context0.prev = 6;
          _loop = /*#__PURE__*/regenerator_default().mark(function _loop() {
            var item, row;
            return regenerator_default().wrap(function (_context9) {
              while (1) switch (_context9.prev = _context9.next) {
                case 0:
                  item = _step3.value;
                  row = personTR(dom, src_ns.solid('instance'), item.instance, {
                    deleteFunction: function () {
                      var _deleteFunction = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee8() {
                        return regenerator_default().wrap(function (_context8) {
                          while (1) switch (_context8.prev = _context8.next) {
                            case 0:
                              _context8.next = 1;
                              return deleteTypeIndexRegistration(item);
                            case 1:
                              tbody.removeChild(row);
                            case 2:
                            case "end":
                              return _context8.stop();
                          }
                        }, _callee8);
                      }));
                      function deleteFunction() {
                        return _deleteFunction.apply(this, arguments);
                      }
                      return deleteFunction;
                    }()
                  });
                  row.children[0].style.paddingLeft = '3em';
                  tbody.appendChild(row);
                case 1:
                case "end":
                  return _context9.stop();
              }
            }, _loop);
          });
          _iterator3.s();
        case 7:
          if ((_step3 = _iterator3.n()).done) {
            _context0.next = 9;
            break;
          }
          return _context0.delegateYield(_loop(), "t0", 8);
        case 8:
          _context0.next = 7;
          break;
        case 9:
          _context0.next = 11;
          break;
        case 10:
          _context0.prev = 10;
          _t8 = _context0["catch"](6);
          _iterator3.e(_t8);
        case 11:
          _context0.prev = 11;
          _iterator3.f();
          return _context0.finish(11);
        case 12:
          _context0.next = 4;
          break;
        case 13:
          _context0.next = 15;
          break;
        case 14:
          _context0.prev = 14;
          _t9 = _context0["catch"](3);
          _iterator2.e(_t9);
        case 15:
          _context0.prev = 15;
          _iterator2.f();
          return _context0.finish(15);
        case 16:
          return _context0.abrupt("return", context);
        case 17:
        case "end":
          return _context0.stop();
      }
    }, _callee9, null, [[3, 14, 15, 16], [6, 10, 11, 12]]);
  }));
  return _registrationList.apply(this, arguments);
}
function signInOrSignUpBox(dom, setUserCallback) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  options = options || {};
  var signInButtonStyle = options.buttonStyle || style.signInAndUpButtonStyle;
  var box = dom.createElement('div');
  var magicClassName = 'SolidSignInOrSignUpBox';
  src_debug/* log */.Rm('widgets.signInOrSignUpBox');
  box.setUserCallback = setUserCallback;
  box.setAttribute('class', magicClassName);
  box.setAttribute('style', 'display:flex;');

  // Sign in button with PopUP
  var signInPopUpButton = dom.createElement('input'); // multi
  box.appendChild(signInPopUpButton);
  signInPopUpButton.setAttribute('type', 'button');
  signInPopUpButton.setAttribute('value', 'Log in');
  signInPopUpButton.setAttribute('style', "".concat(signInButtonStyle).concat(style.headerBannerLoginInput) + style.signUpBackground);
  external_SolidLogic_.authSession.events.on('login', function () {
    var me = external_SolidLogic_.authn.currentUser();
    // const sessionInfo = authSession.info
    // if (sessionInfo && sessionInfo.isLoggedIn) {
    if (me) {
      // const webIdURI = sessionInfo.webId
      var webIdURI = me.uri;
      // setUserCallback(webIdURI)
      var divs = dom.getElementsByClassName(magicClassName);
      src_debug/* log */.Rm("Logged in, ".concat(divs.length, " panels to be serviced"));
      // At the same time, satisfy all the other login boxes
      for (var i = 0; i < divs.length; i++) {
        var div = divs[i];
        // @@ TODO Remove the need to manipulate HTML elements
        if (div.setUserCallback) {
          try {
            div.setUserCallback(webIdURI);
            var parent = div.parentNode;
            if (parent) {
              parent.removeChild(div);
            }
          } catch (e) {
            src_debug/* log */.Rm("## Error satisfying login box: ".concat(e));
            div.appendChild(errorMessageBlock(dom, e));
          }
        }
      }
    }
  });
  signInPopUpButton.addEventListener('click', function () {
    var offline = (0,external_SolidLogic_.offlineTestID)();
    if (offline) return setUserCallback(offline.uri);
    renderSignInPopup(dom);
  }, false);

  // Sign up button
  var signupButton = dom.createElement('input');
  box.appendChild(signupButton);
  signupButton.setAttribute('type', 'button');
  signupButton.setAttribute('value', 'Sign Up for Solid');
  signupButton.setAttribute('style', "".concat(signInButtonStyle).concat(style.headerBannerLoginInput) + style.signInBackground);
  signupButton.addEventListener('click', function (_event) {
    var signupMgr = new Signup();
    signupMgr.signup().then(function (uri) {
      src_debug/* log */.Rm('signInOrSignUpBox signed up ' + uri);
      setUserCallback(uri);
    });
  }, false);
  return box;
}
function renderSignInPopup(dom) {
  /**
   * Issuer Menu
   */
  var issuerPopup = dom.createElement('div');
  issuerPopup.setAttribute('style', 'position: fixed; top: 0; left: 0; right: 0; bottom: 0; display: flex; justify-content: center; align-items: center;');
  dom.body.appendChild(issuerPopup);
  var issuerPopupBox = dom.createElement('div');
  issuerPopupBox.setAttribute('style', "\n      background-color: white;\n      box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.2);\n      -webkit-box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.2);\n      -moz-box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.2);\n      -o-box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.2);\n      border-radius: 4px;\n      min-width: 400px;\n      padding: 10px;\n      z-index : 10;\n    ");
  issuerPopup.appendChild(issuerPopupBox);
  var issuerPopupBoxTopMenu = dom.createElement('div');
  issuerPopupBoxTopMenu.setAttribute('style', "\n      border-bottom: 1px solid #DDD;\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      justify-content: space-between;\n    ");
  issuerPopupBox.appendChild(issuerPopupBoxTopMenu);
  var issuerPopupBoxLabel = dom.createElement('label');
  issuerPopupBoxLabel.setAttribute('style', 'margin-right: 5px; font-weight: 800');
  issuerPopupBoxLabel.innerText = 'Select an identity provider';
  var issuerPopupBoxCloseButton = dom.createElement('button');
  issuerPopupBoxCloseButton.innerHTML = '<img src="https://solidos.github.io/solid-ui/src/icons/noun_1180156.svg" style="width: 2em; height: 2em;" title="Cancel">';
  issuerPopupBoxCloseButton.setAttribute('style', 'background-color: transparent; border: none;');
  issuerPopupBoxCloseButton.addEventListener('click', function () {
    issuerPopup.remove();
  });
  issuerPopupBoxTopMenu.appendChild(issuerPopupBoxLabel);
  issuerPopupBoxTopMenu.appendChild(issuerPopupBoxCloseButton);
  var loginToIssuer = /*#__PURE__*/function () {
    var _ref = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee(issuerUri) {
      var preLoginRedirectHash, locationUrl, _t;
      return regenerator_default().wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            // clear authorization metadata from store
            external_SolidLogic_.solidLogicSingleton.store.updater.flagAuthorizationMetadata();
            // Save hash
            preLoginRedirectHash = new URL(window.location.href).hash;
            if (preLoginRedirectHash) {
              window.localStorage.setItem('preLoginRedirectHash', preLoginRedirectHash);
            }
            window.localStorage.setItem('loginIssuer', issuerUri);
            // Login
            locationUrl = new URL(window.location.href);
            locationUrl.hash = ''; // remove hash part
            _context.next = 1;
            return external_SolidLogic_.authSession.login({
              redirectUrl: locationUrl.href,
              oidcIssuer: issuerUri
            });
          case 1:
            _context.next = 3;
            break;
          case 2:
            _context.prev = 2;
            _t = _context["catch"](0);
            log_alert(_t.message);
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 2]]);
    }));
    return function loginToIssuer(_x1) {
      return _ref.apply(this, arguments);
    };
  }();

  /**
   * Text-based idp selection
   */
  var issuerTextContainer = dom.createElement('div');
  issuerTextContainer.setAttribute('style', "\n      border-bottom: 1px solid #DDD;\n      display: flex;\n      flex-direction: column;\n      padding-top: 10px;\n    ");
  var issuerTextInputContainer = dom.createElement('div');
  issuerTextInputContainer.setAttribute('style', "\n      display: flex;\n      flex-direction: row;\n    ");
  var issuerTextLabel = dom.createElement('label');
  issuerTextLabel.innerText = 'Enter the URL of your identity provider:';
  issuerTextLabel.setAttribute('style', 'color: #888');
  var issuerTextInput = dom.createElement('input');
  issuerTextInput.setAttribute('type', 'text');
  issuerTextInput.setAttribute('style', 'margin-left: 0 !important; flex: 1; margin-right: 5px !important');
  issuerTextInput.setAttribute('placeholder', 'https://example.com');
  issuerTextInput.value = localStorage.getItem('loginIssuer') || '';
  var issuerTextGoButton = dom.createElement('button');
  issuerTextGoButton.innerText = 'Go';
  issuerTextGoButton.setAttribute('style', 'margin-top: 12px; margin-bottom: 12px;');
  issuerTextGoButton.addEventListener('click', function () {
    loginToIssuer(issuerTextInput.value);
  });
  issuerTextContainer.appendChild(issuerTextLabel);
  issuerTextInputContainer.appendChild(issuerTextInput);
  issuerTextInputContainer.appendChild(issuerTextGoButton);
  issuerTextContainer.appendChild(issuerTextInputContainer);
  issuerPopupBox.appendChild(issuerTextContainer);

  /**
   * Button-based idp selection
   */
  var issuerButtonContainer = dom.createElement('div');
  issuerButtonContainer.setAttribute('style', "\n      display: flex;\n      flex-direction: column;\n      padding-top: 10px;\n    ");
  var issuerBottonLabel = dom.createElement('label');
  issuerBottonLabel.innerText = 'Or pick an identity provider from the list below:';
  issuerBottonLabel.setAttribute('style', 'color: #888');
  issuerButtonContainer.appendChild(issuerBottonLabel);
  (0,external_SolidLogic_.getSuggestedIssuers)().forEach(function (issuerInfo) {
    var issuerButton = dom.createElement('button');
    issuerButton.innerText = issuerInfo.name;
    issuerButton.setAttribute('style', 'height: 38px; margin-top: 10px');
    issuerButton.addEventListener('click', function () {
      loginToIssuer(issuerInfo.uri);
    });
    issuerButtonContainer.appendChild(issuerButton);
  });
  issuerPopupBox.appendChild(issuerButtonContainer);
}

/**
 * Login status box
 *
 * A big sign-up/sign in box or a logout box depending on the state
 *
 * @param dom
 * @param listener
 *
 * @returns
 */
function loginStatusBox(dom) {
  var listener = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  // 20190630
  var me = (0,external_SolidLogic_.offlineTestID)();
  // @@ TODO Remove the need to cast HTML element to any
  var box = dom.createElement('div');
  function setIt(newidURI) {
    if (!newidURI) {
      return;
    }

    // const uri = newidURI.uri || newidURI
    // me = sym(uri)
    me = external_SolidLogic_.authn.saveUser(newidURI);
    box.refresh();
    if (listener) listener(me.uri);
  }
  function logoutButtonHandler(_event) {
    var oldMe = me;
    external_SolidLogic_.authSession.logout().then(function () {
      var message = "Your WebID was ".concat(oldMe, ". It has been forgotten.");
      me = null;
      try {
        log_alert(message);
      } catch (_e) {
        window.alert(message);
      }
      box.refresh();
      if (listener) listener(null);
    }, function (err) {
      log_alert('Fail to log out:' + err);
    });
  }
  function logoutButton(me, options) {
    var signInButtonStyle = options.buttonStyle || style.signInAndUpButtonStyle;
    var logoutLabel = 'WebID logout';
    if (me) {
      var nick = external_SolidLogic_.solidLogicSingleton.store.any(me, src_ns.foaf('nick')) || external_SolidLogic_.solidLogicSingleton.store.any(me, src_ns.foaf('name'));
      if (nick) {
        logoutLabel = 'Logout ' + nick.value;
      }
    }
    var signOutButton = dom.createElement('input');
    // signOutButton.className = 'WebIDCancelButton'
    signOutButton.setAttribute('type', 'button');
    signOutButton.setAttribute('value', logoutLabel);
    signOutButton.setAttribute('style', "".concat(signInButtonStyle));
    signOutButton.addEventListener('click', logoutButtonHandler, false);
    return signOutButton;
  }
  box.refresh = function () {
    var sessionInfo = external_SolidLogic_.authSession.info;
    if (sessionInfo && sessionInfo.webId && sessionInfo.isLoggedIn) {
      me = external_SolidLogic_.solidLogicSingleton.store.sym(sessionInfo.webId);
    } else {
      me = null;
    }
    if (me && box.me !== me.uri || !me && box.me) {
      clearElement(box);
      if (me) {
        box.appendChild(logoutButton(me, options));
      } else {
        box.appendChild(signInOrSignUpBox(dom, setIt, options));
      }
    }
    box.me = me ? me.uri : null;
  };
  box.refresh();
  function trackSession() {
    me = external_SolidLogic_.authn.currentUser();
    box.refresh();
  }
  trackSession();
  external_SolidLogic_.authSession.events.on('login', trackSession);
  external_SolidLogic_.authSession.events.on('logout', trackSession);
  box.me = '99999'; // Force refresh
  box.refresh();
  return box;
}
external_SolidLogic_.authSession.events.on('logout', /*#__PURE__*/asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee2() {
  var issuer, wellKnownUri, wellKnownResult, openidConfiguration, _t2;
  return regenerator_default().wrap(function (_context2) {
    while (1) switch (_context2.prev = _context2.next) {
      case 0:
        issuer = window.localStorage.getItem('loginIssuer');
        if (!issuer) {
          _context2.next = 6;
          break;
        }
        _context2.prev = 1;
        // clear authorization metadata from store
        external_SolidLogic_.solidLogicSingleton.store.updater.flagAuthorizationMetadata();
        wellKnownUri = new URL(issuer);
        wellKnownUri.pathname = '/.well-known/openid-configuration';
        _context2.next = 2;
        return fetch(wellKnownUri.toString());
      case 2:
        wellKnownResult = _context2.sent;
        if (!(wellKnownResult.status === 200)) {
          _context2.next = 4;
          break;
        }
        _context2.next = 3;
        return wellKnownResult.json();
      case 3:
        openidConfiguration = _context2.sent;
        if (!(openidConfiguration && openidConfiguration.end_session_endpoint)) {
          _context2.next = 4;
          break;
        }
        _context2.next = 4;
        return fetch(openidConfiguration.end_session_endpoint, {
          credentials: 'include'
        });
      case 4:
        _context2.next = 6;
        break;
      case 5:
        _context2.prev = 5;
        _t2 = _context2["catch"](1);
      case 6:
        window.location.reload();
      case 7:
      case "end":
        return _context2.stop();
    }
  }, _callee2, null, [[1, 5]]);
})));

/**
 * Workspace selection etc
 * See https://github.com/solidos/userguide/issues/16
 */

/**
 * Returns a UI object which, if it selects a workspace,
 * will callback(workspace, newBase).
 * See https://github.com/solidos/userguide/issues/16 for more info on workspaces.
 *
 * If necessary, will get an account, preference file, etc. In sequence:
 *
 *   - If not logged in, log in.
 *   - Load preference file
 *   - Prompt user for workspaces
 *   - Allows the user to just type in a URI by hand
 *
 * Calls back with the workspace and the base URI
 *
 * @param dom
 * @param appDetails
 * @param callbackWS
 */
function selectWorkspace(dom, appDetails, callbackWS) {
  var noun = appDetails.noun;
  var appPathSegment = appDetails.appPathSegment;
  var me = (0,external_SolidLogic_.offlineTestID)();
  var box = dom.createElement('div');
  var context = {
    me: me,
    dom: dom,
    div: box
  };
  function say(s, background) {
    box.appendChild(errorMessageBlock(dom, s, background));
  }
  function figureOutBase(ws) {
    var newBaseNode = external_SolidLogic_.solidLogicSingleton.store.any(ws, src_ns.space('uriPrefix'));
    var newBaseString;
    if (!newBaseNode) {
      newBaseString = ws.uri.split('#')[0];
    } else {
      newBaseString = newBaseNode.value;
    }
    if (newBaseString.slice(-1) !== '/') {
      src_debug/* log */.Rm("".concat(appPathSegment, ": No / at end of uriPrefix ").concat(newBaseString)); // @@ paramater?
      newBaseString = "".concat(newBaseString, "/");
    }
    var now = new Date();
    newBaseString += "".concat(appPathSegment, "/id").concat(now.getTime(), "/"); // unique id
    return newBaseString;
  }
  function displayOptions(context) {
    // console.log('displayOptions!', context)
    function makeNewWorkspace(_x10) {
      return _makeNewWorkspace.apply(this, arguments);
    } // const status = ''
    function _makeNewWorkspace() {
      _makeNewWorkspace = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee3(_event) {
        var row, cell, newBase, newWs, newData, _t3;
        return regenerator_default().wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              row = table.appendChild(dom.createElement('tr'));
              cell = row.appendChild(dom.createElement('td'));
              cell.setAttribute('colspan', '3');
              cell.style.padding = '0.5em';
              _t3 = encodeURI;
              _context3.next = 1;
              return askName(dom, external_SolidLogic_.solidLogicSingleton.store, cell, src_ns.solid('URL'), src_ns.space('Workspace'), 'Workspace');
            case 1:
              newBase = _t3(_context3.sent);
              newWs = newThing(context.preferencesFile);
              newData = [(0,external_$rdf_.st)(context.me, src_ns.space('workspace'), newWs, context.preferencesFile), (0,external_$rdf_.st)(newWs, src_ns.space('uriPrefix'), newBase, context.preferencesFile)];
              if (external_SolidLogic_.solidLogicSingleton.store.updater) {
                _context3.next = 2;
                break;
              }
              throw new Error('store has no updater');
            case 2:
              _context3.next = 3;
              return external_SolidLogic_.solidLogicSingleton.store.updater.update([], newData);
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return _makeNewWorkspace.apply(this, arguments);
    }
    var id = context.me;
    var preferencesFile = context.preferencesFile;
    var newBase = null;

    // A workspace specifically defined in the private preference file:
    var w = external_SolidLogic_.solidLogicSingleton.store.each(id, src_ns.space('workspace'), undefined, preferencesFile); // Only trust preference file here

    // A workspace in a storage in the public profile:
    var storages = external_SolidLogic_.solidLogicSingleton.store.each(id, src_ns.space('storage')); // @@ No provenance requirement at the moment
    if (w.length === 0 && storages) {
      say("You don't seem to have any workspaces. You have ".concat(storages.length, " storage spaces."), 'white');
      storages.map(function (s) {
        w = w.concat(external_SolidLogic_.solidLogicSingleton.store.each(s, src_ns.ldp('contains')));
        return w;
      }).filter(function (file) {
        return file.id ? ['public', 'private'].includes(file.id().toLowerCase()) : '';
      });
    }
    if (w.length === 1) {
      say("Workspace used: ".concat(w[0].uri), 'white'); // @@ allow user to see URI
      newBase = figureOutBase(w[0]);
      // callbackWS(w[0], newBase)
      // } else if (w.length === 0) {
    }

    // Prompt for ws selection or creation
    // say( w.length + " workspaces for " + id + "Choose one.");
    var table = dom.createElement('table');
    table.setAttribute('style', 'border-collapse:separate; border-spacing: 0.5em;');

    // const popup = window.open(undefined, '_blank', { height: 300, width:400 }, false)
    box.appendChild(table);

    //  Add a field for directly adding the URI yourself

    // const hr = box.appendChild(dom.createElement('hr')) // @@
    box.appendChild(dom.createElement('hr')); // @@

    var p = box.appendChild(dom.createElement('p'));
    p.setAttribute('style', style.commentStyle);
    p.textContent = "Where would you like to store the data for the ".concat(noun, "?\n    Give the URL of the folder where you would like the data stored.\n    It can be anywhere in solid world - this URI is just an idea.");
    // @@ TODO Remove the need to cast baseField to any
    var baseField = box.appendChild(dom.createElement('input'));
    baseField.setAttribute('type', 'text');
    baseField.setAttribute('style', style.textInputStyle);
    baseField.size = 80; // really a string
    baseField.label = 'base URL';
    baseField.autocomplete = 'on';
    if (newBase) {
      // set to default
      baseField.value = newBase;
    }
    context.baseField = baseField;
    box.appendChild(dom.createElement('br')); // @@

    var button = box.appendChild(dom.createElement('button'));
    button.setAttribute('style', style.buttonStyle);
    button.textContent = "Start new ".concat(noun, " at this URI");
    button.addEventListener('click', function (_event) {
      var newBase = baseField.value.replace(' ', '%20'); // do not re-encode in general, as % encodings may exist
      if (newBase.slice(-1) !== '/') {
        newBase += '/';
      }
      callbackWS(null, newBase);
    });

    // Now go set up the table of spaces

    // const row = 0
    w = w.filter(function (x) {
      return !external_SolidLogic_.solidLogicSingleton.store.holds(x, src_ns.rdf('type'),
      // Ignore master workspaces
      src_ns.space('MasterWorkspace'));
    });
    var col1, col2, col3, tr, ws, localStyle, comment;
    var cellStyle = 'height: 3em; margin: 1em; padding: 1em white; border-radius: 0.3em;';
    var deselectedStyle = "".concat(cellStyle, "border: 0px;");
    // const selectedStyle = cellStyle + 'border: 1px solid black;'
    for (var i = 0; i < w.length; i++) {
      ws = w[i];
      tr = dom.createElement('tr');
      if (i === 0) {
        col1 = dom.createElement('td');
        col1.setAttribute('rowspan', "".concat(w.length));
        col1.textContent = 'Choose a workspace for this:';
        col1.setAttribute('style', 'vertical-align:middle;');
        tr.appendChild(col1);
      }
      col2 = dom.createElement('td');
      localStyle = external_SolidLogic_.solidLogicSingleton.store.anyValue(ws, src_ns.ui('style'));
      if (!localStyle) {
        // Otherwise make up arbitrary colour
        var hash = function hash(x) {
          return x.split('').reduce(function (a, b) {
            a = (a << 5) - a + b.charCodeAt(0);
            return a & a;
          }, 0);
        };
        var bgcolor = "#".concat((hash(ws.uri) & 0xffffff | 0xc0c0c0).toString(16)); // c0c0c0  forces pale
        localStyle = "color: black ; background-color: ".concat(bgcolor, ";");
      }
      col2.setAttribute('style', deselectedStyle + localStyle);
      tr.target = ws.uri;
      var label = external_SolidLogic_.solidLogicSingleton.store.any(ws, src_ns.rdfs('label'));
      if (!label) {
        label = ws.uri.split('/').slice(-1)[0] || ws.uri.split('/').slice(-2)[0];
      }
      col2.textContent = label || '???';
      tr.appendChild(col2);
      if (i === 0) {
        col3 = dom.createElement('td');
        col3.setAttribute('rowspan', "".concat(w.length, "1"));
        // col3.textContent = '@@@@@ remove';
        col3.setAttribute('style', 'width:50%;');
        tr.appendChild(col3);
      }
      table.appendChild(tr);
      comment = external_SolidLogic_.solidLogicSingleton.store.any(ws, src_ns.rdfs('comment'));
      comment = comment ? comment.value : 'Use this workspace';
      col2.addEventListener('click', function (_event) {
        col3.textContent = comment ? comment.value : '';
        col3.setAttribute('style', deselectedStyle + localStyle);
        var button = dom.createElement('button');
        button.textContent = 'Continue';
        // button.setAttribute('style', style);
        var newBase = figureOutBase(ws);
        baseField.value = newBase; // show user proposed URI

        button.addEventListener('click', function (_event) {
          button.disabled = true;
          callbackWS(ws, newBase);
          button.textContent = '---->';
        }, true); // capture vs bubble
        col3.appendChild(button);
      }, true); // capture vs bubble
    }

    // last line with "Make new workspace"
    var trLast = dom.createElement('tr');
    col2 = dom.createElement('td');
    col2.setAttribute('style', cellStyle);
    col2.textContent = '+ Make a new workspace';
    col2.addEventListener('click', makeNewWorkspace);
    trLast.appendChild(col2);
    table.appendChild(trLast);
  } // displayOptions

  // console.log('kicking off async operation')
  ensureLoadedPreferences(context) // kick off async operation
  .then(displayOptions)["catch"](function (err) {
    // console.log("err from async op")
    box.appendChild(errorMessageBlock(context.dom, err));
  });
  return box; // return the box element, while login proceeds
} // selectWorkspace

/**
 * Creates a new instance of an app.
 *
 * An instance of an app could be e.g. an issue tracker for a given project,
 * or a chess game, or calendar, or a health/fitness record for a person.
 *
 * Note that this use of the term 'app' refers more to entries in the user's
 * type index than to actual software applications that use the personal data
 * to which these entries point.
 *
 * @param dom
 * @param appDetails
 * @param callback
 *
 * @returns A div with a button in it for making a new app instance
 */
function newAppInstance(dom, appDetails, callback) {
  var gotWS = function gotWS(ws, base) {
    // log.debug("newAppInstance: Selected workspace = " + (ws? ws.uri : 'none'))
    callback(ws, base);
  };
  var div = dom.createElement('div');
  var b = dom.createElement('button');
  b.setAttribute('type', 'button');
  div.appendChild(b);
  b.innerHTML = "Make new ".concat(appDetails.noun);
  b.addEventListener('click', function (_event) {
    div.appendChild(selectWorkspace(dom, appDetails, gotWS));
  }, false);
  div.appendChild(b);
  return div;
}
/**
 * Retrieves whether the currently logged in user is a power user
 * and/or a developer
 */
function getUserRoles() {
  return _getUserRoles.apply(this, arguments);
}

/**
 * Filters which panes should be available, based on the result of [[getUserRoles]]
 */
function _getUserRoles() {
  _getUserRoles = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee0() {
    var _yield$ensureLoadedPr, me, preferencesFile, preferencesFileError, _t0;
    return regenerator_default().wrap(function (_context1) {
      while (1) switch (_context1.prev = _context1.next) {
        case 0:
          _context1.prev = 0;
          _context1.next = 1;
          return ensureLoadedPreferences({});
        case 1:
          _yield$ensureLoadedPr = _context1.sent;
          me = _yield$ensureLoadedPr.me;
          preferencesFile = _yield$ensureLoadedPr.preferencesFile;
          preferencesFileError = _yield$ensureLoadedPr.preferencesFileError;
          if (!(!preferencesFile || preferencesFileError)) {
            _context1.next = 2;
            break;
          }
          throw new Error(preferencesFileError);
        case 2:
          return _context1.abrupt("return", external_SolidLogic_.solidLogicSingleton.store.each(me, src_ns.rdf('type'), null, preferencesFile.doc()));
        case 3:
          _context1.prev = 3;
          _t0 = _context1["catch"](0);
          src_debug/* warn */.R8('Unable to fetch your preferences - this was the error: ', _t0);
          return _context1.abrupt("return", []);
        case 4:
        case "end":
          return _context1.stop();
      }
    }, _callee0, null, [[0, 3]]);
  }));
  return _getUserRoles.apply(this, arguments);
}
function filterAvailablePanes(_x11) {
  return _filterAvailablePanes.apply(this, arguments);
}
function _filterAvailablePanes() {
  _filterAvailablePanes = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee1(panes) {
    var userRoles;
    return regenerator_default().wrap(function (_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 1;
          return getUserRoles();
        case 1:
          userRoles = _context10.sent;
          return _context10.abrupt("return", panes.filter(function (pane) {
            return isMatchingAudience(pane, userRoles);
          }));
        case 2:
        case "end":
          return _context10.stop();
      }
    }, _callee1);
  }));
  return _filterAvailablePanes.apply(this, arguments);
}
function isMatchingAudience(pane, userRoles) {
  var audience = pane.audience || [];
  return audience.reduce(function (isMatch, audienceRole) {
    return isMatch && !!userRoles.find(function (role) {
      return role.equals(audienceRole);
    });
  }, true);
}
;// ./src/acl/add-agent-buttons.ts





/**
 * Contains the [[AddAgentButtons]] class
 * @packageDocumentation
 */








/**
 * Renders the Sharing pane's "+" button and the menus behind it,
 * see https://github.com/solidos/userguide/blob/main/views/sharing/userguide.md#add
 */
var AddAgentButtons = /*#__PURE__*/function () {
  function AddAgentButtons(groupList) {
    classCallCheck_classCallCheck(this, AddAgentButtons);
    _defineProperty(this, "isExpanded", false);
    this.groupList = groupList;
    this.rootElement = groupList.controller.dom.createElement('div');
    this.barElement = groupList.controller.dom.createElement('div');
  }
  return createClass_createClass(AddAgentButtons, [{
    key: "render",
    value: function render() {
      this.rootElement.innerHTML = '';
      this.rootElement.appendChild(this.renderAddButton());
      this.rootElement.appendChild(this.barElement);
      return this.rootElement;
    }
  }, {
    key: "renderAddButton",
    value: function renderAddButton() {
      var _this = this;
      return buttons_button(this.groupList.controller.dom, "".concat(iconBase/* icons */.Pt.iconBase, "noun_34653_green.svg"), 'Add ...', function () {
        _this.toggleBar();
        _this.renderBar();
      });
    }
  }, {
    key: "renderBar",
    value: function renderBar() {
      this.barElement.innerHTML = '';
      if (!this.isExpanded) {
        return;
      }
      this.barElement.appendChild(this.renderPersonButton());
      this.barElement.appendChild(this.renderGroupButton());
      this.barElement.appendChild(this.renderPublicButton());
      this.barElement.appendChild(this.renderAuthenticatedAgentButton());
      this.barElement.appendChild(this.renderBotButton());
      this.barElement.appendChild(this.renderAppsButton());
    }
  }, {
    key: "renderSimplifiedBar",
    value: function renderSimplifiedBar(button) {
      var _this2 = this;
      Array.from(this.barElement.children).filter(function (element) {
        return element !== button;
      }).forEach(function (element) {
        return _this2.barElement.removeChild(element);
      });
    }
  }, {
    key: "renderPersonButton",
    value: function renderPersonButton() {
      var _this3 = this;
      return buttons_button(this.groupList.controller.dom, iconBase/* icons */.Pt.iconBase + iconForClass['vcard:Individual'], 'Add Person', function (event) {
        _this3.renderSimplifiedBar(event.target);
        _this3.renderNameForm(src_ns.vcard('Individual'), 'person').then(function (name) {
          return _this3.addPerson(name);
        }).then(function () {
          return _this3.renderCleanup();
        })["catch"](function (error) {
          return _this3.groupList.controller.renderStatus(error);
        });
      });
    }
  }, {
    key: "renderGroupButton",
    value: function renderGroupButton() {
      var _this4 = this;
      return buttons_button(this.groupList.controller.dom, iconBase/* icons */.Pt.iconBase + iconForClass['vcard:Group'], 'Add Group', function (event) {
        _this4.renderSimplifiedBar(event.target);
        _this4.renderNameForm(src_ns.vcard('Group'), 'group').then(function (name) {
          return _this4.addGroup(name);
        }).then(function () {
          return _this4.renderCleanup();
        })["catch"](function (error) {
          return _this4.groupList.controller.renderStatus(error);
        });
      });
    }
  }, {
    key: "renderNameForm",
    value: function renderNameForm(type, noun) {
      return askName(this.groupList.controller.dom, this.groupList.store, this.barElement, src_ns.vcard('URI'), type, noun);
    }
  }, {
    key: "renderPublicButton",
    value: function renderPublicButton() {
      var _this5 = this;
      return buttons_button(this.groupList.controller.dom, iconBase/* icons */.Pt.iconBase + iconForClass['foaf:Agent'], 'Add Everyone', function () {
        return _this5.addAgent(src_ns.foaf('Agent').uri).then(function () {
          return _this5.groupList.controller.renderTemporaryStatus('Adding the general public to those who can read. Drag the globe to a different level to give them more access.');
        }).then(function () {
          return _this5.renderCleanup();
        });
      });
    }
  }, {
    key: "renderAuthenticatedAgentButton",
    value: function renderAuthenticatedAgentButton() {
      var _this6 = this;
      return buttons_button(this.groupList.controller.dom, "".concat(iconBase/* icons */.Pt.iconBase, "noun_99101.svg"), 'Anyone logged In', function () {
        return _this6.addAgent(src_ns.acl('AuthenticatedAgent').uri).then(function () {
          return _this6.groupList.controller.renderTemporaryStatus('Adding anyone logged in to those who can read. Drag the ID icon to a different level to give them more access.');
        }).then(function () {
          return _this6.renderCleanup();
        });
      });
    }
  }, {
    key: "renderBotButton",
    value: function renderBotButton() {
      var _this7 = this;
      return buttons_button(this.groupList.controller.dom, iconBase/* icons */.Pt.iconBase + 'noun_Robot_849764.svg', 'A Software Agent (bot)', function (event) {
        _this7.renderSimplifiedBar(event.target);
        _this7.renderNameForm(src_ns.schema('Application'), 'bot').then(function (name) {
          return _this7.addBot(name);
        }).then(function () {
          return _this7.renderCleanup();
        });
      });
    }
  }, {
    key: "renderAppsButton",
    value: function renderAppsButton() {
      var _this8 = this;
      return buttons_button(this.groupList.controller.dom, "".concat(iconBase/* icons */.Pt.iconBase, "noun_15177.svg"), 'A Web App (origin)', function (event) {
        _this8.renderSimplifiedBar(event.target);
        var eventContext = {
          div: _this8.barElement,
          dom: _this8.groupList.controller.dom
        };
        var existingApps = _this8.renderAppsTable(eventContext)["catch"](function (error) {
          return _this8.groupList.controller.renderStatus(error);
        });
        _this8.renderAppsView();
        var newApp = _this8.renderNameForm(src_ns.schema('WebApplication'), 'webapp domain').then(function (name) {
          return _this8.getOriginFromName(name);
        });
        Promise.race([existingApps, newApp]).then(function (origin) {
          if (origin) {
            _this8.groupList.addNewURI(origin);
          }
        }).then(function () {
          return _this8.renderCleanup();
        });
      });
    }
  }, {
    key: "renderAppsView",
    value: function renderAppsView() {
      var _this9 = this;
      var trustedApplications = this.groupList.controller.context.session.paneRegistry.byName('trustedApplications');
      if (trustedApplications) {
        var trustedApplicationsElement = trustedApplications.render(null, this.groupList.controller.context);
        trustedApplicationsElement.setAttribute('style', style.trustedAppController);
        var cancelButton = buttons_cancelButton(this.groupList.controller.dom, function () {
          return _this9.renderCleanup();
        });
        cancelButton.setAttribute('style', style.trustedAppCancelButton);
        trustedApplicationsElement.insertBefore(cancelButton, trustedApplicationsElement.firstChild);
        this.barElement.appendChild(trustedApplicationsElement);
      }
    }
  }, {
    key: "renderAppsTable",
    value: function () {
      var _renderAppsTable = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee(eventContext) {
        var _this0 = this;
        var trustedApps, trustedOrigins;
        return regenerator_default().wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return ensureLoadedProfile(eventContext);
            case 1:
              trustedApps = this.groupList.store.each(eventContext.me, src_ns.acl('trustedApp')); // @@ TODO fix as
              trustedOrigins = trustedApps.flatMap(function (app) {
                return _this0.groupList.store.each(app, src_ns.acl('origin'));
              }); // @@ TODO fix as
              this.barElement.appendChild(this.groupList.controller.dom.createElement('p')).textContent = "You have ".concat(trustedOrigins.length, " selected web apps.");
              return _context.abrupt("return", new Promise(function (resolve, reject) {
                var appsTable = _this0.barElement.appendChild(_this0.groupList.controller.dom.createElement('table'));
                appsTable.setAttribute('style', style.trustedAppAddApplicationsTable);
                trustedApps.forEach(function (app) {
                  var origin = _this0.groupList.store.any(app, src_ns.acl('origin')); // @@ TODO fix as
                  if (!origin) {
                    reject(new Error("Unable to pick app: ".concat(app.value)));
                  }
                  var thingTR = personTR(_this0.groupList.controller.dom, src_ns.acl('origin'), origin, {});
                  var innerTable = _this0.groupList.controller.dom.createElement('table');
                  var innerRow = innerTable.appendChild(_this0.groupList.controller.dom.createElement('tr'));
                  var innerLeftColumn = innerRow.appendChild(_this0.groupList.controller.dom.createElement('td'));
                  innerLeftColumn.appendChild(thingTR);
                  var innerMiddleColumn = innerRow.appendChild(_this0.groupList.controller.dom.createElement('td'));
                  innerMiddleColumn.textContent = "Give access to ".concat(_this0.groupList.controller.noun, " ").concat(label_label(_this0.groupList.controller.subject), "?");
                  var innerRightColumn = innerRow.appendChild(_this0.groupList.controller.dom.createElement('td'));
                  innerRightColumn.appendChild(continueButton(_this0.groupList.controller.dom, function () {
                    return resolve(origin.value);
                  }));
                  appsTable.appendChild(innerTable);
                });
              }));
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function renderAppsTable(_x) {
        return _renderAppsTable.apply(this, arguments);
      }
      return renderAppsTable;
    }()
  }, {
    key: "renderCleanup",
    value: function renderCleanup() {
      this.renderBar();
      this.groupList.render();
    }
  }, {
    key: "addPerson",
    value: function () {
      var _addPerson = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee2(name) {
        var domainNameRegexp;
        return regenerator_default().wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (name) {
                _context2.next = 1;
                break;
              }
              return _context2.abrupt("return", this.toggleBar());
            case 1:
              // user cancelled
              domainNameRegexp = /^https?:/i;
              if (name.match(domainNameRegexp)) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return", Promise.reject(new Error('Not a http URI')));
            case 2:
              // @@ check it actually is a person and has an owner who agrees they own it
              src_debug/* log */.Rm("Adding to ACL person: ".concat(name));
              _context2.next = 3;
              return this.groupList.addNewURI(name);
            case 3:
              this.toggleBar();
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function addPerson(_x2) {
        return _addPerson.apply(this, arguments);
      }
      return addPerson;
    }()
  }, {
    key: "addGroup",
    value: function () {
      var _addGroup = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee3(name) {
        var domainNameRegexp;
        return regenerator_default().wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (name) {
                _context3.next = 1;
                break;
              }
              return _context3.abrupt("return", this.toggleBar());
            case 1:
              // user cancelled
              domainNameRegexp = /^https?:/i;
              if (name.match(domainNameRegexp)) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return", Promise.reject(new Error('Not a http URI')));
            case 2:
              // @@ check it actually is a group and has an owner who agrees they own it
              src_debug/* log */.Rm('Adding to ACL group: ' + name);
              _context3.next = 3;
              return this.groupList.addNewURI(name);
            case 3:
              this.toggleBar();
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function addGroup(_x3) {
        return _addGroup.apply(this, arguments);
      }
      return addGroup;
    }()
  }, {
    key: "addAgent",
    value: function () {
      var _addAgent = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee4(agentUri) {
        return regenerator_default().wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 1;
              return this.groupList.addNewURI(agentUri);
            case 1:
              this.toggleBar();
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function addAgent(_x4) {
        return _addAgent.apply(this, arguments);
      }
      return addAgent;
    }()
  }, {
    key: "addBot",
    value: function () {
      var _addBot = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee5(name) {
        var domainNameRegexp;
        return regenerator_default().wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (name) {
                _context5.next = 1;
                break;
              }
              return _context5.abrupt("return", this.toggleBar());
            case 1:
              // user cancelled
              domainNameRegexp = /^https?:/i;
              if (name.match(domainNameRegexp)) {
                _context5.next = 2;
                break;
              }
              return _context5.abrupt("return", Promise.reject(new Error('Not a http URI')));
            case 2:
              // @@ check it actually is a bot and has an owner who agrees they own it
              src_debug/* log */.Rm('Adding to ACL bot: ' + name);
              _context5.next = 3;
              return this.groupList.addNewURI(name);
            case 3:
              this.toggleBar();
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function addBot(_x5) {
        return _addBot.apply(this, arguments);
      }
      return addBot;
    }()
  }, {
    key: "getOriginFromName",
    value: function () {
      var _getOriginFromName = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee6(name) {
        var domainNameRegexp, origin;
        return regenerator_default().wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (name) {
                _context6.next = 1;
                break;
              }
              return _context6.abrupt("return", Promise.resolve());
            case 1:
              // user cancelled
              domainNameRegexp = /^([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,}$/i; // https://www.oreilly.com/library/view/regular-expressions-cookbook/9781449327453/ch08s15.html
              if (name.match(domainNameRegexp)) {
                _context6.next = 2;
                break;
              }
              return _context6.abrupt("return", Promise.reject(new Error('Not a domain name')));
            case 2:
              origin = 'https://' + name;
              src_debug/* log */.Rm('Adding to ACL origin: ' + origin);
              this.toggleBar();
              return _context6.abrupt("return", origin);
            case 3:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function getOriginFromName(_x6) {
        return _getOriginFromName.apply(this, arguments);
      }
      return getOriginFromName;
    }()
  }, {
    key: "toggleBar",
    value: function toggleBar() {
      this.isExpanded = !this.isExpanded;
    }
  }]);
}();
;// ./src/acl/access-groups.ts





/**
 * Contains the [[AccessGroups]]
 * and [[AccessGroupsOptions]] classes
 * @packageDocumentation
 */








var ACL = src_ns.acl;
var COLLOQUIAL = {
  13: 'Owners',
  9: 'Owners (write locked)',
  5: 'Editors',
  3: 'Posters',
  2: 'Submitters',
  1: 'Viewers'
};
var RECOMMENDED = {
  13: true,
  5: true,
  3: true,
  2: true,
  1: true
};
var EXPLANATION = {
  13: 'can read, write, and control sharing.',
  9: 'can read and control sharing, currently write-locked.',
  5: 'can read and change information',
  3: 'can add new information, and read but not change existing information',
  2: 'can add new information but not read any',
  1: 'can read but not change information'
};

/**
 * Type for the options parameter of [[AccessGroups]]
 */

/**
 * Renders the table of Owners, Editors, Posters, Submitters, Viewers
 * for https://github.com/solidos/userguide/blob/main/views/sharing/userguide.md
 */
var AccessGroups = /*#__PURE__*/function () {
  // @@ was LiveStore but does not need to be connected to web

  function AccessGroups(doc, aclDoc, controller, store) {
    var _options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
    classCallCheck_classCallCheck(this, AccessGroups);
    this.doc = doc;
    this.aclDoc = aclDoc;
    this.controller = controller;
    this._options = _options;
    this.defaults = this._options.defaults || false;
    this._store = store;
    this.aclMap = readACL(doc, aclDoc, store, this.defaults);
    this.byCombo = ACLbyCombination(this.aclMap);
    this.addAgentButton = new AddAgentButtons(this);
    this.rootElement = this.controller.dom.createElement('div');
    this.rootElement.setAttribute('style', style.accessGroupList);
  }
  return createClass_createClass(AccessGroups, [{
    key: "store",
    get: function get() {
      return this._store;
    },
    set: function set(store) {
      this._store = store;
      this.aclMap = readACL(this.doc, this.aclDoc, store, this.defaults);
      this.byCombo = ACLbyCombination(this.aclMap);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      this.rootElement.innerHTML = '';
      this.renderGroups().forEach(function (group) {
        return _this.rootElement.appendChild(group);
      });
      if (this.controller.isEditable) {
        this.rootElement.appendChild(this.addAgentButton.render());
      }
      return this.rootElement;
    }
  }, {
    key: "renderGroups",
    value: function renderGroups() {
      var groupElements = [];
      for (var comboIndex = 15; comboIndex > 0; comboIndex--) {
        var combo = kToCombo(comboIndex);
        if (this.controller.isEditable && RECOMMENDED[comboIndex] || this.byCombo[combo]) {
          groupElements.push(this.renderGroup(comboIndex, combo));
        }
      }
      return groupElements;
    }
  }, {
    key: "renderGroup",
    value: function renderGroup(comboIndex, combo) {
      var _this2 = this;
      var groupRow = this.controller.dom.createElement('div');
      groupRow.setAttribute('style', style.accessGroupListItem);
      makeDropTarget(groupRow, function (uris) {
        return _this2.handleDroppedUris(uris, combo).then(function () {
          return _this2.controller.render();
        })["catch"](function (error) {
          return _this2.controller.renderStatus(error);
        });
      });
      var groupColumns = this.renderGroupElements(comboIndex, combo);
      groupColumns.forEach(function (column) {
        return groupRow.appendChild(column);
      });
      return groupRow;
    }
  }, {
    key: "renderGroupElements",
    value: function renderGroupElements(comboIndex, combo) {
      var _this3 = this;
      var groupNameColumn = this.controller.dom.createElement('div');
      groupNameColumn.setAttribute('style', style.group);
      if (this.controller.isEditable) {
        switch (comboIndex) {
          case 1:
            groupNameColumn.setAttribute('style', style.group1);
            break;
          case 2:
            groupNameColumn.setAttribute('style', style.group2);
            break;
          case 3:
            groupNameColumn.setAttribute('style', style.group3);
            break;
          case 5:
            groupNameColumn.setAttribute('style', style.group5);
            break;
          case 9:
            groupNameColumn.setAttribute('style', style.group9);
            break;
          case 13:
            groupNameColumn.setAttribute('style', style.group13);
            break;
          default:
            groupNameColumn.setAttribute('style', style.group);
        }
      }
      groupNameColumn.innerText = COLLOQUIAL[comboIndex] || ktToList(comboIndex);
      var groupAgentsColumn = this.controller.dom.createElement('div');
      groupAgentsColumn.setAttribute('style', style.group);
      if (this.controller.isEditable) {
        switch (comboIndex) {
          case 1:
            groupAgentsColumn.setAttribute('style', style.group1);
            break;
          case 2:
            groupAgentsColumn.setAttribute('style', style.group2);
            break;
          case 3:
            groupAgentsColumn.setAttribute('style', style.group3);
            break;
          case 5:
            groupAgentsColumn.setAttribute('style', style.group5);
            break;
          case 9:
            groupAgentsColumn.setAttribute('style', style.group9);
            break;
          case 13:
            groupAgentsColumn.setAttribute('style', style.group13);
            break;
          default:
            groupAgentsColumn.setAttribute('style', style.group);
        }
      }
      var groupAgentsTable = groupAgentsColumn.appendChild(this.controller.dom.createElement('table'));
      var combos = this.byCombo[combo] || [];
      combos.map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          pred = _ref2[0],
          obj = _ref2[1];
        return _this3.renderAgent(groupAgentsTable, combo, pred, obj);
      }).forEach(function (agentElement) {
        return groupAgentsTable.appendChild(agentElement);
      });
      var groupDescriptionElement = this.controller.dom.createElement('div');
      groupDescriptionElement.setAttribute('style', style.group);
      if (this.controller.isEditable) {
        switch (comboIndex) {
          case 1:
            groupDescriptionElement.setAttribute('style', style.group1);
            break;
          case 2:
            groupDescriptionElement.setAttribute('style', style.group2);
            break;
          case 3:
            groupDescriptionElement.setAttribute('style', style.group3);
            break;
          case 5:
            groupDescriptionElement.setAttribute('style', style.group5);
            break;
          case 9:
            groupDescriptionElement.setAttribute('style', style.group9);
            break;
          case 13:
            groupDescriptionElement.setAttribute('style', style.group13);
            break;
          default:
            groupDescriptionElement.setAttribute('style', style.group);
        }
      }
      groupDescriptionElement.innerText = EXPLANATION[comboIndex] || 'Unusual combination';
      return [groupNameColumn, groupAgentsColumn, groupDescriptionElement];
    }
  }, {
    key: "renderAgent",
    value: function renderAgent(groupAgentsTable, combo, pred, obj) {
      var _this4 = this;
      var personRow = personTR(this.controller.dom, ACL(pred), (0,external_$rdf_.sym)(obj), this.controller.isEditable ? {
        deleteFunction: function deleteFunction() {
          return _this4.deleteAgent(combo, pred, obj).then(function () {
            return groupAgentsTable.removeChild(personRow);
          })["catch"](function (error) {
            return _this4.controller.renderStatus(error);
          });
        }
      } : {});
      return personRow;
    }
  }, {
    key: "deleteAgent",
    value: function () {
      var _deleteAgent = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee(combo, pred, obj) {
        var combos, comboToRemove;
        return regenerator_default().wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              combos = this.byCombo[combo] || [];
              comboToRemove = combos.find(function (_ref3) {
                var _ref4 = _slicedToArray(_ref3, 2),
                  comboPred = _ref4[0],
                  comboObj = _ref4[1];
                return comboPred === pred && comboObj === obj;
              });
              if (comboToRemove) {
                combos.splice(combos.indexOf(comboToRemove), 1);
              }
              _context.next = 1;
              return this.controller.save();
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function deleteAgent(_x, _x2, _x3) {
        return _deleteAgent.apply(this, arguments);
      }
      return deleteAgent;
    }()
  }, {
    key: "addNewURI",
    value: function () {
      var _addNewURI = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee2(uri) {
        return regenerator_default().wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 1;
              return this.handleDroppedUri(uri, kToCombo(1));
            case 1:
              _context2.next = 2;
              return this.controller.save();
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function addNewURI(_x4) {
        return _addNewURI.apply(this, arguments);
      }
      return addNewURI;
    }()
  }, {
    key: "handleDroppedUris",
    value: function () {
      var _handleDroppedUris = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee3(uris, combo) {
        var _this5 = this;
        var _t;
        return regenerator_default().wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 1;
              return Promise.all(uris.map(function (uri) {
                return _this5.handleDroppedUri(uri, combo);
              }));
            case 1:
              _context3.next = 2;
              return this.controller.save();
            case 2:
              _context3.next = 4;
              break;
            case 3:
              _context3.prev = 3;
              _t = _context3["catch"](0);
              return _context3.abrupt("return", Promise.reject(_t));
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 3]]);
      }));
      function handleDroppedUris(_x5, _x6) {
        return _handleDroppedUris.apply(this, arguments);
      }
      return handleDroppedUris;
    }()
  }, {
    key: "handleDroppedUri",
    value: function () {
      var _handleDroppedUri = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee4(uri, combo) {
        var secondAttempt,
          agent,
          thing,
          _this$_store,
          message,
          error,
          _args4 = arguments,
          _t2;
        return regenerator_default().wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              secondAttempt = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : false;
              agent = findAgent(uri, this.store); // eg 'agent', 'origin', agentClass'
              thing = (0,external_$rdf_.sym)(uri);
              if (!(!agent && !secondAttempt)) {
                _context4.next = 5;
                break;
              }
              src_debug/* log */.Rm("   Not obvious: looking up dropped thing ".concat(thing));
              _context4.prev = 1;
              _context4.next = 2;
              return (_this$_store = this._store) === null || _this$_store === void 0 || (_this$_store = _this$_store.fetcher) === null || _this$_store === void 0 ? void 0 : _this$_store.load(thing.doc());
            case 2:
              _context4.next = 4;
              break;
            case 3:
              _context4.prev = 3;
              _t2 = _context4["catch"](1);
              message = "Ignore error looking up dropped thing: ".concat(_t2);
              src_debug/* error */.z3(message);
              return _context4.abrupt("return", Promise.reject(new Error(message)));
            case 4:
              return _context4.abrupt("return", this.handleDroppedUri(uri, combo, true));
            case 5:
              if (agent) {
                _context4.next = 6;
                break;
              }
              error = "   Error: Drop fails to drop appropriate thing! ".concat(uri);
              src_debug/* error */.z3(error);
              return _context4.abrupt("return", Promise.reject(new Error(error)));
            case 6:
              this.setACLCombo(combo, uri, agent, this.controller.subject);
            case 7:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[1, 3]]);
      }));
      function handleDroppedUri(_x7, _x8) {
        return _handleDroppedUri.apply(this, arguments);
      }
      return handleDroppedUri;
    }()
  }, {
    key: "setACLCombo",
    value: function setACLCombo(combo, uri, res, subject) {
      if (!(combo in this.byCombo)) {
        this.byCombo[combo] = [];
      }
      this.removeAgentFromCombos(uri); // Combos are mutually distinct
      this.byCombo[combo].push([res.pred, res.obj.uri]);
      src_debug/* log */.Rm("ACL: setting access to ".concat(subject, " by ").concat(res.pred, ": ").concat(res.obj));
    }
  }, {
    key: "removeAgentFromCombos",
    value: function removeAgentFromCombos(uri) {
      for (var k = 0; k < 16; k++) {
        var combos = this.byCombo[kToCombo(k)];
        if (combos) {
          for (var i = 0; i < combos.length; i++) {
            while (i < combos.length && combos[i][1] === uri) {
              combos.splice(i, 1);
            }
          }
        }
      }
    }
  }]);
}();
function kToCombo(k) {
  var y = ['Read', 'Append', 'Write', 'Control'];
  var combo = [];
  for (var i = 0; i < 4; i++) {
    if (k & 1 << i) {
      combo.push('http://www.w3.org/ns/auth/acl#' + y[i]);
    }
  }
  combo.sort();
  return combo.join('\n');
}
function ktToList(k) {
  var list = '';
  var y = ['Read', 'Append', 'Write', 'Control'];
  for (var i = 0; i < 4; i++) {
    if (k & 1 << i) {
      list += y[i];
    }
  }
  return list;
}
function findAgent(uri, kb) {
  var obj = (0,external_$rdf_.sym)(uri);
  var types = kb.findTypeURIs(obj);
  for (var ty in types) {
    src_debug/* log */.Rm('    drop object type includes: ' + ty);
  }
  // An Origin URI is one like https://fred.github.io eith no trailing slash
  if (uri.startsWith('http') && uri.split('/').length === 3) {
    // there is no third slash
    return {
      pred: 'origin',
      obj: obj
    }; // The only way to know an origin alas
  }
  // @@ This is an almighty kludge needed because drag and drop adds extra slashes to origins
  if (uri.startsWith('http') && uri.split('/').length === 4 && uri.endsWith('/')) {
    // there  IS third slash
    src_debug/* log */.Rm('Assuming final slash on dragged origin URI was unintended!');
    return {
      pred: 'origin',
      obj: (0,external_$rdf_.sym)(uri.slice(0, -1))
    }; // Fix a URI where the drag and drop system has added a spurious slash
  }
  if (src_ns.vcard('WebID').uri in types) return {
    pred: 'agent',
    obj: obj
  };
  if (src_ns.vcard('Group').uri in types) {
    return {
      pred: 'agentGroup',
      obj: obj
    }; // @@ note vcard membership not RDFs
  }
  if (obj.sameTerm(src_ns.foaf('Agent')) || obj.sameTerm(src_ns.acl('AuthenticatedAgent')) ||
  // AuthenticatedAgent
  obj.sameTerm(src_ns.rdf('Resource')) || obj.sameTerm(src_ns.owl('Thing'))) {
    return {
      pred: 'agentClass',
      obj: obj
    };
  }
  if (src_ns.vcard('Individual').uri in types || src_ns.foaf('Person').uri in types || src_ns.foaf('Agent').uri in types) {
    var pref = kb.any(obj, src_ns.foaf('preferredURI'));
    if (pref) return {
      pred: 'agent',
      obj: (0,external_$rdf_.sym)(pref)
    };
    return {
      pred: 'agent',
      obj: obj
    };
  }
  if (src_ns.solid('AppProvider').uri in types) {
    return {
      pred: 'origin',
      obj: obj
    };
  }
  if (src_ns.solid('AppProviderClass').uri in types) {
    return {
      pred: 'originClass',
      obj: obj
    };
  }
  src_debug/* log */.Rm('    Triage fails for ' + uri);
  return null;
}
;// ./src/acl/access-controller.ts




/**
 * Contains the [[AccessController]] class
 * @packageDocumentation
 */









/**
 * Rendered HTML component used in the databrowser's Sharing pane.
 */
var AccessController = /*#__PURE__*/function () {
  function AccessController(subject, noun, context, statusElement, targetIsProtected, targetDoc, targetACLDoc, defaultHolder, defaultACLDoc, prospectiveDefaultHolder, store, dom) {
    classCallCheck_classCallCheck(this, AccessController);
    this.subject = subject;
    this.noun = noun;
    this.context = context;
    this.statusElement = statusElement;
    this.targetIsProtected = targetIsProtected;
    this.targetDoc = targetDoc;
    this.targetACLDoc = targetACLDoc;
    this.defaultHolder = defaultHolder;
    this.defaultACLDoc = defaultACLDoc;
    this.prospectiveDefaultHolder = prospectiveDefaultHolder;
    this.store = store;
    this.dom = dom;
    this.rootElement = dom.createElement('div');
    this.rootElement.setAttribute('style', style.aclGroupContent);
    this.isContainer = targetDoc.uri.slice(-1) === '/'; // Give default for all directories
    if (defaultHolder && defaultACLDoc) {
      this.isUsingDefaults = true;
      var aclDefaultStore = adoptACLDefault(this.targetDoc, targetACLDoc, defaultHolder, defaultACLDoc);
      this.mainCombo = new AccessGroups(targetDoc, targetACLDoc, this, aclDefaultStore, {
        defaults: this.isContainer
      });
      this.defaultsCombo = null;
      this.defaultsDiffer = false;
    } else {
      this.isUsingDefaults = false;
      this.mainCombo = new AccessGroups(targetDoc, targetACLDoc, this, store);
      this.defaultsCombo = new AccessGroups(targetDoc, targetACLDoc, this, store, {
        defaults: this.isContainer
      });
      this.defaultsDiffer = !sameACL(this.mainCombo.aclMap, this.defaultsCombo.aclMap);
    }
  }
  return createClass_createClass(AccessController, [{
    key: "isEditable",
    get: function get() {
      return !this.isUsingDefaults;
    }
  }, {
    key: "render",
    value: function render() {
      this.rootElement.innerHTML = '';
      if (this.isUsingDefaults) {
        this.renderStatus("The sharing for this ".concat(this.noun, " is the default for folder "));
        if (this.defaultHolder) {
          var defaultHolderLink = this.statusElement.appendChild(this.dom.createElement('a'));
          defaultHolderLink.href = this.defaultHolder.uri;
          defaultHolderLink.innerText = shortNameForFolder(this.defaultHolder);
        }
      } else if (!this.defaultsDiffer && this.isContainer) {
        this.renderStatus('This is also the default for things in this folder.');
      } else {
        this.renderStatus('');
      }
      this.rootElement.appendChild(this.mainCombo.render());
      if (this.defaultsCombo && this.defaultsDiffer) {
        this.rootElement.appendChild(this.renderRemoveDefaultsController());
        this.rootElement.appendChild(this.defaultsCombo.render());
      } else if (this.isEditable && this.isContainer) {
        this.rootElement.appendChild(this.renderAddDefaultsController());
      }
      if (!this.targetIsProtected && this.isUsingDefaults) {
        this.rootElement.appendChild(this.renderAddAclsController());
      } else if (!this.targetIsProtected) {
        this.rootElement.appendChild(this.renderRemoveAclsController());
      }
      return this.rootElement;
    }
  }, {
    key: "renderRemoveAclsController",
    value: function renderRemoveAclsController() {
      var _this = this;
      var useDefaultButton = this.dom.createElement('button');
      useDefaultButton.innerText = "Remove custom sharing settings for this ".concat(this.noun, " -- just use default").concat(this.prospectiveDefaultHolder ? " for ".concat(label_label(this.prospectiveDefaultHolder)) : '');
      useDefaultButton.setAttribute('style', style.bigButton);
      useDefaultButton.addEventListener('click', function () {
        return _this.removeAcls().then(function () {
          return _this.render();
        })["catch"](function (error) {
          return _this.renderStatus(error);
        });
      });
      return useDefaultButton;
    }
  }, {
    key: "renderAddAclsController",
    value: function renderAddAclsController() {
      var _this2 = this;
      var addAclButton = this.dom.createElement('button');
      addAclButton.innerText = "Set specific sharing for this ".concat(this.noun);
      addAclButton.setAttribute('style', style.bigButton);
      addAclButton.addEventListener('click', function () {
        return _this2.addAcls().then(function () {
          return _this2.render();
        })["catch"](function (error) {
          return _this2.renderStatus(error);
        });
      });
      return addAclButton;
    }
  }, {
    key: "renderAddDefaultsController",
    value: function renderAddDefaultsController() {
      var _this3 = this;
      var containerElement = this.dom.createElement('div');
      containerElement.setAttribute('style', style.defaultsController);
      var noticeElement = containerElement.appendChild(this.dom.createElement('div'));
      noticeElement.innerText = 'Sharing for things within the folder currently tracks sharing for the folder.';
      noticeElement.setAttribute('style', style.defaultsControllerNotice);
      var button = containerElement.appendChild(this.dom.createElement('button'));
      button.innerText = 'Set the sharing of folder contents separately from the sharing for the folder';
      button.setAttribute('style', style.bigButton);
      button.addEventListener('click', function () {
        return _this3.addDefaults().then(function () {
          return _this3.render();
        });
      });
      return containerElement;
    }
  }, {
    key: "renderRemoveDefaultsController",
    value: function renderRemoveDefaultsController() {
      var _this4 = this;
      var containerElement = this.dom.createElement('div');
      containerElement.setAttribute('style', style.defaultsController);
      var noticeElement = containerElement.appendChild(this.dom.createElement('div'));
      noticeElement.innerText = 'Access to things within this folder:';
      noticeElement.setAttribute('style', style.defaultsControllerNotice);
      var button = containerElement.appendChild(this.dom.createElement('button'));
      button.innerText = 'Set default for folder contents to just track the sharing for the folder';
      button.setAttribute('style', style.bigButton);
      button.addEventListener('click', function () {
        return _this4.removeDefaults().then(function () {
          return _this4.render();
        })["catch"](function (error) {
          return _this4.renderStatus(error);
        });
      });
      return containerElement;
    }
  }, {
    key: "renderTemporaryStatus",
    value: function renderTemporaryStatus(message) {
      var _this5 = this;
      // @@ TODO Introduce better system for error notification to user https://github.com/solidos/mashlib/issues/87
      this.statusElement.setAttribute('style', style.aclControlBoxStatusRevealed);
      this.statusElement.innerText = message;
      this.statusElement.setAttribute('style', style.temporaryStatusInit);
      setTimeout(function () {
        _this5.statusElement.setAttribute('style', style.temporaryStatusEnd);
      });
      setTimeout(function () {
        _this5.statusElement.innerText = '';
      }, 5000);
    }
  }, {
    key: "renderStatus",
    value: function renderStatus(message) {
      // @@ TODO Introduce better system for error notification to user https://github.com/solidos/mashlib/issues/87
      if (!message) {
        this.statusElement.setAttribute('style', style.aclControlBoxStatusRevealed);
      }
      this.statusElement.innerText = message;
    }
  }, {
    key: "addAcls",
    value: function () {
      var _addAcls = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee() {
        var _this6 = this;
        var message, aclGraph, _message, _t;
        return regenerator_default().wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!this.defaultHolder || !this.defaultACLDoc)) {
                _context.next = 1;
                break;
              }
              message = 'Unable to find defaults to copy';
              src_debug/* error */.z3(message);
              return _context.abrupt("return", Promise.reject(message));
            case 1:
              aclGraph = adoptACLDefault(this.targetDoc, this.targetACLDoc, this.defaultHolder, this.defaultACLDoc);
              aclGraph.statements.forEach(function (st) {
                return _this6.store.add(st.subject, st.predicate, st.object, _this6.targetACLDoc);
              });
              _context.prev = 2;
              _context.next = 3;
              return this.store.fetcher.putBack(this.targetACLDoc);
            case 3:
              this.isUsingDefaults = false;
              return _context.abrupt("return", Promise.resolve());
            case 4:
              _context.prev = 4;
              _t = _context["catch"](2);
              _message = " Error writing back access control file! ".concat(_t);
              src_debug/* error */.z3(_message);
              return _context.abrupt("return", Promise.reject(_message));
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[2, 4]]);
      }));
      function addAcls() {
        return _addAcls.apply(this, arguments);
      }
      return addAcls;
    }()
  }, {
    key: "addDefaults",
    value: function () {
      var _addDefaults = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee2() {
        return regenerator_default().wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.defaultsCombo = new AccessGroups(this.targetDoc, this.targetACLDoc, this, this.store, {
                defaults: true
              });
              this.defaultsDiffer = true;
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function addDefaults() {
        return _addDefaults.apply(this, arguments);
      }
      return addDefaults;
    }()
  }, {
    key: "removeAcls",
    value: function () {
      var _removeAcls = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee3() {
        var message, _t2, _t3;
        return regenerator_default().wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 1;
              return this.store.fetcher["delete"](this.targetACLDoc.uri, {});
            case 1:
              this.isUsingDefaults = true;
              _context3.prev = 2;
              _context3.next = 3;
              return getProspectiveHolder(this.targetDoc.uri);
            case 3:
              this.prospectiveDefaultHolder = _context3.sent;
              _context3.next = 5;
              break;
            case 4:
              _context3.prev = 4;
              _t2 = _context3["catch"](2);
              // No need to show this error in status, but good to warn about it in console
              src_debug/* warn */.R8(_t2);
            case 5:
              _context3.next = 7;
              break;
            case 6:
              _context3.prev = 6;
              _t3 = _context3["catch"](0);
              message = "Error deleting access control file: ".concat(this.targetACLDoc, ": ").concat(_t3);
              src_debug/* error */.z3(message);
              return _context3.abrupt("return", Promise.reject(message));
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 6], [2, 4]]);
      }));
      function removeAcls() {
        return _removeAcls.apply(this, arguments);
      }
      return removeAcls;
    }()
  }, {
    key: "removeDefaults",
    value: function () {
      var _removeDefaults = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee4() {
        var fallbackCombo, _t4;
        return regenerator_default().wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              fallbackCombo = this.defaultsCombo;
              _context4.prev = 1;
              this.defaultsCombo = null;
              this.defaultsDiffer = false;
              _context4.next = 2;
              return this.save();
            case 2:
              _context4.next = 4;
              break;
            case 3:
              _context4.prev = 3;
              _t4 = _context4["catch"](1);
              this.defaultsCombo = fallbackCombo;
              this.defaultsDiffer = true;
              src_debug/* error */.z3(_t4);
              return _context4.abrupt("return", Promise.reject(_t4));
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[1, 3]]);
      }));
      function removeDefaults() {
        return _removeDefaults.apply(this, arguments);
      }
      return removeDefaults;
    }()
  }, {
    key: "save",
    value: function save() {
      var _this7 = this;
      // build graph
      var newAClGraph = (0,external_$rdf_.graph)();
      if (!this.isContainer) {
        makeACLGraphbyCombo(newAClGraph, this.targetDoc, this.mainCombo.byCombo, this.targetACLDoc, true);
      } else if (this.defaultsCombo && this.defaultsDiffer) {
        // Pair of controls
        makeACLGraphbyCombo(newAClGraph, this.targetDoc, this.mainCombo.byCombo, this.targetACLDoc, true);
        makeACLGraphbyCombo(newAClGraph, this.targetDoc, this.defaultsCombo.byCombo, this.targetACLDoc, false, true);
      } else {
        // Linked controls
        makeACLGraphbyCombo(newAClGraph, this.targetDoc, this.mainCombo.byCombo, this.targetACLDoc, true, true);
      }

      // add authenticated fetcher
      newAClGraph.fetcher = (0,external_$rdf_.fetcher)(newAClGraph, {
        fetch: this.store.fetcher._fetch
      });
      var updater = newAClGraph.updater || new external_$rdf_.UpdateManager(newAClGraph);

      // save ACL resource
      return new Promise(function (resolve, reject) {
        updater.put(_this7.targetACLDoc, newAClGraph.statementsMatching(undefined, undefined, undefined, _this7.targetACLDoc), 'text/turtle', function (uri, ok, message) {
          if (!ok) {
            return reject(new Error("ACL file save failed: ".concat(message)));
          }
          _this7.store.fetcher.unload(_this7.targetACLDoc);
          _this7.store.add(newAClGraph.statements);
          _this7.store.fetcher.requested[_this7.targetACLDoc.uri] = 'done'; // missing: save headers
          _this7.mainCombo.store = _this7.store;
          if (_this7.defaultsCombo) {
            _this7.defaultsCombo.store = _this7.store;
          }
          _this7.defaultsDiffer = !!_this7.defaultsCombo && !sameACL(_this7.mainCombo.aclMap, _this7.defaultsCombo.aclMap);
          src_debug/* log */.Rm('ACL modification: success!');
          resolve();
        });
      });
    }
  }]);
}();
;// ./src/acl/acl-control.ts


/**
 * Functions for rendering the ACL User Interface.
 * See https://github.com/solidos/userguide/blob/main/views/sharing/userguide.md#view
 * for a screenshot.
 * @packageDocumentation
 */







var global = window;
var preventBrowserDropEventsDone = Symbol('prevent double triggering of drop event');

/**
 * See https://coshx.com/preventing-drag-and-drop-disasters-with-a-chrome-userscript
 * Without this dropping anything onto a browser page will cause chrome etc to jump to diff page
 * throwing away all the user's work.
 *
 * In apps which may use drag and drop, this utility takes care of the fact
 * by default in a browser, an uncaught user drop into a browser window
 * causes the browser to lose all its work in that window and navigate to another page
 *
 * @param document  The DOM
 * @returns void
 */
function preventBrowserDropEvents(document) {
  (0,src_debug/* log */.Rm)('preventBrowserDropEvents called.');
  if (typeof global !== 'undefined') {
    if (global[preventBrowserDropEventsDone]) return;
    global[preventBrowserDropEventsDone] = true;
  }
  document.addEventListener('drop', handleDrop, false);
  document.addEventListener('dragenter', preventDrag, false);
  document.addEventListener('dragover', preventDrag, false);
}

/** @internal */
function preventDrag(e) {
  e.stopPropagation();
  e.preventDefault();
}

/** @internal */
function handleDrop(e) {
  if (e.dataTransfer.files.length > 0) {
    if (!global.confirm('Are you sure you want to drop this file here? (Cancel opens it in a new tab)')) {
      e.stopPropagation();
      e.preventDefault();
      (0,src_debug/* log */.Rm)('@@@@ document-level DROP suppressed: ' + e.dataTransfer.dropEffect);
    }
  }
}

/**
 * Get a folder's own filename in the directory tree. Also works for
 * domain names; the URL protocol ('https://') acts as the tree root
 * with short name '/' (see also test/unit/acl/acl-control.test.ts).
 *
 * ```typescript
 * shortNameForFolder($rdf.namedNode('http://example.com/some/folder/'))
 * // 'folder'
 *
 * shortNameForFolder($rdf.namedNode('http://example.com/some/folder'))
 * // 'folder'
 *
 * shortNameForFolder($rdf.namedNode('http://example.com/'))
 * // 'example.com'
 *
 * shortNameForFolder($rdf.namedNode('http://example.com'))
 * // 'example.com'
 *
 * shortNameForFolder($rdf.namedNode('http://'))
 * // '/'
 * ```
 *
 * It also works with relative URLs:
 * ```typescript
 * shortNameForFolder($rdf.namedNode('../folder/'))
 * // 'folder'
 * ```
 *
 * @param x  RDF Node for the folder URL
 * @returns  Short name for the folder
 */
function shortNameForFolder(x) {
  var str = x.uri;

  // Strip the trailing slash
  if (str.slice(-1) === '/') {
    str = str.slice(0, -1);
  }

  // Remove the path if present, keeping only the part
  // after the last slash.
  var slash = str.lastIndexOf('/');
  if (slash >= 0) {
    str = str.slice(slash + 1);
  }
  // Return the folder's filename, or '/' if nothing found
  // (but see https://github.com/solidos/solid-ui/issues/196
  // regarding whether this happens at the domain root or
  // not)
  return str || '/';
}

/**
 * A wrapper that retrieves ACL data and uses it
 * to render an [[AccessController]] component.
 * Presumably the '5' is a version number of some sort,
 * but all we know is it was already called ACLControlBox5
 * when it was introduced into solid-ui in
 * https://github.com/solidos/solid-ui/commit/948b874bd93e7bf5160e6e224821b888f07d15f3#diff-4192a29f38a0ababd563b36b47eba5bbR54
 */
function ACLControlBox5(subject, context, noun, kb) {
  var dom = context.dom;
  var doc = subject.doc(); // The ACL is actually to the doc describing the thing

  var container = dom.createElement('div');
  container.setAttribute('style', style.aclControlBoxContainer);
  var header = container.appendChild(dom.createElement('h1'));
  header.textContent = "Sharing for ".concat(noun, " ").concat(label_label(subject));
  header.setAttribute('style', style.aclControlBoxHeader);
  var status = container.appendChild(dom.createElement('div'));
  status.setAttribute('style', style.aclControlBoxStatus);
  try {
    loadController(doc, kb, subject, noun, context, dom, status).then(function (controller) {
      return container.appendChild(controller.render());
    });
  } catch (error) {
    status.innerText = error;
  }
  return container;
}
function loadController(_x, _x2, _x3, _x4, _x5, _x6, _x7) {
  return _loadController.apply(this, arguments);
}
function _loadController() {
  _loadController = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee2(doc, kb, subject, noun, context, dom, status) {
    return regenerator_default().wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          return _context2.abrupt("return", new Promise(function (resolve, reject) {
            return getACLorDefault(doc, /*#__PURE__*/function () {
              var _ref = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee(ok, isDirectACL, targetDoc, targetACLDoc, defaultHolder, defaultACLDoc) {
                var targetDirectory, targetIsProtected, prospectiveDefaultHolder, getController, _t;
                return regenerator_default().wrap(function (_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      getController = function _getController(prospectiveDefaultHolder) {
                        return new AccessController(subject, noun, context, status, targetIsProtected, targetDoc, targetACLDoc, defaultHolder, defaultACLDoc, prospectiveDefaultHolder, kb, dom);
                      };
                      if (ok) {
                        _context.next = 1;
                        break;
                      }
                      return _context.abrupt("return", reject(new Error("Error reading ".concat(isDirectACL ? '' : ' default ', "ACL. status ").concat(targetDoc, ": ").concat(targetACLDoc))));
                    case 1:
                      targetDirectory = getDirectory(targetDoc);
                      targetIsProtected = isStorage(targetDoc, targetACLDoc, kb) || hasProtectedAcl(targetDoc);
                      if (!(!targetIsProtected && targetDirectory)) {
                        _context.next = 5;
                        break;
                      }
                      _context.prev = 2;
                      _context.next = 3;
                      return getProspectiveHolder(targetDirectory);
                    case 3:
                      prospectiveDefaultHolder = _context.sent;
                      return _context.abrupt("return", resolve(getController(prospectiveDefaultHolder)));
                    case 4:
                      _context.prev = 4;
                      _t = _context["catch"](2);
                      // No need to show this error in status, but good to warn about it in console
                      (0,src_debug/* warn */.R8)(_t);
                    case 5:
                      return _context.abrupt("return", resolve(getController()));
                    case 6:
                    case "end":
                      return _context.stop();
                  }
                }, _callee, null, [[2, 4]]);
              }));
              return function (_x8, _x9, _x0, _x1, _x10, _x11) {
                return _ref.apply(this, arguments);
              };
            }());
          }));
        case 1:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _loadController.apply(this, arguments);
}
function getDirectory(doc) {
  var str = doc.uri.split('#')[0];
  var p = str.slice(0, -1).lastIndexOf('/');
  var q = str.indexOf('//');
  return q >= 0 && p < q + 2 || p < 0 ? null : str.slice(0, p + 1);
}
function isStorage(doc, aclDoc, store) {
  // @@ TODO: The methods used for targetIsStorage are HACKs - it should not be relied upon, and work is
  // @@ underway to standardize a behavior that does not rely upon this hack
  // @@ hopefully fixed as part of https://github.com/solidos/data-interoperability-panel/issues/10
  return store.holds(doc, src_ns.rdf('type'), src_ns.space('Storage'), aclDoc);
}
function hasProtectedAcl(targetDoc) {
  // @@ TODO: This is hacky way of knowing whether or not a certain ACL file can be removed
  // Hopefully we'll find a better, standardized solution to this - https://github.com/solidos/specification/issues/37
  return targetDoc.uri === targetDoc.site().uri;
}

/** @internal */
function setGlobalWindow(window) {
  global = window;
}
;// ./src/acl/index.ts
/**
 * Re-exports all the exports from the various files in the src/acl/ folder
 * @packageDocumentation
 */



var acl = {
  adoptACLDefault: adoptACLDefault,
  readACL: readACL,
  sameACL: sameACL,
  ACLunion: ACLunion,
  loadUnionACL: loadUnionACL,
  ACLbyCombination: ACLbyCombination,
  makeACLGraph: makeACLGraph,
  makeACLGraphbyCombo: makeACLGraphbyCombo,
  ACLToString: ACLToString,
  comboToString: comboToString,
  makeACLString: makeACLString,
  putACLObject: putACLObject,
  putACLbyCombo: putACLbyCombo,
  fixIndividualCardACL: fixIndividualCardACL,
  fixIndividualACL: fixIndividualACL,
  setACL: setACL,
  getACLorDefault: getACLorDefault,
  getACL: getACL
};
var aclControl = {
  preventBrowserDropEvents: preventBrowserDropEvents,
  shortNameForFolder: shortNameForFolder,
  ACLControlBox5: ACLControlBox5
};
;// ./src/create/create.ts
/*   create.js     UI to craete new objects in the solid-app-set world
 **
 */








var create_kb = external_SolidLogic_.solidLogicSingleton.store;

/*  newThingUI -- return UI for user to select a new object, folder, etc
 **
 ** context must include:  dom, div,
 **     optional:   folder: NamedNode -- the folder where the thing is bring put
 **                (suppresses asking for a full URI or workspace)
 **
 */
function newThingUI(createContext, dataBrowserContext, thePanes) {
  var dom = createContext.dom;
  var div = createContext.div;
  if (createContext.me && !createContext.me.uri) {
    throw new Error('newThingUI:  Invalid userid: ' + createContext.me);
  }
  var iconStyle = 'padding: 0.7em; width: 2em; height: 2em;'; // was: 'padding: 1em; width: 3em; height: 3em;'
  var star = div.appendChild(dom.createElement('img'));
  var visible = false; // the inividual tools tools
  //   noun_272948.svg = black star
  // noun_34653_green.svg = green plus
  star.setAttribute('src', iconBase/* icons */.Pt.iconBase + 'noun_34653_green.svg');
  star.setAttribute('style', iconStyle);
  star.setAttribute('title', 'Add another tool');
  var complain = function complain(message) {
    var pre = div.appendChild(dom.createElement('pre'));
    pre.setAttribute('style', 'background-color: pink');
    pre.appendChild(dom.createTextNode(message));
  };
  function styleTheIcons(style) {
    for (var i = 0; i < iconArray.length; i++) {
      var st = iconStyle + style;
      if (iconArray[i].disabled) {
        // @@ unused
        st += 'opacity: 0.3;';
      }
      iconArray[i].setAttribute('style', st); // eg 'background-color: #ccc;'
    }
  }
  function selectTool(icon) {
    styleTheIcons('display: none;'); // 'background-color: #ccc;'
    icon.setAttribute('style', iconStyle + 'background-color: yellow;');
  }
  function selectNewTool(_event) {
    visible = !visible;
    star.setAttribute('style', iconStyle + (visible ? 'background-color: yellow;' : ''));
    styleTheIcons(visible ? '' : 'display: none;');
  }
  star.addEventListener('click', selectNewTool);
  function makeNewAppInstance(options) {
    return new Promise(function (resolve, reject) {
      var selectUI; // , selectUIParent
      function callbackWS(ws, newBase) {
        ensureLoadedProfile(createContext).then(function (_context) {
          var newPaneOptions = Object.assign({
            newBase: newBase,
            folder: options.folder || undefined,
            workspace: ws
          }, options);
          for (var opt in options) {
            // get div, dom, me, folder, pane, refreshTable
            newPaneOptions[opt] = options[opt];
          }
          src_debug/* log */.Rm("newThingUI: Minting new ".concat(newPaneOptions.pane.name, " at ").concat(newPaneOptions.newBase));
          options.pane.mintNew(dataBrowserContext, newPaneOptions).then(function (newPaneOptions) {
            if (!newPaneOptions || !newPaneOptions.newInstance) {
              throw new Error('Cannot mint new - missing newInstance');
            }
            if (newPaneOptions.folder) {
              var tail = newPaneOptions.newInstance.uri.slice(newPaneOptions.folder.uri.length);
              var isPackage = tail.includes('/');
              src_debug/* log */.Rm('  new thing is packge? ' + isPackage);
              if (isPackage) {
                create_kb.add(newPaneOptions.folder, src_ns.ldp('contains'), create_kb.sym(newPaneOptions.newBase), newPaneOptions.folder.doc());
              } else {
                // single file
                create_kb.add(newPaneOptions.folder, src_ns.ldp('contains'), newPaneOptions.newInstance, newPaneOptions.folder.doc()); // Ping the patch system?
              }
              // @ts-ignore @@ TODO check whether refresh can exist here. Either fix type or remove unreachable code
              if (newPaneOptions.refreshTarget && newPaneOptions.refreshTarget.refresh) {
                // @@ TODO Remove the need to cast as any
                ;
                newPaneOptions.refreshTarget.refresh(); // Refresh the containing display
              }
              // selectUI.parentNode.removeChild(selectUI) It removes itself
            } else {
              var p = options.div.appendChild(dom.createElement('p'));
              p.setAttribute('style', 'font-size: 120%;');
              // Make link to new thing
              p.innerHTML = 'Your <a target=\'_blank\' href=\'' + newPaneOptions.newInstance.uri + '\'><b>new ' + options.noun + '</b></a> is ready to be set up. ' + '<br/><br/><a target=\'_blank\' href=\'' + newPaneOptions.newInstance.uri + '\'>Go to your new ' + options.noun + '.</a>';
              // selectUI.parentNode.removeChild(selectUI) // Clean up
              // selectUIParent.removeChild(selectUI) // Clean up
            }
            selectNewTool(); // toggle star to plain and menu vanish again
          })["catch"](function (err) {
            complain(err);
            reject(err);
          });
        }, function (err) {
          // login fails
          complain('Error logging on: ' + err);
        });
      } // callbackWS

      var pa = options.pane;
      // options.appPathSegment = pa.name // was 'edu.mit.solid.pane.'
      options.noun = pa.mintClass ? label_label(pa.mintClass) : pa.name;
      options.appPathSegment = options.noun.slice(0, 1).toUpperCase() + options.noun.slice(1);
      if (!options.folder) {
        // No folder given? Ask user for full URI
        selectUI = selectWorkspace(dom, {
          noun: options.noun,
          appPathSegment: options.appPathSegment
        }, callbackWS);
        options.div.appendChild(selectUI);
        // selectUIParent = options.div
      } else {
        var gotName = function gotName(name) {
          if (!name) {
            // selectUIParent.removeChild(selectUI)   itremves itself if cancelled
            selectNewTool(); // toggle star to plain and menu vanish again
          } else {
            var uri = options.folder.uri;
            if (!uri.endsWith('/')) {
              uri = uri + '/';
            }
            uri = uri + encodeURIComponent(name) + '/';
            callbackWS(null, uri);
          }
        };
        askName(dom, create_kb, options.div, src_ns.foaf('name'), null, options.noun).then(gotName);
        // selectUI = getNameForm(dom, kb, options.noun, gotName)
        // options.div.appendChild(selectUI)
        // selectUIParent = options.div
      }
    });
  } // makeNewAppInstance

  var iconArray = [];
  var mintingPanes = Object.values(thePanes).filter(function (pane) {
    return pane.mintNew;
  });
  var mintingClassMap = mintingPanes.reduce(function (classMap, pane) {
    if (pane.mintClass) {
      classMap[pane.mintClass.uri] = (classMap[pane.mintClass.uri] || 0) + 1;
    }
    return classMap;
  }, {});
  mintingPanes.forEach(function (pane) {
    // @@ TODO Remove the need to cast to any
    var icon = createContext.div.appendChild(dom.createElement('img'));
    icon.setAttribute('src', pane.icon);
    var noun = pane.mintClass ? mintingClassMap[pane.mintClass.uri] > 1 ? "".concat(label_label(pane.mintClass), " (using ").concat(pane.name, " pane)") : label_label(pane.mintClass) : pane.name + ' @@';
    icon.setAttribute('title', 'Make new ' + noun);
    icon.setAttribute('style', iconStyle + 'display: none;');
    iconArray.push(icon);
    if (!icon.disabled) {
      icon.addEventListener('click', function (e) {
        selectTool(icon);
        makeNewAppInstance({
          event: e,
          folder: createContext.folder || null,
          iconEle: icon,
          pane: pane,
          noun: noun,
          noIndexHTML: true,
          // do NOT @@ for now write a HTML file
          div: createContext.div,
          me: createContext.me,
          dom: createContext.dom,
          refreshTarget: createContext.refreshTarget
        });
      });
    }
  });
}

// Form to get the name of a new thing before we create it
//
// Used in contacts for new groups, individuals.
//
/*
function getNameForm (dom, kb, classLabel, gotNameCallback) {
  const form = dom.createElement('div') // form is broken as HTML behaviour can resurface on js error
  form.innerHTML = '<p>Name of new ' + classLabel + ':</p>'
  const namefield = dom.createElement('input')
  namefield.setAttribute('type', 'text')
  namefield.setAttribute('size', '30')
  namefield.setAttribute('style', style.textInputStyle)
  namefield.setAttribute('maxLength', '2048') // No arbitrary limits
  namefield.select() // focus next user input

  const gotName = function () {
    namefield.setAttribute('class', 'pendingedit')
    namefield.disabled = true
    continueButton.disabled = true
    cancel.disabled = true
    gotNameCallback(true, namefield.value)
  }

  namefield.addEventListener('keyup', function (e) {
    if (e.keyCode === 13) {
      gotName()
    }
  }, false)
  form.appendChild(namefield)

  form.appendChild(dom.createElement('br'))

  const cancel = form.appendChild(widgets.cancelButton(dom))
  cancel.addEventListener('click', function (e) {
    form.parentNode.removeChild(form)
    gotNameCallback(false)
  }, false)

  const continueButton = form.appendChild(widgets.continueButton(dom))
  continueButton.addEventListener('click', function (e) {
    gotName()
  }, false)

  return form
}
*/
;// ./src/create/index.ts

var create = {
  newThingUI: newThingUI
};
;// ./src/matrix/matrix.ts
//      Build a 2D matrix of values
//
//  dom      AKA document
//  query    a Query object of rdflib.js with a valid pattern
//  vx       A variable object, the one to be used for the X variable (horiz)
//  vy       A variable object, the one to be used for the Y variable (vertical)
//  vvalue       A variable object, the one to be used for the cell value
//  returns  A DOM element with the matrix in it, which has a .refresh() function.
//
// Options:
//     cellFunction(td, x, y, value)  fill the TD element of a single cell
//     xDecreasing  set true for x axis to be in decreasing order.
//     yDecreasing  set true for y axis to be in decreasing order.
//     set_x        array of X values to be define initial rows (order irrelevant)
//     set_y        array of Y values to be define initial columns
//
// Features:
//   Header row at top (x axis) and left (y-axis) generated automatically.
//   Extra rows and columns are inserted as needed to hold new data points
//   matrix.refresh() will re-run the query and adjust the display




var matrix_kb = external_SolidLogic_.solidLogicSingleton.store;
function matrixForQuery(dom, query, vx, vy, vvalue, options, whenDone) {
  // @@ TODO Remove need to cast to any
  var matrix = dom.createElement('table');
  var header = dom.createElement('tr');
  var corner = header.appendChild(dom.createElement('td'));
  corner.setAttribute('class', 'MatrixCorner');
  matrix.appendChild(header); // just one for now
  matrix.lastHeader = header; // Element before data
  var columns = []; // Vector
  var rows = []; // Associative array

  var setCell = function setCell(cell, x, y, value) {
    while (cell.firstChild) {
      // Empty any previous
      cell.removeChild(cell.firstChild);
    }
    cell.setAttribute('style', '');
    cell.style.textAlign = 'center';
    if (options.cellFunction) {
      options.cellFunction(cell, x, y, value);
    } else {
      cell.textContent = label_label(value);
      cell.setAttribute('style', 'padding: 0.3em');
    }
    delete cell.old;
  };
  var rowFor = function rowFor(y1) {
    var y = y1.toNT();
    if (rows[y]) return rows[y];
    // @@ TODO Remove need for casting to any
    var tr = dom.createElement('tr');
    var header = tr.appendChild(dom.createElement('td'));
    header.setAttribute('style', 'padding: 0.3em;');
    header.textContent = label_label(y1); // first approximation
    if (y1.termType === 'NamedNode') {
      matrix_kb.fetcher.nowOrWhenFetched(y1.uri.split('#')[0], undefined, function (ok, _body, _response) {
        if (ok) header.textContent = label_label(y1);
      });
    }
    for (var i = 0; i < columns.length; i++) {
      setCell(tr.appendChild(dom.createElement('td')), external_$rdf_.fromNT(columns[i]), y1, null);
    }
    tr.dataValueNT = y;
    rows[y] = tr;
    for (var ele = matrix.lastHeader.nextSibling; ele; ele = ele.nextSibling) {
      // skip header
      if (y > ele.dataValueNT && options && options.yDecreasing || y < ele.dataValueNT && !(options && options.yDecreasing)) {
        return matrix.insertBefore(tr, ele); // return the tr
      }
    }
    return matrix.appendChild(tr); // return the tr
  };
  var columnNumberFor = function columnNumberFor(x1) {
    var xNT = x1.toNT(); // xNT is a NT string
    var col = null;
    // These are data columns (not headings)
    for (var i = 0; i < columns.length; i++) {
      if (columns[i] === xNT) {
        return i;
      }
      if (xNT > columns[i] && options.xDecreasing || xNT < columns[i] && !options.xDecreasing) {
        columns = columns.slice(0, i).concat([xNT]).concat(columns.slice(i));
        col = i;
        break;
      }
    }
    if (col === null) {
      col = columns.length;
      columns.push(xNT);
    }

    // col is the number of the new column, starting from 0
    for (var row = matrix.firstChild; row; row = row.nextSibling) {
      // For every row header or not
      var y = row.dataValueNT;
      var td = dom.createElement('td'); // Add a new cell
      td.style.textAlign = 'center';
      if (row === matrix.firstChild) {
        td.textContent = label_label(x1);
      } else {
        setCell(td, x1, external_$rdf_.fromNT(y), null);
      }
      if (col === columns.length - 1) {
        row.appendChild(td);
      } else {
        var t = row.firstChild;
        for (var j = 0; j < col + 1; j++) {
          // Skip header col too
          t = t.nextSibling;
        }
        row.insertBefore(td, t);
      }
    }
    return col;
  };
  var markOldCells = function markOldCells() {
    for (var i = 1; i < matrix.children.length; i++) {
      var row = matrix.children[i];
      for (var j = 1; j < row.children.length; j++) {
        row.children[j].old = true;
      }
    }
  };
  var clearOldCells = function clearOldCells() {
    var row, cell;
    var colsUsed = [];
    var rowsUsed = [];
    if (options.set_y) {
      // Knows y values create rows
      for (var k = 0; k < options.set_y.length; k++) {
        rowsUsed[options.set_y[k]] = true;
      }
    }
    if (options.set_x) {
      for (var _k = 0; _k < options.set_x.length; _k++) {
        colsUsed[columnNumberFor(options.set_x[_k]) + 1] = true;
      }
    }
    for (var i = 1; i < matrix.children.length; i++) {
      row = matrix.children[i];
      for (var j = 1; j < row.children.length; j++) {
        cell = row.children[j];
        if (cell.old) {
          var y = external_$rdf_.fromNT(row.dataValueNT);
          var x = external_$rdf_.fromNT(columns[j - 1]);
          setCell(cell, x, y, null);
        } else {
          rowsUsed[row.dataValueNT] = true;
          colsUsed[j] = true;
        }
      }
    }
    for (var _i = 0; _i < matrix.children.length; _i++) {
      row = matrix.children[_i];
      if (_i > 0 && !rowsUsed[row.dataValueNT]) {
        delete rows[row.dataValueNT];
        matrix.removeChild(row);
      } else {
        for (var _j = row.children.length - 1; _j > 0; _j--) {
          // backwards
          var _cell = row.children[_j];
          if (!colsUsed[_j]) {
            row.removeChild(_cell);
          }
        }
      }
    }
    var newcolumns = [];
    for (var _j2 = 0; _j2 < columns.length; _j2++) {
      if (colsUsed[_j2 + 1]) {
        newcolumns.push(columns[_j2]);
      }
    }
    columns = newcolumns;
  };
  matrix.refresh = function () {
    markOldCells();
    matrix_kb.query(query, addCellFromBindings, undefined, clearOldCells);
  };
  var addCellFromBindings = function addCellFromBindings(bindings) {
    var x = bindings[vx.toString()];
    var y = bindings[vy.toString()];
    var value = bindings[vvalue.toString()];
    var row = rowFor(y);
    var colNo = columnNumberFor(x);
    var cell = row.children[colNo + 1]; // number of Y axis headings
    setCell(cell, x, y, value);
  };
  if (options.set_y) {
    // Knows y values create rows
    for (var k = 0; k < options.set_y.length; k++) {
      rowFor(options.set_y[k]);
    }
  }
  if (options.set_x) {
    for (var _k2 = 0; _k2 < options.set_x.length; _k2++) {
      columnNumberFor(options.set_x[_k2]);
    }
  }
  matrix_kb.query(query, addCellFromBindings, undefined, whenDone); // Populate the matrix
  return matrix;
}
;// ./src/matrix/index.ts

var matrix = {
  matrixForQuery: matrixForQuery
};
;// ./src/media/media-capture.ts


//
//   Media input widget
//
//
// Workflow:
// The HTML5 functionality (on mobile) is to prompt for either
// a realtime camera capture, OR a selection from images already on the device
// (eg camera roll).
//
// The solid alternative is to either take a photo
// or access camera roll (etc) OR to access solid cloud storage of favorite photo albums.
// (Especially latest taken ones)
//


/** @module mediaCapture */




var cameraIcon = iconBase/* icons */.Pt.iconBase + 'noun_Camera_1618446_000000.svg'; // Get it from github
var retakeIcon = iconBase/* icons */.Pt.iconBase + 'noun_479395.svg'; // Get it from github

var contentType = 'image/png';

/** A control to capture a picture using camera
 * @param {Docuemnt} dom - The Document object
 * @param {IndexedForumla} store - The quadstore to store data in
 * @param {NamedNode} getImageDoc() - NN of the image file to be created
 * @param {function} doneCallback - Called when a picture has been taken
 */
function cameraCaptureControl(dom, store, getImageDoc, doneCallback) {
  var div = dom.createElement('div');
  var destination, imageBlob, player, canvas;
  var table = div.appendChild(dom.createElement('table'));
  var mainTR = table.appendChild(dom.createElement('tr'));
  var main = mainTR.appendChild(dom.createElement('td'));
  main.setAttribute('colspan', '4');
  var buttons = table.appendChild(dom.createElement('tr'));
  buttons.appendChild(dom.createElement('td')) // Cancel button
  .appendChild(buttons_cancelButton(dom)).addEventListener('click', function (_event) {
    stopVideo();
    doneCallback(null);
  });
  var retakeButton = buttons.appendChild(dom.createElement('td')) // Retake button
  .appendChild(buttons_button(dom, retakeIcon, 'Retake'));
  retakeButton.addEventListener('click', function (_event) {
    retake();
  });
  retakeButton.style.visibility = 'collapse'; // Hide for now

  var shutterButton = buttons.appendChild(dom.createElement('td')) // Trigger capture button
  .appendChild(buttons_button(dom, iconBase/* icons */.Pt.iconBase + 'noun_10636.svg', 'Snap'));
  shutterButton.addEventListener('click', grabCanvas);
  shutterButton.style.visibility = 'collapse'; // Hide for now

  var sendButton = buttons.appendChild(dom.createElement('td')) // Confirm and save button
  .appendChild(continueButton(dom)); // @@ or send icon??
  sendButton.addEventListener('click', function (_event) {
    saveBlob(imageBlob, destination);
  });
  sendButton.style.visibility = 'collapse'; // Hide for now

  function displayPlayer() {
    player = main.appendChild(dom.createElement('video'));
    player.setAttribute('controls', '1');
    player.setAttribute('autoplay', '1');
    player.setAttribute('style', style.controlStyle);
    if (!navigator.mediaDevices) {
      throw new Error('navigator.mediaDevices not available');
    }
    navigator.mediaDevices.getUserMedia(constraints).then(function (stream) {
      player.srcObject = stream;
      shutterButton.style.visibility = 'visible'; // Enable
      sendButton.style.visibility = 'collapse';
      retakeButton.style.visibility = 'collapse';
    });
  }
  var constraints = {
    video: true
  };
  function retake() {
    main.removeChild(canvas);
    displayPlayer(); // Make new one as old one is stuck black
  }
  function grabCanvas() {
    // Draw the video frame to the canvas.
    canvas = dom.createElement('canvas');
    canvas.setAttribute('width', style.canvasWidth);
    canvas.setAttribute('height', style.canvasHeight);
    canvas.setAttribute('style', style.controlStyle);
    main.appendChild(canvas);
    var context = canvas.getContext('2d');
    context.drawImage(player, 0, 0, canvas.width, canvas.height);
    player.parentNode.removeChild(player);
    canvas.toBlob(function (blob) {
      var msg = "got blob type ".concat(blob.type, " size ").concat(blob.size);
      src_debug/* log */.Rm(msg);
      destination = getImageDoc();
      imageBlob = blob; // save for review
      reviewImage();
      // alert(msg)
    }, contentType); // toBlob
  }
  function reviewImage() {
    sendButton.style.visibility = 'visible';
    retakeButton.style.visibility = 'visible';
    shutterButton.style.visibility = 'collapse'; // Hide for now
  }
  function stopVideo() {
    if (player && player.srcObject) {
      player.srcObject.getVideoTracks().forEach(function (track) {
        return track.stop();
      });
    }
  }
  function saveBlob(blob, destination) {
    var contentType = blob.type;
    // if (!confirm('Save picture to ' + destination + ' ?')) return
    src_debug/* log */.Rm('Putting ' + blob.size + ' bytes of ' + contentType + ' to ' + destination)
    // @@ TODO Remove casting
    ;
    store.fetcher.webOperation('PUT', destination.uri, {
      data: blob,
      contentType: contentType
    }).then(function (_resp) {
      src_debug/* log */.Rm('ok saved ' + destination);
      stopVideo();
      doneCallback(destination);
    }, function (err) {
      stopVideo();
      alert(err);
    });
  }

  // Attach the video stream to the video element and autoplay.
  displayPlayer();
  return div;
}

/** A button to capture a picture using camera
 * @param {Docuemnt} dom - The Document object
 * @param {IndexedForumla} store - The quadstore to store data in
 * @param {fuunction} getImageDoc - returns NN of the image file to be created
 * @param {function<Node>} doneCallback - called with the image taken
 * @returns {DomElement} - A div element with the button in it
 *
 * This expands the button to a large control when it is pressed
 */

function cameraButton(dom, store, getImageDoc, doneCallback) {
  var div = dom.createElement('div');
  var but = buttons_button(dom, cameraIcon, 'Take picture');
  var control;
  function restoreButton(_x) {
    return _restoreButton.apply(this, arguments);
  }
  function _restoreButton() {
    _restoreButton = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee(imageDoc) {
      return regenerator_default().wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            div.removeChild(control);
            div.appendChild(but);
            doneCallback(imageDoc);
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _restoreButton.apply(this, arguments);
  }
  div.appendChild(but);
  but.addEventListener('click', function (_event) {
    div.removeChild(but);
    control = cameraCaptureControl(dom, store, getImageDoc, restoreButton);
    div.appendChild(control);
  });
  return div;
}
;// ./src/media/index.ts

var media = {
  cameraCaptureControl: cameraCaptureControl,
  cameraButton: cameraButton
};
;// ./node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}

// EXTERNAL MODULE: ./node_modules/escape-html/index.js
var escape_html = __webpack_require__(580);
var escape_html_default = /*#__PURE__*/__webpack_require__.n(escape_html);
;// ./node_modules/uuid/dist/native.js
const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
/* harmony default export */ const dist_native = ({ randomUUID });

;// ./node_modules/uuid/dist/rng.js
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
    if (!getRandomValues) {
        if (typeof crypto === 'undefined' || !crypto.getRandomValues) {
            throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
        }
        getRandomValues = crypto.getRandomValues.bind(crypto);
    }
    return getRandomValues(rnds8);
}

;// ./node_modules/uuid/dist/stringify.js

const byteToHex = [];
for (let i = 0; i < 256; ++i) {
    byteToHex.push((i + 0x100).toString(16).slice(1));
}
function unsafeStringify(arr, offset = 0) {
    return (byteToHex[arr[offset + 0]] +
        byteToHex[arr[offset + 1]] +
        byteToHex[arr[offset + 2]] +
        byteToHex[arr[offset + 3]] +
        '-' +
        byteToHex[arr[offset + 4]] +
        byteToHex[arr[offset + 5]] +
        '-' +
        byteToHex[arr[offset + 6]] +
        byteToHex[arr[offset + 7]] +
        '-' +
        byteToHex[arr[offset + 8]] +
        byteToHex[arr[offset + 9]] +
        '-' +
        byteToHex[arr[offset + 10]] +
        byteToHex[arr[offset + 11]] +
        byteToHex[arr[offset + 12]] +
        byteToHex[arr[offset + 13]] +
        byteToHex[arr[offset + 14]] +
        byteToHex[arr[offset + 15]]).toLowerCase();
}
function stringify(arr, offset = 0) {
    const uuid = unsafeStringify(arr, offset);
    if (!validate(uuid)) {
        throw TypeError('Stringified UUID is invalid');
    }
    return uuid;
}
/* harmony default export */ const dist_stringify = ((/* unused pure expression or super */ null && (stringify)));

;// ./node_modules/uuid/dist/v4.js



function _v4(options, buf, offset) {
    options = options || {};
    const rnds = options.random ?? options.rng?.() ?? rng();
    if (rnds.length < 16) {
        throw new Error('Random bytes length must be >= 16');
    }
    rnds[6] = (rnds[6] & 0x0f) | 0x40;
    rnds[8] = (rnds[8] & 0x3f) | 0x80;
    if (buf) {
        offset = offset || 0;
        if (offset < 0 || offset + 16 > buf.length) {
            throw new RangeError(`UUID byte range ${offset}:${offset + 15} is out of buffer bounds`);
        }
        for (let i = 0; i < 16; ++i) {
            buf[offset + i] = rnds[i];
        }
        return buf;
    }
    return unsafeStringify(rnds);
}
function v4(options, buf, offset) {
    if (dist_native.randomUUID && !buf && !options) {
        return dist_native.randomUUID();
    }
    return _v4(options, buf, offset);
}
/* harmony default export */ const dist_v4 = (v4);

;// ./src/widgets/peoplePicker.js



var _templateObject;
/**
 *
 * People Picker Pane
 *
 * This pane offers a mechanism for selecting a set of individuals, groups, or
 * organizations to take some action on.
 *
 * Assumptions
 *   - Assumes that the user has a type index entry for vcard:AddressBook. @@ bad assuption
 *
 */









var peoplePicker_kb = external_SolidLogic_.solidLogicSingleton.store;
var PeoplePicker = /*#__PURE__*/function () {
  function PeoplePicker(element, typeIndex, groupPickedCb, options) {
    classCallCheck_classCallCheck(this, PeoplePicker);
    // @@ can't expect typeindex to be passed
    this.options = options || {};
    this.element = element;
    this.typeIndex = typeIndex;
    this.groupPickedCb = groupPickedCb;
    this.selectedgroup = this.options.selectedgroup; // current selected group if any
    this.onSelectGroup = this.onSelectGroup.bind(this);
  }
  return createClass_createClass(PeoplePicker, [{
    key: "render",
    value: function render() {
      var _this = this;
      var container = document.createElement('div');
      container.style.maxWidth = '350px';
      container.style.minHeight = '200px';
      container.style.outline = '1px solid black';
      container.style.display = 'flex';
      if (this.selectedgroup) {
        container.style.flexDirection = 'column';
        var selectedGroup = document.createElement('div');
        new Group(selectedGroup, this.selectedgroup).render();
        var changeGroupButton = document.createElement('button');
        changeGroupButton.textContent = escape_html_default()('Change group');
        changeGroupButton.addEventListener('click', function (_event) {
          _this.selectedgroup = null;
          _this.render();
        });
        container.appendChild(selectedGroup);
        container.appendChild(changeGroupButton);
      } else {
        this.findAddressBook(this.typeIndex).then(function (_ref) {
          var book = _ref.book;
          var chooseExistingGroupButton = document.createElement('button');
          chooseExistingGroupButton.textContent = escape_html_default()('Pick an existing group');
          chooseExistingGroupButton.style.margin = 'auto';
          chooseExistingGroupButton.addEventListener('click', function (_event) {
            new GroupPicker(container, book, _this.onSelectGroup).render();
          });
          var createNewGroupButton = document.createElement('button');
          createNewGroupButton.textContent = escape_html_default()('Create a new group');
          createNewGroupButton.style.margin = 'auto';
          createNewGroupButton.addEventListener('click', function (_event) {
            _this.createNewGroup(book, _this.options.defaultNewGroupName).then(function (_ref2) {
              var group = _ref2.group;
              new GroupBuilder(_this.element, book, group, _this.onSelectGroup).render();
            })["catch"](function (errorBody) {
              _this.element.appendChild(errorMessageBlock(document, escape_html_default()("Error creating a new group. (".concat(errorBody, ")"))));
            });
          });
          container.appendChild(chooseExistingGroupButton);
          container.appendChild(createNewGroupButton);
          _this.element.innerHTML = '';
          _this.element.appendChild(container);
        })["catch"](function (err) {
          _this.element.appendChild(errorMessageBlock(document, escape_html_default()("Could find your groups. (".concat(err, ")"))));
        });
      }
      this.element.innerHTML = '';
      this.element.appendChild(container);
      return this;
    }
  }, {
    key: "findAddressBook",
    value: function findAddressBook(typeIndex) {
      return new Promise(function (resolve, reject) {
        peoplePicker_kb.fetcher.nowOrWhenFetched(typeIndex, function (ok, err) {
          if (!ok) {
            return reject(err);
          }
          var bookRegistration = peoplePicker_kb.any(null, src_ns.solid('forClass'), src_ns.vcard('AddressBook'));
          if (!bookRegistration) {
            return reject(new Error('no address book registered in the solid type index ' + typeIndex));
          }
          var book = peoplePicker_kb.any(bookRegistration, src_ns.solid('instance'));
          if (!book) {
            return reject(new Error('incomplete address book registration'));
          }
          peoplePicker_kb.fetcher.load(book).then(function (_xhr) {
            return resolve({
              book: book
            });
          })["catch"](function (errr) {
            return reject(new Error('Could not load address book ' + errr));
          });
        });
      });
    }
  }, {
    key: "createNewGroup",
    value: function createNewGroup(book, defaultNewGroupName) {
      var _indexes = indexes(book),
        groupIndex = _indexes.groupIndex,
        groupContainer = _indexes.groupContainer;
      var group = external_$rdf_.sym("".concat(groupContainer.uri).concat(dist_v4().slice(0, 8), ".ttl#this"));
      var name = defaultNewGroupName || 'Untitled Group';

      // NOTE that order matters here.  Unfortunately this type of update is
      // non-atomic in that solid requires us to send two PATCHes, either of which
      // might fail.
      var patchPromises = [group.doc(), groupIndex].map(function (doc) {
        var typeStatement = external_$rdf_.st(group, src_ns.rdf('type'), src_ns.vcard('Group'), doc);
        var nameStatement = external_$rdf_.st(group, src_ns.vcard('fn'), name, group.doc(), doc);
        var includesGroupStatement = external_$rdf_.st(book, src_ns.vcard('includesGroup'), group, doc);
        var toIns = doc.equals(groupIndex) ? [typeStatement, nameStatement, includesGroupStatement] : [typeStatement, nameStatement];
        return patch(doc.uri, {
          toIns: toIns
        }).then(function () {
          toIns.forEach(function (st) {
            peoplePicker_kb.add(st);
          });
        });
      });
      return Promise.all(patchPromises).then(function () {
        return {
          group: group
        };
      })["catch"](function (err) {
        src_debug/* log */.Rm('Could not create new group.  PATCH failed ' + err);
        throw new Error("Couldn't create new group.  PATCH failed for (".concat(err.xhr ? err.xhr.responseURL : '', " )"));
      });
    }
  }, {
    key: "onSelectGroup",
    value: function onSelectGroup(group) {
      this.selectedgroup = group;
      this.groupPickedCb(group);
      this.render();
    }
  }]);
}();
var GroupPicker = /*#__PURE__*/function () {
  function GroupPicker(element, book, onSelectGroup) {
    classCallCheck_classCallCheck(this, GroupPicker);
    this.element = element;
    this.book = book;
    this.onSelectGroup = onSelectGroup;
  }
  return createClass_createClass(GroupPicker, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      this.loadGroups().then(function (groups) {
        // render the groups
        var container = document.createElement('div');
        container.style.display = 'flex';
        container.style.flexDirection = 'column';
        groups.forEach(function (group) {
          var groupButton = document.createElement('button');
          groupButton.addEventListener('click', _this2.handleClickGroup(group));
          new Group(groupButton, group).render();
          container.appendChild(groupButton);
        });
        _this2.element.innerHTML = '';
        _this2.element.appendChild(container);
      })["catch"](function (err) {
        _this2.element.appendChild(errorMessageBlock(document, escape_html_default()("There was an error loading your groups. (".concat(err, ")"))));
      });
      return this;
    }
  }, {
    key: "loadGroups",
    value: function loadGroups() {
      var _this3 = this;
      return new Promise(function (resolve, reject) {
        var _indexes2 = indexes(_this3.book),
          groupIndex = _indexes2.groupIndex;
        peoplePicker_kb.fetcher.nowOrWhenFetched(groupIndex, function (ok, err) {
          if (!ok) {
            return reject(err);
          }
          var groups = peoplePicker_kb.each(_this3.book, src_ns.vcard('includesGroup'));
          return resolve(groups);
        });
      });
    }
  }, {
    key: "handleClickGroup",
    value: function handleClickGroup(group) {
      var _this4 = this;
      return function (_event) {
        _this4.onSelectGroup(group);
      };
    }
  }]);
}();
var Group = /*#__PURE__*/function () {
  function Group(element, group) {
    classCallCheck_classCallCheck(this, Group);
    this.element = element;
    this.group = group;
  }
  return createClass_createClass(Group, [{
    key: "render",
    value: function render() {
      var container = document.createElement('div');
      container.textContent = escape_html_default()(
      // @@@@@ need to escape??
      getWithDefault(this.group, src_ns.vcard('fn'), "[".concat(this.group.value, "]")));
      this.element.innerHTML = '';
      this.element.appendChild(container);
      return this;
    }
  }]);
}();
var GroupBuilder = /*#__PURE__*/function () {
  function GroupBuilder(element, book, group, doneBuildingCb, groupChangedCb) {
    classCallCheck_classCallCheck(this, GroupBuilder);
    this.element = element;
    this.book = book;
    this.group = group;
    this.onGroupChanged = function (err, changeType, agent) {
      if (groupChangedCb) {
        groupChangedCb(err, changeType, agent);
      }
    };
    this.groupChangedCb = groupChangedCb;
    this.doneBuildingCb = doneBuildingCb;
  }
  return createClass_createClass(GroupBuilder, [{
    key: "refresh",
    value: function refresh() {
      // TODO: implement
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;
      var dropContainer = document.createElement('div');
      dropContainer.style.maxWidth = '350px';
      dropContainer.style.minHeight = '200px';
      dropContainer.style.outline = '1px solid black';
      dropContainer.style.display = 'flex';
      dropContainer.style.flexDirection = 'column';
      makeDropTarget(dropContainer, function (uris) {
        uris.forEach(function (uri) {
          _this5.add(uri)["catch"](function (err) {
            _this5.element.appendChild(errorMessageBlock(document, escape_html_default()("Could not add the given WebId. (".concat(err, ")"))));
          });
        });
      });
      var groupNameInput = document.createElement('input');
      groupNameInput.type = 'text';
      groupNameInput.value = getWithDefault(this.group, src_ns.vcard('fn'), 'Untitled Group');
      groupNameInput.addEventListener('change', function (event) {
        _this5.setGroupName(event.target.value)["catch"](function (err) {
          _this5.element.appendChild(errorMessageBlock(document, "Error changing group name. (".concat(err, ")")));
        });
      });
      var groupNameLabel = document.createElement('label');
      groupNameLabel.textContent = escape_html_default()('Group Name:');
      groupNameLabel.appendChild(groupNameInput);
      dropContainer.appendChild(groupNameLabel);
      if (peoplePicker_kb.any(this.group, src_ns.vcard('hasMember'))) {
        peoplePicker_kb.match(this.group, src_ns.vcard('hasMember')).forEach(function (statement) {
          var webIdNode = statement.object;
          var personDiv = document.createElement('div');
          new Person(personDiv, webIdNode, _this5.handleRemove(webIdNode)).render();
          dropContainer.appendChild(personDiv);
        });
      } else {
        var copy = document.createElement('p');
        copy.textContent = escape_html_default()(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        To add someone to this group, drag and drop their WebID URL onto the box.\n      "])));
        dropContainer.appendChild(copy);
      }
      var doneBuildingButton = document.createElement('button');
      doneBuildingButton.textContent = escape_html_default()('Done');
      doneBuildingButton.addEventListener('click', function (_event) {
        _this5.doneBuildingCb(_this5.group);
      });
      dropContainer.appendChild(doneBuildingButton);
      this.element.innerHTML = '';
      this.element.appendChild(dropContainer);
      return this;
    }
  }, {
    key: "add",
    value: function add(webId) {
      var _this6 = this;
      return new Promise(function (resolve, reject) {
        peoplePicker_kb.fetcher.nowOrWhenFetched(webId, function (ok, err) {
          if (!ok) {
            _this6.onGroupChanged(err);
            return reject(err);
          }
          // make sure it's a valid person, group, or entity (for now just handle
          // webId)
          var webIdNode = external_$rdf_.namedNode(webId);
          var rdfClass = peoplePicker_kb.any(webIdNode, src_ns.rdf('type'));
          if (!rdfClass || !rdfClass.equals(src_ns.foaf('Person'))) {
            return reject(new Error("Only people supported right now. (tried to add something of type ".concat(rdfClass.value, ")")));
          }
          return resolve(webIdNode);
        });
      }).then(function (webIdNode) {
        var statement = external_$rdf_.st(_this6.group, src_ns.vcard('hasMember'), webIdNode);
        if (peoplePicker_kb.holdsStatement(statement)) {
          return webIdNode;
        }
        return patch(_this6.group.doc().uri, {
          toIns: [statement]
        }).then(function () {
          statement.why = _this6.group.doc();
          peoplePicker_kb.add(statement);
          _this6.onGroupChanged(null, 'added', webIdNode);
          _this6.render();
        });
      });
    }
  }, {
    key: "handleRemove",
    value: function handleRemove(webIdNode) {
      var _this7 = this;
      return function (_event) {
        var statement = external_$rdf_.st(_this7.group, src_ns.vcard('hasMember'), webIdNode);
        return patch(_this7.group.doc().uri, {
          toDel: [statement]
        }).then(function () {
          peoplePicker_kb.remove(statement);
          _this7.onGroupChanged(null, 'removed', webIdNode);
          _this7.render();
          return true;
        })["catch"](function (err) {
          var name = peoplePicker_kb.any(webIdNode, src_ns.foaf('name'));
          var errorMessage = name && name.value ? "Could not remove ".concat(name.value, ". (").concat(err, ")") : "Could not remove ".concat(webIdNode.value, ". (").concat(err, ")");
          throw new Error(errorMessage);
        });
      };
    }
  }, {
    key: "setGroupName",
    value: function setGroupName(name) {
      var _this8 = this;
      var _indexes3 = indexes(this.book),
        groupIndex = _indexes3.groupIndex;
      var updatePromises = [this.group.doc(), groupIndex].map(function (namedGraph) {
        var oldNameStatements = peoplePicker_kb.match(_this8.group, src_ns.vcard('fn'), null, namedGraph);
        var newNameStatement = external_$rdf_.st(_this8.group, src_ns.vcard('fn'), external_$rdf_.literal(name));
        return patch(namedGraph.value, {
          toDel: oldNameStatements,
          toIns: [newNameStatement]
        }).then(function (_solidResponse) {
          peoplePicker_kb.removeStatements(oldNameStatements);
          newNameStatement.why = namedGraph;
          peoplePicker_kb.add(newNameStatement);
        });
      });
      return Promise.all(updatePromises);
    }
  }]);
}();
// @ignore exporting this only for the unit test
// @@ TODO maybe I should move this down at end, but for
// now I will leave it where it was
var Person = /*#__PURE__*/function () {
  function Person(element, webIdNode, handleRemove) {
    classCallCheck_classCallCheck(this, Person);
    this.webIdNode = webIdNode;
    this.element = element;
    this.handleRemove = handleRemove;
  }
  return createClass_createClass(Person, [{
    key: "render",
    value: function render() {
      var _this9 = this;
      var container = document.createElement('div');
      container.style.display = 'flex';

      // TODO: take a look at UI.widgets.setName
      var imgSrc = getWithDefault(this.webIdNode, src_ns.foaf('img'), iconBase/* iconBase */.LN + 'noun_15059.svg');
      var profileImg = document.createElement('img');
      profileImg.src = escape_html_default()(imgSrc);
      profileImg.width = '50';
      profileImg.height = '50';
      profileImg.style.margin = '5px';

      // TODO: take a look at UI.widgets.setImage
      var name = getWithDefault(this.webIdNode, src_ns.foaf('name'), "[".concat(this.webIdNode, "]"));
      var nameSpan = document.createElement('span');
      nameSpan.innerHTML = escape_html_default()(name);
      nameSpan.style.flexGrow = '1';
      nameSpan.style.margin = 'auto 0';
      var removeButton = document.createElement('button');
      removeButton.textContent = 'Remove';
      removeButton.addEventListener('click', function (_event) {
        return _this9.handleRemove()["catch"](function (err) {
          _this9.element.appendChild(errorMessageBlock(document, escape_html_default()("".concat(err))));
        });
      });
      removeButton.style.margin = '5px';
      container.appendChild(profileImg);
      container.appendChild(nameSpan);
      container.appendChild(removeButton);
      this.element.innerHTML = '';
      this.element.appendChild(container);
      return this;
    }
  }]);
}();
function getWithDefault(subject, predicate, defaultValue) {
  var object = peoplePicker_kb.any(subject, predicate);
  return object ? object.value : defaultValue;
}
function patch(url, _ref3) {
  var toDel = _ref3.toDel,
    toIns = _ref3.toIns;
  return new Promise(function (resolve, reject) {
    peoplePicker_kb.updater.update(toDel, toIns, function (uri, success, errorMessage) {
      if (!success) {
        return reject(new Error("PATCH failed for resource <".concat(uri, ">: ").concat(errorMessage)));
      }
      resolve();
    });
  });
  // return webClient.patch(url, toDel, toIns)
  //   .then(solidResponse => {
  //     const status = solidResponse.xhr.status
  //     if (status < 200 || status >= 400) {
  //       const err = new Error(`PATCH failed for resource <${solidResponse.url}>`)
  //       err.solidResponse = solidResponse
  //       throw err
  //     }
  //   })
}
function indexes(book) {
  return {
    // bookIndex: book,
    groupIndex: peoplePicker_kb.any(book, src_ns.vcard('groupIndex')),
    groupContainer: peoplePicker_kb.sym(book.dir().uri + 'Group/')
  };
}
;// ./src/widgets/index.js
/**
 * General purpose utility functions used in the panes
 * oshani@csail.mit.edu
 *
 * Includes form-oriented widgets  timbl@w3.org
 *
 * sign-in sign-up widgets are in signin.js
 *
 *  Note... For pointers to posssible text-editing code, see
 *  http://stackoverflow.com/questions/6756407/what-contenteditable-editors
 */

// Each widget should ideally live in its own file.  In order to break up this
// monolithic widget index over time, we should add new widgets to the
// 'lib/widgets/' directory, and re-export them by merging the module namespaces:
//
// (In order to avoid name collisions, it is safely assumed that modules don't
// export widgets with the same name)











/*
import * as peoplePicker from './peoplePicker'
import * as dragAndDrop from './dragAndDrop'
import * as buttons from './buttons'
import * as error from './error'
import { forms } from './forms'

const widgets = Object.assign(
  {},
  buttons,
  peoplePicker,
  dragAndDrop,
  error,
  forms
)

// export default widgets .. Policy is not to use exports default
module.export = widgets // @@ Apparently no way to do this (yet?) in esm
console.log('widgets exported:', widgets)
*/
// ends
;// ./src/messageArea.js
//  Common code for a discussion are a of messages about something
//





 // pull in first avoid cross-refs



var messageArea_UI = {
  icons: iconBase/* icons */.Pt,
  ns: src_ns,
  rdf: external_$rdf_,
  style: style,
  widgets: widgets_namespaceObject
};
function messageArea(dom, kb, subject, messageStore, options) {
  kb = kb || external_SolidLogic_.solidLogicSingleton.store;
  messageStore = messageStore.doc(); // No hash
  var ns = messageArea_UI.ns;
  var WF = external_$rdf_.Namespace('http://www.w3.org/2005/01/wf/flow#');
  var DCT = external_$rdf_.Namespace('http://purl.org/dc/terms/');
  options = options || {};
  var newestFirst = !!options.newestFirst;
  var messageBodyStyle = 'white-space: pre-wrap; width: 90%; font-size:100%; border: 0.07em solid #eee; padding: .2em 0.5em; margin: 0.1em 1em 0.1em 1em;';
  // 'font-size: 100%; margin: 0.1em 1em 0.1em 1em;  background-color: white; white-space: pre-wrap; padding: 0.1em;'

  var div = dom.createElement('div');
  // eslint-disable-next-line prefer-const
  var messageTable; // Shared by initial build and addMessageFromBindings

  var me;
  var updater = external_SolidLogic_.solidLogicSingleton.store.updater;
  var anchor = function anchor(text, term) {
    // If there is no link return an element anyway
    var a = dom.createElement('a');
    if (term && term.uri) {
      a.setAttribute('href', term.uri);
      a.addEventListener('click', messageArea_UI.widgets.openHrefInOutlineMode, true);
      a.setAttribute('style', 'color: #3B5998; text-decoration: none; '); // font-weight: bold
    }
    a.textContent = text;
    return a;
  };
  var mention = function mention(message, style) {
    var pre = dom.createElement('pre');
    pre.setAttribute('style', style || 'color: grey');
    div.appendChild(pre);
    pre.appendChild(dom.createTextNode(message));
    return pre;
  };
  var announce = {
    log: function log(message) {
      mention(message, 'color: #111;');
    },
    warn: function warn(message) {
      mention(message, 'color: #880;');
    },
    error: function error(message) {
      mention(message, 'color: #800;');
    }
  };

  //       Form for a new message
  //
  var newMessageForm = function newMessageForm() {
    var form = dom.createElement('tr');
    var lhs = dom.createElement('td');
    var middle = dom.createElement('td');
    var rhs = dom.createElement('td');
    form.appendChild(lhs);
    form.appendChild(middle);
    form.appendChild(rhs);
    form.AJAR_date = '9999-01-01T00:00:00Z'; // ISO format for field sort

    var sendMessage = function sendMessage() {
      // titlefield.setAttribute('class','pendingedit')
      // titlefield.disabled = true
      field.setAttribute('class', 'pendingedit');
      field.disabled = true;
      var sts = [];
      var now = new Date();
      var timestamp = '' + now.getTime();
      var dateStamp = external_$rdf_.term(now);
      // http://www.w3schools.com/jsref/jsref_obj_date.asp
      var message = kb.sym(messageStore.uri + '#' + 'Msg' + timestamp);
      sts.push(new external_$rdf_.Statement(subject, ns.wf('message'), message, messageStore));
      sts.push(new external_$rdf_.Statement(message, ns.sioc('content'), kb.literal(field.value), messageStore));
      sts.push(new external_$rdf_.Statement(message, DCT('created'), dateStamp, messageStore));
      if (me) {
        sts.push(new external_$rdf_.Statement(message, ns.foaf('maker'), me, messageStore));
      }
      var sendComplete = function sendComplete(uri, success, body) {
        if (!success) {
          form.appendChild(messageArea_UI.widgets.errorMessageBlock(dom, 'Error writing message: ' + body));
        } else {
          var bindings = {
            '?msg': message,
            '?content': kb.literal(field.value),
            '?date': dateStamp,
            '?creator': me
          };
          renderMessage(bindings, false); // not green

          field.value = ''; // clear from out for reuse
          field.setAttribute('class', '');
          field.disabled = false;
        }
      };
      updater.update([], sts, sendComplete);
    };
    form.appendChild(dom.createElement('br'));
    var field, sendButton;
    var turnOnInput = function turnOnInput() {
      creatorAndDate(lhs, me, '', null);
      field = dom.createElement('textarea');
      middle.innerHTML = '';
      middle.appendChild(field);
      field.rows = 3;
      // field.cols = 40
      field.setAttribute('style', messageBodyStyle + 'background-color: #eef;');
      field.addEventListener('keyup', function (e) {
        // User preference?
        if (e.keyCode === 13) {
          if (!e.altKey) {
            // Alt-Enter just adds a new line
            sendMessage();
          }
        }
      }, false);
      rhs.innerHTML = '';
      sendButton = messageArea_UI.widgets.button(dom, messageArea_UI.icons.iconBase + 'noun_383448.svg', 'Send');
      sendButton.setAttribute('style', messageArea_UI.style.buttonStyle + 'float: right;');
      sendButton.addEventListener('click', sendMessage, false);
      rhs.appendChild(sendButton);
    };
    var context = {
      div: middle,
      dom: dom
    };
    ensureLoggedIn(context).then(function (context) {
      me = context.me;
      turnOnInput();
    });
    return form;
  };
  function nick(person) {
    var s = external_SolidLogic_.solidLogicSingleton.store.any(person, messageArea_UI.ns.foaf('nick'));
    if (s) return '' + s.value;
    return '' + label_label(person);
  }
  function creatorAndDate(td1, creator, date, message) {
    var nickAnchor = td1.appendChild(anchor(nick(creator), creator));
    if (creator.uri) {
      external_SolidLogic_.solidLogicSingleton.store.fetcher.nowOrWhenFetched(creator.doc(), undefined, function (_ok, _body) {
        nickAnchor.textContent = nick(creator);
      });
    }
    td1.appendChild(dom.createElement('br'));
    td1.appendChild(anchor(date, message));
  }

  // ///////////////////////////////////////////////////////////////////////

  function syncMessages(about, messageTable) {
    var displayed = {};
    var ele, ele2;
    for (ele = messageTable.firstChild; ele; ele = ele.nextSibling) {
      if (ele.AJAR_subject) {
        displayed[ele.AJAR_subject.uri] = true;
      }
    }
    var messages = kb.each(about, ns.wf('message'));
    var stored = {};
    messages.forEach(function (m) {
      stored[m.uri] = true;
      if (!displayed[m.uri]) {
        addMessage(m);
      }
    });
    for (ele = messageTable.firstChild; ele;) {
      ele2 = ele.nextSibling;
      if (ele.AJAR_subject && !stored[ele.AJAR_subject.uri]) {
        messageTable.removeChild(ele);
      }
      ele = ele2;
    }
  }
  var deleteMessage = function deleteMessage(message) {
    var deletions = kb.statementsMatching(message).concat(kb.statementsMatching(undefined, undefined, message));
    updater.update(deletions, [], function (uri, ok, body) {
      if (!ok) {
        announce.error('Cant delete messages:' + body);
      } else {
        syncMessages(subject, messageTable);
      }
    });
  };
  var addMessage = function addMessage(message) {
    var bindings = {
      '?msg': message,
      '?creator': kb.any(message, ns.foaf('maker')),
      '?date': kb.any(message, DCT('created')),
      '?content': kb.any(message, ns.sioc('content'))
    };
    renderMessage(bindings, true); // fresh from elsewhere
  };
  var renderMessage = function renderMessage(bindings, fresh) {
    var creator = bindings['?creator'];
    var message = bindings['?msg'];
    var date = bindings['?date'];
    var content = bindings['?content'];
    var dateString = date.value;
    var tr = dom.createElement('tr');
    tr.AJAR_date = dateString;
    tr.AJAR_subject = message;
    var done = false;
    for (var ele = messageTable.firstChild;; ele = ele.nextSibling) {
      if (!ele) {
        // empty
        break;
      }
      if (dateString > ele.AJAR_date && newestFirst || dateString < ele.AJAR_date && !newestFirst) {
        messageTable.insertBefore(tr, ele);
        done = true;
        break;
      }
    }
    if (!done) {
      messageTable.appendChild(tr);
    }
    var td1 = dom.createElement('td');
    tr.appendChild(td1);
    creatorAndDate(td1, creator, messageArea_UI.widgets.shortDate(dateString), message);
    var td2 = dom.createElement('td');
    tr.appendChild(td2);
    var pre = dom.createElement('p');
    pre.setAttribute('style', messageBodyStyle + (fresh ? 'background-color: #e8ffe8;' : 'background-color: #white;'));
    td2.appendChild(pre);
    pre.textContent = content.value;
    var td3 = dom.createElement('td');
    tr.appendChild(td3);
    var delButton = dom.createElement('button');
    td3.appendChild(delButton);
    delButton.textContent = '-';
    tr.setAttribute('class', 'hoverControl'); // See tabbedtab.css (sigh global CSS)
    delButton.setAttribute('class', 'hoverControlHide');
    delButton.setAttribute('style', 'color: red;');
    delButton.addEventListener('click', function (_event) {
      td3.removeChild(delButton); // Ask -- are you sure?
      var cancelButton = dom.createElement('button');
      cancelButton.textContent = 'cancel';
      td3.appendChild(cancelButton).addEventListener('click', function (_event) {
        td3.removeChild(sureButton);
        td3.removeChild(cancelButton);
        td3.appendChild(delButton);
      }, false);
      var sureButton = dom.createElement('button');
      sureButton.textContent = 'Delete message';
      td3.appendChild(sureButton).addEventListener('click', function (_event) {
        td3.removeChild(sureButton);
        td3.removeChild(cancelButton);
        deleteMessage(message);
      }, false);
    }, false);
  };

  // Messages with date, author etc

  messageTable = dom.createElement('table');
  messageTable.fresh = false;
  div.appendChild(messageTable);
  messageTable.setAttribute('style', 'width: 100%;'); // fill that div!

  var tr = newMessageForm();
  if (newestFirst) {
    messageTable.insertBefore(tr, messageTable.firstChild); // If newestFirst
  } else {
    messageTable.appendChild(tr); // not newestFirst
  }
  var query;
  // Do this with a live query to pull in messages from web
  if (options.query) {
    query = options.query;
  } else {
    query = new external_$rdf_.Query('Messages');
    var v = {}; // semicolon needed
    var vs = ['msg', 'date', 'creator', 'content'];
    vs.forEach(function (x) {
      query.vars.push(v[x] = external_$rdf_.variable(x));
    });
    query.pat.add(subject, WF('message'), v.msg);
    query.pat.add(v.msg, ns.dct('created'), v.date);
    query.pat.add(v.msg, ns.foaf('maker'), v.creator);
    query.pat.add(v.msg, ns.sioc('content'), v.content);
  }
  function doneQuery() {
    messageTable.fresh = true; // any new are fresh and so will be greenish
  }
  kb.query(query, renderMessage, undefined, doneQuery);
  div.refresh = function () {
    syncMessages(subject, messageTable);
  };
  // syncMessages(subject, messageTable) // no the query will do this async
  return div;
}
;// ./src/chat/dateFolder.js




/**
 * Contains the [[DateFolder]] class
 * This tracks data stored in dated folders and sub-folders
 *
 */



 // pull in first avoid cross-refs

function emptyLeaf(_x) {
  return _emptyLeaf.apply(this, arguments);
}

/**
 * Track back through the YYYY/MM/DD tree to find the previous/next day
 */
function _emptyLeaf() {
  _emptyLeaf = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee5(leafDocument) {
    return regenerator_default().wrap(function (_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 1;
          return external_SolidLogic_.store.fetcher.load(leafDocument);
        case 1:
          return _context5.abrupt("return", !(external_SolidLogic_.store.statementsMatching(null, src_ns.dct('created'), null, leafDocument).length > 0));
        case 2:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _emptyLeaf.apply(this, arguments);
}
var DateFolder = /*#__PURE__*/function () {
  function DateFolder(rootThing, leafFileName, membershipProperty) {
    classCallCheck_classCallCheck(this, DateFolder);
    this.root = rootThing;
    this.rootFolder = rootThing.dir();
    this.leafFileName = leafFileName || 'index.ttl'; // typically chat.ttl
    this.membershipProperty = membershipProperty || src_ns.wf('leafObject');
  }

  /* Generate the leaf document (rdf object) from date
   * @returns: <NamedNode> - document
   */
  return createClass_createClass(DateFolder, [{
    key: "leafDocumentFromDate",
    value: function leafDocumentFromDate(date) {
      // debug.log('incoming date: ' + date)
      var isoDate = date.toISOString(); // Like "2018-05-07T17:42:46.576Z"
      var path = isoDate.split('T')[0].replace(/-/g, '/'); //  Like "2018/05/07"
      path = this.root.dir().uri + path + '/' + this.leafFileName;
      return external_SolidLogic_.store.sym(path);
    }

    /* Generate a date object from the leaf file name
     */
  }, {
    key: "dateFromLeafDocument",
    value: function dateFromLeafDocument(doc) {
      var head = this.rootFolder.uri.length;
      var str = doc.uri.slice(head, head + 10).replace(/\//g, '-');
      // let date = new Date(str + 'Z') // GMT - but fails in FF - invalid format :-(
      var date = new Date(str); // not explicitly UTC but is assumed so in spec
      // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/parse
      // debug.log('Date for ' + doc + ':' + date.toISOString())
      return date;
    }
  }, {
    key: "loadPrevious",
    value: function () {
      var _loadPrevious = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee2(date, backwards) {
        var previousPeriod, _previousPeriod, folder, found, leafDocument, nextDate;
        return regenerator_default().wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _previousPeriod = function _previousPeriod3() {
                _previousPeriod = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee(file, level) {
                  var younger, suitable, lastOrFirst, parent, siblings, _folder, uncle, cousins, result, _t;
                  return regenerator_default().wrap(function (_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        lastOrFirst = function _lastOrFirst(siblings) {
                          siblings = siblings.filter(suitable);
                          siblings.sort(); // chronological order
                          if (!backwards) siblings.reverse();
                          return siblings.pop(); // date folder
                        };
                        suitable = function _suitable(x) {
                          var tail = x.uri.slice(0, -1).split('/').slice(-1)[0];
                          if (!'0123456789'.includes(tail[0])) return false; // not numeric
                          return true;
                        };
                        younger = function _younger(x) {
                          if (backwards ? x.uri >= file.uri : x.uri <= file.uri) return false; // later than we want or same -- looking for different
                          return true;
                        };
                        // debug.log('  previousPeriod level' + level + ' file ' + file)
                        parent = file.dir();
                        _context.prev = 1;
                        _context.next = 2;
                        return external_SolidLogic_.store.fetcher.load(parent);
                      case 2:
                        siblings = external_SolidLogic_.store.each(parent, src_ns.ldp('contains'));
                        siblings = siblings.filter(younger);
                        _folder = lastOrFirst(siblings);
                        if (!_folder) {
                          _context.next = 3;
                          break;
                        }
                        return _context.abrupt("return", _folder);
                      case 3:
                        _context.next = 6;
                        break;
                      case 4:
                        _context.prev = 4;
                        _t = _context["catch"](1);
                        if (!(_t.response && _t.response.status && _t.response.status === 404)) {
                          _context.next = 5;
                          break;
                        }
                        src_debug/* log */.Rm('Error 404 for chat parent file ' + parent);
                        _context.next = 6;
                        break;
                      case 5:
                        src_debug/* log */.Rm('*** Error NON 404 for chat parent file ' + parent);
                        // statusTR.appendChild(widgets.errorMessageBlock(dom, err, 'pink'))
                        throw new Error("*** ".concat(_t.message, " for chat folder ").concat(parent));
                      case 6:
                        if (!(level === 0)) {
                          _context.next = 7;
                          break;
                        }
                        return _context.abrupt("return", null);
                      case 7:
                        _context.next = 8;
                        return previousPeriod(parent, level - 1);
                      case 8:
                        uncle = _context.sent;
                        if (uncle) {
                          _context.next = 9;
                          break;
                        }
                        return _context.abrupt("return", null);
                      case 9:
                        _context.next = 10;
                        return external_SolidLogic_.store.fetcher.load(uncle);
                      case 10:
                        cousins = external_SolidLogic_.store.each(uncle, src_ns.ldp('contains'));
                        result = lastOrFirst(cousins); // debug.log('   previousPeriod: returning cousins at level ' + level, cousins)
                        // debug.log('   previousPeriod: returning result at level ' + level, result)
                        return _context.abrupt("return", result);
                      case 11:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee, null, [[1, 4]]);
                }));
                return _previousPeriod.apply(this, arguments);
              };
              previousPeriod = function _previousPeriod2(_x4, _x5) {
                return _previousPeriod.apply(this, arguments);
              }; // previousPeriod
              folder = this.leafDocumentFromDate(date).dir();
            case 1:
              if (false) // removed by dead control flow
{}
              _context2.next = 2;
              return previousPeriod(folder, 3);
            case 2:
              found = _context2.sent;
              if (!found) {
                _context2.next = 6;
                break;
              }
              leafDocument = external_SolidLogic_.store.sym(found.uri + this.leafFileName);
              nextDate = this.dateFromLeafDocument(leafDocument);
              _context2.next = 3;
              return emptyLeaf(leafDocument);
            case 3:
              if (_context2.sent) {
                _context2.next = 4;
                break;
              }
              return _context2.abrupt("return", nextDate);
            case 4:
              // debug.log('  loadPrevious: skipping empty ' + leafDocument)
              date = nextDate;
              folder = this.leafDocumentFromDate(date).dir();
              // debug.log('    loadPrevious: moved back to ' + folder)
            case 5:
              _context2.next = 7;
              break;
            case 6:
              return _context2.abrupt("return", null);
            case 7:
              _context2.next = 1;
              break;
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function loadPrevious(_x2, _x3) {
        return _loadPrevious.apply(this, arguments);
      }
      return loadPrevious;
    }() // loadPrevious
  }, {
    key: "firstLeaf",
    value: function () {
      var _firstLeaf = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee4(backwards) {
        var folderStore, folderFetcher, earliestSubfolder, _earliestSubfolder, y, month, d, leafDocument, leafObjects, msg, sortMe;
        return regenerator_default().wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _earliestSubfolder = function _earliestSubfolder3() {
                _earliestSubfolder = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee3(parent) {
                  var suitable, kids;
                  return regenerator_default().wrap(function (_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        suitable = function _suitable2(x) {
                          var tail = x.uri.slice(0, -1).split('/').slice(-1)[0];
                          if (!'0123456789'.includes(tail[0])) return false; // not numeric
                          return true;
                        };
                        // debug.log('            parent ' + parent)
                        delete folderFetcher.requested[parent.uri];
                        // try {
                        _context3.next = 1;
                        return folderFetcher.load(parent, {
                          force: true
                        });
                      case 1:
                        // Force fetch as will have changed
                        // }catch (err) {
                        // }
                        kids = folderStore.each(parent, src_ns.ldp('contains'));
                        kids = kids.filter(suitable);
                        if (!(kids.length === 0)) {
                          _context3.next = 2;
                          break;
                        }
                        throw new Error(' @@@  No children to         parent2 ' + parent);
                      case 2:
                        kids.sort();
                        if (backwards) kids.reverse();
                        return _context3.abrupt("return", kids[0]);
                      case 3:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee3);
                }));
                return _earliestSubfolder.apply(this, arguments);
              };
              earliestSubfolder = function _earliestSubfolder2(_x7) {
                return _earliestSubfolder.apply(this, arguments);
              };
              // backwards -> last leafObject
              folderStore = external_$rdf_.graph();
              folderFetcher = new external_$rdf_.Fetcher(folderStore);
              _context4.next = 1;
              return earliestSubfolder(this.root.dir());
            case 1:
              y = _context4.sent;
              _context4.next = 2;
              return earliestSubfolder(y);
            case 2:
              month = _context4.sent;
              _context4.next = 3;
              return earliestSubfolder(month);
            case 3:
              d = _context4.sent;
              leafDocument = external_$rdf_.sym(d.uri + 'chat.ttl');
              _context4.next = 4;
              return folderFetcher.load(leafDocument);
            case 4:
              leafObjects = folderStore.each(this.root, this.membershipProperty, null, leafDocument);
              if (!(leafObjects.length === 0)) {
                _context4.next = 5;
                break;
              }
              msg = '  INCONSISTENCY -- no chat leafObject in file ' + leafDocument;
              src_debug/* trace */.uP(msg);
              throw new Error(msg);
            case 5:
              sortMe = leafObjects.map(function (leafObject) {
                return [folderStore.any(leafObject, src_ns.dct('created')), leafObject];
              });
              sortMe.sort();
              if (backwards) sortMe.reverse();
              /* debug.log(
                (backwards ? 'Latest' : 'Earliest') + ' leafObject is ' + sortMe[0][1]
              ) */
              return _context4.abrupt("return", sortMe[0][1]);
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function firstLeaf(_x6) {
        return _firstLeaf.apply(this, arguments);
      }
      return firstLeaf;
    }() // firstleafObject
  }]);
}(); // class
;// ./node_modules/@noble/hashes/utils.js
/**
 * Utilities for hex, bytes, CSPRNG.
 * @module
 */
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
/** Checks if something is Uint8Array. Be careful: nodejs Buffer will return true. */
function utils_isBytes(a) {
    return a instanceof Uint8Array || (ArrayBuffer.isView(a) && a.constructor.name === 'Uint8Array');
}
/** Asserts something is positive integer. */
function utils_anumber(n, title = '') {
    if (!Number.isSafeInteger(n) || n < 0) {
        const prefix = title && `"${title}" `;
        throw new Error(`${prefix}expected integer >= 0, got ${n}`);
    }
}
/** Asserts something is Uint8Array. */
function utils_abytes(value, length, title = '') {
    const bytes = utils_isBytes(value);
    const len = value?.length;
    const needsLen = length !== undefined;
    if (!bytes || (needsLen && len !== length)) {
        const prefix = title && `"${title}" `;
        const ofLen = needsLen ? ` of length ${length}` : '';
        const got = bytes ? `length=${len}` : `type=${typeof value}`;
        throw new Error(prefix + 'expected Uint8Array' + ofLen + ', got ' + got);
    }
    return value;
}
/** Asserts something is hash */
function utils_ahash(h) {
    if (typeof h !== 'function' || typeof h.create !== 'function')
        throw new Error('Hash must wrapped by utils.createHasher');
    utils_anumber(h.outputLen);
    utils_anumber(h.blockLen);
}
/** Asserts a hash instance has not been destroyed / finished */
function aexists(instance, checkFinished = true) {
    if (instance.destroyed)
        throw new Error('Hash instance has been destroyed');
    if (checkFinished && instance.finished)
        throw new Error('Hash#digest() has already been called');
}
/** Asserts output is properly-sized byte array */
function aoutput(out, instance) {
    utils_abytes(out, undefined, 'digestInto() output');
    const min = instance.outputLen;
    if (out.length < min) {
        throw new Error('"digestInto() output" expected to be of length >=' + min);
    }
}
/** Cast u8 / u16 / u32 to u8. */
function u8(arr) {
    return new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
}
/** Cast u8 / u16 / u32 to u32. */
function u32(arr) {
    return new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
}
/** Zeroize a byte array. Warning: JS provides no guarantees. */
function clean(...arrays) {
    for (let i = 0; i < arrays.length; i++) {
        arrays[i].fill(0);
    }
}
/** Create DataView of an array for easy byte-level manipulation. */
function createView(arr) {
    return new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
}
/** The rotate right (circular right shift) operation for uint32 */
function rotr(word, shift) {
    return (word << (32 - shift)) | (word >>> shift);
}
/** The rotate left (circular left shift) operation for uint32 */
function rotl(word, shift) {
    return (word << shift) | ((word >>> (32 - shift)) >>> 0);
}
/** Is current platform little-endian? Most are. Big-Endian platform: IBM */
const isLE = /* @__PURE__ */ (/* unused pure expression or super */ null && ((() => new Uint8Array(new Uint32Array([0x11223344]).buffer)[0] === 0x44)()));
/** The byte swap operation for uint32 */
function byteSwap(word) {
    return (((word << 24) & 0xff000000) |
        ((word << 8) & 0xff0000) |
        ((word >>> 8) & 0xff00) |
        ((word >>> 24) & 0xff));
}
/** Conditionally byte swap if on a big-endian platform */
const swap8IfBE = (/* unused pure expression or super */ null && (isLE
    ? (n) => n
    : (n) => byteSwap(n)));
/** In place byte swap for Uint32Array */
function byteSwap32(arr) {
    for (let i = 0; i < arr.length; i++) {
        arr[i] = byteSwap(arr[i]);
    }
    return arr;
}
const swap32IfBE = (/* unused pure expression or super */ null && (isLE
    ? (u) => u
    : byteSwap32));
// Built-in hex conversion https://caniuse.com/mdn-javascript_builtins_uint8array_fromhex
const hasHexBuiltin = /* @__PURE__ */ (() => 
// @ts-ignore
typeof Uint8Array.from([]).toHex === 'function' && typeof Uint8Array.fromHex === 'function')();
// Array where index 0xf0 (240) is mapped to string 'f0'
const hexes = /* @__PURE__ */ Array.from({ length: 256 }, (_, i) => i.toString(16).padStart(2, '0'));
/**
 * Convert byte array to hex string. Uses built-in function, when available.
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */
function utils_bytesToHex(bytes) {
    utils_abytes(bytes);
    // @ts-ignore
    if (hasHexBuiltin)
        return bytes.toHex();
    // pre-caching improves the speed 6x
    let hex = '';
    for (let i = 0; i < bytes.length; i++) {
        hex += hexes[bytes[i]];
    }
    return hex;
}
// We use optimized technique to convert hex string to byte array
const asciis = { _0: 48, _9: 57, A: 65, F: 70, a: 97, f: 102 };
function asciiToBase16(ch) {
    if (ch >= asciis._0 && ch <= asciis._9)
        return ch - asciis._0; // '2' => 50-48
    if (ch >= asciis.A && ch <= asciis.F)
        return ch - (asciis.A - 10); // 'B' => 66-(65-10)
    if (ch >= asciis.a && ch <= asciis.f)
        return ch - (asciis.a - 10); // 'b' => 98-(97-10)
    return;
}
/**
 * Convert hex string to byte array. Uses built-in function, when available.
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */
function utils_hexToBytes(hex) {
    if (typeof hex !== 'string')
        throw new Error('hex string expected, got ' + typeof hex);
    // @ts-ignore
    if (hasHexBuiltin)
        return Uint8Array.fromHex(hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2)
        throw new Error('hex string expected, got unpadded hex of length ' + hl);
    const array = new Uint8Array(al);
    for (let ai = 0, hi = 0; ai < al; ai++, hi += 2) {
        const n1 = asciiToBase16(hex.charCodeAt(hi));
        const n2 = asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2; // multiply first octet, e.g. 'a3' => 10*16+3 => 160 + 3 => 163
    }
    return array;
}
/**
 * There is no setImmediate in browser and setTimeout is slow.
 * Call of async fn will return Promise, which will be fullfiled only on
 * next scheduler queue processing step and this is exactly what we need.
 */
const nextTick = async () => { };
/** Returns control to thread each 'tick' ms to avoid blocking. */
async function asyncLoop(iters, tick, cb) {
    let ts = Date.now();
    for (let i = 0; i < iters; i++) {
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick)
            continue;
        await nextTick();
        ts += diff;
    }
}
/**
 * Converts string to bytes using UTF8 encoding.
 * Built-in doesn't validate input to be string: we do the check.
 * @example utf8ToBytes('abc') // Uint8Array.from([97, 98, 99])
 */
function utf8ToBytes(str) {
    if (typeof str !== 'string')
        throw new Error('string expected');
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
/**
 * Helper for KDFs: consumes uint8array or string.
 * When string is passed, does utf8 decoding, using TextDecoder.
 */
function kdfInputToBytes(data, errorTitle = '') {
    if (typeof data === 'string')
        return utf8ToBytes(data);
    return utils_abytes(data, undefined, errorTitle);
}
/** Copies several Uint8Arrays into one. */
function utils_concatBytes(...arrays) {
    let sum = 0;
    for (let i = 0; i < arrays.length; i++) {
        const a = arrays[i];
        utils_abytes(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for (let i = 0, pad = 0; i < arrays.length; i++) {
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
/** Merges default options and passed options. */
function checkOpts(defaults, opts) {
    if (opts !== undefined && {}.toString.call(opts) !== '[object Object]')
        throw new Error('options must be object or undefined');
    const merged = Object.assign(defaults, opts);
    return merged;
}
/** Creates function with outputLen, blockLen, create properties from a class constructor. */
function utils_createHasher(hashCons, info = {}) {
    const hashC = (msg, opts) => hashCons(opts).update(msg).digest();
    const tmp = hashCons(undefined);
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts) => hashCons(opts);
    Object.assign(hashC, info);
    return Object.freeze(hashC);
}
/** Cryptographically secure PRNG. Uses internal OS-level `crypto.getRandomValues`. */
function randomBytes(bytesLength = 32) {
    const cr = typeof globalThis === 'object' ? globalThis.crypto : null;
    if (typeof cr?.getRandomValues !== 'function')
        throw new Error('crypto.getRandomValues must be defined');
    return cr.getRandomValues(new Uint8Array(bytesLength));
}
/** Creates OID opts for NIST hashes, with prefix 06 09 60 86 48 01 65 03 04 02. */
const utils_oidNist = (suffix) => ({
    oid: Uint8Array.from([0x06, 0x09, 0x60, 0x86, 0x48, 0x01, 0x65, 0x03, 0x04, 0x02, suffix]),
});
//# sourceMappingURL=utils.js.map
;// ./node_modules/@noble/hashes/_md.js
/**
 * Internal Merkle-Damgard hash utils.
 * @module
 */

/** Choice: a ? b : c */
function Chi(a, b, c) {
    return (a & b) ^ (~a & c);
}
/** Majority function, true if any two inputs is true. */
function Maj(a, b, c) {
    return (a & b) ^ (a & c) ^ (b & c);
}
/**
 * Merkle-Damgard hash construction base class.
 * Could be used to create MD5, RIPEMD, SHA1, SHA2.
 */
class HashMD {
    blockLen;
    outputLen;
    padOffset;
    isLE;
    // For partial updates less than block size
    buffer;
    view;
    finished = false;
    length = 0;
    pos = 0;
    destroyed = false;
    constructor(blockLen, outputLen, padOffset, isLE) {
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.buffer = new Uint8Array(blockLen);
        this.view = createView(this.buffer);
    }
    update(data) {
        aexists(this);
        utils_abytes(data);
        const { view, buffer, blockLen } = this;
        const len = data.length;
        for (let pos = 0; pos < len;) {
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = createView(data);
                for (; blockLen <= len - pos; pos += blockLen)
                    this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        aexists(this);
        aoutput(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer, view, blockLen, isLE } = this;
        let { pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 0b10000000;
        clean(this.buffer.subarray(pos));
        // we have less than padOffset left in buffer, so we cannot put length in
        // current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for (let i = pos; i < blockLen; i++)
            buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        view.setBigUint64(blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = createView(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which must be fused in single op with modulo by JIT
        if (len % 4)
            throw new Error('_sha2: outputLen must be aligned to 32bit');
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length)
            throw new Error('_sha2: outputLen bigger than state');
        for (let i = 0; i < outLen; i++)
            oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer, outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to ||= new this.constructor();
        to.set(...this.get());
        const { blockLen, buffer, length, finished, destroyed, pos } = this;
        to.destroyed = destroyed;
        to.finished = finished;
        to.length = length;
        to.pos = pos;
        if (length % blockLen)
            to.buffer.set(buffer);
        return to;
    }
    clone() {
        return this._cloneInto();
    }
}
/**
 * Initial SHA-2 state: fractional parts of square roots of first 16 primes 2..53.
 * Check out `test/misc/sha2-gen-iv.js` for recomputation guide.
 */
/** Initial SHA256 state. Bits 0..32 of frac part of sqrt of primes 2..19 */
const SHA256_IV = /* @__PURE__ */ Uint32Array.from([
    0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a, 0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19,
]);
/** Initial SHA224 state. Bits 32..64 of frac part of sqrt of primes 23..53 */
const SHA224_IV = /* @__PURE__ */ Uint32Array.from([
    0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939, 0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4,
]);
/** Initial SHA384 state. Bits 0..64 of frac part of sqrt of primes 23..53 */
const SHA384_IV = /* @__PURE__ */ Uint32Array.from([
    0xcbbb9d5d, 0xc1059ed8, 0x629a292a, 0x367cd507, 0x9159015a, 0x3070dd17, 0x152fecd8, 0xf70e5939,
    0x67332667, 0xffc00b31, 0x8eb44a87, 0x68581511, 0xdb0c2e0d, 0x64f98fa7, 0x47b5481d, 0xbefa4fa4,
]);
/** Initial SHA512 state. Bits 0..64 of frac part of sqrt of primes 2..19 */
const SHA512_IV = /* @__PURE__ */ Uint32Array.from([
    0x6a09e667, 0xf3bcc908, 0xbb67ae85, 0x84caa73b, 0x3c6ef372, 0xfe94f82b, 0xa54ff53a, 0x5f1d36f1,
    0x510e527f, 0xade682d1, 0x9b05688c, 0x2b3e6c1f, 0x1f83d9ab, 0xfb41bd6b, 0x5be0cd19, 0x137e2179,
]);
//# sourceMappingURL=_md.js.map
;// ./node_modules/@noble/hashes/_u64.js
/**
 * Internal helpers for u64. BigUint64Array is too slow as per 2025, so we implement it using Uint32Array.
 * @todo re-check https://issues.chromium.org/issues/42212588
 * @module
 */
const U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const _32n = /* @__PURE__ */ BigInt(32);
function fromBig(n, le = false) {
    if (le)
        return { h: Number(n & U32_MASK64), l: Number((n >> _32n) & U32_MASK64) };
    return { h: Number((n >> _32n) & U32_MASK64) | 0, l: Number(n & U32_MASK64) | 0 };
}
function split(lst, le = false) {
    const len = lst.length;
    let Ah = new Uint32Array(len);
    let Al = new Uint32Array(len);
    for (let i = 0; i < len; i++) {
        const { h, l } = fromBig(lst[i], le);
        [Ah[i], Al[i]] = [h, l];
    }
    return [Ah, Al];
}
const toBig = (h, l) => (BigInt(h >>> 0) << _32n) | BigInt(l >>> 0);
// for Shift in [0, 32)
const shrSH = (h, _l, s) => h >>> s;
const shrSL = (h, l, s) => (h << (32 - s)) | (l >>> s);
// Right rotate for Shift in [1, 32)
const rotrSH = (h, l, s) => (h >>> s) | (l << (32 - s));
const rotrSL = (h, l, s) => (h << (32 - s)) | (l >>> s);
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const rotrBH = (h, l, s) => (h << (64 - s)) | (l >>> (s - 32));
const rotrBL = (h, l, s) => (h >>> (s - 32)) | (l << (64 - s));
// Right rotate for shift===32 (just swaps l&h)
const rotr32H = (_h, l) => l;
const rotr32L = (h, _l) => h;
// Left rotate for Shift in [1, 32)
const rotlSH = (h, l, s) => (h << s) | (l >>> (32 - s));
const rotlSL = (h, l, s) => (l << s) | (h >>> (32 - s));
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const rotlBH = (h, l, s) => (l << (s - 32)) | (h >>> (64 - s));
const rotlBL = (h, l, s) => (h << (s - 32)) | (l >>> (64 - s));
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function add(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return { h: (Ah + Bh + ((l / 2 ** 32) | 0)) | 0, l: l | 0 };
}
// Addition with more than 2 elements
const add3L = (Al, Bl, Cl) => (Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
const add3H = (low, Ah, Bh, Ch) => (Ah + Bh + Ch + ((low / 2 ** 32) | 0)) | 0;
const add4L = (Al, Bl, Cl, Dl) => (Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
const add4H = (low, Ah, Bh, Ch, Dh) => (Ah + Bh + Ch + Dh + ((low / 2 ** 32) | 0)) | 0;
const add5L = (Al, Bl, Cl, Dl, El) => (Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
const add5H = (low, Ah, Bh, Ch, Dh, Eh) => (Ah + Bh + Ch + Dh + Eh + ((low / 2 ** 32) | 0)) | 0;
// prettier-ignore

// prettier-ignore
const u64 = {
    fromBig, split, toBig,
    shrSH, shrSL,
    rotrSH, rotrSL, rotrBH, rotrBL,
    rotr32H, rotr32L,
    rotlSH, rotlSL, rotlBH, rotlBL,
    add, add3L, add3H, add4L, add4H, add5H, add5L,
};
/* harmony default export */ const _u64 = ((/* unused pure expression or super */ null && (u64)));
//# sourceMappingURL=_u64.js.map
;// ./node_modules/@noble/hashes/sha2.js
/**
 * SHA2 hash function. A.k.a. sha256, sha384, sha512, sha512_224, sha512_256.
 * SHA256 is the fastest hash implementable in JS, even faster than Blake3.
 * Check out [RFC 4634](https://www.rfc-editor.org/rfc/rfc4634) and
 * [FIPS 180-4](https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf).
 * @module
 */



/**
 * Round constants:
 * First 32 bits of fractional parts of the cube roots of the first 64 primes 2..311)
 */
// prettier-ignore
const SHA256_K = /* @__PURE__ */ Uint32Array.from([
    0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
    0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3, 0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
    0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc, 0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
    0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
    0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13, 0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
    0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3, 0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
    0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
    0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208, 0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
]);
/** Reusable temporary buffer. "W" comes straight from spec. */
const SHA256_W = /* @__PURE__ */ new Uint32Array(64);
/** Internal 32-byte base SHA2 hash class. */
class SHA2_32B extends HashMD {
    constructor(outputLen) {
        super(64, outputLen, 8, false);
    }
    get() {
        const { A, B, C, D, E, F, G, H } = this;
        return [A, B, C, D, E, F, G, H];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for (let i = 0; i < 16; i++, offset += 4)
            SHA256_W[i] = view.getUint32(offset, false);
        for (let i = 16; i < 64; i++) {
            const W15 = SHA256_W[i - 15];
            const W2 = SHA256_W[i - 2];
            const s0 = rotr(W15, 7) ^ rotr(W15, 18) ^ (W15 >>> 3);
            const s1 = rotr(W2, 17) ^ rotr(W2, 19) ^ (W2 >>> 10);
            SHA256_W[i] = (s1 + SHA256_W[i - 7] + s0 + SHA256_W[i - 16]) | 0;
        }
        // Compression function main loop, 64 rounds
        let { A, B, C, D, E, F, G, H } = this;
        for (let i = 0; i < 64; i++) {
            const sigma1 = rotr(E, 6) ^ rotr(E, 11) ^ rotr(E, 25);
            const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            const sigma0 = rotr(A, 2) ^ rotr(A, 13) ^ rotr(A, 22);
            const T2 = (sigma0 + Maj(A, B, C)) | 0;
            H = G;
            G = F;
            F = E;
            E = (D + T1) | 0;
            D = C;
            C = B;
            B = A;
            A = (T1 + T2) | 0;
        }
        // Add the compressed chunk to the current hash value
        A = (A + this.A) | 0;
        B = (B + this.B) | 0;
        C = (C + this.C) | 0;
        D = (D + this.D) | 0;
        E = (E + this.E) | 0;
        F = (F + this.F) | 0;
        G = (G + this.G) | 0;
        H = (H + this.H) | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        clean(SHA256_W);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        clean(this.buffer);
    }
}
/** Internal SHA2-256 hash class. */
class _SHA256 extends SHA2_32B {
    // We cannot use array here since array allows indexing by variable
    // which means optimizer/compiler cannot use registers.
    A = SHA256_IV[0] | 0;
    B = SHA256_IV[1] | 0;
    C = SHA256_IV[2] | 0;
    D = SHA256_IV[3] | 0;
    E = SHA256_IV[4] | 0;
    F = SHA256_IV[5] | 0;
    G = SHA256_IV[6] | 0;
    H = SHA256_IV[7] | 0;
    constructor() {
        super(32);
    }
}
/** Internal SHA2-224 hash class. */
class _SHA224 extends SHA2_32B {
    A = SHA224_IV[0] | 0;
    B = SHA224_IV[1] | 0;
    C = SHA224_IV[2] | 0;
    D = SHA224_IV[3] | 0;
    E = SHA224_IV[4] | 0;
    F = SHA224_IV[5] | 0;
    G = SHA224_IV[6] | 0;
    H = SHA224_IV[7] | 0;
    constructor() {
        super(28);
    }
}
// SHA2-512 is slower than sha256 in js because u64 operations are slow.
// Round contants
// First 32 bits of the fractional parts of the cube roots of the first 80 primes 2..409
// prettier-ignore
const K512 = /* @__PURE__ */ (() => split([
    '0x428a2f98d728ae22', '0x7137449123ef65cd', '0xb5c0fbcfec4d3b2f', '0xe9b5dba58189dbbc',
    '0x3956c25bf348b538', '0x59f111f1b605d019', '0x923f82a4af194f9b', '0xab1c5ed5da6d8118',
    '0xd807aa98a3030242', '0x12835b0145706fbe', '0x243185be4ee4b28c', '0x550c7dc3d5ffb4e2',
    '0x72be5d74f27b896f', '0x80deb1fe3b1696b1', '0x9bdc06a725c71235', '0xc19bf174cf692694',
    '0xe49b69c19ef14ad2', '0xefbe4786384f25e3', '0x0fc19dc68b8cd5b5', '0x240ca1cc77ac9c65',
    '0x2de92c6f592b0275', '0x4a7484aa6ea6e483', '0x5cb0a9dcbd41fbd4', '0x76f988da831153b5',
    '0x983e5152ee66dfab', '0xa831c66d2db43210', '0xb00327c898fb213f', '0xbf597fc7beef0ee4',
    '0xc6e00bf33da88fc2', '0xd5a79147930aa725', '0x06ca6351e003826f', '0x142929670a0e6e70',
    '0x27b70a8546d22ffc', '0x2e1b21385c26c926', '0x4d2c6dfc5ac42aed', '0x53380d139d95b3df',
    '0x650a73548baf63de', '0x766a0abb3c77b2a8', '0x81c2c92e47edaee6', '0x92722c851482353b',
    '0xa2bfe8a14cf10364', '0xa81a664bbc423001', '0xc24b8b70d0f89791', '0xc76c51a30654be30',
    '0xd192e819d6ef5218', '0xd69906245565a910', '0xf40e35855771202a', '0x106aa07032bbd1b8',
    '0x19a4c116b8d2d0c8', '0x1e376c085141ab53', '0x2748774cdf8eeb99', '0x34b0bcb5e19b48a8',
    '0x391c0cb3c5c95a63', '0x4ed8aa4ae3418acb', '0x5b9cca4f7763e373', '0x682e6ff3d6b2b8a3',
    '0x748f82ee5defb2fc', '0x78a5636f43172f60', '0x84c87814a1f0ab72', '0x8cc702081a6439ec',
    '0x90befffa23631e28', '0xa4506cebde82bde9', '0xbef9a3f7b2c67915', '0xc67178f2e372532b',
    '0xca273eceea26619c', '0xd186b8c721c0c207', '0xeada7dd6cde0eb1e', '0xf57d4f7fee6ed178',
    '0x06f067aa72176fba', '0x0a637dc5a2c898a6', '0x113f9804bef90dae', '0x1b710b35131c471b',
    '0x28db77f523047d84', '0x32caab7b40c72493', '0x3c9ebe0a15c9bebc', '0x431d67c49c100d4c',
    '0x4cc5d4becb3e42b6', '0x597f299cfc657e2a', '0x5fcb6fab3ad6faec', '0x6c44198c4a475817'
].map(n => BigInt(n))))();
const SHA512_Kh = /* @__PURE__ */ (() => K512[0])();
const SHA512_Kl = /* @__PURE__ */ (() => K512[1])();
// Reusable temporary buffers
const SHA512_W_H = /* @__PURE__ */ new Uint32Array(80);
const SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
/** Internal 64-byte base SHA2 hash class. */
class SHA2_64B extends HashMD {
    constructor(outputLen) {
        super(128, outputLen, 16, false);
    }
    // prettier-ignore
    get() {
        const { Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl } = this;
        return [Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl];
    }
    // prettier-ignore
    set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
        this.Ah = Ah | 0;
        this.Al = Al | 0;
        this.Bh = Bh | 0;
        this.Bl = Bl | 0;
        this.Ch = Ch | 0;
        this.Cl = Cl | 0;
        this.Dh = Dh | 0;
        this.Dl = Dl | 0;
        this.Eh = Eh | 0;
        this.El = El | 0;
        this.Fh = Fh | 0;
        this.Fl = Fl | 0;
        this.Gh = Gh | 0;
        this.Gl = Gl | 0;
        this.Hh = Hh | 0;
        this.Hl = Hl | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 64 words w[16..79] of the message schedule array
        for (let i = 0; i < 16; i++, offset += 4) {
            SHA512_W_H[i] = view.getUint32(offset);
            SHA512_W_L[i] = view.getUint32((offset += 4));
        }
        for (let i = 16; i < 80; i++) {
            // s0 := (w[i-15] rightrotate 1) xor (w[i-15] rightrotate 8) xor (w[i-15] rightshift 7)
            const W15h = SHA512_W_H[i - 15] | 0;
            const W15l = SHA512_W_L[i - 15] | 0;
            const s0h = rotrSH(W15h, W15l, 1) ^ rotrSH(W15h, W15l, 8) ^ shrSH(W15h, W15l, 7);
            const s0l = rotrSL(W15h, W15l, 1) ^ rotrSL(W15h, W15l, 8) ^ shrSL(W15h, W15l, 7);
            // s1 := (w[i-2] rightrotate 19) xor (w[i-2] rightrotate 61) xor (w[i-2] rightshift 6)
            const W2h = SHA512_W_H[i - 2] | 0;
            const W2l = SHA512_W_L[i - 2] | 0;
            const s1h = rotrSH(W2h, W2l, 19) ^ rotrBH(W2h, W2l, 61) ^ shrSH(W2h, W2l, 6);
            const s1l = rotrSL(W2h, W2l, 19) ^ rotrBL(W2h, W2l, 61) ^ shrSL(W2h, W2l, 6);
            // SHA256_W[i] = s0 + s1 + SHA256_W[i - 7] + SHA256_W[i - 16];
            const SUMl = add4L(s0l, s1l, SHA512_W_L[i - 7], SHA512_W_L[i - 16]);
            const SUMh = add4H(SUMl, s0h, s1h, SHA512_W_H[i - 7], SHA512_W_H[i - 16]);
            SHA512_W_H[i] = SUMh | 0;
            SHA512_W_L[i] = SUMl | 0;
        }
        let { Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl } = this;
        // Compression function main loop, 80 rounds
        for (let i = 0; i < 80; i++) {
            // S1 := (e rightrotate 14) xor (e rightrotate 18) xor (e rightrotate 41)
            const sigma1h = rotrSH(Eh, El, 14) ^ rotrSH(Eh, El, 18) ^ rotrBH(Eh, El, 41);
            const sigma1l = rotrSL(Eh, El, 14) ^ rotrSL(Eh, El, 18) ^ rotrBL(Eh, El, 41);
            //const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            const CHIh = (Eh & Fh) ^ (~Eh & Gh);
            const CHIl = (El & Fl) ^ (~El & Gl);
            // T1 = H + sigma1 + Chi(E, F, G) + SHA512_K[i] + SHA512_W[i]
            // prettier-ignore
            const T1ll = add5L(Hl, sigma1l, CHIl, SHA512_Kl[i], SHA512_W_L[i]);
            const T1h = add5H(T1ll, Hh, sigma1h, CHIh, SHA512_Kh[i], SHA512_W_H[i]);
            const T1l = T1ll | 0;
            // S0 := (a rightrotate 28) xor (a rightrotate 34) xor (a rightrotate 39)
            const sigma0h = rotrSH(Ah, Al, 28) ^ rotrBH(Ah, Al, 34) ^ rotrBH(Ah, Al, 39);
            const sigma0l = rotrSL(Ah, Al, 28) ^ rotrBL(Ah, Al, 34) ^ rotrBL(Ah, Al, 39);
            const MAJh = (Ah & Bh) ^ (Ah & Ch) ^ (Bh & Ch);
            const MAJl = (Al & Bl) ^ (Al & Cl) ^ (Bl & Cl);
            Hh = Gh | 0;
            Hl = Gl | 0;
            Gh = Fh | 0;
            Gl = Fl | 0;
            Fh = Eh | 0;
            Fl = El | 0;
            ({ h: Eh, l: El } = add(Dh | 0, Dl | 0, T1h | 0, T1l | 0));
            Dh = Ch | 0;
            Dl = Cl | 0;
            Ch = Bh | 0;
            Cl = Bl | 0;
            Bh = Ah | 0;
            Bl = Al | 0;
            const All = add3L(T1l, sigma0l, MAJl);
            Ah = add3H(All, T1h, sigma0h, MAJh);
            Al = All | 0;
        }
        // Add the compressed chunk to the current hash value
        ({ h: Ah, l: Al } = add(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0));
        ({ h: Bh, l: Bl } = add(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0));
        ({ h: Ch, l: Cl } = add(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0));
        ({ h: Dh, l: Dl } = add(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0));
        ({ h: Eh, l: El } = add(this.Eh | 0, this.El | 0, Eh | 0, El | 0));
        ({ h: Fh, l: Fl } = add(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0));
        ({ h: Gh, l: Gl } = add(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0));
        ({ h: Hh, l: Hl } = add(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0));
        this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
    }
    roundClean() {
        clean(SHA512_W_H, SHA512_W_L);
    }
    destroy() {
        clean(this.buffer);
        this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
}
/** Internal SHA2-512 hash class. */
class _SHA512 extends SHA2_64B {
    Ah = SHA512_IV[0] | 0;
    Al = SHA512_IV[1] | 0;
    Bh = SHA512_IV[2] | 0;
    Bl = SHA512_IV[3] | 0;
    Ch = SHA512_IV[4] | 0;
    Cl = SHA512_IV[5] | 0;
    Dh = SHA512_IV[6] | 0;
    Dl = SHA512_IV[7] | 0;
    Eh = SHA512_IV[8] | 0;
    El = SHA512_IV[9] | 0;
    Fh = SHA512_IV[10] | 0;
    Fl = SHA512_IV[11] | 0;
    Gh = SHA512_IV[12] | 0;
    Gl = SHA512_IV[13] | 0;
    Hh = SHA512_IV[14] | 0;
    Hl = SHA512_IV[15] | 0;
    constructor() {
        super(64);
    }
}
/** Internal SHA2-384 hash class. */
class _SHA384 extends SHA2_64B {
    Ah = SHA384_IV[0] | 0;
    Al = SHA384_IV[1] | 0;
    Bh = SHA384_IV[2] | 0;
    Bl = SHA384_IV[3] | 0;
    Ch = SHA384_IV[4] | 0;
    Cl = SHA384_IV[5] | 0;
    Dh = SHA384_IV[6] | 0;
    Dl = SHA384_IV[7] | 0;
    Eh = SHA384_IV[8] | 0;
    El = SHA384_IV[9] | 0;
    Fh = SHA384_IV[10] | 0;
    Fl = SHA384_IV[11] | 0;
    Gh = SHA384_IV[12] | 0;
    Gl = SHA384_IV[13] | 0;
    Hh = SHA384_IV[14] | 0;
    Hl = SHA384_IV[15] | 0;
    constructor() {
        super(48);
    }
}
/**
 * Truncated SHA512/256 and SHA512/224.
 * SHA512_IV is XORed with 0xa5a5a5a5a5a5a5a5, then used as "intermediary" IV of SHA512/t.
 * Then t hashes string to produce result IV.
 * See `test/misc/sha2-gen-iv.js`.
 */
/** SHA512/224 IV */
const T224_IV = /* @__PURE__ */ Uint32Array.from([
    0x8c3d37c8, 0x19544da2, 0x73e19966, 0x89dcd4d6, 0x1dfab7ae, 0x32ff9c82, 0x679dd514, 0x582f9fcf,
    0x0f6d2b69, 0x7bd44da8, 0x77e36f73, 0x04c48942, 0x3f9d85a8, 0x6a1d36c8, 0x1112e6ad, 0x91d692a1,
]);
/** SHA512/256 IV */
const T256_IV = /* @__PURE__ */ Uint32Array.from([
    0x22312194, 0xfc2bf72c, 0x9f555fa3, 0xc84c64c2, 0x2393b86b, 0x6f53b151, 0x96387719, 0x5940eabd,
    0x96283ee2, 0xa88effe3, 0xbe5e1e25, 0x53863992, 0x2b0199fc, 0x2c85b8aa, 0x0eb72ddc, 0x81c52ca2,
]);
/** Internal SHA2-512/224 hash class. */
class _SHA512_224 extends SHA2_64B {
    Ah = T224_IV[0] | 0;
    Al = T224_IV[1] | 0;
    Bh = T224_IV[2] | 0;
    Bl = T224_IV[3] | 0;
    Ch = T224_IV[4] | 0;
    Cl = T224_IV[5] | 0;
    Dh = T224_IV[6] | 0;
    Dl = T224_IV[7] | 0;
    Eh = T224_IV[8] | 0;
    El = T224_IV[9] | 0;
    Fh = T224_IV[10] | 0;
    Fl = T224_IV[11] | 0;
    Gh = T224_IV[12] | 0;
    Gl = T224_IV[13] | 0;
    Hh = T224_IV[14] | 0;
    Hl = T224_IV[15] | 0;
    constructor() {
        super(28);
    }
}
/** Internal SHA2-512/256 hash class. */
class _SHA512_256 extends SHA2_64B {
    Ah = T256_IV[0] | 0;
    Al = T256_IV[1] | 0;
    Bh = T256_IV[2] | 0;
    Bl = T256_IV[3] | 0;
    Ch = T256_IV[4] | 0;
    Cl = T256_IV[5] | 0;
    Dh = T256_IV[6] | 0;
    Dl = T256_IV[7] | 0;
    Eh = T256_IV[8] | 0;
    El = T256_IV[9] | 0;
    Fh = T256_IV[10] | 0;
    Fl = T256_IV[11] | 0;
    Gh = T256_IV[12] | 0;
    Gl = T256_IV[13] | 0;
    Hh = T256_IV[14] | 0;
    Hl = T256_IV[15] | 0;
    constructor() {
        super(32);
    }
}
/**
 * SHA2-256 hash function from RFC 4634. In JS it's the fastest: even faster than Blake3. Some info:
 *
 * - Trying 2^128 hashes would get 50% chance of collision, using birthday attack.
 * - BTC network is doing 2^70 hashes/sec (2^95 hashes/year) as per 2025.
 * - Each sha256 hash is executing 2^18 bit operations.
 * - Good 2024 ASICs can do 200Th/sec with 3500 watts of power, corresponding to 2^36 hashes/joule.
 */
const sha2_sha256 = /* @__PURE__ */ utils_createHasher(() => new _SHA256(), 
/* @__PURE__ */ utils_oidNist(0x01));
/** SHA2-224 hash function from RFC 4634 */
const sha224 = /* @__PURE__ */ (/* unused pure expression or super */ null && (createHasher(() => new _SHA224(), 
/* @__PURE__ */ oidNist(0x04))));
/** SHA2-512 hash function from RFC 4634. */
const sha512 = /* @__PURE__ */ (/* unused pure expression or super */ null && (createHasher(() => new _SHA512(), 
/* @__PURE__ */ oidNist(0x03))));
/** SHA2-384 hash function from RFC 4634. */
const sha384 = /* @__PURE__ */ (/* unused pure expression or super */ null && (createHasher(() => new _SHA384(), 
/* @__PURE__ */ oidNist(0x02))));
/**
 * SHA2-512/256 "truncated" hash function, with improved resistance to length extension attacks.
 * See the paper on [truncated SHA512](https://eprint.iacr.org/2010/548.pdf).
 */
const sha512_256 = /* @__PURE__ */ (/* unused pure expression or super */ null && (createHasher(() => new _SHA512_256(), 
/* @__PURE__ */ oidNist(0x06))));
/**
 * SHA2-512/224 "truncated" hash function, with improved resistance to length extension attacks.
 * See the paper on [truncated SHA512](https://eprint.iacr.org/2010/548.pdf).
 */
const sha512_224 = /* @__PURE__ */ (/* unused pure expression or super */ null && (createHasher(() => new _SHA512_224(), 
/* @__PURE__ */ oidNist(0x05))));
//# sourceMappingURL=sha2.js.map
;// ./node_modules/@noble/curves/utils.js
/**
 * Hex, bytes and number utilities.
 * @module
 */
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */


const _0n = /* @__PURE__ */ BigInt(0);
const _1n = /* @__PURE__ */ BigInt(1);
function utils_abool(value, title = '') {
    if (typeof value !== 'boolean') {
        const prefix = title && `"${title}" `;
        throw new Error(prefix + 'expected boolean, got type=' + typeof value);
    }
    return value;
}
// Used in weierstrass, der
function abignumber(n) {
    if (typeof n === 'bigint') {
        if (!isPosBig(n))
            throw new Error('positive bigint expected, got ' + n);
    }
    else
        utils_anumber(n);
    return n;
}
function asafenumber(value, title = '') {
    if (!Number.isSafeInteger(value)) {
        const prefix = title && `"${title}" `;
        throw new Error(prefix + 'expected safe integer, got type=' + typeof value);
    }
}
function numberToHexUnpadded(num) {
    const hex = abignumber(num).toString(16);
    return hex.length & 1 ? '0' + hex : hex;
}
function hexToNumber(hex) {
    if (typeof hex !== 'string')
        throw new Error('hex string expected, got ' + typeof hex);
    return hex === '' ? _0n : BigInt('0x' + hex); // Big Endian
}
// BE: Big Endian, LE: Little Endian
function utils_bytesToNumberBE(bytes) {
    return hexToNumber(utils_bytesToHex(bytes));
}
function bytesToNumberLE(bytes) {
    return hexToNumber(utils_bytesToHex(copyBytes(utils_abytes(bytes)).reverse()));
}
function numberToBytesBE(n, len) {
    utils_anumber(len);
    n = abignumber(n);
    const res = utils_hexToBytes(n.toString(16).padStart(len * 2, '0'));
    if (res.length !== len)
        throw new Error('number too large');
    return res;
}
function numberToBytesLE(n, len) {
    return numberToBytesBE(n, len).reverse();
}
// Unpadded, rarely used
function numberToVarBytesBE(n) {
    return hexToBytes_(numberToHexUnpadded(abignumber(n)));
}
// Compares 2 u8a-s in kinda constant time
function equalBytes(a, b) {
    if (a.length !== b.length)
        return false;
    let diff = 0;
    for (let i = 0; i < a.length; i++)
        diff |= a[i] ^ b[i];
    return diff === 0;
}
/**
 * Copies Uint8Array. We can't use u8a.slice(), because u8a can be Buffer,
 * and Buffer#slice creates mutable copy. Never use Buffers!
 */
function copyBytes(bytes) {
    return Uint8Array.from(bytes);
}
/**
 * Decodes 7-bit ASCII string to Uint8Array, throws on non-ascii symbols
 * Should be safe to use for things expected to be ASCII.
 * Returns exact same result as `TextEncoder` for ASCII or throws.
 */
function asciiToBytes(ascii) {
    return Uint8Array.from(ascii, (c, i) => {
        const charCode = c.charCodeAt(0);
        if (c.length !== 1 || charCode > 127) {
            throw new Error(`string contains non-ASCII character "${ascii[i]}" with code ${charCode} at position ${i}`);
        }
        return charCode;
    });
}
// Is positive bigint
const isPosBig = (n) => typeof n === 'bigint' && _0n <= n;
function inRange(n, min, max) {
    return isPosBig(n) && isPosBig(min) && isPosBig(max) && min <= n && n < max;
}
/**
 * Asserts min <= n < max. NOTE: It's < max and not <= max.
 * @example
 * aInRange('x', x, 1n, 256n); // would assume x is in (1n..255n)
 */
function utils_aInRange(title, n, min, max) {
    // Why min <= n < max and not a (min < n < max) OR b (min <= n <= max)?
    // consider P=256n, min=0n, max=P
    // - a for min=0 would require -1:          `inRange('x', x, -1n, P)`
    // - b would commonly require subtraction:  `inRange('x', x, 0n, P - 1n)`
    // - our way is the cleanest:               `inRange('x', x, 0n, P)
    if (!inRange(n, min, max))
        throw new Error('expected valid ' + title + ': ' + min + ' <= n < ' + max + ', got ' + n);
}
// Bit operations
/**
 * Calculates amount of bits in a bigint.
 * Same as `n.toString(2).length`
 * TODO: merge with nLength in modular
 */
function utils_bitLen(n) {
    let len;
    for (len = 0; n > _0n; n >>= _1n, len += 1)
        ;
    return len;
}
/**
 * Gets single bit at position.
 * NOTE: first bit position is 0 (same as arrays)
 * Same as `!!+Array.from(n.toString(2)).reverse()[pos]`
 */
function bitGet(n, pos) {
    return (n >> BigInt(pos)) & _1n;
}
/**
 * Sets single bit at position.
 */
function bitSet(n, pos, value) {
    return n | ((value ? _1n : _0n) << BigInt(pos));
}
/**
 * Calculate mask for N bits. Not using ** operator with bigints because of old engines.
 * Same as BigInt(`0b${Array(i).fill('1').join('')}`)
 */
const utils_bitMask = (n) => (_1n << BigInt(n)) - _1n;
/**
 * Minimal HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
 * @returns function that will call DRBG until 2nd arg returns something meaningful
 * @example
 *   const drbg = createHmacDRBG<Key>(32, 32, hmac);
 *   drbg(seed, bytesToKey); // bytesToKey must return Key or undefined
 */
function utils_createHmacDrbg(hashLen, qByteLen, hmacFn) {
    anumber(hashLen, 'hashLen');
    anumber(qByteLen, 'qByteLen');
    if (typeof hmacFn !== 'function')
        throw new Error('hmacFn must be a function');
    const u8n = (len) => new Uint8Array(len); // creates Uint8Array
    const NULL = Uint8Array.of();
    const byte0 = Uint8Array.of(0x00);
    const byte1 = Uint8Array.of(0x01);
    const _maxDrbgIters = 1000;
    // Step B, Step C: set hashLen to 8*ceil(hlen/8)
    let v = u8n(hashLen); // Minimal non-full-spec HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
    let k = u8n(hashLen); // Steps B and C of RFC6979 3.2: set hashLen, in our case always same
    let i = 0; // Iterations counter, will throw when over 1000
    const reset = () => {
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    const h = (...msgs) => hmacFn(k, concatBytes_(v, ...msgs)); // hmac(k)(v, ...values)
    const reseed = (seed = NULL) => {
        // HMAC-DRBG reseed() function. Steps D-G
        k = h(byte0, seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0)
            return;
        k = h(byte1, seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    const gen = () => {
        // HMAC-DRBG generate() function
        if (i++ >= _maxDrbgIters)
            throw new Error('drbg: tried max amount of iterations');
        let len = 0;
        const out = [];
        while (len < qByteLen) {
            v = h();
            const sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return concatBytes_(...out);
    };
    const genUntil = (seed, pred) => {
        reset();
        reseed(seed); // Steps D-G
        let res = undefined; // Step H: grind until k is in [1..n-1]
        while (!(res = pred(gen())))
            reseed();
        reset();
        return res;
    };
    return genUntil;
}
function utils_validateObject(object, fields = {}, optFields = {}) {
    if (!object || typeof object !== 'object')
        throw new Error('expected valid options object');
    function checkField(fieldName, expectedType, isOpt) {
        const val = object[fieldName];
        if (isOpt && val === undefined)
            return;
        const current = typeof val;
        if (current !== expectedType || val === null)
            throw new Error(`param "${fieldName}" is invalid: expected ${expectedType}, got ${current}`);
    }
    const iter = (f, isOpt) => Object.entries(f).forEach(([k, v]) => checkField(k, v, isOpt));
    iter(fields, false);
    iter(optFields, true);
}
/**
 * throws not implemented error
 */
const notImplemented = () => {
    throw new Error('not implemented');
};
/**
 * Memoizes (caches) computation result.
 * Uses WeakMap: the value is going auto-cleaned by GC after last reference is removed.
 */
function memoized(fn) {
    const map = new WeakMap();
    return (arg, ...args) => {
        const val = map.get(arg);
        if (val !== undefined)
            return val;
        const computed = fn(arg, ...args);
        map.set(arg, computed);
        return computed;
    };
}
//# sourceMappingURL=utils.js.map
;// ./node_modules/@noble/curves/abstract/modular.js
/**
 * Utils for modular division and fields.
 * Field over 11 is a finite (Galois) field is integer number operations `mod 11`.
 * There is no division: it is replaced by modular multiplicative inverse.
 * @module
 */
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */

// Numbers aren't used in x25519 / x448 builds
// prettier-ignore
const modular_0n = /* @__PURE__ */ BigInt(0), modular_1n = /* @__PURE__ */ BigInt(1), _2n = /* @__PURE__ */ BigInt(2);
// prettier-ignore
const _3n = /* @__PURE__ */ BigInt(3), _4n = /* @__PURE__ */ BigInt(4), _5n = /* @__PURE__ */ BigInt(5);
// prettier-ignore
const _7n = /* @__PURE__ */ BigInt(7), _8n = /* @__PURE__ */ BigInt(8), _9n = /* @__PURE__ */ BigInt(9);
const _16n = /* @__PURE__ */ BigInt(16);
// Calculates a modulo b
function mod(a, b) {
    const result = a % b;
    return result >= modular_0n ? result : b + result;
}
/**
 * Efficiently raise num to power and do modular division.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 * @example
 * pow(2n, 6n, 11n) // 64n % 11n == 9n
 */
function pow(num, power, modulo) {
    return FpPow(Field(modulo), num, power);
}
/** Does `x^(2^power)` mod p. `pow2(30, 4)` == `30^(2^4)` */
function pow2(x, power, modulo) {
    let res = x;
    while (power-- > modular_0n) {
        res *= res;
        res %= modulo;
    }
    return res;
}
/**
 * Inverses number over modulo.
 * Implemented using [Euclidean GCD](https://brilliant.org/wiki/extended-euclidean-algorithm/).
 */
function invert(number, modulo) {
    if (number === modular_0n)
        throw new Error('invert: expected non-zero number');
    if (modulo <= modular_0n)
        throw new Error('invert: expected positive modulus, got ' + modulo);
    // Fermat's little theorem "CT-like" version inv(n) = n^(m-2) mod m is 30x slower.
    let a = mod(number, modulo);
    let b = modulo;
    // prettier-ignore
    let x = modular_0n, y = modular_1n, u = modular_1n, v = modular_0n;
    while (a !== modular_0n) {
        // JIT applies optimization if those two lines follow each other
        const q = b / a;
        const r = b % a;
        const m = x - u * q;
        const n = y - v * q;
        // prettier-ignore
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    const gcd = b;
    if (gcd !== modular_1n)
        throw new Error('invert: does not exist');
    return mod(x, modulo);
}
function assertIsSquare(Fp, root, n) {
    if (!Fp.eql(Fp.sqr(root), n))
        throw new Error('Cannot find square root');
}
// Not all roots are possible! Example which will throw:
// const NUM =
// n = 72057594037927816n;
// Fp = Field(BigInt('0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaab'));
function sqrt3mod4(Fp, n) {
    const p1div4 = (Fp.ORDER + modular_1n) / _4n;
    const root = Fp.pow(n, p1div4);
    assertIsSquare(Fp, root, n);
    return root;
}
function sqrt5mod8(Fp, n) {
    const p5div8 = (Fp.ORDER - _5n) / _8n;
    const n2 = Fp.mul(n, _2n);
    const v = Fp.pow(n2, p5div8);
    const nv = Fp.mul(n, v);
    const i = Fp.mul(Fp.mul(nv, _2n), v);
    const root = Fp.mul(nv, Fp.sub(i, Fp.ONE));
    assertIsSquare(Fp, root, n);
    return root;
}
// Based on RFC9380, Kong algorithm
// prettier-ignore
function sqrt9mod16(P) {
    const Fp_ = Field(P);
    const tn = tonelliShanks(P);
    const c1 = tn(Fp_, Fp_.neg(Fp_.ONE)); //  1. c1 = sqrt(-1) in F, i.e., (c1^2) == -1 in F
    const c2 = tn(Fp_, c1); //  2. c2 = sqrt(c1) in F, i.e., (c2^2) == c1 in F
    const c3 = tn(Fp_, Fp_.neg(c1)); //  3. c3 = sqrt(-c1) in F, i.e., (c3^2) == -c1 in F
    const c4 = (P + _7n) / _16n; //  4. c4 = (q + 7) / 16        # Integer arithmetic
    return (Fp, n) => {
        let tv1 = Fp.pow(n, c4); //  1. tv1 = x^c4
        let tv2 = Fp.mul(tv1, c1); //  2. tv2 = c1 * tv1
        const tv3 = Fp.mul(tv1, c2); //  3. tv3 = c2 * tv1
        const tv4 = Fp.mul(tv1, c3); //  4. tv4 = c3 * tv1
        const e1 = Fp.eql(Fp.sqr(tv2), n); //  5.  e1 = (tv2^2) == x
        const e2 = Fp.eql(Fp.sqr(tv3), n); //  6.  e2 = (tv3^2) == x
        tv1 = Fp.cmov(tv1, tv2, e1); //  7. tv1 = CMOV(tv1, tv2, e1)  # Select tv2 if (tv2^2) == x
        tv2 = Fp.cmov(tv4, tv3, e2); //  8. tv2 = CMOV(tv4, tv3, e2)  # Select tv3 if (tv3^2) == x
        const e3 = Fp.eql(Fp.sqr(tv2), n); //  9.  e3 = (tv2^2) == x
        const root = Fp.cmov(tv1, tv2, e3); // 10.  z = CMOV(tv1, tv2, e3)   # Select sqrt from tv1 & tv2
        assertIsSquare(Fp, root, n);
        return root;
    };
}
/**
 * Tonelli-Shanks square root search algorithm.
 * 1. https://eprint.iacr.org/2012/685.pdf (page 12)
 * 2. Square Roots from 1; 24, 51, 10 to Dan Shanks
 * @param P field order
 * @returns function that takes field Fp (created from P) and number n
 */
function tonelliShanks(P) {
    // Initialization (precomputation).
    // Caching initialization could boost perf by 7%.
    if (P < _3n)
        throw new Error('sqrt is not defined for small field');
    // Factor P - 1 = Q * 2^S, where Q is odd
    let Q = P - modular_1n;
    let S = 0;
    while (Q % _2n === modular_0n) {
        Q /= _2n;
        S++;
    }
    // Find the first quadratic non-residue Z >= 2
    let Z = _2n;
    const _Fp = Field(P);
    while (FpLegendre(_Fp, Z) === 1) {
        // Basic primality test for P. After x iterations, chance of
        // not finding quadratic non-residue is 2^x, so 2^1000.
        if (Z++ > 1000)
            throw new Error('Cannot find square root: probably non-prime P');
    }
    // Fast-path; usually done before Z, but we do "primality test".
    if (S === 1)
        return sqrt3mod4;
    // Slow-path
    // TODO: test on Fp2 and others
    let cc = _Fp.pow(Z, Q); // c = z^Q
    const Q1div2 = (Q + modular_1n) / _2n;
    return function tonelliSlow(Fp, n) {
        if (Fp.is0(n))
            return n;
        // Check if n is a quadratic residue using Legendre symbol
        if (FpLegendre(Fp, n) !== 1)
            throw new Error('Cannot find square root');
        // Initialize variables for the main loop
        let M = S;
        let c = Fp.mul(Fp.ONE, cc); // c = z^Q, move cc from field _Fp into field Fp
        let t = Fp.pow(n, Q); // t = n^Q, first guess at the fudge factor
        let R = Fp.pow(n, Q1div2); // R = n^((Q+1)/2), first guess at the square root
        // Main loop
        // while t != 1
        while (!Fp.eql(t, Fp.ONE)) {
            if (Fp.is0(t))
                return Fp.ZERO; // if t=0 return R=0
            let i = 1;
            // Find the smallest i >= 1 such that t^(2^i) ≡ 1 (mod P)
            let t_tmp = Fp.sqr(t); // t^(2^1)
            while (!Fp.eql(t_tmp, Fp.ONE)) {
                i++;
                t_tmp = Fp.sqr(t_tmp); // t^(2^2)...
                if (i === M)
                    throw new Error('Cannot find square root');
            }
            // Calculate the exponent for b: 2^(M - i - 1)
            const exponent = modular_1n << BigInt(M - i - 1); // bigint is important
            const b = Fp.pow(c, exponent); // b = 2^(M - i - 1)
            // Update variables
            M = i;
            c = Fp.sqr(b); // c = b^2
            t = Fp.mul(t, c); // t = (t * b^2)
            R = Fp.mul(R, b); // R = R*b
        }
        return R;
    };
}
/**
 * Square root for a finite field. Will try optimized versions first:
 *
 * 1. P ≡ 3 (mod 4)
 * 2. P ≡ 5 (mod 8)
 * 3. P ≡ 9 (mod 16)
 * 4. Tonelli-Shanks algorithm
 *
 * Different algorithms can give different roots, it is up to user to decide which one they want.
 * For example there is FpSqrtOdd/FpSqrtEven to choice root based on oddness (used for hash-to-curve).
 */
function FpSqrt(P) {
    // P ≡ 3 (mod 4) => √n = n^((P+1)/4)
    if (P % _4n === _3n)
        return sqrt3mod4;
    // P ≡ 5 (mod 8) => Atkin algorithm, page 10 of https://eprint.iacr.org/2012/685.pdf
    if (P % _8n === _5n)
        return sqrt5mod8;
    // P ≡ 9 (mod 16) => Kong algorithm, page 11 of https://eprint.iacr.org/2012/685.pdf (algorithm 4)
    if (P % _16n === _9n)
        return sqrt9mod16(P);
    // Tonelli-Shanks algorithm
    return tonelliShanks(P);
}
// Little-endian check for first LE bit (last BE bit);
const isNegativeLE = (num, modulo) => (mod(num, modulo) & modular_1n) === modular_1n;
// prettier-ignore
const FIELD_FIELDS = [
    'create', 'isValid', 'is0', 'neg', 'inv', 'sqrt', 'sqr',
    'eql', 'add', 'sub', 'mul', 'pow', 'div',
    'addN', 'subN', 'mulN', 'sqrN'
];
function modular_validateField(field) {
    const initial = {
        ORDER: 'bigint',
        BYTES: 'number',
        BITS: 'number',
    };
    const opts = FIELD_FIELDS.reduce((map, val) => {
        map[val] = 'function';
        return map;
    }, initial);
    utils_validateObject(field, opts);
    // const max = 16384;
    // if (field.BYTES < 1 || field.BYTES > max) throw new Error('invalid field');
    // if (field.BITS < 1 || field.BITS > 8 * max) throw new Error('invalid field');
    return field;
}
// Generic field functions
/**
 * Same as `pow` but for Fp: non-constant-time.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 */
function FpPow(Fp, num, power) {
    if (power < modular_0n)
        throw new Error('invalid exponent, negatives unsupported');
    if (power === modular_0n)
        return Fp.ONE;
    if (power === modular_1n)
        return num;
    let p = Fp.ONE;
    let d = num;
    while (power > modular_0n) {
        if (power & modular_1n)
            p = Fp.mul(p, d);
        d = Fp.sqr(d);
        power >>= modular_1n;
    }
    return p;
}
/**
 * Efficiently invert an array of Field elements.
 * Exception-free. Will return `undefined` for 0 elements.
 * @param passZero map 0 to 0 (instead of undefined)
 */
function modular_FpInvertBatch(Fp, nums, passZero = false) {
    const inverted = new Array(nums.length).fill(passZero ? Fp.ZERO : undefined);
    // Walk from first to last, multiply them by each other MOD p
    const multipliedAcc = nums.reduce((acc, num, i) => {
        if (Fp.is0(num))
            return acc;
        inverted[i] = acc;
        return Fp.mul(acc, num);
    }, Fp.ONE);
    // Invert last element
    const invertedAcc = Fp.inv(multipliedAcc);
    // Walk from last to first, multiply them by inverted each other MOD p
    nums.reduceRight((acc, num, i) => {
        if (Fp.is0(num))
            return acc;
        inverted[i] = Fp.mul(acc, inverted[i]);
        return Fp.mul(acc, num);
    }, invertedAcc);
    return inverted;
}
// TODO: remove
function FpDiv(Fp, lhs, rhs) {
    return Fp.mul(lhs, typeof rhs === 'bigint' ? invert(rhs, Fp.ORDER) : Fp.inv(rhs));
}
/**
 * Legendre symbol.
 * Legendre constant is used to calculate Legendre symbol (a | p)
 * which denotes the value of a^((p-1)/2) (mod p).
 *
 * * (a | p) ≡ 1    if a is a square (mod p), quadratic residue
 * * (a | p) ≡ -1   if a is not a square (mod p), quadratic non residue
 * * (a | p) ≡ 0    if a ≡ 0 (mod p)
 */
function FpLegendre(Fp, n) {
    // We can use 3rd argument as optional cache of this value
    // but seems unneeded for now. The operation is very fast.
    const p1mod2 = (Fp.ORDER - modular_1n) / _2n;
    const powered = Fp.pow(n, p1mod2);
    const yes = Fp.eql(powered, Fp.ONE);
    const zero = Fp.eql(powered, Fp.ZERO);
    const no = Fp.eql(powered, Fp.neg(Fp.ONE));
    if (!yes && !zero && !no)
        throw new Error('invalid Legendre symbol result');
    return yes ? 1 : zero ? 0 : -1;
}
// This function returns True whenever the value x is a square in the field F.
function FpIsSquare(Fp, n) {
    const l = FpLegendre(Fp, n);
    return l === 1;
}
// CURVE.n lengths
function nLength(n, nBitLength) {
    // Bit size, byte size of CURVE.n
    if (nBitLength !== undefined)
        utils_anumber(nBitLength);
    const _nBitLength = nBitLength !== undefined ? nBitLength : n.toString(2).length;
    const nByteLength = Math.ceil(_nBitLength / 8);
    return { nBitLength: _nBitLength, nByteLength };
}
class _Field {
    ORDER;
    BITS;
    BYTES;
    isLE;
    ZERO = modular_0n;
    ONE = modular_1n;
    _lengths;
    _sqrt; // cached sqrt
    _mod;
    constructor(ORDER, opts = {}) {
        if (ORDER <= modular_0n)
            throw new Error('invalid field: expected ORDER > 0, got ' + ORDER);
        let _nbitLength = undefined;
        this.isLE = false;
        if (opts != null && typeof opts === 'object') {
            if (typeof opts.BITS === 'number')
                _nbitLength = opts.BITS;
            if (typeof opts.sqrt === 'function')
                this.sqrt = opts.sqrt;
            if (typeof opts.isLE === 'boolean')
                this.isLE = opts.isLE;
            if (opts.allowedLengths)
                this._lengths = opts.allowedLengths?.slice();
            if (typeof opts.modFromBytes === 'boolean')
                this._mod = opts.modFromBytes;
        }
        const { nBitLength, nByteLength } = nLength(ORDER, _nbitLength);
        if (nByteLength > 2048)
            throw new Error('invalid field: expected ORDER of <= 2048 bytes');
        this.ORDER = ORDER;
        this.BITS = nBitLength;
        this.BYTES = nByteLength;
        this._sqrt = undefined;
        Object.preventExtensions(this);
    }
    create(num) {
        return mod(num, this.ORDER);
    }
    isValid(num) {
        if (typeof num !== 'bigint')
            throw new Error('invalid field element: expected bigint, got ' + typeof num);
        return modular_0n <= num && num < this.ORDER; // 0 is valid element, but it's not invertible
    }
    is0(num) {
        return num === modular_0n;
    }
    // is valid and invertible
    isValidNot0(num) {
        return !this.is0(num) && this.isValid(num);
    }
    isOdd(num) {
        return (num & modular_1n) === modular_1n;
    }
    neg(num) {
        return mod(-num, this.ORDER);
    }
    eql(lhs, rhs) {
        return lhs === rhs;
    }
    sqr(num) {
        return mod(num * num, this.ORDER);
    }
    add(lhs, rhs) {
        return mod(lhs + rhs, this.ORDER);
    }
    sub(lhs, rhs) {
        return mod(lhs - rhs, this.ORDER);
    }
    mul(lhs, rhs) {
        return mod(lhs * rhs, this.ORDER);
    }
    pow(num, power) {
        return FpPow(this, num, power);
    }
    div(lhs, rhs) {
        return mod(lhs * invert(rhs, this.ORDER), this.ORDER);
    }
    // Same as above, but doesn't normalize
    sqrN(num) {
        return num * num;
    }
    addN(lhs, rhs) {
        return lhs + rhs;
    }
    subN(lhs, rhs) {
        return lhs - rhs;
    }
    mulN(lhs, rhs) {
        return lhs * rhs;
    }
    inv(num) {
        return invert(num, this.ORDER);
    }
    sqrt(num) {
        // Caching _sqrt speeds up sqrt9mod16 by 5x and tonneli-shanks by 10%
        if (!this._sqrt)
            this._sqrt = FpSqrt(this.ORDER);
        return this._sqrt(this, num);
    }
    toBytes(num) {
        return this.isLE ? numberToBytesLE(num, this.BYTES) : numberToBytesBE(num, this.BYTES);
    }
    fromBytes(bytes, skipValidation = false) {
        utils_abytes(bytes);
        const { _lengths: allowedLengths, BYTES, isLE, ORDER, _mod: modFromBytes } = this;
        if (allowedLengths) {
            if (!allowedLengths.includes(bytes.length) || bytes.length > BYTES) {
                throw new Error('Field.fromBytes: expected ' + allowedLengths + ' bytes, got ' + bytes.length);
            }
            const padded = new Uint8Array(BYTES);
            // isLE add 0 to right, !isLE to the left.
            padded.set(bytes, isLE ? 0 : padded.length - bytes.length);
            bytes = padded;
        }
        if (bytes.length !== BYTES)
            throw new Error('Field.fromBytes: expected ' + BYTES + ' bytes, got ' + bytes.length);
        let scalar = isLE ? bytesToNumberLE(bytes) : utils_bytesToNumberBE(bytes);
        if (modFromBytes)
            scalar = mod(scalar, ORDER);
        if (!skipValidation)
            if (!this.isValid(scalar))
                throw new Error('invalid field element: outside of range 0..ORDER');
        // NOTE: we don't validate scalar here, please use isValid. This done such way because some
        // protocol may allow non-reduced scalar that reduced later or changed some other way.
        return scalar;
    }
    // TODO: we don't need it here, move out to separate fn
    invertBatch(lst) {
        return modular_FpInvertBatch(this, lst);
    }
    // We can't move this out because Fp6, Fp12 implement it
    // and it's unclear what to return in there.
    cmov(a, b, condition) {
        return condition ? b : a;
    }
}
/**
 * Creates a finite field. Major performance optimizations:
 * * 1. Denormalized operations like mulN instead of mul.
 * * 2. Identical object shape: never add or remove keys.
 * * 3. `Object.freeze`.
 * Fragile: always run a benchmark on a change.
 * Security note: operations don't check 'isValid' for all elements for performance reasons,
 * it is caller responsibility to check this.
 * This is low-level code, please make sure you know what you're doing.
 *
 * Note about field properties:
 * * CHARACTERISTIC p = prime number, number of elements in main subgroup.
 * * ORDER q = similar to cofactor in curves, may be composite `q = p^m`.
 *
 * @param ORDER field order, probably prime, or could be composite
 * @param bitLen how many bits the field consumes
 * @param isLE (default: false) if encoding / decoding should be in little-endian
 * @param redef optional faster redefinitions of sqrt and other methods
 */
function Field(ORDER, opts = {}) {
    return new _Field(ORDER, opts);
}
// Generic random scalar, we can do same for other fields if via Fp2.mul(Fp2.ONE, Fp2.random)?
// This allows unsafe methods like ignore bias or zero. These unsafe, but often used in different protocols (if deterministic RNG).
// which mean we cannot force this via opts.
// Not sure what to do with randomBytes, we can accept it inside opts if wanted.
// Probably need to export getMinHashLength somewhere?
// random(bytes?: Uint8Array, unsafeAllowZero = false, unsafeAllowBias = false) {
//   const LEN = !unsafeAllowBias ? getMinHashLength(ORDER) : BYTES;
//   if (bytes === undefined) bytes = randomBytes(LEN); // _opts.randomBytes?
//   const num = isLE ? bytesToNumberLE(bytes) : bytesToNumberBE(bytes);
//   // `mod(x, 11)` can sometimes produce 0. `mod(x, 10) + 1` is the same, but no 0
//   const reduced = unsafeAllowZero ? mod(num, ORDER) : mod(num, ORDER - _1n) + _1n;
//   return reduced;
// },
function FpSqrtOdd(Fp, elm) {
    if (!Fp.isOdd)
        throw new Error("Field doesn't have isOdd");
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? root : Fp.neg(root);
}
function FpSqrtEven(Fp, elm) {
    if (!Fp.isOdd)
        throw new Error("Field doesn't have isOdd");
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? Fp.neg(root) : root;
}
/**
 * Returns total number of bytes consumed by the field element.
 * For example, 32 bytes for usual 256-bit weierstrass curve.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of field
 */
function getFieldBytesLength(fieldOrder) {
    if (typeof fieldOrder !== 'bigint')
        throw new Error('field order must be bigint');
    const bitLength = fieldOrder.toString(2).length;
    return Math.ceil(bitLength / 8);
}
/**
 * Returns minimal amount of bytes that can be safely reduced
 * by field order.
 * Should be 2^-128 for 128-bit curve such as P256.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of target hash
 */
function modular_getMinHashLength(fieldOrder) {
    const length = getFieldBytesLength(fieldOrder);
    return length + Math.ceil(length / 2);
}
/**
 * "Constant-time" private key generation utility.
 * Can take (n + n/2) or more bytes of uniform input e.g. from CSPRNG or KDF
 * and convert them into private scalar, with the modulo bias being negligible.
 * Needs at least 48 bytes of input for 32-byte private key.
 * https://research.kudelskisecurity.com/2020/07/28/the-definitive-guide-to-modulo-bias-and-how-to-avoid-it/
 * FIPS 186-5, A.2 https://csrc.nist.gov/publications/detail/fips/186/5/final
 * RFC 9380, https://www.rfc-editor.org/rfc/rfc9380#section-5
 * @param hash hash output from SHA3 or a similar function
 * @param groupOrder size of subgroup - (e.g. secp256k1.Point.Fn.ORDER)
 * @param isLE interpret hash bytes as LE num
 * @returns valid private scalar
 */
function modular_mapHashToField(key, fieldOrder, isLE = false) {
    utils_abytes(key);
    const len = key.length;
    const fieldLen = getFieldBytesLength(fieldOrder);
    const minLen = modular_getMinHashLength(fieldOrder);
    // No small numbers: need to understand bias story. No huge numbers: easier to detect JS timings.
    if (len < 16 || len < minLen || len > 1024)
        throw new Error('expected ' + minLen + '-1024 bytes of input, got ' + len);
    const num = isLE ? bytesToNumberLE(key) : utils_bytesToNumberBE(key);
    // `mod(x, 11)` can sometimes produce 0. `mod(x, 10) + 1` is the same, but no 0
    const reduced = mod(num, fieldOrder - modular_1n) + modular_1n;
    return isLE ? numberToBytesLE(reduced, fieldLen) : numberToBytesBE(reduced, fieldLen);
}
//# sourceMappingURL=modular.js.map
;// ./node_modules/@noble/curves/abstract/curve.js
/**
 * Methods for elliptic curve multiplication by scalars.
 * Contains wNAF, pippenger.
 * @module
 */
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */


const curve_0n = /* @__PURE__ */ BigInt(0);
const curve_1n = /* @__PURE__ */ BigInt(1);
function negateCt(condition, item) {
    const neg = item.negate();
    return condition ? neg : item;
}
/**
 * Takes a bunch of Projective Points but executes only one
 * inversion on all of them. Inversion is very slow operation,
 * so this improves performance massively.
 * Optimization: converts a list of projective points to a list of identical points with Z=1.
 */
function normalizeZ(c, points) {
    const invertedZs = modular_FpInvertBatch(c.Fp, points.map((p) => p.Z));
    return points.map((p, i) => c.fromAffine(p.toAffine(invertedZs[i])));
}
function validateW(W, bits) {
    if (!Number.isSafeInteger(W) || W <= 0 || W > bits)
        throw new Error('invalid window size, expected [1..' + bits + '], got W=' + W);
}
function calcWOpts(W, scalarBits) {
    validateW(W, scalarBits);
    const windows = Math.ceil(scalarBits / W) + 1; // W=8 33. Not 32, because we skip zero
    const windowSize = 2 ** (W - 1); // W=8 128. Not 256, because we skip zero
    const maxNumber = 2 ** W; // W=8 256
    const mask = utils_bitMask(W); // W=8 255 == mask 0b11111111
    const shiftBy = BigInt(W); // W=8 8
    return { windows, windowSize, mask, maxNumber, shiftBy };
}
function calcOffsets(n, window, wOpts) {
    const { windowSize, mask, maxNumber, shiftBy } = wOpts;
    let wbits = Number(n & mask); // extract W bits.
    let nextN = n >> shiftBy; // shift number by W bits.
    // What actually happens here:
    // const highestBit = Number(mask ^ (mask >> 1n));
    // let wbits2 = wbits - 1; // skip zero
    // if (wbits2 & highestBit) { wbits2 ^= Number(mask); // (~);
    // split if bits > max: +224 => 256-32
    if (wbits > windowSize) {
        // we skip zero, which means instead of `>= size-1`, we do `> size`
        wbits -= maxNumber; // -32, can be maxNumber - wbits, but then we need to set isNeg here.
        nextN += curve_1n; // +256 (carry)
    }
    const offsetStart = window * windowSize;
    const offset = offsetStart + Math.abs(wbits) - 1; // -1 because we skip zero
    const isZero = wbits === 0; // is current window slice a 0?
    const isNeg = wbits < 0; // is current window slice negative?
    const isNegF = window % 2 !== 0; // fake random statement for noise
    const offsetF = offsetStart; // fake offset for noise
    return { nextN, offset, isZero, isNeg, isNegF, offsetF };
}
function validateMSMPoints(points, c) {
    if (!Array.isArray(points))
        throw new Error('array expected');
    points.forEach((p, i) => {
        if (!(p instanceof c))
            throw new Error('invalid point at index ' + i);
    });
}
function validateMSMScalars(scalars, field) {
    if (!Array.isArray(scalars))
        throw new Error('array of scalars expected');
    scalars.forEach((s, i) => {
        if (!field.isValid(s))
            throw new Error('invalid scalar at index ' + i);
    });
}
// Since points in different groups cannot be equal (different object constructor),
// we can have single place to store precomputes.
// Allows to make points frozen / immutable.
const pointPrecomputes = new WeakMap();
const pointWindowSizes = new WeakMap();
function getW(P) {
    // To disable precomputes:
    // return 1;
    return pointWindowSizes.get(P) || 1;
}
function assert0(n) {
    if (n !== curve_0n)
        throw new Error('invalid wNAF');
}
/**
 * Elliptic curve multiplication of Point by scalar. Fragile.
 * Table generation takes **30MB of ram and 10ms on high-end CPU**,
 * but may take much longer on slow devices. Actual generation will happen on
 * first call of `multiply()`. By default, `BASE` point is precomputed.
 *
 * Scalars should always be less than curve order: this should be checked inside of a curve itself.
 * Creates precomputation tables for fast multiplication:
 * - private scalar is split by fixed size windows of W bits
 * - every window point is collected from window's table & added to accumulator
 * - since windows are different, same point inside tables won't be accessed more than once per calc
 * - each multiplication is 'Math.ceil(CURVE_ORDER / 𝑊) + 1' point additions (fixed for any scalar)
 * - +1 window is neccessary for wNAF
 * - wNAF reduces table size: 2x less memory + 2x faster generation, but 10% slower multiplication
 *
 * @todo Research returning 2d JS array of windows, instead of a single window.
 * This would allow windows to be in different memory locations
 */
class wNAF {
    BASE;
    ZERO;
    Fn;
    bits;
    // Parametrized with a given Point class (not individual point)
    constructor(Point, bits) {
        this.BASE = Point.BASE;
        this.ZERO = Point.ZERO;
        this.Fn = Point.Fn;
        this.bits = bits;
    }
    // non-const time multiplication ladder
    _unsafeLadder(elm, n, p = this.ZERO) {
        let d = elm;
        while (n > curve_0n) {
            if (n & curve_1n)
                p = p.add(d);
            d = d.double();
            n >>= curve_1n;
        }
        return p;
    }
    /**
     * Creates a wNAF precomputation window. Used for caching.
     * Default window size is set by `utils.precompute()` and is equal to 8.
     * Number of precomputed points depends on the curve size:
     * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
     * - 𝑊 is the window size
     * - 𝑛 is the bitlength of the curve order.
     * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
     * @param point Point instance
     * @param W window size
     * @returns precomputed point tables flattened to a single array
     */
    precomputeWindow(point, W) {
        const { windows, windowSize } = calcWOpts(W, this.bits);
        const points = [];
        let p = point;
        let base = p;
        for (let window = 0; window < windows; window++) {
            base = p;
            points.push(base);
            // i=1, bc we skip 0
            for (let i = 1; i < windowSize; i++) {
                base = base.add(p);
                points.push(base);
            }
            p = base.double();
        }
        return points;
    }
    /**
     * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
     * More compact implementation:
     * https://github.com/paulmillr/noble-secp256k1/blob/47cb1669b6e506ad66b35fe7d76132ae97465da2/index.ts#L502-L541
     * @returns real and fake (for const-time) points
     */
    wNAF(W, precomputes, n) {
        // Scalar should be smaller than field order
        if (!this.Fn.isValid(n))
            throw new Error('invalid scalar');
        // Accumulators
        let p = this.ZERO;
        let f = this.BASE;
        // This code was first written with assumption that 'f' and 'p' will never be infinity point:
        // since each addition is multiplied by 2 ** W, it cannot cancel each other. However,
        // there is negate now: it is possible that negated element from low value
        // would be the same as high element, which will create carry into next window.
        // It's not obvious how this can fail, but still worth investigating later.
        const wo = calcWOpts(W, this.bits);
        for (let window = 0; window < wo.windows; window++) {
            // (n === _0n) is handled and not early-exited. isEven and offsetF are used for noise
            const { nextN, offset, isZero, isNeg, isNegF, offsetF } = calcOffsets(n, window, wo);
            n = nextN;
            if (isZero) {
                // bits are 0: add garbage to fake point
                // Important part for const-time getPublicKey: add random "noise" point to f.
                f = f.add(negateCt(isNegF, precomputes[offsetF]));
            }
            else {
                // bits are 1: add to result point
                p = p.add(negateCt(isNeg, precomputes[offset]));
            }
        }
        assert0(n);
        // Return both real and fake points: JIT won't eliminate f.
        // At this point there is a way to F be infinity-point even if p is not,
        // which makes it less const-time: around 1 bigint multiply.
        return { p, f };
    }
    /**
     * Implements ec unsafe (non const-time) multiplication using precomputed tables and w-ary non-adjacent form.
     * @param acc accumulator point to add result of multiplication
     * @returns point
     */
    wNAFUnsafe(W, precomputes, n, acc = this.ZERO) {
        const wo = calcWOpts(W, this.bits);
        for (let window = 0; window < wo.windows; window++) {
            if (n === curve_0n)
                break; // Early-exit, skip 0 value
            const { nextN, offset, isZero, isNeg } = calcOffsets(n, window, wo);
            n = nextN;
            if (isZero) {
                // Window bits are 0: skip processing.
                // Move to next window.
                continue;
            }
            else {
                const item = precomputes[offset];
                acc = acc.add(isNeg ? item.negate() : item); // Re-using acc allows to save adds in MSM
            }
        }
        assert0(n);
        return acc;
    }
    getPrecomputes(W, point, transform) {
        // Calculate precomputes on a first run, reuse them after
        let comp = pointPrecomputes.get(point);
        if (!comp) {
            comp = this.precomputeWindow(point, W);
            if (W !== 1) {
                // Doing transform outside of if brings 15% perf hit
                if (typeof transform === 'function')
                    comp = transform(comp);
                pointPrecomputes.set(point, comp);
            }
        }
        return comp;
    }
    cached(point, scalar, transform) {
        const W = getW(point);
        return this.wNAF(W, this.getPrecomputes(W, point, transform), scalar);
    }
    unsafe(point, scalar, transform, prev) {
        const W = getW(point);
        if (W === 1)
            return this._unsafeLadder(point, scalar, prev); // For W=1 ladder is ~x2 faster
        return this.wNAFUnsafe(W, this.getPrecomputes(W, point, transform), scalar, prev);
    }
    // We calculate precomputes for elliptic curve point multiplication
    // using windowed method. This specifies window size and
    // stores precomputed values. Usually only base point would be precomputed.
    createCache(P, W) {
        validateW(W, this.bits);
        pointWindowSizes.set(P, W);
        pointPrecomputes.delete(P);
    }
    hasCache(elm) {
        return getW(elm) !== 1;
    }
}
/**
 * Endomorphism-specific multiplication for Koblitz curves.
 * Cost: 128 dbl, 0-256 adds.
 */
function mulEndoUnsafe(Point, point, k1, k2) {
    let acc = point;
    let p1 = Point.ZERO;
    let p2 = Point.ZERO;
    while (k1 > curve_0n || k2 > curve_0n) {
        if (k1 & curve_1n)
            p1 = p1.add(acc);
        if (k2 & curve_1n)
            p2 = p2.add(acc);
        acc = acc.double();
        k1 >>= curve_1n;
        k2 >>= curve_1n;
    }
    return { p1, p2 };
}
/**
 * Pippenger algorithm for multi-scalar multiplication (MSM, Pa + Qb + Rc + ...).
 * 30x faster vs naive addition on L=4096, 10x faster than precomputes.
 * For N=254bit, L=1, it does: 1024 ADD + 254 DBL. For L=5: 1536 ADD + 254 DBL.
 * Algorithmically constant-time (for same L), even when 1 point + scalar, or when scalar = 0.
 * @param c Curve Point constructor
 * @param fieldN field over CURVE.N - important that it's not over CURVE.P
 * @param points array of L curve points
 * @param scalars array of L scalars (aka secret keys / bigints)
 */
function pippenger(c, points, scalars) {
    // If we split scalars by some window (let's say 8 bits), every chunk will only
    // take 256 buckets even if there are 4096 scalars, also re-uses double.
    // TODO:
    // - https://eprint.iacr.org/2024/750.pdf
    // - https://tches.iacr.org/index.php/TCHES/article/view/10287
    // 0 is accepted in scalars
    const fieldN = c.Fn;
    validateMSMPoints(points, c);
    validateMSMScalars(scalars, fieldN);
    const plength = points.length;
    const slength = scalars.length;
    if (plength !== slength)
        throw new Error('arrays of points and scalars must have equal length');
    // if (plength === 0) throw new Error('array must be of length >= 2');
    const zero = c.ZERO;
    const wbits = bitLen(BigInt(plength));
    let windowSize = 1; // bits
    if (wbits > 12)
        windowSize = wbits - 3;
    else if (wbits > 4)
        windowSize = wbits - 2;
    else if (wbits > 0)
        windowSize = 2;
    const MASK = bitMask(windowSize);
    const buckets = new Array(Number(MASK) + 1).fill(zero); // +1 for zero array
    const lastBits = Math.floor((fieldN.BITS - 1) / windowSize) * windowSize;
    let sum = zero;
    for (let i = lastBits; i >= 0; i -= windowSize) {
        buckets.fill(zero);
        for (let j = 0; j < slength; j++) {
            const scalar = scalars[j];
            const wbits = Number((scalar >> BigInt(i)) & MASK);
            buckets[wbits] = buckets[wbits].add(points[j]);
        }
        let resI = zero; // not using this will do small speed-up, but will lose ct
        // Skip first bucket, because it is zero
        for (let j = buckets.length - 1, sumI = zero; j > 0; j--) {
            sumI = sumI.add(buckets[j]);
            resI = resI.add(sumI);
        }
        sum = sum.add(resI);
        if (i !== 0)
            for (let j = 0; j < windowSize; j++)
                sum = sum.double();
    }
    return sum;
}
/**
 * Precomputed multi-scalar multiplication (MSM, Pa + Qb + Rc + ...).
 * @param c Curve Point constructor
 * @param fieldN field over CURVE.N - important that it's not over CURVE.P
 * @param points array of L curve points
 * @returns function which multiplies points with scaars
 */
function precomputeMSMUnsafe(c, points, windowSize) {
    /**
     * Performance Analysis of Window-based Precomputation
     *
     * Base Case (256-bit scalar, 8-bit window):
     * - Standard precomputation requires:
     *   - 31 additions per scalar × 256 scalars = 7,936 ops
     *   - Plus 255 summary additions = 8,191 total ops
     *   Note: Summary additions can be optimized via accumulator
     *
     * Chunked Precomputation Analysis:
     * - Using 32 chunks requires:
     *   - 255 additions per chunk
     *   - 256 doublings
     *   - Total: (255 × 32) + 256 = 8,416 ops
     *
     * Memory Usage Comparison:
     * Window Size | Standard Points | Chunked Points
     * ------------|-----------------|---------------
     *     4-bit   |     520         |      15
     *     8-bit   |    4,224        |     255
     *    10-bit   |   13,824        |   1,023
     *    16-bit   |  557,056        |  65,535
     *
     * Key Advantages:
     * 1. Enables larger window sizes due to reduced memory overhead
     * 2. More efficient for smaller scalar counts:
     *    - 16 chunks: (16 × 255) + 256 = 4,336 ops
     *    - ~2x faster than standard 8,191 ops
     *
     * Limitations:
     * - Not suitable for plain precomputes (requires 256 constant doublings)
     * - Performance degrades with larger scalar counts:
     *   - Optimal for ~256 scalars
     *   - Less efficient for 4096+ scalars (Pippenger preferred)
     */
    const fieldN = c.Fn;
    validateW(windowSize, fieldN.BITS);
    validateMSMPoints(points, c);
    const zero = c.ZERO;
    const tableSize = 2 ** windowSize - 1; // table size (without zero)
    const chunks = Math.ceil(fieldN.BITS / windowSize); // chunks of item
    const MASK = bitMask(windowSize);
    const tables = points.map((p) => {
        const res = [];
        for (let i = 0, acc = p; i < tableSize; i++) {
            res.push(acc);
            acc = acc.add(p);
        }
        return res;
    });
    return (scalars) => {
        validateMSMScalars(scalars, fieldN);
        if (scalars.length > points.length)
            throw new Error('array of scalars must be smaller than array of points');
        let res = zero;
        for (let i = 0; i < chunks; i++) {
            // No need to double if accumulator is still zero.
            if (res !== zero)
                for (let j = 0; j < windowSize; j++)
                    res = res.double();
            const shiftBy = BigInt(chunks * windowSize - (i + 1) * windowSize);
            for (let j = 0; j < scalars.length; j++) {
                const n = scalars[j];
                const curr = Number((n >> shiftBy) & MASK);
                if (!curr)
                    continue; // skip zero scalars chunks
                res = res.add(tables[j][curr - 1]);
            }
        }
        return res;
    };
}
function createField(order, field, isLE) {
    if (field) {
        if (field.ORDER !== order)
            throw new Error('Field.ORDER must match order: Fp == p, Fn == n');
        modular_validateField(field);
        return field;
    }
    else {
        return Field(order, { isLE });
    }
}
/** Validates CURVE opts and creates fields */
function createCurveFields(type, CURVE, curveOpts = {}, FpFnLE) {
    if (FpFnLE === undefined)
        FpFnLE = type === 'edwards';
    if (!CURVE || typeof CURVE !== 'object')
        throw new Error(`expected valid ${type} CURVE object`);
    for (const p of ['p', 'n', 'h']) {
        const val = CURVE[p];
        if (!(typeof val === 'bigint' && val > curve_0n))
            throw new Error(`CURVE.${p} must be positive bigint`);
    }
    const Fp = createField(CURVE.p, curveOpts.Fp, FpFnLE);
    const Fn = createField(CURVE.n, curveOpts.Fn, FpFnLE);
    const _b = type === 'weierstrass' ? 'b' : 'd';
    const params = ['Gx', 'Gy', 'a', _b];
    for (const p of params) {
        // @ts-ignore
        if (!Fp.isValid(CURVE[p]))
            throw new Error(`CURVE.${p} must be valid field element of CURVE.Fp`);
    }
    CURVE = Object.freeze(Object.assign({}, CURVE));
    return { CURVE, Fp, Fn };
}
function curve_createKeygen(randomSecretKey, getPublicKey) {
    return function keygen(seed) {
        const secretKey = randomSecretKey(seed);
        return { secretKey, publicKey: getPublicKey(secretKey) };
    };
}
//# sourceMappingURL=curve.js.map
;// ./node_modules/@noble/curves/abstract/weierstrass.js
/**
 * Short Weierstrass curve methods. The formula is: y² = x³ + ax + b.
 *
 * ### Design rationale for types
 *
 * * Interaction between classes from different curves should fail:
 *   `k256.Point.BASE.add(p256.Point.BASE)`
 * * For this purpose we want to use `instanceof` operator, which is fast and works during runtime
 * * Different calls of `curve()` would return different classes -
 *   `curve(params) !== curve(params)`: if somebody decided to monkey-patch their curve,
 *   it won't affect others
 *
 * TypeScript can't infer types for classes created inside a function. Classes is one instance
 * of nominative types in TypeScript and interfaces only check for shape, so it's hard to create
 * unique type for every function call.
 *
 * We can use generic types via some param, like curve opts, but that would:
 *     1. Enable interaction between `curve(params)` and `curve(params)` (curves of same params)
 *     which is hard to debug.
 *     2. Params can be generic and we can't enforce them to be constant value:
 *     if somebody creates curve from non-constant params,
 *     it would be allowed to interact with other curves with non-constant params
 *
 * @todo https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-7.html#unique-symbol
 * @module
 */
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */





// We construct basis in such way that den is always positive and equals n, but num sign depends on basis (not on secret value)
const divNearest = (num, den) => (num + (num >= 0 ? den : -den) / weierstrass_2n) / den;
/**
 * Splits scalar for GLV endomorphism.
 */
function _splitEndoScalar(k, basis, n) {
    // Split scalar into two such that part is ~half bits: `abs(part) < sqrt(N)`
    // Since part can be negative, we need to do this on point.
    // TODO: verifyScalar function which consumes lambda
    const [[a1, b1], [a2, b2]] = basis;
    const c1 = divNearest(b2 * k, n);
    const c2 = divNearest(-b1 * k, n);
    // |k1|/|k2| is < sqrt(N), but can be negative.
    // If we do `k1 mod N`, we'll get big scalar (`> sqrt(N)`): so, we do cheaper negation instead.
    let k1 = k - c1 * a1 - c2 * a2;
    let k2 = -c1 * b1 - c2 * b2;
    const k1neg = k1 < weierstrass_0n;
    const k2neg = k2 < weierstrass_0n;
    if (k1neg)
        k1 = -k1;
    if (k2neg)
        k2 = -k2;
    // Double check that resulting scalar less than half bits of N: otherwise wNAF will fail.
    // This should only happen on wrong basises. Also, math inside is too complex and I don't trust it.
    const MAX_NUM = utils_bitMask(Math.ceil(utils_bitLen(n) / 2)) + weierstrass_1n; // Half bits of N
    if (k1 < weierstrass_0n || k1 >= MAX_NUM || k2 < weierstrass_0n || k2 >= MAX_NUM) {
        throw new Error('splitScalar (endomorphism): failed, k=' + k);
    }
    return { k1neg, k1, k2neg, k2 };
}
function validateSigFormat(format) {
    if (!['compact', 'recovered', 'der'].includes(format))
        throw new Error('Signature format must be "compact", "recovered", or "der"');
    return format;
}
function validateSigOpts(opts, def) {
    const optsn = {};
    for (let optName of Object.keys(def)) {
        // @ts-ignore
        optsn[optName] = opts[optName] === undefined ? def[optName] : opts[optName];
    }
    abool(optsn.lowS, 'lowS');
    abool(optsn.prehash, 'prehash');
    if (optsn.format !== undefined)
        validateSigFormat(optsn.format);
    return optsn;
}
class DERErr extends Error {
    constructor(m = '') {
        super(m);
    }
}
/**
 * ASN.1 DER encoding utilities. ASN is very complex & fragile. Format:
 *
 *     [0x30 (SEQUENCE), bytelength, 0x02 (INTEGER), intLength, R, 0x02 (INTEGER), intLength, S]
 *
 * Docs: https://letsencrypt.org/docs/a-warm-welcome-to-asn1-and-der/, https://luca.ntop.org/Teaching/Appunti/asn1.html
 */
const DER = {
    // asn.1 DER encoding utils
    Err: DERErr,
    // Basic building block is TLV (Tag-Length-Value)
    _tlv: {
        encode: (tag, data) => {
            const { Err: E } = DER;
            if (tag < 0 || tag > 256)
                throw new E('tlv.encode: wrong tag');
            if (data.length & 1)
                throw new E('tlv.encode: unpadded data');
            const dataLen = data.length / 2;
            const len = numberToHexUnpadded(dataLen);
            if ((len.length / 2) & 0b1000_0000)
                throw new E('tlv.encode: long form length too big');
            // length of length with long form flag
            const lenLen = dataLen > 127 ? numberToHexUnpadded((len.length / 2) | 0b1000_0000) : '';
            const t = numberToHexUnpadded(tag);
            return t + lenLen + len + data;
        },
        // v - value, l - left bytes (unparsed)
        decode(tag, data) {
            const { Err: E } = DER;
            let pos = 0;
            if (tag < 0 || tag > 256)
                throw new E('tlv.encode: wrong tag');
            if (data.length < 2 || data[pos++] !== tag)
                throw new E('tlv.decode: wrong tlv');
            const first = data[pos++];
            const isLong = !!(first & 0b1000_0000); // First bit of first length byte is flag for short/long form
            let length = 0;
            if (!isLong)
                length = first;
            else {
                // Long form: [longFlag(1bit), lengthLength(7bit), length (BE)]
                const lenLen = first & 0b0111_1111;
                if (!lenLen)
                    throw new E('tlv.decode(long): indefinite length not supported');
                if (lenLen > 4)
                    throw new E('tlv.decode(long): byte length is too big'); // this will overflow u32 in js
                const lengthBytes = data.subarray(pos, pos + lenLen);
                if (lengthBytes.length !== lenLen)
                    throw new E('tlv.decode: length bytes not complete');
                if (lengthBytes[0] === 0)
                    throw new E('tlv.decode(long): zero leftmost byte');
                for (const b of lengthBytes)
                    length = (length << 8) | b;
                pos += lenLen;
                if (length < 128)
                    throw new E('tlv.decode(long): not minimal encoding');
            }
            const v = data.subarray(pos, pos + length);
            if (v.length !== length)
                throw new E('tlv.decode: wrong value length');
            return { v, l: data.subarray(pos + length) };
        },
    },
    // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
    // since we always use positive integers here. It must always be empty:
    // - add zero byte if exists
    // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
    _int: {
        encode(num) {
            const { Err: E } = DER;
            if (num < weierstrass_0n)
                throw new E('integer: negative integers are not allowed');
            let hex = numberToHexUnpadded(num);
            // Pad with zero byte if negative flag is present
            if (Number.parseInt(hex[0], 16) & 0b1000)
                hex = '00' + hex;
            if (hex.length & 1)
                throw new E('unexpected DER parsing assertion: unpadded hex');
            return hex;
        },
        decode(data) {
            const { Err: E } = DER;
            if (data[0] & 0b1000_0000)
                throw new E('invalid signature integer: negative');
            if (data[0] === 0x00 && !(data[1] & 0b1000_0000))
                throw new E('invalid signature integer: unnecessary leading zero');
            return utils_bytesToNumberBE(data);
        },
    },
    toSig(bytes) {
        // parse DER signature
        const { Err: E, _int: int, _tlv: tlv } = DER;
        const data = utils_abytes(bytes, undefined, 'signature');
        const { v: seqBytes, l: seqLeftBytes } = tlv.decode(0x30, data);
        if (seqLeftBytes.length)
            throw new E('invalid signature: left bytes after parsing');
        const { v: rBytes, l: rLeftBytes } = tlv.decode(0x02, seqBytes);
        const { v: sBytes, l: sLeftBytes } = tlv.decode(0x02, rLeftBytes);
        if (sLeftBytes.length)
            throw new E('invalid signature: left bytes after parsing');
        return { r: int.decode(rBytes), s: int.decode(sBytes) };
    },
    hexFromSig(sig) {
        const { _tlv: tlv, _int: int } = DER;
        const rs = tlv.encode(0x02, int.encode(sig.r));
        const ss = tlv.encode(0x02, int.encode(sig.s));
        const seq = rs + ss;
        return tlv.encode(0x30, seq);
    },
};
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const weierstrass_0n = BigInt(0), weierstrass_1n = BigInt(1), weierstrass_2n = BigInt(2), weierstrass_3n = BigInt(3), weierstrass_4n = BigInt(4);
/**
 * Creates weierstrass Point constructor, based on specified curve options.
 *
 * See {@link WeierstrassOpts}.
 *
 * @example
```js
const opts = {
  p: 0xfffffffffffffffffffffffffffffffeffffac73n,
  n: 0x100000000000000000001b8fa16dfab9aca16b6b3n,
  h: 1n,
  a: 0n,
  b: 7n,
  Gx: 0x3b4c382ce37aa192a4019e763036f4f5dd4d7ebbn,
  Gy: 0x938cf935318fdced6bc28286531733c3f03c4feen,
};
const secp160k1_Point = weierstrass(opts);
```
 */
function weierstrass(params, extraOpts = {}) {
    const validated = createCurveFields('weierstrass', params, extraOpts);
    const { Fp, Fn } = validated;
    let CURVE = validated.CURVE;
    const { h: cofactor, n: CURVE_ORDER } = CURVE;
    utils_validateObject(extraOpts, {}, {
        allowInfinityPoint: 'boolean',
        clearCofactor: 'function',
        isTorsionFree: 'function',
        fromBytes: 'function',
        toBytes: 'function',
        endo: 'object',
    });
    const { endo } = extraOpts;
    if (endo) {
        // validateObject(endo, { beta: 'bigint', splitScalar: 'function' });
        if (!Fp.is0(CURVE.a) || typeof endo.beta !== 'bigint' || !Array.isArray(endo.basises)) {
            throw new Error('invalid endo: expected "beta": bigint and "basises": array');
        }
    }
    const lengths = getWLengths(Fp, Fn);
    function assertCompressionIsSupported() {
        if (!Fp.isOdd)
            throw new Error('compression is not supported: Field does not have .isOdd()');
    }
    // Implements IEEE P1363 point encoding
    function pointToBytes(_c, point, isCompressed) {
        const { x, y } = point.toAffine();
        const bx = Fp.toBytes(x);
        utils_abool(isCompressed, 'isCompressed');
        if (isCompressed) {
            assertCompressionIsSupported();
            const hasEvenY = !Fp.isOdd(y);
            return utils_concatBytes(pprefix(hasEvenY), bx);
        }
        else {
            return utils_concatBytes(Uint8Array.of(0x04), bx, Fp.toBytes(y));
        }
    }
    function pointFromBytes(bytes) {
        utils_abytes(bytes, undefined, 'Point');
        const { publicKey: comp, publicKeyUncompressed: uncomp } = lengths; // e.g. for 32-byte: 33, 65
        const length = bytes.length;
        const head = bytes[0];
        const tail = bytes.subarray(1);
        // No actual validation is done here: use .assertValidity()
        if (length === comp && (head === 0x02 || head === 0x03)) {
            const x = Fp.fromBytes(tail);
            if (!Fp.isValid(x))
                throw new Error('bad point: is not on curve, wrong x');
            const y2 = weierstrassEquation(x); // y² = x³ + ax + b
            let y;
            try {
                y = Fp.sqrt(y2); // y = y² ^ (p+1)/4
            }
            catch (sqrtError) {
                const err = sqrtError instanceof Error ? ': ' + sqrtError.message : '';
                throw new Error('bad point: is not on curve, sqrt error' + err);
            }
            assertCompressionIsSupported();
            const evenY = Fp.isOdd(y);
            const evenH = (head & 1) === 1; // ECDSA-specific
            if (evenH !== evenY)
                y = Fp.neg(y);
            return { x, y };
        }
        else if (length === uncomp && head === 0x04) {
            // TODO: more checks
            const L = Fp.BYTES;
            const x = Fp.fromBytes(tail.subarray(0, L));
            const y = Fp.fromBytes(tail.subarray(L, L * 2));
            if (!isValidXY(x, y))
                throw new Error('bad point: is not on curve');
            return { x, y };
        }
        else {
            throw new Error(`bad point: got length ${length}, expected compressed=${comp} or uncompressed=${uncomp}`);
        }
    }
    const encodePoint = extraOpts.toBytes || pointToBytes;
    const decodePoint = extraOpts.fromBytes || pointFromBytes;
    function weierstrassEquation(x) {
        const x2 = Fp.sqr(x); // x * x
        const x3 = Fp.mul(x2, x); // x² * x
        return Fp.add(Fp.add(x3, Fp.mul(x, CURVE.a)), CURVE.b); // x³ + a * x + b
    }
    // TODO: move top-level
    /** Checks whether equation holds for given x, y: y² == x³ + ax + b */
    function isValidXY(x, y) {
        const left = Fp.sqr(y); // y²
        const right = weierstrassEquation(x); // x³ + ax + b
        return Fp.eql(left, right);
    }
    // Validate whether the passed curve params are valid.
    // Test 1: equation y² = x³ + ax + b should work for generator point.
    if (!isValidXY(CURVE.Gx, CURVE.Gy))
        throw new Error('bad curve params: generator point');
    // Test 2: discriminant Δ part should be non-zero: 4a³ + 27b² != 0.
    // Guarantees curve is genus-1, smooth (non-singular).
    const _4a3 = Fp.mul(Fp.pow(CURVE.a, weierstrass_3n), weierstrass_4n);
    const _27b2 = Fp.mul(Fp.sqr(CURVE.b), BigInt(27));
    if (Fp.is0(Fp.add(_4a3, _27b2)))
        throw new Error('bad curve params: a or b');
    /** Asserts coordinate is valid: 0 <= n < Fp.ORDER. */
    function acoord(title, n, banZero = false) {
        if (!Fp.isValid(n) || (banZero && Fp.is0(n)))
            throw new Error(`bad point coordinate ${title}`);
        return n;
    }
    function aprjpoint(other) {
        if (!(other instanceof Point))
            throw new Error('Weierstrass Point expected');
    }
    function splitEndoScalarN(k) {
        if (!endo || !endo.basises)
            throw new Error('no endo');
        return _splitEndoScalar(k, endo.basises, Fn.ORDER);
    }
    // Memoized toAffine / validity check. They are heavy. Points are immutable.
    // Converts Projective point to affine (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    // (X, Y, Z) ∋ (x=X/Z, y=Y/Z)
    const toAffineMemo = memoized((p, iz) => {
        const { X, Y, Z } = p;
        // Fast-path for normalized points
        if (Fp.eql(Z, Fp.ONE))
            return { x: X, y: Y };
        const is0 = p.is0();
        // If invZ was 0, we return zero point. However we still want to execute
        // all operations, so we replace invZ with a random number, 1.
        if (iz == null)
            iz = is0 ? Fp.ONE : Fp.inv(Z);
        const x = Fp.mul(X, iz);
        const y = Fp.mul(Y, iz);
        const zz = Fp.mul(Z, iz);
        if (is0)
            return { x: Fp.ZERO, y: Fp.ZERO };
        if (!Fp.eql(zz, Fp.ONE))
            throw new Error('invZ was invalid');
        return { x, y };
    });
    // NOTE: on exception this will crash 'cached' and no value will be set.
    // Otherwise true will be return
    const assertValidMemo = memoized((p) => {
        if (p.is0()) {
            // (0, 1, 0) aka ZERO is invalid in most contexts.
            // In BLS, ZERO can be serialized, so we allow it.
            // (0, 0, 0) is invalid representation of ZERO.
            if (extraOpts.allowInfinityPoint && !Fp.is0(p.Y))
                return;
            throw new Error('bad point: ZERO');
        }
        // Some 3rd-party test vectors require different wording between here & `fromCompressedHex`
        const { x, y } = p.toAffine();
        if (!Fp.isValid(x) || !Fp.isValid(y))
            throw new Error('bad point: x or y not field elements');
        if (!isValidXY(x, y))
            throw new Error('bad point: equation left != right');
        if (!p.isTorsionFree())
            throw new Error('bad point: not in prime-order subgroup');
        return true;
    });
    function finishEndo(endoBeta, k1p, k2p, k1neg, k2neg) {
        k2p = new Point(Fp.mul(k2p.X, endoBeta), k2p.Y, k2p.Z);
        k1p = negateCt(k1neg, k1p);
        k2p = negateCt(k2neg, k2p);
        return k1p.add(k2p);
    }
    /**
     * Projective Point works in 3d / projective (homogeneous) coordinates:(X, Y, Z) ∋ (x=X/Z, y=Y/Z).
     * Default Point works in 2d / affine coordinates: (x, y).
     * We're doing calculations in projective, because its operations don't require costly inversion.
     */
    class Point {
        // base / generator point
        static BASE = new Point(CURVE.Gx, CURVE.Gy, Fp.ONE);
        // zero / infinity / identity point
        static ZERO = new Point(Fp.ZERO, Fp.ONE, Fp.ZERO); // 0, 1, 0
        // math field
        static Fp = Fp;
        // scalar field
        static Fn = Fn;
        X;
        Y;
        Z;
        /** Does NOT validate if the point is valid. Use `.assertValidity()`. */
        constructor(X, Y, Z) {
            this.X = acoord('x', X);
            this.Y = acoord('y', Y, true);
            this.Z = acoord('z', Z);
            Object.freeze(this);
        }
        static CURVE() {
            return CURVE;
        }
        /** Does NOT validate if the point is valid. Use `.assertValidity()`. */
        static fromAffine(p) {
            const { x, y } = p || {};
            if (!p || !Fp.isValid(x) || !Fp.isValid(y))
                throw new Error('invalid affine point');
            if (p instanceof Point)
                throw new Error('projective point not allowed');
            // (0, 0) would've produced (0, 0, 1) - instead, we need (0, 1, 0)
            if (Fp.is0(x) && Fp.is0(y))
                return Point.ZERO;
            return new Point(x, y, Fp.ONE);
        }
        static fromBytes(bytes) {
            const P = Point.fromAffine(decodePoint(utils_abytes(bytes, undefined, 'point')));
            P.assertValidity();
            return P;
        }
        static fromHex(hex) {
            return Point.fromBytes(utils_hexToBytes(hex));
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        /**
         *
         * @param windowSize
         * @param isLazy true will defer table computation until the first multiplication
         * @returns
         */
        precompute(windowSize = 8, isLazy = true) {
            wnaf.createCache(this, windowSize);
            if (!isLazy)
                this.multiply(weierstrass_3n); // random number
            return this;
        }
        // TODO: return `this`
        /** A point on curve is valid if it conforms to equation. */
        assertValidity() {
            assertValidMemo(this);
        }
        hasEvenY() {
            const { y } = this.toAffine();
            if (!Fp.isOdd)
                throw new Error("Field doesn't support isOdd");
            return !Fp.isOdd(y);
        }
        /** Compare one point to another. */
        equals(other) {
            aprjpoint(other);
            const { X: X1, Y: Y1, Z: Z1 } = this;
            const { X: X2, Y: Y2, Z: Z2 } = other;
            const U1 = Fp.eql(Fp.mul(X1, Z2), Fp.mul(X2, Z1));
            const U2 = Fp.eql(Fp.mul(Y1, Z2), Fp.mul(Y2, Z1));
            return U1 && U2;
        }
        /** Flips point to one corresponding to (x, -y) in Affine coordinates. */
        negate() {
            return new Point(this.X, Fp.neg(this.Y), this.Z);
        }
        // Renes-Costello-Batina exception-free doubling formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 3
        // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
        double() {
            const { a, b } = CURVE;
            const b3 = Fp.mul(b, weierstrass_3n);
            const { X: X1, Y: Y1, Z: Z1 } = this;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            let t0 = Fp.mul(X1, X1); // step 1
            let t1 = Fp.mul(Y1, Y1);
            let t2 = Fp.mul(Z1, Z1);
            let t3 = Fp.mul(X1, Y1);
            t3 = Fp.add(t3, t3); // step 5
            Z3 = Fp.mul(X1, Z1);
            Z3 = Fp.add(Z3, Z3);
            X3 = Fp.mul(a, Z3);
            Y3 = Fp.mul(b3, t2);
            Y3 = Fp.add(X3, Y3); // step 10
            X3 = Fp.sub(t1, Y3);
            Y3 = Fp.add(t1, Y3);
            Y3 = Fp.mul(X3, Y3);
            X3 = Fp.mul(t3, X3);
            Z3 = Fp.mul(b3, Z3); // step 15
            t2 = Fp.mul(a, t2);
            t3 = Fp.sub(t0, t2);
            t3 = Fp.mul(a, t3);
            t3 = Fp.add(t3, Z3);
            Z3 = Fp.add(t0, t0); // step 20
            t0 = Fp.add(Z3, t0);
            t0 = Fp.add(t0, t2);
            t0 = Fp.mul(t0, t3);
            Y3 = Fp.add(Y3, t0);
            t2 = Fp.mul(Y1, Z1); // step 25
            t2 = Fp.add(t2, t2);
            t0 = Fp.mul(t2, t3);
            X3 = Fp.sub(X3, t0);
            Z3 = Fp.mul(t2, t1);
            Z3 = Fp.add(Z3, Z3); // step 30
            Z3 = Fp.add(Z3, Z3);
            return new Point(X3, Y3, Z3);
        }
        // Renes-Costello-Batina exception-free addition formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 1
        // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
        add(other) {
            aprjpoint(other);
            const { X: X1, Y: Y1, Z: Z1 } = this;
            const { X: X2, Y: Y2, Z: Z2 } = other;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            const a = CURVE.a;
            const b3 = Fp.mul(CURVE.b, weierstrass_3n);
            let t0 = Fp.mul(X1, X2); // step 1
            let t1 = Fp.mul(Y1, Y2);
            let t2 = Fp.mul(Z1, Z2);
            let t3 = Fp.add(X1, Y1);
            let t4 = Fp.add(X2, Y2); // step 5
            t3 = Fp.mul(t3, t4);
            t4 = Fp.add(t0, t1);
            t3 = Fp.sub(t3, t4);
            t4 = Fp.add(X1, Z1);
            let t5 = Fp.add(X2, Z2); // step 10
            t4 = Fp.mul(t4, t5);
            t5 = Fp.add(t0, t2);
            t4 = Fp.sub(t4, t5);
            t5 = Fp.add(Y1, Z1);
            X3 = Fp.add(Y2, Z2); // step 15
            t5 = Fp.mul(t5, X3);
            X3 = Fp.add(t1, t2);
            t5 = Fp.sub(t5, X3);
            Z3 = Fp.mul(a, t4);
            X3 = Fp.mul(b3, t2); // step 20
            Z3 = Fp.add(X3, Z3);
            X3 = Fp.sub(t1, Z3);
            Z3 = Fp.add(t1, Z3);
            Y3 = Fp.mul(X3, Z3);
            t1 = Fp.add(t0, t0); // step 25
            t1 = Fp.add(t1, t0);
            t2 = Fp.mul(a, t2);
            t4 = Fp.mul(b3, t4);
            t1 = Fp.add(t1, t2);
            t2 = Fp.sub(t0, t2); // step 30
            t2 = Fp.mul(a, t2);
            t4 = Fp.add(t4, t2);
            t0 = Fp.mul(t1, t4);
            Y3 = Fp.add(Y3, t0);
            t0 = Fp.mul(t5, t4); // step 35
            X3 = Fp.mul(t3, X3);
            X3 = Fp.sub(X3, t0);
            t0 = Fp.mul(t3, t1);
            Z3 = Fp.mul(t5, Z3);
            Z3 = Fp.add(Z3, t0); // step 40
            return new Point(X3, Y3, Z3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        /**
         * Constant time multiplication.
         * Uses wNAF method. Windowed method may be 10% faster,
         * but takes 2x longer to generate and consumes 2x memory.
         * Uses precomputes when available.
         * Uses endomorphism for Koblitz curves.
         * @param scalar by which the point would be multiplied
         * @returns New point
         */
        multiply(scalar) {
            const { endo } = extraOpts;
            if (!Fn.isValidNot0(scalar))
                throw new Error('invalid scalar: out of range'); // 0 is invalid
            let point, fake; // Fake point is used to const-time mult
            const mul = (n) => wnaf.cached(this, n, (p) => normalizeZ(Point, p));
            /** See docs for {@link EndomorphismOpts} */
            if (endo) {
                const { k1neg, k1, k2neg, k2 } = splitEndoScalarN(scalar);
                const { p: k1p, f: k1f } = mul(k1);
                const { p: k2p, f: k2f } = mul(k2);
                fake = k1f.add(k2f);
                point = finishEndo(endo.beta, k1p, k2p, k1neg, k2neg);
            }
            else {
                const { p, f } = mul(scalar);
                point = p;
                fake = f;
            }
            // Normalize `z` for both points, but return only real one
            return normalizeZ(Point, [point, fake])[0];
        }
        /**
         * Non-constant-time multiplication. Uses double-and-add algorithm.
         * It's faster, but should only be used when you don't care about
         * an exposed secret key e.g. sig verification, which works over *public* keys.
         */
        multiplyUnsafe(sc) {
            const { endo } = extraOpts;
            const p = this;
            if (!Fn.isValid(sc))
                throw new Error('invalid scalar: out of range'); // 0 is valid
            if (sc === weierstrass_0n || p.is0())
                return Point.ZERO; // 0
            if (sc === weierstrass_1n)
                return p; // 1
            if (wnaf.hasCache(this))
                return this.multiply(sc); // precomputes
            // We don't have method for double scalar multiplication (aP + bQ):
            // Even with using Strauss-Shamir trick, it's 35% slower than naïve mul+add.
            if (endo) {
                const { k1neg, k1, k2neg, k2 } = splitEndoScalarN(sc);
                const { p1, p2 } = mulEndoUnsafe(Point, p, k1, k2); // 30% faster vs wnaf.unsafe
                return finishEndo(endo.beta, p1, p2, k1neg, k2neg);
            }
            else {
                return wnaf.unsafe(p, sc);
            }
        }
        /**
         * Converts Projective point to affine (x, y) coordinates.
         * @param invertedZ Z^-1 (inverted zero) - optional, precomputation is useful for invertBatch
         */
        toAffine(invertedZ) {
            return toAffineMemo(this, invertedZ);
        }
        /**
         * Checks whether Point is free of torsion elements (is in prime subgroup).
         * Always torsion-free for cofactor=1 curves.
         */
        isTorsionFree() {
            const { isTorsionFree } = extraOpts;
            if (cofactor === weierstrass_1n)
                return true;
            if (isTorsionFree)
                return isTorsionFree(Point, this);
            return wnaf.unsafe(this, CURVE_ORDER).is0();
        }
        clearCofactor() {
            const { clearCofactor } = extraOpts;
            if (cofactor === weierstrass_1n)
                return this; // Fast-path
            if (clearCofactor)
                return clearCofactor(Point, this);
            return this.multiplyUnsafe(cofactor);
        }
        isSmallOrder() {
            // can we use this.clearCofactor()?
            return this.multiplyUnsafe(cofactor).is0();
        }
        toBytes(isCompressed = true) {
            utils_abool(isCompressed, 'isCompressed');
            this.assertValidity();
            return encodePoint(Point, this, isCompressed);
        }
        toHex(isCompressed = true) {
            return utils_bytesToHex(this.toBytes(isCompressed));
        }
        toString() {
            return `<Point ${this.is0() ? 'ZERO' : this.toHex()}>`;
        }
    }
    const bits = Fn.BITS;
    const wnaf = new wNAF(Point, extraOpts.endo ? Math.ceil(bits / 2) : bits);
    Point.BASE.precompute(8); // Enable precomputes. Slows down first publicKey computation by 20ms.
    return Point;
}
// Points start with byte 0x02 when y is even; otherwise 0x03
function pprefix(hasEvenY) {
    return Uint8Array.of(hasEvenY ? 0x02 : 0x03);
}
/**
 * Implementation of the Shallue and van de Woestijne method for any weierstrass curve.
 * TODO: check if there is a way to merge this with uvRatio in Edwards; move to modular.
 * b = True and y = sqrt(u / v) if (u / v) is square in F, and
 * b = False and y = sqrt(Z * (u / v)) otherwise.
 * @param Fp
 * @param Z
 * @returns
 */
function SWUFpSqrtRatio(Fp, Z) {
    // Generic implementation
    const q = Fp.ORDER;
    let l = weierstrass_0n;
    for (let o = q - weierstrass_1n; o % weierstrass_2n === weierstrass_0n; o /= weierstrass_2n)
        l += weierstrass_1n;
    const c1 = l; // 1. c1, the largest integer such that 2^c1 divides q - 1.
    // We need 2n ** c1 and 2n ** (c1-1). We can't use **; but we can use <<.
    // 2n ** c1 == 2n << (c1-1)
    const _2n_pow_c1_1 = weierstrass_2n << (c1 - weierstrass_1n - weierstrass_1n);
    const _2n_pow_c1 = _2n_pow_c1_1 * weierstrass_2n;
    const c2 = (q - weierstrass_1n) / _2n_pow_c1; // 2. c2 = (q - 1) / (2^c1)  # Integer arithmetic
    const c3 = (c2 - weierstrass_1n) / weierstrass_2n; // 3. c3 = (c2 - 1) / 2            # Integer arithmetic
    const c4 = _2n_pow_c1 - weierstrass_1n; // 4. c4 = 2^c1 - 1                # Integer arithmetic
    const c5 = _2n_pow_c1_1; // 5. c5 = 2^(c1 - 1)                  # Integer arithmetic
    const c6 = Fp.pow(Z, c2); // 6. c6 = Z^c2
    const c7 = Fp.pow(Z, (c2 + weierstrass_1n) / weierstrass_2n); // 7. c7 = Z^((c2 + 1) / 2)
    let sqrtRatio = (u, v) => {
        let tv1 = c6; // 1. tv1 = c6
        let tv2 = Fp.pow(v, c4); // 2. tv2 = v^c4
        let tv3 = Fp.sqr(tv2); // 3. tv3 = tv2^2
        tv3 = Fp.mul(tv3, v); // 4. tv3 = tv3 * v
        let tv5 = Fp.mul(u, tv3); // 5. tv5 = u * tv3
        tv5 = Fp.pow(tv5, c3); // 6. tv5 = tv5^c3
        tv5 = Fp.mul(tv5, tv2); // 7. tv5 = tv5 * tv2
        tv2 = Fp.mul(tv5, v); // 8. tv2 = tv5 * v
        tv3 = Fp.mul(tv5, u); // 9. tv3 = tv5 * u
        let tv4 = Fp.mul(tv3, tv2); // 10. tv4 = tv3 * tv2
        tv5 = Fp.pow(tv4, c5); // 11. tv5 = tv4^c5
        let isQR = Fp.eql(tv5, Fp.ONE); // 12. isQR = tv5 == 1
        tv2 = Fp.mul(tv3, c7); // 13. tv2 = tv3 * c7
        tv5 = Fp.mul(tv4, tv1); // 14. tv5 = tv4 * tv1
        tv3 = Fp.cmov(tv2, tv3, isQR); // 15. tv3 = CMOV(tv2, tv3, isQR)
        tv4 = Fp.cmov(tv5, tv4, isQR); // 16. tv4 = CMOV(tv5, tv4, isQR)
        // 17. for i in (c1, c1 - 1, ..., 2):
        for (let i = c1; i > weierstrass_1n; i--) {
            let tv5 = i - weierstrass_2n; // 18.    tv5 = i - 2
            tv5 = weierstrass_2n << (tv5 - weierstrass_1n); // 19.    tv5 = 2^tv5
            let tvv5 = Fp.pow(tv4, tv5); // 20.    tv5 = tv4^tv5
            const e1 = Fp.eql(tvv5, Fp.ONE); // 21.    e1 = tv5 == 1
            tv2 = Fp.mul(tv3, tv1); // 22.    tv2 = tv3 * tv1
            tv1 = Fp.mul(tv1, tv1); // 23.    tv1 = tv1 * tv1
            tvv5 = Fp.mul(tv4, tv1); // 24.    tv5 = tv4 * tv1
            tv3 = Fp.cmov(tv2, tv3, e1); // 25.    tv3 = CMOV(tv2, tv3, e1)
            tv4 = Fp.cmov(tvv5, tv4, e1); // 26.    tv4 = CMOV(tv5, tv4, e1)
        }
        return { isValid: isQR, value: tv3 };
    };
    if (Fp.ORDER % weierstrass_4n === weierstrass_3n) {
        // sqrt_ratio_3mod4(u, v)
        const c1 = (Fp.ORDER - weierstrass_3n) / weierstrass_4n; // 1. c1 = (q - 3) / 4     # Integer arithmetic
        const c2 = Fp.sqrt(Fp.neg(Z)); // 2. c2 = sqrt(-Z)
        sqrtRatio = (u, v) => {
            let tv1 = Fp.sqr(v); // 1. tv1 = v^2
            const tv2 = Fp.mul(u, v); // 2. tv2 = u * v
            tv1 = Fp.mul(tv1, tv2); // 3. tv1 = tv1 * tv2
            let y1 = Fp.pow(tv1, c1); // 4. y1 = tv1^c1
            y1 = Fp.mul(y1, tv2); // 5. y1 = y1 * tv2
            const y2 = Fp.mul(y1, c2); // 6. y2 = y1 * c2
            const tv3 = Fp.mul(Fp.sqr(y1), v); // 7. tv3 = y1^2; 8. tv3 = tv3 * v
            const isQR = Fp.eql(tv3, u); // 9. isQR = tv3 == u
            let y = Fp.cmov(y2, y1, isQR); // 10. y = CMOV(y2, y1, isQR)
            return { isValid: isQR, value: y }; // 11. return (isQR, y) isQR ? y : y*c2
        };
    }
    // No curves uses that
    // if (Fp.ORDER % _8n === _5n) // sqrt_ratio_5mod8
    return sqrtRatio;
}
/**
 * Simplified Shallue-van de Woestijne-Ulas Method
 * https://www.rfc-editor.org/rfc/rfc9380#section-6.6.2
 */
function weierstrass_mapToCurveSimpleSWU(Fp, opts) {
    validateField(Fp);
    const { A, B, Z } = opts;
    if (!Fp.isValid(A) || !Fp.isValid(B) || !Fp.isValid(Z))
        throw new Error('mapToCurveSimpleSWU: invalid opts');
    const sqrtRatio = SWUFpSqrtRatio(Fp, Z);
    if (!Fp.isOdd)
        throw new Error('Field does not have .isOdd()');
    // Input: u, an element of F.
    // Output: (x, y), a point on E.
    return (u) => {
        // prettier-ignore
        let tv1, tv2, tv3, tv4, tv5, tv6, x, y;
        tv1 = Fp.sqr(u); // 1.  tv1 = u^2
        tv1 = Fp.mul(tv1, Z); // 2.  tv1 = Z * tv1
        tv2 = Fp.sqr(tv1); // 3.  tv2 = tv1^2
        tv2 = Fp.add(tv2, tv1); // 4.  tv2 = tv2 + tv1
        tv3 = Fp.add(tv2, Fp.ONE); // 5.  tv3 = tv2 + 1
        tv3 = Fp.mul(tv3, B); // 6.  tv3 = B * tv3
        tv4 = Fp.cmov(Z, Fp.neg(tv2), !Fp.eql(tv2, Fp.ZERO)); // 7.  tv4 = CMOV(Z, -tv2, tv2 != 0)
        tv4 = Fp.mul(tv4, A); // 8.  tv4 = A * tv4
        tv2 = Fp.sqr(tv3); // 9.  tv2 = tv3^2
        tv6 = Fp.sqr(tv4); // 10. tv6 = tv4^2
        tv5 = Fp.mul(tv6, A); // 11. tv5 = A * tv6
        tv2 = Fp.add(tv2, tv5); // 12. tv2 = tv2 + tv5
        tv2 = Fp.mul(tv2, tv3); // 13. tv2 = tv2 * tv3
        tv6 = Fp.mul(tv6, tv4); // 14. tv6 = tv6 * tv4
        tv5 = Fp.mul(tv6, B); // 15. tv5 = B * tv6
        tv2 = Fp.add(tv2, tv5); // 16. tv2 = tv2 + tv5
        x = Fp.mul(tv1, tv3); // 17.   x = tv1 * tv3
        const { isValid, value } = sqrtRatio(tv2, tv6); // 18. (is_gx1_square, y1) = sqrt_ratio(tv2, tv6)
        y = Fp.mul(tv1, u); // 19.   y = tv1 * u  -> Z * u^3 * y1
        y = Fp.mul(y, value); // 20.   y = y * y1
        x = Fp.cmov(x, tv3, isValid); // 21.   x = CMOV(x, tv3, is_gx1_square)
        y = Fp.cmov(y, value, isValid); // 22.   y = CMOV(y, y1, is_gx1_square)
        const e1 = Fp.isOdd(u) === Fp.isOdd(y); // 23.  e1 = sgn0(u) == sgn0(y)
        y = Fp.cmov(Fp.neg(y), y, e1); // 24.   y = CMOV(-y, y, e1)
        const tv4_inv = FpInvertBatch(Fp, [tv4], true)[0];
        x = Fp.mul(x, tv4_inv); // 25.   x = x / tv4
        return { x, y };
    };
}
function getWLengths(Fp, Fn) {
    return {
        secretKey: Fn.BYTES,
        publicKey: 1 + Fp.BYTES,
        publicKeyUncompressed: 1 + 2 * Fp.BYTES,
        publicKeyHasPrefix: true,
        signature: 2 * Fn.BYTES,
    };
}
/**
 * Sometimes users only need getPublicKey, getSharedSecret, and secret key handling.
 * This helper ensures no signature functionality is present. Less code, smaller bundle size.
 */
function ecdh(Point, ecdhOpts = {}) {
    const { Fn } = Point;
    const randomBytes_ = ecdhOpts.randomBytes || wcRandomBytes;
    const lengths = Object.assign(getWLengths(Point.Fp, Fn), { seed: getMinHashLength(Fn.ORDER) });
    function isValidSecretKey(secretKey) {
        try {
            const num = Fn.fromBytes(secretKey);
            return Fn.isValidNot0(num);
        }
        catch (error) {
            return false;
        }
    }
    function isValidPublicKey(publicKey, isCompressed) {
        const { publicKey: comp, publicKeyUncompressed } = lengths;
        try {
            const l = publicKey.length;
            if (isCompressed === true && l !== comp)
                return false;
            if (isCompressed === false && l !== publicKeyUncompressed)
                return false;
            return !!Point.fromBytes(publicKey);
        }
        catch (error) {
            return false;
        }
    }
    /**
     * Produces cryptographically secure secret key from random of size
     * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
     */
    function randomSecretKey(seed = randomBytes_(lengths.seed)) {
        return mapHashToField(abytes(seed, lengths.seed, 'seed'), Fn.ORDER);
    }
    /**
     * Computes public key for a secret key. Checks for validity of the secret key.
     * @param isCompressed whether to return compact (default), or full key
     * @returns Public key, full when isCompressed=false; short when isCompressed=true
     */
    function getPublicKey(secretKey, isCompressed = true) {
        return Point.BASE.multiply(Fn.fromBytes(secretKey)).toBytes(isCompressed);
    }
    /**
     * Quick and dirty check for item being public key. Does not validate hex, or being on-curve.
     */
    function isProbPub(item) {
        const { secretKey, publicKey, publicKeyUncompressed } = lengths;
        if (!isBytes(item))
            return undefined;
        if (('_lengths' in Fn && Fn._lengths) || secretKey === publicKey)
            return undefined;
        const l = abytes(item, undefined, 'key').length;
        return l === publicKey || l === publicKeyUncompressed;
    }
    /**
     * ECDH (Elliptic Curve Diffie Hellman).
     * Computes shared public key from secret key A and public key B.
     * Checks: 1) secret key validity 2) shared key is on-curve.
     * Does NOT hash the result.
     * @param isCompressed whether to return compact (default), or full key
     * @returns shared public key
     */
    function getSharedSecret(secretKeyA, publicKeyB, isCompressed = true) {
        if (isProbPub(secretKeyA) === true)
            throw new Error('first arg must be private key');
        if (isProbPub(publicKeyB) === false)
            throw new Error('second arg must be public key');
        const s = Fn.fromBytes(secretKeyA);
        const b = Point.fromBytes(publicKeyB); // checks for being on-curve
        return b.multiply(s).toBytes(isCompressed);
    }
    const utils = {
        isValidSecretKey,
        isValidPublicKey,
        randomSecretKey,
    };
    const keygen = createKeygen(randomSecretKey, getPublicKey);
    return Object.freeze({ getPublicKey, getSharedSecret, keygen, Point, utils, lengths });
}
/**
 * Creates ECDSA signing interface for given elliptic curve `Point` and `hash` function.
 *
 * @param Point created using {@link weierstrass} function
 * @param hash used for 1) message prehash-ing 2) k generation in `sign`, using hmac_drbg(hash)
 * @param ecdsaOpts rarely needed, see {@link ECDSAOpts}
 *
 * @example
 * ```js
 * const p256_Point = weierstrass(...);
 * const p256_sha256 = ecdsa(p256_Point, sha256);
 * const p256_sha224 = ecdsa(p256_Point, sha224);
 * const p256_sha224_r = ecdsa(p256_Point, sha224, { randomBytes: (length) => { ... } });
 * ```
 */
function weierstrass_ecdsa(Point, hash, ecdsaOpts = {}) {
    ahash(hash);
    validateObject(ecdsaOpts, {}, {
        hmac: 'function',
        lowS: 'boolean',
        randomBytes: 'function',
        bits2int: 'function',
        bits2int_modN: 'function',
    });
    ecdsaOpts = Object.assign({}, ecdsaOpts);
    const randomBytes = ecdsaOpts.randomBytes || wcRandomBytes;
    const hmac = ecdsaOpts.hmac || ((key, msg) => nobleHmac(hash, key, msg));
    const { Fp, Fn } = Point;
    const { ORDER: CURVE_ORDER, BITS: fnBits } = Fn;
    const { keygen, getPublicKey, getSharedSecret, utils, lengths } = ecdh(Point, ecdsaOpts);
    const defaultSigOpts = {
        prehash: true,
        lowS: typeof ecdsaOpts.lowS === 'boolean' ? ecdsaOpts.lowS : true,
        format: 'compact',
        extraEntropy: false,
    };
    const hasLargeCofactor = CURVE_ORDER * weierstrass_2n < Fp.ORDER; // Won't CURVE().h > 2n be more effective?
    function isBiggerThanHalfOrder(number) {
        const HALF = CURVE_ORDER >> weierstrass_1n;
        return number > HALF;
    }
    function validateRS(title, num) {
        if (!Fn.isValidNot0(num))
            throw new Error(`invalid signature ${title}: out of range 1..Point.Fn.ORDER`);
        return num;
    }
    function assertSmallCofactor() {
        // ECDSA recovery is hard for cofactor > 1 curves.
        // In sign, `r = q.x mod n`, and here we recover q.x from r.
        // While recovering q.x >= n, we need to add r+n for cofactor=1 curves.
        // However, for cofactor>1, r+n may not get q.x:
        // r+n*i would need to be done instead where i is unknown.
        // To easily get i, we either need to:
        // a. increase amount of valid recid values (4, 5...); OR
        // b. prohibit non-prime-order signatures (recid > 1).
        if (hasLargeCofactor)
            throw new Error('"recovered" sig type is not supported for cofactor >2 curves');
    }
    function validateSigLength(bytes, format) {
        validateSigFormat(format);
        const size = lengths.signature;
        const sizer = format === 'compact' ? size : format === 'recovered' ? size + 1 : undefined;
        return abytes(bytes, sizer);
    }
    /**
     * ECDSA signature with its (r, s) properties. Supports compact, recovered & DER representations.
     */
    class Signature {
        r;
        s;
        recovery;
        constructor(r, s, recovery) {
            this.r = validateRS('r', r); // r in [1..N-1];
            this.s = validateRS('s', s); // s in [1..N-1];
            if (recovery != null) {
                assertSmallCofactor();
                if (![0, 1, 2, 3].includes(recovery))
                    throw new Error('invalid recovery id');
                this.recovery = recovery;
            }
            Object.freeze(this);
        }
        static fromBytes(bytes, format = defaultSigOpts.format) {
            validateSigLength(bytes, format);
            let recid;
            if (format === 'der') {
                const { r, s } = DER.toSig(abytes(bytes));
                return new Signature(r, s);
            }
            if (format === 'recovered') {
                recid = bytes[0];
                format = 'compact';
                bytes = bytes.subarray(1);
            }
            const L = lengths.signature / 2;
            const r = bytes.subarray(0, L);
            const s = bytes.subarray(L, L * 2);
            return new Signature(Fn.fromBytes(r), Fn.fromBytes(s), recid);
        }
        static fromHex(hex, format) {
            return this.fromBytes(hexToBytes(hex), format);
        }
        assertRecovery() {
            const { recovery } = this;
            if (recovery == null)
                throw new Error('invalid recovery id: must be present');
            return recovery;
        }
        addRecoveryBit(recovery) {
            return new Signature(this.r, this.s, recovery);
        }
        recoverPublicKey(messageHash) {
            const { r, s } = this;
            const recovery = this.assertRecovery();
            const radj = recovery === 2 || recovery === 3 ? r + CURVE_ORDER : r;
            if (!Fp.isValid(radj))
                throw new Error('invalid recovery id: sig.r+curve.n != R.x');
            const x = Fp.toBytes(radj);
            const R = Point.fromBytes(concatBytes(pprefix((recovery & 1) === 0), x));
            const ir = Fn.inv(radj); // r^-1
            const h = bits2int_modN(abytes(messageHash, undefined, 'msgHash')); // Truncate hash
            const u1 = Fn.create(-h * ir); // -hr^-1
            const u2 = Fn.create(s * ir); // sr^-1
            // (sr^-1)R-(hr^-1)G = -(hr^-1)G + (sr^-1). unsafe is fine: there is no private data.
            const Q = Point.BASE.multiplyUnsafe(u1).add(R.multiplyUnsafe(u2));
            if (Q.is0())
                throw new Error('invalid recovery: point at infinify');
            Q.assertValidity();
            return Q;
        }
        // Signatures should be low-s, to prevent malleability.
        hasHighS() {
            return isBiggerThanHalfOrder(this.s);
        }
        toBytes(format = defaultSigOpts.format) {
            validateSigFormat(format);
            if (format === 'der')
                return hexToBytes(DER.hexFromSig(this));
            const { r, s } = this;
            const rb = Fn.toBytes(r);
            const sb = Fn.toBytes(s);
            if (format === 'recovered') {
                assertSmallCofactor();
                return concatBytes(Uint8Array.of(this.assertRecovery()), rb, sb);
            }
            return concatBytes(rb, sb);
        }
        toHex(format) {
            return bytesToHex(this.toBytes(format));
        }
    }
    // RFC6979: ensure ECDSA msg is X bytes and < N. RFC suggests optional truncating via bits2octets.
    // FIPS 186-4 4.6 suggests the leftmost min(nBitLen, outLen) bits, which matches bits2int.
    // bits2int can produce res>N, we can do mod(res, N) since the bitLen is the same.
    // int2octets can't be used; pads small msgs with 0: unacceptatble for trunc as per RFC vectors
    const bits2int = ecdsaOpts.bits2int ||
        function bits2int_def(bytes) {
            // Our custom check "just in case", for protection against DoS
            if (bytes.length > 8192)
                throw new Error('input is too large');
            // For curves with nBitLength % 8 !== 0: bits2octets(bits2octets(m)) !== bits2octets(m)
            // for some cases, since bytes.length * 8 is not actual bitLength.
            const num = bytesToNumberBE(bytes); // check for == u8 done here
            const delta = bytes.length * 8 - fnBits; // truncate to nBitLength leftmost bits
            return delta > 0 ? num >> BigInt(delta) : num;
        };
    const bits2int_modN = ecdsaOpts.bits2int_modN ||
        function bits2int_modN_def(bytes) {
            return Fn.create(bits2int(bytes)); // can't use bytesToNumberBE here
        };
    // Pads output with zero as per spec
    const ORDER_MASK = bitMask(fnBits);
    /** Converts to bytes. Checks if num in `[0..ORDER_MASK-1]` e.g.: `[0..2^256-1]`. */
    function int2octets(num) {
        // IMPORTANT: the check ensures working for case `Fn.BYTES != Fn.BITS * 8`
        aInRange('num < 2^' + fnBits, num, weierstrass_0n, ORDER_MASK);
        return Fn.toBytes(num);
    }
    function validateMsgAndHash(message, prehash) {
        abytes(message, undefined, 'message');
        return prehash ? abytes(hash(message), undefined, 'prehashed message') : message;
    }
    /**
     * Steps A, D of RFC6979 3.2.
     * Creates RFC6979 seed; converts msg/privKey to numbers.
     * Used only in sign, not in verify.
     *
     * Warning: we cannot assume here that message has same amount of bytes as curve order,
     * this will be invalid at least for P521. Also it can be bigger for P224 + SHA256.
     */
    function prepSig(message, secretKey, opts) {
        const { lowS, prehash, extraEntropy } = validateSigOpts(opts, defaultSigOpts);
        message = validateMsgAndHash(message, prehash); // RFC6979 3.2 A: h1 = H(m)
        // We can't later call bits2octets, since nested bits2int is broken for curves
        // with fnBits % 8 !== 0. Because of that, we unwrap it here as int2octets call.
        // const bits2octets = (bits) => int2octets(bits2int_modN(bits))
        const h1int = bits2int_modN(message);
        const d = Fn.fromBytes(secretKey); // validate secret key, convert to bigint
        if (!Fn.isValidNot0(d))
            throw new Error('invalid private key');
        const seedArgs = [int2octets(d), int2octets(h1int)];
        // extraEntropy. RFC6979 3.6: additional k' (optional).
        if (extraEntropy != null && extraEntropy !== false) {
            // K = HMAC_K(V || 0x00 || int2octets(x) || bits2octets(h1) || k')
            // gen random bytes OR pass as-is
            const e = extraEntropy === true ? randomBytes(lengths.secretKey) : extraEntropy;
            seedArgs.push(abytes(e, undefined, 'extraEntropy')); // check for being bytes
        }
        const seed = concatBytes(...seedArgs); // Step D of RFC6979 3.2
        const m = h1int; // no need to call bits2int second time here, it is inside truncateHash!
        // Converts signature params into point w r/s, checks result for validity.
        // To transform k => Signature:
        // q = k⋅G
        // r = q.x mod n
        // s = k^-1(m + rd) mod n
        // Can use scalar blinding b^-1(bm + bdr) where b ∈ [1,q−1] according to
        // https://tches.iacr.org/index.php/TCHES/article/view/7337/6509. We've decided against it:
        // a) dependency on CSPRNG b) 15% slowdown c) doesn't really help since bigints are not CT
        function k2sig(kBytes) {
            // RFC 6979 Section 3.2, step 3: k = bits2int(T)
            // Important: all mod() calls here must be done over N
            const k = bits2int(kBytes); // Cannot use fields methods, since it is group element
            if (!Fn.isValidNot0(k))
                return; // Valid scalars (including k) must be in 1..N-1
            const ik = Fn.inv(k); // k^-1 mod n
            const q = Point.BASE.multiply(k).toAffine(); // q = k⋅G
            const r = Fn.create(q.x); // r = q.x mod n
            if (r === weierstrass_0n)
                return;
            const s = Fn.create(ik * Fn.create(m + r * d)); // s = k^-1(m + rd) mod n
            if (s === weierstrass_0n)
                return;
            let recovery = (q.x === r ? 0 : 2) | Number(q.y & weierstrass_1n); // recovery bit (2 or 3 when q.x>n)
            let normS = s;
            if (lowS && isBiggerThanHalfOrder(s)) {
                normS = Fn.neg(s); // if lowS was passed, ensure s is always in the bottom half of N
                recovery ^= 1;
            }
            return new Signature(r, normS, hasLargeCofactor ? undefined : recovery);
        }
        return { seed, k2sig };
    }
    /**
     * Signs message hash with a secret key.
     *
     * ```
     * sign(m, d) where
     *   k = rfc6979_hmac_drbg(m, d)
     *   (x, y) = G × k
     *   r = x mod n
     *   s = (m + dr) / k mod n
     * ```
     */
    function sign(message, secretKey, opts = {}) {
        const { seed, k2sig } = prepSig(message, secretKey, opts); // Steps A, D of RFC6979 3.2.
        const drbg = createHmacDrbg(hash.outputLen, Fn.BYTES, hmac);
        const sig = drbg(seed, k2sig); // Steps B, C, D, E, F, G
        return sig.toBytes(opts.format);
    }
    /**
     * Verifies a signature against message and public key.
     * Rejects lowS signatures by default: see {@link ECDSAVerifyOpts}.
     * Implements section 4.1.4 from https://www.secg.org/sec1-v2.pdf:
     *
     * ```
     * verify(r, s, h, P) where
     *   u1 = hs^-1 mod n
     *   u2 = rs^-1 mod n
     *   R = u1⋅G + u2⋅P
     *   mod(R.x, n) == r
     * ```
     */
    function verify(signature, message, publicKey, opts = {}) {
        const { lowS, prehash, format } = validateSigOpts(opts, defaultSigOpts);
        publicKey = abytes(publicKey, undefined, 'publicKey');
        message = validateMsgAndHash(message, prehash);
        if (!isBytes(signature)) {
            const end = signature instanceof Signature ? ', use sig.toBytes()' : '';
            throw new Error('verify expects Uint8Array signature' + end);
        }
        validateSigLength(signature, format); // execute this twice because we want loud error
        try {
            const sig = Signature.fromBytes(signature, format);
            const P = Point.fromBytes(publicKey);
            if (lowS && sig.hasHighS())
                return false;
            const { r, s } = sig;
            const h = bits2int_modN(message); // mod n, not mod p
            const is = Fn.inv(s); // s^-1 mod n
            const u1 = Fn.create(h * is); // u1 = hs^-1 mod n
            const u2 = Fn.create(r * is); // u2 = rs^-1 mod n
            const R = Point.BASE.multiplyUnsafe(u1).add(P.multiplyUnsafe(u2)); // u1⋅G + u2⋅P
            if (R.is0())
                return false;
            const v = Fn.create(R.x); // v = r.x mod n
            return v === r;
        }
        catch (e) {
            return false;
        }
    }
    function recoverPublicKey(signature, message, opts = {}) {
        const { prehash } = validateSigOpts(opts, defaultSigOpts);
        message = validateMsgAndHash(message, prehash);
        return Signature.fromBytes(signature, 'recovered').recoverPublicKey(message).toBytes();
    }
    return Object.freeze({
        keygen,
        getPublicKey,
        getSharedSecret,
        utils,
        lengths,
        Point,
        sign,
        verify,
        recoverPublicKey,
        Signature,
        hash,
    });
}
//# sourceMappingURL=weierstrass.js.map
;// ./node_modules/@noble/curves/secp256k1.js
/**
 * SECG secp256k1. See [pdf](https://www.secg.org/sec2-v2.pdf).
 *
 * Belongs to Koblitz curves: it has efficiently-computable GLV endomorphism ψ,
 * check out {@link EndomorphismOpts}. Seems to be rigid (not backdoored).
 * @module
 */
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */







// Seems like generator was produced from some seed:
// `Pointk1.BASE.multiply(Pointk1.Fn.inv(2n, N)).toAffine().x`
// // gives short x 0x3b78ce563f89a0ed9414f5aa28ad0d96d6795f9c63n
const secp256k1_CURVE = {
    p: BigInt('0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f'),
    n: BigInt('0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141'),
    h: BigInt(1),
    a: BigInt(0),
    b: BigInt(7),
    Gx: BigInt('0x79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798'),
    Gy: BigInt('0x483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8'),
};
const secp256k1_ENDO = {
    beta: BigInt('0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee'),
    basises: [
        [BigInt('0x3086d221a7d46bcde86c90e49284eb15'), -BigInt('0xe4437ed6010e88286f547fa90abfe4c3')],
        [BigInt('0x114ca50f7a8e2f3f657c1108d9d44cfd8'), BigInt('0x3086d221a7d46bcde86c90e49284eb15')],
    ],
};
const secp256k1_0n = /* @__PURE__ */ BigInt(0);
const secp256k1_2n = /* @__PURE__ */ BigInt(2);
/**
 * √n = n^((p+1)/4) for fields p = 3 mod 4. We unwrap the loop and multiply bit-by-bit.
 * (P+1n/4n).toString(2) would produce bits [223x 1, 0, 22x 1, 4x 0, 11, 00]
 */
function sqrtMod(y) {
    const P = secp256k1_CURVE.p;
    // prettier-ignore
    const _3n = BigInt(3), _6n = BigInt(6), _11n = BigInt(11), _22n = BigInt(22);
    // prettier-ignore
    const _23n = BigInt(23), _44n = BigInt(44), _88n = BigInt(88);
    const b2 = (y * y * y) % P; // x^3, 11
    const b3 = (b2 * b2 * y) % P; // x^7
    const b6 = (pow2(b3, _3n, P) * b3) % P;
    const b9 = (pow2(b6, _3n, P) * b3) % P;
    const b11 = (pow2(b9, secp256k1_2n, P) * b2) % P;
    const b22 = (pow2(b11, _11n, P) * b11) % P;
    const b44 = (pow2(b22, _22n, P) * b22) % P;
    const b88 = (pow2(b44, _44n, P) * b44) % P;
    const b176 = (pow2(b88, _88n, P) * b88) % P;
    const b220 = (pow2(b176, _44n, P) * b44) % P;
    const b223 = (pow2(b220, _3n, P) * b3) % P;
    const t1 = (pow2(b223, _23n, P) * b22) % P;
    const t2 = (pow2(t1, _6n, P) * b2) % P;
    const root = pow2(t2, secp256k1_2n, P);
    if (!Fpk1.eql(Fpk1.sqr(root), y))
        throw new Error('Cannot find square root');
    return root;
}
const Fpk1 = Field(secp256k1_CURVE.p, { sqrt: sqrtMod });
const Pointk1 = /* @__PURE__ */ weierstrass(secp256k1_CURVE, {
    Fp: Fpk1,
    endo: secp256k1_ENDO,
});
/**
 * secp256k1 curve: ECDSA and ECDH methods.
 *
 * Uses sha256 to hash messages. To use a different hash,
 * pass `{ prehash: false }` to sign / verify.
 *
 * @example
 * ```js
 * import { secp256k1 } from '@noble/curves/secp256k1.js';
 * const { secretKey, publicKey } = secp256k1.keygen();
 * // const publicKey = secp256k1.getPublicKey(secretKey);
 * const msg = new TextEncoder().encode('hello noble');
 * const sig = secp256k1.sign(msg, secretKey);
 * const isValid = secp256k1.verify(sig, msg, publicKey);
 * // const sigKeccak = secp256k1.sign(keccak256(msg), secretKey, { prehash: false });
 * ```
 */
const secp256k1 = /* @__PURE__ */ (/* unused pure expression or super */ null && (ecdsa(Pointk1, sha256)));
// Schnorr signatures are superior to ECDSA from above. Below is Schnorr-specific BIP0340 code.
// https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki
/** An object mapping tags to their tagged hash prefix of [SHA256(tag) | SHA256(tag)] */
const TAGGED_HASH_PREFIXES = {};
function taggedHash(tag, ...messages) {
    let tagP = TAGGED_HASH_PREFIXES[tag];
    if (tagP === undefined) {
        const tagH = sha2_sha256(asciiToBytes(tag));
        tagP = utils_concatBytes(tagH, tagH);
        TAGGED_HASH_PREFIXES[tag] = tagP;
    }
    return sha2_sha256(utils_concatBytes(tagP, ...messages));
}
// ECDSA compact points are 33-byte. Schnorr is 32: we strip first byte 0x02 or 0x03
const pointToBytes = (point) => point.toBytes(true).slice(1);
const hasEven = (y) => y % secp256k1_2n === secp256k1_0n;
// Calculate point, scalar and bytes
function schnorrGetExtPubKey(priv) {
    const { Fn, BASE } = Pointk1;
    const d_ = Fn.fromBytes(priv);
    const p = BASE.multiply(d_); // P = d'⋅G; 0 < d' < n check is done inside
    const scalar = hasEven(p.y) ? d_ : Fn.neg(d_);
    return { scalar, bytes: pointToBytes(p) };
}
/**
 * lift_x from BIP340. Convert 32-byte x coordinate to elliptic curve point.
 * @returns valid point checked for being on-curve
 */
function lift_x(x) {
    const Fp = Fpk1;
    if (!Fp.isValidNot0(x))
        throw new Error('invalid x: Fail if x ≥ p');
    const xx = Fp.create(x * x);
    const c = Fp.create(xx * x + BigInt(7)); // Let c = x³ + 7 mod p.
    let y = Fp.sqrt(c); // Let y = c^(p+1)/4 mod p. Same as sqrt().
    // Return the unique point P such that x(P) = x and
    // y(P) = y if y mod 2 = 0 or y(P) = p-y otherwise.
    if (!hasEven(y))
        y = Fp.neg(y);
    const p = Pointk1.fromAffine({ x, y });
    p.assertValidity();
    return p;
}
const num = utils_bytesToNumberBE;
/**
 * Create tagged hash, convert it to bigint, reduce modulo-n.
 */
function challenge(...args) {
    return Pointk1.Fn.create(num(taggedHash('BIP0340/challenge', ...args)));
}
/**
 * Schnorr public key is just `x` coordinate of Point as per BIP340.
 */
function schnorrGetPublicKey(secretKey) {
    return schnorrGetExtPubKey(secretKey).bytes; // d'=int(sk). Fail if d'=0 or d'≥n. Ret bytes(d'⋅G)
}
/**
 * Creates Schnorr signature as per BIP340. Verifies itself before returning anything.
 * auxRand is optional and is not the sole source of k generation: bad CSPRNG won't be dangerous.
 */
function schnorrSign(message, secretKey, auxRand = randomBytes(32)) {
    const { Fn } = Pointk1;
    const m = utils_abytes(message, undefined, 'message');
    const { bytes: px, scalar: d } = schnorrGetExtPubKey(secretKey); // checks for isWithinCurveOrder
    const a = utils_abytes(auxRand, 32, 'auxRand'); // Auxiliary random data a: a 32-byte array
    const t = Fn.toBytes(d ^ num(taggedHash('BIP0340/aux', a))); // Let t be the byte-wise xor of bytes(d) and hash/aux(a)
    const rand = taggedHash('BIP0340/nonce', t, px, m); // Let rand = hash/nonce(t || bytes(P) || m)
    // Let k' = int(rand) mod n. Fail if k' = 0. Let R = k'⋅G
    const { bytes: rx, scalar: k } = schnorrGetExtPubKey(rand);
    const e = challenge(rx, px, m); // Let e = int(hash/challenge(bytes(R) || bytes(P) || m)) mod n.
    const sig = new Uint8Array(64); // Let sig = bytes(R) || bytes((k + ed) mod n).
    sig.set(rx, 0);
    sig.set(Fn.toBytes(Fn.create(k + e * d)), 32);
    // If Verify(bytes(P), m, sig) (see below) returns failure, abort
    if (!schnorrVerify(sig, m, px))
        throw new Error('sign: Invalid signature produced');
    return sig;
}
/**
 * Verifies Schnorr signature.
 * Will swallow errors & return false except for initial type validation of arguments.
 */
function schnorrVerify(signature, message, publicKey) {
    const { Fp, Fn, BASE } = Pointk1;
    const sig = utils_abytes(signature, 64, 'signature');
    const m = utils_abytes(message, undefined, 'message');
    const pub = utils_abytes(publicKey, 32, 'publicKey');
    try {
        const P = lift_x(num(pub)); // P = lift_x(int(pk)); fail if that fails
        const r = num(sig.subarray(0, 32)); // Let r = int(sig[0:32]); fail if r ≥ p.
        if (!Fp.isValidNot0(r))
            return false;
        const s = num(sig.subarray(32, 64)); // Let s = int(sig[32:64]); fail if s ≥ n.
        if (!Fn.isValidNot0(s))
            return false;
        const e = challenge(Fn.toBytes(r), pointToBytes(P), m); // int(challenge(bytes(r)||bytes(P)||m))%n
        // R = s⋅G - e⋅P, where -eP == (n-e)P
        const R = BASE.multiplyUnsafe(s).add(P.multiplyUnsafe(Fn.neg(e)));
        const { x, y } = R.toAffine();
        // Fail if is_infinite(R) / not has_even_y(R) / x(R) ≠ r.
        if (R.is0() || !hasEven(y) || x !== r)
            return false;
        return true;
    }
    catch (error) {
        return false;
    }
}
/**
 * Schnorr signatures over secp256k1.
 * https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki
 * @example
 * ```js
 * import { schnorr } from '@noble/curves/secp256k1.js';
 * const { secretKey, publicKey } = schnorr.keygen();
 * // const publicKey = schnorr.getPublicKey(secretKey);
 * const msg = new TextEncoder().encode('hello');
 * const sig = schnorr.sign(msg, secretKey);
 * const isValid = schnorr.verify(sig, msg, publicKey);
 * ```
 */
const schnorr = /* @__PURE__ */ (() => {
    const size = 32;
    const seedLength = 48;
    const randomSecretKey = (seed = randomBytes(seedLength)) => {
        return modular_mapHashToField(seed, secp256k1_CURVE.n);
    };
    return {
        keygen: curve_createKeygen(randomSecretKey, schnorrGetPublicKey),
        getPublicKey: schnorrGetPublicKey,
        sign: schnorrSign,
        verify: schnorrVerify,
        Point: Pointk1,
        utils: {
            randomSecretKey,
            taggedHash,
            lift_x,
            pointToBytes,
        },
        lengths: {
            secretKey: size,
            publicKey: size,
            publicKeyHasPrefix: false,
            signature: size * 2,
            seed: seedLength,
        },
    };
})();
const isoMap = /* @__PURE__ */ (/* unused pure expression or super */ null && ((() => isogenyMap(Fpk1, [
    // xNum
    [
        '0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7',
        '0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581',
        '0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262',
        '0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c',
    ],
    // xDen
    [
        '0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b',
        '0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14',
        '0x0000000000000000000000000000000000000000000000000000000000000001', // LAST 1
    ],
    // yNum
    [
        '0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c',
        '0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3',
        '0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931',
        '0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84',
    ],
    // yDen
    [
        '0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b',
        '0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573',
        '0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f',
        '0x0000000000000000000000000000000000000000000000000000000000000001', // LAST 1
    ],
].map((i) => i.map((j) => BigInt(j)))))()));
const mapSWU = /* @__PURE__ */ (/* unused pure expression or super */ null && ((() => mapToCurveSimpleSWU(Fpk1, {
    A: BigInt('0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533'),
    B: BigInt('1771'),
    Z: Fpk1.create(BigInt('-11')),
}))()));
/** Hashing / encoding to secp256k1 points / field. RFC 9380 methods. */
const secp256k1_hasher = /* @__PURE__ */ (/* unused pure expression or super */ null && ((() => createHasher(Pointk1, (scalars) => {
    const { x, y } = mapSWU(Fpk1.create(scalars[0]));
    return isoMap(x, y);
}, {
    DST: 'secp256k1_XMD:SHA-256_SSWU_RO_',
    encodeDST: 'secp256k1_XMD:SHA-256_SSWU_NU_',
    p: Fpk1.ORDER,
    m: 1,
    k: 128,
    expand: 'xmd',
    hash: sha256,
}))()));
//# sourceMappingURL=secp256k1.js.map
;// ./src/chat/signature.ts




// import {utf8Encoder} from './utils'
// import { getPublicKey } from './keys'

var utf8Decoder = new TextDecoder('utf-8');
var utf8Encoder = new TextEncoder();
var SEC = 'https://w3id.org/security#'; // Proof, VerificationMethod
// export const CERT = 'http://www.w3.org/ns/auth/cert#' // PrivateKey, PublicKey, key

/* export enum Kind {
  Metadata = 0,
  Text = 1,
  RecommendRelay = 2,
  Contacts = 3,
  EncryptedDirectMessage = 4,
  EventDeletion = 5,
  Reaction = 7,
  BadgeAward = 8,
  ChannelCreation = 40,
  ChannelMetadata = 41,
  ChannelMessage = 42,
  ChannelHideMessage = 43,
  ChannelMuteUser = 44,
  Report = 1984,
  ZapRequest = 9734,
  Zap = 9735,
  RelayList = 10002,
  ClientAuth = 22242,
  BadgeDefinition = 30008,
  ProfileBadge = 30009,
  Article = 30023
} */

function getBlankMsg() {
  return {
    id: '',
    created: '',
    dateDeleted: '',
    // TODO to remove if not used
    content: '',
    maker: '',
    sig: '' // TODO to remove if not used
  };
}

/* export function finishMsg (t: MsgTemplate, privateKey: string): Message {
  // to update to chat message triples
  const message = t as Message
  // message.pubkey = getPublicKey(privateKey)
  message.id = getMsgHash(message)
  message.sig = signMsg(message, privateKey)
  return message
} */

function serializeMsg(msg) {
  // to update to chat messages triples
  /* if (!validateMsg(msg))
    throw new Error("can't serialize message with wrong or missing properties") */

  return JSON.stringify(msg);
}
function getMsgHash(message) {
  var msgHash = sha2_sha256(utf8Encoder.encode(serializeMsg(message)));
  return utils_bytesToHex(msgHash);
}

// const isRecord = (obj: unknown): obj is Record<string, unknown> => obj instanceof Object

/* export function validateMsg<T> (message: T): message is T & UnsignedMsg {
  if (!isRecord(message)) return false
  if (typeof message.kind !== 'number') return false
  if (typeof message.content !== 'string') return false
  if (typeof message.created_at !== 'number') return false
  if (typeof message.pubkey !== 'string') return false
  if (!message.pubkey.match(/^[a-f0-9]{64}$/)) return false

  if (!Array.isArray(message.tags)) return false
  for (let i = 0; i < message.tags.length; i++) {
    let tag = message.tags[i]
    if (!Array.isArray(tag)) return false
    for (let j = 0; j < tag.length; j++) {
      if (typeof tag[j] === 'object') return false
    }
  }

  return true
} */

function verifySignature(sig, message, pubKey) {
  return schnorr.verify(utils_hexToBytes(sig), utils_hexToBytes(getMsgHash(message)), utils_hexToBytes(pubKey));
}
function signMsg(message, key) {
  return utils_bytesToHex(schnorr.sign(utils_hexToBytes(getMsgHash(message)), utils_hexToBytes(key)));
}
;// ./src/utils/keyHelpers/otherHelpers.ts


// Will rename this file later. We will probably be using solid-logic anyway
// moved it out so I can mock

var getRootIfPreferencesExist = function getRootIfPreferencesExist(webId) {
  var _store$any, _root;
  var root = (_store$any = external_SolidLogic_.store.any(webId, src_ns.space('preferencesFile'), null, webId.doc())) === null || _store$any === void 0 ? void 0 : _store$any.value;
  root = (_root = root) === null || _root === void 0 ? void 0 : _root.split('/').slice(0, -2).join('/');
  if (!root) throw new Error("prefererencesFile is expected to exist in ".concat(webId));
  return root;
};
;// ./src/utils/keyHelpers/accessData.ts






var pubKeyUrl = function pubKeyUrl(webId) {
  var url;
  try {
    var root = getRootIfPreferencesExist(webId);
    url = "".concat(root, "/profile/keys/publicKey.ttl");
  } catch (err) {
    src_debug/* error */.z3(err);
  }
  return url;
};
var privKeyUrl = function privKeyUrl(webId) {
  var url;
  try {
    var root = getRootIfPreferencesExist(webId);
    url = "".concat(root, "/settings/keys/privateKey.ttl");
  } catch (err) {
    src_debug/* error */.z3(err);
  }
  return url;
};
function getExistingPublicKey(_x, _x2) {
  return _getExistingPublicKey.apply(this, arguments);
}
function _getExistingPublicKey() {
  _getExistingPublicKey = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee(webId, publicKeyUrl) {
    return regenerator_default().wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 1;
          return getKeyIfExists(webId, publicKeyUrl, 'publicKey');
        case 1:
          return _context.abrupt("return", _context.sent);
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getExistingPublicKey.apply(this, arguments);
}
function getExistingPrivateKey(_x3, _x4) {
  return _getExistingPrivateKey.apply(this, arguments);
}
function _getExistingPrivateKey() {
  _getExistingPrivateKey = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee2(webId, privateKeyUrl) {
    return regenerator_default().wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 1;
          return getKeyIfExists(webId, privateKeyUrl, 'privateKey');
        case 1:
          return _context2.abrupt("return", _context2.sent);
        case 2:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _getExistingPrivateKey.apply(this, arguments);
}
function getKeyIfExists(_x5, _x6, _x7) {
  return _getKeyIfExists.apply(this, arguments);
}
function _getKeyIfExists() {
  _getKeyIfExists = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee3(webId, keyUrl, keyType) {
    var key, _t, _t2;
    return regenerator_default().wrap(function (_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 1;
          return external_SolidLogic_.store.fetcher.load(keyUrl);
        case 1:
          key = external_SolidLogic_.store.any(webId, src_ns.solid(keyType)); // store.sym(CERT + keyType))
          return _context3.abrupt("return", key === null || key === void 0 ? void 0 : key.value);
        case 2:
          _context3.prev = 2;
          _t = _context3["catch"](0);
          if (!(_t.response.status === 404)) {
            _context3.next = 7;
            break;
          }
          src_debug/* log */.Rm('createIfNotExists: doc does NOT exist, will create... ' + keyUrl);
          _context3.prev = 3;
          _context3.next = 4;
          return external_SolidLogic_.store.fetcher.webOperation('PUT', keyUrl, {
            data: '',
            contentType: 'text/turtle'
          });
        case 4:
          _context3.next = 6;
          break;
        case 5:
          _context3.prev = 5;
          _t2 = _context3["catch"](3);
          src_debug/* log */.Rm('createIfNotExists doc FAILED: ' + keyUrl + ': ' + _t2);
          throw _t2;
        case 6:
          delete external_SolidLogic_.store.fetcher.requested[keyUrl]; // delete cached 404 error
          // debug.log('createIfNotExists doc created ok ' + doc)
          return _context3.abrupt("return", undefined);
        case 7:
          src_debug/* log */.Rm('createIfNotExists doc FAILED: ' + keyUrl + ': ' + _t);
          throw _t;
        case 8:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[0, 2], [3, 5]]);
  }));
  return _getKeyIfExists.apply(this, arguments);
}
;// ./src/utils/keyHelpers/acl.ts





/**
 * set ACL
 * @param keyDoc
 * @param aclBody
 */
function setAcl(_x, _x2) {
  return _setAcl.apply(this, arguments);
}

/**
 * key container ACL
 * @param me
 * @returns aclBody
 */
function _setAcl() {
  _setAcl = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee(keyDoc, aclBody) {
    var keyAclDoc, _err$response, _t;
    return regenerator_default().wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 1;
          return external_SolidLogic_.store.fetcher.load(keyDoc);
        case 1:
          // FIXME: check the Why value on this quad:
          // debug.log(store.statementsMatching(store.sym(keyDoc), store.sym('http://www.iana.org/assignments/link-relations/acl')))
          keyAclDoc = external_SolidLogic_.store.any(external_SolidLogic_.store.sym(keyDoc), external_SolidLogic_.store.sym('http://www.iana.org/assignments/link-relations/acl'));
          if (keyAclDoc) {
            _context.next = 2;
            break;
          }
          throw new Error('Key ACL doc not found!');
        case 2:
          _context.prev = 2;
          _context.next = 3;
          return external_SolidLogic_.store.fetcher.webOperation('PUT', keyAclDoc.value, {
            data: aclBody,
            contentType: 'text/turtle'
          });
        case 3:
          _context.next = 6;
          break;
        case 4:
          _context.prev = 4;
          _t = _context["catch"](2);
          if (!((_t === null || _t === void 0 || (_err$response = _t.response) === null || _err$response === void 0 ? void 0 : _err$response.status) !== 404)) {
            _context.next = 5;
            break;
          }
          throw new Error(_t);
        case 5:
          src_debug/* log */.Rm('delete ' + keyAclDoc.value + ' ' + _t.response.status); // should test 404 and 2xx
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 4]]);
  }));
  return _setAcl.apply(this, arguments);
}
var keyContainerAclBody = function keyContainerAclBody(me) {
  var aclBody = "\n@prefix : <#>.\n@prefix acl: <http://www.w3.org/ns/auth/acl#>.\n@prefix foaf: <http://xmlns.com/foaf/0.1/>.\n@prefix key: <./>.\n\n:ReadWrite\n    a acl:Authorization;\n    acl:accessTo key:;\n    acl:default key:;\n    acl:agent <".concat(me, ">;\n    acl:mode acl:Read, acl:Write.\n");
  return aclBody;
};

/**
 * Read only ACL
 * @param keyDoc
 * @param me
 * @returns aclBody
 */
var keyAclBody = function keyAclBody(keyDoc, me) {
  var keyAgent = 'acl:agentClass foaf:Agent'; // publicKey
  if (me !== null && me !== void 0 && me.length) keyAgent = "acl:agent <".concat(me, ">"); // privateKey
  var aclBody = "\n@prefix foaf: <http://xmlns.com/foaf/0.1/>.\n@prefix acl: <http://www.w3.org/ns/auth/acl#>.\n<#Read>\n    a acl:Authorization;\n    ".concat(keyAgent, ";\n    acl:accessTo <").concat(keyDoc.split('/').pop(), ">;\n    acl:mode acl:Read.\n");
  return aclBody;
};
;// ./src/chat/keys.ts










function generatePrivateKey() {
  return utils_bytesToHex(schnorr.utils.randomSecretKey());
}
function generatePublicKey(privateKey) {
  return utils_bytesToHex(schnorr.getPublicKey(utils_hexToBytes(privateKey)));
}

/**
 * getPublicKey
 * used for displaying messages in chat, therefore does not
 * create a new key if not found
 * @param webId
 * @returns string | undefined
 */
function getPublicKey(_x) {
  return _getPublicKey.apply(this, arguments);
}
function _getPublicKey() {
  _getPublicKey = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee2(webId) {
    var publicKeyDoc, key, _t2;
    return regenerator_default().wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 1;
          return external_SolidLogic_.store.fetcher.load(webId);
        case 1:
          _context2.next = 2;
          return pubKeyUrl(webId);
        case 2:
          publicKeyDoc = _context2.sent;
          _context2.prev = 3;
          _context2.next = 4;
          return external_SolidLogic_.store.fetcher.load(publicKeyDoc);
        case 4:
          // url.href)
          key = external_SolidLogic_.store.any(webId, src_ns.solid('publicKey'));
          return _context2.abrupt("return", key === null || key === void 0 ? void 0 : key.value);
        case 5:
          _context2.prev = 5;
          _t2 = _context2["catch"](3);
          return _context2.abrupt("return", undefined);
        case 6:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[3, 5]]);
  }));
  return _getPublicKey.apply(this, arguments);
}
function getPrivateKey(_x2) {
  return _getPrivateKey.apply(this, arguments);
}
function _getPrivateKey() {
  _getPrivateKey = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee3(webId) {
    var publicKeyDoc, privateKeyDoc, publicKey, privateKey, validPublicKey, del, add, newPublicKey, keyContainer;
    return regenerator_default().wrap(function (_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 1;
          return external_SolidLogic_.store.fetcher.load(webId);
        case 1:
          _context3.next = 2;
          return pubKeyUrl(webId);
        case 2:
          publicKeyDoc = _context3.sent;
          _context3.next = 3;
          return privKeyUrl(webId);
        case 3:
          privateKeyDoc = _context3.sent;
          _context3.next = 4;
          return getExistingPublicKey(webId, publicKeyDoc);
        case 4:
          publicKey = _context3.sent;
          _context3.next = 5;
          return getExistingPrivateKey(webId, privateKeyDoc);
        case 5:
          privateKey = _context3.sent;
          // is publicKey valid ?
          validPublicKey = true;
          if (privateKey && publicKey !== generatePublicKey(privateKey)) {
            if (confirm('This is strange the publicKey is not valid for\n' + (webId === null || webId === void 0 ? void 0 : webId.uri) + '\'shall we repair keeping the private key ?')) validPublicKey = false;
          }

          // create key pair or repair publicKey
          if (!(!privateKey || !publicKey || !validPublicKey)) {
            _context3.next = 8;
            break;
          }
          del = [];
          add = [];
          if (privateKey) {
            _context3.next = 6;
            break;
          }
          // add = []
          privateKey = generatePrivateKey();
          add = [external_$rdf_.st(webId, src_ns.solid('privateKey'), external_$rdf_.literal(privateKey), external_SolidLogic_.store.sym(privateKeyDoc))];
          _context3.next = 6;
          return saveKey(privateKeyDoc, [], add, webId.uri);
        case 6:
          if (!(!publicKey || !validPublicKey)) {
            _context3.next = 7;
            break;
          }
          del = [];
          // delete invalid public key
          if (publicKey) {
            del = [external_$rdf_.st(webId, src_ns.solid('publicKey'), external_$rdf_.lit(publicKey), external_SolidLogic_.store.sym(publicKeyDoc))];
            src_debug/* log */.Rm('delete invalid publicKey ' + del);
          }
          // update new valid key
          newPublicKey = generatePublicKey(privateKey);
          add = [external_$rdf_.st(webId, src_ns.solid('publicKey'), external_$rdf_.literal(newPublicKey), external_SolidLogic_.store.sym(publicKeyDoc))];
          _context3.next = 7;
          return saveKey(publicKeyDoc, del, add);
        case 7:
          keyContainer = privateKeyDoc.substring(0, privateKeyDoc.lastIndexOf('/') + 1);
          _context3.next = 8;
          return setAcl(keyContainer, keyContainerAclBody(webId.uri));
        case 8:
          return _context3.abrupt("return", privateKey);
        case 9:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _getPrivateKey.apply(this, arguments);
}
var deleteKeyAcl = /*#__PURE__*/function () {
  var _ref = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee(keyDoc) {
    var keyAclDoc, response, _t;
    return regenerator_default().wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 1;
          return external_SolidLogic_.store.fetcher.load(keyDoc);
        case 1:
          keyAclDoc = external_SolidLogic_.store.any(external_SolidLogic_.store.sym(keyDoc), external_SolidLogic_.store.sym('http://www.iana.org/assignments/link-relations/acl'));
          if (!keyAclDoc) {
            _context.next = 6;
            break;
          }
          _context.prev = 2;
          _context.next = 3;
          return external_SolidLogic_.store.fetcher.webOperation('DELETE', keyAclDoc.value);
        case 3:
          response = _context.sent;
          // this may fail if webId is not an owner
          src_debug/* log */.Rm('delete keyAcl' + keyAclDoc.value + ' ' + response.status); // should test 404 and 2xx
          _context.next = 6;
          break;
        case 4:
          _context.prev = 4;
          _t = _context["catch"](2);
          if (!(_t.response.status !== 404)) {
            _context.next = 5;
            break;
          }
          throw new Error(_t);
        case 5:
          src_debug/* log */.Rm('delete keyAcl' + keyAclDoc.value + ' ' + _t.response.status); // should test 404 and 2xx
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 4]]);
  }));
  return function deleteKeyAcl(_x3) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * delete acl if keydoc exists
 * create/edit keyDoc
 * set keyDoc acl
 */
function saveKey(_x4, _x5, _x6) {
  return _saveKey.apply(this, arguments);
}
function _saveKey() {
  _saveKey = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee4(keyDoc, del, add) {
    var me,
      aclBody,
      _args4 = arguments;
    return regenerator_default().wrap(function (_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          me = _args4.length > 3 && _args4[3] !== undefined ? _args4[3] : '';
          _context4.next = 1;
          return deleteKeyAcl(keyDoc);
        case 1:
          _context4.next = 2;
          return external_SolidLogic_.store.updater.updateMany(del, add);
        case 2:
          // or a promise store.updater.update ?
          // create READ only ACL
          aclBody = keyAclBody(keyDoc, me);
          _context4.next = 3;
          return setAcl(keyDoc, aclBody);
        case 3:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _saveKey.apply(this, arguments);
}
;// ./src/chat/chatLogic.js




/**
 * Contains the [[ChatChannel]] class and logic for Solid Chat
 * @packageDocumentation
 */





 // pull in first avoid cross-refs




/* The Solid logic for a 'LongChat'
*/
/**
 * Common code for a chat (discussion area of messages about something)
 * This version runs over a series of files for different time periods
 *
 * Parameters for the whole chat like its title are stored on
 * index.ttl#this and the chats messages are stored in YYYY/MM/DD/chat.ttl
 *
 */

var ChatChannel = /*#__PURE__*/function () {
  function ChatChannel(channel, options) {
    classCallCheck_classCallCheck(this, ChatChannel);
    this.channel = channel;
    this.channelRoot = channel.doc();
    this.options = options;
    this.dateFolder = new DateFolder(this.channelRoot, 'chat.ttl');
    this.div = null; // : HTMLElement
  }

  /* Store a new message in the web,
  */
  return createClass_createClass(ChatChannel, [{
    key: "createMessage",
    value: (function () {
      var _createMessage = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee(text) {
        return regenerator_default().wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.updateMessage(text));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function createMessage(_x) {
        return _createMessage.apply(this, arguments);
      }
      return createMessage;
    }()
    /* Store a new message in the web,
      as a replacement for an existing one.
      The old one iis left, and the two are linked
    */
    )
  }, {
    key: "updateMessage",
    value: (function () {
      var _updateMessage = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee2(text) {
        var oldMsg,
          deleteIt,
          thread,
          sts,
          now,
          timestamp,
          dateStamp,
          chatDocument,
          message,
          me,
          msg,
          oldMsgMaker,
          oldMsgMostRecentVersion,
          oldMsgThread,
          errMsg,
          privateKey,
          sig,
          _errMsg,
          _args2 = arguments,
          _t;
        return regenerator_default().wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              oldMsg = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : null;
              deleteIt = _args2.length > 2 ? _args2[2] : undefined;
              thread = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : null;
              sts = [];
              now = new Date();
              timestamp = '' + now.getTime();
              dateStamp = external_$rdf_.term(now);
              chatDocument = oldMsg ? oldMsg.doc() : this.dateFolder.leafDocumentFromDate(now);
              message = external_SolidLogic_.store.sym(chatDocument.uri + '#' + 'Msg' + timestamp); // const content = store.literal(text)
              me = external_SolidLogic_.authn.currentUser(); // If already logged on
              msg = getBlankMsg();
              msg.id = message.uri;
              if (!oldMsg) {
                _context2.next = 4;
                break;
              }
              // edit message replaces old one
              oldMsgMaker = external_SolidLogic_.store.any(oldMsg, src_ns.foaf('maker')); // may not be needed here, but needed on READ
              if (!(oldMsgMaker.uri === me.uri)) {
                _context2.next = 2;
                break;
              }
              _context2.next = 1;
              return mostRecentVersion(oldMsg);
            case 1:
              oldMsgMostRecentVersion = _context2.sent;
              sts.push(external_$rdf_.st(oldMsgMostRecentVersion, src_ns.dct('isReplacedBy'), message, chatDocument));
              // if oldMsg has_reply => add has_reply to message
              oldMsgThread = external_SolidLogic_.store.any(oldMsgMostRecentVersion, src_ns.sioc('has_reply'));
              if (oldMsgThread) {
                sts.push(external_$rdf_.st(message, src_ns.sioc('has_reply'), oldMsgThread, chatDocument));
              }
              if (deleteIt) {
                // we need to add a specific signature, else anyone can delete a msg ?
                sts.push(external_$rdf_.st(message, src_ns.schema('dateDeleted'), dateStamp, chatDocument));
              }
              _context2.next = 3;
              break;
            case 2:
              errMsg = 'Error you cannot delete/edit a message from someone else : \n' + oldMsgMaker.uri;
              src_debug/* warn */.R8(errMsg);
              alert(errMsg);
              throw new Error(errMsg);
            case 3:
              _context2.next = 5;
              break;
            case 4:
              // link new message to channel
              sts.push(external_$rdf_.st(this.channel, src_ns.wf('message'), message, chatDocument));
            case 5:
              sts.push(external_$rdf_.st(message, src_ns.sioc('content'), external_SolidLogic_.store.literal(text), chatDocument));
              msg.content = text;
              sts.push(external_$rdf_.st(message, src_ns.dct('created'), dateStamp, chatDocument));
              msg.created = dateStamp.value;
              if (!me) {
                _context2.next = 7;
                break;
              }
              sts.push(external_$rdf_.st(message, src_ns.foaf('maker'), me, chatDocument));
              msg.maker = me.uri;
              // privateKey the cached private key of me, cached in store
              _context2.next = 6;
              return getPrivateKey(me);
            case 6:
              privateKey = _context2.sent;
              // me.uri)
              sig = signMsg(msg, privateKey);
              sts.push(external_$rdf_.st(message, external_$rdf_.sym("".concat(SEC, "proofValue")), external_$rdf_.lit(sig), chatDocument));
            case 7:
              if (thread) {
                sts.push(external_$rdf_.st(thread, src_ns.sioc('has_member'), message, chatDocument));
                if (!thread.doc().sameTerm(message.doc())) {
                  sts.push(external_$rdf_.st(thread, src_ns.sioc('has_member'), message, thread.doc()));
                }
              }
              _context2.prev = 8;
              _context2.next = 9;
              return external_SolidLogic_.store.updater.updateMany([], sts);
            case 9:
              _context2.next = 11;
              break;
            case 10:
              _context2.prev = 10;
              _t = _context2["catch"](8);
              _errMsg = 'Error saving chat message: ' + _t;
              src_debug/* warn */.R8(_errMsg);
              alert(_errMsg);
              throw new Error(_errMsg);
            case 11:
              return _context2.abrupt("return", message);
            case 12:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[8, 10]]);
      }));
      function updateMessage(_x2) {
        return _updateMessage.apply(this, arguments);
      }
      return updateMessage;
    }()
    /* Mark a message as deleted
    * Wee add a new version of the message,m witha deletion flag (deletion date)
    * so that the deletion can be revoked by adding another non-deleted update
    */
    )
  }, {
    key: "deleteMessage",
    value: (function () {
      var _deleteMessage = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee3(message) {
        return regenerator_default().wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", this.updateMessage('(message deleted)', message, true));
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function deleteMessage(_x3) {
        return _deleteMessage.apply(this, arguments);
      }
      return deleteMessage;
    }() // Create a new thread of replies to the thread root message
    //  or return one which already exists
    )
  }, {
    key: "createThread",
    value: function () {
      var _createThread = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee4(threadRoot) {
        var already, thread, insert;
        return regenerator_default().wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              already = external_SolidLogic_.store.each(threadRoot, src_ns.sioc('has_reply'), null, threadRoot.doc()).filter(function (thread) {
                return external_SolidLogic_.store.holds(thread, src_ns.rdf('type'), src_ns.sioc('Thread'), thread.doc());
              });
              if (!(already.length > 0)) {
                _context4.next = 1;
                break;
              }
              return _context4.abrupt("return", already[0]);
            case 1:
              thread = external_$rdf_.sym(threadRoot.uri + '-thread');
              insert = [external_$rdf_.st(thread, src_ns.rdf('type'), src_ns.sioc('Thread'), thread.doc()), external_$rdf_.st(threadRoot, src_ns.sioc('has_reply'), thread, thread.doc())];
              _context4.next = 2;
              return external_SolidLogic_.store.updater.update([], insert);
            case 2:
              return _context4.abrupt("return", thread);
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      function createThread(_x4) {
        return _createThread.apply(this, arguments);
      }
      return createThread;
    }()
  }]);
}(); // class ChatChannel

// ////////// Utility functions

// Have to not loop forever if fed loops
function chatLogic_allVersions(_x5) {
  return _allVersions.apply(this, arguments);
}
function _allVersions() {
  _allVersions = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee5(message) {
    var versions, done, m, prev, next;
    return regenerator_default().wrap(function (_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          versions = [message];
          done = {};
          done[message.uri] = true;
          m = message;
        case 1:
          if (false) // removed by dead control flow
{}
          // earlier?
          prev = external_SolidLogic_.store.any(null, src_ns.dct('isReplacedBy'), m, m.doc());
          if (!(!prev || done[prev.uri])) {
            _context5.next = 2;
            break;
          }
          return _context5.abrupt("continue", 4);
        case 2:
          _context5.next = 3;
          return external_SolidLogic_.store.fetcher.load(prev);
        case 3:
          versions.unshift(prev);
          done[prev.uri] = true;
          m = prev;
          _context5.next = 1;
          break;
        case 4:
          m = message;
        case 5:
          if (false) // removed by dead control flow
{}
          // later?
          next = external_SolidLogic_.store.any(m, src_ns.dct('isReplacedBy'), null, m.doc());
          if (!(!next || done[next.uri])) {
            _context5.next = 6;
            break;
          }
          return _context5.abrupt("continue", 7);
        case 6:
          versions.push(next);
          done[next.uri] = true;
          m = next;
          _context5.next = 5;
          break;
        case 7:
          return _context5.abrupt("return", versions);
        case 8:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _allVersions.apply(this, arguments);
}
function originalVersion(_x6) {
  return _originalVersion.apply(this, arguments);
}
function _originalVersion() {
  _originalVersion = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee6(message) {
    var msg, done;
    return regenerator_default().wrap(function (_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          msg = message;
          done = {}; // done[message.uri] = true
        case 1:
          if (!msg) {
            _context6.next = 4;
            break;
          }
          if (!done[msg.uri]) {
            _context6.next = 2;
            break;
          }
          src_debug/* error */.z3('originalVersion: verion loop' + message);
          return _context6.abrupt("return", message);
        case 2:
          done[msg.uri] = true;
          message = msg;
          _context6.next = 3;
          return external_SolidLogic_.store.fetcher.load(message);
        case 3:
          msg = external_SolidLogic_.store.any(null, src_ns.dct('isReplacedBy'), message, message.doc());
          _context6.next = 1;
          break;
        case 4:
          return _context6.abrupt("return", message);
        case 5:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return _originalVersion.apply(this, arguments);
}
function mostRecentVersion(_x7) {
  return _mostRecentVersion.apply(this, arguments);
}
function _mostRecentVersion() {
  _mostRecentVersion = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee7(message) {
    var msg, done;
    return regenerator_default().wrap(function (_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          msg = message;
          done = {};
        case 1:
          if (!msg) {
            _context7.next = 4;
            break;
          }
          if (!done[msg.uri]) {
            _context7.next = 2;
            break;
          }
          src_debug/* error */.z3('mostRecentVersion: verion loop' + message);
          return _context7.abrupt("return", message);
        case 2:
          done[msg.uri] = true;
          message = msg;
          _context7.next = 3;
          return external_SolidLogic_.store.fetcher.load(message);
        case 3:
          msg = external_SolidLogic_.store.any(message, src_ns.dct('isReplacedBy'), null, message.doc());
          _context7.next = 1;
          break;
        case 4:
          return _context7.abrupt("return", message);
        case 5:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return _mostRecentVersion.apply(this, arguments);
}
function isDeleted(message) {
  return external_SolidLogic_.store.holds(message, src_ns.schema('dateDeleted'), null, message.doc());
}
function isReplaced(message) {
  return store.holds(message, ns.dct('isReplacedBy'), null, message.doc());
}
function isHidden(message) {
  return this.isDeleted(message) || this.isReplaced(message);
}

// A Nickname for a person

function nick(person) {
  var s = store.any(person, ns.foaf('nick'));
  if (s) return '' + s.value;
  return '' + utils.label(person);
}
// ends
;// ./src/participation.ts






function participation_createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = participation_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function participation_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return participation_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? participation_arrayLikeToArray(r, a) : void 0; } }
function participation_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/* Manage a UI for the participation of a person in any thing
*/

// import { currentUser } from './authn/authn'










var ParticipationTableElement = /*#__PURE__*/(/* unused pure expression or super */ null && (function (_HTMLTableElement) {
  function ParticipationTableElement() {
    _classCallCheck(this, ParticipationTableElement);
    return _callSuper(this, ParticipationTableElement, arguments);
  }
  _inherits(ParticipationTableElement, _HTMLTableElement);
  return _createClass(ParticipationTableElement);
}(/*#__PURE__*/_wrapNativeSuper(HTMLTableElement))));
var participation_store = external_SolidLogic_.solidLogicSingleton.store;

/**  Manage participation in this session
*
*  @param {Document} dom - the web page loaded into the browser
*  @param {HTMLTableElement} table - the table element
*  @param {NamedNode} unused1/document - the document to render (this argument is no longer used, but left in for backwards compatibility)
*  @param {NamedNode} subject - the thing in which the participation is happening
*  @param {NamedNode} unused2/me - user that is logged into the pod (this argument is no longer used, but left in for backwards compatibility)
*  @param {ParticipationOptions} options - the options that can be passed in are deleteFunction, link, and draggable; these are used by the personTR button
*/
function renderParticipants(dom, table, unused1, subject, unused2, options) {
  table.setAttribute('style', style.participantsStyle);
  var newRowForParticipation = function newRowForParticipation(parp) {
    var person = participation_store.any(parp, src_ns.wf('participant'));
    var tr;
    if (!person) {
      tr = dom.createElement('tr');
      tr.textContent = '???'; // Don't crash - invalid part'n entry
      return tr;
    }
    var bg = participation_store.anyValue(parp, src_ns.ui('backgroundColor')) || styleConstants.participationDefaultBackground;
    var block = dom.createElement('div');
    block.setAttribute('style', style.participantsBlock);
    block.style.backgroundColor = bg;
    tr = personTR(dom, null, person, options);
    table.appendChild(tr);
    var td = dom.createElement('td');
    td.setAttribute('style', style.personTableTD);
    td.appendChild(block);
    tr.insertBefore(td, tr.firstChild);
    return tr;
  };
  var syncTable = function syncTable() {
    var parps = participation_store.each(subject, src_ns.wf('participation')).map(function (parp) {
      (0,src_debug/* log */.Rm)('in participants');
      return [participation_store.anyValue(parp, src_ns.cal('dtstart')) || '9999-12-31', parp];
    });
    parps.sort(); // List in order of joining
    var participations = parps.map(function (p) {
      return p[1];
    });
    syncTableToArray(table, participations, newRowForParticipation);
  };
  table.refresh = syncTable;
  syncTable();
  return table;
}

/** Record, or find old, Participation object
 *
 * A participation object is a place to record things specifically about
 * subject and the user, such as preferences, start of membership, etc
 * @param {NamedNode} subject - the thing in which the participation is happening
 * @param {NamedNode} document -  where to record the data
 * @param {NamedNode} me - the logged in user
 *
 */
function participationObject(subject, padDoc, me) {
  return new Promise(function (resolve, reject) {
    if (!me) {
      throw new Error('No user id');
    }
    var parps = participation_store.each(subject, src_ns.wf('participation')).filter(function (pn) {
      return participation_store.holds(pn, src_ns.wf('participant'), me);
    });
    if (parps.length > 1) {
      // This can happen. https://github.com/solidos/chat-pane/issues/71
      var candidates = [];
      var _iterator = participation_createForOfIteratorHelper(parps),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var participation = _step.value;
          var date = participation_store.anyValue(participation, src_ns.cal('dtstart'));
          if (date) {
            candidates.push([date, participation]);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      candidates.sort(); // Pick the earliest
      // @@ Possibly, for extra credit, delete the others, if we have write access
      src_debug/* warn */.R8('Multiple participation objects, picking earliest, in ' + padDoc);
      resolve(candidates[0][1]);
      // throw new Error('Multiple records of your participation')
    }
    if (parps.length) {
      // If I am not already recorded
      resolve(parps[0]); // returns the participation object
    } else {
      var _participation = newThing(padDoc);
      var ins = [(0,external_$rdf_.st)(subject, src_ns.wf('participation'), _participation, padDoc), (0,external_$rdf_.st)(_participation, src_ns.wf('participant'), me, padDoc), (0,external_$rdf_.st)(_participation, src_ns.cal('dtstart'), new Date(), padDoc), (0,external_$rdf_.st)(_participation, src_ns.ui('backgroundColor'), lightColorHash(me), padDoc)];
      participation_store.updater.update([], ins, function (uri, ok, errorMessage) {
        if (!ok) {
          reject(new Error('Error recording your participation: ' + errorMessage));
        } else {
          resolve(_participation);
        }
      });
      resolve(_participation);
    }
  });
}

/** Record my participation and display participants
 *
 * @param {NamedNode} subject - the thing in which participation is happening
 * @param {NamedNode} padDoc - the document into which the participation should be recorded
 * @param {DOMNode} refreshable - a DOM element whose refresh() is to be called if the change works
 *
 */
function recordParticipation(subject, padDoc, refreshable) {
  var me = external_SolidLogic_.authn.currentUser();
  if (!me) return; // Not logged in

  var parps = participation_store.each(subject, src_ns.wf('participation')).filter(function (pn) {
    return participation_store.holds(pn, src_ns.wf('participant'), me);
  });
  if (parps.length > 1) {
    throw new Error('Multiple records of your participation');
  }
  if (parps.length) {
    // If I am not already recorded
    return parps[0]; // returns the participation object
  } else {
    if (!participation_store.updater.editable(padDoc)) {
      src_debug/* log */.Rm('Not recording participation, as no write access as ' + me + ' to ' + padDoc);
      return null;
    }
    var participation = newThing(padDoc);
    var ins = [(0,external_$rdf_.st)(subject, src_ns.wf('participation'), participation, padDoc), (0,external_$rdf_.st)(participation, src_ns.wf('participant'), me, padDoc), (0,external_$rdf_.st)(participation, src_ns.cal('dtstart'), new Date(), padDoc), (0,external_$rdf_.st)(participation, src_ns.ui('backgroundColor'), lightColorHash(me), padDoc)];
    participation_store.updater.update([], ins, function (uri, ok, errorMessage) {
      if (!ok) {
        throw new Error('Error recording your participation: ' + errorMessage);
      }
      if (refreshable && refreshable.refresh) {
        refreshable.refresh();
      }
    });
    return participation;
  }
}

/**  Record my participation and display participants
*
*   @param {Document} dom  - the web page loaded into the browser
*   @param {HTMLDivElement} container - the container element where the participants should be displayed
*   @param {NamedNode} document - the document into which the participation should be shown
*   @param {NamedNode} subject - the thing in which participation is happening
*   @param {NamedNode} me - the logged in user
*   @param {ParticipationOptions} options - the options that can be passed in are deleteFunction, link, and draggable; these are used by the personTR button
*
*/
function manageParticipation(dom, container, padDoc, subject, me, options) {
  var table = dom.createElement('table');
  container.appendChild(table);
  renderParticipants(dom, table, padDoc, subject, me, options);
  try {
    recordParticipation(subject, padDoc, table);
  } catch (e) {
    container.appendChild(errorMessageBlock(dom, 'Error recording your participation: ' + e)); // Clean up?
  }
  return table;
}
;// ./src/pad.ts






function pad_callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, pad_isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function pad_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (pad_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** **************
 *   Notepad Widget
 */

/** @module pad
 */








var pad_store = external_SolidLogic_.solidLogicSingleton.store;
var PAD = (0,external_$rdf_.Namespace)('http://www.w3.org/ns/pim/pad#');
/**
 * @ignore
 */
var NotepadElement = /*#__PURE__*/(/* unused pure expression or super */ null && (function (_HTMLElement) {
  function NotepadElement() {
    _classCallCheck(this, NotepadElement);
    return pad_callSuper(this, NotepadElement, arguments);
  }
  _inherits(NotepadElement, _HTMLElement);
  return _createClass(NotepadElement);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement))));
/**
 * @ignore
 */
var NotepadPart = /*#__PURE__*/(/* unused pure expression or super */ null && (function (_HTMLElement2) {
  function NotepadPart() {
    _classCallCheck(this, NotepadPart);
    return pad_callSuper(this, NotepadPart, arguments);
  }
  _inherits(NotepadPart, _HTMLElement2);
  return _createClass(NotepadPart);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement))));
/** Figure out a random color from my webid
 *
 * @param {NamedNode} author - The author of text being displayed
 * @returns {String} The CSS color generated, constrained to be light for a background color
 */
function lightColorHash(author) {
  var hash = function hash(x) {
    return x.split('').reduce(function (a, b) {
      a = (a << 5) - a + b.charCodeAt(0);
      return a & a;
    }, 0);
  };
  return author && author.uri ? '#' + (hash(author.uri) & 0xffffff | 0xc0c0c0).toString(16) : '#ffffff'; // c0c0c0  forces pale
} // no id -> white

/**  notepad
 *
 * @param {HTMLDocument} dom - the web page of the browser
 * @param {NamedNode} padDoc - the document in which the participation should be shown
 * @param {NamedNode} subject - the thing in which participation is happening
 * @param {NamedNode} me - person who is logged into the pod
 * @param {notepadOptions} options - the options that can be passed in consist of statusArea, exists
 */
function notepad(dom, padDoc, subject, me, options) {
  options = options || {};
  var exists = options.exists;
  var table = dom.createElement('table');
  var kb = pad_store;
  if (me && !me.uri) throw new Error('UI.pad.notepad:  Invalid userid');
  var updater = pad_store.updater;
  var PAD = (0,external_$rdf_.Namespace)('http://www.w3.org/ns/pim/pad#');
  table.setAttribute('style', style.notepadStyle);
  var upstreamStatus = null;
  var downstreamStatus = null;
  if (options.statusArea) {
    var t = options.statusArea.appendChild(dom.createElement('table'));
    var tr = t.appendChild(dom.createElement('tr'));
    upstreamStatus = tr.appendChild(dom.createElement('td'));
    downstreamStatus = tr.appendChild(dom.createElement('td'));
    if (upstreamStatus) {
      upstreamStatus.setAttribute('style', style.upstreamStatus);
    }
    if (downstreamStatus) {
      downstreamStatus.setAttribute('style', style.downstreamStatus);
    }
  }
  /* @@ TODO want to look into this, it seems upstream should be a boolean and default to false ?
  *
  */
  var complain = function complain(message) {
    var upstream = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    (0,src_debug/* log */.Rm)(message);
    if (options.statusArea) {
      ;
      (upstream ? upstreamStatus : downstreamStatus).appendChild(errorMessageBlock(dom, message, 'pink'));
    }
  };
  // @@ TODO need to refactor so that we don't have to type cast
  var clearStatus = function clearStatus(_upsteam) {
    if (options.statusArea) {
      options.statusArea.innerHTML = '';
    }
  };
  var setPartStyle = function setPartStyle(part, colors, pending) {
    var chunk = part.subject;
    colors = colors || '';
    var baseStyle = style.baseStyle;
    var headingCore = style.headingCore;
    var headingStyle = style.headingStyle;
    var author = kb.any(chunk, src_ns.dc('author'));
    if (!colors && author) {
      // Hash the user webid for now -- later allow user selection!
      var bgcolor = lightColorHash(author);
      colors = 'color: ' + (pending ? '#888' : 'black') + '; background-color: ' + bgcolor + ';';
    }

    // @@ TODO Need to research when this can be an object with the indent stored in value
    // and when the indent is stored as a Number itself, not in an object.
    var indent = kb.any(chunk, PAD('indent'));
    indent = indent ? indent.value : 0;
    var localStyle = indent >= 0 ? baseStyle + 'text-indent: ' + indent * 3 + 'em;' : headingCore + headingStyle[-1 - indent];
    // ? baseStyle + 'padding-left: ' + (indent * 3) + 'em;'
    part.setAttribute('style', localStyle + colors);
  };
  var removePart = function removePart(part) {
    var chunk = part.subject;
    if (!chunk) throw new Error('No chunk for line to be deleted!'); // just in case
    var prev = kb.any(undefined, PAD('next'), chunk);
    var next = kb.any(chunk, PAD('next'));
    if (prev.sameTerm(subject) && next.sameTerm(subject)) {
      // Last one
      (0,src_debug/* log */.Rm)('You can\'t delete the only line.');
      return;
    }
    var del = kb.statementsMatching(chunk, undefined, undefined, padDoc).concat(kb.statementsMatching(undefined, undefined, chunk, padDoc));
    var ins = [(0,external_$rdf_.st)(prev, PAD('next'), next, padDoc)];

    // @@ TODO what should we do if chunk is not a NamedNode should we
    // assume then it is a string?
    if (chunk instanceof external_$rdf_.NamedNode) {
      var label = chunk.uri.slice(-4);
      (0,src_debug/* log */.Rm)('Deleting line ' + label);
    }
    if (!updater) {
      throw new Error('have no updater');
    }
    // @@ TODO below you can see that before is redefined and not a boolean
    updater.update(del, ins, function (uri, ok, errorMessage, response) {
      if (ok) {
        var row = part.parentNode;
        if (row) {
          var before = row.previousSibling;
          if (row.parentNode) {
            row.parentNode.removeChild(row);
          }
          // console.log('    deleted line ' + label + ' ok ' + part.value)
          if (before && before.firstChild) {
            // @@ TODO IMPORTANT FOCUS ISN'T A PROPERTY ON A CHILDNODE
            before.firstChild.focus();
          }
        }
      } else if (response && response.status === 409) {
        // Conflict
        setPartStyle(part, 'color: black;  background-color: #ffd;'); // yellow
        part.state = 0; // Needs downstream refresh
        beep(0.5, 512); // Ooops clash with other person
        setTimeout(function () {
          // Ideally, beep! @@
          reloadAndSync(); // Throw away our changes and
          // updater.requestDownstreamAction(padDoc, reloadAndSync)
        }, 1000);
      } else {
        (0,src_debug/* log */.Rm)('    removePart FAILED ' + chunk + ': ' + errorMessage);
        (0,src_debug/* log */.Rm)('    removePart was deleteing :\'' + del);
        setPartStyle(part, 'color: black;  background-color: #fdd;'); // failed
        var res = response ? response.status : ' [no response field] ';
        complain('Error ' + res + ' saving changes: ' + errorMessage["true"]); // upstream,
        // updater.requestDownstreamAction(padDoc, reloadAndSync);
      }
    });
  }; // removePart

  var changeIndent = function changeIndent(part, chunk, delta) {
    var del = kb.statementsMatching(chunk, PAD('indent'));
    var current = del.length ? Number(del[0].object.value) : 0;
    if (current + delta < -3) return; //  limit negative indent
    var newIndent = current + delta;
    var ins = (0,external_$rdf_.st)(chunk, PAD('indent'), newIndent, padDoc);
    if (!updater) {
      throw new Error('no updater');
    }
    updater.update(del, ins, function (uri, ok, errorBody) {
      if (!ok) {
        (0,src_debug/* log */.Rm)('Indent change FAILED \'' + newIndent + '\' for ' + padDoc + ': ' + errorBody);
        setPartStyle(part, 'color: black;  background-color: #fdd;'); // failed
        updater.requestDownstreamAction(padDoc, reloadAndSync);
      } else {
        setPartStyle(part); // Implement the indent
      }
    });
  };
  var addListeners = function addListeners(part, chunk) {
    part.addEventListener('keydown', function (event) {
      if (!updater) {
        throw new Error('no updater');
      }
      var queueProperty, queue;
      //  up 38; down 40; left 37; right 39     tab 9; shift 16; escape 27
      switch (event.keyCode) {
        case 13:
          // Return
          {
            var before = event.shiftKey;
            (0,src_debug/* log */.Rm)('enter'); // Shift-return inserts before -- only way to add to top of pad.
            if (before) {
              queue = kb.any(undefined, PAD('next'), chunk);
              queueProperty = 'newlinesAfter';
            } else {
              queue = kb.any(chunk, PAD('next'));
              queueProperty = 'newlinesBefore';
            }
            queue[queueProperty] = queue[queueProperty] || 0;
            queue[queueProperty] += 1;
            if (queue[queueProperty] > 1) {
              (0,src_debug/* log */.Rm)('    queueing newline queue = ' + queue[queueProperty]);
              return;
            }
            (0,src_debug/* log */.Rm)('    go ahead line before ' + queue[queueProperty]);
            _newChunk(part, before); // was document.activeElement
            break;
          }
        case 8:
          // Delete
          if (part.value.length === 0) {
            (0,src_debug/* log */.Rm)('Delete key line ' + chunk.uri.slice(-4) + ' state ' + part.state);
            switch (part.state) {
              case 1: // contents being sent
              case 2:
                // contents need to be sent again
                part.state = 4; // delete me
                return;
              case 3: // already being deleted
              case 4:
                // already deleted state
                return;
              case undefined:
              case 0:
                part.state = 3; // being deleted
                removePart(part);
                event.preventDefault();
                break;
              // continue
              default:
                throw new Error('pad: Unexpected state ' + part);
            }
          }
          break;
        case 9:
          // Tab
          {
            var delta = event.shiftKey ? -1 : 1;
            changeIndent(part, chunk, delta);
            event.preventDefault(); // default is to highlight next field
            break;
          }
        case 27:
          // ESC
          (0,src_debug/* log */.Rm)('escape');
          updater.requestDownstreamAction(padDoc, reloadAndSync);
          event.preventDefault();
          break;
        case 38:
          // Up
          if (part.parentNode.previousSibling) {
            part.parentNode.previousSibling.firstChild.focus();
            event.preventDefault();
          }
          break;
        case 40:
          // Down
          if (part.parentNode.nextSibling) {
            part.parentNode.nextSibling.firstChild.focus();
            event.preventDefault();
          }
          break;
        default:
      }
    });
    var _updateStore = function updateStore(part) {
      var chunk = part.subject;
      setPartStyle(part, undefined, true);
      var old = kb.any(chunk, src_ns.sioc('content')).value;
      var del = [(0,external_$rdf_.st)(chunk, src_ns.sioc('content'), old, padDoc)];
      var ins;
      if (part.value) {
        ins = [(0,external_$rdf_.st)(chunk, src_ns.sioc('content'), part.value, padDoc)];
      }
      var newOne = part.value;

      // DEBUGGING ONLY
      if (part.lastSent) {
        if (old !== part.lastSent) {
          throw new Error('Out of order, last sent expected \'' + old + '\' but found \'' + part.lastSent + '\'');
        }
      }
      part.lastSent = newOne;

      /* console.log(
        ' Patch proposed to ' +
        chunk.uri.slice(-4) +
        " '" +
        old +
        "' -> '" +
        newOne +
        "' "
      ) */
      if (!updater) {
        throw new Error('no updater');
      }
      updater.update(del, ins, function (uri, ok, errorBody, xhr) {
        if (!ok) {
          // alert("clash " + errorBody);
          (0,src_debug/* log */.Rm)('    patch FAILED ' + xhr.status + ' for \'' + old + '\' -> \'' + newOne + '\': ' + errorBody);
          if (xhr.status === 409) {
            // Conflict -  @@ we assume someone else
            setPartStyle(part, 'color: black;  background-color: #fdd;');
            part.state = 0; // Needs downstream refresh
            beep(0.5, 512); // Ooops clash with other person
            setTimeout(function () {
              updater.requestDownstreamAction(padDoc, reloadAndSync);
            }, 1000);
          } else {
            setPartStyle(part, 'color: black;  background-color: #fdd;'); // failed pink
            part.state = 0;
            complain('    Error ' + xhr.status + ' sending data: ' + errorBody, true);
            beep(1.0, 128); // Other
            // @@@   Do soemthing more serious with other errors eg auth, etc
          }
        } else {
          clearStatus(true); // upstream
          setPartStyle(part); // synced
          (0,src_debug/* log */.Rm)('    Patch ok \'' + old + '\' -> \'' + newOne + '\' ');
          if (part.state === 4) {
            //  delete me
            part.state = 3;
            removePart(part);
          } else if (part.state === 3) {
            // being deleted
            // pass
          } else if (part.state === 2) {
            part.state = 1; // pending: lock
            _updateStore(part);
          } else {
            part.state = 0; // clear lock
          }
        }
      });
    };
    part.addEventListener('input', function inputChangeListener(_event) {
      // debug.log("input changed "+part.value);
      setPartStyle(part, undefined, true); // grey out - not synced
      (0,src_debug/* log */.Rm)('Input event state ' + part.state + ' value \'' + part.value + '\'');
      switch (part.state) {
        case 3:
          // being deleted
          return;
        case 4:
          // needs to be deleted
          return;
        case 2:
          // needs content updating, we know
          return;
        case 1:
          part.state = 2; // lag we need another patch
          return;
        case 0:
        case undefined:
          part.state = 1; // being upadted
          _updateStore(part);
      }
    }); // listener
  }; // addlisteners

  // @@ TODO Need to research before as it appears to be used as an Element and a boolean
  var newPartAfter = function newPartAfter(tr1, chunk, before) {
    // @@ take chunk and add listeners
    var text = kb.any(chunk, src_ns.sioc('content'));
    text = text ? text.value : '';
    var tr = dom.createElement('tr');
    if (before) {
      table.insertBefore(tr, tr1);
    } else {
      // after
      if (tr1 && tr1.nextSibling) {
        table.insertBefore(tr, tr1.nextSibling);
      } else {
        table.appendChild(tr);
      }
    }
    var part = tr.appendChild(dom.createElement('input'));
    part.subject = chunk;
    part.setAttribute('type', 'text');
    part.value = text;
    if (me) {
      setPartStyle(part, '');
      addListeners(part, chunk);
    } else {
      setPartStyle(part, 'color: #222; background-color: #fff');
      (0,src_debug/* log */.Rm)('Note can\'t add listeners - not logged in');
    }
    return part;
  };

  /* @@ TODO we need to look at indent, it can be a Number or an Object this doesn't seem correct.
  */
  var _newChunk = function newChunk(ele, before) {
    // element of chunk being split
    var kb = pad_store;
    var indent = 0;
    var queueProperty = null;
    var here, prev, next, queue, tr1;
    if (ele) {
      if (ele.tagName.toLowerCase() !== 'input') {
        (0,src_debug/* log */.Rm)('return pressed when current document is: ' + ele.tagName);
      }
      here = ele.subject;
      indent = kb.any(here, PAD('indent'));
      indent = indent ? Number(indent.value) : 0;
      if (before) {
        prev = kb.any(undefined, PAD('next'), here);
        next = here;
        queue = prev;
        queueProperty = 'newlinesAfter';
      } else {
        prev = here;
        next = kb.any(here, PAD('next'));
        queue = next;
        queueProperty = 'newlinesBefore';
      }
      tr1 = ele.parentNode;
    } else {
      prev = subject;
      next = subject;
      tr1 = undefined;
    }
    var chunk = newThing(padDoc);
    var label = chunk.uri.slice(-4);
    var del = [(0,external_$rdf_.st)(prev, PAD('next'), next, padDoc)];
    var ins = [(0,external_$rdf_.st)(prev, PAD('next'), chunk, padDoc), (0,external_$rdf_.st)(chunk, PAD('next'), next, padDoc), (0,external_$rdf_.st)(chunk, src_ns.dc('author'), me, padDoc), (0,external_$rdf_.st)(chunk, src_ns.sioc('content'), '', padDoc)];
    if (indent > 0) {
      // Do not inherit
      ins.push((0,external_$rdf_.st)(chunk, PAD('indent'), indent, padDoc));
    }
    (0,src_debug/* log */.Rm)('    Fresh chunk ' + label + ' proposed');
    if (!updater) {
      throw new Error('no updater');
    }
    updater.update(del, ins, function (uri, ok, errorBody, _xhr) {
      if (!ok) {
        // alert("Error writing new line " + label + ": " + errorBody);
        (0,src_debug/* log */.Rm)('    ERROR writing new line ' + label + ': ' + errorBody);
      } else {
        var newPart = newPartAfter(tr1, chunk, before);
        setPartStyle(newPart);
        newPart.focus(); // Note this is delayed
        if (queueProperty) {
          (0,src_debug/* log */.Rm)('    Fresh chunk ' + label + ' updated, queue = ' + queue[queueProperty]);
          queue[queueProperty] -= 1;
          if (queue[queueProperty] > 0) {
            (0,src_debug/* log */.Rm)('    Implementing queued newlines = ' + next.newLinesBefore);
            _newChunk(newPart, before);
          }
        }
      }
    });
  };
  var consistencyCheck = function consistencyCheck() {
    var found = {};
    var failed = 0;
    function complain2(msg) {
      complain(msg);
      failed++;
    }
    if (!kb.the(subject, PAD('next'))) {
      complain2('No initial next pointer');
      return false; // can't do linked list
    }
    // var chunk = kb.the(subject, PAD('next'))
    var prev = subject;
    var chunk;
    for (;;) {
      chunk = kb.the(prev, PAD('next'));
      if (!chunk) {
        complain2('No next pointer from ' + prev);
      }
      if (chunk.sameTerm(subject)) {
        break;
      }
      prev = chunk;
      var label = chunk.uri.split('#')[1];
      if (found[chunk.uri]) {
        complain2('Loop!');
        return false;
      }
      found[chunk.uri] = true;
      var k = kb.each(chunk, PAD('next')).length;
      if (k !== 1) {
        complain2('Should be 1 not ' + k + ' next pointer for ' + label);
      }
      k = kb.each(chunk, PAD('indent')).length;
      if (k > 1) {
        complain2('Should be 0 or 1 not ' + k + ' indent for ' + label);
      }
      k = kb.each(chunk, src_ns.sioc('content')).length;
      if (k !== 1) {
        complain2('Should be 1 not ' + k + ' contents for ' + label);
      }
      k = kb.each(chunk, src_ns.dc('author')).length;
      if (k !== 1) {
        complain2('Should be 1 not ' + k + ' author for ' + label);
      }
      var sts = kb.statementsMatching(undefined, src_ns.sioc('contents'));
      sts.forEach(function (st) {
        if (!found[st.subject.value]) {
          complain2('Loose chunk! ' + st.subject.value);
        }
      });
    }
    return !failed;
  };

  // Ensure that the display matches the current state of the
  // @@ TODO really need to refactor this so that we don't need to cast types
  var sync = function sync() {
    // var first = kb.the(subject, PAD('next'))
    if (kb.each(subject, PAD('next')).length !== 1) {
      var msg = 'Pad: Inconsistent data - NEXT pointers: ' + kb.each(subject, PAD('next')).length;
      (0,src_debug/* log */.Rm)(msg);
      if (options.statusArea) {
        options.statusArea.textContent += msg;
      }
      return;
    }
    var row;

    // First see which of the logical chunks have existing physical manifestations
    var manif = [];
    // Find which lines correspond to existing chunks

    for (var chunk = kb.the(subject, PAD('next')); !chunk.sameTerm(subject); chunk = kb.the(chunk, PAD('next'))) {
      for (var i = 0; i < table.children.length; i++) {
        var _tr = table.children[i];
        if (_tr.firstChild) {
          if (_tr.firstChild.subject.sameTerm(chunk)) {
            manif[chunk.uri] = _tr.firstChild;
          }
        }
      }
    }

    // Remove any deleted lines
    for (var _i = table.children.length - 1; _i >= 0; _i--) {
      row = table.children[_i];
      if (!manif[row.firstChild.subject.uri]) {
        table.removeChild(row);
      }
    }
    // Insert any new lines and update old ones
    row = table.firstChild; // might be null
    for (var _chunk = kb.the(subject, PAD('next')); !_chunk.sameTerm(subject); _chunk = kb.the(_chunk, PAD('next'))) {
      var text = kb.any(_chunk, src_ns.sioc('content')).value;
      // superstitious -- don't mess with unchanged input fields
      // which may be selected by the user
      if (row && manif[_chunk.uri]) {
        var part = row.firstChild;
        if (text !== part.value) {
          part.value = text;
        }
        setPartStyle(part);
        part.state = 0; // Clear the state machine
        delete part.lastSent; // DEBUG ONLY
        row = row.nextSibling;
      } else {
        newPartAfter(row, _chunk, true); // actually before
      }
    }
  };

  // Refresh the DOM tree

  var _refreshTree = function refreshTree(root) {
    if (root.refresh) {
      root.refresh();
      return;
    }
    for (var i = 0; i < root.children.length; i++) {
      _refreshTree(root.children[i]);
    }
  };
  var reloading = false;
  var checkAndSync = function checkAndSync() {
    (0,src_debug/* log */.Rm)('    reloaded OK');
    clearStatus();
    if (!consistencyCheck()) {
      complain('CONSISTENCY CHECK FAILED');
    } else {
      _refreshTree(table);
    }
  };
  var reloadAndSync = function reloadAndSync() {
    if (reloading) {
      (0,src_debug/* log */.Rm)('   Already reloading - stop');
      return; // once only needed
    }
    reloading = true;
    var retryTimeout = 1000; // ms
    var _tryReload = function tryReload() {
      (0,src_debug/* log */.Rm)('try reload - timeout = ' + retryTimeout);
      if (!updater) {
        throw new Error('no updater');
      }
      updater.reload(updater.store, padDoc, function (ok, message, xhr) {
        reloading = false;
        if (ok) {
          checkAndSync();
        } else {
          if (xhr.status === 0) {
            complain('Network error refreshing the pad. Retrying in ' + retryTimeout / 1000);
            reloading = true;
            retryTimeout = retryTimeout * 2;
            setTimeout(_tryReload, retryTimeout);
          } else {
            complain('Error ' + xhr.status + 'refreshing the pad:' + message + '. Stopped. ' + padDoc);
          }
        }
      });
    };
    _tryReload();
  };
  table.refresh = sync; // Catch downward propagating refresh events
  table.reloadAndSync = reloadAndSync;
  if (!me) (0,src_debug/* log */.Rm)('Warning: must be logged in for pad to be edited');
  if (exists) {
    (0,src_debug/* log */.Rm)('Existing pad.');
    if (consistencyCheck()) {
      sync();
      if (kb.holds(subject, PAD('next'), subject)) {
        // Empty list untenable
        _newChunk(); // require at least one line
      }
    } else {
      (0,src_debug/* log */.Rm)(table.textContent = 'Inconsistent data. Abort');
    }
  } else {
    // Make new pad
    (0,src_debug/* log */.Rm)('No pad exists - making new one.');
    var insertables = [(0,external_$rdf_.st)(subject, src_ns.rdf('type'), PAD('Notepad'), padDoc), (0,external_$rdf_.st)(subject, src_ns.dc('author'), me, padDoc), (0,external_$rdf_.st)(subject, src_ns.dc('created'), new Date(), padDoc), (0,external_$rdf_.st)(subject, PAD('next'), subject, padDoc)];
    if (!updater) {
      throw new Error('no updater');
    }
    updater.update([], insertables, function (uri, ok, errorBody) {
      if (!ok) {
        complain(errorBody || '');
      } else {
        (0,src_debug/* log */.Rm)('Initial pad created');
        _newChunk(); // Add a first chunck
        // getResults();
      }
    });
  }
  return table;
}

/**
 * Get the chunks of the notepad
 * They are stored in a RDF linked list
 */

// @ignore exporting this only for the unit test
function getChunks(subject, kb) {
  var chunks = [];
  for (var chunk = kb.the(subject, PAD('next')); !chunk.sameTerm(subject); chunk = kb.the(chunk, PAD('next'))) {
    chunks.push(chunk);
  }
  return chunks;
}

/**
 *  Encode content to be put in XML or HTML elements
 */
// @ignore exporting this only for the unit test
function xmlEncode(str) {
  return str.replace('&', '&amp;').replace('<', '&lt;').replace('>', '&gt;');
}

/**
 * Convert a notepad to HTML
 *   @param { } pad - the notepad
 *   @param {store} pad - the data store
 */
function notepadToHTML(pad, kb) {
  var chunks = getChunks(pad, kb);
  var html = '<html>\n  <head>\n';
  var title = kb.anyValue(pad, src_ns.dct('title'));
  if (title) {
    html += "    <title>".concat(xmlEncode(title), "</title>\n");
  }
  html += '  </head>\n  <body>\n';
  var level = 0;
  function increaseLevel(indent) {
    for (; level < indent; level++) {
      html += '<ul>\n';
    }
  }
  function decreaseLevel(indent) {
    for (; level > indent; level--) {
      html += '</ul>\n';
    }
  }
  chunks.forEach(function (chunk) {
    var indent = kb.anyJS(chunk, PAD('indent'));
    var rawContent = kb.anyJS(chunk, src_ns.sioc('content'));
    if (!rawContent) return; // seed chunk is dummy
    var content = xmlEncode(rawContent);
    if (indent < 0) {
      // negative indent levels represent heading levels
      decreaseLevel(0);
      var h = indent >= -3 ? 4 + indent : 1; // -1 -> h4, -2 -> h3
      html += "\n<h".concat(h, ">").concat(content, "</h").concat(h, ">\n");
    } else {
      // >= 0
      if (indent > 0) {
        // Lists
        decreaseLevel(indent);
        increaseLevel(indent);
        html += "<li>".concat(content, "</li>\n");
      } else {
        // indent 0
        decreaseLevel(indent);
        html += "<p>".concat(content, "</p>\n");
      }
    }
  }); // foreach chunk
  // At the end decreaseLevel any open ULs
  decreaseLevel(0);
  html += '  </body>\n</html>\n';
  return html;
}
;// ./src/chat/bookmarks.js


/**
 * Functions related to chat and bookmarks
 * @packageDocumentation
 */






 // pull in first avoid cross-refs





var bookmarks_UI = {
  icons: iconBase/* icons */.Pt,
  ns: src_ns,
  media: media,
  pad: pad_namespaceObject,
  style: style,
  utils: utils_namespaceObject,
  widgets: widgets_namespaceObject
};
var BOOK = external_$rdf_.Namespace('http://www.w3.org/2002/01/bookmark#');
var BOOKMARK_ICON = 'noun_45961.svg';
var label = label_label;
var dom = window.document || null;

// @@@@ use the one in rdflib.js when it is avaiable and delete this
function updatePromise(del, ins) {
  return new Promise(function (resolve, reject) {
    external_SolidLogic_.store.updater.update(del, ins, function (uri, ok, errorBody) {
      if (!ok) {
        reject(new Error(errorBody));
      } else {
        resolve();
      }
    }); // callback
  }); // promise
}

/*         Bookmarking
 */
/** Find a user's bookmarks
 */
function findBookmarkDocument(_x) {
  return _findBookmarkDocument.apply(this, arguments);
}

/** Add a bookmark
 */
function _findBookmarkDocument() {
  _findBookmarkDocument = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee(userContext) {
    var theClass, fileTail, isPublic, newBookmarkFile, _t;
    return regenerator_default().wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          theClass = BOOK('Bookmark');
          fileTail = 'bookmarks.ttl';
          isPublic = true;
          _context.next = 1;
          return findAppInstances(userContext, theClass, isPublic);
        case 1:
          if (!(userContext.instances && userContext.instances.length > 0)) {
            _context.next = 2;
            break;
          }
          userContext.bookmarkDocument = userContext.instances[0];
          if (userContext.instances.length > 1) {
            src_debug/* warn */.R8('More than one bookmark file! ' + userContext.instances); // @@ todo - deal with > 1
            // Note: should pick up community bookmarks as well
          }
          _context.next = 9;
          break;
        case 2:
          if (!userContext.publicProfile) {
            _context.next = 8;
            break;
          }
          // publicProfile or preferencesFile
          newBookmarkFile = external_$rdf_.sym(userContext.publicProfile.dir().uri + fileTail);
          _context.prev = 3;
          src_debug/* log */.Rm('Creating new bookmark file ' + newBookmarkFile);
          _context.next = 4;
          return external_SolidLogic_.store.fetcher.createIfNotExists(newBookmarkFile);
        case 4:
          _context.next = 6;
          break;
        case 5:
          _context.prev = 5;
          _t = _context["catch"](3);
          src_debug/* warn */.R8('Can\'t make fresh bookmark file:' + _t);
          return _context.abrupt("return", userContext);
        case 6:
          _context.next = 7;
          return external_SolidLogic_.createTypeIndexLogic.registerInTypeIndex(newBookmarkFile, userContext.index, theClass);
        case 7:
          userContext.bookmarkDocument = newBookmarkFile;
          _context.next = 9;
          break;
        case 8:
          src_debug/* warn */.R8('You seem to have no bookmark file, nor even a profile file!');
        case 9:
          return _context.abrupt("return", userContext);
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[3, 5]]);
  }));
  return _findBookmarkDocument.apply(this, arguments);
}
function addBookmark(_x2, _x3) {
  return _addBookmark.apply(this, arguments);
}
function _addBookmark() {
  _addBookmark = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee2(context, target) {
    var title, me, author, bookmarkDoc, bookmark, ins, msg, _t2;
    return regenerator_default().wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          /* like
          @prefix terms: <http://purl.org/dc/terms/>.
          @prefix bookm: <http://www.w3.org/2002/01/bookmark#>.
          @prefix n0: <http://xmlns.com/foaf/0.1/>.
          <> terms:references <#0.5534145389246576>.
          <#0.5534145389246576>
           a bookm:Bookmark;
           terms:created "2019-01-26T20:26:44.374Z"^^XML:dateTime;
           terms:title "Herons";
           bookm:recalls wiki:Heron;
           n0:maker c:me.
          */
          title = '';
          me = external_SolidLogic_.authn.currentUser(); // If already logged on
          if (me) {
            _context2.next = 1;
            break;
          }
          throw new Error('Must be logged on to add Bookmark');
        case 1:
          author = external_SolidLogic_.store.any(target, src_ns.foaf('maker'));
          title = label(author) + ': ' + external_SolidLogic_.store.anyValue(target, src_ns.sioc('content')).slice(0, 80); // @@ add chat title too?
          bookmarkDoc = context.bookmarkDocument;
          bookmark = bookmarks_UI.widgets.newThing(bookmarkDoc, title);
          ins = [external_$rdf_.st(bookmarkDoc, bookmarks_UI.ns.dct('references'), bookmark, bookmarkDoc), external_$rdf_.st(bookmark, bookmarks_UI.ns.rdf('type'), BOOK('Bookmark'), bookmarkDoc), external_$rdf_.st(bookmark, bookmarks_UI.ns.dct('created'), new Date(), bookmarkDoc), external_$rdf_.st(bookmark, BOOK('recalls'), target, bookmarkDoc), external_$rdf_.st(bookmark, bookmarks_UI.ns.foaf('maker'), me, bookmarkDoc), external_$rdf_.st(bookmark, bookmarks_UI.ns.dct('title'), title, bookmarkDoc)];
          _context2.prev = 2;
          _context2.next = 3;
          return updatePromise([], ins);
        case 3:
          _context2.next = 5;
          break;
        case 4:
          _context2.prev = 4;
          _t2 = _context2["catch"](2);
          msg = 'Making bookmark: ' + _t2;
          src_debug/* warn */.R8(msg);
          return _context2.abrupt("return", null);
        case 5:
          return _context2.abrupt("return", bookmark);
        case 6:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[2, 4]]);
  }));
  return _addBookmark.apply(this, arguments);
}
function toggleBookmark(_x4, _x5, _x6) {
  return _toggleBookmark.apply(this, arguments);
}
function _toggleBookmark() {
  _toggleBookmark = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee3(userContext, target, bookmarkButton) {
    var bookmarks, i, bookmark, _t3;
    return regenerator_default().wrap(function (_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 1;
          return external_SolidLogic_.store.fetcher.load(userContext.bookmarkDocument);
        case 1:
          bookmarks = external_SolidLogic_.store.each(null, BOOK('recalls'), target, userContext.bookmarkDocument);
          if (!bookmarks.length) {
            _context3.next = 9;
            break;
          }
          if (confirm('Delete bookmark on this?' + bookmarks.length)) {
            _context3.next = 2;
            break;
          }
          return _context3.abrupt("return");
        case 2:
          i = 0;
        case 3:
          if (!(i < bookmarks.length)) {
            _context3.next = 8;
            break;
          }
          _context3.prev = 4;
          _context3.next = 5;
          return updatePromise(external_SolidLogic_.store.connectedStatements(bookmarks[i]), []);
        case 5:
          bookmarkButton.style.backgroundColor = 'white';
          src_debug/* log */.Rm('Bookmark deleted: ' + bookmarks[i]);
          _context3.next = 7;
          break;
        case 6:
          _context3.prev = 6;
          _t3 = _context3["catch"](4);
          src_debug/* error */.z3('Cant delete bookmark:' + _t3);
          src_debug/* warn */.R8('Cannot delete bookmark:' + _t3);
        case 7:
          i++;
          _context3.next = 3;
          break;
        case 8:
          _context3.next = 11;
          break;
        case 9:
          _context3.next = 10;
          return addBookmark(userContext, target);
        case 10:
          bookmark = _context3.sent;
          bookmarkButton.style.backgroundColor = 'yellow';
          src_debug/* log */.Rm('Bookmark added: ' + bookmark);
        case 11:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[4, 6]]);
  }));
  return _toggleBookmark.apply(this, arguments);
}
function renderBookmarksButton(_x7, _x8) {
  return _renderBookmarksButton.apply(this, arguments);
}
function _renderBookmarksButton() {
  _renderBookmarksButton = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee5(userContext, target) {
    var setBookmarkButtonColor, _setBookmarkButtonColor, bookmarkButton;
    return regenerator_default().wrap(function (_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _setBookmarkButtonColor = function _setBookmarkButtonCol2() {
            _setBookmarkButtonColor = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee4(bookmarkButton) {
              var bookmarked;
              return regenerator_default().wrap(function (_context4) {
                while (1) switch (_context4.prev = _context4.next) {
                  case 0:
                    _context4.next = 1;
                    return external_SolidLogic_.store.fetcher.load(userContext.bookmarkDocument);
                  case 1:
                    bookmarked = external_SolidLogic_.store.any(null, BOOK('recalls'), bookmarkButton.target, userContext.bookmarkDocument);
                    bookmarkButton.style = bookmarks_UI.style.buttonStyle;
                    if (bookmarked) bookmarkButton.style.backgroundColor = 'yellow';
                  case 2:
                  case "end":
                    return _context4.stop();
                }
              }, _callee4);
            }));
            return _setBookmarkButtonColor.apply(this, arguments);
          };
          setBookmarkButtonColor = function _setBookmarkButtonCol(_x9) {
            return _setBookmarkButtonColor.apply(this, arguments);
          };
          if (!userContext.bookmarkDocument) {
            _context5.next = 2;
            break;
          }
          bookmarkButton = bookmarks_UI.widgets.button(dom, bookmarks_UI.icons.iconBase + BOOKMARK_ICON, label(BOOK('Bookmark')), function () {
            toggleBookmark(userContext, target, bookmarkButton);
          });
          bookmarkButton.target = target;
          _context5.next = 1;
          return setBookmarkButtonColor(bookmarkButton);
        case 1:
          return _context5.abrupt("return", bookmarkButton);
        case 2:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _renderBookmarksButton.apply(this, arguments);
}
;// ./src/chat/messageTools.js



/**
 * Tools for doing things with a message
 * Let us be creative here.  Allow all sorts of things to
 * be done to a message - linking to new or old objects in an open way
 *
 * Ideas: Bookmark, Like, star, pin at top of chat, reply as new thread,
 * If you made it originally: edit, delete, attach
 * @packageDocumentation
 */


// import { media } from '../media/index'

// import * as pad from '../pad'
 // pull in first avoid cross-refs
// import { style } from '../style'






var messageTools_dom = window.document;

// THE UNUSED ICONS are here as reminders for possible future functionality
// const BOOKMARK_ICON = 'noun_45961.svg'
// const HEART_ICON = 'noun_130259.svg' -> Add this to my (private) favorites
// const MENU_ICON = 'noun_897914.svg'
// const PAPERCLIP_ICON = 'noun_25830.svg' -> add attachments to this message
// const PIN_ICON = 'noun_562340.svg'  -> pin this message permanently in the chat UI
var PENCIL_ICON = 'noun_253504.svg'; // edit a message
// const SPANNER_ICON = 'noun_344563.svg' -> settings
var THUMBS_UP_ICON = 'noun_1384132.svg';
var THUMBS_DOWN_ICON = 'noun_1384135.svg';
var REPLY_ICON = 'noun-reply-5506924.svg';
/**
 * Emoji in Unicode
 */
var emojiMap = {};
emojiMap[src_ns.schema('AgreeAction')] = '👍';
emojiMap[src_ns.schema('DisagreeAction')] = '👎';
emojiMap[src_ns.schema('EndorseAction')] = '⭐️';
emojiMap[src_ns.schema('LikeAction')] = '❤️';
function emojiFromActionClass(action) {
  return emojiMap[action] || null;
}
function ActionClassFromEmoji(emoji) {
  for (var a in emojiMap) {
    if (emojiMap[a] === emoji) {
      return rdf.sym(a.slice(1, -1)); // remove < >
    }
  }
  return null;
}

// Allow the action to give its own emoji as content,
// or get the emoji from the class of action.
function emojiFromAction(action) {
  var content = store.any(action, ns.sioc('content'), null, action.doc());
  if (content) return content;
  var klass = store.any(action, ns.rdf('type'), null, action.doc());
  if (klass) {
    var em = emojiFromActionClass(klass);
    if (em) return em;
  }
  return '⬜️';
}

/**
 * Create strip of sentiments expressed
 */
function sentimentStrip(_x, _x2) {
  return _sentimentStrip.apply(this, arguments);
}
/**
 * Create strip of sentiments expressed, with hyperlinks
 *
 * @param target {NamedNode} - The thing about which they are expressed
 * @param doc {NamedNode} - The document in which they are expressed
 */
function _sentimentStrip() {
  _sentimentStrip = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(target, doc) {
    var versions, actions, strings;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 1;
          return allVersions(target);
        case 1:
          versions = _context.sent;
          // debug.log('sentimentStrip Versions for ' + target, versions)
          actions = versions.map(function (version) {
            return store.each(null, ns.schema('target'), version, doc);
          }).flat(); // debug.log('sentimentStrip: Actions for ' + target, actions)
          strings = actions.map(function (action) {
            return emojiFromAction(action) || '';
          });
          return _context.abrupt("return", messageTools_dom.createTextNode(strings.join(' ')));
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _sentimentStrip.apply(this, arguments);
}
function sentimentStripLinked(_x3, _x4) {
  return _sentimentStripLinked.apply(this, arguments);
}
/**
 * Creates a message toolbar component
 */
function _sentimentStripLinked() {
  _sentimentStripLinked = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee3(target, doc) {
    var strip, refresh, _refresh;
    return regenerator_default().wrap(function (_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _refresh = function _refresh3() {
            _refresh = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee2() {
              var versions, actions, sentiments;
              return regenerator_default().wrap(function (_context2) {
                while (1) switch (_context2.prev = _context2.next) {
                  case 0:
                    strip.innerHTML = '';
                    if (!isDeleted(target)) {
                      _context2.next = 1;
                      break;
                    }
                    return _context2.abrupt("return", strip);
                  case 1:
                    _context2.next = 2;
                    return chatLogic_allVersions(target);
                  case 2:
                    versions = _context2.sent;
                    // debug.log('sentimentStripLinked: Versions for ' + target, versions)
                    actions = versions.map(function (version) {
                      return external_SolidLogic_.store.each(null, src_ns.schema('target'), version, doc);
                    }).flat(); // debug.log('sentimentStripLinked: Actions for ' + target, actions)
                    if (!(actions.length === 0)) {
                      _context2.next = 3;
                      break;
                    }
                    return _context2.abrupt("return", strip);
                  case 3:
                    sentiments = actions.map(function (a) {
                      return [external_SolidLogic_.store.any(a, src_ns.rdf('type'), null, doc), external_SolidLogic_.store.any(a, src_ns.sioc('content'), null, doc), external_SolidLogic_.store.any(a, src_ns.schema('agent'), null, doc)];
                    }); // debug.log('  Actions sentiments ', sentiments)
                    sentiments.sort();
                    sentiments.forEach(function (ss) {
                      var _ss = _slicedToArray(ss, 3),
                        theClass = _ss[0],
                        content = _ss[1],
                        agent = _ss[2];
                      var res;
                      if (agent) {
                        res = messageTools_dom.createElement('a');
                        res.setAttribute('href', agent.uri);
                      } else {
                        res = messageTools_dom.createTextNode('');
                      }
                      res.textContent = content || emojiMap[theClass] || '⬜️';
                      strip.appendChild(res);
                    });
                    // debug.log('  Actions strip ', strip)
                  case 4:
                  case "end":
                    return _context2.stop();
                }
              }, _callee2);
            }));
            return _refresh.apply(this, arguments);
          };
          refresh = function _refresh2() {
            return _refresh.apply(this, arguments);
          };
          strip = messageTools_dom.createElement('span');
          refresh().then(src_debug/* log */.Rm('sentimentStripLinked: sentimentStripLinked async refreshed'));
          strip.refresh = refresh;
          return _context3.abrupt("return", strip);
        case 1:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _sentimentStripLinked.apply(this, arguments);
}
function messageToolbar(_x5, _x6, _x7, _x8) {
  return _messageToolbar.apply(this, arguments);
}
function _messageToolbar() {
  _messageToolbar = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee0(message, messageRow, userContext, channelObject) {
    var deleteMessage, _deleteMessage, editMessage, _editMessage, replyInThread, _replyInThread, div, closeToolbar, deleteThingThen, _deleteThingThen, me, sentimentButton, context1, cancelButton, _t2, _t3, _t4, _t5, _t6;
    return regenerator_default().wrap(function (_context0) {
      while (1) switch (_context0.prev = _context0.next) {
        case 0:
          sentimentButton = function _sentimentButton(context, target, icon, actionClass, doc, mutuallyExclusive) {
            function setColor() {
              button.style.backgroundColor = action ? 'yellow' : 'white';
            }
            var button = buttons_button(messageTools_dom, icon, label_label(actionClass), /*#__PURE__*/function () {
              var _ref = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee4(_event) {
                var insertMe, dirty, i, a;
                return regenerator_default().wrap(function (_context4) {
                  while (1) switch (_context4.prev = _context4.next) {
                    case 0:
                      if (!action) {
                        _context4.next = 2;
                        break;
                      }
                      _context4.next = 1;
                      return deleteThingThen(action);
                    case 1:
                      action = null;
                      setColor();
                      _context4.next = 8;
                      break;
                    case 2:
                      // no action
                      action = newThing(doc);
                      insertMe = [external_$rdf_.st(action, src_ns.schema('agent'), context.me, doc), external_$rdf_.st(action, src_ns.rdf('type'), actionClass, doc), external_$rdf_.st(action, src_ns.schema('target'), target, doc)];
                      _context4.next = 3;
                      return external_SolidLogic_.store.updater.update([], insertMe);
                    case 3:
                      setColor();
                      if (!mutuallyExclusive) {
                        _context4.next = 8;
                        break;
                      }
                      // Delete incompative sentiments
                      dirty = false;
                      i = 0;
                    case 4:
                      if (!(i < mutuallyExclusive.length)) {
                        _context4.next = 7;
                        break;
                      }
                      a = existingAction(mutuallyExclusive[i]);
                      if (!a) {
                        _context4.next = 6;
                        break;
                      }
                      _context4.next = 5;
                      return deleteThingThen(a);
                    case 5:
                      // but how refresh? refreshTree the parent?
                      dirty = true;
                    case 6:
                      i++;
                      _context4.next = 4;
                      break;
                    case 7:
                      if (dirty) {
                        // widgets.refreshTree(button.parentNode) // requires them all to be immediate siblings
                        refreshTree(messageRow); // requires them all to be immediate siblings
                      }
                    case 8:
                    case "end":
                      return _context4.stop();
                  }
                }, _callee4);
              }));
              return function (_x1) {
                return _ref.apply(this, arguments);
              };
            }());
            function existingAction(actionClass) {
              var actions = external_SolidLogic_.store.each(null, src_ns.schema('agent'), context.me, doc).filter(function (x) {
                return external_SolidLogic_.store.holds(x, src_ns.rdf('type'), actionClass, doc);
              }).filter(function (x) {
                return external_SolidLogic_.store.holds(x, src_ns.schema('target'), target, doc);
              });
              return actions.length ? actions[0] : null;
            }
            function refresh() {
              action = existingAction(actionClass);
              setColor();
            }
            var action;
            button.refresh = refresh; // If the file changes, refresh live
            refresh();
            return button;
          };
          _deleteThingThen = function _deleteThingThen3() {
            _deleteThingThen = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee9(x) {
              return regenerator_default().wrap(function (_context9) {
                while (1) switch (_context9.prev = _context9.next) {
                  case 0:
                    _context9.next = 1;
                    return external_SolidLogic_.store.updater.update(external_SolidLogic_.store.connectedStatements(x), []);
                  case 1:
                  case "end":
                    return _context9.stop();
                }
              }, _callee9);
            }));
            return _deleteThingThen.apply(this, arguments);
          };
          deleteThingThen = function _deleteThingThen2(_x0) {
            return _deleteThingThen.apply(this, arguments);
          };
          closeToolbar = function _closeToolbar() {
            div.parentElement.parentElement.removeChild(div.parentElement); // remive the TR
          };
          _replyInThread = function _replyInThread3() {
            _replyInThread = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee8() {
              var thread, options;
              return regenerator_default().wrap(function (_context8) {
                while (1) switch (_context8.prev = _context8.next) {
                  case 0:
                    _context8.next = 1;
                    return channelObject.createThread(message);
                  case 1:
                    thread = _context8.sent;
                    options = userContext.chatOptions;
                    if (options) {
                      _context8.next = 2;
                      break;
                    }
                    throw new Error('replyInThread: missing options');
                  case 2:
                    options.showThread(thread, options);
                    closeToolbar(); // a one-off action
                  case 3:
                  case "end":
                    return _context8.stop();
                }
              }, _callee8);
            }));
            return _replyInThread.apply(this, arguments);
          };
          replyInThread = function _replyInThread2() {
            return _replyInThread.apply(this, arguments);
          };
          _editMessage = function _editMessage3() {
            _editMessage = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee7(messageRow) {
              return regenerator_default().wrap(function (_context7) {
                while (1) switch (_context7.prev = _context7.next) {
                  case 0:
                    if (!(me.value === external_SolidLogic_.store.any(message, src_ns.foaf('maker')).value)) {
                      _context7.next = 1;
                      break;
                    }
                    closeToolbar(); // edit is a one-off action
                    _context7.next = 1;
                    return switchToEditor(messageRow, message, channelObject, userContext);
                  case 1:
                  case "end":
                    return _context7.stop();
                }
              }, _callee7);
            }));
            return _editMessage.apply(this, arguments);
          };
          editMessage = function _editMessage2(_x9) {
            return _editMessage.apply(this, arguments);
          };
          _deleteMessage = function _deleteMessage3() {
            _deleteMessage = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee6() {
              var author, msg, area, _t;
              return regenerator_default().wrap(function (_context6) {
                while (1) switch (_context6.prev = _context6.next) {
                  case 0:
                    author = external_SolidLogic_.store.any(message, src_ns.foaf('maker'));
                    if (me) {
                      _context6.next = 1;
                      break;
                    }
                    alert('You can\'t delete the message, you are not logged in.');
                    _context6.next = 7;
                    break;
                  case 1:
                    if (!me.sameTerm(author)) {
                      _context6.next = 6;
                      break;
                    }
                    _context6.prev = 2;
                    _context6.next = 3;
                    return channelObject.deleteMessage(message);
                  case 3:
                    _context6.next = 5;
                    break;
                  case 4:
                    _context6.prev = 4;
                    _t = _context6["catch"](2);
                    msg = 'Error deleting messaage ' + _t;
                    src_debug/* warn */.R8(msg);
                    alert(msg);
                    area = userContext.statusArea || messageRow.parentNode;
                    area.appendChild(errorMessageBlock(messageTools_dom, msg));
                  case 5:
                    messageRow.parentNode.removeChild(messageRow);
                    _context6.next = 7;
                    break;
                  case 6:
                    alert('You can\'t delete the message, you are not logged in as the author, ' + author);
                  case 7:
                    closeToolbar();
                  case 8:
                  case "end":
                    return _context6.stop();
                }
              }, _callee6, null, [[2, 4]]);
            }));
            return _deleteMessage.apply(this, arguments);
          };
          deleteMessage = function _deleteMessage2() {
            return _deleteMessage.apply(this, arguments);
          }; // alain: TODO allow chat owner to fully delete message + sentiments and replacing messages
          div = messageTools_dom.createElement('div'); // is message deleted ?
          _context0.next = 1;
          return mostRecentVersion(message).value;
        case 1:
          _t2 = _context0.sent;
          _t3 = src_ns.schema('dateDeleted').value;
          if (!(_t2 === _t3)) {
            _context0.next = 2;
            break;
          }
          return _context0.abrupt("return", div);
        case 2:
          // Things only the original author can do
          me = external_SolidLogic_.authn.currentUser(); // If already logged on
          if (me && external_SolidLogic_.store.holds(message, src_ns.foaf('maker'), me)) {
            // button to delete the message
            div.appendChild(deleteButtonWithCheck(messageTools_dom, div, 'message', deleteMessage));
            // button to edit the message
            div.appendChild(buttons_button(messageTools_dom, iconBase/* icons */.Pt.iconBase + PENCIL_ICON, 'edit', function () {
              return editMessage(messageRow);
            }));
          } // if mine
          // Things anyone can do if they have a bookmark list async
          /*
          var bookmarkButton = await bookmarks.renderBookmarksButton(userContext)
          if (bookmarkButton) {
           div.appendChild(bookmarkButton)
          }
          */
          // Things anyone can do if they have a bookmark list

          renderBookmarksButton(userContext).then(function (bookmarkButton) {
            if (bookmarkButton) div.appendChild(bookmarkButton);
          });

          /**   Button to allow user to express a sentiment (like, endorse, etc) about a target
           *
           * @param context {Object} - Provide dom and me
           * @param target {NamedNode} - The thing the user expresses an opnion about
           * @param icon {uristring} - The icon to be used for the button
           * @param actionClass {NamedNode} - The RDF class  - typically a subclass of schema:Action
           * @param doc - {NamedNode} - the Solid document iunto which the data should be written
           * @param mutuallyExclusive {Array<NamedNode>} - Any RDF classes of sentimentswhich are mutiually exclusive
           */

          // THUMBS_UP_ICON
          // https://schema.org/AgreeAction
          me = external_SolidLogic_.authn.currentUser(); // If already logged on
          _t4 = me;
          if (!_t4) {
            _context0.next = 4;
            break;
          }
          _context0.next = 3;
          return mostRecentVersion(message).value;
        case 3:
          _t5 = _context0.sent;
          _t6 = src_ns.schema('dateDeleted').value;
          _t4 = _t5 !== _t6;
        case 4:
          if (!_t4) {
            _context0.next = 5;
            break;
          }
          context1 = {
            me: me,
            dom: messageTools_dom,
            div: div
          };
          div.appendChild(sentimentButton(context1, message,
          // @@ TODO use widgets.sentimentButton
          iconBase/* icons */.Pt.iconBase + THUMBS_UP_ICON, src_ns.schema('AgreeAction'), message.doc(), [src_ns.schema('DisagreeAction')]));
          // Thumbs down
          div.appendChild(sentimentButton(context1, message, iconBase/* icons */.Pt.iconBase + THUMBS_DOWN_ICON, src_ns.schema('DisagreeAction'), message.doc(), [src_ns.schema('AgreeAction')]));
        case 5:
          // Reply buttton

          if (external_SolidLogic_.store.any(message, src_ns.dct('created'))) {
            // Looks like a messsage? Bar can be used for other things
            div.appendChild(buttons_button(messageTools_dom, iconBase/* icons */.Pt.iconBase + REPLY_ICON, 'Reply in thread', /*#__PURE__*/asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee5() {
              return regenerator_default().wrap(function (_context5) {
                while (1) switch (_context5.prev = _context5.next) {
                  case 0:
                    _context5.next = 1;
                    return replyInThread();
                  case 1:
                  case "end":
                    return _context5.stop();
                }
              }, _callee5);
            }))));
          }
          // X button to remove the tool UI itself
          cancelButton = div.appendChild(buttons_cancelButton(messageTools_dom));
          cancelButton.style["float"] = 'right';
          cancelButton.firstChild.style.opacity = '0.3';
          cancelButton.addEventListener('click', closeToolbar);
          return _context0.abrupt("return", div);
        case 6:
        case "end":
          return _context0.stop();
      }
    }, _callee0);
  }));
  return _messageToolbar.apply(this, arguments);
}
;// ./src/chat/message.js


function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function message_createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = message_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function message_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return message_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? message_arrayLikeToArray(r, a) : void 0; } }
function message_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }

/**  UI code for individual messages: display them, edit them
 *
 * @packageDocumentation
 */

/* global $rdf */
















var message_dom = window.document;
var messageBodyStyle = style.messageBodyStyle;
var message_label = label_label;

/**
 * elementForImageURI
 * HTML component for an image
 * @param imageUri
 * @param options { inlineImageHeightEms }
 * @returns HTMLAnchorElement For Image
 */
function elementForImageURI(imageUri, options) {
  var img = message_dom.createElement('img');
  var height = '10';
  if (options.inlineImageHeightEms) {
    height = ('' + options.inlineImageHeightEms).trim();
  }
  img.setAttribute('style', 'max-height: ' + height + 'em; border-radius: 1em; margin: 0.7em;');
  // widgets.makeDropTarget(img, handleURIsDroppedOnMugshot, droppedFileHandler)
  if (imageUri) img.setAttribute('src', imageUri);
  var anchor = message_dom.createElement('a');
  anchor.setAttribute('href', imageUri);
  anchor.setAttribute('target', 'images');
  anchor.appendChild(img);
  makeDraggable(img, $rdf.sym(imageUri));
  return anchor;
}
var message_anchor = function anchor(text, term) {
  // If there is no link return an element anyway
  var a = message_dom.createElement('a');
  if (term && term.uri) {
    a.setAttribute('href', term.uri);
    a.addEventListener('click', openHrefInOutlineMode, true);
    a.setAttribute('style', 'color: #3B5998; text-decoration: none; '); // font-weight: bold
  }
  a.textContent = text;
  return a;
};
function nickname(person) {
  var s = external_SolidLogic_.store.any(person, src_ns.foaf('nick'));
  if (s) return '' + s.value;
  return '' + message_label(person);
}

/**
 * creatorAndDate
 * Displays creator and date for a chat message
 * inside the `td1` element
 * @param td1
 * @param creator
 * @param date
 * @param message
 * @returns HTMLAnchorElement For Image
 */
function creatorAndDate(td1, creator, date, message) {
  var nickAnchor = td1.appendChild(message_anchor(nickname(creator), creator));
  if (creator.uri) {
    external_SolidLogic_.store.fetcher.nowOrWhenFetched(creator.doc(), undefined, function (_ok, _body) {
      nickAnchor.textContent = nickname(creator);
    });
  }
  td1.appendChild(message_dom.createElement('br'));
  td1.appendChild(message_anchor(date, message));
}

/**
 * creatorAndDateHorizontal
 * Horizontally displays creator and date for a chat message
 * inside the `td1` element
 * @param td1
 * @param creator
 * @param date
 * @param message
 * @returns HTMLAnchorElement For Image
 */
function creatorAndDateHorizontal(td1, creator, date, message) {
  var nickAnchor = td1.appendChild(message_anchor(message_label(creator), creator));
  if (creator.uri) {
    external_SolidLogic_.store.fetcher.nowOrWhenFetched(creator.doc(), undefined, function (_ok, _body) {
      nickAnchor.textContent = nickname(creator);
    });
  }
  var dateBit = td1.appendChild(message_anchor(date, message));
  dateBit.style.fontSize = '80%';
  dateBit.style.marginLeft = '1em';
  td1.appendChild(message_dom.createElement('br'));
}

/**
 * renderMessageRow
 * Renders a chat message, read-only mode
 * @param channelObject
 * @param message
 * @param fresh
 * @param options
 * @param userContext
 * @returns Message Row HTML Table Element
 */
function renderMessageRow(_x, _x2, _x3, _x4, _x5) {
  return _renderMessageRow.apply(this, arguments);
} // END OF RENDERMESSAGE
function _renderMessageRow() {
  _renderMessageRow = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee9(channelObject, message, fresh, options, userContext) {
    var unsignedMessage, colorizeByAuthor, creator, date, latestVersion, latestVersionCreator, msgId, content, versions, replies, thread, straightReplies, _iterator2, _step2, reply, signature, msg, originalMessage, edited, sortDate, messageRow, td1, img, bothDates, td2, text, isURI, para, isImage, _img, anc, bgcolor, getBgColor, strip, td3, toolsButton;
    return regenerator_default().wrap(function (_context0) {
      while (1) switch (_context0.prev = _context0.next) {
        case 0:
          getBgColor = function _getBgColor(fresh) {
            return fresh ? '#e8ffe8' : 'white';
          };
          unsignedMessage = false;
          colorizeByAuthor = options.colorizeByAuthor === '1' || options.colorizeByAuthor === true; // const id = store.any(latestVersion, ns.sioc('id'))
          // const replies = store.each(latestVersion, ns.sioc('has_reply'))
          creator = external_SolidLogic_.store.any(message, src_ns.foaf('maker'));
          date = external_SolidLogic_.store.any(message, src_ns.dct('created'));
          _context0.next = 1;
          return mostRecentVersion(message);
        case 1:
          latestVersion = _context0.sent;
          latestVersionCreator = external_SolidLogic_.store.any(latestVersion, src_ns.foaf('maker')); // use latest content if same owner, else use original
          // this is may be too strict. Should we find latest valid version if any ?
          msgId = creator.uri === (latestVersionCreator === null || latestVersionCreator === void 0 ? void 0 : latestVersionCreator.uri) ? latestVersion : message;
          content = external_SolidLogic_.store.any(msgId, src_ns.sioc('content'));
          _context0.next = 2;
          return chatLogic_allVersions(msgId);
        case 2:
          versions = _context0.sent;
          if (versions.length > 1) {
            src_debug/* log */.Rm('renderMessageRow versions: ', versions.join(',  '));
          }
          // be tolerant in accepting replies on any version of a message
          replies = versions.map(function (version) {
            return external_SolidLogic_.store.each(version, src_ns.sioc('has_reply'));
          }).flat();
          thread = null;
          straightReplies = [];
          _iterator2 = message_createForOfIteratorHelper(replies);
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              reply = _step2.value;
              if (external_SolidLogic_.store.holds(reply, src_ns.rdf('type'), src_ns.sioc('Thread'))) {
                thread = reply;
                src_debug/* log */.Rm('renderMessageRow: found thread: ' + thread);
              } else {
                straightReplies.push(reply);
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          if (straightReplies.length > 1) {
            src_debug/* log */.Rm('renderMessageRow: found normal replies: ', straightReplies);
          }
          if (!thread) {
            // thread = store.any(message, ns.sioc('has_reply'))
            thread = external_SolidLogic_.store.any(null, src_ns.sioc('has_member'), message);
          }
          // debug.log('@@@@ is thread' + thread)

          // get signature
          signature = external_SolidLogic_.store.any(msgId, $rdf.sym("".concat(SEC, "proofValue"))); // set proof message object
          msg = getBlankMsg();
          msg.id = msgId.uri;
          msg.created = external_SolidLogic_.store.any(msgId, src_ns.dct('created')).value;
          msg.content = content.value;
          msg.maker = creator.uri;

          // verify signature
          if (!(signature !== null && signature !== void 0 && signature.value)) {
            // unsigned message
            unsignedMessage = true;
            src_debug/* warn */.R8(msgId.uri + ' is unsigned'); // TODO replace with UI (colored message ?)
          } else {
            // signed message, get public key and check signature
            getPublicKey(creator).then(function (publicKey) {
              // debug.log(creator.uri + '\n' + msg.created + '\n' + msg.id + '\n' + publicKey)
              if (!publicKey) {
                src_debug/* warn */.R8('message is signed but ' + creator.uri + ' is missing publicKey');
              }
              // check that publicKey is a valid hex string
              var regex = /[0-9A-Fa-f]{6}/g;
              if (!(publicKey !== null && publicKey !== void 0 && publicKey.match(regex))) src_debug/* warn */.R8('invalid publicKey hex string\n' + creator.uri + '\n' + publicKey);
              // verify signature
              else if (signature !== null && signature !== void 0 && signature.value && !verifySignature(signature === null || signature === void 0 ? void 0 : signature.value, msg, publicKey)) src_debug/* warn */.R8('invalid signature\n' + msg.id);
            });
          }
          _context0.next = 3;
          return originalVersion(message);
        case 3:
          originalMessage = _context0.sent;
          edited = !message.sameTerm(originalMessage); // @@ load it first  @@   Or display the new data at the old date.
          // @@@ kludge!
          sortDate = external_SolidLogic_.store.the(originalMessage, src_ns.dct('created'), null, originalMessage.doc()) || external_SolidLogic_.store.the(message, src_ns.dct('created'), null, message.doc()); // In message
          messageRow = message_dom.createElement('tr');
          if (unsignedMessage) messageRow.setAttribute('style', 'background-color: red');
          messageRow.AJAR_date = sortDate.value;
          messageRow.AJAR_subject = message;
          td1 = message_dom.createElement('td');
          messageRow.appendChild(td1);
          if (!options.authorDateOnLeft) {
            img = message_dom.createElement('img');
            img.setAttribute('style', 'max-height: 2.5em; max-width: 2.5em; border-radius: 0.5em; margin: auto;');
            setImage(img, creator);
            td1.appendChild(img);
          } else {
            creatorAndDate(td1, creator, shortDate(sortDate.value), message);
          }
          bothDates = shortDate(sortDate.value);
          if (edited) {
            bothDates += ' ... ' + shortDate(date.value);
          }

          // Render the content ot the message itself
          td2 = messageRow.appendChild(message_dom.createElement('td'));
          if (!options.authorDateOnLeft) {
            creatorAndDateHorizontal(td2, creator, bothDates,
            // widgets.shortDate(dateString)
            message);
          }
          text = content ? content.value.trim() : '??? no content?';
          isURI = /^https?:\/[^ <>]*$/i.test(text);
          para = null;
          if (isURI) {
            isImage = /\.(gif|jpg|jpeg|tiff|png|svg)$/i.test(text); // @@ Should use content-type not URI
            if (isImage && options.expandImagesInline) {
              _img = elementForImageURI(text, options);
              td2.appendChild(_img);
            } else {
              // Link but not Image
              anc = td2.appendChild(message_dom.createElement('a'));
              para = anc.appendChild(message_dom.createElement('p'));
              anc.href = text;
              para.textContent = text;
              td2.appendChild(anc);
            }
          } else {
            // text
            para = message_dom.createElement('p');
            td2.appendChild(para);
            para.textContent = text;
          }
          if (para) {
            bgcolor = colorizeByAuthor ? lightColorHash(creator) : getBgColor(fresh);
            para.setAttribute('style', messageBodyStyle + 'background-color: ' + bgcolor + ';');
          }
          _context0.next = 4;
          return sentimentStripLinked(message, message.doc());
        case 4:
          strip = _context0.sent;
          if (strip.children.length) {
            td2.appendChild(message_dom.createElement('br'));
            td2.appendChild(strip);
          }

          // Message tool bar button
          td3 = message_dom.createElement('td');
          messageRow.appendChild(td3);
          toolsButton = buttons_button(message_dom, iconBase/* icons */.Pt.iconBase + 'noun_243787.svg', '...');
          td3.appendChild(toolsButton);
          toolsButton.addEventListener('click', /*#__PURE__*/function () {
            var _ref4 = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee8(_event) {
              var toolsTR, tools, toolsTD;
              return regenerator_default().wrap(function (_context9) {
                while (1) switch (_context9.prev = _context9.next) {
                  case 0:
                    if (!messageRow.toolTR) {
                      _context9.next = 1;
                      break;
                    }
                    // already got a toolbar? Toogle
                    messageRow.parentNode.removeChild(messageRow.toolTR);
                    delete messageRow.toolTR;
                    return _context9.abrupt("return");
                  case 1:
                    toolsTR = message_dom.createElement('tr');
                    _context9.next = 2;
                    return messageToolbar(message, messageRow, _objectSpread(_objectSpread({}, userContext), {}, {
                      chatOptions: options
                    }), channelObject);
                  case 2:
                    tools = _context9.sent;
                    tools.style = 'border: 0.05em solid #888; border-radius: 0 0 0.7em 0.7em;  border-top: 0; height:3.5em; background-color: #fff;'; // @@ fix
                    if (messageRow.nextSibling) {
                      messageRow.parentElement.insertBefore(toolsTR, messageRow.nextSibling);
                    } else {
                      messageRow.parentElement.appendChild(toolsTR);
                    }
                    messageRow.toolTR = toolsTR;
                    toolsTR.appendChild(message_dom.createElement('td')); // left
                    toolsTD = toolsTR.appendChild(message_dom.createElement('td'));
                    toolsTR.appendChild(message_dom.createElement('td')); // right
                    toolsTD.appendChild(tools);
                  case 3:
                  case "end":
                    return _context9.stop();
                }
              }, _callee8);
            }));
            return function (_x18) {
              return _ref4.apply(this, arguments);
            };
          }());
          if (thread && options.showThread) {
            // debug.log('  message has thread ' + thread)
            td3.appendChild(buttons_button(message_dom, iconBase/* icons */.Pt.iconBase + 'noun_1180164.svg',
            // right arrow .. @@ think of stg better
            'see thread', function (_e) {
              // debug.log('@@@@ Calling showThread thread ' + thread)
              options.showThread(thread, options);
            }));
          }
          return _context0.abrupt("return", messageRow);
        case 5:
        case "end":
          return _context0.stop();
      }
    }, _callee9);
  }));
  return _renderMessageRow.apply(this, arguments);
}
function switchToEditor(_x6, _x7, _x8, _x9) {
  return _switchToEditor.apply(this, arguments);
}
/*       Control for a new message -- or editing an old message ***************
 *
 */
function _switchToEditor() {
  _switchToEditor = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee0(messageRow, message, channelObject, userContext) {
    var messageTable, editRow, _t3, _t4, _t5, _t6, _t7;
    return regenerator_default().wrap(function (_context1) {
      while (1) switch (_context1.prev = _context1.next) {
        case 0:
          messageTable = messageRow.parentNode;
          _t3 = renderMessageEditor;
          _t4 = channelObject;
          _t5 = messageTable;
          _t6 = userContext;
          _t7 = channelObject.options;
          _context1.next = 1;
          return mostRecentVersion(message);
        case 1:
          editRow = _t3(_t4, _t5, _t6, _t7, _context1.sent);
          messageTable.insertBefore(editRow, messageRow);
          editRow.originalRow = messageRow;
          messageRow.style.visibility = 'hidden'; // Hide the original message. unhide if user cancels edit
        case 2:
        case "end":
          return _context1.stop();
      }
    }, _callee0);
  }));
  return _switchToEditor.apply(this, arguments);
}
function renderMessageEditor(channelObject, messageTable, userContext, options, originalMessage) {
  function revertEditing(messageEditor) {
    messageEditor.originalRow.style.visibility = 'visible'; // restore read-only version
    messageEditor.parentNode.removeChild(messageEditor);
  }
  function handleFieldInput(_x0) {
    return _handleFieldInput.apply(this, arguments);
  }
  function _handleFieldInput() {
    _handleFieldInput = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee5(_event) {
      return regenerator_default().wrap(function (_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 1;
            return sendMessage(field.value, true);
          case 1:
          case "end":
            return _context6.stop();
        }
      }, _callee5);
    }));
    return _handleFieldInput.apply(this, arguments);
  }
  function sendMessage(_x1, _x10) {
    return _sendMessage.apply(this, arguments);
  } // sendMessage
  //    DRAG AND DROP
  function _sendMessage() {
    _sendMessage = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee7(text, fromMainField) {
      var sendComplete, _sendComplete, message, statusArea, _t2;
      return regenerator_default().wrap(function (_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            _sendComplete = function _sendComplete3() {
              _sendComplete = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee6(message, _text2) {
                var oldRow;
                return regenerator_default().wrap(function (_context7) {
                  while (1) switch (_context7.prev = _context7.next) {
                    case 0:
                      _context7.next = 1;
                      return insertMessageIntoTable(channelObject, messageTable, message, false, options, userContext);
                    case 1:
                      // not green

                      if (originalMessage) {
                        // editing another message
                        oldRow = messageEditor.originalRow; // oldRow.style.display = '' // restore read-only version, re-attack
                        if (oldRow.parentNode) {
                          oldRow.parentNode.removeChild(oldRow); // No longer needed old version
                        } else {
                          src_debug/* warn */.R8('No parentNode on old message ' + oldRow.textContent);
                          oldRow.style.backgroundColor = '#fee';
                          oldRow.style.visibility = 'hidden'; // @@ FIX THIS AND REMOVE FROM DOM INSTEAD
                        }
                        messageEditor.parentNode.removeChild(messageEditor); // no longer need editor
                      } else {
                        if (fromMainField) {
                          field.value = ''; // clear from out for reuse
                          field.setAttribute('style', messageBodyStyle);
                          field.disabled = false;
                          field.scrollIntoView(options.newestFirst); // allign bottom (top)
                          field.focus(); // Start typing next line immediately
                          field.select();
                        }
                      }
                      // await channelObject.div.refresh() // Add new day if nec  @@ add back
                    case 2:
                    case "end":
                      return _context7.stop();
                  }
                }, _callee6);
              }));
              return _sendComplete.apply(this, arguments);
            };
            sendComplete = function _sendComplete2(_x16, _x17) {
              return _sendComplete.apply(this, arguments);
            }; // const me = authn.currentUser() // Must be logged on or wuld have got login button
            if (fromMainField) {
              field.setAttribute('style', messageBodyStyle + 'color: #bbb;'); // pendingedit
              field.disabled = true;
            }
            _context8.prev = 1;
            _context8.next = 2;
            return channelObject.updateMessage(text, originalMessage, null, options.thread);
          case 2:
            message = _context8.sent;
            _context8.next = 4;
            break;
          case 3:
            _context8.prev = 3;
            _t2 = _context8["catch"](1);
            statusArea = userContext.statusArea || messageEditor;
            statusArea.appendChild(errorMessageBlock(message_dom, 'Error writing message: ' + _t2));
            return _context8.abrupt("return");
          case 4:
            _context8.next = 5;
            return sendComplete(message, text);
          case 5:
          case "end":
            return _context8.stop();
        }
      }, _callee7, null, [[1, 3]]);
    }));
    return _sendMessage.apply(this, arguments);
  }
  function droppedFileHandler(files) {
    var base = messageTable.chatDocument.dir().uri;
    uploadFiles(external_SolidLogic_.store.fetcher, files, base + 'Files', base + 'Pictures', /*#__PURE__*/function () {
      var _ref = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee(theFile, destURI) {
        return regenerator_default().wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 1;
              return sendMessage(destURI);
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee);
      }));
      return function (_x11, _x12) {
        return _ref.apply(this, arguments);
      };
    }());
  }

  // When a set of URIs are dropped on the field
  var droppedURIHandler = /*#__PURE__*/function () {
    var _ref2 = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee2(uris) {
      var _iterator, _step, uri, _t;
      return regenerator_default().wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _iterator = message_createForOfIteratorHelper(uris);
            _context3.prev = 1;
            _iterator.s();
          case 2:
            if ((_step = _iterator.n()).done) {
              _context3.next = 4;
              break;
            }
            uri = _step.value;
            _context3.next = 3;
            return sendMessage(uri);
          case 3:
            _context3.next = 2;
            break;
          case 4:
            _context3.next = 6;
            break;
          case 5:
            _context3.prev = 5;
            _t = _context3["catch"](1);
            _iterator.e(_t);
          case 6:
            _context3.prev = 6;
            _iterator.f();
            return _context3.finish(6);
          case 7:
          case "end":
            return _context3.stop();
        }
      }, _callee2, null, [[1, 5, 6, 7]]);
    }));
    return function droppedURIHandler(_x13) {
      return _ref2.apply(this, arguments);
    };
  }();

  // When we are actually logged on
  function turnOnInput() {
    function getImageDoc() {
      imageDoc = $rdf.sym(chatDocument.dir().uri + 'Image_' + Date.now() + '.png');
      return imageDoc;
    }
    function tookPicture(_x14) {
      return _tookPicture.apply(this, arguments);
    } // Body of turnOnInput
    function _tookPicture() {
      _tookPicture = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee4(imageDoc) {
        return regenerator_default().wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (!imageDoc) {
                _context5.next = 1;
                break;
              }
              _context5.next = 1;
              return sendMessage(imageDoc.uri);
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee4);
      }));
      return _tookPicture.apply(this, arguments);
    }
    var menuButton;
    if (options.menuHandler) {
      var _menuButton = buttons_button(message_dom, iconBase/* icons */.Pt.iconBase + 'noun_243787.svg', 'More');
      _menuButton.setAttribute('style', style.buttonStyle + 'float: right;');
      // menuButton.addEventListener('click', _event => sendMessage(), false) (done in turnoninput)
      rhs.appendChild(_menuButton);
    }
    if (options.menuHandler && menuButton) {
      var _me = external_SolidLogic_.authn.currentUser();
      var menuOptions = {
        me: _me,
        dom: message_dom,
        div: null,
        // @@ was: div
        newBase: messageTable.chatDocument.dir().uri
      };
      menuButton.addEventListener('click', function (event) {
        options.menuHandler(event, channelObject.chatChannel, menuOptions);
      }, false);
    }
    var me = external_SolidLogic_.authn.currentUser(); // If already logged on
    creatorAndDate(lhs, me, '', null);
    field = message_dom.createElement('textarea');
    middle.innerHTML = '';
    middle.appendChild(field);
    field.rows = 3;
    if (originalMessage) {
      field.value = external_SolidLogic_.store.anyValue(originalMessage, src_ns.sioc('content'), null, originalMessage.doc());
    }
    // field.cols = 40
    field.setAttribute('style', messageBodyStyle + 'background-color: #eef;');

    // Trap the Enter BEFORE it is used ti make a newline

    field.addEventListener('keydown', /*#__PURE__*/function () {
      var _ref3 = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee3(e) {
        return regenerator_default().wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!(e.code === 'Enter')) {
                _context4.next = 1;
                break;
              }
              if (!(!e.shiftKey && !options.shiftEnterSendsMessage || e.shiftKey && options.shiftEnterSendsMessage)) {
                _context4.next = 1;
                break;
              }
              _context4.next = 1;
              return handleFieldInput(e);
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee3);
      }));
      return function (_x15) {
        return _ref3.apply(this, arguments);
      };
    }(), false);
    makeDropTarget(field, droppedURIHandler, droppedFileHandler);
    rhs.innerHTML = '';
    sendButton = buttons_button(message_dom, sendIcon, 'Send');
    sendButton.style["float"] = 'right';
    sendButton.addEventListener('click', function (_event) {
      return handleFieldInput();
    }, false);
    rhs.appendChild(sendButton);
    if (originalMessage) {
      // Are we editing another message?
      var cancelButton = rhs.appendChild(buttons_cancelButton(message_dom));
      cancelButton.style["float"] = 'left';
      // cancelButton.firstChild.style.opacity = '0.3' // moved to buttons
      cancelButton.addEventListener('click', function (_event) {
        return revertEditing(messageEditor);
      }, false);
      rhs.appendChild(cancelButton);
    }
    var chatDocument = channelObject.dateFolder.leafDocumentFromDate(new Date());
    var imageDoc;
    middle.appendChild(media.cameraButton(message_dom, external_SolidLogic_.store, getImageDoc, tookPicture));
    recordParticipation(channelObject.channel, channelObject.channel.doc()); // participation =
  } // turn on inpuut

  // Body of renderMessageEditor

  var sortDate, sendIcon;
  if (originalMessage) {
    sortDate = external_SolidLogic_.store.anyValue(originalMessage, src_ns.dct('created'), null, originalMessage.doc());
    // text = store.anyValue(originalMessage, ns.sioc('content'), null, originalMessage.doc())
    sendIcon = iconBase/* icons */.Pt.iconBase + 'noun_1180158.svg'; // Green check
    // cancelIcon = icons.iconBase + 'noun_1180156.svg' // Black cross
  } else {
    sendIcon = iconBase/* icons */.Pt.iconBase + 'noun_383448.svg';
    sortDate = '9999-01-01T00:00:00Z'; // ISO format for field sort
    // text = ''
  }
  var messageEditor = message_dom.createElement('tr');
  var lhs = message_dom.createElement('td');
  var middle = message_dom.createElement('td');
  var rhs = message_dom.createElement('td');
  messageEditor.appendChild(lhs);
  messageEditor.appendChild(middle);
  messageEditor.appendChild(rhs);
  messageEditor.AJAR_date = sortDate;
  // messageEditor.appendChild(dom.createElement('br'))

  var field, sendButton;
  var context = {
    div: middle,
    dom: message_dom
  };
  ensureLoggedIn(context).then(function (context) {
    // me = context.me
    turnOnInput();
    Object.assign(context, userContext);
    findBookmarkDocument(context).then(function (_context) {
      // debug.log('Bookmark file: ' + context.bookmarkDocument)
    });
  });
  return messageEditor;
} // renderMessageEditor
;// ./src/chat/infinite.js

function infinite_createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = infinite_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function infinite_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return infinite_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? infinite_arrayLikeToArray(r, a) : void 0; } }
function infinite_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }

/**
 * Contains the [[infiniteMessageArea]] class
 * @packageDocumentation
 */
// import { findBookmarkDocument } from './bookmarks'
 // pull in first avoid cross-refs




// import { style } from '../style'
// import * as utils from '../utils'

// import * as pad from '../pad'
// import { DateFolder } from './dateFolder'



// const UI = { authn, icons, ns, media, pad, $rdf, store, style, utils, widgets }

function desktopNotification(str) {
  // Let's check if the browser supports notifications
  if (!('Notification' in window)) {
    src_debug/* warn */.R8('This browser does no t support desktop notification');
  } else if (Notification.permission === 'granted') {
    // Let's check whether notificatio n permissions have already been granted
    // eslint-disable-next-line no-new
    new Notification(str);
  } else if (Notification.permission !== 'denied') {
    // Otherwise, we need to ask the user for permission
    Notification.requestPermission().then(function (permission) {
      // If the user accepts, let's create a notification
      if (permission === 'granted') {
        // eslint-disable-next-line no-new
        new Notification(str);
      }
    });
  }
  // At last, if the user has denied notifications, and you
  // want to be respectful there is no need to bother them any more.
}

/**
 * Renders a chat message inside a `messageTable`
 */
function insertMessageIntoTable(_x, _x2, _x3, _x4, _x5, _x6) {
  return _insertMessageIntoTable.apply(this, arguments);
}

/**
 * Common code for a chat (discussion area of messages about something)
 * This version runs over a series of files for different time periods
 *
 * Parameters for the whole chat like its title are stored on
 * index.ttl#this and the chats messages are stored in YYYY/MM/DD/chat.ttl
 *
 * Use to import store as param 2, now ignores it and uses the UI main store
 *
 * Options include:

 - shiftEnterSendsMessage: Use shift/enter to send message, Enter to add newline, instead of the reverse.
 - authorDateOnLeft:  Display the author's anme and date of the message in the left column instead of first above the content
 - selectedMessage: Display one message highlighted with the chat around it
 - solo: By itelf on a webpage, so user scroll anywhere in the web page scan scroll the chat.
 - newestFirst: Arrange the chat messages chronologically newest at the top insted of at the bottom
 - infinite:  Use infinite scroll
 - showDeletedMessages: Show messages which have been delted as "deleted message". Otherwise hide them.
 - expandImagesInline: If a URI by itself in a message looks like an image URI, replace it with the image
 - inlineImageHeightEms: The height (in ems) of images expaned from their URIs in the chat.

 */
function _insertMessageIntoTable() {
  _insertMessageIntoTable = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee(channelObject, messageTable, message, fresh, options, userContext) {
    var messageRow, done, ele, newestFirst, dateString;
    return regenerator_default().wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 1;
          return renderMessageRow(channelObject, message, fresh, options, userContext);
        case 1:
          messageRow = _context.sent;
          // const message = messageRow.AJAR_subject
          if (options.selectedMessage && options.selectedMessage.sameTerm(message)) {
            messageRow.style.backgroundColor = 'yellow';
            options.selectedElement = messageRow;
            messageTable.selectedElement = messageRow;
          }
          done = false;
          ele = messageTable.firstChild;
        case 2:
          if (ele) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("continue", 5);
        case 3:
          newestFirst = options.newestfirst === true;
          dateString = messageRow.AJAR_date;
          if (!(dateString > ele.AJAR_date && newestFirst || dateString < ele.AJAR_date && !newestFirst)) {
            _context.next = 4;
            break;
          }
          messageTable.insertBefore(messageRow, ele);
          done = true;
          return _context.abrupt("continue", 5);
        case 4:
          ele = ele.nextSibling;
          _context.next = 2;
          break;
        case 5:
          if (!done) {
            messageTable.appendChild(messageRow);
          }
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _insertMessageIntoTable.apply(this, arguments);
}
function infiniteMessageArea(_x7, _x8, _x9, _x0) {
  return _infiniteMessageArea.apply(this, arguments);
}
function _infiniteMessageArea() {
  _infiniteMessageArea = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee13(dom, wasStore, chatChannel, options) {
    var syncMessages, _syncMessages, addMessage, _addMessage, insertPreviousMessages, _insertPreviousMessages, removePreviousMessages, createMessageTable, _createMessageTable, renderMessageTable, _renderMessageTable, addNewChatDocumentIfNewDay, _addNewChatDocumentIfNewDay, appendCurrentMessages, _appendCurrentMessages, loadMoreWhereNeeded, _loadMoreWhereNeeded, loadInitialContent, _loadInitialContent, newestFirst, channelObject, dateFolder, div, statusArea, userContext, liveMessageTable, threadRootMessage, earliest, latest, thread, threadTime, lock;
    return regenerator_default().wrap(function (_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          _loadInitialContent = function _loadInitialContent3() {
            _loadInitialContent = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee12() {
              var yank, fixScroll, live, selectedDocument, threadRootDocument, initialDocment, now, todayDocument, selectedMessageTable, selectedDate;
              return regenerator_default().wrap(function (_context12) {
                while (1) switch (_context12.prev = _context12.next) {
                  case 0:
                    fixScroll = function _fixScroll() {
                      if (options.selectedElement) {
                        options.selectedElement.scrollIntoView({
                          block: 'center'
                        }); // align tops or bottoms
                      } else {
                        if (liveMessageTable.inputRow.scrollIntoView) {
                          liveMessageTable.inputRow.scrollIntoView(newestFirst); // align tops or bottoms
                        }
                      }
                    };
                    yank = function _yank() {
                      if (selectedMessageTable && selectedMessageTable.selectedElement) {
                        selectedMessageTable.selectedElement.scrollIntoView({
                          block: 'center'
                        });
                      }
                    }; // During initial load ONLY keep scroll to selected thing or bottom
                    if (options.selectedMessage) {
                      selectedDocument = options.selectedMessage.doc();
                    }
                    if (threadRootMessage) {
                      threadRootDocument = threadRootMessage.doc();
                    }
                    initialDocment = selectedDocument || threadRootDocument;
                    if (initialDocment) {
                      now = new Date();
                      todayDocument = dateFolder.leafDocumentFromDate(now);
                      live = todayDocument.sameTerm(initialDocment);
                    }
                    if (!(initialDocment && !live)) {
                      _context12.next = 2;
                      break;
                    }
                    selectedDate = dateFolder.dateFromLeafDocument(initialDocment);
                    _context12.next = 1;
                    return createMessageTable(selectedDate, live);
                  case 1:
                    selectedMessageTable = _context12.sent;
                    div.appendChild(selectedMessageTable);
                    earliest.messageTable = selectedMessageTable;
                    latest.messageTable = selectedMessageTable;
                    yank();
                    setTimeout(yank, 1000); // @@ kludge - restore position distubed by other cHANGES
                    _context12.next = 4;
                    break;
                  case 2:
                    _context12.next = 3;
                    return appendCurrentMessages();
                  case 3:
                    earliest.messageTable = liveMessageTable;
                    latest.messageTable = liveMessageTable;
                  case 4:
                    _context12.next = 5;
                    return loadMoreWhereNeeded(null, fixScroll);
                  case 5:
                    div.addEventListener('scroll', loadMoreWhereNeeded);
                    if (options.solo) {
                      document.body.addEventListener('scroll', loadMoreWhereNeeded);
                    }
                  case 6:
                  case "end":
                    return _context12.stop();
                }
              }, _callee12);
            }));
            return _loadInitialContent.apply(this, arguments);
          };
          loadInitialContent = function _loadInitialContent2() {
            return _loadInitialContent.apply(this, arguments);
          };
          _loadMoreWhereNeeded = function _loadMoreWhereNeeded3() {
            _loadMoreWhereNeeded = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee11(event, fixScroll) {
              var freeze, magicZone, done, scrollBottom, scrollTop;
              return regenerator_default().wrap(function (_context11) {
                while (1) switch (_context11.prev = _context11.next) {
                  case 0:
                    if (!lock) {
                      _context11.next = 1;
                      break;
                    }
                    return _context11.abrupt("return");
                  case 1:
                    lock = true;
                    freeze = !fixScroll;
                    magicZone = 150; // const top = div.scrollTop
                    // const bottom = div.scrollHeight - top - div.clientHeight
                  case 2:
                    if (!(div.scrollTop < magicZone && earliest.messageTable && !earliest.messageTable.initial && earliest.messageTable.extendBackwards)) {
                      _context11.next = 6;
                      break;
                    }
                    if (!(div.scrollHeight === 0)) {
                      _context11.next = 3;
                      break;
                    }
                    // debug.log('    chat/loadMoreWhereNeeded: trying later...')
                    setTimeout(loadMoreWhereNeeded, 2000); // couple be less
                    lock = false;
                    return _context11.abrupt("return");
                  case 3:
                    // debug.log('    chat/loadMoreWhereNeeded: Going now')
                    scrollBottom = div.scrollHeight - div.scrollTop; // debug.log('infinite scroll: adding above: top ' + div.scrollTop)
                    _context11.next = 4;
                    return earliest.messageTable.extendBackwards();
                  case 4:
                    done = _context11.sent;
                    if (freeze) {
                      div.scrollTop = div.scrollHeight - scrollBottom;
                    }
                    if (fixScroll) fixScroll();
                    if (!done) {
                      _context11.next = 5;
                      break;
                    }
                    return _context11.abrupt("continue", 6);
                  case 5:
                    _context11.next = 2;
                    break;
                  case 6:
                    if (!(options.selectedMessage &&
                    // we started in the middle not at the bottom
                    div.scrollHeight - div.scrollTop - div.clientHeight < magicZone &&
                    // we are scrolled right to the bottom
                    latest.messageTable && !latest.messageTable["final"] &&
                    // there is more data to come
                    latest.messageTable.extendForwards)) {
                      _context11.next = 9;
                      break;
                    }
                    scrollTop = div.scrollTop;
                    /* debug.log(
                      'infinite scroll: adding below: bottom: ' +
                      (div.scrollHeight - div.scrollTop - div.clientHeight)
                    ) */
                    _context11.next = 7;
                    return latest.messageTable.extendForwards();
                  case 7:
                    done = _context11.sent;
                    // then add more data on the bottom
                    if (freeze) {
                      div.scrollTop = scrollTop; // while adding below keep same things in view
                    }
                    if (fixScroll) fixScroll();
                    if (!done) {
                      _context11.next = 8;
                      break;
                    }
                    return _context11.abrupt("continue", 9);
                  case 8:
                    _context11.next = 6;
                    break;
                  case 9:
                    lock = false;
                  case 10:
                  case "end":
                    return _context11.stop();
                }
              }, _callee11);
            }));
            return _loadMoreWhereNeeded.apply(this, arguments);
          };
          loadMoreWhereNeeded = function _loadMoreWhereNeeded2(_x18, _x19) {
            return _loadMoreWhereNeeded.apply(this, arguments);
          };
          _appendCurrentMessages = function _appendCurrentMessage2() {
            _appendCurrentMessages = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee10() {
              var now, chatDocument, messageTable;
              return regenerator_default().wrap(function (_context10) {
                while (1) switch (_context10.prev = _context10.next) {
                  case 0:
                    now = new Date();
                    chatDocument = dateFolder.leafDocumentFromDate(now); /// ///////////////////////////////////////////////////////////
                    _context10.next = 1;
                    return createMessageTable(now, true);
                  case 1:
                    messageTable = _context10.sent;
                    div.appendChild(messageTable);
                    div.refresh = /*#__PURE__*/asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee1() {
                      return regenerator_default().wrap(function (_context1) {
                        while (1) switch (_context1.prev = _context1.next) {
                          case 0:
                            _context1.next = 1;
                            return addNewChatDocumentIfNewDay(new Date());
                          case 1:
                            _context1.next = 2;
                            return syncMessages(chatChannel, messageTable);
                          case 2:
                            // @@ livemessagetable??
                            desktopNotification(chatChannel);
                          case 3:
                          case "end":
                            return _context1.stop();
                        }
                      }, _callee1);
                    })); // The short chat version the live update listening is done in the pane but we do it in the widget @@
                    external_SolidLogic_.store.updater.addDownstreamChangeListener(chatDocument, div.refresh); // Live update
                    liveMessageTable = messageTable;
                    latest.messageTable = liveMessageTable;
                    return _context10.abrupt("return", messageTable);
                  case 2:
                  case "end":
                    return _context10.stop();
                }
              }, _callee10);
            }));
            return _appendCurrentMessages.apply(this, arguments);
          };
          appendCurrentMessages = function _appendCurrentMessage() {
            return _appendCurrentMessages.apply(this, arguments);
          };
          _addNewChatDocumentIfNewDay = function _addNewChatDocumentIf2() {
            _addNewChatDocumentIfNewDay = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee0() {
              var newChatDocument, oldChatDocument, sts;
              return regenerator_default().wrap(function (_context0) {
                while (1) switch (_context0.prev = _context0.next) {
                  case 0:
                    // @@ Remove listener from previous table as it is now static
                    newChatDocument = dateFolder.leafDocumentFromDate(new Date());
                    if (newChatDocument.sameTerm(latest.messageTable.chatDocument)) {
                      _context0.next = 2;
                      break;
                    }
                    // It is a new day
                    if (liveMessageTable.inputRow) {
                      liveMessageTable.removeChild(liveMessageTable.inputRow);
                      delete liveMessageTable.inputRow;
                    }
                    oldChatDocument = latest.messageTable.chatDocument;
                    _context0.next = 1;
                    return appendCurrentMessages();
                  case 1:
                    // Adding a link in the document will ping listeners to add the new block too
                    if (!external_SolidLogic_.store.holds(oldChatDocument, src_ns.rdfs('seeAlso'), newChatDocument, oldChatDocument)) {
                      sts = [external_$rdf_.st(oldChatDocument, src_ns.rdfs('seeAlso'), newChatDocument, oldChatDocument)];
                      try {
                        external_SolidLogic_.store.updater.update([], sts);
                      } catch (err) {
                        alert('Unable to link old chat file to new one:' + err);
                      }
                    }
                  case 2:
                  case "end":
                    return _context0.stop();
                }
              }, _callee0);
            }));
            return _addNewChatDocumentIfNewDay.apply(this, arguments);
          };
          addNewChatDocumentIfNewDay = function _addNewChatDocumentIf() {
            return _addNewChatDocumentIfNewDay.apply(this, arguments);
          };
          _renderMessageTable = function _renderMessageTable3() {
            _renderMessageTable = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee9(date, live) {
              var scrollBackbutton, scrollForwardButton, extendBackwards, _extendBackwards, setScrollBackbuttonIcon, extendForwards, _extendForwards, setScrollForwardButtonIcon, scrollForwardButtonHandler, _scrollForwardButtonHandler, messageTable, chatDocument, tr, test, titleTR, dateCell, scrollForwardButtonCell, sts, _iterator2, _step2, st, _t3;
              return regenerator_default().wrap(function (_context9) {
                while (1) switch (_context9.prev = _context9.next) {
                  case 0:
                    _scrollForwardButtonHandler = function _scrollForwardButtonH2() {
                      _scrollForwardButtonHandler = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee8(_event) {
                        return regenerator_default().wrap(function (_context8) {
                          while (1) switch (_context8.prev = _context8.next) {
                            case 0:
                              if (!messageTable.extendedForwards) {
                                _context8.next = 1;
                                break;
                              }
                              removePreviousMessages(false, messageTable);
                              messageTable.extendedForwards = false;
                              setScrollForwardButtonIcon();
                              _context8.next = 3;
                              break;
                            case 1:
                              _context8.next = 2;
                              return extendForwards();
                            case 2:
                              // async
                              latest.messageTable.scrollIntoView(newestFirst);
                            case 3:
                            case "end":
                              return _context8.stop();
                          }
                        }, _callee8);
                      }));
                      return _scrollForwardButtonHandler.apply(this, arguments);
                    };
                    scrollForwardButtonHandler = function _scrollForwardButtonH(_x20) {
                      return _scrollForwardButtonHandler.apply(this, arguments);
                    };
                    setScrollForwardButtonIcon = function _setScrollForwardButt() {
                      if (!scrollForwardButton) return;
                      var sense = messageTable.extendedForwards ? !newestFirst : newestFirst; // noun_T-Block_1114657_000000.svg
                      var scrollForwardIcon = messageTable["final"] ? 'noun_T-Block_1114657_000000.svg' : getScrollForwardButtonIcon(sense);
                      scrollForwardButton.firstChild.setAttribute('src', iconBase/* icons */.Pt.iconBase + scrollForwardIcon);
                      function getScrollForwardButtonIcon(sense) {
                        return !sense ? 'noun_1369241.svg' : 'noun_1369237.svg';
                      }
                    };
                    _extendForwards = function _extendForwards3() {
                      _extendForwards = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee7() {
                        var done;
                        return regenerator_default().wrap(function (_context7) {
                          while (1) switch (_context7.prev = _context7.next) {
                            case 0:
                              _context7.next = 1;
                              return insertPreviousMessages(false);
                            case 1:
                              done = _context7.sent;
                              return _context7.abrupt("return", done);
                            case 2:
                            case "end":
                              return _context7.stop();
                          }
                        }, _callee7);
                      }));
                      return _extendForwards.apply(this, arguments);
                    };
                    extendForwards = function _extendForwards2() {
                      return _extendForwards.apply(this, arguments);
                    };
                    setScrollBackbuttonIcon = function _setScrollBackbuttonI() {
                      if (!scrollBackbutton) {
                        return;
                      }
                      var sense = messageTable.extendedBack ? !newestFirst : newestFirst;
                      var scrollBackIcon = messageTable.initial ? 'noun_T-Block_1114655_000000.svg' : getScrollbackIcon(sense);
                      scrollBackbutton.firstChild.setAttribute('src', iconBase/* icons */.Pt.iconBase + scrollBackIcon);
                      function getScrollbackIcon(sense) {
                        return sense ? 'noun_1369241.svg' : 'noun_1369237.svg';
                      }
                    };
                    _extendBackwards = function _extendBackwards3() {
                      _extendBackwards = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee6() {
                        var done;
                        return regenerator_default().wrap(function (_context6) {
                          while (1) switch (_context6.prev = _context6.next) {
                            case 0:
                              _context6.next = 1;
                              return insertPreviousMessages(true);
                            case 1:
                              done = _context6.sent;
                              if (done) {
                                if (scrollBackbutton) {
                                  scrollBackbutton.firstChild.setAttribute('src', iconBase/* icons */.Pt.iconBase + 'noun_T-Block_1114655_000000.svg'); // T
                                  scrollBackbutton.disabled = true;
                                }
                                messageTable.initial = true;
                              } else {
                                messageTable.extendedBack = true;
                              }
                              setScrollBackbuttonIcon();
                              return _context6.abrupt("return", done);
                            case 2:
                            case "end":
                              return _context6.stop();
                          }
                        }, _callee6);
                      }));
                      return _extendBackwards.apply(this, arguments);
                    };
                    extendBackwards = function _extendBackwards2() {
                      return _extendBackwards.apply(this, arguments);
                    };
                    scrollBackbutton = null; // was let
                    scrollForwardButton = null; // was let
                    /// /////////////////   Scroll down adding more above
                    /// ////////////// Scroll up adding more below
                    // eslint-disable-next-line no-unused-vars
                    /// ///////////////////////
                    /*
                    options = options || {}
                    options.authorDateOnLeft = true
                    const newestFirst = options.newestFirst === '1' || options.newestFirst === true // hack for now
                    const channelObject = new ChatChannel(chatChannel, options)
                    const dateFolder = channelObject.dateFolder
                     const div = dom.createElement('div')
                    const statusArea = div.appendChild(dom.createElement('div'))
                    const userContext = { dom, statusArea, div: statusArea } // logged on state, pointers to user's stuff
                    */
                    // debug.log('Options for called message Area', options)
                    messageTable = dom.createElement('table');
                    messageTable.style.width = '100%'; // fill the pane div
                    messageTable.extendBackwards = extendBackwards; // Make function available to scroll stuff
                    messageTable.extendForwards = extendForwards; // Make function available to scroll stuff

                    messageTable.date = date;
                    chatDocument = dateFolder.leafDocumentFromDate(date);
                    messageTable.chatDocument = chatDocument;
                    messageTable.fresh = false;
                    messageTable.setAttribute('style', 'width: 100%;'); // fill that div!
                    if (live) {
                      messageTable["final"] = true;
                      liveMessageTable = messageTable;
                      latest.messageTable = messageTable;
                      tr = renderMessageEditor(channelObject, messageTable, userContext, options);
                      if (newestFirst) {
                        messageTable.insertBefore(tr, messageTable.firstChild); // If newestFirst
                      } else {
                        messageTable.appendChild(tr); // not newestFirst
                      }
                      messageTable.inputRow = tr;
                    }

                    /// ///// Infinite scroll
                    //
                    // @@ listen for swipe past end event not just button
                    test = true;
                    if (test) {
                      // ws options.infinite but need for non-infinite
                      titleTR = dom.createElement('tr');
                      /*  const scrollBackbuttonCell = titleTR.appendChild(
                        dom.createElement('td')
                      ) */
                      // up traingles: noun_1369237.svg
                      // down triangles: noun_1369241.svg
                      /*
                      const scrollBackIcon = newestFirst
                        ? 'noun_1369241.svg'
                        : 'noun_1369237.svg' // down and up arrows respoctively
                      scrollBackbutton = widgets.button(
                        dom,
                        icons.iconBase + scrollBackIcon,
                        'Previous messages ...'
                      )
                      scrollBackbuttonCell.style = 'width:3em; height:3em;'
                      scrollBackbutton.addEventListener('click', scrollBackbuttonHandler, false)
                      messageTable.extendedBack = false
                      scrollBackbuttonCell.appendChild(scrollBackbutton)
                      setScrollBackbuttonIcon()
                      */
                      dateCell = titleTR.appendChild(dom.createElement('td'));
                      dateCell.style = 'text-align: center; vertical-align: middle; color: #888; font-style: italic;';
                      dateCell.textContent = shortDate(date.toISOString(), true); // no time, only date

                      // @@@@@@@@@@@ todo move this button to other end of  message cell, o
                      scrollForwardButtonCell = titleTR.appendChild(dom.createElement('td'));
                      if (options.includeRemoveButton) {
                        scrollForwardButtonCell.appendChild(buttons_cancelButton(dom, function (_e) {
                          div.parentNode.removeChild(div);
                        }));
                      }
                      /*
                      const scrollForwardIcon = newestFirst
                        ? 'noun_1369241.svg'
                        : 'noun_1369237.svg' // down and up arrows respoctively
                      scrollForwardButton = widgets.button(
                        dom,
                        icons.iconBase + scrollForwardIcon,
                        'Later messages ...'
                      )
                      scrollForwardButtonCell.appendChild(scrollForwardButton)
                      scrollForwardButtonCell.style = 'width:3em; height:3em;'
                      scrollForwardButton.addEventListener(
                        'click',
                        scrollForwardButtonHandler,
                        false
                      )
                      messageTable.extendedForward = false
                      setScrollForwardButtonIcon()
                      */
                      messageTable.extendedForwards = false;
                      if (!newestFirst) {
                        // opposite end from the entry field
                        messageTable.insertBefore(titleTR, messageTable.firstChild); // If not newestFirst
                      } else {
                        messageTable.appendChild(titleTR); //  newestFirst
                      }
                    }
                    sts = external_SolidLogic_.store.statementsMatching(null, src_ns.wf('message'), null, chatDocument);
                    if (!live && sts.length === 0) {
                      // not todays
                      // no need buttomns at the moment
                      // messageTable.style.visibility = 'collapse' // Hide files with no messages
                    }
                    _iterator2 = infinite_createForOfIteratorHelper(sts);
                    _context9.prev = 1;
                    _iterator2.s();
                  case 2:
                    if ((_step2 = _iterator2.n()).done) {
                      _context9.next = 4;
                      break;
                    }
                    st = _step2.value;
                    _context9.next = 3;
                    return addMessage(st.object, messageTable);
                  case 3:
                    _context9.next = 2;
                    break;
                  case 4:
                    _context9.next = 6;
                    break;
                  case 5:
                    _context9.prev = 5;
                    _t3 = _context9["catch"](1);
                    _iterator2.e(_t3);
                  case 6:
                    _context9.prev = 6;
                    _iterator2.f();
                    return _context9.finish(6);
                  case 7:
                    messageTable.fresh = true; // message table updated with insertMessageIntoTable()
                    return _context9.abrupt("return", messageTable);
                  case 8:
                  case "end":
                    return _context9.stop();
                }
              }, _callee9, null, [[1, 5, 6, 7]]);
            }));
            return _renderMessageTable.apply(this, arguments);
          };
          renderMessageTable = function _renderMessageTable2(_x16, _x17) {
            return _renderMessageTable.apply(this, arguments);
          };
          _createMessageTable = function _createMessageTable3() {
            _createMessageTable = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee5(date, live) {
              var chatDocument, messageTable, statusTR, _t2;
              return regenerator_default().wrap(function (_context5) {
                while (1) switch (_context5.prev = _context5.next) {
                  case 0:
                    // debug.log('   createMessageTable for  ' + date)
                    chatDocument = dateFolder.leafDocumentFromDate(date);
                    _context5.prev = 1;
                    _context5.next = 2;
                    return external_SolidLogic_.store.fetcher.createIfNotExists(chatDocument);
                  case 2:
                    _context5.next = 7;
                    break;
                  case 3:
                    _context5.prev = 3;
                    _t2 = _context5["catch"](1);
                    messageTable = dom.createElement('table');
                    statusTR = messageTable.appendChild(dom.createElement('tr')); // ### find status in exception
                    if (!(_t2.response && _t2.response.status && _t2.response.status === 404)) {
                      _context5.next = 5;
                      break;
                    }
                    _context5.next = 4;
                    return renderMessageTable(date, live);
                  case 4:
                    return _context5.abrupt("return", _context5.sent);
                  case 5:
                    src_debug/* log */.Rm('*** Error NON 404 for chat file ' + chatDocument);
                    statusTR.appendChild(errorMessageBlock(dom, _t2, 'pink'));
                  case 6:
                    return _context5.abrupt("return", statusTR);
                  case 7:
                    _context5.next = 8;
                    return renderMessageTable(date, live);
                  case 8:
                    return _context5.abrupt("return", _context5.sent);
                  case 9:
                  case "end":
                    return _context5.stop();
                }
              }, _callee5, null, [[1, 3]]);
            }));
            return _createMessageTable.apply(this, arguments);
          };
          createMessageTable = function _createMessageTable2(_x14, _x15) {
            return _createMessageTable.apply(this, arguments);
          };
          removePreviousMessages = function _removePreviousMessag(backwards, messageTable) {
            if (backwards ? newestFirst : !newestFirst) {
              // it was put on bottom
              while (messageTable.nextSibling) {
                div.removeChild(messageTable.nextSibling);
              }
            } else {
              // it was put on top as we scroll back
              while (messageTable.previousSibling) {
                div.removeChild(messageTable.previousSibling);
              }
            }
            var extr = backwards ? earliest : latest;
            extr.messageTable = messageTable;
          };
          _insertPreviousMessages = function _insertPreviousMessag2() {
            _insertPreviousMessages = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee4(backwards) {
              var extremity, date, live, todayDoc, doc, newMessageTable;
              return regenerator_default().wrap(function (_context4) {
                while (1) switch (_context4.prev = _context4.next) {
                  case 0:
                    extremity = backwards ? earliest : latest;
                    date = extremity.messageTable.date; // day in mssecs
                    // Are we at the top of a thread?
                    if (!(backwards && earliest.limit && date <= earliest.limit)) {
                      _context4.next = 2;
                      break;
                    }
                    if (liveMessageTable) {
                      _context4.next = 1;
                      break;
                    }
                    _context4.next = 1;
                    return appendCurrentMessages();
                  case 1:
                    return _context4.abrupt("return", true);
                  case 2:
                    _context4.next = 3;
                    return dateFolder.loadPrevious(date, backwards);
                  case 3:
                    date = _context4.sent;
                    if (!(!date && !backwards && !liveMessageTable)) {
                      _context4.next = 4;
                      break;
                    }
                    _context4.next = 4;
                    return appendCurrentMessages();
                  case 4:
                    if (date) {
                      _context4.next = 5;
                      break;
                    }
                    return _context4.abrupt("return", true);
                  case 5:
                    // done
                    live = false;
                    if (!backwards) {
                      todayDoc = dateFolder.leafDocumentFromDate(new Date());
                      doc = dateFolder.leafDocumentFromDate(date);
                      live = doc.sameTerm(todayDoc); // Is this todays?
                    }
                    _context4.next = 6;
                    return createMessageTable(date, live);
                  case 6:
                    newMessageTable = _context4.sent;
                    extremity.messageTable = newMessageTable; // move pointer to earliest
                    if (backwards ? newestFirst : !newestFirst) {
                      // put on bottom or top
                      div.appendChild(newMessageTable);
                    } else {
                      // put on top as we scroll back
                      div.insertBefore(newMessageTable, div.firstChild);
                    }
                    return _context4.abrupt("return", live);
                  case 7:
                  case "end":
                    return _context4.stop();
                }
              }, _callee4);
            }));
            return _insertPreviousMessages.apply(this, arguments);
          };
          insertPreviousMessages = function _insertPreviousMessag(_x13) {
            return _insertPreviousMessages.apply(this, arguments);
          };
          _addMessage = function _addMessage3() {
            _addMessage = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee3(message, messageTable) {
              var thread, id;
              return regenerator_default().wrap(function (_context3) {
                while (1) switch (_context3.prev = _context3.next) {
                  case 0:
                    if (!(isDeleted(message) && !options.showDeletedMessages)) {
                      _context3.next = 1;
                      break;
                    }
                    return _context3.abrupt("return");
                  case 1:
                    /* if (isReplaced(message)) { //
                      return // this is old version
                    } */
                    thread = external_SolidLogic_.store.any(null, src_ns.sioc('has_member'), message, message.doc());
                    id = external_SolidLogic_.store.any(message, src_ns.sioc('id'), null, message.doc());
                    if (id && !thread) {
                      thread = external_SolidLogic_.store.any(null, src_ns.sioc('has_member'), id, message.doc());
                    }
                    if (!options.thread) {
                      _context3.next = 5;
                      break;
                    }
                    if (!external_SolidLogic_.store.holds(message, src_ns.sioc('has_reply'), options.thread)) {
                      _context3.next = 2;
                      break;
                    }
                    _context3.next = 4;
                    break;
                  case 2:
                    if (!(thread && thread.sameTerm(options.thread))) {
                      _context3.next = 3;
                      break;
                    }
                    _context3.next = 4;
                    break;
                  case 3:
                    return _context3.abrupt("return");
                  case 4:
                    _context3.next = 6;
                    break;
                  case 5:
                    if (!thread) {
                      _context3.next = 6;
                      break;
                    }
                    return _context3.abrupt("return");
                  case 6:
                    if (messageTable.fresh) {
                      _context3.next = 7;
                      break;
                    }
                    _context3.next = 7;
                    return insertMessageIntoTable(channelObject, messageTable, message, messageTable.fresh, options, userContext);
                  case 7:
                  case "end":
                    return _context3.stop();
                }
              }, _callee3);
            }));
            return _addMessage.apply(this, arguments);
          };
          addMessage = function _addMessage2(_x11, _x12) {
            return _addMessage.apply(this, arguments);
          };
          _syncMessages = function _syncMessages3() {
            _syncMessages = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee2(chatChannel, messageTable) {
              var displayed, ele, ele2, messages, stored, _iterator, _step, m, _t;
              return regenerator_default().wrap(function (_context2) {
                while (1) switch (_context2.prev = _context2.next) {
                  case 0:
                    displayed = {};
                    for (ele = messageTable.firstChild; ele; ele = ele.nextSibling) {
                      if (ele.AJAR_subject) {
                        displayed[ele.AJAR_subject.uri] = true;
                      }
                    }
                    messages = external_SolidLogic_.store.each(chatChannel, src_ns.wf('message'), null, messageTable.chatDocument);
                    stored = {};
                    _iterator = infinite_createForOfIteratorHelper(messages);
                    _context2.prev = 1;
                    _iterator.s();
                  case 2:
                    if ((_step = _iterator.n()).done) {
                      _context2.next = 4;
                      break;
                    }
                    m = _step.value;
                    stored[m.uri] = true;
                    if (displayed[m.uri]) {
                      _context2.next = 3;
                      break;
                    }
                    _context2.next = 3;
                    return addMessage(m, messageTable);
                  case 3:
                    _context2.next = 2;
                    break;
                  case 4:
                    _context2.next = 6;
                    break;
                  case 5:
                    _context2.prev = 5;
                    _t = _context2["catch"](1);
                    _iterator.e(_t);
                  case 6:
                    _context2.prev = 6;
                    _iterator.f();
                    return _context2.finish(6);
                  case 7:
                    for (ele = messageTable.firstChild; ele;) {
                      ele2 = ele.nextSibling;
                      if (ele.AJAR_subject && !stored[ele.AJAR_subject.uri]) {
                        messageTable.removeChild(ele);
                      }
                      ele = ele2;
                    }
                    for (ele = messageTable.firstChild; ele; ele = ele.nextSibling) {
                      if (ele.AJAR_subject) {
                        // Refresh thumbs up etc
                        refreshTree(ele); // Things inside may have changed too
                      }
                    }
                  case 8:
                  case "end":
                    return _context2.stop();
                }
              }, _callee2, null, [[1, 5, 6, 7]]);
            }));
            return _syncMessages.apply(this, arguments);
          };
          syncMessages = function _syncMessages2(_x1, _x10) {
            return _syncMessages.apply(this, arguments);
          }; // ///////////////////////////////////////////////////////////////////////
          // syncMessages
          // Called once per original message displayed
          /* Add a new messageTable at the top/bottom
            */
          /* Remove message tables earlier than this one
           */
          /* Load and render message table
           ** @returns DOM element generates
           */
          // renderMessageTable
          /*
          function messageCount () {
            var n = 0
            const tables = div.children
            for (let i = 0; i < tables.length; i++) {
              n += tables[i].children.length - 1
              // debug.log('    table length:' + tables[i].children.length)
            }
            return n
          }
          */
          /* Add the live message block with entry field for today
           */
          // Body of main function
          options = options || {};
          options.authorDateOnLeft = false; // @@ make a user optiosn
          newestFirst = options.newestFirst === '1' || options.newestFirst === true; // hack for now
          channelObject = new ChatChannel(chatChannel, options);
          dateFolder = channelObject.dateFolder;
          div = dom.createElement('div');
          channelObject.div = div;
          statusArea = div.appendChild(dom.createElement('div'));
          userContext = {
            dom: dom,
            statusArea: statusArea,
            div: statusArea
          }; // logged on state, pointers to user's stuff
          earliest = {
            messageTable: null
          }; // Stuff about each end of the loaded days
          latest = {
            messageTable: null
          };
          if (options.thread) {
            thread = options.thread;
            threadRootMessage = external_SolidLogic_.store.any(null, src_ns.sioc('has_reply'), thread, thread.doc());
            if (threadRootMessage) {
              threadTime = external_SolidLogic_.store.any(threadRootMessage, src_ns.dct('created'), null, threadRootMessage.doc());
              if (threadTime) {
                earliest.limit = new Date(threadTime.value);
                // debug.log(' infinite: thread start at ' + earliest.limit)
              }
            }
          }
          lock = false;
          _context13.next = 1;
          return loadInitialContent();
        case 1:
          return _context13.abrupt("return", div);
        case 2:
        case "end":
          return _context13.stop();
      }
    }, _callee13);
  }));
  return _infiniteMessageArea.apply(this, arguments);
}
;// ./src/preferences.js
//                  Solid-UI preferences
//                  =====================
//

 // pull in first avoid cross-refs




 // @ts-ignore

var preferences_kb = external_SolidLogic_.store;

// This was tabulator . preferences in the tabulator
//  Is this functionality used anywhere?
//

// used for storing user name
// @@ Deprocate these functions.  They were used for
// communication around the tabulator functionality about the user session

var value = [];
function get(k) {
  return value[k];
}
function set(k, v) {
  if (typeof v !== 'string') {
    src_debug/* log */.Rm('Non-string value of preference ' + k + ': ' + v);
    throw new Error('Non-string value of preference ' + k + ': ' + v);
  }
  this.value[k] = v;
}

// In a solid world, Preferences are stored in the web
//
// Make an RDF node for recording the common view preferences for any object
// (maybe make it in a separate file?)
function recordSharedPreferences(subject, context) {
  return new Promise(function (resolve, reject) {
    var sharedPreferences = preferences_kb.any(subject, src_ns.ui('sharedPreferences'));
    if (!sharedPreferences) {
      if (!preferences_kb.updater.editable(subject.doc())) {
        src_debug/* log */.Rm(" Cant make shared preferences, may not change ".concat(subject.doc));
        resolve(context);
      }
      var sp = external_$rdf_.sym(subject.doc().uri + '#SharedPreferences');
      var ins = [external_$rdf_.st(subject, src_ns.ui('sharedPreferences'), sp, subject.doc())];
      src_debug/* log */.Rm('Creating shared preferences ' + sp);
      preferences_kb.updater.update([], ins, function (uri, ok, errorMessage) {
        if (!ok) {
          reject(new Error('Error creating shared prefs: ' + errorMessage));
        } else {
          context.sharedPreferences = sp;
          resolve(context);
        }
      });
    } else {
      context.sharedPreferences = sharedPreferences;
      resolve(context);
    }
  });
}

// Construct a personal defaults node in the preferences file for a given class of object
//
function recordPersonalDefaults(theClass, context) {
  return new Promise(function (resolve, reject) {
    ensureLoadedPreferences(context).then(function (context) {
      if (!context.preferencesFile) {
        src_debug/* log */.Rm('Not doing private class preferences as no access to preferences file. ' + context.preferencesFileError);
        return;
      }
      var regs = preferences_kb.each(null, src_ns.solid('forClass'), theClass, context.preferencesFile);
      var ins = [];
      var prefs;
      var reg;
      if (regs.length) {
        // Use existing node if we can
        regs.forEach(function (r) {
          prefs = prefs || preferences_kb.any(r, src_ns.solid('personalDefaults'));
        });
        if (prefs) {
          context.personalDefaults = prefs; // Found one
          resolve(context);
          return;
        } else {
          prefs = newThing(context.preferencesFile);
          reg = regs[0];
        }
      } else {
        // no regs fo class
        reg = newThing(context.preferencesFile);
        ins = [external_$rdf_.st(reg, src_ns.rdf('type'), src_ns.solid('TypeRegistration'), context.preferencesFile), external_$rdf_.st(reg, src_ns.solid('forClass'), theClass, context.preferencesFile)];
      }
      prefs = newThing(context.preferencesFile);
      ins.push(external_$rdf_.st(reg, src_ns.solid('personalDefaults'), prefs, context.preferencesFile));
      preferences_kb.updater.update([], ins, function (uri, ok, errm) {
        if (!ok) {
          reject(new Error('Setting preferences for ' + theClass + ': ' + errm));
        } else {
          context.personalDefaults = prefs;
          resolve(context);
        }
      });
    }, function (err) {
      reject(err);
    });
  });
}
function renderPreferencesForm(subject, theClass, preferencesForm, context) {
  var prefContainer = context.dom.createElement('div');
  participationObject(subject, subject.doc(), context.me).then(function (participation) {
    var dom = context.dom;
    function heading(text) {
      prefContainer.appendChild(dom.createElement('h5')).textContent = text;
    }
    heading('My view of this ' + context.noun);
    appendForm(dom, prefContainer, {}, participation, preferencesForm, subject.doc(), function (ok, mes) {
      if (!ok) complain(context, mes);
    });
    heading('Everyone\'s  view of this ' + context.noun);
    recordSharedPreferences(subject, context).then(function (context) {
      var sharedPreferences = context.sharedPreferences;
      appendForm(dom, prefContainer, {}, sharedPreferences, preferencesForm, subject.doc(), function (ok, mes) {
        if (!ok) complain(context, mes);
      });
      heading('My default view of any ' + context.noun);
      recordPersonalDefaults(theClass, context).then(function (context) {
        appendForm(dom, prefContainer, {}, context.personalDefaults, preferencesForm, context.preferencesFile, function (ok, mes) {
          if (!ok) complain(context, mes);
        });
      }, function (err) {
        complain(context, err);
      });
    });
  }, function (err) {
    // parp object fails
    prefContainer.appendChild(errorMessageBlock(context.dom, err));
  });
  return prefContainer;
}

// This should be part of rdflib.js ad part of the RDFJS Standard!!

function toJS(term) {
  if (!term.datatype) return term; // Objects remain objects
  if (term.datatype.equals(src_ns.xsd('boolean'))) {
    return term.value === '1';
  }
  if (term.datatype.equals(src_ns.xsd('dateTime')) || term.datatype.equals(src_ns.xsd('date'))) {
    return new Date(term.value);
  }
  if (term.datatype.equals(src_ns.xsd('integer')) || term.datatype.equals(src_ns.xsd('float')) || term.datatype.equals(src_ns.xsd('decimal'))) {
    return Number(term.value);
  }
  return term.value;
}

// This is the function which acuakly reads and combines the preferences
//
//  @@ make it much more tolerant of missing buts of prefernces
function getPreferencesForClass(subject, theClass, predicates, context) {
  return new Promise(function (resolve, reject) {
    recordSharedPreferences(subject, context).then(function (context) {
      var sharedPreferences = context.sharedPreferences;
      if (context.me) {
        participationObject(subject, subject.doc(), context.me).then(function (participation) {
          recordPersonalDefaults(theClass, context).then(function (context) {
            var results = [];
            var personalDefaults = context.personalDefaults;
            predicates.forEach(function (pred) {
              // Order of preference: My settings on object, Global settings on object, my settings on class
              var v1 = preferences_kb.any(participation, pred) || preferences_kb.any(sharedPreferences, pred) || preferences_kb.any(personalDefaults, pred);
              if (v1) {
                results[pred.uri] = toJS(v1);
              }
            });
            resolve(results);
          }, reject);
        }, reject);
      } else {
        // no user defined, just use common prefs
        var results = [];
        predicates.forEach(function (pred) {
          var v1 = preferences_kb.any(sharedPreferences, pred);
          if (v1) {
            results[pred.uri] = toJS(v1);
          }
        });
        resolve(results);
      }
    });
  });
}

// ends
;// ./src/table.js
// Table Widget: Format an array of RDF statements as an HTML table.
//
// This can operate in one of three modes: when the class of object is given
// or when the source document from whuch data is taken is given,
// or if a prepared query object is given.
// (In principle it could operate with neither class nor document
// given but typically
// there would be too much data.)
// When the tableClass is not given, it looks for common  classes in the data,
// and gives the user the option.
//
// 2008 Written, Ilaria Liccardi  as the tableViewPane.js
// 2014 Core table widget moved into common/table.js - timbl
//






 // pull in first avoid cross-refs


var table_UI = {
  icons: iconBase/* icons */.Pt,
  log: log_namespaceObject,
  ns: src_ns,
  utils: utils_namespaceObject,
  widgets: widgets_namespaceObject
};

// UI.widgets.renderTableViewPane
function renderTableViewPane(doc, options) {
  var sourceDocument = options.sourceDocument;
  var tableClass = options.tableClass;
  var givenQuery = options.query;
  var RDFS_LITERAL = 'http://www.w3.org/2000/01/rdf-schema#Literal';
  var ns = table_UI.ns;
  var kb = external_SolidLogic_.store;
  var rowsLookup = {}; //  Persistent mapping of subject URI to dom TR

  // Predicates that are never made into columns:

  var FORBIDDEN_COLUMNS = {
    'http://www.w3.org/2002/07/owl#sameAs': true,
    'http://www.w3.org/1999/02/22-rdf-syntax-ns#type': true
  };

  // Number types defined in the XML schema:

  var XSD_NUMBER_TYPES = {
    'http://www.w3.org/2001/XMLSchema#decimal': true,
    'http://www.w3.org/2001/XMLSchema#float': true,
    'http://www.w3.org/2001/XMLSchema#double': true,
    'http://www.w3.org/2001/XMLSchema#integer': true,
    'http://www.w3.org/2001/XMLSchema#nonNegativeInteger': true,
    'http://www.w3.org/2001/XMLSchema#positiveInteger': true,
    'http://www.w3.org/2001/XMLSchema#nonPositiveInteger': true,
    'http://www.w3.org/2001/XMLSchema#negativeInteger': true,
    'http://www.w3.org/2001/XMLSchema#long': true,
    'http://www.w3.org/2001/XMLSchema#int': true,
    'http://www.w3.org/2001/XMLSchema#short': true,
    'http://www.w3.org/2001/XMLSchema#byte': true,
    'http://www.w3.org/2001/XMLSchema#unsignedLong': true,
    'http://www.w3.org/2001/XMLSchema#unsignedInt': true,
    'http://www.w3.org/2001/XMLSchema#unsignedShort': true,
    'http://www.w3.org/2001/XMLSchema#unsignedByte': true
  };
  var XSD_DATE_TYPES = {
    'http://www.w3.org/2001/XMLSchema#dateTime': true,
    'http://www.w3.org/2001/XMLSchema#date': true
  };

  // Classes that indicate an image:

  var IMAGE_TYPES = {
    'http://xmlns.com/foaf/0.1/Image': true,
    'http://purl.org/dc/terms/Image': true
  };

  // Name of the column used as a "key" value to look up the row.
  // This is necessary because in the normal view, the columns are
  // all "optional" values, meaning that we will get a result set
  // for every individual value that is found.  The row key acts
  // as an anchor that can be used to combine this information
  // back into the same row.

  var keyVariable = options.keyVariable || '?_row';
  var subjectIdCounter = 0;
  var allType, types;
  var typeSelectorDiv, addColumnDiv;

  // The last SPARQL query used:
  var lastQuery = null;
  var mostCommonType = null;
  var resultDiv = doc.createElement('div');
  resultDiv.className = 'tableViewPane';
  resultDiv.appendChild(generateControlBar()); // sets typeSelectorDiv

  var tableDiv = doc.createElement('div');
  resultDiv.appendChild(tableDiv);

  // Save a refresh function for use by caller
  resultDiv.refresh = function () {
    runQuery(table.query, table.logicalRows, table.columns, table);
    // updateTable(givenQuery, mostCommonType) // This could be a lot more incremental and efficient
  };

  // A specifically asked-for query
  var table;
  if (givenQuery) {
    table = renderTableForQuery(givenQuery);
    // lastQuery = givenQuery
    tableDiv.appendChild(table);
  } else {
    // Find the most common type and select it by default

    var s = calculateTable();
    allType = s[0];
    types = s[1];
    if (!tableClass) {
      typeSelectorDiv.appendChild(generateTypeSelector(allType, types));
    }
    mostCommonType = getMostCommonType(types);
    if (mostCommonType) {
      buildFilteredTable(mostCommonType);
    } else {
      buildFilteredTable(allType);
    }
  }
  return resultDiv;

  // /////////////////////////////////////////////////////////////////
  /*
  function closeDialog (dialog) {
    dialog.parentNode.removeChild(dialog)
  }
   function createActionButton (label, callback) {
    var button = doc.createElement('input')
    button.setAttribute('type', 'submit')
    button.setAttribute('value', label)
    button.addEventListener('click', callback, false)
    return button
  }
  // @@ Tdo:  put these  buttonsback in,
  // to allow user to see and edit and save the sparql query for the table they are looking at
  //
   function createSparqlWindow () {
    var dialog = doc.createElement('div')
     dialog.setAttribute('class', 'sparqlDialog')
     var title = doc.createElement('h3')
    title.appendChild(doc.createTextNode('Edit SPARQL query'))
     var inputbox = doc.createElement('textarea')
    inputbox.value = rdf.queryToSPARQL(lastQuery)
     dialog.appendChild(title)
    dialog.appendChild(inputbox)
     dialog.appendChild(createActionButton('Query', function () {
      var query = rdf.SPARQLToQuery(inputbox.value)
      updateTable(query)
      closeDialog(dialog)
    }))
     dialog.appendChild(createActionButton('Close', function () {
      closeDialog(dialog)
    }))
     return dialog
  }
   function sparqlButtonPressed () {
    var dialog = createSparqlWindow()
     resultDiv.appendChild(dialog)
  }
   function generateSparqlButton () {
    var image = doc.createElement('img')
    image.setAttribute('class', 'sparqlButton')
    image.setAttribute('src', UI.iconBase + 'icons/1pt5a.gif')
    image.setAttribute('alt', 'Edit SPARQL query')
     image.addEventListener('click', sparqlButtonPressed, false)
     return image
  }
  */
  // Generate the control bar displayed at the top of the screen.

  function generateControlBar() {
    var result = doc.createElement('table');
    result.setAttribute('class', 'toolbar');
    var tr = doc.createElement('tr');

    /*             @@    Add in later -- not debugged yet
            var sparqlButtonDiv = doc.createElement("td")
            sparqlButtonDiv.appendChild(generateSparqlButton())
            tr.appendChild(sparqlButtonDiv)
    */
    typeSelectorDiv = doc.createElement('td');
    tr.appendChild(typeSelectorDiv);
    addColumnDiv = doc.createElement('td');
    tr.appendChild(addColumnDiv);
    result.appendChild(tr);
    return result;
  }

  // Add the SELECT details to the query being built.

  function addSelectToQuery(query, type) {
    var selectedColumns = type.getColumns();
    for (var i = 0; i < selectedColumns.length; ++i) {
      // TODO: autogenerate nicer names for variables
      // variables have to be unambiguous

      var variable = kb.variable('_col' + i);
      query.vars.push(variable);
      selectedColumns[i].setVariable(variable);
    }
  }

  // Add WHERE details to the query being built.

  function addWhereToQuery(query, rowVar, type) {
    var queryType = type.type;
    if (!queryType) {
      queryType = kb.variable('_any');
    }

    // _row a type
    query.pat.add(rowVar, table_UI.ns.rdf('type'), queryType);
  }

  // Generate OPTIONAL column selectors.

  function addColumnsToQuery(query, rowVar, type) {
    var selectedColumns = type.getColumns();
    for (var i = 0; i < selectedColumns.length; ++i) {
      var column = selectedColumns[i];
      var formula = kb.formula();
      formula.add(rowVar, column.predicate, column.getVariable());
      query.pat.optional.push(formula);
    }
  }

  // Generate a query object from the currently-selected type
  // object.

  function generateQuery(type) {
    var query = new external_$rdf_.Query();
    var rowVar = kb.variable(keyVariable.slice(1)); // don't pass '?'

    addSelectToQuery(query, type);
    addWhereToQuery(query, rowVar, type);
    addColumnsToQuery(query, rowVar, type);
    return query;
  }

  // Build the contents of the tableDiv element, filtered according
  // to the specified type.

  function buildFilteredTable(type) {
    // Generate "add column" cell.

    clearElement(addColumnDiv);
    addColumnDiv.appendChild(generateColumnAddDropdown(type));
    var query = generateQuery(type);
    updateTable(query, type);
  }
  function updateTable(query, type) {
    // Stop the previous query from doing any updates.

    if (lastQuery) {
      lastQuery.running = false;
    }

    // Render the HTML table.

    var htmlTable = renderTableForQuery(query, type);

    // Clear the tableDiv element, and replace with the new table.

    clearElement(tableDiv);
    tableDiv.appendChild(htmlTable);

    // Save the query for the edit dialog.

    lastQuery = query;
  }

  // Remove all subelements of the specified element.

  function clearElement(element) {
    while (element.childNodes.length > 0) {
      element.removeChild(element.childNodes[0]);
    }
  }

  // A SubjectType is created for each rdf:type discovered.

  function SubjectType(type) {
    this.type = type;
    this.columns = null;
    this.allColumns = [];
    this.useCount = 0;

    // Get a list of all columns used by this type.

    this.getAllColumns = function () {
      return this.allColumns;
    };

    // Get a list of the current columns used by this type
    // (subset of allColumns)

    this.getColumns = function () {
      // The first time through, get a list of all the columns
      // and select only the six most popular columns.

      if (!this.columns) {
        var allColumns = this.getAllColumns();
        this.columns = allColumns.slice(0, 7);
      }
      return this.columns;
    };

    // Get a list of unused columns

    this.getUnusedColumns = function () {
      var allColumns = this.getAllColumns();
      var columns = this.getColumns();
      var result = [];
      for (var i = 0; i < allColumns.length; ++i) {
        if (columns.indexOf(allColumns[i]) === -1) {
          result.push(allColumns[i]);
        }
      }
      return result;
    };
    this.addColumn = function (column) {
      this.columns.push(column);
    };
    this.removeColumn = function (column) {
      this.columns = this.columns.filter(function (x) {
        return x !== column;
      });
    };
    this.getLabel = function () {
      return label_label(this.type);
    };
    this.addUse = function () {
      this.useCount += 1;
    };
  }

  // Class representing a column in the table.

  function Column() {
    this.useCount = 0;

    // Have we checked any values for this column yet?

    this.checkedAnyValues = false;

    // If the range is unknown, but we just get literals in this
    // column, then we can generate a literal selector.

    this.possiblyLiteral = true;

    // If the range is unknown, but we just get literals and they
    // match the regular expression for numbers, we can generate
    // a number selector.

    this.possiblyNumber = true;

    // We accumulate classes which things in the column must be a member of

    this.constraints = [];

    // Check values as they are read.  If we don't know what the
    // range is, we might be able to infer that it is a literal
    // if all of the values are literals.  Similarly, we might
    // be able to determine if the literal values are actually
    // numbers (using regexps).

    this.checkValue = function (term) {
      var termType = term.termType;
      if (this.possiblyLiteral && termType !== 'Literal' && termType !== 'NamedNode') {
        this.possiblyNumber = false;
        this.possiblyLiteral = false;
      } else if (this.possiblyNumber) {
        if (termType !== 'Literal') {
          this.possiblyNumber = false;
        } else {
          var literalValue = term.value;
          if (!literalValue.match(/^-?\d+(\.\d*)?$/)) {
            this.possiblyNumber = false;
          }
        }
      }
      this.checkedAnyValues = true;
    };
    this.getVariable = function () {
      return this.variable;
    };
    this.setVariable = function (variable) {
      this.variable = variable;
    };
    this.getKey = function () {
      return this.variable.toString();
    };
    this.addUse = function () {
      this.useCount += 1;
    };
    this.getHints = function () {
      if (options && options.hints && this.variable && options.hints[this.variable.toNT()]) {
        return options.hints[this.variable.toNT()];
      }
      return {};
    };
    this.getLabel = function () {
      if (this.getHints().label) {
        return this.getHints().label;
      }
      if (this.predicate) {
        if (this.predicate.sameTerm(ns.rdf('type')) && this.superClass) {
          return label_label(this.superClass, true); // do initial cap
        }
        return label_label(this.predicate);
      } else if (this.variable) {
        return this.variable.toString();
      } else {
        return 'unlabeled column?';
      }
    };
    this.setPredicate = function (predicate, inverse, other) {
      if (inverse) {
        // variable is in the subject pos
        this.inverse = predicate;
        this.constraints = this.constraints.concat(kb.each(predicate, table_UI.ns.rdfs('domain')));
        if (predicate.sameTerm(ns.rdfs('subClassOf')) && other.termType === 'NamedNode') {
          this.superClass = other;
          this.alternatives = kb.each(undefined, ns.rdfs('subClassOf'), other);
        }
      } else {
        // variable is the object
        this.predicate = predicate;
        this.constraints = this.constraints.concat(kb.each(predicate, table_UI.ns.rdfs('range')));
      }
    };
    this.getConstraints = function () {
      return this.constraints;
    };
    this.filterFunction = function () {
      return true;
    };
    this.sortKey = function () {
      return this.getLabel().toLowerCase();
    };
    this.isImageColumn = function () {
      for (var i = 0; i < this.constraints.length; i++) {
        if (this.constraints[i].uri in IMAGE_TYPES) return true;
      }
      return false;
    };
  }

  // Convert an object to an array.

  function objectToArray(obj, filter) {
    var result = [];
    for (var property in obj) {
      // @@@ have to guard against methods
      var value = obj[property];
      if (!filter || filter(property, value)) {
        result.push(value);
      }
    }
    return result;
  }

  // Generate an <option> in a drop-down list.

  function optionElement(label, value) {
    var result = doc.createElement('option');
    result.setAttribute('value', value);
    result.appendChild(doc.createTextNode(label));
    return result;
  }

  // Generate drop-down list box for choosing type of data displayed

  function generateTypeSelector(allType, types) {
    var resultDiv = doc.createElement('div');
    resultDiv.appendChild(doc.createTextNode('Select type: '));
    var dropdown = doc.createElement('select');
    dropdown.appendChild(optionElement('All types', 'null'));
    for (var uri in types) {
      dropdown.appendChild(optionElement(types[uri].getLabel(), uri));
    }
    dropdown.addEventListener('click', function () {
      var type;
      if (dropdown.value === 'null') {
        type = allType;
      } else {
        type = types[dropdown.value];
      }
      typeSelectorChanged(type);
    }, false);
    resultDiv.appendChild(dropdown);
    return resultDiv;
  }

  // Callback invoked when the type selector drop-down list is changed.

  function typeSelectorChanged(selectedType) {
    buildFilteredTable(selectedType);
  }

  // Build drop-down list to add a new column

  function generateColumnAddDropdown(type) {
    var resultDiv = doc.createElement('div');
    var unusedColumns = type.getUnusedColumns();
    unusedColumns.sort(function (a, b) {
      var aLabel = a.sortKey();
      var bLabel = b.sortKey();
      return (aLabel > bLabel) - (aLabel < bLabel);
    });

    // If there are no unused columns, the div is empty.

    if (unusedColumns.length > 0) {
      resultDiv.appendChild(doc.createTextNode('Add column: '));

      // Build dropdown list of unused columns.

      var dropdown = doc.createElement('select');
      dropdown.appendChild(optionElement('', '-1'));
      for (var i = 0; i < unusedColumns.length; ++i) {
        var column = unusedColumns[i];
        dropdown.appendChild(optionElement(column.getLabel(), '' + i));
      }
      resultDiv.appendChild(dropdown);

      // Invoke callback when the dropdown is changed, to add
      // the column and reload the table.

      dropdown.addEventListener('click', function () {
        var columnIndex = Number(dropdown.value);
        if (columnIndex >= 0) {
          type.addColumn(unusedColumns[columnIndex]);
          buildFilteredTable(type);
        }
      }, false);
    }
    return resultDiv;
  }

  // Find the column for a given variable

  function getColumnForVariable(columns, variableNT) {
    for (var predicateUri in columns) {
      var column = columns[predicateUri];
      if (column.variable.toNT() === variableNT) {
        return column;
      }
    }
    throw new Error("getColumnForVariable: no column for variable ".concat(variableNT));
    // return null
  }

  // Find the column for a given predicate, creating a new column object
  // if necessary.

  function getColumnForPredicate(columns, predicate) {
    var column;
    if (predicate.uri in columns) {
      column = columns[predicate.uri];
    } else {
      column = new Column();
      column.setPredicate(predicate);
      columns[predicate.uri] = column;
    }
    return column;
  }

  // Find a type by its URI, creating a new SubjectType object if
  // necessary.

  function getTypeForObject(types, type) {
    var subjectType;
    if (type.uri in types) {
      subjectType = types[type.uri];
    } else {
      subjectType = new SubjectType(type);
      types[type.uri] = subjectType;
    }
    return subjectType;
  }

  // Discover types and subjects for search.

  function discoverTypes() {
    // rdf:type properties of subjects, indexed by URI for the type.

    var types = {};

    // Get a list of statements that match:  ? rdfs:type ?
    // From this we can get a list of subjects and types.

    var subjectList = kb.statementsMatching(undefined, table_UI.ns.rdf('type'), tableClass,
    // can be undefined OR
    sourceDocument); // can be undefined

    // Subjects for later lookup.  This is a mapping of type URIs to
    // lists of subjects (it is necessary to record the type of
    // a subject).

    var subjects = {};
    for (var i = 0; i < subjectList.length; ++i) {
      var type = subjectList[i].object;
      if (type.termType !== 'NamedNode') {
        // @@ no bnodes?
        continue;
      }
      var typeObj = getTypeForObject(types, type);
      if (!(type.uri in subjects)) {
        subjects[type.uri] = [];
      }
      subjects[type.uri].push(subjectList[i].subject);
      typeObj.addUse();
    }
    return [subjects, types];
  }

  // Get columns for the given subject.

  function getSubjectProperties(subject, columns) {
    // Get a list of properties of this subject.

    var properties = kb.statementsMatching(subject, undefined, undefined, sourceDocument);
    var result = {};
    for (var j = 0; j < properties.length; ++j) {
      var predicate = properties[j].predicate;
      if (predicate.uri in FORBIDDEN_COLUMNS) {
        continue;
      }

      // Find/create a column for this predicate.

      var column = getColumnForPredicate(columns, predicate);
      column.checkValue(properties[j].object);
      result[predicate.uri] = column;
    }
    return result;
  }

  // Identify the columns associated with a type.

  function identifyColumnsForType(type, subjects) {
    var allColumns = {};

    // Process each subject of this type to build up the
    // column list.

    for (var i = 0; i < subjects.length; ++i) {
      var columns = getSubjectProperties(subjects[i], allColumns);
      for (var predicateUri in columns) {
        var column = columns[predicateUri];
        column.addUse();
      }
    }

    // Generate the columns list

    var allColumnsList = objectToArray(allColumns);
    sortColumns(allColumnsList);
    type.allColumns = allColumnsList;
  }

  // Build table information from parsing RDF statements.

  function calculateTable() {
    // Find the types that we will display in the dropdown
    // list box, and associated objects of those types.

    var subjects, types;
    var s = discoverTypes();
    // eslint-disable-next-line prefer-const
    subjects = s[0];
    // eslint-disable-next-line prefer-const
    types = s[1]; // no [ ] on LHS

    for (var typeUrl in subjects) {
      var subjectList = subjects[typeUrl];
      var type = types[typeUrl];
      identifyColumnsForType(type, subjectList);
    }

    // TODO: Special type that captures all rows.
    // Combine columns from all types

    var allType = new SubjectType(null);
    return [allType, objectToArray(types)];
  }

  // Sort the list of columns by the most common columns.

  function sortColumns(columns) {
    function sortFunction(a, b) {
      return (a.useCount < b.useCount) - (a.useCount > b.useCount);
    }
    columns.sort(sortFunction);
  }

  // Create the delete button for a column.

  function renderColumnDeleteButton(type, column) {
    var button = doc.createElement('a');
    button.appendChild(doc.createTextNode('[x]'));
    button.addEventListener('click', function () {
      type.removeColumn(column);
      buildFilteredTable(type);
    }, false);
    return button;
  }

  // Render the table header for the HTML table.

  function renderTableHeader(columns, type) {
    var tr = doc.createElement('tr');

    /* Empty header for link column */
    var linkTd = doc.createElement('th');
    tr.appendChild(linkTd);
    for (var i = 0; i < columns.length; ++i) {
      var th = doc.createElement('th');
      var column = columns[i];
      th.appendChild(doc.createTextNode(column.getLabel()));

      // We can only add a delete button if we are using the
      // proper interface and have a type to delete from:
      if (type) {
        th.appendChild(renderColumnDeleteButton(type, column));
      }
      tr.appendChild(th);
    }
    return tr;
  }

  // Sort the rows in the rendered table by data from a specific
  // column, using the provided sort function to compare values.

  function applyColumnSort(rows, column, sortFunction, reverse) {
    var columnKey = column.getKey();

    // Sort the rows array.
    rows.sort(function (row1, row2) {
      var row1Value = null;
      var row2Value = null;
      if (columnKey in row1.values) {
        row1Value = row1.values[columnKey][0];
      }
      if (columnKey in row2.values) {
        row2Value = row2.values[columnKey][0];
      }
      var result = sortFunction(row1Value, row2Value);
      if (reverse) {
        return -result;
      } else {
        return result;
      }
    });

    // Remove all rows from the table:

    if (rows.length) {
      var parentTable = rows[0]._htmlRow.parentNode;
      for (var i = 0; i < rows.length; ++i) {
        parentTable.removeChild(rows[i]._htmlRow);
      }

      // Add back the rows in the new sorted order:

      for (var _i = 0; _i < rows.length; ++_i) {
        parentTable.appendChild(rows[_i]._htmlRow);
      }
    }
  }

  // Filter the list of rows based on the selectors for the
  // columns.

  function applyColumnFiltersToRow(row, columns) {
    var rowDisplayed = true;

    // Check the filter functions for every column.
    // The row should only be displayed if the filter functions
    // for all of the columns return true.

    for (var c = 0; c < columns.length; ++c) {
      var column = columns[c];
      var columnKey = column.getKey();
      var columnValue = null;
      if (columnKey in row.values) {
        columnValue = row.values[columnKey][0];
      }
      if (!column.filterFunction(columnValue)) {
        rowDisplayed = false;
        break;
      }
    }

    // Show or hide the HTML row according to the result
    // from the filter function.

    var htmlRow = row._htmlRow;
    if (rowDisplayed) {
      htmlRow.style.display = '';
    } else {
      htmlRow.style.display = 'none';
    }
  }

  // Filter the list of rows based on the selectors for the
  // columns.

  function applyColumnFilters(rows, columns) {
    // Apply filterFunction to each row.

    for (var r = 0; r < rows.length; ++r) {
      var row = rows[r];
      applyColumnFiltersToRow(row, columns);
    }
  }

  // /////////////////////////////////// Literal column handling

  // Sort by literal value

  function literalSort(rows, column, reverse) {
    function literalToString(colValue) {
      if (colValue) {
        if (colValue.termType === 'Literal') {
          return colValue.value.toLowerCase();
        } else if (colValue.termType === 'NamedNode') {
          return label_label(colValue).toLowerCase();
        }
        return colValue.value.toLowerCase();
      } else {
        return '';
      }
    }
    function literalCompare(value1, value2) {
      var strValue1 = literalToString(value1);
      var strValue2 = literalToString(value2);
      if (strValue1 < strValue2) {
        return -1;
      } else if (strValue1 > strValue2) {
        return 1;
      } else {
        return 0;
      }
    }
    applyColumnSort(rows, column, literalCompare, reverse);
  }

  // Generates a selector for an RDF literal column.

  function renderLiteralSelector(rows, columns, column) {
    var result = doc.createElement('div');
    var textBox = doc.createElement('input');
    textBox.setAttribute('type', 'text');
    textBox.style.width = '70%';
    result.appendChild(textBox);
    var sort1 = doc.createElement('span');
    sort1.appendChild(doc.createTextNode("\u25BC"));
    sort1.addEventListener('click', function () {
      literalSort(rows, column, false);
    }, false);
    result.appendChild(sort1);
    var sort2 = doc.createElement('span');
    sort2.appendChild(doc.createTextNode("\u25B2"));
    sort2.addEventListener('click', function () {
      literalSort(rows, column, true);
    }, false);
    result.appendChild(sort2);
    var substring = null;

    // Filter the table to show only rows that have a particular
    // substring in the specified column.

    column.filterFunction = function (colValue) {
      if (!substring) {
        return true;
      } else if (!colValue) {
        return false;
      } else {
        var literalValue;
        if (colValue.termType === 'Literal') {
          literalValue = colValue.value;
        } else if (colValue.termType === 'NamedNode') {
          literalValue = label_label(colValue);
        } else {
          literalValue = '';
        }
        return literalValue.toLowerCase().indexOf(substring) >= 0;
      }
    };
    textBox.addEventListener('keyup', function () {
      if (textBox.value !== '') {
        substring = textBox.value.toLowerCase();
      } else {
        substring = null;
      }
      applyColumnFilters(rows, columns);
    }, false);
    return result;
  }

  // ///////////////////////////////////  Enumeration

  // Generates a dropdown selector for enumeration types include
  //
  //  @param rows,
  //  @param columns, the mapping of predictae URIs to columns
  //  @param column,
  //  @param list,    List of alternative terms
  //
  function renderEnumSelector(rows, columns, column, list) {
    var doMultiple = true;
    var result = doc.createElement('div');
    var dropdown = doc.createElement('select');
    var searchValue = {}; // Defualt to all enabled
    for (var i = 0; i < list.length; ++i) {
      var value = list[i];
      searchValue[value.uri] = true;
    }
    var initialSelection = getHints(column).initialSelection;
    if (initialSelection) searchValue = initialSelection;
    if (doMultiple) dropdown.setAttribute('multiple', 'true');else dropdown.appendChild(optionElement('(All)', '-1'));
    for (var _i2 = 0; _i2 < list.length; ++_i2) {
      var _value = list[_i2];
      var ele = optionElement(label_label(_value), _i2);
      if (searchValue[_value.uri]) ele.selected = true;
      dropdown.appendChild(ele);
    }
    result.appendChild(dropdown);

    // Select based on an enum value.

    column.filterFunction = function (colValue) {
      return !searchValue || colValue && searchValue[colValue.uri];
    };
    dropdown.addEventListener('click', function () {
      if (doMultiple) {
        searchValue = {};
        var opt = dropdown.options;
        for (var _i3 = 0; _i3 < opt.length; _i3++) {
          var option = opt[_i3];
          var index = Number(option.value);
          if (opt[_i3].selected) searchValue[list[index].uri] = true;
        }
      } else {
        var _index = Number(dropdown.value); // adjusted in Standard tweaks 2018-01
        if (_index < 0) {
          searchValue = null;
        } else {
          searchValue = {};
          searchValue[list[_index].uri] = true;
        }
      }
      applyColumnFilters(rows, columns);
    }, true);
    return result;
  }

  // //////////////////////////////////// Numeric
  //
  // Selector for XSD number types.

  function renderNumberSelector(rows, columns, column) {
    var result = doc.createElement('div');
    var minSelector = doc.createElement('input');
    minSelector.setAttribute('type', 'text');
    minSelector.style.width = '40px';
    result.appendChild(minSelector);
    var maxSelector = doc.createElement('input');
    maxSelector.setAttribute('type', 'text');
    maxSelector.style.width = '40px';
    result.appendChild(maxSelector);

    // Select based on minimum/maximum limits.

    var min = null;
    var max = null;
    column.filterFunction = function (colValue) {
      if (colValue) {
        colValue = Number(colValue);
      }
      if (min && (!colValue || colValue < min)) {
        return false;
      }
      if (max && (!colValue || colValue > max)) {
        return false;
      }
      return true;
    };

    // When the values in the boxes are changed, update the
    // displayed columns.

    function eventListener() {
      if (minSelector.value === '') {
        min = null;
      } else {
        min = Number(minSelector.value);
      }
      if (maxSelector.value === '') {
        max = null;
      } else {
        max = Number(maxSelector.value);
      }
      applyColumnFilters(rows, columns);
    }
    minSelector.addEventListener('keyup', eventListener, false);
    maxSelector.addEventListener('keyup', eventListener, false);
    return result;
  }

  // /////////////////////////////////////////////////////////////////

  // Fallback attempts at generating a selector if other attempts fail.

  function fallbackRenderTableSelector(rows, columns, column) {
    // Have all values matched as numbers?

    if (column.checkedAnyValues && column.possiblyNumber) {
      return renderNumberSelector(rows, columns, column);
    }

    // Have all values been literals?

    if (column.possiblyLiteral) {
      return renderLiteralSelector(rows, columns, column);
    }
    return null;
  }

  // Render a selector for a given row.

  function renderTableSelector(rows, columns, column) {
    // What type of data is in this column?  Check the constraints for
    // this predicate.

    // If this is a class which can be one of various sibling classes?
    if (column.superClass && column.alternatives.length > 0) {
      return renderEnumSelector(rows, columns, column, column.alternatives);
    }
    var cs = column.getConstraints();
    var range;
    for (var i = 0; i < cs.length; i++) {
      range = cs[i];

      // Is this a number type?
      // Alternatively, is this an rdf:Literal type where all of
      // the values match as numbers?

      if (column.checkedAnyValues && column.possiblyNumber || range.uri in XSD_NUMBER_TYPES) {
        return renderNumberSelector(rows, columns, column);
      }

      // rdf:Literal?  Assume a string at this point

      if (range.uri === RDFS_LITERAL) {
        return renderLiteralSelector(rows, columns, column);
      }

      // Is this an enumeration type?

      // Also  ToDo: @@@ Handle membership of classes whcih are disjointUnions

      var choices = kb.each(range, table_UI.ns.owl('oneOf'));
      if (choices.length > 0) {
        return renderEnumSelector(rows, columns, column, choices.elements);
      }
    }
    return fallbackRenderTableSelector(rows, columns, column);
  }

  // Generate the search selectors for the table columns.

  function renderTableSelectors(rows, columns) {
    var tr = doc.createElement('tr');
    tr.className = 'selectors';

    // Empty link column

    tr.appendChild(doc.createElement('td'));

    // Generate selectors.

    for (var i = 0; i < columns.length; ++i) {
      var td = doc.createElement('td');
      var selector = renderTableSelector(rows, columns, columns[i]);
      if (selector) {
        td.appendChild(selector);
      }
      /*
                  // Useful debug: display URI of predicate in column header
                  if (columns[i].predicate.uri) {
                      td.appendChild(document.createTextNode(columns[i].predicate.uri))
                  }
      */
      tr.appendChild(td);
    }
    return tr;
  }
  function linkTo(uri, linkText, hints) {
    hints = hints || {};
    var result = doc.createElement('a');
    var linkFunction = hints.linkFunction;
    result.setAttribute('href', uri);
    result.appendChild(doc.createTextNode(linkText));
    if (!linkFunction) {
      result.addEventListener('click', table_UI.widgets.openHrefInOutlineMode, true);
    } else {
      result.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var target = getTarget(e);
        var uri = target.getAttribute('href');
        if (!uri) src_debug/* log */.Rm('No href found \n');
        linkFunction(uri);
      }, true);
    }
    return result;
  }
  function linkToObject(obj, hints) {
    var match = false;
    if (obj.uri) {
      match = obj.uri.match(/^mailto:(.*)/);
    }
    if (match) {
      return linkTo(obj.uri, match[1], hints);
    } else {
      return linkTo(obj.uri, label_label(obj), hints);
    }
  }

  // Render an image

  function renderImage(obj) {
    var result = doc.createElement('img');
    result.setAttribute('src', obj.uri);

    // Set the height, so it appears as a thumbnail.
    result.style.height = '40px';
    return result;
  }

  // Render an individual RDF object to an HTML object displayed
  // in a table cell.

  function getHints(column) {
    if (options && options.hints && column.variable && options.hints[column.variable.toNT()]) {
      return options.hints[column.variable.toNT()];
    }
    return {};
  }
  function renderValue(obj, column) {
    // hint
    var hints = getHints(column);
    var cellFormat = hints.cellFormat;
    if (cellFormat) {
      switch (cellFormat) {
        case 'shortDate':
          return doc.createTextNode(table_UI.widgets.shortDate(obj.value));
        // break
        default:
        // drop through
      }
    } else {
      if (obj.termType === 'Literal') {
        if (obj.datatype) {
          if (XSD_DATE_TYPES[obj.datatype.uri]) {
            return doc.createTextNode(table_UI.widgets.shortDate(obj.value));
          } else if (XSD_NUMBER_TYPES[obj.datatype.uri]) {
            var span = doc.createElement('span');
            span.textContent = obj.value;
            span.setAttribute('style', 'text-align: right');
            return span;
          }
        }
        return doc.createTextNode(obj.value);
      } else if (obj.termType === 'NamedNode' && column.isImageColumn()) {
        return renderImage(obj);
      } else if (obj.termType === 'NamedNode' || obj.termType === 'BlankNode') {
        return linkToObject(obj, hints);
      } else if (obj.termType === 'Collection') {
        var _span = doc.createElement('span');
        _span.appendChild(doc.createTextNode('['));
        obj.elements.forEach(function (x) {
          _span.appendChild(renderValue(x, column));
          _span.appendChild(doc.createTextNode(', '));
        });
        _span.removeChild(_span.lastChild);
        _span.appendChild(doc.createTextNode(']'));
        return _span;
      } else {
        return doc.createTextNode('unknown termtype \'' + obj.termType + '\'!');
      }
    }
  }

  // Render a row of the HTML table, from the given row structure.
  // Note that unlike other functions, this renders into a provided
  // row (<tr>) element.

  function renderTableRowInto(tr, row, columns, _downstream) {
    /* Link column, for linking to this subject. */

    var linkTd = doc.createElement('td');
    if (row._subject && 'uri' in row._subject) {
      linkTd.appendChild(linkTo(row._subject.uri, "\u2192"));
    }
    tr.appendChild(linkTd);

    // Create a <td> for each column (whether the row has data for that
    // column or not).

    for (var i = 0; i < columns.length; ++i) {
      var column = columns[i];
      var td = doc.createElement('td');
      var orig = void 0;
      var columnKey = column.getKey();
      if (columnKey in row.values) {
        var objects = row.values[columnKey];
        var different = false;
        if (row.originalValues && row.originalValues[columnKey]) {
          if (objects.length !== row.originalValues[columnKey].length) {
            different = true;
          }
        }
        for (var j = 0; j < objects.length; ++j) {
          var obj = objects[j];
          if (row.originalValues && row.originalValues[columnKey] && row.originalValues[columnKey].length > j) {
            orig = row.originalValues[columnKey][j];
            if (obj.toString() !== orig.toString()) {
              different = true;
            }
          }
          td.appendChild(renderValue(obj, column));
          if (j !== objects.length - 1) {
            td.appendChild(doc.createTextNode(',\n'));
          }
          if (different) {
            td.style.background = '#efe'; // green = new changed
          }
        }
      }
      tr.appendChild(td);
    }

    // Save a reference to the HTML row in the row object.

    row._htmlRow = tr;
    return tr;
  }

  // Check if a value is already stored in the list of values for
  // a cell (the query can sometimes find it multiple times)

  function valueInList(value, list) {
    var key = null;
    if (value.termType === 'Literal') {
      key = 'value';
    } else if (value.termType === 'NamedNode') {
      key = 'uri';
    } else {
      return list.indexOf(value) >= 0;
    }

    // Check the list and compare keys:

    var i;
    for (i = 0; i < list.length; ++i) {
      if (list[i].termType === value.termType && list[i][key] === value[key]) {
        return true;
      }
    }

    // Not found?

    return false;
  }

  // Update a row, add new values, and regenerate the HTML element
  // containing the values.

  function updateRow(row, columns, values) {
    var key;
    var needUpdate = false;
    for (key in values) {
      var value = values[key];

      // If this key is not already in the row, create a new entry
      // for it:

      if (!(key in row.values)) {
        row.values[key] = [];
      }

      // Possibly add this new value to the list, but don't
      // add it if we have already added it:

      if (!valueInList(value, row.values[key])) {
        row.values[key].push(value);
        needUpdate = true;
      }
    }

    // Regenerate the HTML row?

    if (needUpdate) {
      clearElement(row._htmlRow);
      renderTableRowInto(row._htmlRow, row, columns);
    }
    applyColumnFiltersToRow(row, columns); // Hide immediately if nec
  }

  // Get a unique ID for the given subject.  This is normally the
  // URI; if the subject has no URI, a unique ID is assigned.

  function getSubjectId(subject) {
    if ('uri' in subject) {
      return subject.uri;
    } else if ('_subject_id' in subject) {
      return subject._subject_id;
    } else {
      var result = '' + subjectIdCounter;
      subject._subject_id = result;
      ++subjectIdCounter;
      return result;
    }
  }

  // Run a query and populate the table.
  // Populates also an array of logical rows.  This will be empty when the function
  // first returns (as the query is performed in the background)

  function runQuery(query, rows, columns, table) {
    query.running = true;
    var startTime = Date.now();
    var progressMessage = doc.createElement('tr');
    table.appendChild(progressMessage);
    progressMessage.textContent = 'Loading ...';
    for (var i = 0; i < rows.length; i++) {
      rows[i].original = true;
      if (!rows[i].originalValues) {
        // remember first set
        rows[i].originalValues = rows[i].values;
      }
      rows[i].values = {};
      // oldStyle = rows[i]._htmlRow.getAttribute('style') || ''
      // rows[i]._htmlRow.style.background = '#ffe'; //setAttribute('style', ' background-color: #ffe;')// yellow
    }
    var onResult = function onResult(values) {
      if (!query.running) {
        return;
      }
      progressMessage.textContent += '.'; // give a progress bar

      var row = null;
      var rowKey = null;
      var rowKeyId;

      // If the query has a row key, use it to look up the row.

      if (keyVariable in values) {
        rowKey = values[keyVariable];
        rowKeyId = getSubjectId(rowKey);

        // Do we have a row for this already?
        // If so, reuse it; otherwise, we must create a new row.

        if (rowKeyId in rowsLookup) {
          row = rowsLookup[rowKeyId];
        }
      }

      // Create a new row?

      if (!row) {
        var tr = doc.createElement('tr');
        table.appendChild(tr);
        row = {
          _htmlRow: tr,
          _subject: rowKey,
          values: {}
        };
        rows.push(row);
        if (rowKey) {
          rowsLookup[rowKeyId] = row;
        }
      }

      // Add the new values to this row.
      delete row.original; // This is included in the new data
      updateRow(row, columns, values);
    };
    var onDone = function onDone() {
      if (progressMessage && progressMessage.parentNode && progressMessage.parentNode.removeChild) {
        progressMessage.parentNode.removeChild(progressMessage);
        progressMessage = null;
      }
      var elapsedTimeMS = Date.now() - startTime;
      src_debug/* log */.Rm('Query done: ' + rows.length + ' rows, ' + elapsedTimeMS + 'ms');
      // Delete rows which were from old values not new
      for (var _i4 = rows.length - 1; _i4 >= 0; _i4--) {
        // backwards
        if (rows[_i4].original) {
          src_debug/* log */.Rm('   deleting row ' + rows[_i4]._subject);
          var tr = rows[_i4]._htmlRow;
          tr.parentNode.removeChild(tr);
          delete rowsLookup[getSubjectId(rows[_i4]._subject)];
          rows.splice(_i4, 1);
        }
      }
      if (options.sortBy) {
        // @@ for each column check needs sorting
        var column = getColumnForVariable(columns, options.sortBy);
        literalSort(rows, column, options.sortReverse);
      }
      if (options.onDone) options.onDone(resultDiv); // return div makes testing easier
    };
    kb.query(query, onResult, undefined, onDone);
  }

  // Given the formula object which is the query pattern,
  // deduce from where the variable occurs constraints on
  // what values it can take.

  function inferColumnsFromFormula(columns, formula) {
    table_UI.log.debug('>> processing formula');
    for (var i = 0; i < formula.statements.length; ++i) {
      var statement = formula.statements[i];
      // UI.log.debug("processing statement " + i)

      // Does it match this?:
      // <something> <predicate> ?var
      // If so, we can use the predicate as the predicate for the
      // column used for the specified variable.

      if (statement.predicate.termType === 'NamedNode' && statement.object.termType === 'Variable') {
        var variable = statement.object.toString();
        if (variable in columns) {
          var column = columns[variable];
          column.setPredicate(statement.predicate, false, statement.subject);
        }
      }
      if (statement.predicate.termType === 'NamedNode' && statement.subject.termType === 'Variable') {
        var _variable = statement.subject.toString();
        if (_variable in columns) {
          var _column = columns[_variable];
          _column.setPredicate(statement.predicate, true, statement.object);
        }
      }
    }

    // Apply to OPTIONAL formulas:

    for (var _i5 = 0; _i5 < formula.optional.length; ++_i5) {
      table_UI.log.debug('recurse to optional subformula ' + _i5);
      inferColumnsFromFormula(columns, formula.optional[_i5]);
    }
    table_UI.log.debug('<< finished processing formula');
  }

  // Generate a list of column structures and infer details about the
  // predicates based on the contents of the query

  function inferColumns(query) {
    // Generate the columns list:

    var result = [];
    var columns = {};
    for (var i = 0; i < query.vars.length; ++i) {
      var column = new Column();
      var queryVar = query.vars[i];
      table_UI.log.debug('column ' + i + ' : ' + queryVar);
      column.setVariable(queryVar);
      columns[queryVar] = column;
      result.push(column);
    }
    inferColumnsFromFormula(columns, query.pat);
    return result;
  }

  // Generate a table from a query.

  function renderTableForQuery(query, type) {
    // infer columns from query, to allow generic queries
    var columns;
    if (!givenQuery) {
      columns = type.getColumns();
    } else {
      columns = inferColumns(query);
    }

    // Start with an empty list of rows; this will be populated
    // by the query.

    var rows = [];

    // Create table element and header.

    var table = doc.createElement('table');
    table.appendChild(renderTableHeader(columns, type));
    table.appendChild(renderTableSelectors(rows, columns));

    // Run query.  Note that this is perform asynchronously; the
    // query runs in the background and this call does not block.

    table.logicalRows = rows; // Save for refresh
    table.columns = columns;
    table.query = query;
    runQuery(query, rows, columns, table);
    return table;
  }

  // Find the most common type of row

  function getMostCommonType(types) {
    var bestCount = -1;
    var best = null;
    var typeUri;
    for (typeUri in types) {
      var type = types[typeUri];
      if (type.useCount > bestCount) {
        best = type;
        bestCount = type.useCount;
      }
    }
    return best;
  }

  // Filter list of columns to only those columns used in the
  // specified rows.
  /*
  function filterColumns (columns, rows) {
    var filteredColumns = {}
     // Copy columns from "columns" -> "filteredColumns", but only
    // those columns that are used in the list of rows specified.
     for (let columnUri in columns) {
      for (let i = 0; i < rows.length; ++i) {
        if (columnUri in rows[i]) {
          filteredColumns[columnUri] = columns[columnUri]
          break
        }
      }
    }
    return filteredColumns
  }
  */
}
// ///////////////////////////////////////////////////////////////////

// ENDS
;// ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

;// ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js


function possibleConstructorReturn_possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}

;// ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
function getPrototypeOf_getPrototypeOf(t) {
  return getPrototypeOf_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, getPrototypeOf_getPrototypeOf(t);
}

;// ./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}

;// ./node_modules/@babel/runtime/helpers/esm/inherits.js

function inherits_inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}

;// ./node_modules/@babel/runtime/helpers/esm/isNativeFunction.js
function _isNativeFunction(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (n) {
    return "function" == typeof t;
  }
}

;// ./node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js
function isNativeReflectConstruct_isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (isNativeReflectConstruct_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}

;// ./node_modules/@babel/runtime/helpers/esm/construct.js


function _construct(t, e, r) {
  if (isNativeReflectConstruct_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}

;// ./node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js




function wrapNativeSuper_wrapNativeSuper(t) {
  var r = "function" == typeof Map ? new Map() : void 0;
  return wrapNativeSuper_wrapNativeSuper = function _wrapNativeSuper(t) {
    if (null === t || !_isNativeFunction(t)) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r) {
      if (r.has(t)) return r.get(t);
      r.set(t, Wrapper);
    }
    function Wrapper() {
      return _construct(t, arguments, getPrototypeOf_getPrototypeOf(this).constructor);
    }
    return Wrapper.prototype = Object.create(t.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), _setPrototypeOf(Wrapper, t);
  }, wrapNativeSuper_wrapNativeSuper(t);
}

;// ./src/tabs.ts







function tabs_callSuper(t, o, e) { return o = getPrototypeOf_getPrototypeOf(o), possibleConstructorReturn_possibleConstructorReturn(t, tabs_isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_getPrototypeOf(t).constructor) : o.apply(t, e)); }
function tabs_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (tabs_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }





/**
 * @ignore
 */
var ContainerElement = /*#__PURE__*/(/* unused pure expression or super */ null && (function (_HTMLElement) {
  function ContainerElement() {
    _classCallCheck(this, ContainerElement);
    return tabs_callSuper(this, ContainerElement, arguments);
  }
  _inherits(ContainerElement, _HTMLElement);
  return _createClass(ContainerElement);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement))));
var TabWidgetElement = /*#__PURE__*/function (_HTMLElement2) {
  function TabWidgetElement() {
    classCallCheck_classCallCheck(this, TabWidgetElement);
    return tabs_callSuper(this, TabWidgetElement, arguments);
  }
  inherits_inherits(TabWidgetElement, _HTMLElement2);
  return createClass_createClass(TabWidgetElement);
}(/*#__PURE__*/wrapNativeSuper_wrapNativeSuper(HTMLElement));

/**
 * @ignore
 */
var TabElement = /*#__PURE__*/(/* unused pure expression or super */ null && (function (_HTMLElement3) {
  function TabElement() {
    _classCallCheck(this, TabElement);
    return tabs_callSuper(this, TabElement, arguments);
  }
  _inherits(TabElement, _HTMLElement3);
  return _createClass(TabElement);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement))));
/**
 * Use this widget to generate tabs from triples set in the global store.
 *
 * [Here you can see examples of the tabs](https://solidos.github.io/solid-ui/examples/tabs/).
 *
 * It assumes that items to use for tabs will be in a collection by default,
 * e.g.:
 *
 * ```turtle
 * :subject :predicate ( :item1 :item2 ) .
 * ```
 *
 * You can override this by setting `ordered: false`, in which case it expects
 * unordered triples:
 *
 * ```turtle
 * :subject :predicate :item1, :item 2 .
 * ```
 *
 * Triples that are not ordered in collection are in principle not sorted,
 * which means that tabs could change order every time you render the widget.
 * But in this case the widget will try to sort it in order to keep it
 * consistent.
 *
 * In both of these cases you need to define options `subject` and `predicate`
 * to tell the widget which triples it should be looking for.
 *
 * Finally you can set items manually, using the `items` option, e.g.:
 *
 * ```javascript
 * {
 *   items: [
 *     namedNode('https://domain.tld/#item1'),
 *     namedNode('https://domain.tld/#item2')
 *   ]
 * }
 * ```
 *
 * When you set items manually you do not need to set `subject` and
 * `predicate`.
 *
 * In any case you probably want to set the renderMain option to specify
 * what should be rendered for the various items, e.g.:
 *
 * ```javascript
 * {
 *   renderMain: (bodyMain, subject) => {
 *     bodyMain.innerHTML = renderItem(subject)
 *   }
 * }
 * ```
 *
 * **Note:** `renderItem` is a custom function that you need to define yourself.
 *
 * The option `renderTabSettings` allows you to render a custom view in the
 * body container that is shown when you hold the ALT key and click on a
 * tab. It works very much like the `renderMain` option:
 *
 * ```javascript
 * {
 *   renderTabSettings: (bodyMain, subject) => {
 *     bodyMain.innerHTML = renderTabSettings(subject)
 *   }
 * }
 * ```
 *
 * **Note:** `renderTabSettings` is a custom function that you need to define
 * yourself.
 *
 * By default the widget will try to guess the label by using the
 * [[utils.label]] function. If you want to customize this yourself, you can
 * use the `renderTab` option:
 *
 * ```javascript
 * {
 *   renderTab: (tabDiv, subject) => {
 *     tabDiv.innerText = renderTabText(subject)
 *   }
 * }
 * ```
 *
 * **Note:** `renderTabText` is a custom function you need to define yourself.
 *
 * The option renderTab is also important if you want to set which tab should
 * be selected once the widget is rendered. By default it will simply select
 * the first tab, but you can override by setting `dataset.name` on the tab
 * and referring to the same string in `selectedTab`:
 *
 * ```javascript
 * {
 *   renderTab: (tabDiv, subject)  => {
 *     tabDiv.dataset.name = subject.uri
 *   },
 *   selectedTab: item2.uri
 * }
 * ```
 *
 * You can apply a color to use for tabs and border of the container by using
 * option `background-color`. This is #ddddcc by default.
 *
 * You can override the document object that the widget uses to generate DOM
 * elements by setting the option `dom`. This is encouraged to set if you
 * intend your functionality to be used in environments that don't provide
 * a global `document` object.
 *
 * If you want to render a close button next to the tabs you can set option
 * `onClose` which takes a callback function that is triggered when the
 * button is clicked:
 *
 * ```javascript
 * {
 *   onClose: (event) => {
 *     // do something that hides the widget altogether
 *   }
 * }
 * ```
 *
 * The option `orientation` allows you to set which side the tabs should be
 * located: `'0'` = Top, `'1'` = Left, `'2'` = Bottom, `'3'` = Right
 *
 * If you don't want to render anything in the body container by default,
 * you can set the option `startEmpty` to `true`.
 *
 * @param options
 */
var tabsDefaultBackgroundColor = '#ddddcc';
function tabWidget(options) {
  var subject = options.subject;
  var dom = options.dom || document;
  var orientation = parseInt(options.orientation || '0');
  var backgroundColor = options.backgroundColor || tabsDefaultBackgroundColor;
  var flipped = orientation & 2;
  var vertical = orientation & 1;
  var onClose = options.onClose;
  var _getColors = getColors(backgroundColor),
    _getColors2 = _slicedToArray(_getColors, 2),
    selectedColor = _getColors2[0],
    color = _getColors2[1];
  var bodyMainStyle = "flex: 2; width: auto; height: 100%; border: 0.1em; border-style: solid; border-color: ".concat(selectedColor, "; padding: 1em;");
  var rootElement = dom.createElement('div'); // 20200117a

  rootElement.setAttribute('style', style.tabsRootElement);
  rootElement.style.flexDirection = (vertical ? 'row' : 'column') + (flipped ? '-reverse' : '');
  var navElement = rootElement.appendChild(dom.createElement('nav'));
  navElement.setAttribute('style', style.tabsNavElement);
  var mainElement = rootElement.appendChild(dom.createElement('main'));
  mainElement.setAttribute('style', style.tabsMainElement); // override tabbedtab.css
  var tabContainer = navElement.appendChild(dom.createElement('ul'));
  tabContainer.setAttribute('style', style.tabContainer);
  tabContainer.style.flexDirection = "".concat(vertical ? 'column' : 'row');
  var tabElement = 'li';
  var bodyContainer = mainElement;
  rootElement.tabContainer = tabContainer;
  rootElement.bodyContainer = bodyContainer;
  var corners = ['0.2em', '0.2em', '0', '0']; // top left, TR, BR, BL
  var cornersPrepped = corners.concat(corners).slice(orientation, orientation + 4);
  var cornersStyle = "border-radius: ".concat(cornersPrepped.join(' '), ";");
  var margins = ['0.3em', '0.3em', '0', '0.3em']; // top, right, bottom, left
  var marginsPrepped = margins.concat(margins).slice(orientation, orientation + 4);
  var marginsStyle = "margin: ".concat(marginsPrepped.join(' '), ";");
  var paddingStyle = "padding: ".concat(marginsPrepped.join(' '), ";");
  var tabStyle = cornersStyle + "position: relative; padding: 0.7em; max-width: 20em; color: ".concat(color, ";");
  var unselectedStyle = "".concat(tabStyle + marginsStyle, " opacity: 50%; background-color: ").concat(backgroundColor, ";");
  var selectedStyle = "".concat(tabStyle + marginsStyle, " background-color: ").concat(selectedColor, ";");
  var shownStyle = 'height: 100%; width: 100%;';
  var hiddenStyle = shownStyle + 'display: none;';
  rootElement.refresh = orderedSync;
  orderedSync();
  if (!options.startEmpty && tabContainer.children.length && options.selectedTab) {
    var selectedTab0 = Array.from(tabContainer.children) // Version left for compatibility with ??
    .map(function (tab) {
      return tab.firstChild;
    }).find(function (tab) {
      return tab.dataset.name === options.selectedTab;
    });
    var selectedTabURI = options.selectedTab.uri;
    var selectedTab1 = Array.from(tabContainer.children)
    // @ts-ignore
    .find(function (tab) {
      return tab.subject &&
      // @ts-ignore
      tab.subject.uri &&
      // @ts-ignore
      tab.subject.uri === selectedTabURI;
    });
    var tab = selectedTab1 || selectedTab0 || tabContainer.children[0];
    var clickMe = tab.firstChild;
    if (clickMe !== null && clickMe !== void 0 && clickMe.click) {
      clickMe.click();
    } else if (tab instanceof HTMLElement) {
      tab.click();
    }
  } else if (!options.startEmpty) {
    var firstTab = tabContainer.children[0];
    var clickTarget = firstTab === null || firstTab === void 0 ? void 0 : firstTab.firstChild;
    if (clickTarget !== null && clickTarget !== void 0 && clickTarget.click) {
      clickTarget.click();
    } else if (firstTab instanceof HTMLElement) {
      firstTab.click(); // Open first tab
    }
  }
  return rootElement;
  function addCancelButton(tabContainer) {
    if (tabContainer.dataset.onCloseSet) {
      // @@ TODO: this is only here to make the browser tests work
      // Discussion at https://github.com/solidos/solid-ui/pull/110#issuecomment-527080663
      var existingCancelButton = tabContainer.querySelector('.unstyled');
      tabContainer.removeChild(existingCancelButton);
    }
    var extraTab = dom.createElement(tabElement);
    extraTab.classList.add('unstyled');
    var tabCancelButton = buttons_cancelButton(dom, onClose);
    tabCancelButton.setAttribute('style', tabCancelButton.getAttribute('style') + paddingStyle);
    extraTab.appendChild(tabCancelButton);
    tabContainer.appendChild(extraTab);
    tabContainer.dataset.onCloseSet = 'true';
  }
  function getItems() {
    if (options.items) return options.items;
    if (options.ordered !== false) {
      // options.ordered defaults to true
      return external_SolidLogic_.store.the(subject, options.predicate).elements;
    } else {
      return external_SolidLogic_.store.each(subject, options.predicate);
    }
  }
  function makeNewSlot(item) {
    var ele = dom.createElement(tabElement);
    ele.setAttribute('style', unselectedStyle);
    ele.subject = item;
    var div = ele.appendChild(dom.createElement('button'));
    div.setAttribute('style', style.makeNewSlot);
    div.onclick = function () {
      resetTabStyle();
      resetBodyStyle();
      ele.setAttribute('style', selectedStyle);
      if (!ele.bodyTR) return;
      ele.bodyTR.setAttribute('style', shownStyle);
      var bodyMain = getOrCreateContainerElement(ele);
      if (options.renderMain && ele.subject && bodyMain.asSettings !== false) {
        bodyMain.innerHTML = 'loading item ...' + item;
        options.renderMain(bodyMain, ele.subject);
        bodyMain.asSettings = false;
      }
    };
    if (options.renderTabSettings && ele.subject) {
      var ellipsis = dom.createElement('button');
      ellipsis.textContent = '...';
      ellipsis.setAttribute('style', style.ellipsis);
      ellipsis.onclick = function () {
        resetTabStyle();
        resetBodyStyle();
        ele.setAttribute('style', selectedStyle);
        if (!ele.bodyTR) return;
        ele.bodyTR.setAttribute('style', shownStyle);
        var bodyMain = getOrCreateContainerElement(ele);
        if (options.renderTabSettings && ele.subject && bodyMain.asSettings !== true) {
          bodyMain.innerHTML = 'loading settings ...' + item;
          options.renderTabSettings(bodyMain, ele.subject);
          bodyMain.asSettings = true;
        }
      };
      ele.appendChild(ellipsis);
    }
    if (options.renderTab) {
      options.renderTab(div, item);
    } else {
      div.innerHTML = label_label(item);
    }
    return ele;
    function getOrCreateContainerElement(ele) {
      var _ele$bodyTR;
      var bodyMain = (_ele$bodyTR = ele.bodyTR) === null || _ele$bodyTR === void 0 ? void 0 : _ele$bodyTR.children[0];
      if (bodyMain) return bodyMain;
      var newBodyMain = ele.bodyTR.appendChild(dom.createElement('main'));
      newBodyMain.setAttribute('style', bodyMainStyle);
      return newBodyMain;
    }
  }

  // @@ Use common one from utils?
  function orderedSync() {
    var items = getItems();
    var slot, i, j, left, right;
    var differ = false;
    // Find how many match at each end
    for (left = 0; left < tabContainer.children.length; left++) {
      slot = tabContainer.children[left];
      if (left >= items.length || slot.subject && !slot.subject.sameTerm(items[left])) {
        differ = true;
        break;
      }
    }
    if (!differ && items.length === tabContainer.children.length) {
      return; // The two just match in order: a case to optimize for
    }
    for (right = tabContainer.children.length - 1; right >= 0; right--) {
      slot = tabContainer.children[right];
      j = right - tabContainer.children.length + items.length;
      if (slot.subject && !slot.subject.sameTerm(items[j])) {
        break;
      }
    }
    // The elements left ... right in tabContainer.children do not match
    var insertables = items.slice(left, right - tabContainer.children.length + items.length + 1);
    while (right >= left) {
      // remove extra
      tabContainer.removeChild(tabContainer.children[left]);
      bodyContainer.removeChild(bodyContainer.children[left]);
      right -= 1;
    }
    for (i = 0; i < insertables.length; i++) {
      var newSlot = makeNewSlot(insertables[i]);
      var newBodyDiv = dom.createElement('div');
      newSlot.bodyTR = newBodyDiv;
      if (left === tabContainer.children.length) {
        // None left of original on right
        tabContainer.appendChild(newSlot);
        bodyContainer.appendChild(newBodyDiv);
      } else {
        tabContainer.insertBefore(newSlot, tabContainer.children[left + i]);
        bodyContainer.insertBefore(newBodyDiv, bodyContainer.children[left + i]);
      }
    }
    if (onClose) {
      addCancelButton(tabContainer);
    }
  }
  function resetTabStyle() {
    for (var i = 0; i < tabContainer.children.length; i++) {
      var _tab = tabContainer.children[i];
      if (_tab.classList.contains('unstyled')) {
        continue;
      } else {
        _tab.setAttribute('style', unselectedStyle);
      }
    }
  }
  function resetBodyStyle() {
    for (var i = 0; i < bodyContainer.children.length; i++) {
      bodyContainer.children[i].setAttribute('style', hiddenStyle);
    }
  }
}

/**
 * @internal
 */
function getColors(backgroundColor) {
  return isLight(backgroundColor) ? [colorBlend(backgroundColor, '#ffffff', 0.3), '#000000'] : [colorBlend(backgroundColor, '#000000', 0.3), '#ffffff'];
}

/**
 * @internal
 */
function colorBlend(a, b, mix) {
  var ca, cb, res;
  var str = '#';
  var hex = '0123456789abcdef';
  for (var i = 0; i < 3; i++) {
    ca = parseInt(a.slice(i * 2 + 1, i * 2 + 3), 16);
    cb = parseInt(b.slice(i * 2 + 1, i * 2 + 3), 16);
    res = ca * (1.0 - mix) + cb * mix; // @@@ rounding
    var res2 = parseInt(('' + res).split('.')[0]); // @@ ugh
    var h = parseInt(('' + res2 / 16).split('.')[0]); // @@ ugh
    var l = parseInt(('' + res2 % 16).split('.')[0]); // @@ ugh
    str += hex[h] + hex[l];
  }
  return str;
}

/**
 * @internal
 */
function isLight(x) {
  var total = 0;
  for (var i = 0; i < 3; i++) {
    total += parseInt(x.slice(i * 2 + 1, i * 2 + 3), 16);
  }
  return total > 128 * 3;
}
;// ./src/header/empty-profile.ts
var emptyProfile = "\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"26\" height=\"26\" viewBox=\"0 0 26 26\" fill=\"none\">\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13 25C19.6274 25 25 19.6274 25 13C25 6.37258 19.6274 1 13 1C6.37258 1 1 6.37258 1 13C1 19.6274 6.37258 25 13 25Z\" fill=\"#D8D8D8\" stroke=\"#8B8B8B\"/>\n    <mask id=\"mask0\" mask-type=\"alpha\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"26\" height=\"26\">\n        <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13 25C19.6274 25 25 19.6274 25 13C25 6.37258 19.6274 1 13 1C6.37258 1 1 6.37258 1 13C1 19.6274 6.37258 25 13 25Z\" fill=\"white\" stroke=\"white\"/>\n    </mask>\n    <g mask=\"url(#mask0)\">\n        <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.0468 10.4586C17.0468 14.4979 15.4281 16.9214 12.9999 16.9214C10.5718 16.9214 8.95298 14.4979 8.95298 10.4586C8.95298 6.41931 12.9999 6.41931 12.9999 6.41931C12.9999 6.41931 17.0468 6.41931 17.0468 10.4586ZM4.09668 23.3842C6.52483 17.7293 12.9999 17.7293 12.9999 17.7293C12.9999 17.7293 19.475 17.7293 21.9031 23.3842C21.9031 23.3842 17.8481 25 12.9999 25C8.15169 25 4.09668 23.3842 4.09668 23.3842Z\" fill=\"#8B8B8B\"/>\n    </g>\n</svg>";
;// ./src/utils/headerFooterHelpers.ts


/*
    Copied from mashlib/src/global/metadata.ts
 */



/* @ts-ignore  no-console */

/**
 * @ignore exporting this only for the unit test
 */
function getPod() {
  // @@ TODO: This is given that mashlib runs on NSS - might need to change when we want it to run on other Pod servers
  return (0,external_$rdf_.sym)(document.location.origin).site();
}
/**
 */
function getPodOwner(_x, _x2) {
  return _getPodOwner.apply(this, arguments);
}
/**
 * @ignore exporting this only for the unit test
 */
function _getPodOwner() {
  _getPodOwner = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee(pod, store) {
    var response, containerTurtle, podOwner, guess, _t, _t2, _t3;
    return regenerator_default().wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          if (store.any(pod, null, src_ns.ldp('Container'), pod)) {
            _context.next = 2;
            break;
          }
          _context.next = 1;
          return store.fetcher.webOperation('GET', pod.uri, store.fetcher.initFetchOptions(pod.uri, {
            headers: {
              accept: 'text/turtle'
            }
          }));
        case 1:
          response = _context.sent;
          containerTurtle = response.responseText;
          (0,external_$rdf_.parse)(containerTurtle, store, pod.uri, 'text/turtle');
        case 2:
          _context.next = 4;
          break;
        case 3:
          _context.prev = 3;
          _t = _context["catch"](0);
          console.error('Error loading pod ' + pod + ': ' + _t);
          return _context.abrupt("return", null);
        case 4:
          if (store.holds(pod, src_ns.rdf('type'), src_ns.space('Storage'), pod)) {
            _context.next = 5;
            break;
          }
          console.warn('Pod  ' + pod + ' does not declare itself as a space:Storage');
          return _context.abrupt("return", null);
        case 5:
          podOwner = store.any(pod, src_ns.solid('owner'), null, pod) || store.any(null, src_ns.space('storage'), pod, pod);
          if (!podOwner) {
            _context.next = 10;
            break;
          }
          _context.prev = 6;
          _context.next = 7;
          return store.fetcher.load(podOwner.doc());
        case 7:
          _context.next = 9;
          break;
        case 8:
          _context.prev = 8;
          _t2 = _context["catch"](6);
          console.warn('Unable to load profile of pod owner ' + podOwner);
          return _context.abrupt("return", null);
        case 9:
          if (!store.holds(podOwner, src_ns.space('storage'), pod, podOwner.doc())) {
            console.warn("Pod owner ".concat(podOwner, " does NOT list pod ").concat(pod, " as their storage"));
          }
          return _context.abrupt("return", podOwner);
        case 10:
          // pod owner not declared in pod
          // @@ TODO: This is given the structure that NSS provides
          // This is a massive guess.  For old pods which don't have owner link
          guess = (0,external_$rdf_.sym)("".concat(pod.uri, "profile/card#me"));
          _context.prev = 11;
          _context.next = 12;
          return store.fetcher.load(guess);
        case 12:
          _context.next = 14;
          break;
        case 13:
          _context.prev = 13;
          _t3 = _context["catch"](11);
          console.error('Ooops. Guessed wrong pod owner webid {$guess} : can\'t load it.');
          return _context.abrupt("return", null);
        case 14:
          if (!store.holds(guess, src_ns.space('storage'), pod, guess.doc())) {
            _context.next = 15;
            break;
          }
          console.warn('Using guessed pod owner webid but it links back.');
          return _context.abrupt("return", guess);
        case 15:
          return _context.abrupt("return", null);
        case 16:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 3], [6, 8], [11, 13]]);
  }));
  return _getPodOwner.apply(this, arguments);
}
function getName(store, user) {
  return store.anyValue(user, src_ns.vcard('fn'), null, user.doc()) || store.anyValue(user, src_ns.foaf('name'), null, user.doc()) || user.uri;
}
/**
 * @ignore exporting this only for the unit test
 */
function throttle(func, wait) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var context, args, result;
  var timeout = null;
  var previous = 0;
  var later = function later() {
    previous = !options.leading ? 0 : Date.now();
    timeout = null;
    result = func.apply(context, args);
    if (!timeout) context = args = null;
  };
  return function () {
    var now = Date.now();
    if (!previous && !options.leading) previous = now;
    var remaining = wait - (now - previous);
    // @ts-ignore
    context = this;
    args = arguments;
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = now;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining);
    }
    return result;
  };
}
;// ./src/header/index.ts


/* global EventListenerOrEventListenerObject */
/*
    This file was copied from mashlib/src/global/header.ts file. It is modified to
    work in solid-ui by adjusting where imported functions are found.
 */




// import { loginStatusBox, authSession, currentUser } from '../authn/authn'





/**
 * menu icons
*/
var DEFAULT_HELP_MENU_ICON = iconBase/* icons */.Pt.iconBase + 'noun_help.svg';
var DEFAUL_SOLID_ICON_URL = 'https://solidproject.org/assets/img/solid-emblem.svg';

/*
  HeaderOptions allow for customizing the logo and menu list.  If a logo is not provided the default
  is solid. Menulist will always show a link to logout and to the users profile.
  */

/**
 * Initialize header component, the header object returned depends on whether the user is authenticated.
 * @param store the data store
 * @param userMenuList a list of menu items when the user is logged in
 * @param options allow the header to be customized with a personalized logo, help icon and a help menu list of links or buttons.
 * @returns a header for an authenticated user with menu items given or a login screen
 */
function initHeader(_x, _x2, _x3) {
  return _initHeader.apply(this, arguments);
}
/**
 * @ignore exporting this only for the unit test
 */
function _initHeader() {
  _initHeader = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee2(store, userMenuList, options) {
    var header, pod;
    return regenerator_default().wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          header = document.getElementById('PageHeader');
          if (header) {
            _context2.next = 1;
            break;
          }
          return _context2.abrupt("return");
        case 1:
          pod = getPod();
          rebuildHeader(header, store, pod, userMenuList, options)();
          external_SolidLogic_.authSession.events.on('logout', rebuildHeader(header, store, pod, userMenuList, options));
          external_SolidLogic_.authSession.events.on('login', rebuildHeader(header, store, pod, userMenuList, options));
        case 2:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _initHeader.apply(this, arguments);
}
function rebuildHeader(header, store, pod, userMenuList, options) {
  return /*#__PURE__*/asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee() {
    var user, _t;
    return regenerator_default().wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          user = external_SolidLogic_.authn.currentUser();
          header.innerHTML = '';
          _t = header;
          _context.next = 1;
          return createBanner(store, pod, user, userMenuList, options);
        case 1:
          _t.appendChild.call(_t, _context.sent);
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
}
/**
 * @ignore exporting this only for the unit test
 */
function createBanner(_x4, _x5, _x6, _x7, _x8) {
  return _createBanner.apply(this, arguments);
}
/**
 * @ignore exporting this only for the unit test
 */
function _createBanner() {
  _createBanner = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee3(store, pod, user, userMenuList, options) {
    var podLink, image, userMenu, banner, leftSideOfHeader, helpMenu, _t2;
    return regenerator_default().wrap(function (_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          podLink = document.createElement('a');
          podLink.href = pod.uri;
          podLink.setAttribute('style', style.headerBannerLink);
          image = document.createElement('img');
          if (options) {
            image.src = options.logo ? options.logo : DEFAUL_SOLID_ICON_URL;
          }
          image.setAttribute('style', style.headerBannerIcon);
          podLink.appendChild(image);
          if (!user) {
            _context3.next = 2;
            break;
          }
          _context3.next = 1;
          return createUserMenu(store, user, userMenuList);
        case 1:
          _t2 = _context3.sent;
          _context3.next = 3;
          break;
        case 2:
          _t2 = createLoginSignUpButtons();
        case 3:
          userMenu = _t2;
          banner = document.createElement('div');
          banner.setAttribute('style', style.headerBanner);
          banner.appendChild(podLink);
          leftSideOfHeader = document.createElement('div');
          leftSideOfHeader.setAttribute('style', style.headerBannerRightMenu);
          leftSideOfHeader.appendChild(userMenu);
          if (options && options.helpMenuList) {
            helpMenu = createHelpMenu(options, options.helpMenuList);
            leftSideOfHeader.appendChild(helpMenu);
          }
          banner.appendChild(leftSideOfHeader);
          return _context3.abrupt("return", banner);
        case 4:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _createBanner.apply(this, arguments);
}
function createHelpMenu(options, helpMenuItems) {
  if (!helpMenuItems) return;
  var helpMenuList = document.createElement('ul');
  helpMenuList.setAttribute('style', style.headerUserMenuList);
  helpMenuItems.forEach(function (menuItem) {
    var menuItemType = menuItem.url ? 'url' : 'onclick';
    if (menuItemType === 'url') {
      helpMenuList.appendChild(createUserMenuItem(createUserMenuLink(menuItem.label, menuItem.url, menuItem.target)));
    } else {
      helpMenuList.appendChild(createUserMenuItem(createUserMenuButton(menuItem.label, menuItem.onclick)));
    }
  });
  var helpMenu = document.createElement('nav');
  helpMenu.setAttribute('style', style.headerUserMenuNavigationMenuNotDisplayed);
  helpMenu.setAttribute('aria-hidden', 'true');
  helpMenu.setAttribute('id', 'helperNav');
  helpMenu.appendChild(helpMenuList);
  var helpMenuContainer = document.createElement('div');
  helpMenuContainer.setAttribute('style', style.headerBannerUserMenu);
  helpMenuContainer.appendChild(helpMenu);
  var helpMenuTrigger = document.createElement('button');
  helpMenuTrigger.setAttribute('style', style.headerUserMenuTrigger);
  helpMenuTrigger.type = 'button';
  var helpMenuIcon = document.createElement('img');
  helpMenuIcon.src = options && options.helpIcon ? options.helpIcon : iconBase/* icons */.Pt.iconBase + DEFAULT_HELP_MENU_ICON;
  helpMenuIcon.setAttribute('style', style.headerUserMenuTriggerImg);
  helpMenuContainer.appendChild(helpMenuTrigger);
  helpMenuTrigger.appendChild(helpMenuIcon);
  var throttledMenuToggle = throttle(function (event) {
    return toggleMenu(event, helpMenuTrigger, helpMenu);
  }, 50);
  helpMenuTrigger.addEventListener('click', throttledMenuToggle);
  var timer = setTimeout(function () {
    return null;
  }, 0);
  helpMenuContainer.addEventListener('mouseover', function (event) {
    clearTimeout(timer);
    throttledMenuToggle(event);
    var nav = document.getElementById('helperNav');
    nav === null || nav === void 0 || nav.setAttribute('style', style.headerUserMenuNavigationMenu);
  });
  helpMenuContainer.addEventListener('mouseout', function (event) {
    timer = setTimeout(function () {
      return throttledMenuToggle(event);
    }, 200);
    var nav = document.getElementById('helperNav');
    nav === null || nav === void 0 || nav.setAttribute('style', style.headerUserMenuNavigationMenuNotDisplayed);
  });
  return helpMenuContainer;
}
/**
 * @ignore exporting this only for the unit test
 */
function createLoginSignUpButtons() {
  var profileLoginButtonPre = document.createElement('div');
  profileLoginButtonPre.setAttribute('style', style.headerBannerLogin);
  profileLoginButtonPre.appendChild(loginStatusBox(document, null, {}));
  return profileLoginButtonPre;
}
/**
 * @ignore exporting this only for the unit test
 */
function createUserMenuButton(label, onClick) {
  var button = document.createElement('button');
  button.setAttribute('style', style.headerUserMenuButton);
  button.onmouseover = function () {
    button.setAttribute('style', style.headerUserMenuButtonHover);
  };
  button.onmouseout = function () {
    button.setAttribute('style', style.headerUserMenuButton);
  };
  button.addEventListener('click', onClick);
  button.innerText = label;
  return button;
}
/**
 * @ignore exporting this only for the unit test
 */
function createUserMenuLink(label, href, target) {
  var link = document.createElement('a');
  link.setAttribute('style', style.headerUserMenuLink);
  link.onmouseover = function () {
    link.setAttribute('style', style.headerUserMenuLinkHover);
  };
  link.onmouseout = function () {
    link.setAttribute('style', style.headerUserMenuLink);
  };
  link.href = href;
  link.innerText = label;
  if (target) link.target = target;
  return link;
}

/**
 * @ignore exporting this only for the unit test
 */
function createUserMenu(_x9, _x0, _x1) {
  return _createUserMenu.apply(this, arguments);
}

/**
 * @ignore exporting this only for the unit test
 */
function _createUserMenu() {
  _createUserMenu = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee4(store, user, userMenuList) {
    var fetcher, loggedInMenuList, loggedInMenu, loggedInMenuTrigger, profileImg, loggedInMenuContainer, throttledMenuToggle, timer;
    return regenerator_default().wrap(function (_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          fetcher = store.fetcher;
          if (!fetcher) {
            _context4.next = 1;
            break;
          }
          _context4.next = 1;
          return fetcher.load(user);
        case 1:
          loggedInMenuList = document.createElement('ul');
          loggedInMenuList.setAttribute('style', style.headerUserMenuList);
          if (userMenuList) {
            userMenuList.forEach(function (menuItem) {
              var menuItemType = menuItem.url ? 'url' : 'onclick';
              if (menuItemType === 'url') {
                loggedInMenuList.appendChild(createUserMenuItem(createUserMenuLink(menuItem.label, menuItem.url, menuItem.target)));
              } else {
                loggedInMenuList.appendChild(createUserMenuItem(createUserMenuButton(menuItem.label, menuItem.onclick)));
              }
            });
          }
          loggedInMenu = document.createElement('nav');
          loggedInMenu.setAttribute('style', style.headerUserMenuNavigationMenuNotDisplayed);
          loggedInMenu.setAttribute('aria-hidden', 'true');
          loggedInMenu.setAttribute('id', 'loggedInNav');
          loggedInMenu.appendChild(loggedInMenuList);
          loggedInMenuTrigger = document.createElement('button');
          loggedInMenuTrigger.setAttribute('style', style.headerUserMenuTrigger);
          loggedInMenuTrigger.type = 'button';
          profileImg = getProfileImg(store, user);
          if (typeof profileImg === 'string') {
            loggedInMenuTrigger.innerHTML = profileImg;
          } else {
            loggedInMenuTrigger.appendChild(profileImg);
          }
          loggedInMenuContainer = document.createElement('div');
          loggedInMenuContainer.setAttribute('style', style.headerBannerUserMenuNotDisplayed);
          loggedInMenuContainer.appendChild(loggedInMenuTrigger);
          loggedInMenuContainer.appendChild(loggedInMenu);
          throttledMenuToggle = throttle(function (event) {
            return toggleMenu(event, loggedInMenuTrigger, loggedInMenu);
          }, 50);
          loggedInMenuTrigger.addEventListener('click', throttledMenuToggle);
          timer = setTimeout(function () {
            return null;
          }, 0);
          loggedInMenuContainer.addEventListener('mouseover', function (event) {
            clearTimeout(timer);
            throttledMenuToggle(event);
            var nav = document.getElementById('loggedInNav');
            nav === null || nav === void 0 || nav.setAttribute('style', style.headerUserMenuNavigationMenu);
          });
          loggedInMenuContainer.addEventListener('mouseout', function (event) {
            timer = setTimeout(function () {
              return throttledMenuToggle(event);
            }, 200);
            var nav = document.getElementById('loggedInNav');
            nav === null || nav === void 0 || nav.setAttribute('style', style.headerUserMenuNavigationMenuNotDisplayed);
          });
          return _context4.abrupt("return", loggedInMenuContainer);
        case 2:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _createUserMenu.apply(this, arguments);
}
function createUserMenuItem(child) {
  var menuProfileItem = document.createElement('li');
  menuProfileItem.setAttribute('style', style.headerUserMenuListItem);
  menuProfileItem.appendChild(child);
  return menuProfileItem;
}
/**
 * @ignore exporting this only for the unit test
 */
function getProfileImg(store, user) {
  var profileUrl = null;
  try {
    profileUrl = findImage(user);
    if (!profileUrl) {
      return emptyProfile;
    }
  } catch (_unused) {
    return emptyProfile;
  }
  var profileImage = document.createElement('div');
  profileImage.setAttribute('style', style.headerUserMenuPhoto);
  profileImage.style.backgroundImage = "url(".concat(profileUrl, ")");
  return profileImage;
}

/**
 * @internal
 */
function toggleMenu(event, trigger, menu) {
  var isExpanded = trigger.getAttribute('aria-expanded') === 'true';
  var expand = event.type === 'mouseover';
  var close = event.type === 'mouseout';
  if (isExpanded && expand || !isExpanded && close) {
    return;
  }
  trigger.setAttribute('aria-expanded', (!isExpanded).toString());
  menu.setAttribute('aria-hidden', isExpanded.toString());
}
;// ./src/footer/index.ts


/*
    This file was copied from mashlib/src/global/footer.ts file. It is modified to
    work in solid-ui by adjusting where imported functions are found.
 */




var DEFAULT_SOLID_PROJECT_URL = 'https://solidproject.org';
var DEFAULT_SOLID_PROJECT_NAME = 'solidproject.org';

/*
  FooterOptions allow for customizing the link and name of the link part of the footer.
  */

/**
 * Initialize footer component, the footer object returned depends on whether the user is authenticated.
 * @param store the data store
 * @returns the footer
 */
function initFooter(_x, _x2) {
  return _initFooter.apply(this, arguments);
}
/**
 * @ignore exporting this only for the unit test
 */
function _initFooter() {
  _initFooter = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee2(store, options) {
    var footer, pod, podOwner;
    return regenerator_default().wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          footer = document.getElementById('PageFooter');
          if (footer) {
            _context2.next = 1;
            break;
          }
          return _context2.abrupt("return");
        case 1:
          pod = getPod();
          _context2.next = 2;
          return getPodOwner(pod, store);
        case 2:
          podOwner = _context2.sent;
          rebuildFooter(footer, store, pod, podOwner, options)();
          external_SolidLogic_.authSession.events.on('login', rebuildFooter(footer, store, pod, podOwner, options));
          external_SolidLogic_.authSession.events.on('logout', rebuildFooter(footer, store, pod, podOwner, options));
        case 3:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _initFooter.apply(this, arguments);
}
function rebuildFooter(footer, store, pod, podOwner, options) {
  return /*#__PURE__*/asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee() {
    var user, _t;
    return regenerator_default().wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          user = external_SolidLogic_.authn.currentUser();
          footer.innerHTML = '';
          _t = footer;
          _context.next = 1;
          return createControllerInfoBlock(store, user, pod, podOwner, options);
        case 1:
          _t.appendChild.call(_t, _context.sent);
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
}
/**
 * @ignore exporting this only for the unit test
 */
function createControllerInfoBlock(store, user, pod, podOwner, options) {
  var profileLinkContainer = document.createElement('div');
  if (!pod || !podOwner || user && user.equals(podOwner)) {
    return profileLinkContainer;
  }
  profileLinkContainer.setAttribute('style', style.footer);
  var podLinkPre = document.createElement('span');
  podLinkPre.innerText = 'You\'re visiting ';
  var podLink = document.createElement('a');
  podLink.href = pod.uri;
  podLink.innerText = 'the Pod';
  var profileLinkPre = document.createElement('span');
  profileLinkPre.innerText = ' controlled by ';
  var profileLink = document.createElement('a');
  profileLink.href = podOwner.uri;
  profileLink.innerText = getName(store, podOwner);
  var solidProjectLinkPre = document.createElement('span');
  solidProjectLinkPre.innerText = '. For more info, check out ';
  var solidProjectLink = document.createElement('a');
  solidProjectLink.href = options && options.solidProjectUrl ? options.solidProjectUrl : DEFAULT_SOLID_PROJECT_URL;
  solidProjectLink.innerText = options && options.solidProjectName ? options.solidProjectName : DEFAULT_SOLID_PROJECT_NAME;
  var solidProjectLinkPost = document.createElement('span');
  solidProjectLinkPost.innerText = '.';
  profileLinkContainer.appendChild(podLinkPre);
  profileLinkContainer.appendChild(podLink);
  profileLinkContainer.appendChild(profileLinkPre);
  profileLinkContainer.appendChild(profileLink);
  profileLinkContainer.appendChild(solidProjectLinkPre);
  profileLinkContainer.appendChild(solidProjectLink);
  profileLinkContainer.appendChild(solidProjectLinkPost);
  return profileLinkContainer;
}
;// ./src/create/types.ts

;// ./src/index.ts
/*
The MIT License (MIT)

Copyright (c) 2015-2016 Solid

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.

If you would like to know more about the solid Solid project, please see
https://github.com/solidos/solid
*/


/**
 * Provides a Solid client helper object (which exposes various static modules).
 * @module UI.js
 * @main UI.js
 */

/**
 * @class UI
 * @static
 */

// REMOVE @ts-ignore as you migrate files to TypeScript
// @ts-ignore



// @ts-ignore





// @ts-ignore

// @ts-ignore

// @ts-ignore

// @ts-ignore

// @ts-ignore

// @ts-ignore

// @ts-ignore


// @ts-ignore






var src_dom = window ? window.document : null; // Idea that UI.dom can be adapted in non-browser environments

if (typeof window !== 'undefined') {
  ;
  window.UI = {
    ns: src_ns,
    acl: acl,
    aclControl: aclControl,
    create: create,
    createTypes: types_namespaceObject,
    dom: src_dom,
    icons: iconBase/* icons */.Pt,
    language: language_namespaceObject,
    log: log_namespaceObject,
    login: login_namespaceObject,
    matrix: matrix,
    media: media,
    messageArea: messageArea,
    infiniteMessageArea: infiniteMessageArea,
    pad: pad_namespaceObject,
    participation: participation_namespaceObject,
    preferences: preferences_namespaceObject,
    style: style,
    table: renderTableViewPane,
    tabs: tabs_namespaceObject,
    utils: utils_namespaceObject,
    widgets: widgets_namespaceObject,
    initHeader: initHeader,
    initFooter: initFooter
  }; // Simpler access by non-node scripts
}

// this variables are directly used in the storybook

// uses in solid-panes
})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=solid-ui.js.map